/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-concat */
import React, { useState, useRef, useEffect, useCallback } from "react";
import { supabase } from './supabase';
import { loadStripe } from "@stripe/stripe-js";
import { Elements, PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Device } from '@twilio/voice-sdk';
import MaterialsCatalog from './materialscatalog';
import ProjectBudgetBuilder from './projectbudgetbuilder';
import EnhancedPLDashboard from './enhancedpldashboard';
import MarketingDashboard from './MarketingDashboard';
import OutreachDrafts from './OutreachDrafts';
import AIAssistant from './AIAssistant';
import CrewApp from './CrewApp';
import ActivityTracker from './ActivityTracker';
import ActivityDashboard from './ActivityDashboard';
import { downloadEstimatePDF } from './estimatePdf';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

// ── Feature Flags ──
const SHOW_LEGACY_MATERIALS = process.env.REACT_APP_SHOW_LEGACY_MATERIALS === 'true';

// ── Fonts via Google Fonts (injected in head via style tag)
const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&family=DM+Sans:wght@300;400;500;600&display=swap');

    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

    :root {
      --stone-950: #1a1714;
      --stone-900: #241f1b;
      --stone-800: #332d27;
      --stone-700: #4a4238;
      --stone-600: #6b5e52;
      --stone-500: #8c7b6e;
      --stone-400: #b0a095;
      --stone-300: #cfc4ba;
      --stone-200: #e8e0d8;
      --stone-100: #f4f0eb;
      --stone-50:  #faf8f5;
      --sand-400:  #d4b896;
      --sand-300:  #e2cdb4;
      --sand-200:  #eedfd0;
      --warm-gold: #c9a96e;
      --warm-gold-light: #dfc08a;
      --accent-green: #7a9e7e;
      --accent-red:   #c0614a;
      --accent-blue:  #6b8cae;
      --accent-amber: #c4954a;
      --shadow-sm: 0 1px 3px rgba(26,23,20,0.12);
      --shadow-md: 0 4px 12px rgba(26,23,20,0.15);
      --shadow-lg: 0 8px 28px rgba(26,23,20,0.18);
      --radius: 8px;
      --radius-lg: 14px;
      --font-display: 'Cormorant Garamond', serif;
      --font-body: 'DM Sans', sans-serif;
    }

    body { background: var(--stone-100); color: var(--stone-900); font-family: var(--font-body); }

    /* Scrollbar */
    ::-webkit-scrollbar { width: 6px; height: 6px; }
    ::-webkit-scrollbar-track { background: var(--stone-200); }
    ::-webkit-scrollbar-thumb { background: var(--stone-400); border-radius: 3px; }

    /* Tile pattern background for sidebar */
    .tile-pattern {
      background-image:
        linear-gradient(45deg, rgba(201,169,110,0.06) 25%, transparent 25%),
        linear-gradient(-45deg, rgba(201,169,110,0.06) 25%, transparent 25%),
        linear-gradient(45deg, transparent 75%, rgba(201,169,110,0.06) 75%),
        linear-gradient(-45deg, transparent 75%, rgba(201,169,110,0.06) 75%);
      background-size: 20px 20px;
      background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
    }

    /* Animations */
    @keyframes fadeIn { from { opacity:0; transform:translateY(8px); } to { opacity:1; transform:translateY(0); } }
    @keyframes slideIn { from { opacity:0; transform:translateX(-12px); } to { opacity:1; transform:translateX(0); } }
    @keyframes pulse { 0%,100% { opacity:1; } 50% { opacity:0.5; } }
    .fade-in { animation: fadeIn 0.35s ease forwards; }
    .slide-in { animation: slideIn 0.3s ease forwards; }

    /* Modal */
    .modal-overlay {
      position:fixed; inset:0; background:rgba(26,23,20,0.55); backdrop-filter:blur(4px);
      z-index:1000; overflow-y:auto; display:flex; justify-content:center;
      align-items:flex-start; padding:40px 20px 80px 20px;
    }
    .modal-box {
      background:var(--stone-50); border-radius:var(--radius-lg); padding:32px;
      width:100%; max-width:580px; box-shadow:var(--shadow-lg);
      animation:modalIn 0.25s ease; position:relative; margin:auto 0;
    }
    @keyframes modalIn { from { opacity:0; transform:scale(0.97); } to { opacity:1; transform:scale(1); } }
    @keyframes spin { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }

    /* Form elements */
    input, select, textarea {
      width:100%; padding:9px 12px; border:1.5px solid var(--stone-300);
      border-radius:var(--radius); font-family:var(--font-body); font-size:14px;
      background:var(--stone-50); color:var(--stone-900); outline:none;
      transition:border-color 0.2s;
    }
    input[type="radio"], input[type="checkbox"] {
      width:auto; padding:0; border:none; border-radius:0; background:none;
    }
    input:focus, select:focus, textarea:focus { border-color:var(--warm-gold); }
    label { font-size:12px; font-weight:600; color:var(--stone-600); letter-spacing:0.05em; text-transform:uppercase; display:block; margin-bottom:5px; }
    .form-grid { display:grid; grid-template-columns:1fr 1fr; gap:16px; }
    .form-group { margin-bottom:16px; }
    .form-full { grid-column:1/-1; }

    /* Buttons */
    .btn {
      display:inline-flex; align-items:center; gap:6px; padding:9px 18px;
      border-radius:var(--radius); font-family:var(--font-body); font-size:13px;
      font-weight:500; cursor:pointer; border:none; transition:all 0.2s; white-space:nowrap;
    }
    .btn-primary { background:var(--warm-gold); color:white; }
    .btn-primary:hover { background:var(--warm-gold-light); transform:translateY(-1px); box-shadow:var(--shadow-sm); }
    .btn-secondary { background:var(--stone-200); color:var(--stone-800); }
    .btn-secondary:hover { background:var(--stone-300); }
    .btn-ghost { background:transparent; color:var(--stone-600); padding:6px 10px; }
    .btn-ghost:hover { background:var(--stone-200); color:var(--stone-900); }
    .btn-danger { background:var(--accent-red); color:white; }
    .btn-danger:hover { opacity:0.88; }
    .btn-sm { padding:6px 12px; font-size:12px; }
    .btn-icon { padding:7px; border-radius:var(--radius); background:transparent; cursor:pointer; border:none; color:var(--stone-500); transition:all 0.2s; display:inline-flex; align-items:center; }
    .btn-icon:hover { background:var(--stone-200); color:var(--stone-900); }

    /* Badge */
    .badge {
      display:inline-flex; align-items:center; padding:3px 10px; border-radius:99px;
      font-size:11px; font-weight:600; letter-spacing:0.04em;
    }
    .badge-new { background:#e8f0fe; color:#3b5bdb; }
    .badge-contacted { background:#fff3bf; color:#946c00; }
    .badge-quoted { background:#e8f5e9; color:#2d6a4f; }
    .badge-won { background:#d3f9d8; color:#1a6b2a; }
    .badge-lost { background:#ffe3e3; color:#c92a2a; }
    .badge-scheduled { background:#e3fafc; color:#0b7285; }
    .badge-in-progress { background:#fff3bf; color:#946c00; }
    .badge-completed { background:#d3f9d8; color:#1a6b2a; }
    .badge-invoiced { background:#f3d9fa; color:#6a1b9a; }
    .badge-paid { background:#d3f9d8; color:#1a6b2a; }
    .badge-overdue { background:#ffe3e3; color:#c92a2a; }
    .badge-draft { background:var(--stone-200); color:var(--stone-700); }

    /* Cards */
    .card {
      background:var(--stone-50); border-radius:var(--radius-lg); padding:20px;
      box-shadow:var(--shadow-sm); border:1px solid var(--stone-200);
      transition:box-shadow 0.2s;
    }
    .card:hover { box-shadow:var(--shadow-md); }

    /* Kanban */
    .kanban-col { min-width:240px; max-width:270px; }
    .kanban-card {
      background:var(--stone-50); border-radius:var(--radius); padding:14px;
      border:1px solid var(--stone-200); cursor:grab; transition:all 0.2s;
      box-shadow:var(--shadow-sm);
    }
    .kanban-card:hover { box-shadow:var(--shadow-md); transform:translateY(-2px); }
    .kanban-card.dragging { opacity:0.5; cursor:grabbing; }
    .kanban-drop-zone { min-height:80px; border:2px dashed var(--stone-300); border-radius:var(--radius); padding:8px; }
    .kanban-drop-zone.over { border-color:var(--warm-gold); background:rgba(201,169,110,0.06); }

    /* Table */
    table { width:100%; border-collapse:collapse; }
    th { text-align:left; padding:10px 14px; font-size:11px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:var(--stone-500); border-bottom:2px solid var(--stone-200); }
    td { padding:12px 14px; font-size:13px; border-bottom:1px solid var(--stone-200); vertical-align:middle; }
    tr:hover td { background:var(--stone-100); }
    tr:last-child td { border-bottom:none; }

    /* Stat card */
    .stat-card {
      background:var(--stone-50); border-radius:var(--radius-lg); padding:20px 24px;
      border:1px solid var(--stone-200); box-shadow:var(--shadow-sm);
    }
    .stat-value { font-family:var(--font-display); font-size:36px; font-weight:600; color:var(--stone-900); line-height:1; }
    .stat-label { font-size:12px; color:var(--stone-500); font-weight:500; letter-spacing:0.05em; text-transform:uppercase; margin-top:6px; }

    /* Calendar */
    .cal-day { min-height:90px; border:1px solid var(--stone-200); padding:6px; border-radius:6px; font-size:12px; }
    .cal-day.today { background:rgba(201,169,110,0.1); border-color:var(--warm-gold); }
    .cal-day.other-month { background:var(--stone-100); color:var(--stone-400); }
    .cal-event { background:var(--warm-gold); color:white; border-radius:4px; padding:2px 6px; font-size:11px; margin-top:3px; cursor:pointer; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .cal-event.job { background:var(--accent-green); }
    .cal-event.follow-up { background:var(--accent-blue); }

    /* Nav */
    .nav-item {
      display:flex; align-items:center; gap:10px; padding:10px 14px;
      border-radius:var(--radius); cursor:pointer; font-size:13px; font-weight:500;
      color:var(--stone-400); transition:all 0.2s; text-decoration:none;
    }
    .nav-item:hover { background:rgba(255,255,255,0.08); color:var(--stone-200); }
    .nav-item.active { background:rgba(201,169,110,0.18); color:var(--warm-gold); }
    .nav-item svg { flex-shrink:0; }

    /* Tabs */
    .tab-bar { display:flex; border-bottom:2px solid var(--stone-200); margin-bottom:20px; gap:4px; }
    .tab { padding:9px 18px; font-size:13px; font-weight:500; cursor:pointer; color:var(--stone-500); border-bottom:2px solid transparent; margin-bottom:-2px; transition:all 0.2s; }
    .tab.active { color:var(--warm-gold); border-bottom-color:var(--warm-gold); }
    .tab:hover:not(.active) { color:var(--stone-800); }

    /* Gallery */
    .photo-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(140px,1fr)); gap:10px; }
    .photo-thumb { aspect-ratio:1; border-radius:var(--radius); object-fit:cover; cursor:pointer; transition:transform 0.2s; border:2px solid var(--stone-200); background:var(--stone-200); display:flex; align-items:center; justify-content:center; font-size:32px; }
    .photo-thumb:hover { transform:scale(1.04); border-color:var(--warm-gold); }

    /* Misc */
    .divider { border:none; border-top:1px solid var(--stone-200); margin:16px 0; }
    .text-muted { color:var(--stone-500); font-size:13px; }
    .empty-state { text-align:center; padding:48px 20px; color:var(--stone-400); }
    .empty-state svg { margin-bottom:12px; }
    .section-title { font-family:var(--font-display); font-size:28px; font-weight:600; color:var(--stone-900); margin-bottom:6px; }
    .section-sub { font-size:13px; color:var(--stone-500); margin-bottom:24px; }
    .avatar { width:34px; height:34px; border-radius:50%; background:var(--sand-300); display:inline-flex; align-items:center; justify-content:center; font-size:13px; font-weight:600; color:var(--stone-700); flex-shrink:0; }
    .progress-bar { height:6px; background:var(--stone-200); border-radius:3px; overflow:hidden; }

    /* Desktop font size boost — keeps mobile untouched */
    @media (min-width: 769px) {
      body { font-size: 15px; }
      td { font-size: 14.5px; padding: 13px 16px; }
      th { font-size: 12px; padding: 11px 16px; }
      .text-muted { font-size: 14px; }
      .section-title { font-size: 32px; }
      .section-sub { font-size: 14px; }
      label { font-size: 13px; }
      input, select, textarea { font-size: 15px; padding: 10px 14px; }
      input[type="radio"], input[type="checkbox"] { width:auto; padding:0; font-size:inherit; }
      .btn { font-size: 14px; padding: 10px 20px; }
      .btn-sm { font-size: 13px; padding: 7px 14px; }
      .badge { font-size: 12px; padding: 3px 11px; }
      .nav-item { font-size: 14px; padding: 11px 14px; }
      .tab { font-size: 14px; }
      .stat-label { font-size: 13px; }
      .cal-day { font-size: 13px; }
      .cal-event { font-size: 12px; }
      .empty-state { font-size: 14px; }
      .avatar { font-size: 14px; }
    }
    .progress-fill { height:100%; background:var(--warm-gold); border-radius:3px; transition:width 0.4s ease; }

    /* Responsive */
    @media (max-width:768px) {
      .form-grid { grid-template-columns:1fr; }
      .sidebar { display:none; }
    }
  `}</style>
);

// ── IMAGE COMPRESSION UTILITY ─────────────────────────────────────────────────
// Resizes photos to max 1200px and compresses to JPEG ~75% before base64 storage.
// Prevents Supabase statement timeouts caused by multi-MB base64 in JSONB columns.
const compressImage = (dataUrl, maxDim = 1200, quality = 0.75) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => {
    let { width, height } = img;
    if (width > maxDim || height > maxDim) {
      const ratio = Math.min(maxDim / width, maxDim / height);
      width = Math.round(width * ratio);
      height = Math.round(height * ratio);
    }
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, width, height);
    resolve(canvas.toDataURL('image/jpeg', quality));
  };
  img.onerror = () => resolve(dataUrl); // fallback to original on error
  img.src = dataUrl;
});

// ── SVG Icons ─────────────────────────────────────────────────────────────────
const Icon = ({ name, size = 16, color = "currentColor" }) => {
  const icons = {
    dashboard: <><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></>,
    leads: <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    pipeline: <><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></>,
    jobs: <><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></>,
    customers: <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>,
    calendar: <><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>,
    invoice: <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></>,
    estimate: <><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></>,
    gallery: <><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></>,
    plus: <><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>,
    search: <><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></>,
    edit: <><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></>,
    trash: <><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></>,
    phone_in: <><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.18 2 2 0 0 1 3.59 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.57a16 16 0 0 0 6.29 6.29l.44-.44a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/><polyline points="17 1 21 5 17 9"/><line x1="21" y1="5" x2="9" y2="5"/></>,
    phone_out: <><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.18 2 2 0 0 1 3.59 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.57a16 16 0 0 0 6.29 6.29l.44-.44a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/><polyline points="21 1 17 5 21 9"/><line x1="9" y1="5" x2="21" y2="5"/></>,
    phone_missed: <><line x1="23" y1="1" x2="17" y2="7"/><line x1="17" y1="1" x2="23" y2="7"/><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.18 2 2 0 0 1 3.59 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.57a16 16 0 0 0 6.29 6.29l.44-.44a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></>,
    calls: <><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.18 2 2 0 0 1 3.59 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.57a16 16 0 0 0 6.29 6.29l.44-.44a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></>,
    voicemail: <><circle cx="5.5" cy="11.5" r="4.5"/><circle cx="18.5" cy="11.5" r="4.5"/><line x1="5.5" y1="16" x2="18.5" y2="16"/></>,
    clock: <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    mail: <><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></>,
    dollar: <><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></>,
    chevron_down: <><polyline points="6 9 12 15 18 9"/></>,
    chevron_right: <><polyline points="9 18 15 12 9 6"/></>,
    x: <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>,
    check: <><polyline points="20 6 9 17 4 12"/></>,
    eye: <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>,
    upload: <><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></>,
    tile: <><rect x="2" y="2" width="9" height="9" rx="1"/><rect x="13" y="2" width="9" height="9" rx="1"/><rect x="2" y="13" width="9" height="9" rx="1"/><rect x="13" y="13" width="9" height="9" rx="1"/></>,
    location: <><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></>,
    note: <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="13" y1="17" x2="8" y2="17"/></>,
    star: <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    warning: <><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></>,
    playbook:  <><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></>,
    sop:       <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><line x1="10" y1="9" x2="8" y2="9"/></>,
    script:    <><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></>,
    folder:    <><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></>,
    hardhat:   <><path d="M2 18h20"/><path d="M12 2a8 8 0 0 1 8 8v2H4v-2a8 8 0 0 1 8-8z"/><line x1="12" y1="2" x2="12" y2="10"/></>,
    clipboard: <><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></>,
    download:  <><polyline points="8 17 12 21 16 17"/><line x1="12" y1="21" x2="12" y2="3"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></>,
    copy:      <><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></>,
    megaphone: <><path d="M3 11l19-9-9 19-2-8-8-2z"/></>,
    target:    <><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></>,
    trending:  <><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></>,
    zap:       <><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></>,
    link:      <><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></>,
    refresh:   <><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-.02-6.28"/></>,
    bell:      <><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {icons[name] || null}
    </svg>
  );
};

// ── INVOICE HELPERS ───────────────────────────────────────────────────────────
const invPaidToDate = (inv) => (inv.payments||[]).filter(p=>p.status==="Paid").reduce((s,p)=>s+(p.amount||0),0);
const stripCONotes = (notes) => (notes || "").replace(/\n*── Change Order CO-\d{3} \(\d{4}-\d{2}-\d{2}\) ──[^─]*/g, "").replace(/\n*— Change Order\nCO-\d{3} \(\d{4}-\d{2}-\d{2}\) — Scope (Edited|Added): \$[\d,]+ → \$[\d,]+.*/g, "").replace(/\n+$/, "").trim();
const invTotal = (inv) => inv.contractTotal || inv.contract_total || 0;
const invRemaining = (inv) => invTotal(inv) - invPaidToDate(inv);
const invDisplayId = (inv) => inv.display_id || inv.id || '—';

// ── CLIENT CREDIT ─────────────────────────────────────────────────────────────
// Every dollar the client has already put toward an estimate, from ANY source:
//   1. Paid payments on ANY invoice linked to the estimate (by estimate_id, or
//      through the estimate's job) — not just the first one found. This is what
//      makes separate draw/progress invoices show up on the client page.
//   2. Manually-logged prior_deposits on the estimate itself (Change Order panel).
// A prior deposit that duplicates an invoice payment (same amount + same date) is
// counted once, so logging a draw in both places doesn't double up.
const estimateInvoices = (est, invoices, jobs) => {
  if (!est) return [];
  const jobIds = (jobs || [])
    .filter(j => (j.estimateId || j.estimate_id) === est.id)
    .map(j => j.id);
  return (invoices || []).filter(inv =>
    (inv.estimate_id && inv.estimate_id === est.id) ||
    (inv.jobId  != null && jobIds.includes(inv.jobId)) ||
    (inv.job_id != null && jobIds.includes(inv.job_id))
  );
};

const estimatePaidToDate = (est, invoices, jobs) => {
  if (!est) return 0;
  const paidPmts = estimateInvoices(est, invoices, jobs)
    .flatMap(inv => (inv.payments || []).filter(p => p.status === "Paid"));
  const invPaid = paidPmts.reduce((s, p) => s + (Number(p.amount) || 0), 0);
  const seen = paidPmts.map(p => `${Math.round(Number(p.amount) || 0)}|${p.paidDate || ""}`);
  const depPaid = (est.prior_deposits || []).reduce((s, d) => {
    const amt = Number(d.amount) || 0;
    if (amt <= 0) return s;
    const i = seen.indexOf(`${Math.round(amt)}|${d.date || ""}`);
    if (i > -1) { seen.splice(i, 1); return s; }   // already counted via an invoice
    return s + amt;
  }, 0);
  return invPaid + depPaid;
};

// ── SMS HISTORY HELPERS ──────────────────────────────────────────────────────
// Merge fresh rows into existing messages by id (keeps older history loaded)
const mergeMessages = (prev, fresh) => {
  const map = new Map((prev || []).map(m => [m.id, m]));
  (fresh || []).forEach(m => map.set(m.id, { ...map.get(m.id), ...m }));
  return [...map.values()].sort((a, b) => (b.created_at || '').localeCompare(a.created_at || ''));
};
// Mark a conversation read in the database (replaces the old bulk upsert)
const markThreadRead = (msgs, key) => {
  const ids = (msgs || []).filter(m => !m.read && m.direction === 'inbound' && m.phone?.replace(/\D/g, '').slice(-10) === key).map(m => m.id);
  if (ids.length) supabase.from('messages').update({ read: true }).in('id', ids).then(({ error }) => { if (error) console.warn('[sms] mark read failed:', error.message); });
};

// ── SEED DATA ─────────────────────────────────────────────────────────────────
const initLeads = [
  { id: 1, name: "Marcus Webb", email: "marcus@email.com", phone: "(757) 555-0192", source: "Google", status: "New", project: "Kitchen Backsplash", value: 3200, date: "2024-03-01", notes: "Interested in subway tile, wants neutral palette.", address: "412 Oceanview Dr, VA Beach" },
  { id: 2, name: "Sandra Kim", email: "skim@email.com", phone: "(757) 555-0284", source: "Referral", status: "Contacted", project: "Master Bath", value: 7800, date: "2024-03-03", notes: "Referred by Johnson project. Wants large format tiles.", address: "91 Pine Ridge Rd, Chesapeake" },
  { id: 3, name: "Derrick Holloway", email: "d.holloway@email.com", phone: "(757) 555-0371", source: "Facebook", status: "Quoted", project: "Pool Deck", value: 12500, date: "2024-03-05", notes: "Outdoor slip-resistant tile needed.", address: "7 Inlet Court, Norfolk" },
  { id: 4, name: "Priya Nair", email: "priya.n@email.com", phone: "(757) 555-0415", source: "Google", status: "Won", project: "Entryway & Foyer", value: 4100, date: "2024-02-20", notes: "Marble look porcelain chosen. Deposit received.", address: "230 Heritage Blvd, Suffolk" },
  { id: 5, name: "Tom Brewer", email: "tbrewer@email.com", phone: "(757) 555-0509", source: "Yelp", status: "Lost", project: "Bathroom Remodel", value: 5600, date: "2024-02-15", notes: "Went with competitor. Price too high.", address: "88 Windmill Way, VA Beach" },
  { id: 6, name: "Claire Fontaine", email: "cfontaine@email.com", phone: "(757) 555-0623", source: "Referral", status: "Contacted", project: "Living Room Floor", value: 9200, date: "2024-03-08", notes: "Wants to see samples first.", address: "155 Cobblestone Ln, Chesapeake" },
];

const initCustomers = [
  { id: 1, name: "Priya Nair", email: "priya.n@email.com", phone: "(757) 555-0415", address: "230 Heritage Blvd, Suffolk", totalJobs: 2, totalRevenue: 8700, since: "2023-08", notes: "Excellent client, always pays on time." },
  { id: 2, name: "Helen Marsh", email: "hmarsh@email.com", phone: "(757) 555-0788", address: "640 Bayshore Dr, Norfolk", totalJobs: 3, totalRevenue: 24500, since: "2022-05", notes: "Referred 2 clients. VIP treatment." },
  { id: 3, name: "George Santos", email: "gsantos@email.com", phone: "(757) 555-0831", address: "17 Magnolia St, Portsmouth", totalJobs: 1, totalRevenue: 6200, since: "2023-11", notes: "" },
  { id: 4, name: "Tina Wallace", email: "twallace@email.com", phone: "(757) 555-0944", address: "310 Baxter Ave, VA Beach", totalJobs: 4, totalRevenue: 31200, since: "2021-03", notes: "Long-term client. Large luxury home." },
];

const initJobs = [
  { id: 1, customerId: 1, customer: "Priya Nair",    project: "Entryway & Foyer",      status: "Completed",  startDate: "2024-03-15", endDate: "2024-03-18", value: 4100,  cost: 2100,  address: "230 Heritage Blvd, Suffolk",    notes: "Marble porcelain 24x24. Completed on schedule.", crew: "Team A", photos: [], estimateId: null },
  { id: 2, customerId: 2, customer: "Helen Marsh",   project: "Master Bath Remodel",   status: "In Progress",startDate: "2024-03-20", endDate: "2024-03-28", value: 11200, cost: 6800,  address: "640 Bayshore Dr, Norfolk",       notes: "Large format 32x32 stone look. Day 3 of 8.",     crew: "Team B", photos: [], estimateId: "EST-002" },
  { id: 3, customerId: 4, customer: "Tina Wallace",  project: "Outdoor Patio",         status: "Scheduled",  startDate: "2024-04-02", endDate: "2024-04-07", value: 8400,  cost: 4950,  address: "310 Baxter Ave, VA Beach",       notes: "Travertine pavers, 400 sq ft.",                  crew: "Team A", photos: [], estimateId: null },
  { id: 4, customerId: 3, customer: "George Santos", project: "Kitchen Floor",         status: "Completed",  startDate: "2024-02-10", endDate: "2024-02-13", value: 6200,  cost: 2900,  address: "17 Magnolia St, Portsmouth",     notes: "Herringbone pattern, classic white subway.",     crew: "Team C", photos: [], estimateId: "EST-003" },
];

const initInvoices = [
  {
    id: "INV-001", jobId: 1, customer: "Priya Nair", project: "Entryway & Foyer",
    contractTotal: 4100, issued: "2024-03-19", status: "Paid",
    payments: [
      { id: "pmt-1", label: "Deposit (50%)", amount: 2050, due: "2024-03-26", status: "Paid", paidDate: "2024-03-22", method: "Found Bank", note: "" },
      { id: "pmt-2", label: "Balance (50%)", amount: 2050, due: "2024-04-02", status: "Paid", paidDate: "2024-03-30", method: "Check", note: "" },
    ]
  },
  {
    id: "INV-002", jobId: 4, customer: "George Santos", project: "Kitchen Floor",
    contractTotal: 6200, issued: "2024-02-14", status: "Paid",
    payments: [
      { id: "pmt-1", label: "Deposit (50%)", amount: 3100, due: "2024-02-21", status: "Paid", paidDate: "2024-02-18", method: "Stripe", note: "" },
      { id: "pmt-2", label: "Balance (50%)", amount: 3100, due: "2024-02-28", status: "Paid", paidDate: "2024-02-27", method: "Stripe", note: "" },
    ]
  },
  {
    id: "INV-003", jobId: 2, customer: "Helen Marsh", project: "Master Bath Remodel",
    contractTotal: 5600, issued: "2024-03-20", status: "Invoiced",
    payments: [
      { id: "pmt-1", label: "Deposit (50%)", amount: 2800, due: "2024-03-27", status: "Paid", paidDate: "2024-03-24", method: "Found Bank", note: "" },
      { id: "pmt-2", label: "Balance (50%)", amount: 2800, due: "2024-04-05", status: "Pending", paidDate: null, method: "", note: "" },
    ]
  },
  {
    id: "INV-004", jobId: 3, customer: "Tina Wallace", project: "Outdoor Patio",
    contractTotal: 4200, issued: "2024-03-28", status: "Draft",
    payments: [
      { id: "pmt-1", label: "Deposit (50%)", amount: 2100, due: "2024-04-04", status: "Pending", paidDate: null, method: "", note: "" },
      { id: "pmt-2", label: "Balance (50%)", amount: 2100, due: "2024-04-12", status: "Pending", paidDate: null, method: "", note: "" },
    ]
  },
];

const initEstimates = [
  { id: "EST-001", customer: "Derrick Holloway", project: "Pool Deck", date: "2024-03-06", status: "Sent", pricingMode: "bundled", items: [{ desc: "Porcelain Pavers 12x12", laborDesc: "Supply and install 12x12 porcelain pavers over prepared concrete deck. Includes layout, cutting, and grouting to manufacturer spec.", qty: 450, unit: "sqft", price: 18, materials: [{ desc: "Porcelain Pavers 12x12 — Ivory", qty: 450, unit: "sqft", price: 3.80 }] }, { desc: "Labor & Installation", laborDesc: "Surface preparation, thinset application, paver setting, and joint filling for full pool deck area.", qty: 450, unit: "sqft", price: 9, materials: [{ desc: "Thinset Mortar Outdoor", qty: 8, unit: "ea", price: 34.00 }, { desc: "Polymer Sand Jointing", qty: 4, unit: "ea", price: 28.00 }] }, { desc: "Waterproofing", laborDesc: "Apply waterproof membrane to full deck substrate prior to tile installation.", qty: 1, unit: "job", price: 850, materials: [] }], notes: "Slip-resistant outdoor grade only." },
  { id: "EST-002", customer: "Sandra Kim", project: "Master Bath", date: "2024-03-07", status: "Draft", pricingMode: "bundled", items: [{ desc: "Large Format Tile 24x48", laborDesc: "Install large format porcelain tile in waterfall layout on shower walls and floor. Includes precision cuts around fixtures and niches.", qty: 220, unit: "sqft", price: 22, materials: [{ desc: "Large Format Porcelain 24x48", qty: 220, unit: "sqft", price: 4.20 }] }, { desc: "Labor & Installation", laborDesc: "", qty: 220, unit: "sqft", price: 12, materials: [{ desc: "Mapei Ultraflex 2 Adhesive", qty: 6, unit: "ea", price: 38.50 }, { desc: "Mapei Grout — Warm Gray", qty: 4, unit: "ea", price: 22.00 }] }, { desc: "Niche & Shower Pan", laborDesc: "Build and waterproof recessed shower niche and pre-sloped shower pan using Wedi system.", qty: 1, unit: "job", price: 1200, materials: [{ desc: "Wedi Shower System", qty: 1, unit: "ea", price: 385.00 }] }], notes: "Client wants waterfall layout on back wall." },
  { id: "EST-003", customer: "Claire Fontaine", project: "Living Room Floor", date: "2024-03-09", status: "Draft", pricingMode: "bundled", items: [{ desc: "Engineered Stone 18x18", laborDesc: "Supply and install 18x18 engineered stone tile across living room floor. Includes floor prep, leveling, layout, and edge trim installation.", qty: 480, unit: "sqft", price: 16, materials: [{ desc: "Engineered Stone 18x18 — Calacatta", qty: 480, unit: "sqft", price: 4.20 }, { desc: "Schluter Rondec Edge Strip 8ft", qty: 8, unit: "ea", price: 28.00 }] }, { desc: "Labor & Installation", laborDesc: "Full installation labor including thinset application, tile setting, grouting, and final cleanup.", qty: 480, unit: "sqft", price: 8, materials: [{ desc: "Mapei Ultraflex 2 Adhesive (50lb)", qty: 10, unit: "ea", price: 38.50 }, { desc: "Mapei Keracolor Grout — Warm Gray", qty: 6, unit: "ea", price: 22.00 }] }], notes: "" },
];

const initMaterials = [
  { id:1,  jobId:2, invId:"INV-003", item:"Large Format Porcelain 24x48", cat:"Tile",             supplier:"The Tile Shop", qty:260, price:4.20,  date:"2024-03-18", ref:"TS-44821", reimb:false },
  { id:2,  jobId:2, invId:"INV-003", item:"Mapei Ultraflex 2 Adhesive",   cat:"Adhesive/Grout",  supplier:"Home Depot",    qty:12,  price:38.50, date:"2024-03-18", ref:"HD-9921",  reimb:false },
  { id:3,  jobId:2, invId:"INV-003", item:"Mapei Grout — Warm Gray",      cat:"Adhesive/Grout",  supplier:"Home Depot",    qty:8,   price:22.00, date:"2024-03-19", ref:"HD-9922",  reimb:false },
  { id:4,  jobId:2, invId:"INV-003", item:"Schluter Rondec Strip 8ft",    cat:"Other",            supplier:"The Tile Shop", qty:4,   price:28.00, date:"2024-03-19", ref:"TS-44830", reimb:false },
  { id:5,  jobId:2, invId:"INV-003", item:"Wedi Shower System",           cat:"Backer/Membrane", supplier:"Floor & Decor", qty:1,   price:385,   date:"2024-03-20", ref:"FD-7712",  reimb:false },
  { id:6,  jobId:2, invId:"INV-003", item:"Tile Saw Blade 10in",          cat:"Tools",            supplier:"Home Depot",    qty:2,   price:45.00, date:"2024-03-20", ref:"HD-9945",  reimb:true  },
  { id:7,  jobId:1, invId:"INV-001", item:"Subway Tile 3x6 White",        cat:"Tile",             supplier:"Floor & Decor", qty:55,  price:3.80,  date:"2024-03-10", ref:"FD-7680",  reimb:false },
  { id:8,  jobId:1, invId:"INV-001", item:"Thinset Mortar Gray",          cat:"Adhesive/Grout",  supplier:"Home Depot",    qty:3,   price:31.00, date:"2024-03-10", ref:"HD-9870",  reimb:false },
  { id:9,  jobId:4, invId:"INV-002", item:"Herringbone Subway Tile",      cat:"Tile",             supplier:"The Tile Shop", qty:120, price:4.60,  date:"2024-02-10", ref:"TS-44100", reimb:false },
  { id:10, jobId:4, invId:"INV-002", item:"Mapei Keracolor Grout",        cat:"Adhesive/Grout",  supplier:"Home Depot",    qty:5,   price:24.00, date:"2024-02-10", ref:"HD-9800",  reimb:false },
];

const GOOGLE_REVIEW_LINK = "https://g.page/r/CainbWNwvp6sEBM/review";

const initReviews = [
  { id:1, jobId:1, customer:"Priya Nair", project:"Entryway & Foyer", crew:"Team A", requestedDate:"2024-03-19", respondedDate:"2024-03-21", status:"Responded", rating:5, cleanliness:5, communication:5, comment:"Absolutely beautiful work. The marble porcelain looks stunning and the team was incredibly professional. Would hire again without hesitation.", googleSent:true, flagged:false },
  { id:2, jobId:4, customer:"George Santos", project:"Kitchen Floor", crew:"Team C", requestedDate:"2024-02-14", respondedDate:"2024-02-16", status:"Responded", rating:4, cleanliness:4, communication:5, comment:"Great craftsmanship on the herringbone pattern. Took a little longer than expected but the result was worth it.", googleSent:false, flagged:false },
  { id:3, jobId:2, customer:"Helen Marsh", project:"Master Bath Remodel", crew:"Team B", requestedDate:"2024-03-29", respondedDate:null, status:"Pending", rating:null, cleanliness:null, communication:null, comment:"", googleSent:false, flagged:false },
];

const initEvents = [
  { id: 1, title: "Site Visit – Sandra Kim", date: "2024-03-12", type: "lead", time: "10:00 AM" },
  { id: 2, title: "Job Start – Helen Marsh Bath", date: "2024-03-20", type: "job", time: "8:00 AM" },
  { id: 3, title: "Follow-up – Claire Fontaine", date: "2024-03-14", type: "follow-up", time: "2:00 PM" },
  { id: 4, title: "Job – Tina Wallace Patio", date: "2024-04-02", type: "job", time: "7:30 AM" },
  { id: 5, title: "Estimate Delivery – Derrick", date: "2024-03-13", type: "lead", time: "3:00 PM" },
];

const initCalls = [
  { id: 1, contact: "Marcus Webb",    phone: "(757) 555-0192", direction: "inbound",  outcome: "Answered",  duration: "4:22", date: "2024-03-01", time: "9:14 AM",  notes: "First inquiry, interested in kitchen backsplash. Sending estimate.", linkedLead: 1, linkedCustomer: null },
  { id: 2, contact: "Sandra Kim",     phone: "(757) 555-0284", direction: "outbound", outcome: "Answered",  duration: "6:48", date: "2024-03-04", time: "11:30 AM", notes: "Discussed large format tile options. Site visit scheduled for 3/12.", linkedLead: 2, linkedCustomer: null },
  { id: 3, contact: "Derrick Holloway",phone:"(757) 555-0371", direction: "inbound",  outcome: "Answered",  duration: "3:05", date: "2024-03-05", time: "2:00 PM",  notes: "Pool deck inquiry. Needs slip-resistant outdoor tile.", linkedLead: 3, linkedCustomer: null },
  { id: 4, contact: "Priya Nair",     phone: "(757) 555-0415", direction: "outbound", outcome: "Answered",  duration: "8:10", date: "2024-03-14", time: "10:00 AM", notes: "Confirmed deposit received. Project starts 3/15.", linkedLead: null, linkedCustomer: 1 },
  { id: 5, contact: "Claire Fontaine",phone: "(757) 555-0623", direction: "outbound", outcome: "Voicemail", duration: "0:28", date: "2024-03-09", time: "3:30 PM",  notes: "Left voicemail re: sample drop-off.", linkedLead: 6, linkedCustomer: null },
  { id: 6, contact: "Unknown",        phone: "(757) 555-0881", direction: "inbound",  outcome: "Missed",    duration: "0:00", date: "2024-03-10", time: "8:45 AM",  notes: "Missed call. No voicemail left.", linkedLead: null, linkedCustomer: null },
  { id: 7, contact: "Helen Marsh",    phone: "(757) 555-0788", direction: "inbound",  outcome: "Answered",  duration: "5:33", date: "2024-03-18", time: "4:15 PM",  notes: "Called to confirm tile selection for master bath project.", linkedLead: null, linkedCustomer: 2 },
  { id: 8, contact: "Tina Wallace",   phone: "(757) 555-0944", direction: "outbound", outcome: "Answered",  duration: "7:02", date: "2024-03-22", time: "1:00 PM",  notes: "Reviewed patio layout. Confirmed travertine pavers.", linkedLead: null, linkedCustomer: 4 },
];

// ── PIPELINE STAGES ───────────────────────────────────────────────────────────
const PIPELINE_STAGES = ["New", "Contacted", "Quoted", "Won", "Lost"];
const STAGE_COLORS = { New: "#3b5bdb", Contacted: "#946c00", Quoted: "#2d6a4f", Won: "#1a6b2a", Lost: "#c92a2a" };

// ── MODAL COMPONENT ───────────────────────────────────────────────────────────
const Modal = ({ title, onClose, children }) => (
  <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
    <div className="modal-box fade-in">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <h2 style={{ fontFamily: "var(--font-display)", fontSize: "22px", fontWeight: 600 }}>{title}</h2>
        <button className="btn-icon" onClick={onClose}><Icon name="x" size={18} /></button>
      </div>
      {children}
    </div>
  </div>
);

// ── DELETE CONFIRMATION MODAL ────────────────────────────────────────────────
const ConfirmDeleteModal = ({ target, onConfirm, onCancel }) => {
  if (!target) return null;
  const typeLabels = { leads:"Lead", customers:"Customer", jobs:"Job", estimates:"Estimate", invoices:"Invoice", events:"Calendar Event", calls:"Call", reviews:"Review" };
  return (
    <Modal title="Confirm Delete" onClose={onCancel}>
      <div style={{ textAlign:"center", padding:"10px 0 18px" }}>
        <div style={{ fontSize:40, marginBottom:12 }}>🗑</div>
        <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:600, marginBottom:6 }}>
          Delete {typeLabels[target.table] || "Record"}?
        </div>
        <div style={{ fontSize:"14px", fontWeight:600, color:"var(--stone-800)", marginBottom:4 }}>{target.label}</div>
        {target.sublabel && <div style={{ fontSize:"12px", color:"var(--stone-500)", marginBottom:4 }}>{target.sublabel}</div>}
        <div style={{ fontSize:"13px", color:"var(--stone-500)", marginBottom:6, lineHeight:1.5 }}>
          This item will be moved to Trash and automatically purged after 30 days.
        </div>
        <div style={{ display:"inline-flex", alignItems:"center", gap:6, background:"rgba(201,169,110,0.08)", padding:"6px 14px", borderRadius:99, fontSize:"12px", color:"var(--warm-gold)", fontWeight:600, marginBottom:18 }}>
          ♻️ You can restore it from Trash anytime within 30 days
        </div>
        <div style={{ display:"flex", gap:10, justifyContent:"center" }}>
          <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
          <button className="btn btn-danger" onClick={onConfirm}>
            <Icon name="trash" size={14} /> Move to Trash
          </button>
        </div>
      </div>
    </Modal>
  );
};

// ── TRASH PAGE ───────────────────────────────────────────────────────────────
const TrashPage = ({ trashItems, onRestore, onPermanentDelete }) => {
  const [filter, setFilter] = useState("All");
  const typeLabels = { leads:"Lead", customers:"Customer", jobs:"Job", estimates:"Estimate", invoices:"Invoice", events:"Event", calls:"Call", reviews:"Review" };
  const types = ["All", ...new Set(trashItems.map(t => t.table))];

  const filtered = filter === "All" ? trashItems : trashItems.filter(t => t.table === filter);
  const sortedItems = [...filtered].sort((a,b) => (b.deletedAt||0) - (a.deletedAt||0));

  const getDaysLeft = (deletedAt) => {
    const elapsed = Date.now() - deletedAt;
    const daysLeft = Math.max(0, 30 - Math.floor(elapsed / (24*60*60*1000)));
    return daysLeft;
  };

  return (
    <div className="fade-in" style={{ minHeight:"calc(100vh - 120px)" }}>
      <div style={{ marginBottom:"20px" }}>
        <h1 className="section-title">Trash</h1>
        <p className="section-sub">Deleted records are kept for 30 days before permanent removal.</p>
      </div>

      {trashItems.length === 0 ? (
        <div className="card" style={{ textAlign:"center", padding:"60px 20px" }}>
          <div style={{ fontSize:48, marginBottom:12, opacity:0.3 }}>🗑</div>
          <div style={{ fontFamily:"var(--font-display)", fontSize:"20px", fontWeight:600, color:"var(--stone-400)", marginBottom:6 }}>Trash is Empty</div>
          <div style={{ fontSize:"13px", color:"var(--stone-400)" }}>Deleted records will appear here for 30 days before being permanently removed.</div>
        </div>
      ) : (
        <>
          <div style={{ display:"flex", gap:"8px", marginBottom:"16px", flexWrap:"wrap" }}>
            {types.map(t => (
              <button key={t} className="btn btn-sm" style={{ background:filter===t?"var(--warm-gold)":"var(--stone-200)", color:filter===t?"white":"var(--stone-700)" }} onClick={() => setFilter(t)}>
                {t === "All" ? `All (${trashItems.length})` : `${typeLabels[t] || t}s (${trashItems.filter(i => i.table === t).length})`}
              </button>
            ))}
          </div>
          <div className="card" style={{ padding:0 }}>
            <table>
              <thead><tr><th>Type</th><th>Name / Description</th><th>Deleted</th><th>Expires</th><th>Actions</th></tr></thead>
              <tbody>
                {sortedItems.map(item => {
                  const daysLeft = getDaysLeft(item.deletedAt);
                  return (
                    <tr key={`${item.table}-${item.id}`}>
                      <td><span className="badge badge-draft" style={{ textTransform:"capitalize" }}>{typeLabels[item.table] || item.table}</span></td>
                      <td>
                        <div style={{ fontWeight:600 }}>{item.label}</div>
                        {item.sublabel && <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:1 }}>{item.sublabel}</div>}
                      </td>
                      <td className="text-muted">{new Date(item.deletedAt).toLocaleDateString("en-US",{month:"short",day:"numeric"})}</td>
                      <td>
                        <span style={{ fontSize:"12px", fontWeight:600, color: daysLeft <= 7 ? "var(--accent-red)" : "var(--stone-500)" }}>
                          {daysLeft} day{daysLeft !== 1 ? "s" : ""} left
                        </span>
                      </td>
                      <td>
                        <div style={{ display:"flex", gap:4 }}>
                          <button className="btn btn-sm btn-secondary" style={{ border:"1.5px solid var(--accent-green)", color:"var(--accent-green)" }} onClick={() => onRestore(item.table, item.id)}>
                            ♻️ Restore
                          </button>
                          <button className="btn btn-sm btn-danger" onClick={() => onPermanentDelete(item.table, item.id)}>
                            Purge
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

// ── Shared utility: map local estimate → Supabase row (used by Estimates, Jobs, and background sync) ──
const mapEstimateToRow = (e) => ({ id:e.id, customer:e.customer, project:e.project, date:e.date, status:e.status, notes:e.notes||'', items:e.items, surcharge:e.surcharge||false, pricing_mode:e.pricingMode||e.pricing_mode||'bundled', hide_mat_qty:e.hideMatQty||e.hide_mat_qty||false, sent_count:e.sent_count||null, last_sent_at:e.last_sent_at||null, resend_dates:e.resend_dates||null, audit_log:e.audit_log||null, change_orders:e.change_orders||null, prior_deposits:e.prior_deposits||null, override_total:e.override_total||null });

// ── DASHBOARD ─────────────────────────────────────────────────────────────────
const Dashboard = ({ leads, jobs, invoices, customers }) => {
  const totalRevenue = invoices.filter(i => i.status === "Paid").reduce((s, i) => s + invTotal(i), 0);
  const openJobs = jobs.filter(j => j.status === "In Progress").length;
  const pendingInvoices = invoices.filter(i => i.status === "Invoiced" || i.status === "Overdue").reduce((s, i) => s + invTotal(i), 0);
  const newLeads = leads.filter(l => l.status === "New" || l.status === "Contacted").length;

  const recentLeads = [...leads].sort((a,b) => new Date(b.date) - new Date(a.date)).slice(0,4);
  const recentJobs = jobs.slice(0,3);

  return (
    <div className="fade-in">
      <div style={{ marginBottom: "28px" }}>
        <h1 className="section-title">Welcome back 👋</h1>
        <p className="section-sub">Here's what's happening at Timeless Tile Pro today.</p>
      </div>

      {/* Stats */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "16px", marginBottom: "28px" }}>
        {[
          { label: "Revenue (YTD)", value: `$${totalRevenue.toLocaleString()}`, icon: "dollar", color: "var(--accent-green)" },
          { label: "Active Jobs", value: openJobs, icon: "jobs", color: "var(--warm-gold)" },
          { label: "Pending Invoices", value: `$${pendingInvoices.toLocaleString()}`, icon: "invoice", color: "var(--accent-amber)" },
          { label: "New Leads", value: newLeads, icon: "leads", color: "var(--accent-blue)" },
          { label: "Total Customers", value: customers.length, icon: "customers", color: "var(--stone-500)" },
        ].map(s => (
          <div className="stat-card" key={s.label} style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <div style={{ width: 44, height: 44, borderRadius: 10, background: s.color + "1a", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Icon name={s.icon} size={20} color={s.color} />
            </div>
            <div>
              <div className="stat-value" style={{ fontSize: "26px" }}>{s.value}</div>
              <div className="stat-label">{s.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
        {/* Recent Leads */}
        <div className="card">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "14px" }}>
            <h3 style={{ fontFamily: "var(--font-display)", fontSize: "18px", fontWeight: 600 }}>Recent Leads</h3>
          </div>
          {recentLeads.map(l => (
            <div key={l.id} style={{ display: "flex", alignItems: "center", gap: "12px", padding: "10px 0", borderBottom: "1px solid var(--stone-200)" }}>
              <div className="avatar">{l.name.split(" ").map(n=>n[0]).join("")}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 500, fontSize: "13px" }}>{l.name}</div>
                <div className="text-muted" style={{ fontSize: "12px" }}>{l.project} · ${l.value.toLocaleString()}</div>
              </div>
              <span className={`badge badge-${l.status.toLowerCase()}`}>{l.status}</span>
            </div>
          ))}
        </div>

        {/* Active Jobs */}
        <div className="card">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "14px" }}>
            <h3 style={{ fontFamily: "var(--font-display)", fontSize: "18px", fontWeight: 600 }}>Active Jobs</h3>
          </div>
          {recentJobs.map(j => {
            const start = new Date(j.startDate), end = new Date(j.endDate), today = new Date();
            const total = (end - start) / 86400000;
            const done = Math.min(Math.max((today - start) / 86400000, 0), total);
            const pct = total > 0 ? Math.round((done / total) * 100) : 0;
            return (
              <div key={j.id} style={{ padding: "10px 0", borderBottom: "1px solid var(--stone-200)" }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                  <span style={{ fontWeight: 500, fontSize: "13px" }}>{j.customer}</span>
                  <span className={`badge badge-${j.status.toLowerCase().replace(" ","-")}`}>{j.status}</span>
                </div>
                <div className="text-muted" style={{ fontSize: "12px", marginBottom: "6px" }}>{j.project} · {j.startDate} → {j.endDate}</div>
                <div className="progress-bar"><div className="progress-fill" style={{ width: `${pct}%` }} /></div>
              </div>
            );
          })}
        </div>

        {/* Invoice Summary */}
        <div className="card">
          <h3 style={{ fontFamily: "var(--font-display)", fontSize: "18px", fontWeight: 600, marginBottom: "14px" }}>Invoice Overview</h3>
          {[
            { label: "Paid", status: "Paid", color: "var(--accent-green)" },
            { label: "Outstanding", status: "Invoiced", color: "var(--accent-amber)" },
            { label: "Overdue", status: "Overdue", color: "var(--accent-red)" },
            { label: "Draft", status: "Draft", color: "var(--stone-400)" },
          ].map(r => {
            const amt = invoices.filter(i => i.status === r.status).reduce((s,i)=>s+invTotal(i),0);
            const cnt = invoices.filter(i => i.status === r.status).length;
            return (
              <div key={r.label} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid var(--stone-200)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <div style={{ width: 8, height: 8, borderRadius: "50%", background: r.color }} />
                  <span style={{ fontSize: "13px" }}>{r.label}</span>
                  <span className="text-muted">({cnt})</span>
                </div>
                <span style={{ fontWeight: 600, fontSize: "13px" }}>${amt.toLocaleString()}</span>
              </div>
            );
          })}
        </div>

        {/* Lead Sources */}
        <div className="card">
          <h3 style={{ fontFamily: "var(--font-display)", fontSize: "18px", fontWeight: 600, marginBottom: "14px" }}>Lead Sources</h3>
          {["Google", "Referral", "Facebook", "Yelp"].map(src => {
            const cnt = leads.filter(l => l.source === src).length;
            const pct = Math.round((cnt / leads.length) * 100);
            return (
              <div key={src} style={{ marginBottom: "12px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "4px" }}>
                  <span>{src}</span><span style={{ color: "var(--stone-500)" }}>{cnt} ({pct}%)</span>
                </div>
                <div className="progress-bar"><div className="progress-fill" style={{ width: `${pct}%`, background: src === "Google" ? "var(--accent-blue)" : src === "Referral" ? "var(--accent-green)" : src === "Facebook" ? "#3b5bdb" : "var(--accent-amber)" }} /></div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

// ── LEADS ─────────────────────────────────────────────────────────────────────
// ── PIPELINE TOAST ─────────────────────────────────────────────────────────────
const PipelineToast = ({ message, actionLabel, onAction, onClose }) => (
  <div style={{
    position:"fixed", bottom:24, right:24, zIndex:3000,
    background:"var(--stone-900)", color:"white", borderRadius:"var(--radius-lg)",
    padding:"14px 20px", display:"flex", alignItems:"center", gap:16,
    boxShadow:"0 8px 32px rgba(0,0,0,0.3)", animation:"modalIn 0.3s ease",
    maxWidth:360
  }}>
    <Icon name="check" size={18} color="var(--accent-green)" />
    <span style={{ fontSize:14, flex:1 }}>{message}</span>
    {actionLabel && <button onClick={onAction} style={{ background:"var(--warm-gold)", color:"white", border:"none", borderRadius:"var(--radius)", padding:"6px 12px", fontSize:12, cursor:"pointer", fontWeight:600, whiteSpace:"nowrap" }}>{actionLabel}</button>}
    <button onClick={onClose} style={{ background:"none", border:"none", color:"var(--stone-400)", cursor:"pointer", padding:0 }}><Icon name="x" size={14} /></button>
  </div>
);

const Leads = ({ leads, setLeads, jobs, setJobs, estimates, setEstimates, customers, setCustomers, setPage, addNotification, requestDelete, setEstimateViews }) => {
  const [view, setView]               = useState("list");
  const [modal, setModal]             = useState(null);   // "add" | lead obj | null
  const [photoModal, setPhotoModal]   = useState(null);   // lead obj for photo viewer
  const [lightbox, setLightbox]       = useState(null);   // { src, name, date }
  const [carryModal, setCarryModal]   = useState(null);   // lead obj for carry-over confirm
  const [carryJobId, setCarryJobId]   = useState("");     // selected job id for carry-over
  const [search, setSearch]           = useState("");
  const [filterStatus, setFilterStatus] = useState("All");
  const [form, setForm] = useState({ name:"", email:"", phone:"", source:"Google", status:"New", project:"", value:"", date:"", notes:"", address:"", photos:[] });
  const [dragging, setDragging] = useState(null);
  const [over, setOver]         = useState(null);

  const fileInputRef  = useRef();
  const photoLeadRef  = useRef(null);
  const [toast, setToast] = useState(null);

  const showToast = (message, actionLabel, onAction) => {
    setToast({ message, actionLabel, onAction });
    setTimeout(() => setToast(null), 6000);
  };

  const convertToEstimate = (lead) => {
    const newEst = {
      id: `EST-${String(Math.max(0, ...(estimates||[]).map(e => parseInt(e.id?.replace('EST-',''))||0)) + 1).padStart(3,"0")}`,
      customer: lead.name,
      project: lead.project || "",
      date: new Date().toISOString().slice(0,10),
      status: "Draft",
      notes: lead.notes || "",
      items: [{ desc: lead.project || "Tile Installation", laborDesc: "", qty: 1, unit: "job", price: lead.value || 0, materials: [] }],
      pricingMode: "bundled"
    };
    setEstimates(p => [...p, newEst]);
    setLeads(p => p.map(l => l.id === lead.id ? { ...l, status: "Qualified" } : l));

    // Auto-create customer profile if they don't already exist
    const alreadyCustomer = (customers||[]).some(c => c.name.toLowerCase() === lead.name.toLowerCase());
    if (!alreadyCustomer) {
      const newCustomer = {
        id: Date.now(),
        name: lead.name,
        email: lead.email || "",
        phone: lead.phone || "",
        address: lead.address || "",
        notes: `Auto-created from lead on ${new Date().toISOString().slice(0,10)}`,
        totalJobs: 0,
        totalRevenue: 0,
        since: new Date().toISOString().slice(0,7),
      };
      setCustomers(p => [...p, newCustomer]);
      if (addNotification) addNotification("lead", `👤 Customer profile created for ${lead.name}`, "customers");
    }

    if (addNotification) addNotification("estimate", `📝 Estimate ${newEst.id} created for ${lead.name} · ${lead.project}`, "estimates");
    showToast(`Estimate ${newEst.id} created · ${lead.name} added to Customers`, "View Estimates", () => { setPage("estimates"); setToast(null); });
  };

  const filtered = leads.filter(l =>
    (filterStatus === "All" || l.status === filterStatus) &&
    (l.name.toLowerCase().includes(search.toLowerCase()) || l.project.toLowerCase().includes(search.toLowerCase()))
  );

  // ── save lead (preserve existing photos if editing) ──
  const saveLead = () => {
    if (modal === "add") {
      const newLead = { ...form, id: Date.now(), value: Number(form.value), photos: form.photos || [] };
      setLeads(p => [...p, newLead]);
      if (addNotification) addNotification("lead", `📋 New lead: ${form.name} · ${form.project} · $${Number(form.value).toLocaleString()}`, "leads");

      // Auto-create customer profile for New or Qualified leads
      if (form.name && (form.status === "New" || form.status === "Qualified")) {
        const alreadyCustomer = (customers||[]).some(c => c.name.toLowerCase() === form.name.toLowerCase());
        if (!alreadyCustomer) {
          const newCustomer = {
            id: Date.now() + 1,
            name: form.name,
            email: form.email || "",
            phone: form.phone || "",
            address: form.address || "",
            notes: `Auto-created from lead on ${new Date().toISOString().slice(0,10)}`,
            totalJobs: 0,
            totalRevenue: 0,
            since: new Date().toISOString().slice(0,7),
          };
          setCustomers(p => [...p, newCustomer]);
          if (addNotification) addNotification("lead", `👤 Customer profile created for ${form.name}`, "customers");
        }
      }
    } else {
      setLeads(p => p.map(l => l.id === modal.id ? { ...form, id: l.id, value: Number(form.value), photos: form.photos || [] } : l));
      // Cascade ALL contact changes to customer record, estimates, and jobs
      const oldName = modal.name;
      const oldProject = modal.project;
      const nameChanged = form.name !== oldName;
      const projectChanged = form.project !== oldProject;
      const emailChanged = form.email !== modal.email;
      const phoneChanged = form.phone !== modal.phone;
      const addressChanged = form.address !== modal.address;
      const anyChange = nameChanged || projectChanged || emailChanged || phoneChanged || addressChanged;

      if (anyChange) {
        // Update customer record with new contact info
        const matchName = nameChanged ? oldName : form.name;
        if (setCustomers) {
          setCustomers(p => p.map(c => {
            if (c.name?.toLowerCase() !== matchName?.toLowerCase()) return c;
            const updated = { ...c };
            if (nameChanged) updated.name = form.name;
            if (emailChanged) updated.email = form.email || c.email;
            if (phoneChanged) updated.phone = form.phone || c.phone;
            if (addressChanged) updated.address = form.address || c.address;
            return updated;
          }));
          // Persist customer update to Supabase
          const custMatch = (customers||[]).find(c => c.name?.toLowerCase() === matchName?.toLowerCase());
          if (custMatch) {
            const custUpdate = {};
            if (nameChanged) custUpdate.name = form.name;
            if (emailChanged) custUpdate.email = form.email;
            if (phoneChanged) custUpdate.phone = form.phone;
            if (addressChanged) custUpdate.address = form.address;
            supabase.from('customers').update(custUpdate).eq('id', custMatch.id).then(({ error }) => {
              if (error) console.error('[Cascade] Customer update error:', error.message);
            });
          } else {
            // No customer record exists — create one
            const newCust = {
              id: Date.now() + 1,
              name: form.name,
              email: form.email || "",
              phone: form.phone || "",
              address: form.address || "",
              notes: `Auto-created from lead update on ${new Date().toISOString().slice(0,10)}`,
              totalJobs: 0, total_jobs: 0,
              totalRevenue: 0, total_revenue: 0,
              since: new Date().toISOString().slice(0,7),
            };
            setCustomers(p => [...p, newCust]);
            supabase.from('customers').upsert({ id: newCust.id, name: newCust.name, email: newCust.email, phone: newCust.phone, address: newCust.address, notes: newCust.notes, total_jobs: 0, total_revenue: 0, since: newCust.since }, { onConflict: 'id' }).then(({ error }) => {
              if (error) console.error('[Cascade] Customer create error:', error.message);
            });
            if (addNotification) addNotification("lead", `👤 Customer profile created for ${form.name}`, "customers");
          }
        }

        // Cascade name/project to estimates and jobs
        if (nameChanged) {
          setEstimates(p => p.map(e => e.customer === oldName ? { ...e, customer: form.name } : e));
          setJobs(p => p.map(j => j.customer === oldName ? { ...j, customer: form.name } : j));
        }
        if (projectChanged) {
          setEstimates(p => p.map(e => e.customer === (form.name || oldName) && e.project === oldProject ? { ...e, project: form.project } : e));
          setJobs(p => p.map(j => j.customer === (form.name || oldName) && j.project === oldProject ? { ...j, project: form.project } : j));
        }
        // Cascade address to jobs
        if (addressChanged) {
          setJobs(p => p.map(j => j.customer === (form.name || oldName) ? { ...j, address: form.address } : j));
        }

        const changes = [nameChanged && "name", emailChanged && "email", phoneChanged && "phone", addressChanged && "address", projectChanged && "project"].filter(Boolean).join(", ");
        if (addNotification) addNotification("lead", `🔄 Updated ${form.name} (${changes}) across all records`, "leads");
      }

      // Safety net: always ensure a customer record exists with current lead data
      if (setCustomers && form.name) {
        const custExists = (customers||[]).some(c => c.name?.toLowerCase() === form.name?.toLowerCase());
        if (!custExists) {
          const newCust = {
            id: Date.now() + 2,
            name: form.name,
            email: form.email || "",
            phone: form.phone || "",
            address: form.address || "",
            notes: `Auto-created from lead save on ${new Date().toISOString().slice(0,10)}`,
            totalJobs: 0, total_jobs: 0,
            totalRevenue: 0, total_revenue: 0,
            since: new Date().toISOString().slice(0,7),
          };
          setCustomers(p => [...p, newCust]);
          supabase.from('customers').upsert({ id: newCust.id, name: newCust.name, email: newCust.email, phone: newCust.phone, address: newCust.address, notes: newCust.notes, total_jobs: 0, total_revenue: 0, since: newCust.since }, { onConflict: 'id' }).then(({ error }) => {
            if (error) console.error('[Cascade] Safety customer create error:', error.message);
          });
          if (addNotification) addNotification("lead", `👤 Customer profile created for ${form.name}`, "customers");
        } else {
          // Customer exists but might have stale email/phone/address — sync current lead data
          setCustomers(p => p.map(c => {
            if (c.name?.toLowerCase() !== form.name?.toLowerCase()) return c;
            const updated = { ...c };
            if (form.email && !c.email) updated.email = form.email;
            if (form.phone && !c.phone) updated.phone = form.phone;
            if (form.address && !c.address) updated.address = form.address;
            return updated;
          }));
          const custRec = (customers||[]).find(c => c.name?.toLowerCase() === form.name?.toLowerCase());
          if (custRec && ((!custRec.email && form.email) || (!custRec.phone && form.phone) || (!custRec.address && form.address))) {
            const patch = {};
            if (!custRec.email && form.email) patch.email = form.email;
            if (!custRec.phone && form.phone) patch.phone = form.phone;
            if (!custRec.address && form.address) patch.address = form.address;
            supabase.from('customers').update(patch).eq('id', custRec.id).then(({ error }) => {
              if (error) console.error('[Cascade] Backfill customer error:', error.message);
            });
          }
        }
      }
    }
    setModal(null);
  };

  const openEdit = lead => { setForm({ ...lead, photos: lead.photos || [] }); setModal(lead); };
  const openAdd  = () => {
    setForm({ name:"", email:"", phone:"", source:"Google", status:"New", project:"", value:"", date: new Date().toISOString().slice(0,10), notes:"", address:"", photos:[] });
    setModal("add");
  };

  // ── photo upload (with compression) ──
  const handleFileChange = e => {
    const files = Array.from(e.target.files);
    if (!files.length || !photoLeadRef.current) return;
    const leadId = photoLeadRef.current;
    files.forEach(file => {
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const compressed = await compressImage(ev.target.result);
        const photo = { src: compressed, name: file.name, date: new Date().toLocaleDateString(), tag: "Client Submitted" };
        setLeads(prev => prev.map(l =>
          l.id === leadId
            ? { ...l, photos: [...(l.photos || []), photo] }
            : l
        ));
        // keep photo modal in sync
        setPhotoModal(prev => prev && prev.id === leadId
          ? { ...prev, photos: [...(prev.photos || []), photo] }
          : prev
        );
      };
      reader.readAsDataURL(file);
    });
    e.target.value = "";
  };

  const triggerUpload = leadId => { photoLeadRef.current = leadId; fileInputRef.current.click(); };

  const removeLeadPhoto = (leadId, idx) => {
    setLeads(prev => prev.map(l => l.id === leadId ? { ...l, photos: l.photos.filter((_,i) => i !== idx) } : l));
    setPhotoModal(prev => prev && prev.id === leadId ? { ...prev, photos: prev.photos.filter((_,i) => i !== idx) } : prev);
  };

  // ── carry-over photos to job ──
  const confirmCarryOver = () => {
    if (!carryJobId || !carryModal) return;
    const lead = leads.find(l => l.id === carryModal.id);
    const photosToCarry = (lead.photos || []).map(p => ({ ...p, tag: "From Lead" }));
    setJobs(prev => prev.map(j =>
      j.id === Number(carryJobId)
        ? { ...j, photos: [...(j.photos || []), ...photosToCarry] }
        : j
    ));
    setCarryModal(null);
    setCarryJobId("");
  };

  // ── kanban drag ──
  const handleDrop = stage => {
    if (dragging) setLeads(p => p.map(l => l.id === dragging.id ? { ...l, status: stage } : l));
    setDragging(null); setOver(null);
  };

  return (
    <div className="fade-in" style={{ minHeight: "calc(100vh - 120px)" }}>
      {/* Hidden file input */}
      <input ref={fileInputRef} type="file" accept="image/*" multiple style={{ display:"none" }} onChange={handleFileChange} />

      {/* ── Header ── */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:"20px", flexWrap:"wrap", gap:"12px" }}>
        <div>
          <h1 className="section-title">Lead Management</h1>
          <p className="section-sub">Track and convert your incoming leads.</p>
        </div>
        <button className="btn btn-primary" onClick={openAdd}><Icon name="plus" size={14} /> Add Lead</button>
      </div>

      {/* ── Controls ── */}
      <div style={{ display:"flex", gap:"10px", marginBottom:"20px", flexWrap:"wrap" }}>
        <div style={{ position:"relative", flex:1, minWidth:"200px" }}>
          <span style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)" }}><Icon name="search" size={14} color="var(--stone-400)" /></span>
          <input style={{ paddingLeft:"34px" }} placeholder="Search leads…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <select style={{ width:"auto" }} value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
          <option value="All">All Status</option>
          {PIPELINE_STAGES.map(s => <option key={s}>{s}</option>)}
        </select>
        <div style={{ display:"flex", background:"var(--stone-200)", borderRadius:"var(--radius)", padding:"3px", gap:"2px" }}>
          {["list","kanban"].map(v => (
            <button key={v} className="btn btn-sm" style={{ background: view===v?"var(--stone-50)":"transparent", color: view===v?"var(--stone-900)":"var(--stone-500)", boxShadow: view===v?"var(--shadow-sm)":"none", border:"none" }} onClick={() => setView(v)}>
              {v === "list" ? "List" : "Pipeline"}
            </button>
          ))}
        </div>
      </div>

      {/* ══ LIST VIEW ══ */}
      {view === "list" ? (
        <div className="card" style={{ padding:0 }}>
          <table>
            <thead>
              <tr><th>Name</th><th>Project</th><th>Source</th><th>Photos</th><th>Value</th><th>Date</th><th>Status</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={8} style={{ textAlign:"center", padding:"40px", color:"var(--stone-400)" }}>No leads found</td></tr>
              ) : filtered.map(l => {
                const photoCount = (l.photos || []).length;
                return (
                  <tr key={l.id}>
                    <td>
                      <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
                        <div className="avatar">{l.name.split(" ").map(n=>n[0]).join("")}</div>
                        <div>
                          <div style={{ display:"flex", alignItems:"center", gap:"6px" }}>
                            <span style={{ fontWeight:500 }}>{l.name}</span>
                            {l.auto_created && (
                              <span style={{ fontSize:"9px", fontWeight:700, background:"rgba(107,140,174,0.15)", color:"var(--accent-blue)", padding:"1px 6px", borderRadius:99, whiteSpace:"nowrap" }}>AUTO</span>
                            )}
                            {l.ai_classified && (
                              <span style={{ fontSize:"9px", fontWeight:700, background:"rgba(201,169,110,0.15)", color:"var(--warm-gold)", padding:"1px 6px", borderRadius:99, whiteSpace:"nowrap" }}>AI</span>
                            )}
                          </div>
                          <div className="text-muted">{l.email}</div>
                        </div>
                      </div>
                    </td>
                    <td>{l.project}</td>
                    <td><span style={{ fontSize:"12px", background:"var(--stone-100)", padding:"3px 8px", borderRadius:99, color:"var(--stone-600)" }}>{l.source}</span></td>
                    {/* Photos cell */}
                    <td>
                      <div style={{ display:"flex", alignItems:"center", gap:"6px" }}>
                        {photoCount > 0 ? (
                          <button
                            onClick={() => setPhotoModal(l)}
                            style={{ display:"flex", alignItems:"center", gap:"5px", background:"rgba(201,169,110,0.12)", border:"1.5px solid var(--warm-gold)", borderRadius:99, padding:"3px 10px", fontSize:"12px", color:"var(--warm-gold)", fontWeight:600, cursor:"pointer" }}
                          >
                            <Icon name="gallery" size={12} color="var(--warm-gold)" /> {photoCount} photo{photoCount !== 1 ? "s" : ""}
                          </button>
                        ) : (
                          <button
                            onClick={() => triggerUpload(l.id)}
                            style={{ display:"flex", alignItems:"center", gap:"5px", background:"var(--stone-100)", border:"1.5px dashed var(--stone-300)", borderRadius:99, padding:"3px 10px", fontSize:"12px", color:"var(--stone-400)", cursor:"pointer" }}
                          >
                            <Icon name="upload" size={11} /> Add
                          </button>
                        )}
                      </div>
                    </td>
                    <td style={{ fontWeight:600 }}>${Number(l.value).toLocaleString()}</td>
                    <td className="text-muted">{l.date}</td>
                    <td><span className={`badge badge-${l.status.toLowerCase()}`}>{l.status}</span></td>
                    <td>
                      <div style={{ display:"flex", gap:"4px", flexWrap:"wrap" }}>
                        <button className="btn-icon" title="Upload Photos" onClick={() => triggerUpload(l.id)}><Icon name="upload" size={14} color="var(--accent-blue)" /></button>
                        {photoCount > 0 && <button className="btn-icon" title="View Photos" onClick={() => setPhotoModal(l)}><Icon name="gallery" size={14} color="var(--accent-amber)" /></button>}
                        <button className="btn-icon" title="Edit" onClick={() => openEdit(l)}><Icon name="edit" size={14} /></button>
                        <button className="btn-icon" title="Delete" onClick={() => requestDelete("leads", l)}><Icon name="trash" size={14} color="var(--accent-red)" /></button>
                        <button title="Create Estimate" onClick={() => convertToEstimate(l)} style={{ background:"var(--accent-green)", color:"white", border:"none", borderRadius:"var(--radius)", padding:"4px 8px", fontSize:"11px", cursor:"pointer", fontWeight:600, whiteSpace:"nowrap" }}>→ Estimate</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

      ) : (
        /* ══ KANBAN VIEW ══ */
        <div style={{ display:"flex", gap:"14px", overflowX:"auto", paddingBottom:"12px" }}>
          {PIPELINE_STAGES.map(stage => {
            const stageleads = leads.filter(l => l.status === stage);
            return (
              <div key={stage} className="kanban-col" style={{ flexShrink:0 }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"10px" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
                    <div style={{ width:10, height:10, borderRadius:"50%", background:STAGE_COLORS[stage] }} />
                    <span style={{ fontWeight:600, fontSize:"13px" }}>{stage}</span>
                  </div>
                  <span style={{ fontSize:"11px", background:"var(--stone-200)", padding:"2px 8px", borderRadius:99 }}>{stageleads.length}</span>
                </div>
                <div
                  className={`kanban-drop-zone${over === stage ? " over" : ""}`}
                  onDragOver={e => { e.preventDefault(); setOver(stage); }}
                  onDragLeave={() => setOver(null)}
                  onDrop={() => handleDrop(stage)}
                >
                  {stageleads.map(l => {
                    const photoCount = (l.photos || []).length;
                    return (
                      <div
                        key={l.id}
                        className={`kanban-card${dragging?.id === l.id ? " dragging" : ""}`}
                        draggable onDragStart={() => setDragging(l)}
                        style={{ marginBottom:"8px" }}
                      >
                        <div style={{ display:"flex", alignItems:"center", gap:"5px", marginBottom:"3px" }}>
                          <span style={{ fontWeight:600, fontSize:"13px" }}>{l.name}</span>
                          {l.auto_created && <span style={{ fontSize:"8px", fontWeight:700, background:"rgba(107,140,174,0.15)", color:"var(--accent-blue)", padding:"1px 5px", borderRadius:99 }}>AUTO</span>}
                          {l.ai_classified && <span style={{ fontSize:"8px", fontWeight:700, background:"rgba(201,169,110,0.15)", color:"var(--warm-gold)", padding:"1px 5px", borderRadius:99 }}>AI</span>}
                        </div>
                        <div className="text-muted" style={{ fontSize:"12px", marginBottom:"6px" }}>{l.project}</div>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"8px" }}>
                          <span style={{ fontWeight:600, fontSize:"13px", color:"var(--warm-gold)" }}>${Number(l.value).toLocaleString()}</span>
                          <span style={{ fontSize:"11px", color:"var(--stone-400)" }}>{l.source}</span>
                        </div>
                        {/* Photo thumbnails on kanban card */}
                        {photoCount > 0 && (
                          <div style={{ display:"flex", gap:"4px", marginBottom:"8px", flexWrap:"wrap" }}>
                            {(l.photos || []).slice(0,3).map((p,i) => (
                              <div key={i} style={{ width:40, height:40, borderRadius:5, overflow:"hidden", border:"1.5px solid var(--stone-200)", flexShrink:0 }}>
                                <img src={p.src} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"cover" }} />
                              </div>
                            ))}
                            {photoCount > 3 && <div style={{ width:40, height:40, borderRadius:5, background:"var(--stone-200)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"11px", color:"var(--stone-500)", fontWeight:600 }}>+{photoCount-3}</div>}
                          </div>
                        )}
                        <div style={{ display:"flex", gap:"4px" }}>
                          <button className="btn btn-ghost btn-sm" style={{ fontSize:"11px", padding:"4px 8px" }} onClick={() => openEdit(l)}><Icon name="edit" size={11} /> Edit</button>
                          <button className="btn btn-ghost btn-sm" style={{ fontSize:"11px", padding:"4px 8px" }} onClick={() => triggerUpload(l.id)}><Icon name="upload" size={11} /> Photo</button>
                          {photoCount > 0 && <button className="btn btn-ghost btn-sm" style={{ fontSize:"11px", padding:"4px 8px", color:"var(--warm-gold)" }} onClick={() => setPhotoModal(l)}><Icon name="gallery" size={11} /> {photoCount}</button>}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ══ ADD / EDIT LEAD MODAL ══ */}
      {modal && (
        <Modal title={modal === "add" ? "Add New Lead" : "Edit Lead"} onClose={() => setModal(null)}>
          <div className="form-grid">
            {[["name","Full Name"],["email","Email"],["phone","Phone"],["address","Address"]].map(([k,lbl]) => (
              <div className="form-group" key={k}><label>{lbl}</label><input value={form[k]} onChange={e => setForm(p => ({...p,[k]:e.target.value}))} /></div>
            ))}
            <div className="form-group"><label>Project Type</label><input value={form.project} onChange={e => setForm(p => ({...p,project:e.target.value}))} /></div>
            <div className="form-group"><label>Estimated Value</label><input type="number" value={form.value} onChange={e => setForm(p => ({...p,value:e.target.value}))} /></div>
            <div className="form-group">
              <label>Lead Source</label>
              <select value={form.source} onChange={e => setForm(p => ({...p,source:e.target.value}))}>
                {["Google","Referral","Facebook","Yelp","Instagram","Other"].map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Status</label>
              <select value={form.status} onChange={e => setForm(p => ({...p,status:e.target.value}))}>
                {PIPELINE_STAGES.map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Date</label><input type="date" value={form.date} onChange={e => setForm(p => ({...p,date:e.target.value}))} /></div>
            <div className="form-group form-full"><label>Notes</label><textarea rows={3} value={form.notes} onChange={e => setForm(p => ({...p,notes:e.target.value}))} /></div>
          </div>
          <div style={{ display:"flex", justifyContent:"flex-end", gap:"8px", marginTop:"4px" }}>
            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancel</button>
            <button className="btn btn-primary" onClick={saveLead}><Icon name="check" size={14} /> Save Lead</button>
          </div>
        </Modal>
      )}

      {/* ══ LEAD PHOTO MODAL ══ */}
      {photoModal && (
        <Modal title={`📷 ${photoModal.name} — Client Space Photos`} onClose={() => setPhotoModal(null)}>
          {/* Context bar */}
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"14px", padding:"10px 14px", background:"var(--stone-100)", borderRadius:"var(--radius)", border:"1px solid var(--stone-200)" }}>
            <div style={{ fontSize:"13px", color:"var(--stone-600)" }}>
              <span style={{ fontWeight:600 }}>{photoModal.project}</span>
              <span style={{ color:"var(--stone-400)", margin:"0 8px" }}>·</span>
              <span>{(photoModal.photos || []).length} photo{(photoModal.photos || []).length !== 1 ? "s" : ""} uploaded</span>
            </div>
            <div style={{ display:"flex", gap:"8px" }}>
              <button className="btn btn-primary btn-sm" onClick={() => triggerUpload(photoModal.id)}>
                <Icon name="upload" size={13} /> Upload Photos
              </button>
              {jobs && jobs.length > 0 && (photoModal.photos || []).length > 0 && (
                <button
                  className="btn btn-sm"
                  style={{ background:"var(--accent-green)", color:"white", border:"none" }}
                  onClick={() => { setCarryModal(photoModal); setPhotoModal(null); }}
                >
                  <Icon name="jobs" size={13} /> Send to Job
                </button>
              )}
            </div>
          </div>

          {(photoModal.photos || []).length === 0 ? (
            <div className="empty-state" style={{ padding:"40px 0" }}>
              <div style={{ fontSize:44, marginBottom:10 }}>🏠</div>
              <div style={{ fontSize:"14px", color:"var(--stone-400)", marginBottom:6 }}>No client photos yet.</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)" }}>Ask the client to send photos of their space, then upload them here for quoting reference.</div>
              <button className="btn btn-primary" style={{ marginTop:16 }} onClick={() => triggerUpload(photoModal.id)}><Icon name="upload" size={13} /> Upload First Photo</button>
            </div>
          ) : (
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(130px,1fr))", gap:"10px" }}>
              {(photoModal.photos || []).map((p,i) => (
                <div key={i} style={{ position:"relative", borderRadius:10, overflow:"hidden", border:"2px solid var(--stone-200)", background:"var(--stone-200)", aspectRatio:"1" }}>
                  <img src={p.src} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"cover", cursor:"pointer" }} onClick={() => setLightbox({ src:p.src, name:p.name, date:p.date })} />
                  {/* Tag ribbon */}
                  <div style={{ position:"absolute", top:6, left:0, background:"var(--stone-800)", color:"var(--sand-300)", fontSize:"9px", fontWeight:700, padding:"2px 8px", letterSpacing:"0.05em", textTransform:"uppercase", borderRadius:"0 4px 4px 0" }}>
                    {p.tag || "Client Submitted"}
                  </div>
                  {/* Caption bar */}
                  <div style={{ position:"absolute", bottom:0, left:0, right:0, background:"rgba(26,23,20,0.6)", color:"white", fontSize:"10px", padding:"4px 7px", display:"flex", justifyContent:"space-between" }}>
                    <span style={{ overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:"76%" }}>{p.name}</span>
                    <span style={{ flexShrink:0 }}>{p.date}</span>
                  </div>
                  {/* Delete button */}
                  <button onClick={() => removeLeadPhoto(photoModal.id, i)} style={{ position:"absolute", top:4, right:4, background:"rgba(192,97,74,0.85)", border:"none", borderRadius:"50%", width:20, height:20, display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer" }}>
                    <Icon name="x" size={10} color="white" />
                  </button>
                </div>
              ))}
              {/* Upload tile */}
              <div onClick={() => triggerUpload(photoModal.id)}
                style={{ aspectRatio:"1", borderRadius:10, border:"2px dashed var(--stone-300)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", cursor:"pointer", color:"var(--stone-400)", gap:"6px", fontSize:"12px", transition:"all 0.2s" }}
                onMouseEnter={e => { e.currentTarget.style.borderColor="var(--warm-gold)"; e.currentTarget.style.color="var(--warm-gold)"; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor="var(--stone-300)"; e.currentTarget.style.color="var(--stone-400)"; }}
              >
                <Icon name="upload" size={22} /><span>Add More</span>
              </div>
            </div>
          )}
          <div style={{ display:"flex", justifyContent:"flex-end", marginTop:"16px" }}>
            <button className="btn btn-secondary" onClick={() => setPhotoModal(null)}>Close</button>
          </div>
        </Modal>
      )}

      {/* ══ CARRY-OVER TO JOB MODAL ══ */}
      {carryModal && (
        <Modal title="Send Photos to Job" onClose={() => { setCarryModal(null); setCarryJobId(""); }}>
          {/* Preview strip */}
          <div style={{ marginBottom:"18px" }}>
            <div style={{ fontSize:"13px", color:"var(--stone-600)", marginBottom:"10px" }}>
              These <strong>{(carryModal.photos || []).length} client photo{(carryModal.photos || []).length !== 1 ? "s" : ""}</strong> from <strong>{carryModal.name}</strong> will be copied into the selected job's progress photo gallery, tagged as <em>"From Lead"</em> so your crew knows these are the starting-point reference images.
            </div>
            <div style={{ display:"flex", gap:"8px", flexWrap:"wrap", marginBottom:"4px" }}>
              {(carryModal.photos || []).slice(0,5).map((p,i) => (
                <div key={i} style={{ width:58, height:58, borderRadius:8, overflow:"hidden", border:"2px solid var(--stone-200)", flexShrink:0 }}>
                  <img src={p.src} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"cover" }} />
                </div>
              ))}
              {(carryModal.photos || []).length > 5 && (
                <div style={{ width:58, height:58, borderRadius:8, background:"var(--stone-200)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"12px", fontWeight:600, color:"var(--stone-500)" }}>+{(carryModal.photos||[]).length-5}</div>
              )}
            </div>
          </div>

          {/* Job selector */}
          <div className="form-group" style={{ marginBottom:"20px" }}>
            <label>Select Destination Job</label>
            <select value={carryJobId} onChange={e => setCarryJobId(e.target.value)}>
              <option value="">— Choose a job —</option>
              {(jobs || []).map(j => (
                <option key={j.id} value={j.id}>
                  {j.project} · {j.customer} · {j.status}
                </option>
              ))}
            </select>
          </div>

          {/* Warning if job already has photos */}
          {carryJobId && (() => {
            const job = (jobs || []).find(j => j.id === Number(carryJobId));
            const existing = (job?.photos || []).length;
            return existing > 0 ? (
              <div style={{ fontSize:"12px", color:"var(--accent-amber)", background:"rgba(196,149,74,0.1)", border:"1px solid rgba(196,149,74,0.3)", borderRadius:6, padding:"8px 12px", marginBottom:"16px", display:"flex", gap:"8px", alignItems:"flex-start" }}>
                <Icon name="warning" size={14} color="var(--accent-amber)" />
                <span>This job already has <strong>{existing} photo{existing !== 1 ? "s" : ""}</strong>. The lead photos will be added alongside them, not replace them.</span>
              </div>
            ) : null;
          })()}

          <div style={{ display:"flex", justifyContent:"flex-end", gap:"8px" }}>
            <button className="btn btn-secondary" onClick={() => { setCarryModal(null); setCarryJobId(""); }}>Cancel</button>
            <button className="btn btn-primary" disabled={!carryJobId} style={{ opacity: carryJobId ? 1 : 0.5 }} onClick={confirmCarryOver}>
              <Icon name="check" size={14} /> Copy Photos to Job
            </button>
          </div>
        </Modal>
      )}

      {/* ══ LIGHTBOX ══ */}
      {lightbox && (
        <div className="modal-overlay" onClick={() => setLightbox(null)} style={{ zIndex:2000 }}>
          <div style={{ background:"var(--stone-950)", borderRadius:16, overflow:"hidden", maxWidth:"80vw", maxHeight:"85vh", display:"flex", flexDirection:"column", boxShadow:"0 20px 60px rgba(0,0,0,0.6)" }} onClick={e => e.stopPropagation()}>
            <img src={lightbox.src} alt={lightbox.name} style={{ maxWidth:"80vw", maxHeight:"75vh", objectFit:"contain", display:"block" }} />
            <div style={{ padding:"12px 18px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div>
                <div style={{ color:"var(--stone-200)", fontSize:"13px", fontWeight:500 }}>{lightbox.name}</div>
                <div style={{ color:"var(--stone-500)", fontSize:"11px" }}>{lightbox.date}</div>
              </div>
              <button className="btn btn-ghost btn-sm" style={{ color:"var(--stone-400)" }} onClick={() => setLightbox(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
      {toast && <PipelineToast message={toast.message} actionLabel={toast.actionLabel} onAction={toast.onAction} onClose={() => setToast(null)} />}
    </div>
  );
};

// ── CUSTOMERS ─────────────────────────────────────────────────────────────────
const Customers = ({ customers, setCustomers, requestDelete }) => {
  const [modal, setModal] = useState(null);
  const [search, setSearch] = useState("");
  const [form, setForm] = useState({ name:"", email:"", phone:"", address:"", notes:"", cc_email:"" });

  const filtered = customers.filter(c =>
    c.name.toLowerCase().includes(search.toLowerCase()) ||
    c.email.toLowerCase().includes(search.toLowerCase())
  );

  const save = () => {
    if (modal === "add") setCustomers(p => [...p, { ...form, id: Date.now(), totalJobs: 0, totalRevenue: 0, since: new Date().toISOString().slice(0,7) }]);
    else setCustomers(p => p.map(c => c.id === modal.id ? { ...c, ...form } : c));
    setModal(null);
  };

  return (
    <div className="fade-in" style={{ minHeight: "calc(100vh - 120px)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "20px", flexWrap: "wrap", gap: "12px" }}>
        <div>
          <h1 className="section-title">Customer Database</h1>
          <p className="section-sub">Manage your client relationships.</p>
        </div>
        <button className="btn btn-primary" onClick={() => { setForm({ name:"",email:"",phone:"",address:"",notes:"",cc_email:"" }); setModal("add"); }}><Icon name="plus" size={14} /> Add Customer</button>
      </div>
      <div style={{ marginBottom: "16px" }}>
        <div style={{ position: "relative", maxWidth: "340px" }}>
          <input style={{ paddingLeft: "34px" }} placeholder="Search customers…" value={search} onChange={e => setSearch(e.target.value)} />
          <span style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)" }}><Icon name="search" size={14} color="var(--stone-400)" /></span>
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px,1fr))", gap: "16px" }}>
        {filtered.map(c => (
          <div className="card" key={c.id}>
            <div style={{ display: "flex", gap: "14px", alignItems: "flex-start" }}>
              <div className="avatar" style={{ width: 46, height: 46, fontSize: 16 }}>{c.name.split(" ").map(n=>n[0]).join("")}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: "15px" }}>{c.name}</div>
                <div className="text-muted" style={{ fontSize: "12px" }}>{c.email}</div>
                {c.cc_email && <div className="text-muted" style={{ fontSize: "11px", color: "var(--warm-gold)" }}>CC: {c.cc_email}</div>}
                <div className="text-muted" style={{ fontSize: "12px" }}>{c.phone}</div>
              </div>
              <div style={{ display: "flex", gap: "4px" }}>
                <button className="btn-icon" onClick={() => { setForm({ name: c.name, email: c.email, phone: c.phone, address: c.address, notes: c.notes || "", cc_email: c.cc_email || "" }); setModal(c); }}><Icon name="edit" size={14} /></button>
                <button className="btn-icon" onClick={() => requestDelete("customers", c)}><Icon name="trash" size={14} color="var(--accent-red)" /></button>
              </div>
            </div>
            <hr className="divider" />
            <div style={{ display: "flex", gap: "12px", fontSize: "12px" }}>
              <div style={{ flex: 1 }}>
                <div style={{ color: "var(--stone-500)", marginBottom: "2px" }}>Total Jobs</div>
                <div style={{ fontWeight: 600 }}>{c.totalJobs}</div>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ color: "var(--stone-500)", marginBottom: "2px" }}>Revenue</div>
                <div style={{ fontWeight: 600, color: "var(--accent-green)" }}>${c.totalRevenue.toLocaleString()}</div>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ color: "var(--stone-500)", marginBottom: "2px" }}>Client Since</div>
                <div style={{ fontWeight: 600 }}>{c.since}</div>
              </div>
            </div>
            {c.address && <div style={{ fontSize: "12px", color: "var(--stone-500)", marginTop: "8px", display: "flex", gap: "4px", alignItems: "flex-start" }}><Icon name="location" size={12} /> {c.address}</div>}
            {c.notes && <div style={{ fontSize: "12px", color: "var(--stone-600)", marginTop: "6px", background: "var(--stone-100)", padding: "8px", borderRadius: "6px" }}>{c.notes}</div>}
          </div>
        ))}
      </div>
      {modal && (
        <Modal title={modal === "add" ? "Add Customer" : "Edit Customer"} onClose={() => setModal(null)}>
          <div className="form-grid">
            {[["name","Full Name"],["email","Email"],["phone","Phone"],["address","Address"],["cc_email","CC / Spouse Email"]].map(([k,l]) => (
              <div className="form-group" key={k}><label>{l}</label><input value={form[k]} onChange={e => setForm(p => ({...p,[k]:e.target.value}))} placeholder={k === "cc_email" ? "Optional — receives copy of all emails" : ""} /></div>
            ))}
            <div className="form-group form-full"><label>Notes</label><textarea rows={3} value={form.notes} onChange={e => setForm(p => ({...p,notes:e.target.value}))} /></div>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancel</button>
            <button className="btn btn-primary" onClick={save}><Icon name="check" size={14} /> Save</button>
          </div>
        </Modal>
      )}
    </div>
  );
};

// ── JOB TRACKING ──────────────────────────────────────────────────────────────
const Jobs = ({ loadJobPhotos, loadAllJobPhotos, photoLoading, jobs, setJobs, customers, estimates, setEstimates, invoices, setInvoices, events, setEvents, users, setPage, addNotification, requestDelete, estimateViews, setEstimateViews, currentUser, reviews, setReviews }) => {
  const isOwner = currentUser?.role === "owner";
  // Job Tracking shows thumbnails and photo counts, so it needs the photos the
  // login deliberately skipped. Desktop-only screen, so the weight is acceptable
  // here — the lean login is what protects installers in the field.
  useEffect(() => { loadAllJobPhotos && loadAllJobPhotos(); }, []); // eslint-disable-line
  const [modal, setModal] = useState(null);
  const [photoModal, setPhotoModal] = useState(null);
  const [estimateModal, setEstimateModal] = useState(null);
  const [lightbox, setLightbox] = useState(null);
  const [filter, setFilter] = useState("All");
  const [expandedJob, setExpandedJob] = useState(null);
  const [toast, setToast] = useState(null);
  const [crewView, setCrewView] = useState(false);
  const [crewSent, setCrewSent] = useState(false);
  const [changeOrder, setChangeOrder] = useState(false);
  const [changeItems, setChangeItems] = useState([]);
  const [changeNotes, setChangeNotes] = useState("");
  const [changeMode, setChangeMode] = useState("edit");
  const [priorDeposits, setPriorDeposits] = useState([]);
  const [changeOverridePrice, setChangeOverridePrice] = useState("");
  const [changeReceipts, setChangeReceipts] = useState([]);
  const [receiptUploading, setReceiptUploading] = useState(false);
  const receiptFileRef = useRef(null);
  const [clientSent, setClientSent] = useState(false);
  const [form, setForm] = useState({ customer:"", project:"", status:"Scheduled", startDate:"", startTime:"8:00 AM", endDate:"", value:"", cost:"", address:"", crewName:"", crewPay:[], crewNotes:[], notes:"", estimateId:"", estimatedDays:1 });
  const fileInputRef = useRef();
  const photoJobRef = useRef(null);
  const [pendingPhotos, setPendingPhotos] = useState([]);
  const [photoTagModal, setPhotoTagModal] = useState(false);

  const PHOTO_TAGS = [
    { id: 'Before', label: 'Before', color: '#3b5bdb', desc: 'Existing conditions' },
    { id: 'During', label: 'During', color: '#946c00', desc: 'Work in progress' },
    { id: 'After', label: 'After', color: '#1a6b2a', desc: 'Final result — posted to Google' },
    { id: 'Substrate', label: 'Substrate', color: '#5a5248', desc: 'Prep before tile' },
    { id: 'Other', label: 'Other', color: '#8c7b6e', desc: 'Reference photos' },
  ];

  const showToast = (message, actionLabel, onAction) => {
    setToast({ message, actionLabel, onAction });
    setTimeout(() => setToast(null), 6000);
  };

  // ── Change Order Receipt Handlers ──
  const handleReceiptUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const MAX_FILES = 5;
    const MAX_SIZE = 10 * 1024 * 1024; // 10 MB
    const available = MAX_FILES - changeReceipts.length;
    if (available <= 0) {
      showToast(`Maximum ${MAX_FILES} receipts per change order`);
      if (receiptFileRef.current) receiptFileRef.current.value = '';
      return;
    }
    const toUpload = files.slice(0, available);
    if (files.length > available) showToast(`Only ${available} more receipt${available===1?'':'s'} allowed — uploaded first ${available}`);

    setReceiptUploading(true);
    try {
      const coNum = (estimateModal?.change_orders || []).length + 1;
      const coId = `CO-${String(coNum).padStart(3,'0')}`;
      for (const file of toUpload) {
        if (file.size > MAX_SIZE) { showToast(`"${file.name}" is too large (max 10MB)`); continue; }
        const isImage = file.type.startsWith('image/');
        const isPdf = file.type === 'application/pdf';
        if (!isImage && !isPdf) { showToast(`"${file.name}" — only images and PDFs supported`); continue; }

        try {
          let blob, mimeType, ext;
          if (isImage) {
            const dataUrl = await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = (ev) => resolve(ev.target.result);
              reader.onerror = reject;
              reader.readAsDataURL(file);
            });
            const compressed = await compressImage(dataUrl, 1200, 0.75);
            const base64 = compressed.split(',')[1];
            const byteArr = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
            blob = new Blob([byteArr], { type: 'image/jpeg' });
            mimeType = 'image/jpeg';
            ext = 'jpg';
          } else {
            blob = file;
            mimeType = 'application/pdf';
            ext = 'pdf';
          }
          const slug = (file.name || 'receipt').replace(/\.[^.]+$/, '').replace(/[^a-zA-Z0-9-]/g, '_').slice(0, 40) || 'receipt';
          const path = `${estimateModal?.id || 'unknown'}/${coId}/${Date.now()}-${slug}.${ext}`;
          const { error: upErr } = await supabase.storage.from('receipts').upload(path, blob, { contentType: mimeType, upsert: false });
          if (upErr) { console.error('[CO Receipt] Upload error:', upErr.message); showToast(`Failed: ${file.name}`); continue; }
          const { data: urlData } = supabase.storage.from('receipts').getPublicUrl(path);
          if (urlData?.publicUrl) {
            setChangeReceipts(p => [...p, {
              url: urlData.publicUrl,
              path,
              fileName: file.name,
              fileSize: blob.size,
              mimeType,
              uploadedAt: new Date().toISOString(),
            }]);
          }
        } catch (ue) {
          console.error('[CO Receipt] Upload failed:', ue);
          showToast(`Failed to upload ${file.name}`);
        }
      }
    } finally {
      setReceiptUploading(false);
      if (receiptFileRef.current) receiptFileRef.current.value = '';
    }
  };

  const deleteReceipt = async (idx) => {
    const receipt = changeReceipts[idx];
    if (!receipt) return;
    try { await supabase.storage.from('receipts').remove([receipt.path]); }
    catch (e) { console.warn('[CO Receipt] Storage delete failed (keeping local removal):', e); }
    setChangeReceipts(p => p.filter((_, i) => i !== idx));
  };

  const fmtFileSize = (bytes) => {
    if (!bytes) return '';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024*1024) return `${(bytes/1024).toFixed(0)} KB`;
    return `${(bytes/1024/1024).toFixed(1)} MB`;
  };

  const convertToInvoice = async (job) => {
    // Guard: don't create duplicate invoice for the same job (local check)
    const existing = invoices.find(inv => inv.jobId === job.id || (job.estimateId && inv.estimate_id === job.estimateId));
    if (existing) {
      showToast(`Invoice ${existing.display_id || existing.id} already exists for this job`, "View Invoices", () => { setPage("invoicing"); setToast(null); });
      return;
    }
    // Guard: check Supabase for auto-created invoices (from client Stripe payments before CRM invoice existed)
    try {
      const estId = job.estimateId || job.estimate_id;
      if (estId) {
        const { data: dbInvoices } = await supabase.from('invoices').select('*').eq('estimate_id', estId).limit(5);
        if (dbInvoices?.length) {
          // Found auto-created invoice in Supabase — adopt it into local state instead of creating a duplicate
          const autoInv = dbInvoices[0];
          const invNum = `INV-${String((invoices||[]).length + 1).padStart(3,"0")}`;
          const adoptedInv = {
            id: autoInv.id,
            display_id: invNum,
            jobId: job.id,
            estimate_id: estId,
            customer: autoInv.customer || job.customer,
            project: autoInv.project || job.project,
            contractTotal: autoInv.contract_total || job.value || 0,
            issued: autoInv.issued || new Date().toISOString().slice(0,10),
            status: autoInv.status || "Invoiced",
            payments: autoInv.payments || [],
          };
          // Update Supabase with the proper display_id and job_id
          await supabase.from('invoices').update({ display_id: invNum, job_id: job.id }).eq('id', autoInv.id);
          setInvoices(p => [...p, adoptedInv]);
          const paidAmt = (adoptedInv.payments || []).filter(p => p.status === 'Paid').reduce((s, p) => s + (Number(p.amount) || 0), 0);
          if (paidAmt > 0) {
            showToast(`Invoice ${invNum} adopted from existing record · $${paidAmt.toLocaleString()} already paid via Stripe`, "View Invoices", () => { setPage("invoicing"); setToast(null); });
            if (addNotification) addNotification("invoice", `💰 Invoice ${invNum} adopted · ${job.customer} · $${paidAmt.toLocaleString()} already paid`, "invoicing");
          } else {
            showToast(`Invoice ${invNum} adopted from existing record for ${job.customer}`, "View Invoices", () => { setPage("invoicing"); setToast(null); });
            if (addNotification) addNotification("invoice", `💰 Invoice ${invNum} created for ${job.customer} · $${(adoptedInv.contractTotal||0).toLocaleString()}`, "invoicing");
          }
          return;
        }
      }
    } catch (e) { console.warn('[convertToInvoice] Supabase check failed:', e.message); }

    const total = job.value || 0;
    const half = Math.round(total / 2);
    const today = new Date().toISOString().slice(0,10);
    const depositDue = new Date(Date.now() + 7*24*60*60*1000).toISOString().slice(0,10);
    const balanceDue = new Date(Date.now() + 30*24*60*60*1000).toISOString().slice(0,10);
    const invId = `INV-${String((invoices||[]).length + 1).padStart(3,"0")}`;
    const newInv = {
      id: invId,
      display_id: invId,
      jobId: job.id,
      estimate_id: job.estimateId || job.estimate_id || null,
      customer: job.customer,
      project: job.project,
      contractTotal: total,
      issued: today,
      status: "Invoiced",
      payments: [
        { id: "pmt-1", label: "Deposit (50%)", amount: half, due: depositDue, status: "Pending", paidDate: null, method: "", note: "" },
        { id: "pmt-2", label: "Balance (50%)", amount: total - half, due: balanceDue, status: "Pending", paidDate: null, method: "", note: "" },
      ]
    };
    setInvoices(p => [...p, newInv]);
    if (addNotification) addNotification("invoice", `💰 Invoice ${invId} created for ${job.customer} · $${total.toLocaleString()}`, "invoicing");
    showToast(`Invoice ${invId} created for ${job.customer} · Deposit $${half.toLocaleString()} due ${depositDue}`, "View Invoices", () => { setPage("invoicing"); setToast(null); });
  };

  const filtered = jobs.filter(j => filter === "All" || j.status === filter);
  const statColors = { "Scheduled": "var(--accent-blue)", "In Progress": "var(--accent-amber)", "Completed": "var(--accent-green)" };

  const getEstimate = (estimateId) => estimates.find(e => e.id === estimateId) || null;
  const getTotal = (items) => items.reduce((s, i) => s + (Number(i.qty) * Number(i.price)) + (i.materials||[]).reduce((ms,m) => ms + (Number(m.qty)*Number(m.price)), 0), 0);

  // ── Auto-create calendar events for assigned jobs ──
  const syncJobToCalendar = (job) => {
    if (!setEvents || !job.crewName || !job.startDate) return;
    const jobTag = `job-${job.id}`;
    const days = job.estimatedDays || 1;
    const crewMembers = (job.crewName || "").split(",").map(s => s.trim()).filter(Boolean);

    setEvents(prev => {
      // Remove any existing events for this job
      const filtered = prev.filter(e => e.jobTag !== jobTag);

      // Don't create events for completed/cancelled jobs
      if (job.status === "Completed" || job.status === "Cancelled") return filtered;
      if (crewMembers.length === 0) return filtered;

      // Create events for each day × each crew member
      const startDate = new Date(job.startDate + "T00:00:00");
      const newEvents = [];
      for (let d = 0; d < days; d++) {
        const eventDate = new Date(startDate);
        eventDate.setDate(eventDate.getDate() + d);
        const dateStr = eventDate.toISOString().slice(0, 10);
        const dayLabel = days > 1 ? `(Day ${d + 1}/${days})` : '';
        crewMembers.forEach((member, mi) => {
          newEvents.push({
            id: Math.floor(Date.now() + d * 1000 + mi * 100 + Math.random() * 99),
            jobTag: jobTag,
            title: `${job.project} ${dayLabel}`.trim(),
            date: dateStr,
            time: job.startTime || "8:00 AM",
            type: "job",
            crew: member,
            address: job.address || "",
            customer: job.customer,
            brief: job.notes || "",
            jobId: job.id,
            multiDay: days > 1,
            dayNum: d + 1,
            totalDays: days,
          });
        });
      }
      return [...filtered, ...newEvents];
    });
  };

  const save = () => {
    if (modal === "add") {
      const newJob = { ...form, id: Date.now(), value: Number(form.value), cost: Number(form.cost)||0, customerId: null, photos: [], estimateId: form.estimateId || null, estimatedDays: Number(form.estimatedDays)||1, startTime: form.startTime || "8:00 AM" };
      setJobs(p => [...p, newJob]);
      if (addNotification) addNotification("job", `New job created: ${form.project} for ${form.customer}`, "jobs");
      // Auto-create calendar events
      syncJobToCalendar(newJob);
    } else {
      const prevStatus = modal.status;
      const prevCrew = modal.crewName || modal.crew || "";
      const updatedJob = { ...modal, ...form, value: Number(form.value), cost: Number(form.cost)||0, estimateId: form.estimateId || null, estimatedDays: Number(form.estimatedDays)||1, startTime: form.startTime || "8:00 AM" };
      setJobs(p => p.map(j => j.id === modal.id ? updatedJob : j));
      if (addNotification && form.status !== prevStatus) {
        const statusEmoji = form.status === "In Progress" ? "🔨" : form.status === "Completed" ? "✅" : "📅";
        addNotification("job", `${statusEmoji} ${form.project} (${form.customer}) → ${form.status}`, "jobs");
      }
      // Re-sync calendar events if crew or dates changed
      syncJobToCalendar(updatedJob);
    }
    setModal(null);
  };

  const openEdit = (j) => {
    setForm({ customer: j.customer, project: j.project, status: j.status, startDate: j.startDate, startTime: j.startTime || "8:00 AM", endDate: j.endDate, value: j.value, cost: j.cost||"", address: j.address, crewName: j.crewName || j.crew || "", crewPay: j.crewPay || j.crew_pay || [], crewNotes: j.crewNotes || j.crew_notes || [], notes: j.notes, estimateId: j.estimateId || "", estimatedDays: j.estimatedDays || 1 });
    setModal(j);
  };

  // Handle real file uploads — compress then store as base64 data URLs
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length || !photoJobRef.current) return;
    const pending = [];
    let loaded = 0;
    files.forEach(file => {
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const compressed = await compressImage(ev.target.result);
        pending.push({ src: compressed, name: file.name, date: new Date().toLocaleDateString() });
        loaded++;
        if (loaded === files.length) {
          setPendingPhotos(pending);
          setPhotoTagModal(true);
        }
      };
      reader.readAsDataURL(file);
    });
    e.target.value = "";
  };

  const confirmPhotoTag = (tag) => {
    const jobId = photoJobRef.current;
    if (!jobId || !pendingPhotos.length) return;
    const tagged = pendingPhotos.map(p => ({ ...p, tag }));
    setJobs(prev => prev.map(j =>
      j.id === jobId ? { ...j, photos: [...j.photos, ...tagged] } : j
    ));
    if (photoModal) {
      setPhotoModal(prev => prev && prev.id === jobId ? { ...prev, photos: [...prev.photos, ...tagged] } : prev);
    }
    setPendingPhotos([]);
    setPhotoTagModal(false);
    showToast(`${tagged.length} photo${tagged.length !== 1 ? 's' : ''} added as "${tag}"`);
  };

  const triggerUpload = (jobId) => {
    photoJobRef.current = jobId;
    fileInputRef.current.click();
  };

  const removePhoto = (jobId, idx) => {
    setJobs(prev => prev.map(j => j.id === jobId ? { ...j, photos: j.photos.filter((_,i) => i !== idx) } : j));
    setPhotoModal(prev => prev && prev.id === jobId ? { ...prev, photos: prev.photos.filter((_,i) => i !== idx) } : prev);
  };

  return (
    <div className="fade-in" style={{ minHeight: "calc(100vh - 120px)" }}>
      {/* Hidden file input */}
      <input ref={fileInputRef} type="file" accept="image/*" multiple style={{ display:"none" }} onChange={handleFileChange} />

      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:"20px", flexWrap:"wrap", gap:"12px" }}>
        <div><h1 className="section-title">Job Tracking</h1><p className="section-sub">Monitor all active and completed jobs.</p></div>
        <button className="btn btn-primary" onClick={() => { setForm({ customer:"", project:"", status:"Scheduled", startDate:"", startTime:"8:00 AM", endDate:"", value:"", cost:"", address:"", crewName:"", crewPay:[], crewNotes:[], notes:"", estimateId:"", estimatedDays:1 }); setModal("add"); }}><Icon name="plus" size={14} /> New Job</button>
      </div>

      <div style={{ display:"flex", gap:"8px", marginBottom:"20px", flexWrap:"wrap" }}>
        {["All","Scheduled","In Progress","Completed"].map(s => (
          <button key={s} className="btn btn-sm" style={{ background: filter===s?"var(--warm-gold)":"var(--stone-200)", color: filter===s?"white":"var(--stone-700)" }} onClick={() => setFilter(s)}>{s}</button>
        ))}
      </div>

      <div style={{ display:"grid", gap:"16px" }}>
        {filtered.map(j => {
          const start = new Date(j.startDate), end = new Date(j.endDate), today = new Date();
          const total = (end - start) / 86400000 || 1;
          const done = Math.min(Math.max((today - start) / 86400000, 0), total);
          const pct = Math.round((done / total) * 100);
          const color = statColors[j.status] || "var(--stone-400)";
          const crewLabel = j.crewName || j.crew || "—";
          const photoCount = j.photos?.length || 0;
          const linkedEst = getEstimate(j.estimateId);
          const isExpanded = expandedJob === j.id;

          return (
            <div className="card" key={j.id} style={{ borderLeft:`4px solid ${color}`, padding:"20px 22px" }}>

              {/* ── Header row ── */}
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:"10px" }}>
                <div>
                  <div style={{ fontWeight:600, fontSize:"16px", marginBottom:"4px" }}>{j.project}</div>
                  <div style={{ fontSize:"13px", color:"var(--stone-500)", display:"flex", gap:"12px", flexWrap:"wrap", alignItems:"center" }}>
                    <span style={{ display:"flex", gap:"4px", alignItems:"center" }}><Icon name="customers" size={12}/>{j.customer}</span>
                    <span style={{ display:"flex", gap:"4px", alignItems:"center" }}><Icon name="location" size={12}/>{j.address}</span>
                    <span style={{ display:"flex", gap:"4px", alignItems:"center" }}><Icon name="calendar" size={12}/>{j.startDate} → {j.endDate}</span>
                    <span style={{ display:"flex", gap:"5px", alignItems:"center", background:"var(--stone-100)", border:"1px solid var(--stone-300)", borderRadius:99, padding:"2px 10px", fontSize:"12px", color:"var(--stone-700)", fontWeight:500 }}>
                      👷 {crewLabel}
                    </span>
                    {/* Estimate pill */}
                    {linkedEst ? (
                      <span
                        onClick={() => setExpandedJob(isExpanded ? null : j.id)}
                        style={{ display:"flex", gap:"5px", alignItems:"center", background:"rgba(201,169,110,0.12)", border:"1.5px solid var(--warm-gold)", borderRadius:99, padding:"2px 10px", fontSize:"12px", color:"var(--warm-gold)", fontWeight:600, cursor:"pointer", transition:"all 0.2s", userSelect:"none" }}
                        title="Click to view linked estimate"
                      >
                        <Icon name="estimate" size={11} color="var(--warm-gold)"/>
                        {linkedEst.id} &nbsp;·&nbsp; ${(linkedEst.override_total || getTotal(linkedEst.items)).toLocaleString()}
                        <Icon name={isExpanded ? "chevron_down" : "chevron_right"} size={11} color="var(--warm-gold)"/>
                      </span>
                    ) : (
                      <span
                        onClick={() => openEdit(j)}
                        style={{ display:"flex", gap:"5px", alignItems:"center", background:"var(--stone-100)", border:"1.5px dashed var(--stone-300)", borderRadius:99, padding:"2px 10px", fontSize:"12px", color:"var(--stone-400)", fontWeight:500, cursor:"pointer", transition:"all 0.2s", userSelect:"none" }}
                        title="Link an estimate to this job"
                      >
                        <Icon name="estimate" size={11}/>
                        Link Estimate
                      </span>
                    )}
                  </div>
                </div>
                <div style={{ display:"flex", gap:"8px", alignItems:"center", flexWrap:"wrap" }}>
                  <span className={`badge badge-${j.status.toLowerCase().replace(" ","-")}`}>{j.status}</span>
                  <span style={{ fontWeight:700, fontSize:"16px", color:"var(--warm-gold)" }}>${Number(j.value).toLocaleString()}</span>
                  <button className="btn-icon" title="Upload Photos" onClick={() => triggerUpload(j.id)}><Icon name="upload" size={14} color="var(--accent-blue)"/></button>
                  <button className="btn-icon" title="View Photos" onClick={() => setPhotoModal(j)} style={{ position:"relative" }}>
                    <Icon name="gallery" size={14} color="var(--accent-amber)"/>
                    {photoCount > 0 && <span style={{ position:"absolute", top:-4, right:-4, background:"var(--warm-gold)", color:"white", fontSize:"9px", fontWeight:700, borderRadius:99, width:14, height:14, display:"flex", alignItems:"center", justifyContent:"center" }}>{photoCount}</span>}
                  </button>
                  <button className="btn-icon" title="Edit Job" onClick={() => openEdit(j)}><Icon name="edit" size={14}/></button>
                  <button className="btn-icon" title="Delete" onClick={() => requestDelete("jobs", j)}><Icon name="trash" size={14} color="var(--accent-red)"/></button>
                  {!invoices.find(inv => inv.jobId === j.id || (j.estimateId && inv.estimate_id === j.estimateId)) && <button title="Create Invoice" onClick={() => convertToInvoice(j)} style={{ background:"var(--warm-gold)", color:"white", border:"none", borderRadius:"var(--radius)", padding:"4px 8px", fontSize:"11px", cursor:"pointer", fontWeight:600, whiteSpace:"nowrap" }}>→ Invoice</button>}
                  {j.status === "Completed" && <button title="Request Review" onClick={async () => { const already = (reviews||[]).find(r=>(r.jobId===j.id||r.job_id===j.id)&&r.status!=="Flagged"); if (already) { showToast("ℹ️ Review request already exists for this job."); setPage("reviews"); return; } const newReview = { id: Date.now(), jobId: j.id, job_id: j.id, customer: j.customer, project: j.project, crew: j.crew||j.crewName||"", requestedDate: new Date().toISOString().slice(0,10), respondedDate: null, status: "Pending", rating: null, cleanliness: null, communication: null, comment: "", googleSent: false, flagged: false }; if (setReviews) setReviews(p => [...p, newReview]); try { await supabase.from('reviews').upsert({ id: newReview.id, job_id: j.id, customer: j.customer, project: j.project, crew: newReview.crew, requestedDate: newReview.requestedDate, status: 'Pending' }, { onConflict: 'id' }); } catch (e) { console.log('[reviews] Supabase insert error:', e.message); } if (addNotification) addNotification("review", `⭐ Review request sent to ${j.customer} · ${j.project}`, "reviews"); showToast(`✅ Review request created for ${j.customer}`); setPage("reviews"); }} style={{ background:"var(--accent-blue)", color:"white", border:"none", borderRadius:"var(--radius)", padding:"4px 8px", fontSize:"11px", cursor:"pointer", fontWeight:600, whiteSpace:"nowrap" }}>⭐ Review</button>}
                  {j.status === "Completed" && (() => { const inv = (invoices||[]).find(i => i.jobId === j.id || (j.estimateId && i.estimate_id === j.estimateId)); const est = (estimates||[]).find(e => e.id === j.estimateId); const custRec = (customers||[]).find(c => c.name?.toLowerCase() === j.customer?.toLowerCase()); const pd = inv ? invPaidToDate(inv) : 0; if (!inv || pd <= 0) return null; return <button title="Project Receipt" onClick={() => { const payload = { invoiceId: inv.display_id||inv.id, estimateId: j.estimateId||est?.id||"", customer: j.customer, customerAddress: custRec?.address||"", customerEmail: custRec?.email||"", project: j.project, startDate: j.startDate||j.start_date, endDate: j.endDate||j.end_date, items: est?.items||[], payments: inv.payments||[], contractTotal: inv.contractTotal||inv.contract_total||0, paidToDate: pd, surcharge: est?.surcharge||false, surchargeAmt: est?.surcharge ? Math.round((est.override_total||getTotal(est.items))*0.03) : 0, crew: j.crew||j.crewName||"", notes: "" }; const url = `${window.location.origin}/api/project-receipt?d=${encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(payload)))))}`; window.open(url, "_blank"); }} style={{ background:"#6b5b3e", color:"white", border:"none", borderRadius:"var(--radius)", padding:"4px 8px", fontSize:"11px", cursor:"pointer", fontWeight:600, whiteSpace:"nowrap" }}>🧾 Receipt</button>; })()}
                </div>
              </div>

              {/* ── Progress bar ── */}
              {j.status !== "Scheduled" && (
                <div style={{ marginTop:"14px" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", fontSize:"12px", color:"var(--stone-500)", marginBottom:"4px" }}>
                    <span>Progress</span><span style={{ fontWeight:600 }}>{pct}%</span>
                  </div>
                  <div className="progress-bar"><div className="progress-fill" style={{ width:`${pct}%`, background:color }}/></div>
                </div>
              )}

              {/* ── Notes ── */}
              {j.notes && <div style={{ marginTop:"12px", fontSize:"12px", color:"var(--stone-600)", background:"var(--stone-100)", padding:"8px 10px", borderRadius:6 }}>{j.notes}</div>}

              {/* ── Crew Role Notes ── */}
              {(j.crewNotes || j.crew_notes || []).length > 0 && (
                <div style={{ marginTop:"12px", padding:"8px 12px", background:"rgba(201,169,110,0.06)", borderRadius:6, border:"1px solid rgba(201,169,110,0.12)" }}>
                  <div style={{ fontSize:10, fontWeight:600, color:"var(--warm-gold)", textTransform:"uppercase", letterSpacing:".04em", marginBottom:6 }}>📋 Crew Roles</div>
                  <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                    {(j.crewNotes || j.crew_notes || []).map((cn, ci) => (
                      <span key={ci} style={{ fontSize:12, background:"white", border:"1px solid var(--stone-200)", borderRadius:99, padding:"3px 10px", display:"inline-flex", gap:5, alignItems:"center" }}>
                        <strong style={{ color:"var(--stone-700)" }}>{cn.name?.split(" ")[0]}</strong>
                        <span style={{ color:"var(--stone-400)" }}>—</span>
                        <span style={{ color:"var(--stone-600)" }}>{cn.note}</span>
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* ── Inline Estimate Panel ── */}
              {isExpanded && linkedEst && (
                <div style={{ marginTop:"16px", border:"1.5px solid var(--sand-300)", borderRadius:"var(--radius-lg)", overflow:"hidden", animation:"fadeIn 0.25s ease" }}>
                  {/* Panel header */}
                  <div style={{ background:"var(--stone-800)", padding:"12px 18px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
                      <Icon name="estimate" size={15} color="var(--warm-gold)"/>
                      <span style={{ fontFamily:"var(--font-display)", fontSize:"16px", fontWeight:600, color:"white" }}>Scope of Work — {linkedEst.id}</span>
                      <span className={`badge badge-${linkedEst.status.toLowerCase()}`}>{linkedEst.status}</span>
                      {(() => {
                        const view = (estimateViews||{})[linkedEst.id];
                        if (linkedEst.status === "Draft") return null;
                        if (view?.viewed_at) {
                          return <span style={{ display:"inline-flex", alignItems:"center", gap:"4px", fontSize:"11px", fontWeight:600, color:"#4a7c59", background:"rgba(74,124,89,0.15)", padding:"2px 8px", borderRadius:99 }}>
                            <span style={{ width:6, height:6, borderRadius:"50%", background:"#4a7c59", display:"inline-block" }} />
                            Viewed {view.view_count > 1 ? `${view.view_count}×` : ""} · {new Date(view.last_viewed_at||view.viewed_at).toLocaleDateString("en-US",{month:"short",day:"numeric"})}
                          </span>;
                        }
                        if (linkedEst.status === "Sent" || linkedEst.last_sent_at) {
                          const sentAt = linkedEst.last_sent_at || linkedEst.date;
                          const daysSince = sentAt ? Math.floor((Date.now() - new Date(sentAt).getTime()) / 86400000) : 0;
                          return <span style={{ display:"inline-flex", alignItems:"center", gap:"4px", fontSize:"11px", fontWeight:600, color: daysSince >= 3 ? "#b94a4a" : "#c9a96e", background: daysSince >= 3 ? "rgba(185,74,74,0.15)" : "rgba(201,169,110,0.15)", padding:"2px 8px", borderRadius:99 }}>
                            <span style={{ width:6, height:6, borderRadius:"50%", background: daysSince >= 3 ? "#b94a4a" : "#c9a96e", display:"inline-block" }} />
                            {daysSince >= 3 ? "Not Viewed" : "Awaiting"} · {daysSince}d ago
                          </span>;
                        }
                        return null;
                      })()}
                    </div>
                    <div style={{ display:"flex", gap:"8px", alignItems:"center" }}>
                      <span style={{ fontSize:"12px", color:"var(--stone-400)" }}>{linkedEst.date}</span>
                      <button
                        onClick={() => setEstimateModal(linkedEst)}
                        style={{ background:"rgba(201,169,110,0.2)", border:"1px solid var(--warm-gold)", borderRadius:6, padding:"4px 10px", fontSize:"12px", color:"var(--warm-gold)", cursor:"pointer", fontFamily:"var(--font-body)", fontWeight:500 }}
                      >
                        Full View
                      </button>
                    </div>
                  </div>

                  {/* Line items table */}
                  <div style={{ background:"var(--stone-50)", padding:"0" }}>
                    <table style={{ width:"100%", fontSize:"13px" }}>
                      <thead>
                        <tr style={{ background:"var(--stone-100)" }}>
                          <th style={{ padding:"9px 16px", textAlign:"left", fontSize:"11px", fontWeight:600, letterSpacing:"0.05em", textTransform:"uppercase", color:"var(--stone-500)", borderBottom:"1px solid var(--stone-200)" }}>Description / Scope Item</th>
                          <th style={{ padding:"9px 12px", textAlign:"right", fontSize:"11px", fontWeight:600, letterSpacing:"0.05em", textTransform:"uppercase", color:"var(--stone-500)", borderBottom:"1px solid var(--stone-200)" }}>Qty</th>
                          <th style={{ padding:"9px 12px", textAlign:"right", fontSize:"11px", fontWeight:600, letterSpacing:"0.05em", textTransform:"uppercase", color:"var(--stone-500)", borderBottom:"1px solid var(--stone-200)" }}>Unit</th>
                          <th style={{ padding:"9px 12px", textAlign:"right", fontSize:"11px", fontWeight:600, letterSpacing:"0.05em", textTransform:"uppercase", color:"var(--stone-500)", borderBottom:"1px solid var(--stone-200)" }}>Rate</th>
                          <th style={{ padding:"9px 16px", textAlign:"right", fontSize:"11px", fontWeight:600, letterSpacing:"0.05em", textTransform:"uppercase", color:"var(--stone-500)", borderBottom:"1px solid var(--stone-200)" }}>Line Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {linkedEst.items.map((item, i) => (
                          <React.Fragment key={i}>
                            <tr style={{ borderBottom: (item.materials||[]).length > 0 ? "none" : "1px solid var(--stone-200)" }}>
                              <td style={{ padding:"10px 16px" }}><div style={{ fontWeight:600 }}>{item.desc}</div>{item.laborDesc && <div style={{ fontSize:"11px", color:"var(--stone-500)", marginTop:2, lineHeight:1.4, fontStyle:"italic" }}>{item.laborDesc}</div>}</td>
                              <td style={{ padding:"10px 12px", textAlign:"right", color:"var(--stone-600)" }}>{item.qty}</td>
                              <td style={{ padding:"10px 12px", textAlign:"right", color:"var(--stone-600)" }}>{item.unit}</td>
                              <td style={{ padding:"10px 12px", textAlign:"right", color:"var(--stone-600)" }}>${Number(item.price).toLocaleString()}</td>
                              <td style={{ padding:"10px 16px", textAlign:"right", fontWeight:700, color:"var(--stone-900)" }}>${(item.qty * item.price).toLocaleString()}</td>
                            </tr>
                            {(item.materials||[]).map((m, mi) => (
                              <tr key={`m-${mi}`} style={{ borderBottom: mi === item.materials.length - 1 ? "1px solid var(--stone-200)" : "1px solid var(--stone-100)", background:"#fffdf8" }}>
                                <td style={{ padding:"6px 16px 6px 36px", fontSize:"12px", color:"var(--stone-600)", borderLeft:"2px solid var(--sand-300)" }}>
                                  <span style={{ fontSize:"8px", fontWeight:700, background:"rgba(201,169,110,0.12)", color:"var(--warm-gold)", padding:"1px 5px", borderRadius:3, marginRight:5, letterSpacing:"0.04em" }}>MTL</span>
                                  {m.desc}
                                </td>
                                <td style={{ padding:"6px 12px", textAlign:"right", fontSize:"12px", color:"var(--stone-500)" }}>{m.qty}</td>
                                <td style={{ padding:"6px 12px", textAlign:"right", fontSize:"12px", color:"var(--stone-500)" }}>{m.unit}</td>
                                <td style={{ padding:"6px 12px", textAlign:"right", fontSize:"12px", color:"var(--stone-500)" }}>${Number(m.price).toFixed(2)}</td>
                                <td style={{ padding:"6px 16px", textAlign:"right", fontSize:"12px", fontWeight:600, color:"var(--stone-600)" }}>${(m.qty * m.price).toFixed(2)}</td>
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                    {/* Total row */}
                    <div style={{ padding:"12px 16px", borderTop:"2px solid var(--stone-200)", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <div style={{ fontSize:"12px", color:"var(--stone-500)" }}>
                        {stripCONotes(linkedEst.notes) && <span><strong>Note:</strong> {stripCONotes(linkedEst.notes)}</span>}
                      </div>
                      <div style={{ fontFamily:"var(--font-display)", fontSize:"20px", fontWeight:700, color:"var(--warm-gold)" }}>
                        Estimate Total: ${(linkedEst.override_total || getTotal(linkedEst.items)).toLocaleString()}
                      </div>
                    </div>

                    {/* ── Payment Summary Strip ── */}
                    {(() => {
                      const linkedInv = invoices.find(inv => inv.jobId === j.id) || (j.estimateId ? invoices.find(inv => inv.estimate_id && inv.estimate_id === j.estimateId) : null);
                      if (!linkedInv) return null;
                      const paidToDate = (linkedInv.payments || []).filter(p => p.status === "Paid").reduce((s, p) => s + (p.amount||0), 0);
                      const remaining = (linkedInv.contractTotal||0) - paidToDate;
                      return (
                        <div style={{ padding:"14px 16px", background:"var(--stone-800)", borderTop:"2px solid var(--stone-700)" }}>
                          <div style={{ fontSize:"11px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--stone-400)", marginBottom:"10px" }}>💳 Payment Status — {linkedInv.id}</div>
                          <div style={{ display:"grid", gridTemplateColumns:"repeat(3, 1fr)", gap:"10px", marginBottom:"12px" }}>
                            <div style={{ background:"rgba(255,255,255,0.05)", borderRadius:8, padding:"10px 12px" }}>
                              <div style={{ fontSize:"11px", color:"var(--stone-400)", marginBottom:3 }}>Contract Total</div>
                              <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, color:"var(--warm-gold)" }}>${(linkedInv.contractTotal||0).toLocaleString()}</div>
                            </div>
                            <div style={{ background:"rgba(74,156,109,0.15)", borderRadius:8, padding:"10px 12px" }}>
                              <div style={{ fontSize:"11px", color:"var(--stone-400)", marginBottom:3 }}>Paid to Date</div>
                              <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, color:"var(--accent-green)" }}>${paidToDate.toLocaleString()}</div>
                            </div>
                            <div style={{ background: remaining > 0 ? "rgba(196,148,74,0.15)" : "rgba(74,156,109,0.1)", borderRadius:8, padding:"10px 12px" }}>
                              <div style={{ fontSize:"11px", color:"var(--stone-400)", marginBottom:3 }}>{remaining<0?"Overpaid":"Remaining"}</div>
                              <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, color: remaining > 0 ? "var(--accent-amber)" : "var(--accent-green)" }}>${remaining<0?Math.abs(remaining).toLocaleString():remaining.toLocaleString()}</div>
                            </div>
                          </div>
                          {(linkedInv.payments || []).map((pmt, i) => (
                            <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 10px", background:"rgba(255,255,255,0.04)", borderRadius:6, marginBottom:6, border:`1px solid ${pmt.status==="Paid" ? "rgba(74,156,109,0.3)" : "rgba(255,255,255,0.08)"}` }}>
                              <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
                                <span style={{ fontSize:"13px" }}>{pmt.status === "Paid" ? "✅" : "⏳"}</span>
                                <div>
                                  <div style={{ fontSize:"12px", fontWeight:600, color:"white" }}>{pmt.label}</div>
                                  {pmt.status === "Paid" && <div style={{ fontSize:"11px", color:"var(--stone-400)" }}>{pmt.method} · {pmt.paidDate}</div>}
                                  {pmt.status !== "Paid" && <div style={{ fontSize:"11px", color:"var(--stone-400)" }}>Due {pmt.due}</div>}
                                </div>
                              </div>
                              <div style={{ fontFamily:"var(--font-display)", fontSize:"16px", fontWeight:700, color: pmt.status === "Paid" ? "var(--accent-green)" : "var(--stone-300)" }}>${pmt.amount.toLocaleString()}</div>
                            </div>
                          ))}
                        </div>
                      );
                    })()}
                  </div>
                </div>
              )}

              {/* ── Photo strip preview ── */}
              {photoCount > 0 && (
                <div style={{ marginTop:"14px" }}>
                  <div style={{ fontSize:"11px", fontWeight:600, color:"var(--stone-500)", letterSpacing:"0.05em", textTransform:"uppercase", marginBottom:"8px" }}>Progress Photos ({photoCount})</div>
                  <div style={{ display:"flex", gap:"8px", flexWrap:"wrap" }}>
                    {j.photos.slice(0,5).map((p,i) => (
                      <div key={i} onClick={() => setLightbox({ src: p.src, label: p.name, date: p.date })}
                        style={{ width:64, height:64, borderRadius:8, overflow:"hidden", border:"2px solid var(--stone-200)", cursor:"pointer", flexShrink:0, transition:"border-color 0.2s", background:"var(--stone-200)" }}
                        onMouseEnter={e => e.currentTarget.style.borderColor="var(--warm-gold)"}
                        onMouseLeave={e => e.currentTarget.style.borderColor="var(--stone-200)"}
                      >
                        <img src={p.src} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"cover" }}/>
                      </div>
                    ))}
                    {photoCount > 5 && (
                      <div onClick={() => setPhotoModal(j)} style={{ width:64, height:64, borderRadius:8, background:"var(--stone-200)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"13px", fontWeight:600, color:"var(--stone-500)", cursor:"pointer", border:"2px solid var(--stone-200)" }}>
                        +{photoCount - 5}
                      </div>
                    )}
                    <div onClick={() => triggerUpload(j.id)} style={{ width:64, height:64, borderRadius:8, border:"2px dashed var(--stone-300)", display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer", color:"var(--stone-400)", fontSize:"22px", transition:"all 0.2s" }}
                      onMouseEnter={e => { e.currentTarget.style.borderColor="var(--warm-gold)"; e.currentTarget.style.color="var(--warm-gold)"; }}
                      onMouseLeave={e => { e.currentTarget.style.borderColor="var(--stone-300)"; e.currentTarget.style.color="var(--stone-400)"; }}
                    >+</div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* ── Add / Edit Job Modal ── */}
      {modal && (
        <Modal title={modal === "add" ? "Create Job" : "Edit Job"} onClose={() => setModal(null)}>
          <div className="form-grid">
            <div className="form-group">
              <label>Customer</label>
              <select value={form.customer} onChange={e => setForm(p => ({...p,customer:e.target.value}))}>
                <option value="">Select Customer</option>
                {customers.map(c => <option key={c.id}>{c.name}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Project Name</label><input value={form.project} onChange={e => setForm(p => ({...p,project:e.target.value}))} /></div>
            <div className="form-group">
              <label>Status</label>
              <select value={form.status} onChange={e => setForm(p => ({...p,status:e.target.value}))}>
                {["Scheduled","In Progress","Completed"].map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Assign Crew / Technician</label>
              <div style={{ border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", padding:"8px 10px", background:"white", display:"flex", gap:"6px", flexWrap:"wrap", minHeight:"40px", alignItems:"center" }}>
                {(users||[]).filter(u => u.active !== false && (u.role === "installer" || u.role === "admin" || u.role === "owner")).map(u => {
                  const selected = (form.crewName || "").split(",").map(s => s.trim()).filter(Boolean);
                  const isSelected = selected.includes(u.name);
                  return (
                    <button key={u.id} type="button" onClick={() => {
                      const current = (form.crewName || "").split(",").map(s => s.trim()).filter(Boolean);
                      const updated = isSelected ? current.filter(n => n !== u.name) : [...current, u.name];
                      setForm(p => ({...p, crewName: updated.join(", ")}));
                    }} style={{
                      padding:"5px 12px", borderRadius:99, fontSize:"12px", fontWeight:600, cursor:"pointer",
                      border: isSelected ? "1.5px solid var(--warm-gold)" : "1.5px solid var(--stone-200)",
                      background: isSelected ? "rgba(196,149,74,0.1)" : "var(--stone-50)",
                      color: isSelected ? "var(--warm-gold)" : "var(--stone-500)",
                      display:"flex", alignItems:"center", gap:"5px", transition:"all 0.15s"
                    }}>
                      {isSelected && <span style={{ fontSize:"10px" }}>✓</span>}
                      {u.name.split(" ")[0]} · <span style={{ fontWeight:400, textTransform:"capitalize" }}>{u.role}</span>
                    </button>
                  );
                })}
                {!(form.crewName || "").trim() && <span style={{ fontSize:"12px", color:"var(--stone-400)" }}>Tap to assign crew members</span>}
              </div>
              {/* Crew Pay — per-member flat rate (owner only) */}
              {isOwner && (form.crewName || "").trim() && (() => {
                const members = (form.crewName || "").split(",").map(s => s.trim()).filter(Boolean);
                if (members.length === 0) return null;
                return (
                  <div style={{ marginTop:8, padding:"10px 14px", background:"rgba(122,158,126,0.06)", borderRadius:"var(--radius)", border:"1px solid rgba(122,158,126,0.15)" }}>
                    <div style={{ fontSize:11, fontWeight:600, color:"var(--accent-green)", textTransform:"uppercase", letterSpacing:".04em", marginBottom:8 }}>💰 Crew Pay (per member)</div>
                    <div style={{ display:"grid", gap:6 }}>
                      {members.map(name => {
                        const existing = (form.crewPay || []).find(p => p.name === name);
                        return (
                          <div key={name} style={{ display:"flex", alignItems:"center", gap:10 }}>
                            <span style={{ fontSize:12, fontWeight:600, color:"var(--stone-700)", minWidth:100 }}>{name.split(" ")[0]}</span>
                            <span style={{ fontSize:12, color:"var(--stone-400)" }}>$</span>
                            <input type="number" placeholder="0" value={existing?.amount || ""} onChange={e => {
                              const amt = e.target.value;
                              setForm(p => {
                                const current = [...(p.crewPay || [])].filter(cp => cp.name !== name);
                                if (amt) current.push({ name, amount: Number(amt) });
                                return { ...p, crewPay: current };
                              });
                            }} style={{ width:100, padding:"5px 8px", borderRadius:6, border:"1.5px solid var(--stone-200)", fontSize:13, textAlign:"right" }} />
                          </div>
                        );
                      })}
                    </div>
                    {(form.crewPay || []).length > 0 && (
                      <div style={{ marginTop:6, fontSize:11, color:"var(--stone-400)" }}>
                        Total crew cost: <strong style={{ color:"var(--stone-600)" }}>${(form.crewPay || []).reduce((s,p) => s + (Number(p.amount)||0), 0).toLocaleString()}</strong>
                        {" "}· Visible to each crew member in their Crew App
                      </div>
                    )}
                  </div>
                );
              })()}
            </div>
            {/* Crew Role Notes — per-member task/role (owner + admin) */}
            {(form.crewName || "").trim() && (() => {
              const members = (form.crewName || "").split(",").map(s => s.trim()).filter(Boolean);
              if (members.length === 0) return null;
              return (
                <div style={{ marginTop:4, padding:"10px 14px", background:"rgba(201,169,110,0.06)", borderRadius:"var(--radius)", border:"1px solid rgba(201,169,110,0.15)" }}>
                  <div style={{ fontSize:11, fontWeight:600, color:"var(--warm-gold)", textTransform:"uppercase", letterSpacing:".04em", marginBottom:8 }}>📋 Crew Role Notes</div>
                  <div style={{ display:"grid", gap:6 }}>
                    {members.map(name => {
                      const existing = (form.crewNotes || []).find(n => n.name === name);
                      return (
                        <div key={name} style={{ display:"flex", alignItems:"center", gap:10 }}>
                          <span style={{ fontSize:12, fontWeight:600, color:"var(--stone-700)", minWidth:100 }}>{name.split(" ")[0]}</span>
                          <input type="text" placeholder="e.g. Demo & floor prep" value={existing?.note || ""} onChange={e => {
                            const note = e.target.value;
                            setForm(p => {
                              const current = [...(p.crewNotes || [])].filter(cn => cn.name !== name);
                              if (note) current.push({ name, note });
                              return { ...p, crewNotes: current };
                            });
                          }} style={{ flex:1, padding:"5px 8px", borderRadius:6, border:"1.5px solid var(--stone-200)", fontSize:13 }} />
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}
            <div className="form-group"><label>Start Date</label><input type="date" value={form.startDate} onChange={e => {
              const start = e.target.value;
              const days = Number(form.estimatedDays) || 1;
              const endDate = days > 1 ? new Date(new Date(start + "T00:00:00").getTime() + (days - 1) * 86400000).toISOString().slice(0,10) : start;
              setForm(p => ({...p, startDate: start, endDate}));
            }} /></div>
            <div className="form-group"><label>Start Time</label>
              <select value={form.startTime||"8:00 AM"} onChange={e => setForm(p => ({...p, startTime: e.target.value}))}>
                {["6:00 AM","6:30 AM","7:00 AM","7:30 AM","8:00 AM","8:30 AM","9:00 AM","9:30 AM","10:00 AM","10:30 AM","11:00 AM","11:30 AM","12:00 PM","12:30 PM","1:00 PM","1:30 PM","2:00 PM","2:30 PM","3:00 PM","3:30 PM","4:00 PM","4:30 PM","5:00 PM"].map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Estimated Duration (days)</label><input type="number" min="1" value={form.estimatedDays} onChange={e => {
              const days = Math.max(1, Number(e.target.value) || 1);
              const endDate = form.startDate && days > 1 ? new Date(new Date(form.startDate + "T00:00:00").getTime() + (days - 1) * 86400000).toISOString().slice(0,10) : form.startDate;
              setForm(p => ({...p, estimatedDays: days, endDate}));
            }} /></div>
            <div className="form-group"><label>End Date <span style={{ fontSize:"11px", color:"var(--stone-400)", fontWeight:400 }}>auto-calculated</span></label><input type="date" value={form.endDate} onChange={e => setForm(p => ({...p,endDate:e.target.value}))} /></div>
            <div className="form-group"><label>Contract Value ($)</label><input type="number" value={form.value} onChange={e => setForm(p => ({...p,value:e.target.value}))} /></div>
            <div className="form-group"><label>Job Cost ($) <span style={{ fontSize:"11px", color:"var(--stone-400)", fontWeight:400 }}>materials + labor</span></label><input type="number" placeholder="0" value={form.cost} onChange={e => setForm(p => ({...p,cost:e.target.value}))} /></div>
            <div className="form-group"><label>Job Address</label><input value={form.address} onChange={e => setForm(p => ({...p,address:e.target.value}))} /></div>

            {/* ── Estimate Linker ── */}
            <div className="form-group form-full" style={{ background:"rgba(201,169,110,0.07)", border:"1.5px solid var(--sand-300)", borderRadius:"var(--radius)", padding:"14px 16px" }}>
              <div style={{ display:"flex", alignItems:"center", gap:"8px", marginBottom:"8px" }}>
                <Icon name="estimate" size={14} color="var(--warm-gold)"/>
                <label style={{ margin:0, color:"var(--stone-700)" }}>Link Estimate (Scope of Work)</label>
              </div>
              <select
                value={form.estimateId}
                onChange={e => setForm(p => ({...p, estimateId: e.target.value}))}
                style={{ borderColor:"var(--sand-300)" }}
              >
                <option value="">— No estimate linked —</option>
                {estimates.map(est => (
                  <option key={est.id} value={est.id}>
                    {est.id} · {est.customer} · {est.project} · ${(est.override_total || getTotal(est.items)).toLocaleString()} ({est.status})
                  </option>
                ))}
              </select>
              {form.estimateId && (() => {
                const est = getEstimate(form.estimateId);
                return est ? (
                  <div style={{ marginTop:"10px", fontSize:"12px", color:"var(--stone-600)", display:"flex", gap:"16px", flexWrap:"wrap" }}>
                    <span>📋 {est.items.length} line items</span>
                    <span>💰 ${(est.override_total || getTotal(est.items)).toLocaleString()} estimated</span>
                    <span>📅 {est.date}</span>
                    <span className={`badge badge-${est.status.toLowerCase()}`}>{est.status}</span>
                  </div>
                ) : null;
              })()}
            </div>

            <div className="form-group form-full"><label>Notes</label><textarea rows={3} value={form.notes} onChange={e => setForm(p => ({...p,notes:e.target.value}))} /></div>
          </div>
          <div style={{ display:"flex", justifyContent:"flex-end", gap:"8px" }}>
            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancel</button>
            <button className="btn btn-primary" onClick={save}><Icon name="check" size={14}/> Save Job</button>
          </div>
        </Modal>
      )}

      {/* ── Full Estimate View Modal ── */}
      {estimateModal && (() => {
        const job = jobs.find(j => j.estimateId === estimateModal.id);
        const sendToCrew = () => {
          if (job) {
            const scopeLines = estimateModal.items.map(item => {
              let line = `• ${item.desc} — ${item.qty} ${item.unit}`;
              if (item.laborDesc) line += `\n  ${item.laborDesc}`;
              if (item.materials && item.materials.length > 0) {
                line += "\n" + item.materials.map(m => `  ↳ ${m.desc} — ${m.qty} ${m.unit}`).join("\n");
              }
              return line;
            }).join("\n");
            const crewNote = `📋 CREW BRIEF — ${estimateModal.id}\nProject: ${estimateModal.project}\nClient: ${estimateModal.customer}\nStart: ${job.startDate || "TBD"}\nAddress: ${job.address || "See job details"}\n\nScope of Work:\n${scopeLines}${stripCONotes(estimateModal.notes) ? `\n\nNotes: ${stripCONotes(estimateModal.notes)}` : ""}`;
            setJobs(p => p.map(j => j.id === job.id ? { ...j, notes: (j.notes ? j.notes + "\n\n" : "") + crewNote } : j));
            if (addNotification) addNotification("job", `👷 Crew brief sent for ${estimateModal.project} · ${job.crewName || job.crew || "crew"}`, "jobs");
          }
          setCrewSent(true);
          setTimeout(() => setCrewSent(false), 4000);
        };
        return (
          <Modal title={`${crewView ? "👷 Crew Brief" : "📋 Full Estimate"} — ${estimateModal.id}`} onClose={() => { setEstimateModal(null); setCrewView(false); }}>
            {/* View toggle */}
            <div style={{ display:"flex", gap:"6px", marginBottom:"16px", background:"var(--stone-100)", borderRadius:"var(--radius)", padding:"4px" }}>
              <button onClick={() => setCrewView(false)} style={{ flex:1, padding:"7px", borderRadius:"var(--radius)", border:"none", cursor:"pointer", fontWeight:600, fontSize:"12px", background: !crewView ? "white" : "transparent", color: !crewView ? "var(--stone-900)" : "var(--stone-500)", boxShadow: !crewView ? "0 1px 4px rgba(0,0,0,0.1)" : "none" }}>
                🔒 Full Estimate (Admin)
              </button>
              <button onClick={() => setCrewView(true)} style={{ flex:1, padding:"7px", borderRadius:"var(--radius)", border:"none", cursor:"pointer", fontWeight:600, fontSize:"12px", background: crewView ? "white" : "transparent", color: crewView ? "var(--stone-900)" : "var(--stone-500)", boxShadow: crewView ? "0 1px 4px rgba(0,0,0,0.1)" : "none" }}>
                👷 Crew View (No Pricing)
              </button>
            </div>
            <div style={{ background:"var(--stone-100)", borderRadius:"var(--radius)", padding:"20px", marginBottom:"16px" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:"18px", paddingBottom:"14px", borderBottom:"1px solid var(--stone-300)" }}>
                <div>
                  <div style={{ fontFamily:"var(--font-display)", fontSize:"26px", fontWeight:700, color:"var(--stone-900)" }}>Timeless Tile Pro LLC</div>
                  <div style={{ fontSize:"12px", color:"var(--stone-500)" }}>Virginia Beach, VA · (757) 263-0978 · timelesstilepro.com</div>
                </div>
                <div style={{ textAlign:"right" }}>
                  <div style={{ fontWeight:700, fontSize:"20px", color: crewView ? "var(--accent-blue)" : "var(--warm-gold)", fontFamily:"var(--font-display)" }}>{crewView ? "CREW BRIEF" : estimateModal.id}</div>
                  <div style={{ fontSize:"12px", color:"var(--stone-500)", marginBottom:"4px" }}>{crewView ? `Start: ${job?.startDate || "TBD"}` : `Issued: ${estimateModal.date}`}</div>
                  {!crewView && <span className={`badge badge-${estimateModal.status.toLowerCase()}`}>{estimateModal.status}</span>}
                  {!crewView && (() => {
                    const view = (estimateViews||{})[estimateModal.id];
                    if (estimateModal.status === "Draft") return null;
                    if (view?.viewed_at) {
                      return <div style={{ marginTop:"4px", display:"flex", alignItems:"center", gap:"4px", fontSize:"11px", fontWeight:600, color:"var(--accent-green)" }}>
                        <span style={{ width:7, height:7, borderRadius:"50%", background:"var(--accent-green)", display:"inline-block" }} />
                        Viewed {view.view_count > 1 ? `${view.view_count}×` : ""} · {new Date(view.last_viewed_at||view.viewed_at).toLocaleDateString("en-US",{month:"short",day:"numeric"})}
                      </div>;
                    }
                    if (estimateModal.status === "Sent" || estimateModal.last_sent_at) {
                      const sentAt = estimateModal.last_sent_at || estimateModal.date;
                      const daysSince = sentAt ? Math.floor((Date.now() - new Date(sentAt).getTime()) / 86400000) : 0;
                      return <div style={{ marginTop:"4px", display:"flex", alignItems:"center", gap:"4px", fontSize:"11px", fontWeight:600, color: daysSince >= 3 ? "var(--accent-red)" : "var(--accent-amber)" }}>
                        <span style={{ width:7, height:7, borderRadius:"50%", background: daysSince >= 3 ? "var(--accent-red)" : "var(--accent-amber)", display:"inline-block" }} />
                        {daysSince >= 3 ? "Not Viewed" : "Awaiting"} · {daysSince}d ago
                      </div>;
                    }
                    return null;
                  })()}
                </div>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"12px", marginBottom:"16px" }}>
                <div>
                  <div style={{ fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--stone-500)", marginBottom:"3px" }}>{crewView ? "Customer" : "Client"}</div>
                  <div style={{ fontWeight:600 }}>{estimateModal.customer}</div>
                </div>
                <div>
                  <div style={{ fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--stone-500)", marginBottom:"3px" }}>Project</div>
                  <div style={{ fontWeight:600 }}>{estimateModal.project}</div>
                </div>
                {crewView && job?.address && (
                  <div style={{ gridColumn:"1/-1" }}>
                    <div style={{ fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--stone-500)", marginBottom:"3px" }}>Job Address</div>
                    <div style={{ fontWeight:600 }}>{job.address}</div>
                  </div>
                )}
                {crewView && (job?.crewName || job?.crew) && (
                  <div style={{ gridColumn:"1/-1" }}>
                    <div style={{ fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--stone-500)", marginBottom:"3px" }}>Assigned Crew</div>
                    <div style={{ fontWeight:600 }}>{job.crewName || job.crew}</div>
                  </div>
                )}
              </div>
              <table style={{ width:"100%", fontSize:"13px", borderRadius:6, overflow:"hidden" }}>
                <thead>
                  <tr style={{ background:"var(--stone-800)" }}>
                    <th style={{ padding:"10px 14px", textAlign:"left", color:"var(--stone-300)", fontWeight:600, fontSize:"11px", textTransform:"uppercase", letterSpacing:"0.05em" }}>Description / Scope</th>
                    <th style={{ padding:"10px 10px", textAlign:"right", color:"var(--stone-300)", fontWeight:600, fontSize:"11px", textTransform:"uppercase", letterSpacing:"0.05em" }}>Qty</th>
                    <th style={{ padding:"10px 10px", textAlign:"right", color:"var(--stone-300)", fontWeight:600, fontSize:"11px", textTransform:"uppercase", letterSpacing:"0.05em" }}>Unit</th>
                    {!crewView && <th style={{ padding:"10px 10px", textAlign:"right", color:"var(--stone-300)", fontWeight:600, fontSize:"11px", textTransform:"uppercase", letterSpacing:"0.05em" }}>Unit Price</th>}
                    {!crewView && <th style={{ padding:"10px 14px", textAlign:"right", color:"var(--stone-300)", fontWeight:600, fontSize:"11px", textTransform:"uppercase", letterSpacing:"0.05em" }}>Total</th>}
                  </tr>
                </thead>
                <tbody>
                  {estimateModal.items.map((item, i) => (
                    <React.Fragment key={i}>
                      <tr style={{ background: i % 2 === 0 ? "white" : "var(--stone-50)", borderBottom: (item.materials||[]).length > 0 ? "none" : "1px solid var(--stone-200)" }}>
                        <td style={{ padding:"11px 14px" }}><div style={{ fontWeight:600 }}>{item.desc}</div>{item.laborDesc && <div style={{ fontSize:"11px", color:"var(--stone-500)", marginTop:2, lineHeight:1.4, fontStyle:"italic" }}>{item.laborDesc}</div>}</td>
                        <td style={{ padding:"11px 10px", textAlign:"right", color:"var(--stone-600)" }}>{item.qty}</td>
                        <td style={{ padding:"11px 10px", textAlign:"right", color:"var(--stone-600)" }}>{item.unit}</td>
                        {!crewView && <td style={{ padding:"11px 10px", textAlign:"right", color:"var(--stone-600)" }}>${Number(item.price).toLocaleString()}</td>}
                        {!crewView && <td style={{ padding:"11px 14px", textAlign:"right", fontWeight:700 }}>${(item.qty * item.price).toLocaleString()}</td>}
                      </tr>
                      {(item.materials||[]).map((m, mi) => (
                        <tr key={`m-${mi}`} style={{ background:"#fffdf8", borderBottom: mi === item.materials.length - 1 ? "1px solid var(--stone-200)" : "1px solid var(--stone-100)" }}>
                          <td style={{ padding:"6px 14px 6px 34px", fontSize:"12px", color:"var(--stone-600)", borderLeft:"2px solid var(--sand-300)" }}>
                            <span style={{ fontSize:"8px", fontWeight:700, background:"rgba(201,169,110,0.12)", color:"var(--warm-gold)", padding:"1px 5px", borderRadius:3, marginRight:5, letterSpacing:"0.04em" }}>MTL</span>
                            {m.desc}
                          </td>
                          <td style={{ padding:"6px 10px", textAlign:"right", fontSize:"12px", color:"var(--stone-500)" }}>{m.qty}</td>
                          <td style={{ padding:"6px 10px", textAlign:"right", fontSize:"12px", color:"var(--stone-500)" }}>{m.unit}</td>
                          {!crewView && <td style={{ padding:"6px 10px", textAlign:"right", fontSize:"12px", color:"var(--stone-500)" }}>${Number(m.price).toFixed(2)}</td>}
                          {!crewView && <td style={{ padding:"6px 14px", textAlign:"right", fontSize:"12px", fontWeight:600, color:"var(--stone-600)" }}>${(m.qty * m.price).toFixed(2)}</td>}
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
              {!crewView && (
                <div style={{ display:"flex", justifyContent:"flex-end", background:"var(--stone-800)", padding:"14px 16px", borderRadius:"0 0 8px 8px" }}>
                  <div style={{ fontFamily:"var(--font-display)", fontSize:"22px", fontWeight:700, color:"var(--warm-gold)" }}>
                    Total: ${(estimateModal.override_total || getTotal(estimateModal.items)).toLocaleString()}
                  </div>
                </div>
              )}
              {crewView && (
                <div style={{ marginTop:"10px", fontSize:"11px", color:"var(--accent-blue)", background:"rgba(74,123,196,0.08)", border:"1px solid rgba(74,123,196,0.2)", borderRadius:6, padding:"8px 12px", display:"flex", gap:"6px", alignItems:"center" }}>
                  <Icon name="eye" size={12} color="var(--accent-blue)" /> Pricing and totals are hidden in this view. Crew sees scope and quantities only.
                </div>
              )}
              {stripCONotes(estimateModal.notes) && (
                <div style={{ marginTop:"14px", fontSize:"12px", color:"var(--stone-600)", padding:"10px 12px", background:"white", borderRadius:6, border:"1px solid var(--stone-200)" }}>
                  <strong>Notes:</strong> {stripCONotes(estimateModal.notes)}
                </div>
              )}
              {/* ── Change Order History (from structured data) ── */}
              {(estimateModal.change_orders||[]).length > 0 && (
                <div style={{ marginTop:"10px", borderRadius:6, border:"1px solid rgba(196,149,74,0.25)", overflow:"hidden" }}>
                  <div style={{ background:"rgba(196,149,74,0.08)", padding:"8px 12px", display:"flex", alignItems:"center", gap:"6px", borderBottom:"1px solid rgba(196,149,74,0.15)" }}>
                    <Icon name="edit" size={12} color="var(--warm-gold)" />
                    <span style={{ fontSize:"12px", fontWeight:700, color:"var(--warm-gold)" }}>Change Order History</span>
                  </div>
                  {(estimateModal.change_orders).map((co, idx) => (
                    <div key={co.id || idx} style={{ padding:"8px 12px", fontSize:"12px", color:"var(--stone-600)", borderBottom: idx < estimateModal.change_orders.length - 1 ? "1px solid var(--stone-100)" : "none", display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:"12px" }}>
                      <div style={{ flex:1 }}>
                        <span style={{ fontWeight:700, color:"var(--stone-800)" }}>{co.id}</span>
                        <span style={{ color:"var(--stone-400)", marginLeft:6 }}>{co.date}</span>
                        <span style={{ marginLeft:8, color: co.mode === "edit" ? "var(--accent-amber)" : "var(--accent-green)", fontWeight:600 }}>
                          {co.mode === "edit" ? "Scope Edited" : "Scope Added"}
                        </span>
                        {co.reason && co.reason !== "Scope change" && (
                          <div style={{ marginTop:2, color:"var(--stone-500)", fontStyle:"italic" }}>{co.reason}</div>
                        )}
                        {(co.receipts||[]).length > 0 && (
                          <div style={{ marginTop:6, display:"flex", flexWrap:"wrap", gap:6 }}>
                            {co.receipts.map((r, ri) => (
                              <a key={ri} href={r.url} target="_blank" rel="noopener noreferrer" title={r.fileName}
                                 style={{ display:"flex", alignItems:"center", gap:4, padding:"3px 7px", background:"rgba(196,149,74,0.1)", border:"1px solid rgba(196,149,74,0.3)", borderRadius:4, fontSize:"10px", color:"var(--warm-gold)", textDecoration:"none", fontWeight:600 }}>
                                <span>{r.mimeType === 'application/pdf' ? '📄' : '🖼️'}</span>
                                <span style={{ maxWidth:120, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{r.fileName}</span>
                              </a>
                            ))}
                          </div>
                        )}
                      </div>
                      <div style={{ textAlign:"right", whiteSpace:"nowrap" }}>
                        <span style={{ color:"var(--stone-400)", textDecoration:"line-through" }}>${(co.originalTotal||0).toLocaleString()}</span>
                        <span style={{ margin:"0 4px" }}>→</span>
                        <span style={{ fontWeight:700, color:"var(--stone-800)" }}>${(co.overridePrice || co.newTotal||0).toLocaleString()}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* ── Payment Status Panel (admin view only) ── */}
            {!crewView && (() => {
              const linkedInv = invoices.find(inv => inv.jobId === job?.id) || invoices.find(inv => inv.estimate_id && inv.estimate_id === estimateModal.id);
              if (!linkedInv) return null;
              const paidToDate = invPaidToDate(linkedInv);
              const remaining = invRemaining(linkedInv);
              return (
                <div style={{ borderRadius:"var(--radius)", overflow:"hidden", marginBottom:"16px", border:"1px solid var(--stone-200)" }}>
                  <div style={{ background:"var(--stone-800)", padding:"12px 16px", display:"flex", alignItems:"center", gap:"8px" }}>
                    <Icon name="dollar" size={14} color="var(--warm-gold)" />
                    <span style={{ fontWeight:700, fontSize:"13px", color:"white" }}>Payment Status — {linkedInv.id}</span>
                  </div>
                  <div style={{ background:"var(--stone-800)", padding:"0 16px 14px", display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:"10px" }}>
                    <div style={{ background:"rgba(255,255,255,0.05)", borderRadius:8, padding:"10px 12px" }}>
                      <div style={{ fontSize:"11px", color:"var(--stone-400)", marginBottom:3 }}>Contract Total</div>
                      <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, color:"var(--warm-gold)" }}>${(linkedInv.contractTotal||0).toLocaleString()}</div>
                    </div>
                    <div style={{ background:"rgba(74,156,109,0.15)", borderRadius:8, padding:"10px 12px" }}>
                      <div style={{ fontSize:"11px", color:"var(--stone-400)", marginBottom:3 }}>Paid to Date</div>
                      <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, color:"var(--accent-green)" }}>${paidToDate.toLocaleString()}</div>
                    </div>
                    <div style={{ background: remaining > 0 ? "rgba(196,148,74,0.15)" : "rgba(74,156,109,0.1)", borderRadius:8, padding:"10px 12px" }}>
                      <div style={{ fontSize:"11px", color:"var(--stone-400)", marginBottom:3 }}>{remaining<0?"Overpaid":"Remaining"}</div>
                      <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, color: remaining > 0 ? "var(--accent-amber)" : "var(--accent-green)" }}>${remaining<0?Math.abs(remaining).toLocaleString():remaining.toLocaleString()}</div>
                    </div>
                  </div>
                  <div style={{ background:"var(--stone-800)", padding:"0 16px 16px", display:"flex", flexDirection:"column", gap:"6px" }}>
                    {(linkedInv.payments || []).map((pmt, i) => (
                      <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 12px", background:"rgba(255,255,255,0.04)", borderRadius:6, border:`1px solid ${pmt.status==="Paid" ? "rgba(74,156,109,0.3)" : "rgba(255,255,255,0.08)"}` }}>
                        <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
                          <span style={{ fontSize:"14px" }}>{pmt.status === "Paid" ? "✅" : "⏳"}</span>
                          <div>
                            <div style={{ fontSize:"12px", fontWeight:600, color:"white" }}>{pmt.label}</div>
                            {pmt.status === "Paid"
                              ? <div style={{ fontSize:"11px", color:"var(--accent-green)" }}>{pmt.method} · {pmt.paidDate}{pmt.note ? ` · ${pmt.note}` : ""}</div>
                              : <div style={{ fontSize:"11px", color:"var(--stone-400)" }}>Due {pmt.due || "upon completion"}</div>
                            }
                          </div>
                        </div>
                        <div style={{ fontFamily:"var(--font-display)", fontSize:"16px", fontWeight:700, color: pmt.status === "Paid" ? "var(--accent-green)" : "var(--stone-300)" }}>${pmt.amount.toLocaleString()}</div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })()}

            {/* ── Change Order Panel (admin only) ── */}
            {!crewView && changeOrder && (() => {
              const origTotal = getTotal(estimateModal.items);
              const newScopeTotal = changeItems.filter(i => i.desc).reduce((s,i) => s + (Number(i.qty||0) * Number(i.price||0)) + (i.materials||[]).reduce((ms,m) => ms + (Number(m.qty||0)*Number(m.price||0)), 0), 0);
              const hasOverride = changeOverridePrice !== "" && Number(changeOverridePrice) > 0;
              const projectedTotal = hasOverride ? Number(changeOverridePrice) : (changeMode === "edit" ? newScopeTotal : origTotal + newScopeTotal);
              const totalCredit = priorDeposits.reduce((s,d) => s + (Number(d.amount)||0), 0);
              const newDeposit = Math.round(projectedTotal * 0.5);
              const additionalDeposit = Math.max(0, newDeposit - totalCredit);
              const balance = projectedTotal - newDeposit;

              return (
                <div style={{ background:"rgba(196,149,74,0.06)", border:"1px solid rgba(196,149,74,0.25)", borderRadius:"var(--radius)", padding:"20px", marginBottom:"16px" }}>
                  {/* Header */}
                  <div style={{ fontWeight:700, fontSize:"14px", color:"var(--warm-gold)", marginBottom:"16px", display:"flex", alignItems:"center", gap:"8px" }}>
                    <Icon name="edit" size={14} color="var(--warm-gold)" /> Change Order — {estimateModal.id}
                  </div>

                  {/* ── Mode Selector ── */}
                  <div style={{ display:"flex", gap:"8px", marginBottom:"16px" }}>
                    {["edit","add"].map(mode => (
                      <button key={mode} onClick={() => {
                        setChangeMode(mode);
                        if (mode === "edit") { setChangeItems(JSON.parse(JSON.stringify(estimateModal.items))); }
                        else { setChangeItems([{ desc:"", laborDesc:"", qty:1, unit:"sqft", price:0, clientSupplied:false, clientSuppliedNote:"", materials:[] }]); }
                        setChangeOverridePrice("");
                      }} style={{
                        flex:1, padding:"10px 14px", borderRadius:"var(--radius)",
                        border: changeMode === mode ? "2px solid var(--warm-gold)" : "1px solid var(--stone-200)",
                        background: changeMode === mode ? "rgba(196,149,74,0.08)" : "white",
                        cursor:"pointer", fontSize:"12px", fontWeight:600, textAlign:"center",
                        color: changeMode === mode ? "var(--warm-gold)" : "var(--text-secondary)"
                      }}>
                        {mode === "edit" ? "✏️ Edit Scope" : "➕ Add to Scope"}
                        <div style={{ fontSize:"10px", fontWeight:400, marginTop:"2px", color:"var(--text-secondary)" }}>
                          {mode === "edit" ? "Modify existing estimate items" : "New items added to existing"}
                        </div>
                      </button>
                    ))}
                  </div>

                  {/* ── Original Total Reference (compact) ── */}
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 12px", background:"white", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", marginBottom:"14px", fontSize:"12px" }}>
                    <span style={{ color:"var(--text-secondary)" }}>Original Estimate Total</span>
                    <span style={{ fontWeight:700, color: changeMode === "edit" ? "var(--accent-red)" : "var(--text-primary)", textDecoration: changeMode === "edit" ? "line-through" : "none" }}>${origTotal.toLocaleString()}</span>
                  </div>

                  {/* ── New Scope Items ── */}
                  <div style={{ marginBottom:"14px" }}>
                    <div style={{ fontSize:"10px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--warm-gold)", marginBottom:"4px" }}>
                      {changeMode === "edit" ? "Scope of Work" : "Additional Line Items"}
                    </div>
                    <div style={{ display:"grid", gridTemplateColumns:"3fr 55px 60px 80px 70px 24px", gap:"4px", padding:"4px 0 2px", marginBottom:"2px" }}>
                      <span style={{ fontSize:"9px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--text-secondary)" }}>Description / Scope</span>
                      <span style={{ fontSize:"9px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--text-secondary)" }}>Qty</span>
                      <span style={{ fontSize:"9px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--text-secondary)" }}>Unit</span>
                      <span style={{ fontSize:"9px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--text-secondary)" }}>Unit Price</span>
                      <span style={{ fontSize:"9px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--text-secondary)", textAlign:"right" }}>Total</span>
                      <span />
                    </div>
                    {changeItems.map((item, i) => (
                      <div key={i} style={{ marginBottom:"10px", paddingBottom:"10px", borderBottom:"1px solid var(--stone-100)" }}>
                        {/* Main row: desc, qty, unit, price, total, remove */}
                        <div style={{ display:"grid", gridTemplateColumns:"3fr 55px 60px 80px 70px 24px", gap:"5px", alignItems:"center" }}>
                          <input value={item.desc} onChange={e => setChangeItems(p => p.map((it,idx) => idx===i ? {...it, desc:e.target.value} : it))} placeholder="Description / Scope"
                            style={{ padding:"7px 10px", border:"1.5px solid var(--stone-300)", borderRadius:"var(--radius)", fontSize:"12px", fontWeight:600 }} />
                          <input value={item.qty} onChange={e => setChangeItems(p => p.map((it,idx) => idx===i ? {...it, qty:e.target.value} : it))} placeholder="Qty" type="number"
                            style={{ padding:"7px 8px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"12px", textAlign:"right" }} />
                          <select value={item.unit} onChange={e => setChangeItems(p => p.map((it,idx) => idx===i ? {...it, unit:e.target.value} : it))}
                            style={{ padding:"7px 5px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"12px", background:"white" }}>
                            {["sqft","lnft","job","ea","hr"].map(u => <option key={u}>{u}</option>)}
                          </select>
                          <input value={item.price} onChange={e => setChangeItems(p => p.map((it,idx) => idx===i ? {...it, price:e.target.value} : it))} placeholder="0.00" type="number"
                            style={{ padding:"7px 8px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"12px", textAlign:"right" }} />
                          <div style={{ padding:"7px 8px", background:"var(--stone-50)", border:"1px solid var(--stone-100)", borderRadius:"var(--radius)", fontSize:"12px", fontWeight:600, textAlign:"right", color:"var(--stone-700)" }}>
                            ${(Number(item.qty||0) * Number(item.price||0)).toLocaleString()}
                          </div>
                          <button onClick={() => setChangeItems(p => p.filter((_,idx) => idx!==i))} style={{ background:"none", border:"none", cursor:"pointer", padding:4 }}>
                            <Icon name="x" size={12} color="var(--accent-red)" />
                          </button>
                        </div>

                        {/* Labor description */}
                        <textarea value={item.laborDesc||""} onChange={e => setChangeItems(p => p.map((it,idx) => idx===i ? {...it, laborDesc:e.target.value} : it))}
                          placeholder="Labor description — detail the scope of work for this item…" rows={2}
                          style={{ width:"100%", marginTop:"5px", padding:"6px 10px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"11px", color:"var(--stone-600)", resize:"vertical", lineHeight:1.5, background:"var(--stone-50)" }} />

                        {/* Client-supplied flag for this scope */}
                        <div style={{ display:"flex", alignItems:"center", gap:8, marginTop:4, paddingLeft:2, flexWrap:"wrap" }}>
                          <label style={{ display:"inline-flex", alignItems:"center", gap:5, fontSize:"11px", color:"var(--stone-600)", cursor:"pointer" }}>
                            <input type="checkbox" checked={!!item.clientSupplied}
                              onChange={e => setChangeItems(p => p.map((it,idx) => idx===i ? {...it, clientSupplied:e.target.checked} : it))}
                              style={{ width:13, height:13, accentColor:"#c9a96e", cursor:"pointer" }} />
                            Client supplies material for this scope
                          </label>
                          {item.clientSupplied && (
                            <input placeholder="What is client supplying? (e.g. tile, fixtures)" value={item.clientSuppliedNote||""}
                              onChange={e => setChangeItems(p => p.map((it,idx) => idx===i ? {...it, clientSuppliedNote:e.target.value} : it))}
                              style={{ flex:"1 1 220px", minWidth:180, padding:"4px 8px", border:"1px solid rgba(201,149,74,0.35)", borderRadius:5, fontSize:"11px", background:"rgba(201,149,74,0.06)", color:"#8a5a1a" }} />
                          )}
                        </div>

                        {/* Materials */}
                        <div style={{ marginLeft:"18px", marginTop:"5px", paddingLeft:"14px", borderLeft:"2px solid var(--sand-300, rgba(201,169,110,0.3))" }}>
                          {(item.materials||[]).length > 0 && (
                            <div style={{ fontSize:"10px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.04em", color:"var(--warm-gold)", marginBottom:"4px", marginTop:"2px" }}>Materials</div>
                          )}
                          {(item.materials||[]).map((m, mi) => (
                            <div key={mi} style={{ marginBottom:"5px" }}>
                              <div style={{ display:"grid", gridTemplateColumns:"3fr 55px 55px 70px 65px 24px", gap:"4px", alignItems:"center" }}>
                                <input placeholder="Material name" value={m.desc} onChange={e => setChangeItems(p => p.map((it,idx) => idx===i ? {...it, materials:(it.materials||[]).map((mat,midx) => midx===mi ? {...mat, desc:e.target.value} : mat)} : it))}
                                  style={{ padding:"6px 8px", border:"1px solid var(--sand-200, rgba(201,169,110,0.2))", borderRadius:6, fontSize:"11px", background:"#fffdf8" }} />
                                <input type="number" placeholder="Qty" value={m.qty} onChange={e => setChangeItems(p => p.map((it,idx) => idx===i ? {...it, materials:(it.materials||[]).map((mat,midx) => midx===mi ? {...mat, qty:e.target.value} : mat)} : it))}
                                  style={{ padding:"6px 7px", border:"1px solid var(--sand-200, rgba(201,169,110,0.2))", borderRadius:6, fontSize:"11px", textAlign:"right", background:"#fffdf8" }} />
                                <select value={m.unit} onChange={e => setChangeItems(p => p.map((it,idx) => idx===i ? {...it, materials:(it.materials||[]).map((mat,midx) => midx===mi ? {...mat, unit:e.target.value} : mat)} : it))}
                                  style={{ padding:"6px 5px", border:"1px solid var(--sand-200, rgba(201,169,110,0.2))", borderRadius:6, fontSize:"11px", background:"#fffdf8" }}>
                                  {["ea","sqft","lnft","job","hr","box","bag"].map(u => <option key={u}>{u}</option>)}
                                </select>
                                <input type="number" placeholder="0.00" value={m.price} onChange={e => setChangeItems(p => p.map((it,idx) => idx===i ? {...it, materials:(it.materials||[]).map((mat,midx) => midx===mi ? {...mat, price:e.target.value} : mat)} : it))}
                                  style={{ padding:"6px 7px", border:"1px solid var(--sand-200, rgba(201,169,110,0.2))", borderRadius:6, fontSize:"11px", textAlign:"right", background:"#fffdf8" }} />
                                <div style={{ padding:"6px 7px", background:"#fffdf8", border:"1px solid var(--stone-100)", borderRadius:6, fontSize:"11px", fontWeight:600, textAlign:"right", color:"var(--stone-600)" }}>
                                  ${(Number(m.qty||0) * Number(m.price||0)).toFixed(2)}
                                </div>
                                <button onClick={() => setChangeItems(p => p.map((it,idx) => idx===i ? {...it, materials:(it.materials||[]).filter((_,midx) => midx!==mi)} : it))} style={{ background:"none", border:"none", cursor:"pointer", padding:4 }}>
                                  <Icon name="x" size={10} color="var(--accent-red)" />
                                </button>
                              </div>
                              <label style={{ display:"inline-flex", alignItems:"center", gap:4, fontSize:"10px", color: m.clientSupplied ? "#8a5a1a" : "var(--stone-500)", cursor:"pointer", marginTop:2, paddingLeft:2 }}>
                                <input type="checkbox" checked={!!m.clientSupplied}
                                  onChange={e => setChangeItems(p => p.map((it,idx) => idx===i ? {...it, materials:(it.materials||[]).map((mat,midx) => midx===mi ? {...mat, clientSupplied:e.target.checked} : mat)} : it))}
                                  style={{ width:11, height:11, accentColor:"#c9a96e", cursor:"pointer" }} />
                                Client supplied
                              </label>
                            </div>
                          ))}
                          <button onClick={() => setChangeItems(p => p.map((it,idx) => idx===i ? {...it, materials:[...(it.materials||[]), { desc:"", qty:1, unit:"ea", price:0, clientSupplied:false }]} : it))}
                            style={{ padding:"3px 8px", fontSize:"10px", fontWeight:600, background:"transparent", color:"var(--warm-gold)", border:"1px dashed rgba(201,169,110,0.4)", borderRadius:5, cursor:"pointer", marginTop:"2px", marginBottom:"4px" }}>
                            + Add Material
                          </button>
                        </div>
                      </div>
                    ))}
                    <button onClick={() => setChangeItems(p => [...p, { desc:"", laborDesc:"", qty:1, unit:"sqft", price:0, clientSupplied:false, clientSuppliedNote:"", materials:[] }])} style={{ fontSize:"12px", color:"var(--warm-gold)", background:"none", border:"1px dashed var(--warm-gold)", borderRadius:"var(--radius)", padding:"6px 14px", cursor:"pointer" }}>
                      + Add Scope Item
                    </button>
                  </div>

                  {/* ── Prior Deposits ── */}
                  <div style={{ background:"white", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", padding:"14px", marginBottom:"14px" }}>
                    <div style={{ fontSize:"10px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--text-secondary)", marginBottom:"10px", display:"flex", alignItems:"center", gap:"6px" }}>
                      💰 Prior Deposits Received
                    </div>
                    {priorDeposits.map((dep, i) => (
                      <div key={i} style={{ display:"grid", gridTemplateColumns:"100px 110px 90px 1fr 28px", gap:"6px", marginBottom:"8px", alignItems:"center" }}>
                        <input value={dep.amount} onChange={e => setPriorDeposits(p => p.map((d,idx) => idx===i ? {...d, amount:e.target.value} : d))} placeholder="$ Amount" type="number" step="0.01" style={{ padding:"7px 10px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"12px" }} />
                        <input value={dep.date} onChange={e => setPriorDeposits(p => p.map((d,idx) => idx===i ? {...d, date:e.target.value} : d))} type="date" style={{ padding:"7px 10px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"12px" }} />
                        <select value={dep.method} onChange={e => setPriorDeposits(p => p.map((d,idx) => idx===i ? {...d, method:e.target.value} : d))} style={{ padding:"7px 10px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"12px", background:"white" }}>
                          <option value="Stripe">Card/Stripe</option>
                          <option value="Check">Check</option>
                          <option value="Cash">Cash</option>
                          <option value="Zelle">Zelle</option>
                          <option value="Other">Other</option>
                        </select>
                        <input value={dep.note} onChange={e => setPriorDeposits(p => p.map((d,idx) => idx===i ? {...d, note:e.target.value} : d))} placeholder="Note (e.g. original deposit on grout refresh)" style={{ padding:"7px 10px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"12px" }} />
                        <button onClick={() => setPriorDeposits(p => p.filter((_,idx) => idx!==i))} style={{ background:"none", border:"none", cursor:"pointer", color:"var(--accent-red)" }}><Icon name="x" size={13} color="var(--accent-red)" /></button>
                      </div>
                    ))}
                    <button onClick={() => setPriorDeposits(p => [...p, { amount:"", date:new Date().toISOString().slice(0,10), method:"Stripe", note:"" }])} style={{ fontSize:"12px", color:"var(--text-secondary)", background:"none", border:"1px dashed var(--stone-200)", borderRadius:"var(--radius)", padding:"5px 12px", cursor:"pointer" }}>
                      + Add Deposit Record
                    </button>
                  </div>

                  {/* ── Change Notes ── */}
                  <textarea value={changeNotes} onChange={e => setChangeNotes(e.target.value)} placeholder="Reason for change order (e.g. shower base needs full replacement — discovered on-site arrival)" rows={2} style={{ width:"100%", padding:"10px 12px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"12px", resize:"vertical", marginBottom:"14px" }} />

                  {/* ── Overall Project Price Override ── */}
                  <div style={{ background:"white", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", padding:"14px", marginBottom:"14px" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:"12px" }}>
                      <div>
                        <div style={{ fontSize:"10px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--text-secondary)", marginBottom:"2px" }}>
                          Overall Project Price
                        </div>
                        <div style={{ fontSize:"10px", color:"var(--text-secondary)" }}>
                          {hasOverride ? "Using override price" : `Calculated from line items: $${newScopeTotal.toLocaleString()}`}
                        </div>
                      </div>
                      <div style={{ display:"flex", alignItems:"center", gap:"6px" }}>
                        <span style={{ fontSize:"16px", fontWeight:700, color:"var(--warm-gold)" }}>$</span>
                        <input value={changeOverridePrice} onChange={e => setChangeOverridePrice(e.target.value)} placeholder={newScopeTotal.toLocaleString()} type="number" step="0.01"
                          style={{ width:"130px", padding:"8px 10px", border: hasOverride ? "2px solid var(--warm-gold)" : "1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"14px", fontWeight:700, textAlign:"right", background: hasOverride ? "rgba(196,149,74,0.06)" : "white" }} />
                        {hasOverride && (
                          <button onClick={() => setChangeOverridePrice("")} style={{ background:"none", border:"none", cursor:"pointer", padding:"4px", fontSize:"11px", color:"var(--accent-red)" }} title="Clear override">
                            <Icon name="x" size={12} color="var(--accent-red)" />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* ── Financial Summary ── */}
                  <div style={{ background:"var(--sidebar-bg)", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", padding:"16px", marginBottom:"14px" }}>
                    <div style={{ fontSize:"10px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--text-secondary)", marginBottom:"10px" }}>
                      📊 Financial Summary
                    </div>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr auto", gap:"6px 16px", fontSize:"13px" }}>
                      {changeMode === "add" && !hasOverride && (
                        <>
                          <span style={{ color:"var(--text-secondary)" }}>Original scope</span>
                          <span style={{ textAlign:"right" }}>${origTotal.toLocaleString()}</span>
                          <span style={{ color:"var(--text-secondary)" }}>Additional scope</span>
                          <span style={{ textAlign:"right" }}>+ ${newScopeTotal.toLocaleString()}</span>
                        </>
                      )}
                      {changeMode === "edit" && !hasOverride && (
                        <>
                          <span style={{ color:"var(--text-secondary)" }}>Line items total</span>
                          <span style={{ textAlign:"right" }}>${newScopeTotal.toLocaleString()}</span>
                        </>
                      )}
                      {hasOverride && (
                        <>
                          <span style={{ color:"var(--text-secondary)" }}>Line items total</span>
                          <span style={{ textAlign:"right", textDecoration:"line-through", color:"var(--text-secondary)" }}>${(changeMode === "add" ? origTotal + newScopeTotal : newScopeTotal).toLocaleString()}</span>
                          <span style={{ color:"var(--warm-gold)", fontWeight:600 }}>Override price</span>
                          <span style={{ textAlign:"right", color:"var(--warm-gold)", fontWeight:600 }}>${Number(changeOverridePrice).toLocaleString()}</span>
                        </>
                      )}
                      <span style={{ fontWeight:700 }}>New Project Total</span>
                      <span style={{ textAlign:"right", fontWeight:700, fontSize:"15px" }}>${projectedTotal.toLocaleString()}</span>

                      <div style={{ gridColumn:"1/-1", borderTop:"1px solid var(--stone-200)", margin:"6px 0" }} />

                      <span style={{ color:"var(--text-secondary)" }}>New Deposit (50%)</span>
                      <span style={{ textAlign:"right" }}>${newDeposit.toLocaleString()}</span>

                      {totalCredit > 0 && (
                        <>
                          <span style={{ color:"var(--accent-green)", fontWeight:600 }}>Prior Deposit Credit</span>
                          <span style={{ textAlign:"right", color:"var(--accent-green)", fontWeight:600 }}>− ${totalCredit.toLocaleString(undefined, {minimumFractionDigits:2})}</span>
                        </>
                      )}

                      <span style={{ fontWeight:700, color:"var(--warm-gold)" }}>Additional Deposit Owed</span>
                      <span style={{ textAlign:"right", fontWeight:700, color:"var(--warm-gold)", fontSize:"15px" }}>${additionalDeposit.toLocaleString(undefined, {minimumFractionDigits:2})}</span>

                      <div style={{ gridColumn:"1/-1", borderTop:"1px solid var(--stone-200)", margin:"6px 0" }} />

                      <span style={{ color:"var(--text-secondary)" }}>Balance on Completion</span>
                      <span style={{ textAlign:"right", fontWeight:600 }}>${balance.toLocaleString()}</span>
                    </div>
                  </div>

                  {/* ── Receipts & Attachments (visible to client) ── */}
                  <div style={{ marginTop:"14px", padding:"12px 14px", background:"rgba(196,149,74,0.04)", border:"1px dashed rgba(196,149,74,0.35)", borderRadius:"var(--radius)" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"8px" }}>
                      <div style={{ display:"flex", alignItems:"center", gap:"6px" }}>
                        <Icon name="upload" size={13} color="var(--warm-gold)" />
                        <span style={{ fontSize:"12px", fontWeight:700, color:"var(--stone-800)" }}>Receipts &amp; Attachments</span>
                        <span style={{ fontSize:"10px", color:"var(--stone-400)", fontWeight:500 }}>· client will see these</span>
                      </div>
                      <span style={{ fontSize:"10px", color:"var(--stone-400)" }}>{changeReceipts.length}/5</span>
                    </div>

                    {changeReceipts.length > 0 && (
                      <div style={{ display:"flex", flexWrap:"wrap", gap:"8px", marginBottom:"8px" }}>
                        {changeReceipts.map((r, ri) => (
                          <div key={ri} style={{ position:"relative", width:86, border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", background:"white", overflow:"hidden" }}>
                            <a href={r.url} target="_blank" rel="noopener noreferrer" style={{ display:"block", textDecoration:"none", color:"inherit" }}>
                              {r.mimeType === 'application/pdf' ? (
                                <div style={{ width:"100%", height:70, background:"var(--stone-100)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:26 }}>📄</div>
                              ) : (
                                <img src={r.url} alt={r.fileName} style={{ width:"100%", height:70, objectFit:"cover", display:"block" }} />
                              )}
                              <div style={{ padding:"4px 6px", fontSize:"9px", color:"var(--stone-600)", lineHeight:1.3, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }} title={r.fileName}>{r.fileName}</div>
                              <div style={{ padding:"0 6px 4px", fontSize:"9px", color:"var(--stone-400)" }}>{fmtFileSize(r.fileSize)}</div>
                            </a>
                            <button onClick={() => deleteReceipt(ri)} title="Remove" style={{ position:"absolute", top:2, right:2, width:18, height:18, borderRadius:"50%", border:"none", background:"rgba(26,23,20,0.7)", color:"white", cursor:"pointer", fontSize:11, display:"flex", alignItems:"center", justifyContent:"center", padding:0 }}>×</button>
                          </div>
                        ))}
                      </div>
                    )}

                    <div style={{ display:"flex", gap:"8px", alignItems:"center", flexWrap:"wrap" }}>
                      <input ref={receiptFileRef} type="file" accept="image/*,application/pdf" capture="environment" multiple onChange={handleReceiptUpload} style={{ display:"none" }} />
                      <button
                        onClick={() => receiptFileRef.current?.click()}
                        disabled={receiptUploading || changeReceipts.length >= 5}
                        style={{
                          fontSize:"12px", padding:"6px 12px", borderRadius:"var(--radius)",
                          border:"1px solid var(--warm-gold)",
                          background: (receiptUploading || changeReceipts.length >= 5) ? "var(--stone-100)" : "white",
                          color:"var(--warm-gold)",
                          cursor: (receiptUploading || changeReceipts.length >= 5) ? "not-allowed" : "pointer",
                          fontWeight:600, display:"flex", alignItems:"center", gap:"6px"
                        }}
                      >
                        <Icon name="plus" size={11} color="var(--warm-gold)" />
                        {receiptUploading ? "Uploading…" : "Add Receipt"}
                      </button>
                      <span style={{ fontSize:"10px", color:"var(--stone-400)" }}>
                        Images or PDFs · max 10MB each · up to 5 files
                      </span>
                    </div>
                  </div>

                  {/* ── Action Buttons ── */}
                  <div style={{ display:"flex", justifyContent:"flex-end", gap:"8px" }}>
                    <button onClick={() => { setChangeOrder(false); setChangeItems([]); setChangeNotes(""); setChangeMode("edit"); setPriorDeposits([]); setChangeOverridePrice(""); setChangeReceipts([]); }} style={{ fontSize:"12px", padding:"8px 14px", borderRadius:"var(--radius)", border:"1px solid var(--stone-200)", background:"white", cursor:"pointer" }}>
                      Cancel
                    </button>
                    <button onClick={() => {
                      const validItems = changeItems.filter(i => i.desc);
                      if (validItems.length === 0) return;

                      const updatedItems = changeMode === "edit" ? validItems : [...estimateModal.items, ...validItems];
                      const validDeposits = priorDeposits.filter(d => Number(d.amount) > 0);

                      const coRecord = {
                        id: `CO-${String((estimateModal.change_orders||[]).length + 1).padStart(3,"0")}`,
                        date: new Date().toISOString().slice(0,10),
                        reason: changeNotes || "Scope change",
                        mode: changeMode,
                        originalItems: [...estimateModal.items],
                        originalTotal: origTotal,
                        newTotal: projectedTotal,
                        overridePrice: hasOverride ? Number(changeOverridePrice) : null,
                        priorDeposits: validDeposits,
                        receipts: changeReceipts,
                        by: "Owner"
                      };

                      const modeLabel = changeMode === "edit" ? "Scope Edited" : "Scope Added";

                      const changeOrders = [...(estimateModal.change_orders||[]), coRecord];
                      const priorDeps = validDeposits.length > 0 ? validDeposits : (estimateModal.prior_deposits || []);

                      setEstimates(p => p.map(e => e.id === estimateModal.id ? {
                        ...e,
                        items: updatedItems,
                        notes: stripCONotes(e.notes),
                        status: "Draft",
                        change_orders: changeOrders,
                        prior_deposits: priorDeps,
                        override_total: hasOverride ? Number(changeOverridePrice) : null
                      } : e));

                      // ── Immediate Supabase persist for change order ──
                      try {
                        const coSaved = { ...estimateModal, items: updatedItems, notes: stripCONotes(estimateModal.notes), status: "Draft", change_orders: changeOrders, prior_deposits: priorDeps, override_total: hasOverride ? Number(changeOverridePrice) : null };
                        supabase.from('estimates').upsert(mapEstimateToRow(coSaved), { onConflict: 'id' }).then(({ error }) => { if (error) console.error('[estimates] CO immediate save failed:', error.message); });
                      } catch (err) { console.error('[estimates] CO save exception:', err.message); }

                      setEstimateModal(prev => ({
                        ...prev,
                        items: updatedItems,
                        notes: stripCONotes(prev.notes),
                        status: "Draft",
                        change_orders: changeOrders,
                        prior_deposits: priorDeps,
                        override_total: hasOverride ? Number(changeOverridePrice) : null
                      }));

                      // ── Sync job value + invoice contractTotal on change order ──
                      const linkedJob = jobs.find(j => j.estimateId === estimateModal.id);
                      if (linkedJob) {
                        const newTotal = projectedTotal;
                        // Update job value to match new estimate total
                        setJobs(p => p.map(j => j.id === linkedJob.id ? { ...j, value: newTotal } : j));
                        // Update linked invoice contractTotal and recalculate pending payment splits
                        setInvoices(p => p.map(inv => {
                          if (inv.jobId !== linkedJob.id && inv.estimate_id !== estimateModal.id) return inv;
                          const paidSoFar = (inv.payments || []).filter(pm => pm.status === "Paid").reduce((s, pm) => s + (pm.amount || 0), 0);
                          const newHalf = Math.round(newTotal / 2);
                          return {
                            ...inv,
                            contractTotal: newTotal,
                            payments: (inv.payments || []).map(pmt => {
                              if (pmt.status === "Paid") return pmt; // preserve already-paid amounts
                              if (pmt.label && pmt.label.includes("Deposit")) return { ...pmt, amount: Math.max(0, newHalf - paidSoFar) };
                              if (pmt.label && pmt.label.includes("Balance")) return { ...pmt, amount: newTotal - newHalf };
                              return pmt;
                            })
                          };
                        }));
                      }

                      if (addNotification) addNotification("estimate", `📝 Change order ${coRecord.id} applied to ${estimateModal.id} — $${origTotal.toLocaleString()} → $${projectedTotal.toLocaleString()} (${modeLabel})${totalCredit > 0 ? ` · $${totalCredit.toFixed(2)} credit` : ""}`, "jobs");

                      setChangeOrder(false); setChangeItems([]); setChangeNotes(""); setChangeMode("edit"); setPriorDeposits([]); setChangeOverridePrice(""); setChangeReceipts([]);
                    }} disabled={changeItems.filter(i => i.desc).length === 0} style={{
                      fontSize:"12px", padding:"8px 16px", borderRadius:"var(--radius)", border:"none",
                      background: changeItems.filter(i => i.desc).length > 0 ? "var(--warm-gold)" : "var(--stone-200)",
                      color: changeItems.filter(i => i.desc).length > 0 ? "white" : "var(--text-secondary)",
                      cursor: changeItems.filter(i => i.desc).length > 0 ? "pointer" : "not-allowed",
                      fontWeight:700, display:"flex", alignItems:"center", gap:"6px"
                    }}>
                      <Icon name="check" size={12} /> Apply Change Order
                    </button>
                  </div>
                </div>
              );
            })()}

            {/* ── Footer buttons ── */}
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:"8px" }}>
              <div style={{ fontSize:"12px", fontWeight:600, transition:"opacity 0.3s", opacity: (crewSent || clientSent) ? 1 : 0, color: clientSent ? "var(--accent-amber)" : "var(--accent-green)" }}>
                {clientSent ? "📧 Estimate queued to send to client" : "✅ Crew brief saved to job notes"}
              </div>
              <div style={{ display:"flex", gap:"8px" }}>
                <button className="btn btn-secondary" onClick={() => { setEstimateModal(null); setCrewView(false); setChangeOrder(false); setChangeItems([]); setChangeNotes(""); setChangeMode("edit"); setPriorDeposits([]); setChangeOverridePrice(""); setChangeReceipts([]); }}>Close</button>
                {!crewView ? (
                  <>
                    <button onClick={() => { setChangeOrder(p => !p); if (!changeOrder) { setChangeItems(JSON.parse(JSON.stringify(estimateModal.items))); setChangeMode("edit"); setPriorDeposits(estimateModal.prior_deposits?.length ? JSON.parse(JSON.stringify(estimateModal.prior_deposits)) : [{ amount:"", date:new Date().toISOString().slice(0,10), method:"Stripe", note:"" }]); setChangeOverridePrice(estimateModal.override_total ? String(estimateModal.override_total) : ""); setChangeReceipts([]); } }} style={{ padding:"8px 14px", borderRadius:"var(--radius)", border:"1px solid var(--warm-gold)", background:"white", color:"var(--warm-gold)", cursor:"pointer", fontWeight:600, fontSize:"13px", display:"flex", alignItems:"center", gap:"6px" }}>
                      <Icon name="edit" size={13} color="var(--warm-gold)" /> Change Order
                    </button>
                    <button onClick={() => {
                      const est = estimateModal;
                      const customerRecord = (customers||[]).find(c => c.name.toLowerCase() === est.customer.toLowerCase());
                      const baseTotal = est.override_total || getTotal(est.items);
                      const surchargeAmt = est.surcharge ? Math.round(baseTotal * 0.03) : 0;
                      const total = baseTotal + surchargeAmt;
                      const deposit = Math.round(total * 0.5);
                      const paidToDate = Math.min(estimatePaidToDate(est, invoices, jobs), total);
                      const estPayload = {
                        id: est.id, customer: est.customer, customerAddress: customerRecord?.address || "", customerEmail: customerRecord?.email || "",
                        project: est.project, date: est.date, status: est.status, notes: stripCONotes(est.notes),
                        items: est.items, surcharge: est.surcharge || false,
                        pricingMode: est.pricingMode || "bundled",
                        hideMatQty: est.hideMatQty || false,
                        total, deposit, surchargeAmt, paidToDate,
      /* change_orders & priorDeposits omitted from URL — not rendered by /api/estimate; they embed full item snapshots + receipts and overflow the URL (URI_TOO_LONG) */
                      };
                      const estimateUrl = `${window.location.origin}/api/estimate?d=${encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(estPayload)))))}`;
                      window.open(estimateUrl, "_blank");
                    }} style={{ padding:"8px 14px", borderRadius:"var(--radius)", border:"1px solid var(--accent-blue)", background:"white", color:"var(--accent-blue)", cursor:"pointer", fontWeight:600, fontSize:"13px", display:"flex", alignItems:"center", gap:"6px" }}>
                      🖥 Client Preview
                    </button>
                    <button onClick={async () => {
                      const est = estimateModal;
                      const customer = (customers||[]).find(c => c.name?.toLowerCase() === est.customer?.toLowerCase());
                      try { await downloadEstimatePDF(est, { customer, paidToDate: estimatePaidToDate(est, invoices, jobs) }); }
                      catch (err) { showToast(`⚠️ Download failed: ${err.message}`); }
                    }} style={{ padding:"8px 14px", borderRadius:"var(--radius)", border:"1px solid var(--stone-400)", background:"white", color:"var(--stone-700)", cursor:"pointer", fontWeight:600, fontSize:"13px", display:"flex", alignItems:"center", gap:"6px" }}>
                      <Icon name="download" size={13}/> Download PDF
                    </button>
                    <button onClick={async () => {
                      const est = estimateModal;
                      const customerRecord = (customers||[]).find(c => c.name.toLowerCase() === est.customer.toLowerCase());
                      const customerEmail = customerRecord?.email;

                      if (!customerEmail) {
                        if (addNotification) addNotification("estimate", `⚠️ No email found for ${est.customer} — add it in Customers first`, "jobs");
                        return;
                      }

                      const baseTotal = est.override_total || getTotal(est.items);
                      const surchargeAmt = est.surcharge ? Math.round(baseTotal * 0.03) : 0;
                      const total = baseTotal + surchargeAmt;
                      const deposit = Math.round(total * 0.5);
                      const paidToDate = Math.min(estimatePaidToDate(est, invoices, jobs), total);
                      const estPayload = {
                        id: est.id, customer: est.customer, customerAddress: customerRecord?.address || "", customerEmail,
                        project: est.project, date: est.date, status: est.status, notes: stripCONotes(est.notes),
                        items: est.items, surcharge: est.surcharge || false,
                        pricingMode: est.pricingMode || "bundled",
                        hideMatQty: est.hideMatQty || false,
                        total, deposit, surchargeAmt, paidToDate,
      /* change_orders & priorDeposits omitted from URL — not rendered by /api/estimate; they embed full item snapshots + receipts and overflow the URL (URI_TOO_LONG) */
                      };
                      const estimateUrl = `${window.location.origin}/api/estimate?d=${encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(estPayload)))))}`;

                      // Actually send the email
                      try {
                        const res = await fetch("/api/send-estimate-email", {
                          method: "POST",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify({
                            to: customerEmail,
                            cc: customerRecord?.cc_email || "",
                            customerName: est.customer,
                            customerAddress: customerRecord?.address || "",
                            estimateId: est.id,
                            project: est.project,
                            total, deposit, estimateUrl,
                            surcharge: est.surcharge || false, surchargeAmt,
                          }),
                        });
                        const data = await res.json();
                        if (!res.ok) throw new Error(data.error || "Failed to send");
                      } catch (err) {
                        if (addNotification) addNotification("estimate", `⚠️ Email failed for ${est.id}: ${err.message}`, "jobs");
                        return;
                      }

                      // Update tracking metadata
                      const now = new Date().toISOString();
                      const resends = est.resend_dates ? [...est.resend_dates, now] : [now];
                      const auditEntry = { action: "resent", date: now, by: "Owner", details: `Resend #${(est.sent_count||1)+1}` };
                      const audit = est.audit_log ? [...est.audit_log, auditEntry] : [auditEntry];
                      setEstimates(p => p.map(e => e.id === est.id ? { ...e, status: "Sent", sent_count: (e.sent_count||1) + 1, last_sent_at: now, resend_dates: resends, audit_log: audit } : e));
                      setEstimateModal(prev => ({ ...prev, status: "Sent", sent_count: (prev.sent_count||1) + 1, last_sent_at: now, resend_dates: resends, audit_log: audit }));
                      // Reset view tracking
                      if (setEstimateViews) setEstimateViews(prev => { const next = {...prev}; delete next[est.id]; return next; });
                      try { fetch('/api/track-estimate', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ estimateId: est.id, event: 'reset' }) }); } catch(e){}
                      setClientSent(true); setTimeout(() => setClientSent(false), 5000);
                      if (addNotification) addNotification("estimate", `📧 ${est.id} sent to ${est.customer} (send #${(est.sent_count||1)+1}) — $${total.toLocaleString()} · view tracking reset`, "jobs");
                    }} style={{ padding:"8px 14px", borderRadius:"var(--radius)", border:"none", background:"var(--accent-green)", color:"white", cursor:"pointer", fontWeight:600, fontSize:"13px", display:"flex", alignItems:"center", gap:"6px" }}>
                      <Icon name="mail" size={13} /> Resend to Client {estimateModal.sent_count > 1 ? `(${estimateModal.sent_count}×)` : ""}
                    </button>
                  </>
                ) : (
                  <button className="btn btn-primary" onClick={sendToCrew} style={{ background:"var(--accent-blue)" }}>
                    <Icon name="hardhat" size={14}/> Send to Crew
                  </button>
                )}
              </div>
            </div>
          </Modal>
        );
      })()}

      {/* ── Photo Gallery Modal ── */}
      {photoModal && (
        <Modal title={`📷 ${photoModal.project} — Progress Photos`} onClose={() => setPhotoModal(null)}>
          <div style={{ marginBottom:"12px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <span style={{ fontSize:"13px", color:"var(--stone-500)" }}>
              👷 {photoModal.crewName || photoModal.crew || "—"} &nbsp;·&nbsp; {photoModal.photos.length} photo{photoModal.photos.length !== 1 ? "s" : ""}
            </span>
            <button className="btn btn-primary btn-sm" onClick={() => triggerUpload(photoModal.id)}>
              <Icon name="upload" size={13}/> Upload Photos
            </button>
          </div>

          {photoModal.photos.length === 0 ? (
            <div className="empty-state" style={{ padding:"40px 0" }}>
              <div style={{ fontSize:40, marginBottom:8 }}>📷</div>
              <div style={{ fontSize:"14px", color:"var(--stone-400)" }}>No photos yet. Click "Upload Photos" to add progress shots.</div>
            </div>
          ) : (
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(130px,1fr))", gap:"10px" }}>
              {photoModal.photos.map((p,i) => {
                const src = p.src || p;
                const name = p.name || `Photo ${i+1}`;
                const date = p.date || '';
                const tag = p.tag || '';
                const tagColor = tag === 'Before' ? '#3b5bdb' : tag === 'After' ? '#1a6b2a' : tag === 'During' ? '#946c00' : tag === 'Substrate' ? '#5a5248' : '#8c7b6e';
                return (
                <div key={i} style={{ position:"relative", borderRadius:10, overflow:"hidden", border: tag === 'After' ? "2px solid #1a6b2a" : tag === 'Before' ? "2px solid #3b5bdb" : "2px solid var(--stone-200)", background:"var(--stone-200)", aspectRatio:"1" }}>
                  <img src={src} alt={name} style={{ width:"100%", height:"100%", objectFit:"cover", cursor:"pointer" }} onClick={() => setLightbox({ src, label:name, date })} />
                  {tag && (
                    <div style={{ position:"absolute", top:4, left:4, background:tagColor, color:"white", fontSize:"9px", fontWeight:700, padding:"2px 6px", borderRadius:4, textTransform:"uppercase", letterSpacing:"0.5px" }}>
                      {tag}
                    </div>
                  )}
                  <div style={{ position:"absolute", bottom:0, left:0, right:0, background:"rgba(26,23,20,0.55)", color:"white", fontSize:"10px", padding:"4px 6px", display:"flex", justifyContent:"space-between" }}>
                    <span style={{ overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:"80%" }}>{name}</span>
                    <span>{date}</span>
                  </div>
                  <button onClick={() => removePhoto(photoModal.id, i)} style={{ position:"absolute", top:4, right:4, background:"rgba(192,97,74,0.85)", border:"none", borderRadius:"50%", width:20, height:20, display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer", color:"white" }}>
                    <Icon name="x" size={10} color="white"/>
                  </button>
                </div>
                );
              })}
              {/* Upload tile */}
              <div onClick={() => triggerUpload(photoModal.id)} style={{ aspectRatio:"1", borderRadius:10, border:"2px dashed var(--stone-300)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", cursor:"pointer", color:"var(--stone-400)", gap:"6px", fontSize:"12px", transition:"all 0.2s" }}
                onMouseEnter={e => { e.currentTarget.style.borderColor="var(--warm-gold)"; e.currentTarget.style.color="var(--warm-gold)"; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor="var(--stone-300)"; e.currentTarget.style.color="var(--stone-400)"; }}
              >
                <Icon name="upload" size={22}/>
                <span>Add Photos</span>
              </div>
            </div>
          )}
          <div style={{ display:"flex", justifyContent:"flex-end", marginTop:"16px" }}>
            <button className="btn btn-secondary" onClick={() => setPhotoModal(null)}>Close</button>
          </div>
        </Modal>
      )}

      {/* ── Lightbox ── */}
      {lightbox && (
        <div className="modal-overlay" onClick={() => setLightbox(null)} style={{ zIndex:2000 }}>
          <div style={{ background:"var(--stone-950)", borderRadius:16, overflow:"hidden", maxWidth:"80vw", maxHeight:"85vh", display:"flex", flexDirection:"column", boxShadow:"0 20px 60px rgba(0,0,0,0.6)" }} onClick={e => e.stopPropagation()}>
            <img src={lightbox.src} alt={lightbox.label} style={{ maxWidth:"80vw", maxHeight:"75vh", objectFit:"contain", display:"block" }}/>
            <div style={{ padding:"12px 18px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div>
                <div style={{ color:"var(--stone-200)", fontSize:"13px", fontWeight:500 }}>{lightbox.label}</div>
                <div style={{ color:"var(--stone-500)", fontSize:"11px" }}>{lightbox.date}</div>
              </div>
              <button className="btn btn-ghost btn-sm" style={{ color:"var(--stone-400)" }} onClick={() => setLightbox(null)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Photo Tag Picker ── */}
      {photoTagModal && (
        <div className="modal-overlay" onClick={() => { setPhotoTagModal(false); setPendingPhotos([]); }} style={{ zIndex:2001 }}>
          <div className="modal-box fade-in" style={{ maxWidth:420 }} onClick={e => e.stopPropagation()}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
              <h2 style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:600 }}>
                Tag {pendingPhotos.length} Photo{pendingPhotos.length !== 1 ? "s" : ""}
              </h2>
              <button className="btn-icon" onClick={() => { setPhotoTagModal(false); setPendingPhotos([]); }}><Icon name="x" size={18} /></button>
            </div>

            {/* Preview thumbnails */}
            <div style={{ display:"flex", gap:6, marginBottom:16, overflowX:"auto", paddingBottom:4 }}>
              {pendingPhotos.slice(0, 6).map((p, i) => (
                <img key={i} src={p.src} alt="" style={{ width:56, height:56, borderRadius:8, objectFit:"cover", border:"2px solid var(--stone-200)" }} />
              ))}
              {pendingPhotos.length > 6 && (
                <div style={{ width:56, height:56, borderRadius:8, background:"var(--stone-200)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, color:"var(--stone-500)", fontWeight:600 }}>+{pendingPhotos.length - 6}</div>
              )}
            </div>

            <div style={{ fontSize:13, color:"var(--stone-500)", marginBottom:12 }}>
              What stage are these photos from?
            </div>

            <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
              {PHOTO_TAGS.map(tag => (
                <button key={tag.id} onClick={() => confirmPhotoTag(tag.id)} style={{
                  display:"flex", alignItems:"center", gap:12, padding:"12px 16px",
                  borderRadius:10, border:"1px solid var(--stone-200)", background:"white",
                  cursor:"pointer", transition:"all 0.15s", textAlign:"left",
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = tag.color; e.currentTarget.style.background = tag.color + '08'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--stone-200)"; e.currentTarget.style.background = "white"; }}
                >
                  <div style={{ width:10, height:10, borderRadius:"50%", background:tag.color, flexShrink:0 }} />
                  <div>
                    <div style={{ fontWeight:600, fontSize:14, color:"var(--stone-800)" }}>{tag.label}</div>
                    <div style={{ fontSize:11, color:"var(--stone-400)" }}>
                      {tag.desc}{tag.id === "After" ? " ✦" : ""}
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ── CALENDAR (v2 — Day/Week/Month with mobile-first agenda) ──────────────────
const CalendarView = ({ events, setEvents, jobs, requestDelete }) => {
  const today = new Date();
  const todayStr = today.toISOString().slice(0,10);
  const [year, setYear] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth());
  const [selectedDate, setSelectedDate] = useState(todayStr);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ title:"", date:"", time:"", type:"lead", address:"", brief:"" });

  // Auto-detect mobile and default to day view
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" ? window.innerWidth < 768 : false);
  const [calView, setCalView] = useState(isMobile ? "day" : "month"); // day | week | month

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  const dayNamesShort = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

  // ── Helpers ──
  const getDateStr = (y, m, d) => `${y}-${String(m+1).padStart(2,"0")}-${String(d).padStart(2,"0")}`;
  const getDateStrFromDate = (dt) => dt.toISOString().slice(0,10);
  const parseDateStr = (s) => { const [y,mo,d] = s.split("-").map(Number); return new Date(y, mo-1, d); };
  const getDayEventsForDate = (dateStr) => events.filter(e => e.date === dateStr);
  const eventColor = (type) => type === "job" ? "var(--accent-green)" : type === "follow-up" ? "var(--accent-blue)" : "var(--warm-gold)";
  const eventLabel = (type) => type === "job" ? "Job" : type === "follow-up" ? "Follow-up" : "Lead / Estimate";

  // ── Navigation ──
  const goToToday = () => { setYear(today.getFullYear()); setMonth(today.getMonth()); setSelectedDate(todayStr); if (isMobile) setCalView("day"); };
  const prevDay = () => { const d = parseDateStr(selectedDate); d.setDate(d.getDate() - 1); setSelectedDate(getDateStrFromDate(d)); setYear(d.getFullYear()); setMonth(d.getMonth()); };
  const nextDay = () => { const d = parseDateStr(selectedDate); d.setDate(d.getDate() + 1); setSelectedDate(getDateStrFromDate(d)); setYear(d.getFullYear()); setMonth(d.getMonth()); };

  // Week
  const getWeekStart = (dateStr) => { const d = parseDateStr(dateStr); d.setDate(d.getDate() - d.getDay()); return d; };
  const [weekStart, setWeekStart] = useState(getWeekStart(todayStr));
  useEffect(() => { setWeekStart(getWeekStart(selectedDate)); }, [selectedDate]);
  const prevWeek = () => { const d = new Date(weekStart); d.setDate(d.getDate() - 7); setWeekStart(d); setSelectedDate(getDateStrFromDate(d)); setYear(d.getFullYear()); setMonth(d.getMonth()); };
  const nextWeek = () => { const d = new Date(weekStart); d.setDate(d.getDate() + 7); setWeekStart(d); setSelectedDate(getDateStrFromDate(d)); setYear(d.getFullYear()); setMonth(d.getMonth()); };
  const weekDays = []; for (let i = 0; i < 7; i++) { const d = new Date(weekStart); d.setDate(d.getDate() + i); weekDays.push(d); }
  const weekLabel = (() => { const s = weekDays[0]; const e = weekDays[6]; const sm = s.toLocaleDateString("en-US",{month:"short"}); const em = e.toLocaleDateString("en-US",{month:"short"}); return sm === em ? `${sm} ${s.getDate()} – ${e.getDate()}, ${s.getFullYear()}` : `${sm} ${s.getDate()} – ${em} ${e.getDate()}, ${s.getFullYear()}`; })();

  // Month
  const prevMonth = () => { if (month === 0) { setMonth(11); setYear(y=>y-1); } else setMonth(m=>m-1); };
  const nextMonth = () => { if (month === 11) { setMonth(0); setYear(y=>y+1); } else setMonth(m=>m+1); };
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const cells = [];
  const prevDaysCount = new Date(year, month, 0).getDate();
  for (let i = firstDay - 1; i >= 0; i--) cells.push({ day: prevDaysCount - i, thisMonth: false });
  for (let i = 1; i <= daysInMonth; i++) cells.push({ day: i, thisMonth: true });
  while (cells.length % 7 !== 0) cells.push({ day: cells.length - daysInMonth - firstDay + 1, thisMonth: false });

  const save = () => { if (modal === "add") setEvents(p => [...p, { ...form, id: Date.now() }]); else setEvents(p => p.map(e => e.id === modal.id ? { ...form, id: e.id } : e)); setModal(null); };
  const openAddEvent = (dateStr) => { setForm({ title:"", date: dateStr, time:"9:00 AM", type:"lead", address:"", brief:"" }); setModal("add"); };
  const openEventDetail = (ev) => { setForm({ title:ev.title, date:ev.date, time:ev.time||"", type:ev.type, crew:ev.crew||"", address:ev.address||"", customer:ev.customer||"", brief:ev.brief||"", jobId:ev.jobId||null, jobTag:ev.jobTag||null }); setModal(ev); };

  // Sort events by time
  const sortByTime = (evs) => [...evs].sort((a, b) => {
    const aAllDay = a.type === "job" && a.crew; const bAllDay = b.type === "job" && b.crew;
    if (aAllDay && !bAllDay) return -1; if (!aAllDay && bAllDay) return 1;
    const parseT = (t, orig) => { if (!t) return 0; const clean = (t || "").replace(/[^0-9:]/g, ""); const [h, m] = clean.split(":").map(Number); const isPM = (orig||"").toLowerCase().includes("pm"); const isAM = (orig||"").toLowerCase().includes("am"); let hrs = h||0; if (isPM && hrs < 12) hrs += 12; if (isAM && hrs === 12) hrs = 0; return hrs * 60 + (m||0); };
    return parseT(a.time, a.time) - parseT(b.time, b.time);
  });

  // ── Agenda event card ──
  const AgendaEventCard = ({ ev, compact }) => {
    const color = eventColor(ev.type);
    const isAllDay = ev.type === "job" && ev.crew;
    return (
      <div onClick={() => openEventDetail(ev)} style={{
        display:"flex", gap: compact ? 10 : 14, padding: compact ? "8px 10px" : "14px 16px",
        background:"var(--stone-50)", borderRadius:"var(--radius)", border:"1px solid var(--stone-200)",
        cursor:"pointer", borderLeft:`4px solid ${color}`, transition:"all 0.15s", marginBottom: compact ? 4 : 8,
      }}
        onMouseEnter={e => { e.currentTarget.style.boxShadow = "var(--shadow-md)"; e.currentTarget.style.transform = "translateY(-1px)"; }}
        onMouseLeave={e => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "none"; }}
      >
        <div style={{ minWidth: compact ? 52 : 64, flexShrink:0, paddingTop:2 }}>
          {isAllDay ? <div style={{ fontSize: compact ? 10 : 11, fontWeight:700, color, textTransform:"uppercase", letterSpacing:"0.04em" }}>All Day</div>
            : ev.time ? <div style={{ fontSize: compact ? 13 : 15, fontWeight:700, color:"var(--stone-800)", lineHeight:1.2 }}>{ev.time}</div>
            : <div style={{ fontSize: compact ? 10 : 11, color:"var(--stone-400)", fontStyle:"italic" }}>No time</div>}
        </div>
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom: compact ? 2 : 4, flexWrap:"wrap" }}>
            <span style={{ fontSize: compact ? 12 : 14, fontWeight:700, color:"var(--stone-800)" }}>{ev.title}</span>
            <span style={{ fontSize:9, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", background:`${color}18`, color, padding:"2px 7px", borderRadius:4 }}>{eventLabel(ev.type)}</span>
            {ev.multiDay && <span style={{ fontSize:9, fontWeight:700, color:"var(--stone-400)", background:"var(--stone-100)", padding:"2px 6px", borderRadius:4 }}>Day {ev.dayNum}/{ev.totalDays}</span>}
          </div>
          {!compact && <div style={{ display:"flex", flexWrap:"wrap", gap:"6px 14px", fontSize:12, color:"var(--stone-500)" }}>
            {ev.customer && <span>👤 {ev.customer}</span>}
            {ev.crew && <span>👷 {ev.crew}</span>}
            {ev.address && <span style={{ maxWidth:220, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>📍 {ev.address}</span>}
          </div>}
          {compact && ev.customer && <div style={{ fontSize:11, color:"var(--stone-500)" }}>👤 {ev.customer}{ev.crew ? ` · 👷 ${ev.crew.split(",")[0].trim().split(" ")[0]}` : ""}</div>}
        </div>
      </div>
    );
  };

  return (
    <div className="fade-in" style={{ minHeight: "calc(100vh - 120px)" }}>
      {/* Header */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16, flexWrap:"wrap", gap:12 }}>
        <div>
          <h1 className="section-title">Calendar</h1>
          <p className="section-sub">{monthNames[month]} {year} — {calView === "day" ? "Day" : calView === "week" ? "Week" : "Month"} View</p>
        </div>
        <button className="btn btn-primary" onClick={() => openAddEvent(selectedDate)}><Icon name="plus" size={14} /> Add Event</button>
      </div>

      {/* View toggle + Today */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16, flexWrap:"wrap", gap:10 }}>
        <div style={{ display:"flex", gap:4, background:"var(--stone-200)", borderRadius:"var(--radius)", padding:3 }}>
          {["day","week","month"].map(v => (
            <button key={v} onClick={() => setCalView(v)} style={{
              padding:"7px 14px", borderRadius:6, border:"none", cursor:"pointer", fontSize:13, fontWeight:600,
              background: calView === v ? "white" : "transparent", color: calView === v ? "var(--stone-900)" : "var(--stone-500)",
              boxShadow: calView === v ? "0 1px 4px rgba(0,0,0,0.1)" : "none", transition:"all 0.15s",
            }}>{v === "day" ? "📋 Day" : v === "week" ? "📅 Week" : "🗓️ Month"}</button>
          ))}
        </div>
        <button className="btn btn-ghost" onClick={goToToday} style={{
          fontSize:12, fontWeight:700, padding:"6px 14px",
          color: selectedDate === todayStr ? "var(--warm-gold)" : "var(--stone-600)",
          border:`1.5px solid ${selectedDate === todayStr ? "var(--warm-gold)" : "var(--stone-300)"}`, borderRadius:"var(--radius)",
        }}>● Today</button>
      </div>

      {/* ═══ DAY VIEW ═══ */}
      {calView === "day" && (() => {
        const dayEvents = sortByTime(getDayEventsForDate(selectedDate));
        const selDate = parseDateStr(selectedDate);
        const isToday = selectedDate === todayStr;
        return (
          <div>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:12, marginBottom:20 }}>
              <button className="btn btn-ghost" onClick={prevDay} style={{ fontSize:20, padding:"4px 12px" }}>‹</button>
              <div style={{ textAlign:"center", minWidth:220 }}>
                <div style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, color: isToday ? "var(--warm-gold)" : "var(--stone-800)" }}>
                  {isToday && <span style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.08em", background:"var(--warm-gold)", color:"white", padding:"2px 8px", borderRadius:4, marginRight:8, verticalAlign:"middle" }}>Today</span>}
                  {selDate.toLocaleDateString("en-US", { weekday:"short", month:"short", day:"numeric" })}
                </div>
              </div>
              <button className="btn btn-ghost" onClick={nextDay} style={{ fontSize:20, padding:"4px 12px" }}>›</button>
            </div>
            {/* Mini week strip */}
            <div style={{ display:"flex", justifyContent:"center", gap:4, marginBottom:20 }}>
              {(() => {
                const d = parseDateStr(selectedDate); const sow = new Date(d); sow.setDate(d.getDate() - d.getDay());
                return Array.from({length:7}, (_, i) => {
                  const wd = new Date(sow); wd.setDate(sow.getDate() + i);
                  const ds = getDateStrFromDate(wd); const hasEv = getDayEventsForDate(ds).length > 0;
                  const isSel = ds === selectedDate; const isTod = ds === todayStr;
                  return (
                    <button key={i} onClick={() => setSelectedDate(ds)} style={{
                      display:"flex", flexDirection:"column", alignItems:"center", gap:3,
                      padding:"8px 8px 6px", borderRadius:10, border:"none", cursor:"pointer",
                      background: isSel ? "var(--stone-800)" : "transparent", minWidth:44, transition:"all 0.15s",
                    }}>
                      <span style={{ fontSize:10, fontWeight:600, color: isSel ? "var(--stone-300)" : "var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.04em" }}>{dayNamesShort[wd.getDay()]}</span>
                      <span style={{ fontSize:16, fontWeight: isSel || isTod ? 800 : 500, color: isSel ? "white" : isTod ? "var(--warm-gold)" : "var(--stone-700)" }}>{wd.getDate()}</span>
                      <span style={{ width:5, height:5, borderRadius:"50%", background: hasEv ? (isSel ? "var(--warm-gold)" : "var(--accent-green)") : "transparent" }} />
                    </button>
                  );
                });
              })()}
            </div>
            {dayEvents.length === 0 ? (
              <div style={{ textAlign:"center", padding:"48px 20px" }}>
                <div style={{ fontSize:40, marginBottom:12, opacity:0.3 }}>📅</div>
                <div style={{ fontSize:15, fontWeight:600, color:"var(--stone-400)", marginBottom:8 }}>Nothing scheduled</div>
                <button className="btn btn-primary" onClick={() => openAddEvent(selectedDate)} style={{ fontSize:13 }}><Icon name="plus" size={13} /> Add Event</button>
              </div>
            ) : (
              <div>
                <div style={{ fontSize:11, fontWeight:600, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:10 }}>{dayEvents.length} event{dayEvents.length !== 1 ? "s" : ""}</div>
                {dayEvents.map(ev => <AgendaEventCard key={ev.id} ev={ev} compact={false} />)}
              </div>
            )}
          </div>
        );
      })()}

      {/* ═══ WEEK VIEW ═══ */}
      {calView === "week" && (() => {
        return (
          <div>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:12, marginBottom:20 }}>
              <button className="btn btn-ghost" onClick={prevWeek} style={{ fontSize:20, padding:"4px 12px" }}>‹</button>
              <h2 style={{ fontFamily:"var(--font-display)", fontSize: isMobile ? 16 : 20, fontWeight:600, textAlign:"center", minWidth: isMobile ? 180 : 260 }}>{weekLabel}</h2>
              <button className="btn btn-ghost" onClick={nextWeek} style={{ fontSize:20, padding:"4px 12px" }}>›</button>
            </div>
            {isMobile ? (
              /* Mobile: stacked day cards */
              <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                {weekDays.map((wd, i) => {
                  const ds = getDateStrFromDate(wd); const dayEvts = sortByTime(getDayEventsForDate(ds)); const isTod = ds === todayStr;
                  return (
                    <div key={i} style={{ background: isTod ? "rgba(201,169,110,0.06)" : "var(--stone-50)", border:`1px solid ${isTod ? "var(--warm-gold)" : "var(--stone-200)"}`, borderRadius:"var(--radius-lg)", padding:"12px 14px" }}>
                      <div onClick={() => { setSelectedDate(ds); setCalView("day"); }} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom: dayEvts.length > 0 ? 10 : 0, cursor:"pointer" }}>
                        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                          <span style={{ fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, color: isTod ? "var(--warm-gold)" : "var(--stone-800)" }}>{wd.getDate()}</span>
                          <span style={{ fontSize:13, fontWeight:600, color:"var(--stone-500)" }}>{dayNamesShort[wd.getDay()]}</span>
                          {isTod && <span style={{ fontSize:9, fontWeight:700, background:"var(--warm-gold)", color:"white", padding:"2px 7px", borderRadius:4, textTransform:"uppercase", letterSpacing:"0.04em" }}>Today</span>}
                        </div>
                        <span style={{ fontSize:12, color:"var(--stone-400)" }}>{dayEvts.length > 0 ? `${dayEvts.length} event${dayEvts.length>1?"s":""}` : "—"}</span>
                      </div>
                      {dayEvts.map(ev => <AgendaEventCard key={ev.id} ev={ev} compact={true} />)}
                    </div>
                  );
                })}
              </div>
            ) : (
              /* Desktop: grid columns */
              <div className="card" style={{ padding:0, overflow:"hidden" }}>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", background:"var(--stone-800)" }}>
                  {weekDays.map((wd, i) => {
                    const isTod = getDateStrFromDate(wd) === todayStr;
                    return (
                      <div key={i} style={{ padding:"10px 8px", textAlign:"center", background: isTod ? "rgba(201,169,110,0.15)" : "transparent" }}>
                        <div style={{ fontSize:11, fontWeight:600, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.06em" }}>{dayNamesShort[wd.getDay()]}</div>
                        <div style={{ fontSize:18, fontWeight: isTod ? 800 : 600, color: isTod ? "var(--warm-gold)" : "var(--stone-200)", marginTop:2 }}>
                          {wd.getDate()}{isTod && <span style={{ display:"inline-block", width:6, height:6, borderRadius:"50%", background:"var(--warm-gold)", marginLeft:4, verticalAlign:"super" }} />}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", minHeight:300 }}>
                  {weekDays.map((wd, i) => {
                    const ds = getDateStrFromDate(wd); const dayEvts = sortByTime(getDayEventsForDate(ds)); const isTod = ds === todayStr;
                    return (
                      <div key={i} onClick={() => { setSelectedDate(ds); setCalView("day"); }}
                        style={{ borderRight: i < 6 ? "1px solid var(--stone-200)" : "none", padding:6, cursor:"pointer", minHeight:120, background: isTod ? "rgba(201,169,110,0.04)" : "transparent", transition:"background 0.15s" }}
                        onMouseEnter={e => { e.currentTarget.style.background = "var(--stone-100)"; }}
                        onMouseLeave={e => { e.currentTarget.style.background = isTod ? "rgba(201,169,110,0.04)" : "transparent"; }}
                      >
                        {dayEvts.map(ev => {
                          const color = eventColor(ev.type); const isAllDay = ev.type === "job" && ev.crew;
                          return (
                            <div key={ev.id} onClick={(e) => { e.stopPropagation(); openEventDetail(ev); }}
                              style={{ background: color, color:"white", borderRadius:4, padding:"3px 6px", fontSize:11, marginBottom:3, cursor:"pointer", overflow:"hidden" }}>
                              <div style={{ fontWeight:700, fontSize:9, textTransform:"uppercase", letterSpacing:"0.03em", opacity:0.85, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                                {isAllDay ? "All Day" : ev.time || ""} · {eventLabel(ev.type)}
                              </div>
                              <div style={{ whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", fontWeight:600, fontSize:11 }}>{ev.customer || ev.title}</div>
                              {ev.crew && <div style={{ fontSize:9, opacity:0.8, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{ev.crew}</div>}
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        );
      })()}

      {/* ═══ MONTH VIEW ═══ */}
      {calView === "month" && (() => {
        return (
          <div>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:16, marginBottom:20 }}>
              <button className="btn btn-ghost" onClick={prevMonth}>‹</button>
              <h2 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:600, minWidth:200, textAlign:"center" }}>{monthNames[month]} {year}</h2>
              <button className="btn btn-ghost" onClick={nextMonth}>›</button>
            </div>
            <div className="card" style={{ padding:0, overflow:"hidden" }}>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", background:"var(--stone-800)" }}>
                {dayNamesShort.map(d => (
                  <div key={d} style={{ padding:"10px", textAlign:"center", fontSize:"11px", fontWeight:600, color:"var(--stone-300)", letterSpacing:"0.06em", textTransform:"uppercase" }}>{d}</div>
                ))}
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)" }}>
                {cells.map((cell, i) => {
                  const cellDateStr = cell.thisMonth ? getDateStr(year, month, cell.day) : null;
                  const isToday = cell.thisMonth && cell.day === today.getDate() && month === today.getMonth() && year === today.getFullYear();
                  const dayEvents = cell.thisMonth ? getDayEventsForDate(cellDateStr) : [];
                  return (
                    <div key={i}
                      className={`cal-day${isToday ? " today" : ""}${!cell.thisMonth ? " other-month" : ""}`}
                      onClick={() => { if (!cell.thisMonth) return; setSelectedDate(cellDateStr); setCalView("day"); }}
                      style={{ cursor: cell.thisMonth ? "pointer" : "default" }}
                    >
                      <div style={{ fontWeight: isToday ? 700 : 400, fontSize:"13px", color: isToday ? "var(--warm-gold)" : "inherit" }}>{cell.day}</div>
                      {dayEvents.map(ev => (
                        <div key={ev.id}
                          className={`cal-event${ev.type === "job" ? " job" : ev.type === "follow-up" ? " follow-up" : ""}`}
                          title={[ev.title, ev.crew ? `👷 ${ev.crew}` : '', ev.address ? `📍 ${ev.address}` : '', ev.brief || ''].filter(Boolean).join('\n')}
                          onClick={(e) => { e.stopPropagation(); openEventDetail(ev); }}
                          style={{ cursor:"pointer" }}
                        >
                          {ev.type === "job" && ev.crew && <span style={{ fontSize:"9px", fontWeight:800, textTransform:"uppercase", letterSpacing:"0.04em", opacity:0.7 }}>👷 {ev.crew.split(",")[0].trim().split(" ")[0]} </span>}
                          {ev.multiDay && <span style={{ fontSize:"9px", fontWeight:700, opacity:0.7 }}>D{ev.dayNum}/{ev.totalDays} </span>}
                          {ev.time && !ev.crew && <span style={{ opacity:0.85 }}>{ev.time} · </span>}
                          {ev.title}
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })()}

      {/* Legend */}
      <div style={{ marginTop:20, display:"flex", gap:16, flexWrap:"wrap", justifyContent:"center" }}>
        {[["var(--warm-gold)","Lead / Estimate"],["var(--accent-green)","Job"],["var(--accent-blue)","Follow-up"]].map(([c,l]) => (
          <div key={l} style={{ display:"flex", alignItems:"center", gap:6, fontSize:12 }}>
            <div style={{ width:10, height:10, borderRadius:"50%", background:c }} />{l}
          </div>
        ))}
      </div>

      {/* ═══ MODAL ═══ */}
      {modal && (
        <Modal title={modal === "add" ? "Add Event" : modal.type === "job" ? "Job Details" : "Edit Event"} onClose={() => setModal(null)}>
          {modal !== "add" && modal.type === "job" && modal.jobId ? (
            <div>
              <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius)", padding:"16px 18px", marginBottom:16 }}>
                <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, marginBottom:8 }}>{modal.title}</div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px", fontSize:"13px" }}>
                  {modal.customer && <div><span style={{ color:"var(--stone-400)", fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.04em" }}>Client</span><div style={{ fontWeight:600 }}>{modal.customer}</div></div>}
                  {modal.crew && <div><span style={{ color:"var(--stone-400)", fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.04em" }}>Crew / Tech</span><div style={{ fontWeight:600 }}>👷 {modal.crew}</div></div>}
                  {modal.address && <div style={{ gridColumn:"1/-1" }}><span style={{ color:"var(--stone-400)", fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.04em" }}>Location</span><div style={{ fontWeight:600 }}>📍 {modal.address}</div></div>}
                  <div><span style={{ color:"var(--stone-400)", fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.04em" }}>Date</span><div style={{ fontWeight:600 }}>{modal.date}</div></div>
                  {modal.time && <div><span style={{ color:"var(--stone-400)", fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.04em" }}>Start Time</span><div style={{ fontWeight:600 }}>{modal.time}</div></div>}
                  {modal.totalDays > 1 && <div><span style={{ color:"var(--stone-400)", fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.04em" }}>Duration</span><div style={{ fontWeight:600 }}>Day {modal.dayNum} of {modal.totalDays}</div></div>}
                </div>
              </div>
              {modal.brief && (
                <div style={{ borderLeft:"3px solid var(--warm-gold)", background:"rgba(201,169,110,0.06)", borderRadius:"0 var(--radius) var(--radius) 0", padding:"12px 16px", marginBottom:16 }}>
                  <div style={{ fontSize:"10px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--stone-400)", marginBottom:4 }}>Job Notes</div>
                  <div style={{ fontSize:"13px", color:"var(--stone-700)", lineHeight:1.6 }}>{modal.brief}</div>
                </div>
              )}
              <div style={{ display:"flex", justifyContent:"space-between", flexWrap:"wrap", gap:8 }}>
                <div style={{ display:"flex", gap:6 }}>
                  <button className="btn btn-secondary" style={{ color:"var(--accent-red)", borderColor:"var(--accent-red)", fontSize:12 }} onClick={() => { requestDelete("events", modal); setModal(null); }}>Delete This Day</button>
                  {modal.totalDays > 1 && (
                    <button className="btn btn-secondary" style={{ color:"var(--accent-red)", borderColor:"var(--accent-red)", fontSize:12 }} onClick={() => { setEvents(p => p.map(e => e.jobTag === modal.jobTag ? { ...e, deletedAt: Date.now() } : e)); setModal(null); }}>Delete All {modal.totalDays} Days</button>
                  )}
                </div>
                <button className="btn btn-secondary" onClick={() => setModal(null)}>Close</button>
              </div>
            </div>
          ) : (
          <>
          <div className="form-grid">
            <div className="form-group form-full"><label>Event Title</label><input value={form.title} onChange={e => setForm(p => ({...p,title:e.target.value}))} placeholder="e.g. Quote walkthrough — Sandra Kim" /></div>
            <div className="form-group"><label>Date</label><input type="date" value={form.date} onChange={e => setForm(p => ({...p,date:e.target.value}))} /></div>
            <div className="form-group"><label>Time</label><input value={form.time} onChange={e => setForm(p => ({...p,time:e.target.value}))} placeholder="e.g. 10:00 AM" /></div>
            <div className="form-group form-full"><label>Type</label>
              <select value={form.type} onChange={e => setForm(p => ({...p,type:e.target.value}))}>
                <option value="lead">Lead / Estimate</option>
                <option value="job">Job</option>
                <option value="follow-up">Follow-up</option>
              </select>
            </div>
            <div className="form-group form-full"><label>Address / Location</label><input value={form.address||""} onChange={e => setForm(p => ({...p,address:e.target.value}))} placeholder="e.g. 1234 Shore Dr, Virginia Beach, VA 23451" /></div>
            <div className="form-group form-full"><label>Notes</label><textarea rows={3} value={form.brief||""} onChange={e => setForm(p => ({...p,brief:e.target.value}))} placeholder="Quote details, access instructions, material notes…" /></div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "8px" }}>
            {modal !== "add" && (
              <button className="btn btn-secondary" style={{ color:"var(--accent-red)", borderColor:"var(--accent-red)" }} onClick={() => { requestDelete("events", modal); setModal(null); }}>Delete</button>
            )}
            <div style={{ display:"flex", gap:8, marginLeft:"auto" }}>
              <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancel</button>
              <button className="btn btn-primary" onClick={save}><Icon name="check" size={14} /> Save</button>
            </div>
          </div>
          </>
          )}
        </Modal>
      )}
    </div>
  );
};

// ── ESTIMATES ─────────────────────────────────────────────────────────────────
// ── STRIPE CHECKOUT FORM (inner — runs inside Elements context) ───────────────
const StripeCheckoutForm = ({ amount, label, onSuccess, onCancel }) => {
  const stripe   = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    setLoading(true); setError(null);
    const { error: submitErr } = await elements.submit();
    if (submitErr) { setError(submitErr.message); setLoading(false); return; }
    const { error: confirmErr, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: { return_url: window.location.href },
      redirect: "if_required",
    });
    if (confirmErr) { setError(confirmErr.message); setLoading(false); }
    else if (paymentIntent?.status === "succeeded") { setSuccess(true); setTimeout(() => onSuccess(paymentIntent), 1500); }
  };

  if (success) return (
    <div style={{ textAlign:"center", padding:"32px 0" }}>
      <div style={{ fontSize:48, marginBottom:12 }}>✅</div>
      <div style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:"var(--accent-green)", marginBottom:6 }}>Payment Confirmed!</div>
      <div style={{ fontSize:13, color:"var(--stone-500)" }}>${amount.toLocaleString()} received · updating your records…</div>
    </div>
  );

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ background:"var(--stone-900)", borderRadius:"var(--radius)", padding:"14px 18px", marginBottom:20, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <span style={{ fontSize:12, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.07em", color:"rgba(255,255,255,0.55)" }}>{label}</span>
        <span style={{ fontFamily:"var(--font-display)", fontSize:26, fontWeight:700, color:"var(--warm-gold)" }}>${amount.toLocaleString()}</span>
      </div>
      <div style={{ marginBottom:16 }}>
        <PaymentElement options={{ layout:"tabs", paymentMethodOrder:["card","apple_pay","google_pay"], wallets:{ applePay:"auto", googlePay:"auto" }, business:{ name:"Timeless Tile Pro LLC" } }} />
      </div>
      {error && (
        <div style={{ background:"rgba(185,74,74,0.08)", border:"1px solid rgba(185,74,74,0.25)", borderRadius:"var(--radius)", padding:"10px 14px", marginBottom:14, fontSize:13, color:"#b94a4a" }}>
          ⚠️ {error}
        </div>
      )}
      <div style={{ display:"flex", gap:8, justifyContent:"flex-end", marginTop:8 }}>
        <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={loading}>Cancel</button>
        <button type="submit" className="btn btn-primary" disabled={!stripe || loading} style={{ background:"var(--accent-green)", minWidth:140 }}>
          {loading
            ? <span style={{ display:"flex", alignItems:"center", gap:8 }}>
                <span style={{ width:14, height:14, border:"2px solid rgba(255,255,255,0.3)", borderTopColor:"white", borderRadius:"50%", animation:"spin 0.7s linear infinite", display:"inline-block" }}/>
                Processing…
              </span>
            : `Pay $${amount.toLocaleString()}`}
        </button>
      </div>
      <div style={{ textAlign:"center", marginTop:12, fontSize:11, color:"var(--stone-400)", display:"flex", alignItems:"center", justifyContent:"center", gap:5 }}>
        🔒 Secured by Stripe · Your card info never touches our servers
      </div>
    </form>
  );
};

// ── STRIPE PAYMENT MODAL (outer — fetches PaymentIntent, wraps Elements) ──────
const stripeAppearance = {
  theme: "stripe",
  variables: { colorPrimary:"#c9a96e", colorBackground:"#ffffff", colorText:"#2c2820", colorDanger:"#b94a4a", fontFamily:"'DM Sans', sans-serif", borderRadius:"8px", fontSizeBase:"14px" },
  rules: {
    ".Input": { border:"1.5px solid #e8e4dc", boxShadow:"none" },
    ".Input:focus": { border:"1.5px solid #c9a96e", boxShadow:"0 0 0 3px rgba(201,169,110,0.15)" },
    ".Label": { fontSize:"11px", fontWeight:"700", textTransform:"uppercase", letterSpacing:"0.06em", color:"#a09880" },
    ".Tab": { border:"1.5px solid #e8e4dc" },
    ".Tab--selected": { border:"1.5px solid #c9a96e", color:"#c9a96e" },
  },
};

const StripePaymentModal = ({ amount, label, metadata, onSuccess, onClose }) => {
  const [clientSecret,  setClientSecret]  = useState(null);
  const [fetchError,    setFetchError]    = useState(null);
  const [loadingIntent, setLoadingIntent] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res  = await fetch("/api/create-payment-intent", { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({ amount, metadata }) });
        const data = await res.json();
        if (data.error) throw new Error(data.error);
        setClientSecret(data.clientSecret);
      } catch (err) { setFetchError(err.message); }
      finally { setLoadingIntent(false); }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box fade-in" style={{ maxWidth:480 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
          <div>
            <h2 style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:600 }}>Secure Payment</h2>
            <div style={{ fontSize:12, color:"var(--stone-500)", marginTop:2 }}>{metadata?.estimateId} · {metadata?.customer}</div>
          </div>
          <button className="btn-icon" onClick={onClose}><Icon name="x" size={18}/></button>
        </div>
        {loadingIntent && (
          <div style={{ textAlign:"center", padding:"40px 0" }}>
            <div style={{ width:32, height:32, border:"3px solid var(--stone-200)", borderTopColor:"var(--warm-gold)", borderRadius:"50%", animation:"spin 0.7s linear infinite", margin:"0 auto 12px" }}/>
            <div style={{ fontSize:13, color:"var(--stone-400)" }}>Preparing secure checkout…</div>
          </div>
        )}
        {fetchError && (
          <div style={{ textAlign:"center", padding:"24px 0" }}>
            <div style={{ fontSize:13, color:"#b94a4a", marginBottom:16 }}>⚠️ {fetchError}</div>
            <div style={{ fontSize:12, color:"var(--stone-400)", marginBottom:16 }}>Make sure your Stripe keys are set in Vercel environment variables.</div>
            <button className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>
        )}
        {clientSecret && (
          <Elements stripe={stripePromise} options={{ clientSecret, appearance: stripeAppearance }}>
            <StripeCheckoutForm amount={amount} label={label} onSuccess={pi => { onSuccess(pi); onClose(); }} onCancel={onClose} />
          </Elements>
        )}
      </div>
    </div>
  );
};

// ── ESTIMATES ─────────────────────────────────────────────────────────────────
const Estimates = ({ estimates, setEstimates, customers, setCustomers, jobs, setJobs, invoices, setPage, addNotification, requestDelete, estimateViews, setEstimateViews, scopeTemplates, setScopeTemplates }) => {
  const [modal, setModal] = useState(null);
  const [viewing, setViewing] = useState(null);
  const [toast, setToast] = useState(null);
  const [form, setForm] = useState({ customer:"", project:"", date:"", status:"Draft", notes:"", pricingMode:"bundled", hideMatQty:false, items:[{ desc:"", laborDesc:"", qty:1, unit:"sqft", price:0, clientSupplied:false, clientSuppliedNote:"", materials:[] }] });
  const [sendingEmail, setSendingEmail] = useState(false);
  const [emailStatus, setEmailStatus] = useState(null);
  const [estSearch, setEstSearch] = useState("");
  const [estStatusFilter, setEstStatusFilter] = useState("All");
  const [estSort, setEstSort] = useState("newest"); // newest | oldest | highest | lowest

  // ── Scope Template Panel State ──
  const [tplPanel, setTplPanel] = useState(false);
  const [tplTab, setTplTab] = useState("templates"); // templates | past | save
  const [tplCatFilter, setTplCatFilter] = useState("All");
  const [tplSearch, setTplSearch] = useState("");
  const [tplPastSearch, setTplPastSearch] = useState("");
  const [tplExpanded, setTplExpanded] = useState(null);
  const [tplPastExpanded, setTplPastExpanded] = useState(null);
  const [tplSelected, setTplSelected] = useState({});
  const [tplSaveName, setTplSaveName] = useState("");
  const [tplSaveCat, setTplSaveCat] = useState("Bathroom");
  const TPL_CATEGORIES = ["All","Bathroom","Kitchen","Outdoor","Flooring","Custom"];

  const getScopeTotal = items => items.reduce((s,i) => s + (Number(i.qty) * Number(i.price)), 0);
  const getMaterialsTotal = items => items.reduce((s,i) => s + (i.materials||[]).reduce((ms,m) => ms + (Number(m.qty) * Number(m.price)), 0), 0);
  const getTotal = items => getScopeTotal(items) + getMaterialsTotal(items);

  // ── Guard against duplicate save calls ──
  const saveGuard = useRef(false);

  // ── Download estimate as PDF ──
  const [downloadingId, setDownloadingId] = useState(null);
  const handleDownload = async (est) => {
    if (downloadingId) return;
    setDownloadingId(est.id);
    try {
      const customer = customers.find(c => c.name?.toLowerCase() === est.customer?.toLowerCase());
      await downloadEstimatePDF(est, { customer, paidToDate: estimatePaidToDate(est, invoices, jobs) });
    } catch (err) {
      showToast(`⚠️ Download failed: ${err.message}`);
    } finally {
      setDownloadingId(null);
    }
  };

  const showToast = (message, actionLabel, onAction) => {
    setToast({ message, actionLabel, onAction });
    setTimeout(() => setToast(null), 6000);
  };

  const convertToJob = async (est) => {
    const newJob = {
      id: Date.now(),
      customer: est.customer,
      project: est.project,
      status: "Scheduled",
      startDate: new Date().toISOString().slice(0,10),
      endDate: "",
      value: est.override_total || getTotal(est.items),
      cost: 0,
      address: "",
      notes: est.notes || "",
      crew: "",
      estimateId: est.id,
      photos: []
    };
    setJobs(p => [...p, newJob]);
    setEstimates(p => p.map(e => e.id === est.id ? { ...e, status: "Approved" } : e));

    // Auto-create customer if not already exists
    const alreadyCustomer = (customers||[]).some(c => c.name.toLowerCase() === est.customer.toLowerCase());
    if (!alreadyCustomer && setCustomers) {
      setCustomers(p => [...p, {
        id: Date.now() + 1,
        name: est.customer,
        email: "", phone: "", address: "",
        notes: `Auto-created from ${est.id} on ${new Date().toISOString().slice(0,10)}`,
        totalJobs: 0, totalRevenue: 0,
        since: new Date().toISOString().slice(0,7),
      }]);
    }

    // ═══ AUTO-SEED PROJECT BUDGET FROM ESTIMATE ═══
    try {
      const estimateTotal = est.override_total || getTotal(est.items);

      // Phase icon auto-assignment based on scope item description
      const phaseIcon = (desc) => {
        const d = (desc || "").toLowerCase();
        if (/demo|demolition|tear/.test(d)) return "🔨";
        if (/subfloor|prep|level/.test(d)) return "📐";
        if (/waterproof|membrane|kerdi/.test(d)) return "🛡️";
        if (/tile|porcelain|mosaic|stone|marble/.test(d)) return "🏛️";
        if (/fixture|plumbing|faucet|shower/.test(d)) return "🚿";
        if (/cabinet|counter|vanity/.test(d)) return "🗄️";
        if (/electric|lighting/.test(d)) return "💡";
        if (/labor|install/.test(d)) return "👷";
        if (/glass|mirror/.test(d)) return "🪟";
        if (/paint|finish/.test(d)) return "🎨";
        return "📦";
      };

      // Map each estimate scope item → budget phase
      const phases = (est.items || []).map((item, scopeIdx) => {
        const hasMaterials = (item.materials || []).length > 0;

        // Nested materials become budget line items
        const lineItems = (item.materials || []).map((mat, matIdx) => ({
          id: Date.now() + scopeIdx * 100 + matIdx + 10,
          catalogId: null,
          name: mat.desc || "Unnamed material",
          cat: "Other",
          unit: mat.unit || "ea",
          budgetQty: Number(mat.qty) || 0,
          budgetPrice: Number(mat.price) || 0,
          actualQty: 0,
          actualPrice: 0,
          supplier: "",
          invId: null,
          receiptRef: null,
          purchaseDate: null,
          reimb: false,
          source: "estimate",
          crewFlagId: null,
          estimateItemIndex: `${scopeIdx}-${matIdx}`,
        }));

        // Scope item's own value (qty × price) = labor budget for this phase
        const scopeValue = Number(item.qty || 0) * Number(item.price || 0);

        return {
          name: item.desc || `Phase ${scopeIdx + 1}`,
          icon: phaseIcon(item.desc),
          wbs: String(scopeIdx + 1),
          collapsed: false,
          laborBudget: hasMaterials ? 0 : scopeValue,
          laborActual: 0,
          items: lineItems,
        };
      });

      // Build the project budget row for Supabase
      const budgetId = Date.now() + 999;
      const budgetRow = {
        id: budgetId,
        name: est.project || "Untitled",
        customer: est.customer || "",
        location: "",
        type: "custom",
        labor_type: "flat",
        labor_rate: 0,
        labor_hours: 0,
        labor_flat: 0,
        original_quote: estimateTotal,
        change_order: 0,
        phases: phases,
        job_id: newJob.id,
        estimate_id: est.id,
        seeded_from_estimate: true,
        status: "active",
        budget_status: "active",
      };

      const { error } = await supabase
        .from("project_budgets")
        .upsert(budgetRow, { onConflict: "id" });

      if (error) {
        console.error("[AutoSeed] Failed to seed project budget:", error.message);
      } else {
        console.log(`[AutoSeed] Budget seeded for ${est.project} (${est.id}) → budget id ${budgetId}`);
        if (addNotification) {
          addNotification("budget", `📋 Project budget auto-created for ${est.project} from ${est.id}`, "budgets");
        }
      }
    } catch (err) {
      console.error("[AutoSeed] Exception during budget seeding:", err);
    }

    if (addNotification) addNotification("job", `🔨 Job created from ${est.id} · ${est.project} for ${est.customer}`, "jobs");
    showToast(`Job created from ${est.id} for ${est.customer}`, "View Jobs", () => { setPage("jobs"); setToast(null); });
  };

  const nextEstId = (list) => {
    const arr = list || estimates;
    return `EST-${String(Math.max(0, ...arr.map(e => parseInt(e.id?.replace('EST-',''))||0)) + 1).padStart(3,"0")}`;
  };

  const save = async () => {
    if (saveGuard.current) return; // Block re-entry
    saveGuard.current = true;
    setTimeout(() => { saveGuard.current = false; }, 1000);

    let saved;
    if (modal === "add") {
      const newId = nextEstId();
      saved = { ...form, id: newId };
      setEstimates(p => {
        if (p.some(e => e.id === newId)) return p;
        return [...p, saved];
      });
    } else {
      saved = { ...form, id: modal.id };
      setEstimates(p => p.map(e => e.id === modal.id ? saved : e));
    }
    setModal(null);

    // ── Immediate Supabase persist (don't rely on debounced background sync) ──
    try {
      const { error } = await supabase.from('estimates').upsert(mapEstimateToRow(saved), { onConflict: 'id' });
      if (error) console.error('[estimates] Immediate save failed:', error.message);
    } catch (err) { console.error('[estimates] Immediate save exception:', err.message); }
  };

  const saveAndSend = async () => {
    if (saveGuard.current) return; // Block re-entry
    saveGuard.current = true;
    setTimeout(() => { saveGuard.current = false; }, 2000);

    // First save the estimate
    let saved;
    if (modal === "add") {
      const newId = nextEstId();
      saved = { ...form, id: newId, status:"Sent" };
      setEstimates(p => {
        if (p.some(e => e.id === newId)) return p;
        return [...p, saved];
      });
    } else {
      saved = { ...form, id: modal.id, status:"Sent" };
      setEstimates(p => p.map(e => e.id === modal.id ? saved : e));
    }
    setModal(null);

    // ── Immediate Supabase persist (don't rely on debounced background sync) ──
    try {
      const { error } = await supabase.from('estimates').upsert(mapEstimateToRow(saved), { onConflict: 'id' });
      if (error) console.error('[estimates] Immediate save failed:', error.message);
    } catch (err) { console.error('[estimates] Immediate save exception:', err.message); }

    // Look up customer email
    const customerRecord = customers.find(c => c.name.toLowerCase() === saved.customer.toLowerCase());
    const customerEmail  = customerRecord?.email;

    if (!customerEmail) {
      showToast(`⚠️ No email found for ${saved.customer} — add it in Customers first`, null, null);
      return;
    }

    // Build the estimate URL — opens the client preview page
    const baseTotal     = saved.override_total || getTotal(saved.items);
    const surchargeAmt  = saved.surcharge ? Math.round(baseTotal * 0.03) : 0;
    const total         = baseTotal + surchargeAmt;
    const deposit       = Math.round(total * 0.5);
    const paidToDate = Math.min(estimatePaidToDate(saved, invoices, jobs), total);
    const estPayload = {
      id: saved.id, customer: saved.customer, customerAddress: customerRecord?.address || "", customerEmail: customerRecord?.email || "",
      project: saved.project,
      date: saved.date, status: saved.status, notes: stripCONotes(saved.notes),
      items: saved.items, surcharge: saved.surcharge || false,
      pricingMode: saved.pricingMode || "bundled",
      hideMatQty: saved.hideMatQty || false,
      total, deposit, surchargeAmt, paidToDate,
      /* change_orders & priorDeposits omitted from URL — not rendered by /api/estimate; they embed full item snapshots + receipts and overflow the URL (URI_TOO_LONG) */
    };
    const estimateUrl = `${window.location.origin}/api/estimate?d=${encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(estPayload)))))}`;

    // Send via Resend
    setSendingEmail(true);
    try {
      const res = await fetch("/api/send-estimate-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          to:           customerEmail,
          cc:           customerRecord?.cc_email || "",
          customerName: saved.customer,
          customerAddress: customerRecord?.address || "",
          estimateId:   saved.id,
          project:      saved.project,
          total,
          deposit,
          estimateUrl,
          surcharge:    saved.surcharge || false,
          surchargeAmt,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to send");

      // ── Reset view tracking so resent estimate shows as "Awaiting" ──
      if (setEstimateViews) setEstimateViews(prev => { const next = {...prev}; delete next[saved.id]; return next; });
      try { fetch('/api/track-estimate', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ estimateId: saved.id, event: 'reset' }) }); } catch(e){}

      // Update resend metadata
      const now = new Date().toISOString();
      const resends = saved.resend_dates ? [...saved.resend_dates, now] : [now];
      const auditEntry = { action: "resent", date: now, by: "Owner", details: `Resend #${(saved.sent_count||1)+1}` };
      const audit = saved.audit_log ? [...saved.audit_log, auditEntry] : [auditEntry];
      const updatedMeta = { sent_count: (saved.sent_count||1) + 1, last_sent_at: now, resend_dates: resends, audit_log: audit };
      setEstimates(p => p.map(e => e.id === saved.id ? { ...e, ...updatedMeta } : e));
      try { await supabase.from('estimates').update(updatedMeta).eq('id', saved.id); } catch(e){}

      if (addNotification) addNotification("estimate", `📧 ${saved.id} sent to ${saved.customer} · ${saved.project} · view tracking reset`, "estimates");
      showToast(`📧 Estimate emailed to ${customerEmail}`, "View Estimates", () => setToast(null));
    } catch (err) {
      showToast(`⚠️ Email failed: ${err.message}`, null, null);
    } finally {
      setSendingEmail(false);
    }
  };

  // Send from viewing modal (already saved estimate)
  const sendFromViewing = async (est) => {
    const customerRecord = customers.find(c => c.name.toLowerCase() === est.customer.toLowerCase());
    const customerEmail  = customerRecord?.email;

    if (!customerEmail) {
      showToast(`⚠️ No email found for ${est.customer} — add it in Customers first`, null, null);
      return;
    }

    const baseTotal    = est.override_total || getTotal(est.items);
    const surchargeAmt = est.surcharge ? Math.round(baseTotal * 0.03) : 0;
    const total        = baseTotal + surchargeAmt;
    const deposit      = Math.round(total * 0.5);
    const paidToDate = Math.min(estimatePaidToDate(est, invoices, jobs), total);
    const estPayload = {
      id: est.id, customer: est.customer, customerAddress: customerRecord?.address || "", customerEmail: customerRecord?.email || "",
      project: est.project,
      date: est.date, status: est.status, notes: stripCONotes(est.notes),
      items: est.items, surcharge: est.surcharge || false,
      pricingMode: est.pricingMode || "bundled",
      hideMatQty: est.hideMatQty || false,
      total, deposit, surchargeAmt, paidToDate,
      /* change_orders & priorDeposits omitted from URL — not rendered by /api/estimate; they embed full item snapshots + receipts and overflow the URL (URI_TOO_LONG) */
    };
    const estimateUrl = `${window.location.origin}/api/estimate?d=${encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(estPayload)))))}`;

    setEmailStatus(null);
    setSendingEmail(true);
    try {
      const res = await fetch("/api/send-estimate-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          to: customerEmail, cc: customerRecord?.cc_email || "", customerName: est.customer, customerAddress: customerRecord?.address || "",
          estimateId: est.id,
          project: est.project, total, deposit, estimateUrl,
          surcharge: est.surcharge || false, surchargeAmt,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to send");

      // Update estimate status to Sent + resend metadata
      const now = new Date().toISOString();
      const resends = est.resend_dates ? [...est.resend_dates, now] : [now];
      const auditEntry = { action: "resent", date: now, by: "Owner", details: `Resend #${(est.sent_count||1)+1}` };
      const audit = est.audit_log ? [...est.audit_log, auditEntry] : [auditEntry];
      const updatedMeta = { status:"Sent", sent_count: (est.sent_count||1) + 1, last_sent_at: now, resend_dates: resends, audit_log: audit };
      setEstimates(p => p.map(e => e.id === est.id ? {...e, ...updatedMeta} : e));
      setViewing(v => ({...v, ...updatedMeta}));

      // ── Immediate Supabase persist for resend metadata ──
      try { await supabase.from('estimates').update(updatedMeta).eq('id', est.id); } catch(e){}

      // ── Reset view tracking so resent estimate shows as "Awaiting" ──
      if (setEstimateViews) setEstimateViews(prev => { const next = {...prev}; delete next[est.id]; return next; });
      try { fetch('/api/track-estimate', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ estimateId: est.id, event: 'reset' }) }); } catch(e){}

      setEmailStatus("sent");
      if (addNotification) addNotification("estimate", `📧 ${est.id} sent to ${est.customer} · ${est.project} · view tracking reset`, "estimates");
    } catch (err) {
      setEmailStatus("error:" + err.message);
    } finally {
      setSendingEmail(false);
    }
  };

  const addItem = () => setForm(p => ({ ...p, items: [...p.items, { desc:"", laborDesc:"", qty:1, unit:"sqft", price:0, clientSupplied:false, clientSuppliedNote:"", materials:[] }] }));
  const updateItem = (i, k, v) => setForm(p => ({ ...p, items: p.items.map((it,idx) => idx===i ? {...it,[k]:v} : it) }));
  const removeItem = (i) => setForm(p => ({ ...p, items: p.items.filter((_,idx) => idx!==i) }));
  const addMaterial = (itemIdx) => setForm(p => ({ ...p, items: p.items.map((it,idx) => idx===itemIdx ? {...it, materials:[...(it.materials||[]), { desc:"", qty:1, unit:"ea", price:0, clientSupplied:false }]} : it) }));
  const updateMaterial = (itemIdx, matIdx, k, v) => setForm(p => ({ ...p, items: p.items.map((it,idx) => idx===itemIdx ? {...it, materials:(it.materials||[]).map((m,mi) => mi===matIdx ? {...m,[k]:v} : m)} : it) }));
  const removeMaterial = (itemIdx, matIdx) => setForm(p => ({ ...p, items: p.items.map((it,idx) => idx===itemIdx ? {...it, materials:(it.materials||[]).filter((_,mi) => mi!==matIdx)} : it) }));

  // ── Scope Template Helpers ──
  const openTplPanel = (tab) => { setTplPanel(true); setTplTab(tab || "templates"); setTplSelected({}); setTplExpanded(null); setTplPastExpanded(null); setTplSearch(""); setTplPastSearch(""); };
  const loadFullTemplate = (tpl) => {
    const deep = JSON.parse(JSON.stringify(tpl.items));
    const hasContent = form.items.some(it => it.desc.trim());
    if (hasContent) setForm(p => ({ ...p, items: [...p.items.filter(it => it.desc.trim()), ...deep] }));
    else setForm(p => ({ ...p, items: deep }));
    showToast(hasContent ? `Added ${deep.length} items from "${tpl.name}"` : `Loaded "${tpl.name}" — ${deep.length} items`);
    setTplPanel(false);
  };
  const loadSelectedItems = (sourceItems, sourceName) => {
    const selIdx = Object.entries(tplSelected).filter(([_,v]) => v).map(([k]) => parseInt(k));
    if (selIdx.length === 0) return;
    const deep = JSON.parse(JSON.stringify(selIdx.map(i => sourceItems[i])));
    const hasContent = form.items.some(it => it.desc.trim());
    if (hasContent) setForm(p => ({ ...p, items: [...p.items.filter(it => it.desc.trim()), ...deep] }));
    else setForm(p => ({ ...p, items: deep }));
    showToast(`Added ${deep.length} item${deep.length > 1 ? "s" : ""} from ${sourceName}`);
    setTplSelected({}); setTplPanel(false);
  };
  const saveAsTemplate = () => {
    if (!tplSaveName.trim()) return;
    const validItems = form.items.filter(it => it.desc.trim());
    if (validItems.length === 0) return;
    const newTpl = { id: `tpl-${Date.now()}`, name: tplSaveName.trim(), category: tplSaveCat, items: JSON.parse(JSON.stringify(validItems)), created_at: new Date().toISOString() };
    setScopeTemplates(p => [newTpl, ...p]);
    showToast(`Template "${tplSaveName}" saved with ${validItems.length} items`);
    setTplSaveName(""); setTplTab("templates");
  };
  const deleteTpl = (id) => { setScopeTemplates(p => p.filter(t => t.id !== id)); showToast("Template deleted"); };
  const filteredTpls = (scopeTemplates||[]).filter(t => {
    if (tplCatFilter !== "All" && t.category !== tplCatFilter) return false;
    if (tplSearch && !t.name.toLowerCase().includes(tplSearch.toLowerCase()) && !(t.category||"").toLowerCase().includes(tplSearch.toLowerCase())) return false;
    return true;
  });
  const filteredPastEsts = estimates.filter(e => {
    if (!tplPastSearch) return true;
    const s = tplPastSearch.toLowerCase();
    return (e.customer||"").toLowerCase().includes(s) || (e.project||"").toLowerCase().includes(s) || (e.id||"").toLowerCase().includes(s);
  });

  return (
    <div className="fade-in" style={{ minHeight: "calc(100vh - 120px)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "20px", flexWrap: "wrap", gap: "12px" }}>
        <div><h1 className="section-title">Estimate Builder</h1><p className="section-sub">Create and send professional estimates.</p></div>
        <button className="btn btn-primary" onClick={() => { setForm({ customer:"", project:"", date:new Date().toISOString().slice(0,10), status:"Draft", notes:"", pricingMode:"bundled", items:[{ desc:"", laborDesc:"", qty:1, unit:"sqft", price:0, clientSupplied:false, clientSuppliedNote:"", materials:[] }], surcharge:false, hideMatQty:false }); setModal("add"); }}><Icon name="plus" size={14} /> New Estimate</button>
      </div>

      {/* ── Estimate Filters ── */}
      <div style={{ display:"flex", gap:"10px", marginBottom:"16px", flexWrap:"wrap", alignItems:"center" }}>
        <div style={{ position:"relative", flex:1, minWidth:"200px" }}>
          <span style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)" }}><Icon name="search" size={14} color="var(--stone-400)"/></span>
          <input style={{ paddingLeft:"34px" }} placeholder="Search by customer, project, ID…" value={estSearch} onChange={e => setEstSearch(e.target.value)} />
        </div>
        <div style={{ display:"flex", gap:"4px", background:"var(--stone-200)", borderRadius:"var(--radius)", padding:"3px" }}>
          {["All","Draft","Sent","Approved"].map(s => (
            <button key={s} className="btn btn-sm" style={{ background: estStatusFilter===s?"white":"transparent", color: estStatusFilter===s?"var(--stone-900)":"var(--stone-500)", boxShadow: estStatusFilter===s?"var(--shadow-sm)":"none", border:"none" }} onClick={() => setEstStatusFilter(s)}>{s}</button>
          ))}
        </div>
        <select value={estSort} onChange={e => setEstSort(e.target.value)} style={{ padding:"6px 12px", border:"1.5px solid var(--stone-300)", borderRadius:"var(--radius)", fontSize:"12px", color:"var(--stone-600)" }}>
          <option value="newest">Newest First</option>
          <option value="oldest">Oldest First</option>
          <option value="highest">Highest $</option>
          <option value="lowest">Lowest $</option>
        </select>
      </div>
      <div className="card" style={{ padding: 0 }}>
        <table>
          <thead><tr><th>Estimate #</th><th>Customer</th><th>Project</th><th>Date</th><th>Total</th><th>Status</th><th>Client Activity</th><th>Actions</th></tr></thead>
          <tbody>
            {estimates
              .filter(e => (estStatusFilter === "All" || e.status === estStatusFilter) && (
                !estSearch || e.customer?.toLowerCase().includes(estSearch.toLowerCase()) ||
                e.project?.toLowerCase().includes(estSearch.toLowerCase()) ||
                e.id?.toLowerCase().includes(estSearch.toLowerCase())
              ))
              .sort((a,b) => {
                if (estSort === "newest") return (b.date||"").localeCompare(a.date||"");
                if (estSort === "oldest") return (a.date||"").localeCompare(b.date||"");
                if (estSort === "highest") return getTotal(b.items) - getTotal(a.items);
                return getTotal(a.items) - getTotal(b.items);
              })
              .map(e => {
              const view = (estimateViews||{})[e.id];
              const sentDaysAgo = Math.floor((Date.now() - new Date(e.last_sent_at || e.date).getTime()) / (24*60*60*1000));
              return (
              <tr key={e.id}>
                <td style={{ fontWeight: 600, color: "var(--warm-gold)" }}>{e.id}</td>
                <td>{e.customer}</td>
                <td>{e.project}</td>
                <td className="text-muted">{e.date}</td>
                <td style={{ fontWeight: 600 }}>${getTotal(e.items).toLocaleString()}</td>
                <td><span className={`badge badge-${e.status.toLowerCase()}`}>{e.status}</span></td>
                <td>
                  {e.status === "Draft" ? (
                    <span style={{ fontSize:"11px", color:"var(--stone-400)" }}>—</span>
                  ) : view?.accepted_at ? (
                    <div style={{ display:"flex", alignItems:"center", gap:5 }}>
                      <span style={{ width:7, height:7, borderRadius:"50%", background:"var(--accent-green)", flexShrink:0 }}/>
                      <span style={{ fontSize:"11px", fontWeight:600, color:"var(--accent-green)" }}>Accepted</span>
                    </div>
                  ) : view?.viewed_at ? (
                    <div>
                      <div style={{ display:"flex", alignItems:"center", gap:5 }}>
                        <span style={{ width:7, height:7, borderRadius:"50%", background:"var(--accent-blue)", flexShrink:0 }}/>
                        <span style={{ fontSize:"11px", fontWeight:600, color:"var(--accent-blue)" }}>Viewed</span>
                      </div>
                      <div style={{ fontSize:"10px", color:"var(--stone-400)", marginTop:1 }}>{view.view_count > 1 ? `${view.view_count}× · ` : ""}Last {new Date(view.last_viewed_at||view.viewed_at).toLocaleDateString("en-US",{month:"short",day:"numeric"})}</div>
                    </div>
                  ) : e.status === "Sent" ? (
                    <div>
                      <div style={{ display:"flex", alignItems:"center", gap:5 }}>
                        <span style={{ width:7, height:7, borderRadius:"50%", background: sentDaysAgo >= 3 ? "var(--accent-red)" : "var(--accent-amber)", flexShrink:0 }}/>
                        <span style={{ fontSize:"11px", fontWeight:600, color: sentDaysAgo >= 3 ? "var(--accent-red)" : "var(--accent-amber)" }}>{sentDaysAgo >= 3 ? "Not Viewed" : "Awaiting"}</span>
                      </div>
                      <div style={{ fontSize:"10px", color:"var(--stone-400)", marginTop:1 }}>
                        {(e.sent_count||1) > 1 && <span style={{ color:"var(--accent-amber)", fontWeight:600 }}>Sent {e.sent_count}× · </span>}
                        {sentDaysAgo >= 3 && <span style={{ color:"var(--accent-red)" }}>{sentDaysAgo}d ago · Follow up</span>}
                        {sentDaysAgo < 3 && (e.sent_count||1) <= 1 && <span>Sent {sentDaysAgo === 0 ? "today" : `${sentDaysAgo}d ago`}</span>}
                      </div>
                    </div>
                  ) : (
                    <span style={{ fontSize:"11px", color:"var(--stone-400)" }}>—</span>
                  )}
                </td>
                <td>
                  <div style={{ display: "flex", gap: "4px", flexWrap:"wrap" }}>
                    <button className="btn-icon" title="View" onClick={() => setViewing(e)}><Icon name="eye" size={14} /></button>
                    <button className="btn-icon" title="Download PDF" disabled={downloadingId === e.id} onClick={() => handleDownload(e)}><Icon name="download" size={14} color="var(--accent-blue)" /></button>
                    <button className="btn-icon" title="Edit" onClick={() => { setForm({ ...e }); setModal(e); }}><Icon name="edit" size={14} /></button>
                    <button className="btn-icon" title="Delete" onClick={() => requestDelete("estimates", e)}><Icon name="trash" size={14} color="var(--accent-red)" /></button>
                    <button title="Convert to Job" onClick={() => convertToJob(e)} style={{ background:"var(--accent-blue)", color:"white", border:"none", borderRadius:"var(--radius)", padding:"4px 8px", fontSize:"11px", cursor:"pointer", fontWeight:600, whiteSpace:"nowrap" }}>→ Job</button>
                  </div>
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* ── Add / Edit Modal ── */}
      {modal && (
        <Modal title={modal === "add" ? "New Estimate" : `Edit ${modal.id}`} onClose={() => setModal(null)}>
          <div className="form-grid">
            <div className="form-group">
              <label>Customer</label>
              <select value={form.customer} onChange={e => setForm(p => ({...p, customer: e.target.value}))}>
                <option value="">Select customer</option>
                {customers.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Project Name</label>
              <input value={form.project} onChange={e => setForm(p => ({...p, project: e.target.value}))} placeholder="e.g. Master Bath Remodel" />
            </div>
            <div className="form-group">
              <label>Date</label>
              <input type="date" value={form.date} onChange={e => setForm(p => ({...p, date: e.target.value}))} />
            </div>
            <div className="form-group">
              <label>Status</label>
              <select value={form.status} onChange={e => setForm(p => ({...p, status: e.target.value}))}>
                {["Draft","Sent","Approved","Declined"].map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
          </div>

          {/* Pricing Display Toggle */}
          <div style={{ display:"flex", alignItems:"center", gap:"12px", padding:"10px 14px", marginBottom:"16px", background:"rgba(201,169,110,0.06)", border:"1px solid rgba(201,169,110,0.2)", borderRadius:"var(--radius)", flexWrap:"wrap" }}>
            <div style={{ fontSize:"12px", fontWeight:600, color:"var(--stone-600)" }}>Client Pricing:</div>
            <div style={{ display:"flex", borderRadius:6, overflow:"hidden", border:"1px solid var(--stone-300)" }}>
              {["bundled","itemized"].map(v => (
                <button key={v} onClick={() => setForm(p => ({...p, pricingMode:v}))}
                  style={{ padding:"5px 14px", fontSize:"11px", fontWeight:600, fontFamily:"var(--font-body)", border:"none", cursor:"pointer",
                    background:form.pricingMode===v?"var(--stone-800)":"white", color:form.pricingMode===v?"var(--warm-gold)":"var(--stone-600)",
                    textTransform:"capitalize", transition:"all 0.2s" }}>
                  {v === "bundled" ? "✓ Bundled" : "$ Itemized"}
                </button>
              ))}
            </div>
            <div style={{ fontSize:"11px", color:"var(--stone-400)" }}>
              {form.pricingMode === "itemized" ? "Client sees line prices" : "Client sees \"✓ Included\""}
            </div>
          </div>

          {/* Line Items with Nested Materials */}
          <div style={{ marginBottom: "16px" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"10px" }}>
              <label style={{ fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--stone-500)" }}>Scope / Line Items</label>
              <div style={{ display:"flex", gap:"6px" }}>
                <button onClick={() => openTplPanel("templates")} style={{ display:"flex", alignItems:"center", gap:"5px", padding:"5px 12px", borderRadius:"var(--radius)", border:"1.5px solid rgba(201,169,110,0.4)", background:"rgba(201,169,110,0.06)", cursor:"pointer", fontSize:"12px", fontWeight:600, color:"var(--warm-gold)", fontFamily:"var(--font-body)", transition:"all 0.15s" }}
                  onMouseEnter={e => { e.currentTarget.style.background="rgba(201,169,110,0.15)"; e.currentTarget.style.borderColor="var(--warm-gold)"; }}
                  onMouseLeave={e => { e.currentTarget.style.background="rgba(201,169,110,0.06)"; e.currentTarget.style.borderColor="rgba(201,169,110,0.4)"; }}
                >📋 Templates</button>
                <button className="btn btn-ghost btn-sm" onClick={addItem}><Icon name="plus" size={12} /> Add Scope Item</button>
              </div>
            </div>
            {/* Header row */}
            <div style={{ display:"grid", gridTemplateColumns:"3fr 70px 70px 90px 90px 28px", gap:"6px", marginBottom:"6px" }}>
              {["Description / Scope","Qty","Unit","Unit Price","Total",""].map((h,i) => (
                <div key={i} style={{ fontSize:"10px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--stone-400)", padding:"0 2px" }}>{h}</div>
              ))}
            </div>
            {form.items.map((it, i) => (
              <div key={i} style={{ marginBottom:"12px" }}>
                {/* Scope item row */}
                <div style={{ display:"grid", gridTemplateColumns:"3fr 70px 70px 90px 90px 28px", gap:"6px", alignItems:"center" }}>
                  <input placeholder="Description" value={it.desc} onChange={e => updateItem(i,"desc",e.target.value)}
                    style={{ padding:"8px 10px", border:"1.5px solid var(--stone-300)", borderRadius:"var(--radius)", fontSize:"13px", fontWeight:600, fontFamily:"var(--font-body)" }} />
                  <input type="number" placeholder="Qty" value={it.qty} onChange={e => updateItem(i,"qty",e.target.value)}
                    style={{ padding:"7px 9px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"12px", fontFamily:"var(--font-body)", textAlign:"right" }} />
                  <select value={it.unit} onChange={e => updateItem(i,"unit",e.target.value)}
                    style={{ padding:"7px 6px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"12px", fontFamily:"var(--font-body)" }}>
                    {["sqft","lnft","job","ea","hr"].map(u => <option key={u}>{u}</option>)}
                  </select>
                  <input type="number" placeholder="0.00" value={it.price} onChange={e => updateItem(i,"price",e.target.value)}
                    style={{ padding:"7px 9px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"12px", fontFamily:"var(--font-body)", textAlign:"right" }} />
                  <div style={{ padding:"7px 9px", background:"var(--stone-50)", border:"1px solid var(--stone-100)", borderRadius:"var(--radius)", fontSize:"12px", fontWeight:600, textAlign:"right", color:"var(--stone-700)" }}>
                    ${(Number(it.qty) * Number(it.price)).toLocaleString()}
                  </div>
                  <button className="btn-icon" onClick={() => removeItem(i)} title="Remove">
                    <Icon name="x" size={12} color="var(--accent-red)" />
                  </button>
                </div>
                {/* Labor description */}
                <textarea placeholder="Labor description — detail the scope of work for this item…" value={it.laborDesc||""} onChange={e => updateItem(i,"laborDesc",e.target.value)}
                  rows={2}
                  style={{ width:"100%", marginTop:"4px", padding:"6px 10px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"11px", fontFamily:"var(--font-body)", color:"var(--stone-600)", resize:"vertical", lineHeight:1.5, background:"var(--stone-50)" }} />
                {/* Client-supplied flag for this scope */}
                <div style={{ display:"flex", alignItems:"center", gap:8, marginTop:4, paddingLeft:2, flexWrap:"wrap" }}>
                  <label style={{ display:"inline-flex", alignItems:"center", gap:5, fontSize:"11px", color:"var(--stone-600)", cursor:"pointer", fontFamily:"var(--font-body)" }}>
                    <input type="checkbox" checked={!!it.clientSupplied} onChange={e => updateItem(i,"clientSupplied",e.target.checked)}
                      style={{ width:13, height:13, accentColor:"#c9a96e", cursor:"pointer" }} />
                    Client supplies material for this scope
                  </label>
                  {it.clientSupplied && (
                    <input placeholder="What is client supplying? (e.g. tile, fixtures)" value={it.clientSuppliedNote||""}
                      onChange={e => updateItem(i,"clientSuppliedNote",e.target.value)}
                      style={{ flex:"1 1 220px", minWidth:180, padding:"4px 8px", border:"1px solid rgba(201,149,74,0.35)", borderRadius:5, fontSize:"11px", fontFamily:"var(--font-body)", background:"rgba(201,149,74,0.06)", color:"#8a5a1a" }} />
                  )}
                </div>
                {/* Nested materials for this scope item */}
                <div style={{ marginLeft:"18px", marginTop:"4px", paddingLeft:"14px", borderLeft:"2px solid var(--sand-300)" }}>
                  {(it.materials||[]).length > 0 && (
                    <div style={{ fontSize:"10px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.04em", color:"var(--warm-gold)", marginBottom:"4px", marginTop:"2px" }}>Materials</div>
                  )}
                  {(it.materials||[]).map((m, mi) => (
                    <div key={mi} style={{ marginBottom:"5px" }}>
                      <div style={{ display:"grid", gridTemplateColumns:"3fr 60px 60px 80px 80px 24px", gap:"5px", alignItems:"center" }}>
                        <input placeholder="Material name" value={m.desc} onChange={e => updateMaterial(i,mi,"desc",e.target.value)}
                          style={{ padding:"6px 8px", border:"1px solid var(--sand-200)", borderRadius:6, fontSize:"11px", fontFamily:"var(--font-body)", background:"#fffdf8" }} />
                        <input type="number" placeholder="Qty" value={m.qty} onChange={e => updateMaterial(i,mi,"qty",e.target.value)}
                          style={{ padding:"6px 7px", border:"1px solid var(--sand-200)", borderRadius:6, fontSize:"11px", fontFamily:"var(--font-body)", textAlign:"right", background:"#fffdf8" }} />
                        <select value={m.unit} onChange={e => updateMaterial(i,mi,"unit",e.target.value)}
                          style={{ padding:"6px 5px", border:"1px solid var(--sand-200)", borderRadius:6, fontSize:"11px", fontFamily:"var(--font-body)", background:"#fffdf8" }}>
                          {["ea","sqft","lnft","job","hr","box","bag"].map(u => <option key={u}>{u}</option>)}
                        </select>
                        <input type="number" placeholder="0.00" value={m.price} onChange={e => updateMaterial(i,mi,"price",e.target.value)}
                          style={{ padding:"6px 7px", border:"1px solid var(--sand-200)", borderRadius:6, fontSize:"11px", fontFamily:"var(--font-body)", textAlign:"right", background:"#fffdf8" }} />
                        <div style={{ padding:"6px 7px", background:"#fffdf8", border:"1px solid var(--stone-100)", borderRadius:6, fontSize:"11px", fontWeight:600, textAlign:"right", color:"var(--stone-600)" }}>
                          ${(Number(m.qty) * Number(m.price)).toFixed(2)}
                        </div>
                        <button className="btn-icon" onClick={() => removeMaterial(i,mi)} title="Remove material" style={{ padding:4 }}>
                          <Icon name="x" size={10} color="var(--accent-red)" />
                        </button>
                      </div>
                      <label style={{ display:"inline-flex", alignItems:"center", gap:4, fontSize:"10px", color: m.clientSupplied ? "#8a5a1a" : "var(--stone-500)", cursor:"pointer", marginTop:2, paddingLeft:2, fontFamily:"var(--font-body)" }}>
                        <input type="checkbox" checked={!!m.clientSupplied} onChange={e => updateMaterial(i,mi,"clientSupplied",e.target.checked)}
                          style={{ width:11, height:11, accentColor:"#c9a96e", cursor:"pointer" }} />
                        Client supplied
                      </label>
                    </div>
                  ))}
                  <button onClick={() => addMaterial(i)}
                    style={{ padding:"3px 8px", fontSize:"10px", fontWeight:600, background:"transparent", color:"var(--warm-gold)", border:"1px dashed rgba(201,169,110,0.4)", borderRadius:5, cursor:"pointer", fontFamily:"var(--font-body)", marginTop:"2px", marginBottom:"4px" }}>
                    + Add Material
                  </button>
                </div>
              </div>
            ))}
            {/* Subtotals */}
            {form.items.some(it => (it.materials||[]).length > 0) && (
              <div style={{ display:"flex", justifyContent:"flex-end", gap:"16px", fontSize:"12px", color:"var(--stone-600)", marginTop:"8px" }}>
                <span>Scope: <strong>${getScopeTotal(form.items).toLocaleString()}</strong></span>
                <span style={{ color:"var(--warm-gold)" }}>Materials: <strong>${getMaterialsTotal(form.items).toLocaleString(undefined,{minimumFractionDigits:2})}</strong></span>
              </div>
            )}
            {/* Total bar */}
            <div style={{ display:"flex", justifyContent:"flex-end", background:"var(--stone-800)", padding:"10px 14px", borderRadius:"var(--radius)", marginTop:"8px" }}>
              <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, color:"var(--warm-gold)" }}>
                Total: ${getTotal(form.items).toLocaleString()}
              </div>
            </div>
          </div>

          <div className="form-group">
            <label>Notes</label>
            <textarea rows={3} value={form.notes} onChange={e => setForm(p => ({...p, notes: e.target.value}))}
              placeholder="Any special instructions, client preferences, or scope details…"
              style={{ width:"100%", padding:"8px 10px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"13px", fontFamily:"var(--font-body)", resize:"vertical" }} />
          </div>

          {/* Surcharge Toggle */}
          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 16px", background:"var(--stone-50)", borderRadius:"var(--radius)", border:"1px solid var(--stone-200)", marginTop:"8px" }}>
            <div>
              <div style={{ fontSize:"13px", fontWeight:600, color:"var(--stone-800)" }}>Apply 3% Card Surcharge</div>
              <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:"2px" }}>Adds 3% to project total for card payments</div>
            </div>
            <div onClick={() => setForm(p => ({...p, surcharge:!p.surcharge}))}
              style={{ width:42, height:24, borderRadius:12, background:form.surcharge?"var(--accent-green)":"var(--stone-300)", cursor:"pointer", position:"relative", transition:"background 0.2s", flexShrink:0 }}>
              <div style={{ position:"absolute", top:3, left:form.surcharge?20:3, width:18, height:18, borderRadius:"50%", background:"white", transition:"left 0.2s", boxShadow:"0 1px 3px rgba(0,0,0,0.2)" }}/>
            </div>
          </div>

          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 16px", background:"var(--stone-50)", borderRadius:"var(--radius)", border:"1px solid var(--stone-200)", marginTop:"8px" }}>
            <div>
              <div style={{ fontSize:"13px", fontWeight:600, color:"var(--stone-800)" }}>Hide Material Quantities</div>
              <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:"2px" }}>Client sees material names only — no qty or units</div>
            </div>
            <div onClick={() => setForm(p => ({...p, hideMatQty:!p.hideMatQty}))}
              style={{ width:42, height:24, borderRadius:12, background:form.hideMatQty?"var(--accent-green)":"var(--stone-300)", cursor:"pointer", position:"relative", transition:"background 0.2s", flexShrink:0 }}>
              <div style={{ position:"absolute", top:3, left:form.hideMatQty?20:3, width:18, height:18, borderRadius:"50%", background:"white", transition:"left 0.2s", boxShadow:"0 1px 3px rgba(0,0,0,0.2)" }}/>
            </div>
          </div>

          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:"8px", marginTop:"4px", flexWrap:"wrap" }}>
            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancel</button>
            <div style={{ display:"flex", gap:"8px" }}>
              <button className="btn btn-secondary" onClick={save} style={{ border:"1.5px solid var(--warm-gold)", color:"var(--warm-gold)" }}>
                <Icon name="check" size={14} /> Save Estimate
              </button>
              <button className="btn btn-primary" onClick={saveAndSend} style={{ background:"var(--accent-green)" }}>
                <Icon name="mail" size={14} /> Save & Send to Client
              </button>
            </div>
          </div>
        </Modal>
      )}
      {/* Estimate Preview */}
      {viewing && (() => {
        const baseTotal = getTotal(viewing.items);
        const surchargeAmt = viewing.surcharge ? Math.round(baseTotal * 0.03) : 0;
        const total    = baseTotal + surchargeAmt;
        const deposit  = Math.round(total * 0.5);
        const paidToDate = Math.min(estimatePaidToDate(viewing, invoices, jobs), total);
        const remaining = total - paidToDate;
        const expiry   = new Date(new Date(viewing.date).getTime() + 30*24*60*60*1000).toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"});
        const issued   = new Date(viewing.date).toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"});
        const customerRecord = customers.find(c => c.name.toLowerCase() === viewing.customer.toLowerCase());
        const customerAddress = customerRecord?.address || "";
        const customerEmail = customerRecord?.email || "";

        const openClientView = () => {
          const html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8"/>
<meta name="viewport" content="width=device-width,initial-scale=1"/>
<title>Estimate ${viewing.id} — Timeless Tile Pro LLC</title>
<link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=DM+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet"/>
<script src="https://js.stripe.com/v3/">${"</scr"+"ipt>"}
<style>
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{--gold:#c9a96e;--gold-light:#e8d5a3;--dark:#1a1714;--dark-2:#242018;--stone:#f5f3ef;--stone-2:#ece9e3;--stone-3:#ddd9d0;--ink:#2c2820;--ink-mid:#5a5248;--ink-light:#a09880;--white:#fff;--green:#4a7c59;--red:#b94a4a}
html{scroll-behavior:smooth}
body{font-family:'DM Sans',sans-serif;background:var(--stone);color:var(--ink);min-height:100vh;padding:32px 16px 60px}
body::before{content:'';position:fixed;inset:0;background:radial-gradient(ellipse 80% 50% at 50% -20%,rgba(201,169,110,0.07) 0%,transparent 60%);pointer-events:none;z-index:0}
.wrap{max-width:700px;margin:0 auto;position:relative;z-index:1;animation:pageIn 0.6s cubic-bezier(0.22,1,0.36,1) both}
@keyframes pageIn{from{opacity:0;transform:translateY(24px)}to{opacity:1;transform:translateY(0)}}
.doc{background:var(--white);border-radius:20px;overflow:hidden;box-shadow:0 20px 60px rgba(26,23,20,0.12),0 4px 16px rgba(26,23,20,0.08)}
.header{background:var(--dark);padding:36px 40px 30px;position:relative;overflow:hidden}
.header::after{content:'';position:absolute;top:-40px;right:-40px;width:200px;height:200px;background:radial-gradient(circle,rgba(201,169,110,0.12) 0%,transparent 70%);pointer-events:none}
.header-inner{display:flex;justify-content:space-between;align-items:flex-start;gap:20px;flex-wrap:wrap;position:relative;z-index:1}
.brand-mark{display:flex;align-items:center;gap:14px;margin-bottom:6px}
.brand-tile{width:42px;height:42px;background:var(--gold);border-radius:10px;display:grid;grid-template-columns:1fr 1fr;grid-template-rows:1fr 1fr;gap:3px;padding:6px;flex-shrink:0}
.brand-tile span{background:rgba(255,255,255,0.35);border-radius:2px}
.brand-tile span:nth-child(2),.brand-tile span:nth-child(3){background:rgba(255,255,255,0.6)}
.brand-name{font-family:'Cormorant Garamond',serif;font-size:26px;font-weight:700;color:#fff;line-height:1.1}
.brand-sub{font-size:11px;color:rgba(255,255,255,0.38);letter-spacing:.07em;text-transform:uppercase;margin-top:5px}
.est-label{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:rgba(255,255,255,0.35);margin-bottom:4px}
.est-number{font-family:'Cormorant Garamond',serif;font-size:32px;font-weight:700;color:var(--gold);line-height:1}
.est-date{font-size:12px;color:rgba(255,255,255,0.4);margin-top:5px}
.status-badge{display:inline-flex;align-items:center;gap:5px;background:rgba(201,169,110,0.15);color:var(--gold-light);border:1px solid rgba(201,169,110,0.25);padding:4px 12px;border-radius:99px;font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;margin-top:8px}
.status-dot{width:6px;height:6px;background:var(--gold);border-radius:50%;animation:pulse 2s ease-in-out infinite}
@keyframes pulse{0%,100%{opacity:1}50%{opacity:0.4}}
.gold-bar{height:3px;background:linear-gradient(90deg,var(--gold) 0%,var(--gold-light) 40%,transparent 100%)}
.client-strip{display:grid;grid-template-columns:1fr 1fr;border-bottom:1px solid var(--stone-2)}
.client-cell{padding:22px 40px}
.client-cell:first-child{border-right:1px solid var(--stone-2)}
.cell-label{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.09em;color:var(--ink-light);margin-bottom:7px}
.cell-name{font-family:'Cormorant Garamond',serif;font-size:20px;font-weight:600;color:var(--ink);line-height:1.2}
.cell-address{font-size:12px;color:var(--ink-mid);margin-top:4px}
.cell-email{font-size:11px;color:var(--ink-light);margin-top:2px}
.scope-wrap{padding:28px 40px 0}
.section-head{display:flex;justify-content:space-between;padding-bottom:12px;border-bottom:2px solid var(--dark)}
.section-title{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:var(--ink-light)}
.scope-item{display:flex;justify-content:space-between;align-items:flex-start;padding:15px 0;border-bottom:1px solid var(--stone-2);gap:16px}
.item-name{font-size:14px;font-weight:500;color:var(--ink)}
.item-meta{font-size:11px;color:var(--ink-light);margin-top:3px}
.item-labor-desc{font-size:11px;color:var(--ink-mid);margin-top:4px;line-height:1.6;font-style:italic}
.item-check{display:inline-flex;align-items:center;gap:5px;background:rgba(74,124,89,0.08);color:var(--green);border:1px solid rgba(74,124,89,0.2);padding:4px 10px;border-radius:6px;font-size:11px;font-weight:600;white-space:nowrap;flex-shrink:0}
.item-price{font-size:13px;font-weight:700;color:var(--ink);white-space:nowrap;flex-shrink:0}
.scope-item.parent{border-bottom:none}
.mat-group{margin-left:20px;padding-left:16px;border-left:2px solid var(--gold-light);margin-bottom:4px}
.mat-row{display:flex;justify-content:space-between;align-items:center;padding:8px 0;gap:10px}
.mat-row+.mat-row{border-top:1px solid var(--stone)}
.mat-row:last-child{border-bottom:1px solid var(--stone-2)}
.mat-badge{font-size:8px;font-weight:700;background:rgba(201,169,110,0.12);color:var(--gold);padding:1px 5px;border-radius:3px;letter-spacing:.04em;flex-shrink:0;margin-right:5px}
.mat-name{font-size:12px;font-weight:500;color:var(--ink-mid)}
.mat-meta{font-size:10px;color:var(--ink-light);margin-top:2px;padding-left:28px}
.mat-check{display:inline-flex;align-items:center;gap:3px;background:rgba(74,124,89,0.04);color:var(--green);border:1px solid rgba(74,124,89,0.1);padding:2px 8px;border-radius:5px;font-size:10px;font-weight:600;white-space:nowrap;flex-shrink:0}
.mat-price{font-size:12px;font-weight:600;color:var(--ink-mid);white-space:nowrap;flex-shrink:0}
.subtotals{display:flex;justify-content:flex-end;gap:16px;margin-top:10px;padding-top:8px;border-top:1px solid var(--stone-2);font-size:12px;color:var(--ink-mid)}
.total-section{padding:20px 40px 28px;display:flex;justify-content:flex-end}
.total-box{min-width:280px}
.total-line{display:flex;justify-content:space-between;padding:8px 0;font-size:13px;color:var(--ink-mid);border-top:1px solid var(--stone-2)}
.total-final{display:flex;justify-content:space-between;align-items:center;background:var(--dark);padding:16px 22px;border-radius:12px;margin-top:8px}
.total-key{font-size:11px;font-weight:700;color:rgba(255,255,255,0.5);text-transform:uppercase;letter-spacing:.08em}
.total-amt{font-family:'Cormorant Garamond',serif;font-size:30px;font-weight:700;color:var(--gold)}
.payment-section{padding:0 40px 28px}
.payment-card{background:#fffdf8;border:1px solid rgba(201,169,110,0.25);border-radius:12px;overflow:hidden}
.payment-header{background:rgba(201,169,110,0.08);padding:12px 20px;border-bottom:1px solid rgba(201,169,110,0.15);display:flex;align-items:center;gap:8px}
.payment-header-title{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.09em;color:var(--ink-light)}
.payment-row{display:flex;justify-content:space-between;align-items:center;padding:13px 20px;border-bottom:1px solid rgba(201,169,110,0.1);gap:12px}
.payment-row:last-child{border-bottom:none}
.payment-label{font-size:13px;color:var(--ink-mid)}
.payment-val{font-size:14px;font-weight:700;color:var(--ink);text-align:right}
.payment-sub{font-size:11px;font-weight:400;color:var(--ink-light);margin-top:1px}
.notes-section{padding:0 40px 28px}
.notes-card{border-left:3px solid var(--gold);background:var(--stone);border-radius:0 10px 10px 0;padding:16px 20px}
.notes-label{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.09em;color:var(--ink-light);margin-bottom:8px}
.notes-text{font-size:13px;color:var(--ink-mid);line-height:1.75}
.sig-section{padding:0 40px 28px}
.sig-card{border:1px solid var(--stone-3);border-radius:12px;overflow:hidden}
.sig-card-header{background:var(--dark);padding:13px 20px;display:flex;align-items:center;gap:8px}
.sig-card-title{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.09em;color:rgba(255,255,255,0.5)}
.sig-body{padding:22px}
.sig-agreement{font-size:12px;color:var(--ink-mid);line-height:1.7;margin-bottom:24px;padding:12px 16px;background:var(--stone);border-radius:8px;border-left:2px solid var(--stone-3)}
.sig-grid{display:grid;grid-template-columns:1fr 1fr;gap:22px 28px}
.field-label{font-size:10px;color:var(--ink-light);margin-top:6px;letter-spacing:.04em}
.canvas-wrap{grid-column:1/-1;border:1.5px solid var(--stone-3);border-radius:10px;overflow:hidden;background:#fafaf8;transition:border-color 0.2s;position:relative}
.canvas-wrap.active{border-color:var(--gold)}
.canvas-wrap canvas{display:block;width:100%;touch-action:none;cursor:crosshair}
.canvas-hint{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;pointer-events:none;transition:opacity 0.25s}
.canvas-hint.hidden{opacity:0}
.hint-icon{font-size:26px;opacity:0.22}
.hint-text{font-size:12px;color:var(--ink-light);font-style:italic}
.canvas-toolbar{display:flex;justify-content:space-between;align-items:center;padding:8px 14px;background:var(--stone);border-top:1px solid var(--stone-2)}
.canvas-lbl{font-size:10px;color:var(--ink-light);text-transform:uppercase;letter-spacing:.05em}
.clear-btn{font-size:11px;color:var(--ink-light);background:none;border:none;cursor:pointer;padding:3px 8px;border-radius:4px;font-family:'DM Sans',sans-serif}
.sig-input{width:100%;border:none;border-bottom:1.5px solid var(--stone-3);background:transparent;font-family:'DM Sans',sans-serif;font-size:14px;color:var(--ink);padding:6px 0;outline:none;transition:border-color 0.2s}
.sig-input::placeholder{color:var(--stone-3);font-style:italic}
.sig-input:focus{border-bottom-color:var(--gold)}
.date-tap{width:100%;border-bottom:1.5px solid var(--stone-3);padding:6px 0;min-height:34px;display:flex;align-items:center;justify-content:space-between;cursor:pointer;user-select:none}
.date-tap .ph{font-size:13px;color:var(--stone-3);font-style:italic}
.date-tap .dv{font-size:14px;font-weight:500;color:var(--ink);display:none}
.date-tap.filled .ph{display:none}
.date-tap.filled .dv{display:block}
.date-tap.filled{border-bottom-color:var(--ink)}
.date-tap .xb{font-size:11px;color:var(--ink-light);display:none;padding:2px 5px}
.date-tap.filled .xb{display:inline}
.auth-line{border-bottom:1.5px solid var(--ink);padding:6px 0;font-family:'Cormorant Garamond',serif;font-size:16px;font-style:italic;font-weight:600;color:var(--ink)}
/* Accept button — always active, validates on click */
.accept-section{padding:0 40px 24px}
.accept-btn{width:100%;padding:18px;border:none;border-radius:12px;background:var(--dark);color:var(--gold);font-family:'Cormorant Garamond',serif;font-size:20px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:10px;transition:all 0.25s;opacity:1;-webkit-tap-highlight-color:rgba(201,169,110,0.3);touch-action:manipulation}
.accept-btn:hover{background:#2c2820;transform:translateY(-1px)}
.accept-btn:active{transform:scale(0.98)}
.accept-btn.done{background:var(--green);color:#fff;cursor:default;opacity:1}
.accept-note{text-align:center;font-size:11px;color:var(--ink-light);margin-top:10px}
.accept-note.good{color:var(--green)}
.accept-note.warn{color:var(--red)}
/* Payment options (shown after signature accepted) */
.pay-section{display:none;padding:0 40px 28px}
.pay-section.show{display:block;animation:fadeUp 0.4s ease both}
@keyframes fadeUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
.pay-title{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:var(--ink-light);margin-bottom:14px}
.pay-options{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:16px}
.pay-opt{border:1.5px solid var(--stone-3);border-radius:12px;padding:16px 18px;cursor:pointer;transition:all 0.2s;background:var(--white);text-align:center}
.pay-opt:hover{border-color:var(--gold);background:#fffdf8}
.pay-opt.selected{border-color:var(--gold);background:#fffdf8;box-shadow:0 0 0 3px rgba(201,169,110,0.15)}
.pay-opt-label{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:var(--ink-light);margin-bottom:6px}
.pay-opt-amt{font-family:'Cormorant Garamond',serif;font-size:24px;font-weight:700;color:var(--ink)}
.pay-opt-sub{font-size:11px;color:var(--ink-light);margin-top:3px}
/* Stripe form embed */
.stripe-form-wrap{background:#fff;border:1.5px solid var(--stone-3);border-radius:12px;padding:20px;display:none}
.stripe-form-wrap.show{display:block}
#stripe-element-container{min-height:44px}
.stripe-submit{width:100%;margin-top:16px;padding:15px;border:none;border-radius:10px;background:var(--green);color:#fff;font-family:'Cormorant Garamond',serif;font-size:18px;font-weight:700;cursor:pointer;transition:all 0.2s}
.stripe-submit:hover{background:#3d6b4a;transform:translateY(-1px)}
.stripe-submit:disabled{opacity:0.6;cursor:not-allowed;transform:none}
.stripe-secure{text-align:center;font-size:11px;color:var(--ink-light);margin-top:10px}
.stripe-error{background:rgba(185,74,74,0.08);border:1px solid rgba(185,74,74,0.2);border-radius:8px;padding:10px 14px;font-size:13px;color:var(--red);margin-top:12px;display:none}
.stripe-error.show{display:block}
/* Skip pay */
.skip-pay{text-align:center;margin-top:12px}
.skip-link{font-size:12px;color:var(--ink-light);cursor:pointer;text-decoration:underline;text-underline-offset:2px}
/* Success */
.success-banner{display:none;margin:0 40px 24px;background:rgba(74,124,89,0.07);border:1px solid rgba(74,124,89,0.22);border-radius:12px;padding:18px 22px;align-items:center;gap:14px}
.success-banner.show{display:flex}
.success-title{font-size:15px;font-weight:700;color:var(--green)}
.success-sub{font-size:12px;color:var(--ink-mid);margin-top:3px;line-height:1.5}
.pay-success{display:none;margin:0 40px 28px;background:rgba(74,124,89,0.07);border:1px solid rgba(74,124,89,0.22);border-radius:12px;padding:20px 24px;text-align:center}
.pay-success.show{display:block}
.pay-success-icon{font-size:36px;margin-bottom:10px}
.pay-success-title{font-family:'Cormorant Garamond',serif;font-size:20px;font-weight:700;color:var(--green)}
.pay-success-sub{font-size:13px;color:var(--ink-mid);margin-top:6px}
.footer{background:var(--dark-2,#242018);padding:20px 40px;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:10px}
.footer-brand{font-family:'Cormorant Garamond',serif;font-size:14px;color:rgba(255,255,255,0.35);font-style:italic}
.footer-exp{font-size:11px;color:var(--gold);font-weight:600}
.footer-web{font-size:11px;color:rgba(255,255,255,0.25)}
@media(max-width:540px){
  body{padding:12px 10px 48px}
  .header{padding:24px 22px 22px}
  .brand-name{font-size:20px}.est-number{font-size:26px}
  .client-strip{grid-template-columns:1fr}
  .client-cell:first-child{border-right:none;border-bottom:1px solid var(--stone-2)}
  .client-cell,.scope-wrap{padding-left:22px;padding-right:22px}
  .scope-wrap{padding-top:20px}
  .total-section,.payment-section,.notes-section,.sig-section,.accept-section,.pay-section{padding-left:22px;padding-right:22px}
  .success-banner,.pay-success{margin-left:22px;margin-right:22px}
  .total-box{min-width:auto;width:100%}
  .sig-grid,.pay-options{grid-template-columns:1fr;gap:12px}
  .mat-group{margin-left:12px;padding-left:12px}
  .footer{padding:16px 22px;flex-direction:column;align-items:flex-start;gap:6px}
}
</style>
</head>
<body>
<div class="wrap"><div class="doc">
  <div class="header">
    <div class="header-inner">
      <div>
        <div class="brand-mark">
          <div class="brand-tile"><span></span><span></span><span></span><span></span></div>
          <div class="brand-name">Timeless Tile Pro LLC</div>
        </div>
        <div class="brand-sub">Virginia Beach, VA &nbsp;·&nbsp; (757) 263-0978 &nbsp;·&nbsp; timelesstilepro.com</div>
      </div>
      <div style="text-align:right">
        <div class="est-label">Estimate</div>
        <div class="est-number">${viewing.id}</div>
        <div class="est-date">Issued ${issued}</div>
        <span class="status-badge"><span class="status-dot"></span>${viewing.status}</span>
      </div>
    </div>
  </div>
  <div class="gold-bar"></div>
  <div class="client-strip">
    <div class="client-cell"><div class="cell-label">Prepared For</div><div class="cell-name">${viewing.customer}</div>${customerAddress ? `<div class="cell-address">${customerAddress}</div>` : ""}${customerEmail ? `<div class="cell-email">${customerEmail}</div>` : ""}</div>
    <div class="client-cell"><div class="cell-label">Project</div><div class="cell-name">${viewing.project}</div></div>
  </div>
  <div class="scope-wrap">
    <div class="section-head"><span class="section-title">Scope of Work</span><span class="section-title">${viewing.pricingMode === "itemized" ? "Amount" : "Status"}</span></div>
    ${viewing.items.map(it => {
      const hasMats = (it.materials||[]).length > 0;
      const clientPillScope = `<div style="display:inline-flex;align-items:center;gap:3px;background:rgba(201,149,74,0.12);color:#8a5a1a;border:1px solid rgba(201,149,74,0.3);padding:2px 8px;border-radius:5px;font-size:11px;font-weight:600;white-space:nowrap;flex-shrink:0">&#x2B22; Client supplied${it.clientSuppliedNote ? ' ' + it.clientSuppliedNote : ''}</div>`;
      const clientPillMat = `<div style="display:inline-flex;align-items:center;gap:3px;background:rgba(201,149,74,0.12);color:#8a5a1a;border:1px solid rgba(201,149,74,0.3);padding:2px 8px;border-radius:5px;font-size:10px;font-weight:600;white-space:nowrap;flex-shrink:0">&#x2B22; Client supplied</div>`;
      const scopeStatusCell = viewing.pricingMode === "itemized"
        ? `<div class="item-price">$${(Number(it.qty)*Number(it.price)).toLocaleString(undefined,{minimumFractionDigits:2})}</div>`
        : (it.clientSupplied ? clientPillScope : `<div class="item-check">&#10003; Included</div>`);
      const scopeRow = `<div class="scope-item${hasMats || it.laborDesc ? ' parent' : ''}"><div><div class="item-name" style="font-weight:600">${it.desc}</div>${it.laborDesc ? `<div class="item-labor-desc">${it.laborDesc}</div>` : ""}<div class="item-meta">${it.qty} ${it.unit}${viewing.pricingMode === "itemized" ? ` &times; $${Number(it.price).toFixed(2)}` : ""}</div></div>${scopeStatusCell}</div>`;
      const matRows = hasMats ? `<div class="mat-group">${it.materials.map(m => {
        const matStatusCell = viewing.pricingMode === "itemized"
          ? `<div class="mat-price">$${(Number(m.qty)*Number(m.price)).toLocaleString(undefined,{minimumFractionDigits:2})}</div>`
          : (m.clientSupplied ? clientPillMat : `<div class="mat-check">&#10003; Included</div>`);
        return `<div class="mat-row"><div style="flex:1;min-width:0"><div class="mat-name"><span class="mat-badge">MTL</span>${m.desc}</div>${viewing.hideMatQty ? "" : `<div class="mat-meta">${m.qty} ${m.unit}${viewing.pricingMode === "itemized" ? ` &times; $${Number(m.price).toFixed(2)}` : ""}</div>`}</div>${matStatusCell}</div>`;
      }).join("")}</div>` : "";
      return scopeRow + matRows;
    }).join("")}
    ${viewing.pricingMode === "itemized" ? `<div class="subtotals"><span>Scope: <strong>$${getScopeTotal(viewing.items).toLocaleString(undefined,{minimumFractionDigits:2})}</strong></span><span style="color:var(--gold)">Materials: <strong>$${getMaterialsTotal(viewing.items).toLocaleString(undefined,{minimumFractionDigits:2})}</strong></span></div>` : ""}
  </div>
  <div class="total-section">
    <div class="total-box">
      <div class="total-line"><span>${viewing.items.length} scope item${viewing.items.length!==1?"s":""} &middot; all materials &amp; labor</span></div>
      <div class="total-final"><span class="total-key">Project Total</span><span class="total-amt">$${total.toLocaleString()}</span></div>
    </div>
  </div>
  <div class="payment-section">
    <div class="payment-card">
      <div class="payment-header"><span>&#128179;</span><span class="payment-header-title">Payment Terms</span></div>
      ${paidToDate > 0 ? `
      <div class="payment-row" style="background:rgba(74,124,89,0.06);border-radius:8px;margin-bottom:4px"><div class="payment-label" style="color:#4a7c59;font-weight:600">&#9989; Deposit Received</div><div class="payment-val" style="color:#4a7c59">$${paidToDate.toLocaleString()}<div class="payment-sub">Thank you!</div></div></div>
      <div class="payment-row"><div class="payment-label" style="font-weight:600">Remaining Balance</div><div class="payment-val" style="font-weight:700;color:#2c2820">$${remaining.toLocaleString()}<div class="payment-sub">Due on completion</div></div></div>
      ` : `
      <div class="payment-row"><div class="payment-label">Deposit &mdash; due to confirm start date</div><div class="payment-val">$${deposit.toLocaleString()}<div class="payment-sub">50% of total</div></div></div>
      <div class="payment-row"><div class="payment-label">Balance &mdash; due on completion</div><div class="payment-val">$${(total-deposit).toLocaleString()}<div class="payment-sub">50% of total</div></div></div>
      `}
      <div class="payment-row"><div class="payment-label">Accepted methods</div><div class="payment-val" style="font-size:13px;font-weight:500">Card &middot; Bank Transfer &middot; Check</div></div>
    </div>
    ${viewing.surcharge ? `<div style="margin-top:10px;padding:10px 16px;background:rgba(201,169,110,0.08);border:1px solid rgba(201,169,110,0.25);border-radius:8px;font-size:12px;color:#5a5248;line-height:1.6"><strong style="color:#c9a96e">3% Card Processing Fee Applied</strong><br>A surcharge of $${surchargeAmt.toLocaleString()} has been added to the project total for card payments. Pay by check or bank transfer to waive this fee.</div>` : ""}
  </div>
  ${stripCONotes(viewing.notes) ? `<div class="notes-section"><div class="notes-card"><div class="notes-label">Project Notes</div><div class="notes-text">${stripCONotes(viewing.notes)}</div></div></div>` : ""}
  <div class="sig-section">
    <div class="sig-card">
      <div class="sig-card-header"><span>&#9997;&#65039;</span><span class="sig-card-title">Step 1 of 2 &mdash; Accept &amp; Proceed</span></div>
      <div class="sig-body">
        <div class="sig-agreement">By entering your name and date below, you authorize Timeless Tile Pro LLC to proceed with the project as described and agree to the payment terms.</div>
        <div class="sig-grid">
          <div>
            <input class="sig-input" id="printedName" type="text" placeholder="Your full name&hellip;" autocomplete="name" value="${viewing.customer}"/>
            <div class="field-label">Full Name</div>
          </div>
          <div>
            <input type="date" id="datePicker" onchange="handleDateChange(this.value)" style="width:100%;border:none;border-bottom:1.5px solid var(--stone-3);background:transparent;font-family:'DM Sans',sans-serif;font-size:14px;color:var(--ink);padding:6px 0;outline:none;-webkit-appearance:none"/>
            <div class="field-label">Date</div>
          </div>
          <div style="grid-column:1/-1"><div class="auth-line">Timeless Tile Pro LLC</div><div class="field-label">Authorized By</div></div>
        </div>
      </div>
    </div>
  </div>
  <div class="accept-section">
    <button class="accept-btn" id="acceptBtn" onclick="submitAcceptance()"><span id="btnIcon">&#127963;</span><span id="btnText">Accept Estimate &amp; Continue to Payment</span></button>
    <div class="accept-note" id="acceptNote">Tap to accept and proceed to payment.</div>
  </div>

  <!-- STEP 2: PAYMENT (revealed after signature) -->
  <div class="pay-section" id="paySection">
    <div class="sig-card-header" style="border-radius:12px 12px 0 0;background:var(--dark);padding:13px 20px;display:flex;align-items:center;gap:8px;margin-bottom:0">
      <span>&#128179;</span><span class="sig-card-title">Step 2 of 2 &mdash; Secure Your Start Date</span>
    </div>
    <div style="border:1px solid var(--stone-3);border-top:none;border-radius:0 0 12px 12px;padding:22px">
      <div class="pay-title">Choose your payment amount</div>
      <div class="pay-options">
        ${paidToDate > 0 ? `
        <div class="pay-opt" id="optFull" onclick="selectPayOption('full')" style="flex:1">
          <div class="pay-opt-label">&#128176; Pay Remaining Balance</div>
          <div class="pay-opt-amt">$${remaining.toLocaleString()}</div>
          <div class="pay-opt-sub">$${paidToDate.toLocaleString()} deposit already applied</div>
        </div>
        ` : `
        <div class="pay-opt" id="optDeposit" onclick="selectPayOption('deposit')">
          <div class="pay-opt-label">&#128274; Deposit to Book</div>
          <div class="pay-opt-amt">$${deposit.toLocaleString()}</div>
          <div class="pay-opt-sub">50% &mdash; locks in your date</div>
        </div>
        <div class="pay-opt" id="optFull" onclick="selectPayOption('full')">
          <div class="pay-opt-label">&#9889; Pay in Full</div>
          <div class="pay-opt-amt">$${total.toLocaleString()}</div>
          <div class="pay-opt-sub">100% &mdash; nothing due later</div>
        </div>
        `}
      </div>
      <div class="stripe-form-wrap" id="stripeFormWrap">
        <div id="stripe-element-container"></div>
        <div class="stripe-error" id="stripeError"></div>
        <button class="stripe-submit" id="stripeSubmitBtn" onclick="submitStripePayment()">Pay Now</button>
        <div class="stripe-secure">&#128274; Secured by Stripe &mdash; your card info never touches our servers</div>
      </div>
      <div class="skip-pay"><span class="skip-link" onclick="skipPayment()">I&rsquo;ll arrange payment separately</span></div>
    </div>
  </div>

  <div class="pay-success" id="paySuccess">
    <div class="pay-success-icon">&#127881;</div>
    <div class="pay-success-title">Payment Received!</div>
    <div class="pay-success-sub">You&rsquo;re all set, <strong>${viewing.customer}</strong>. Timeless Tile Pro LLC will contact you shortly to confirm your start date.</div>
  </div>

  <div class="footer">
    <div class="footer-brand">Timeless Tile Pro LLC &mdash; Thank you for your business.</div>
    <div style="display:flex;align-items:center;gap:16px"><span class="footer-exp">Valid until ${expiry}</span><span class="footer-web">timelesstilepro.com</span></div>
  </div>
</div></div>
<script>
// ── CLIENT ESTIMATE PAGE — ACCEPTANCE + STRIPE ──────────────────────────
var dateSet=true;

function submitAcceptance(){
  // Read name directly on click — works on all browsers
  var el=document.getElementById('printedName');
  var name=el?el.value.trim():'';
  var note=document.getElementById('acceptNote');
  var btn=document.getElementById('acceptBtn');

  if(name.length<2){
    // Shake the name field and show warning
    if(note){note.textContent='Please enter your full name above to continue.';note.className='accept-note warn';}
    if(el){el.style.borderBottomColor='var(--red)';el.focus();setTimeout(function(){el.style.borderBottomColor='';},2000);}
    return;
  }

  // Accepted!
  if(btn){btn.classList.add('done');btn.disabled=true;
    document.getElementById('btnIcon').textContent='\\u2713';
    document.getElementById('btnText').textContent='Accepted \\u2014 Complete Payment Below';}
  if(note){note.textContent='Thank you! Please complete payment to confirm your start date.';note.className='accept-note good';}

  // Show payment section
  var ps=document.getElementById('paySection');
  if(ps){ps.style.display='block';ps.classList.add('show');setTimeout(function(){ps.scrollIntoView({behavior:'smooth',block:'start'});},150);}

  // Init Stripe if available
  try{_initStripe();}catch(e){}
}

// Date picker
function handleDateChange(val){dateSet=val.length>0;}
function resizeCanvas(){}
function applyStyle(){}

window.addEventListener('DOMContentLoaded',function(){
  var dp=document.getElementById('datePicker');
  if(dp)dp.value=new Date().toISOString().slice(0,10);
});
${"</scr"+"ipt>"}
<script>
// ── STRIPE PAYMENT (errors here cannot break acceptance button) ─────────
var _stripe=null,_elements=null,_paymentElement=null,_selectedOpt=null;
var _depositAmt=${paidToDate > 0 ? remaining : deposit},_fullAmt=${paidToDate > 0 ? remaining : total};
var _stripeKey=${JSON.stringify(process.env.REACT_APP_STRIPE_PUBLIC_KEY||"")};
var _estMeta=${JSON.stringify({estimateId:viewing.id,customer:viewing.customer,project:viewing.project})};

function _initStripe(){
  if(!_stripeKey||typeof Stripe==='undefined')return;
  try{_stripe=Stripe(_stripeKey);}catch(e){}
}

function selectPayOption(opt){
  _selectedOpt=opt;
  var depEl=document.getElementById('optDeposit');
  if(depEl)depEl.classList.toggle('selected',opt==='deposit');
  document.getElementById('optFull').classList.toggle('selected',opt==='full');
  var wrap=document.getElementById('stripeFormWrap');
  wrap.classList.add('show');wrap.style.display='block';
  var amt=opt==='deposit'?_depositAmt:_fullAmt;
  document.getElementById('stripeSubmitBtn').textContent='Pay $'+amt.toLocaleString()+' Now';
  if(_stripe){
    if(_paymentElement){try{_paymentElement.destroy();}catch(e){}_paymentElement=null;}
    _createPE(amt);
  }
}

function _createPE(amt){
  fetch('/api/create-payment-intent',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({amount:amt,metadata:_estMeta})})
  .then(function(r){return r.json()})
  .then(function(data){
    if(data.error){_showErr(data.error);return;}
    _elements=_stripe.elements({clientSecret:data.clientSecret,appearance:{theme:'stripe',variables:{colorPrimary:'#c9a96e',fontFamily:'DM Sans,sans-serif',borderRadius:'8px'}}});
    _paymentElement=_elements.create('payment',{layout:'tabs',business:{name:'Timeless Tile Pro LLC'}});
    _paymentElement.mount('#stripe-element-container');
    document.getElementById('stripeSubmitBtn').disabled=false;
  })
  .catch(function(){_showErr('Could not connect to payment server.');});
}

function submitStripePayment(){
  if(!_stripe||!_elements||!_selectedOpt)return;
  var btn=document.getElementById('stripeSubmitBtn');
  btn.disabled=true;btn.textContent='Processing\\u2026';
  _stripe.confirmPayment({elements:_elements,redirect:'if_required'})
  .then(function(result){
    if(result.error){
      _showErr(result.error.message);
      btn.disabled=false;
      btn.textContent='Pay $'+(_selectedOpt==='deposit'?_depositAmt:_fullAmt).toLocaleString()+' Now';
    }else{
      document.getElementById('paySection').style.display='none';
      var ps=document.getElementById('paySuccess');
      ps.style.display='block';ps.classList.add('show');
      ps.scrollIntoView({behavior:'smooth',block:'center'});
      // Record payment + send receipt email
      var piId=result.paymentIntent?result.paymentIntent.id:'';
      var amt=_selectedOpt==='deposit'?_depositAmt:_fullAmt;
      console.log('[TTP] Recording payment...', {estimateId:_estMeta.estimateId,customer:_estMeta.customer,project:_estMeta.project,amount:amt,type:_selectedOpt,paymentIntentId:piId});
      fetch('/api/record-client-payment',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({
        estimateId:_estMeta.estimateId,customer:_estMeta.customer,project:_estMeta.project,
        amount:amt,type:_selectedOpt,paymentIntentId:piId,sendReceipt:true
      })}).then(function(r){return r.json()}).then(function(data){
        console.log('[TTP] Payment recorded:', data);
        if(data.errors&&data.errors.length)console.warn('[TTP] Warnings:', data.errors);
      }).catch(function(err){console.error('[TTP] Record payment failed:', err);});
    }
  })
  .catch(function(){
    _showErr('Payment failed. Please try again.');
    btn.disabled=false;
    btn.textContent='Pay $'+(_selectedOpt==='deposit'?_depositAmt:_fullAmt).toLocaleString()+' Now';
  });
}

function _showErr(msg){var el=document.getElementById('stripeError');if(el){el.textContent=msg;el.style.display='block';}}

function skipPayment(){
  document.getElementById('paySection').style.display='none';
  var b=document.createElement('div');
  b.style.cssText='margin:0 40px 24px;background:rgba(201,169,110,0.08);border:1px solid rgba(201,169,110,0.25);border-radius:12px;padding:18px 22px;text-align:center;animation:fadeUp 0.4s ease both';
  b.innerHTML='<div style="font-size:15px;font-weight:700;color:#c9a96e;margin-bottom:6px">Estimate Accepted</div><div style="font-size:13px;color:#5a5248">Timeless Tile Pro LLC will contact you to arrange payment and confirm your start date.</div>';
  var f=document.querySelector('.footer');if(f&&f.parentNode)f.parentNode.insertBefore(b,f);
  b.scrollIntoView({behavior:'smooth',block:'center'});
}
${"</scr"+"ipt>"}
</body></html>`;
          const w = window.open("","_blank");
          w.document.write(html);
          w.document.close();
        };

        return (
          <Modal title={`Preview — ${viewing.id}`} onClose={() => setViewing(null)}>
            {/* Internal CRM preview */}
            <div style={{ background:"white", borderRadius:"var(--radius-lg)", overflow:"hidden", border:"1px solid var(--stone-200)", marginBottom:"16px" }}>
              <div style={{ background:"var(--stone-900)", padding:"20px 24px", display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:10 }}>
                <div>
                  <div style={{ fontFamily:"var(--font-display)", fontSize:"22px", fontWeight:700, color:"white" }}>Timeless Tile Pro LLC</div>
                  <div style={{ fontSize:"11px", color:"rgba(255,255,255,0.45)", marginTop:3, letterSpacing:"0.05em" }}>VIRGINIA BEACH, VA · (757) 263-0978 · TIMELESSTILEPRO.COM</div>
                </div>
                <div style={{ textAlign:"right" }}>
                  <div style={{ fontFamily:"var(--font-display)", fontSize:"20px", fontWeight:700, color:"#c9a96e" }}>{viewing.id}</div>
                  <div style={{ fontSize:"11px", color:"rgba(255,255,255,0.45)", marginTop:2 }}>Issued {issued}</div>
                  <span style={{ background:"rgba(201,169,110,0.2)", color:"#c9a96e", border:"1px solid rgba(201,169,110,0.3)", padding:"2px 10px", borderRadius:99, fontSize:"10px", fontWeight:700, letterSpacing:"0.05em", textTransform:"uppercase", marginTop:6, display:"inline-block" }}>{viewing.status}</span>
                </div>
              </div>
              <div style={{ height:3, background:"linear-gradient(90deg,#c9a96e,#e8d5a3,transparent)" }}/>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", borderBottom:"1px solid #f0ede8" }}>
                <div style={{ padding:"14px 20px", borderRight:"1px solid #f0ede8" }}>
                  <div style={{ fontSize:"10px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.07em", color:"#a09880", marginBottom:4 }}>Prepared For</div>
                  <div style={{ fontWeight:700, fontSize:"14px" }}>{viewing.customer}</div>
                  {customerAddress && <div style={{ fontSize:"11px", color:"#6b5e52", marginTop:2 }}>{customerAddress}</div>}
                  {customerEmail && <div style={{ fontSize:"11px", color:"#a09880", marginTop:2 }}>{customerEmail}</div>}
                </div>
                <div style={{ padding:"14px 20px" }}>
                  <div style={{ fontSize:"10px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.07em", color:"#a09880", marginBottom:4 }}>Project</div>
                  <div style={{ fontWeight:700, fontSize:"14px" }}>{viewing.project}</div>
                </div>
              </div>
              <div style={{ padding:"0 20px 16px" }}>
                <div style={{ display:"flex", justifyContent:"space-between", padding:"12px 0 8px", borderBottom:"2px solid var(--stone-900)" }}>
                  <span style={{ fontSize:"10px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.07em", color:"#a09880" }}>Scope of Work</span>
                  <span style={{ fontSize:"10px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.07em", color:"#a09880" }}>{viewing.pricingMode === "itemized" ? "Amount" : "Included"}</span>
                </div>
                {viewing.items.map((it,i) => (
                  <div key={i}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", padding:"12px 0", borderBottom: (it.materials||[]).length === 0 && !it.laborDesc ? "1px solid #f5f3ef" : "none" }}>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ fontSize:"14px", fontWeight:600 }}>{it.desc}</div>
                        {it.laborDesc && <div style={{ fontSize:"11px", color:"#6b5e52", marginTop:3, lineHeight:1.5, fontStyle:"italic" }}>{it.laborDesc}</div>}
                        <div style={{ fontSize:"11px", color:"#a09880", marginTop:2 }}>{it.qty} {it.unit}{viewing.pricingMode === "itemized" ? ` × $${Number(it.price).toFixed(2)}` : ""}</div>
                      </div>
                      {viewing.pricingMode === "itemized"
                        ? <div style={{ fontSize:"13px", fontWeight:700, color:"#1a1714", whiteSpace:"nowrap" }}>${(Number(it.qty)*Number(it.price)).toLocaleString(undefined,{minimumFractionDigits:2})}</div>
                        : it.clientSupplied
                          ? <div style={{ display:"inline-flex", alignItems:"center", gap:3, background:"rgba(201,149,74,0.12)", color:"#8a5a1a", border:"1px solid rgba(201,149,74,0.3)", padding:"2px 8px", borderRadius:5, fontSize:"11px", fontWeight:600, whiteSpace:"nowrap", flexShrink:0 }}>⬢ Client supplied{it.clientSuppliedNote ? ` ${it.clientSuppliedNote}` : ""}</div>
                          : <div style={{ fontSize:"12px", fontWeight:600, color:"var(--accent-green)" }}>✓ Included</div>}
                    </div>
                    {(it.materials||[]).length > 0 && (
                      <div style={{ marginLeft:20, paddingLeft:14, borderLeft:"2px solid #e8d5a3", marginBottom:4 }}>
                        {it.materials.map((m,mi) => (
                          <div key={mi} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom: mi < it.materials.length-1 ? "1px solid #faf8f5" : "1px solid #f0ede8", gap:10 }}>
                            <div style={{ flex:1, minWidth:0 }}>
                              <div style={{ fontSize:"12px", fontWeight:500, color:"#5a5248", display:"flex", alignItems:"center", gap:5 }}>
                                <span style={{ fontSize:"8px", fontWeight:700, background:"rgba(201,169,110,0.12)", color:"#c9a96e", padding:"1px 5px", borderRadius:3, letterSpacing:"0.04em", flexShrink:0 }}>MTL</span>
                                {m.desc}
                              </div>
                              <div style={{ fontSize:"10px", color:"#b0a095", marginTop:2, paddingLeft:28 }}>{viewing.hideMatQty ? "" : `${m.qty} ${m.unit}`}{viewing.pricingMode === "itemized" && !viewing.hideMatQty ? ` × $${Number(m.price).toFixed(2)}` : ""}</div>
                            </div>
                            {viewing.pricingMode === "itemized"
                              ? <div style={{ fontSize:"12px", fontWeight:600, color:"#6b5e52", whiteSpace:"nowrap", flexShrink:0 }}>${(Number(m.qty)*Number(m.price)).toLocaleString(undefined,{minimumFractionDigits:2})}</div>
                              : m.clientSupplied
                                ? <div style={{ display:"inline-flex", alignItems:"center", gap:3, background:"rgba(201,149,74,0.12)", color:"#8a5a1a", border:"1px solid rgba(201,149,74,0.3)", padding:"2px 8px", borderRadius:5, fontSize:"10px", fontWeight:600, whiteSpace:"nowrap", flexShrink:0 }}>⬢ Client supplied</div>
                                : <div style={{ display:"inline-flex", alignItems:"center", gap:3, background:"rgba(74,124,89,0.04)", color:"#7a9e7e", border:"1px solid rgba(74,124,89,0.1)", padding:"2px 8px", borderRadius:5, fontSize:"10px", fontWeight:600, whiteSpace:"nowrap", flexShrink:0 }}>✓ Included</div>}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
                {viewing.pricingMode === "itemized" && (
                  <div style={{ display:"flex", justifyContent:"flex-end", gap:16, marginTop:10, paddingTop:8, borderTop:"1px solid #e8e0d8", fontSize:"12px", color:"#6b5e52" }}>
                    <span>Scope: <strong>${getScopeTotal(viewing.items).toLocaleString(undefined,{minimumFractionDigits:2})}</strong></span>
                    <span style={{ color:"#c9a96e" }}>Materials: <strong>${getMaterialsTotal(viewing.items).toLocaleString(undefined,{minimumFractionDigits:2})}</strong></span>
                  </div>
                )}
                <div style={{ display:"flex", justifyContent:"flex-end", marginTop:12 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", background:"var(--stone-900)", padding:"12px 18px", borderRadius:"var(--radius)", minWidth:220 }}>
                    <span style={{ fontSize:"12px", fontWeight:700, color:"rgba(255,255,255,0.6)", textTransform:"uppercase", letterSpacing:"0.06em" }}>Project Total</span>
                    <span style={{ fontFamily:"var(--font-display)", fontSize:"22px", fontWeight:700, color:"#c9a96e" }}>${total.toLocaleString()}</span>
                  </div>
                </div>
              </div>
              {stripCONotes(viewing.notes) && (
                <div style={{ margin:"0 20px 16px", background:"#fffdf8", borderLeft:"3px solid #c9a96e", borderRadius:"0 6px 6px 0", padding:"12px 14px" }}>
                  <div style={{ fontSize:"10px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.07em", color:"#a09880", marginBottom:5 }}>Notes</div>
                  <div style={{ fontSize:"12px", color:"#5a5448", lineHeight:1.6 }}>{stripCONotes(viewing.notes)}</div>
                </div>
              )}
              <div style={{ background:"#fafaf8", borderTop:"1px solid #f0ede8", padding:"12px 20px", display:"flex", justifyContent:"space-between", fontSize:"11px", color:"#a09880" }}>
                <span>50% deposit · 50% on completion</span>
                <span>Valid until {expiry}</span>
              </div>
            </div>

            {/* Pricing Display Toggle in Viewing Modal */}
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 16px", background:"var(--stone-50)", borderRadius:"var(--radius)", border:"1px solid var(--stone-200)", marginBottom:"8px" }}>
              <div>
                <div style={{ fontSize:"13px", fontWeight:600, color:"var(--stone-800)" }}>Pricing Display <span style={{ fontSize:"11px", color: viewing.pricingMode === "itemized" ? "var(--warm-gold)" : "var(--accent-green)", fontWeight:700 }}>● {viewing.pricingMode === "itemized" ? "ITEMIZED" : "BUNDLED"}</span></div>
                <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:"2px" }}>{viewing.pricingMode === "itemized" ? "Client sees individual line pricing" : "Client sees \"✓ Included\" — single total"}</div>
              </div>
              <div onClick={() => { const newMode = viewing.pricingMode === "itemized" ? "bundled" : "itemized"; setEstimates(p => p.map(e => e.id === viewing.id ? {...e, pricingMode:newMode} : e)); setViewing(v => ({...v, pricingMode:newMode})); }}
                style={{ width:42, height:24, borderRadius:12, background:viewing.pricingMode === "itemized"?"var(--warm-gold)":"var(--stone-300)", cursor:"pointer", position:"relative", transition:"background 0.2s", flexShrink:0 }}>
                <div style={{ position:"absolute", top:3, left:viewing.pricingMode === "itemized"?20:3, width:18, height:18, borderRadius:"50%", background:"white", transition:"left 0.2s", boxShadow:"0 1px 3px rgba(0,0,0,0.2)" }}/>
              </div>
            </div>

            {/* Surcharge Toggle in Viewing Modal */}
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 16px", background:"var(--stone-50)", borderRadius:"var(--radius)", border:"1px solid var(--stone-200)", marginBottom:"12px" }}>
              <div>
                <div style={{ fontSize:"13px", fontWeight:600, color:"var(--stone-800)" }}>3% Card Surcharge <span style={{ fontSize:"11px", color: viewing.surcharge ? "var(--accent-green)" : "var(--stone-400)" }}>{viewing.surcharge ? "● ON" : "● OFF"}</span></div>
                <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:"2px" }}>{viewing.surcharge ? `+$${surchargeAmt.toLocaleString()} added · Total becomes $${total.toLocaleString()}` : "Toggle on to add 3% to client total"}</div>
              </div>
              <div onClick={() => setEstimates(p => p.map(e => e.id === viewing.id ? {...e, surcharge:!e.surcharge} : e)) || setViewing(v => ({...v, surcharge:!v.surcharge}))}
                style={{ width:42, height:24, borderRadius:12, background:viewing.surcharge?"var(--accent-green)":"var(--stone-300)", cursor:"pointer", position:"relative", transition:"background 0.2s", flexShrink:0 }}>
                <div style={{ position:"absolute", top:3, left:viewing.surcharge?20:3, width:18, height:18, borderRadius:"50%", background:"white", transition:"left 0.2s", boxShadow:"0 1px 3px rgba(0,0,0,0.2)" }}/>
              </div>
            </div>

            {/* Hide Material Qty Toggle in Viewing Modal */}
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 16px", background:"var(--stone-50)", borderRadius:"var(--radius)", border:"1px solid var(--stone-200)", marginBottom:"12px" }}>
              <div>
                <div style={{ fontSize:"13px", fontWeight:600, color:"var(--stone-800)" }}>Hide Material Quantities <span style={{ fontSize:"11px", color: viewing.hideMatQty ? "var(--accent-green)" : "var(--stone-400)" }}>{viewing.hideMatQty ? "● ON" : "● OFF"}</span></div>
                <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:"2px" }}>{viewing.hideMatQty ? "Client sees material names only" : "Client sees qty and units on materials"}</div>
              </div>
              <div onClick={() => setEstimates(p => p.map(e => e.id === viewing.id ? {...e, hideMatQty:!e.hideMatQty} : e)) || setViewing(v => ({...v, hideMatQty:!v.hideMatQty}))}
                style={{ width:42, height:24, borderRadius:12, background:viewing.hideMatQty?"var(--accent-green)":"var(--stone-300)", cursor:"pointer", position:"relative", transition:"background 0.2s", flexShrink:0 }}>
                <div style={{ position:"absolute", top:3, left:viewing.hideMatQty?20:3, width:18, height:18, borderRadius:"50%", background:"white", transition:"left 0.2s", boxShadow:"0 1px 3px rgba(0,0,0,0.2)" }}/>
              </div>
            </div>

            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:"8px", flexWrap:"wrap" }}>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                <button className="btn btn-secondary" onClick={() => { setViewing(null); setForm({...viewing}); setModal(viewing); }} style={{ border:"1.5px solid var(--warm-gold)", color:"var(--warm-gold)" }}>
                  <Icon name="edit" size={13}/> Edit
                </button>
                <button className="btn btn-secondary" onClick={openClientView} style={{ border:"1.5px solid var(--accent-blue)", color:"var(--accent-blue)" }}>
                  🖥 Client Preview
                </button>
                <button className="btn btn-secondary" onClick={() => handleDownload(viewing)} disabled={downloadingId === viewing.id} style={{ border:"1.5px solid var(--stone-400)", color:"var(--stone-700)" }}>
                  <Icon name="download" size={13}/> {downloadingId === viewing.id ? "Preparing…" : "Download PDF"}
                </button>
                <button className="btn btn-primary" style={{ background: sendingEmail ? "var(--stone-400)" : "var(--accent-green)", minWidth:140 }}
                  disabled={sendingEmail}
                  onClick={() => sendFromViewing(viewing)}>
                  {sendingEmail
                    ? <><span style={{ display:"inline-block", width:12, height:12, border:"2px solid rgba(255,255,255,0.3)", borderTopColor:"white", borderRadius:"50%", animation:"spin 0.7s linear infinite", marginRight:6 }}/>Sending…</>
                    : <><Icon name="mail" size={14}/> Send to Client</>}
                </button>
              </div>
            </div>
            {/* Email status feedback */}
            {emailStatus === "sent" && (
              <div style={{ marginTop:10, padding:"10px 14px", background:"rgba(74,124,89,0.08)", border:"1px solid rgba(74,124,89,0.25)", borderRadius:"var(--radius)", fontSize:13, color:"var(--accent-green)", display:"flex", alignItems:"center", gap:8 }}>
                ✅ Estimate emailed successfully — client will receive it shortly.
              </div>
            )}
            {emailStatus && emailStatus.startsWith("error:") && (
              <div style={{ marginTop:10, padding:"10px 14px", background:"rgba(185,74,74,0.08)", border:"1px solid rgba(185,74,74,0.25)", borderRadius:"var(--radius)", fontSize:13, color:"#b94a4a", display:"flex", alignItems:"center", gap:8 }}>
                ⚠️ {emailStatus.replace("error:","")}
              </div>
            )}
          </Modal>
        );
      })()}
      {toast && <PipelineToast message={toast.message} actionLabel={toast.actionLabel} onAction={toast.onAction} onClose={() => setToast(null)} />}

      {/* ═══ SCOPE TEMPLATE PANEL (slide-over) ═══ */}
      {tplPanel && (
        <>
          <div onClick={() => setTplPanel(false)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.35)", zIndex:1100 }} />
          <div style={{
            position:"fixed", top:0, right:0, bottom:0, width:"min(480px, 92vw)",
            background:"white", zIndex:1101, boxShadow:"-8px 0 30px rgba(0,0,0,0.15)",
            display:"flex", flexDirection:"column", borderRadius:"16px 0 0 16px", overflow:"hidden",
          }}>
            {/* Panel header */}
            <div style={{ padding:"18px 22px 14px", borderBottom:"1px solid var(--stone-200)", flexShrink:0 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
                <div style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:"var(--stone-900)" }}>Scope Templates</div>
                <button onClick={() => setTplPanel(false)} style={{ background:"none", border:"none", fontSize:20, cursor:"pointer", color:"var(--stone-400)", padding:"4px 8px" }}>✕</button>
              </div>
              <div style={{ display:"flex", gap:4, background:"var(--stone-100)", borderRadius:8, padding:3 }}>
                {[["templates","📋 My Templates"],["past","📄 Past Estimates"],["save","💾 Save Current"]].map(([id,label]) => (
                  <button key={id} onClick={() => { setTplTab(id); setTplSelected({}); setTplExpanded(null); setTplPastExpanded(null); }}
                    style={{ flex:1, padding:"7px 10px", borderRadius:6, border:"none", cursor:"pointer", fontSize:12, fontWeight:600, fontFamily:"var(--font-body)",
                      background: tplTab===id ? "white" : "transparent", color: tplTab===id ? "var(--stone-900)" : "var(--stone-500)",
                      boxShadow: tplTab===id ? "0 1px 4px rgba(0,0,0,0.08)" : "none", transition:"all 0.15s" }}>{label}</button>
                ))}
              </div>
            </div>

            {/* Panel body */}
            <div style={{ flex:1, overflow:"auto", padding:"16px 22px" }}>

              {/* ── My Templates tab ── */}
              {tplTab === "templates" && (
                <div>
                  <input placeholder="Search templates…" value={tplSearch} onChange={e => setTplSearch(e.target.value)}
                    style={{ width:"100%", padding:"8px 12px", border:"1.5px solid var(--stone-200)", borderRadius:8, fontSize:13, fontFamily:"var(--font-body)", marginBottom:12 }} />
                  <div style={{ display:"flex", gap:4, marginBottom:16, flexWrap:"wrap" }}>
                    {TPL_CATEGORIES.map(c => (
                      <button key={c} onClick={() => setTplCatFilter(c)}
                        style={{ padding:"4px 12px", borderRadius:6, border:"none", cursor:"pointer", fontSize:11, fontWeight:600, fontFamily:"var(--font-body)",
                          background: tplCatFilter===c ? "var(--stone-800)" : "var(--stone-100)", color: tplCatFilter===c ? "var(--warm-gold)" : "var(--stone-500)", transition:"all 0.15s" }}>{c}</button>
                    ))}
                  </div>
                  {filteredTpls.length === 0 ? (
                    <div style={{ textAlign:"center", padding:"40px 20px", color:"var(--stone-400)" }}>
                      <div style={{ fontSize:32, marginBottom:8, opacity:0.3 }}>📋</div>
                      <div style={{ fontSize:14, fontWeight:600 }}>{(scopeTemplates||[]).length === 0 ? "No templates yet" : "No matches"}</div>
                      <div style={{ fontSize:12, marginTop:4 }}>{(scopeTemplates||[]).length === 0 ? "Build an estimate, then use Save Current to create your first template." : "Try a different category or search."}</div>
                    </div>
                  ) : filteredTpls.map(tpl => (
                    <div key={tpl.id} style={{ background:"var(--stone-50)", borderRadius:10, border:"1px solid var(--stone-200)", marginBottom:10, overflow:"hidden" }}>
                      <div onClick={() => { setTplExpanded(tplExpanded===tpl.id ? null : tpl.id); setTplSelected({}); }}
                        style={{ padding:"12px 16px", cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                        <div>
                          <div style={{ fontWeight:700, fontSize:14, color:"var(--stone-900)" }}>{tpl.name}</div>
                          <div style={{ fontSize:11, color:"var(--stone-400)", marginTop:2 }}>
                            <span style={{ background:"rgba(201,169,110,0.12)", color:"var(--warm-gold)", padding:"1px 8px", borderRadius:4, fontWeight:600, fontSize:10, marginRight:8 }}>{tpl.category||"Custom"}</span>
                            {tpl.items.length} items · ${getTotal(tpl.items).toLocaleString()}
                          </div>
                        </div>
                        <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                          <button onClick={(e) => { e.stopPropagation(); loadFullTemplate(tpl); }}
                            style={{ padding:"5px 12px", borderRadius:6, border:"none", background:"var(--warm-gold)", color:"white", fontSize:11, fontWeight:700, cursor:"pointer", fontFamily:"var(--font-body)", whiteSpace:"nowrap" }}>Load All</button>
                          <span style={{ fontSize:14, color:"var(--stone-400)", transform: tplExpanded===tpl.id ? "rotate(180deg)" : "rotate(0)", transition:"transform 0.2s", display:"inline-block" }}>▾</span>
                        </div>
                      </div>
                      {tplExpanded === tpl.id && (
                        <div style={{ borderTop:"1px solid var(--stone-200)", padding:"10px 16px 14px" }}>
                          {tpl.items.map((it, i) => (
                            <label key={i} style={{ display:"flex", gap:10, alignItems:"flex-start", padding:"8px 10px", borderRadius:8, cursor:"pointer", marginBottom:4,
                              background: tplSelected[i] ? "rgba(201,169,110,0.08)" : "transparent", border:`1px solid ${tplSelected[i] ? "rgba(201,169,110,0.25)" : "transparent"}`, transition:"all 0.15s" }}>
                              <input type="checkbox" checked={!!tplSelected[i]} onChange={e => setTplSelected(p => ({...p,[i]:e.target.checked}))} style={{ marginTop:2, accentColor:"var(--warm-gold)" }} />
                              <div style={{ flex:1, minWidth:0 }}>
                                <div style={{ fontWeight:600, fontSize:13, color:"var(--stone-900)" }}>{it.desc}</div>
                                {it.laborDesc && <div style={{ fontSize:11, color:"var(--stone-500)", marginTop:2, lineHeight:1.4, fontStyle:"italic", overflow:"hidden", display:"-webkit-box", WebkitLineClamp:2, WebkitBoxOrient:"vertical" }}>{it.laborDesc}</div>}
                                <div style={{ fontSize:11, color:"var(--stone-400)", marginTop:2 }}>
                                  {it.qty} {it.unit} × ${Number(it.price).toLocaleString()} = ${(Number(it.qty)*Number(it.price)).toLocaleString()}
                                  {(it.materials||[]).length > 0 && <span style={{ color:"var(--warm-gold)", marginLeft:8 }}>+{it.materials.length} materials</span>}
                                </div>
                              </div>
                            </label>
                          ))}
                          {Object.values(tplSelected).some(v=>v) && (
                            <button onClick={() => loadSelectedItems(tpl.items, tpl.name)}
                              style={{ width:"100%", padding:8, borderRadius:8, border:"none", background:"var(--stone-800)", color:"var(--warm-gold)", fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"var(--font-body)", marginTop:6 }}>
                              Add {Object.values(tplSelected).filter(v=>v).length} Selected Item{Object.values(tplSelected).filter(v=>v).length>1?"s":""}
                            </button>
                          )}
                          <button onClick={(e) => { e.stopPropagation(); deleteTpl(tpl.id); }}
                            style={{ marginTop:6, background:"none", border:"none", fontSize:11, color:"var(--accent-red)", cursor:"pointer", fontFamily:"var(--font-body)", opacity:0.6 }}>Delete template</button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* ── Past Estimates tab ── */}
              {tplTab === "past" && (
                <div>
                  <input placeholder="Search by customer, project, or ID…" value={tplPastSearch} onChange={e => setTplPastSearch(e.target.value)}
                    style={{ width:"100%", padding:"8px 12px", border:"1.5px solid var(--stone-200)", borderRadius:8, fontSize:13, fontFamily:"var(--font-body)", marginBottom:12 }} />
                  <div style={{ fontSize:11, color:"var(--stone-400)", marginBottom:12 }}>Pick individual line items from any past estimate to reuse.</div>
                  {filteredPastEsts.length === 0 ? (
                    <div style={{ textAlign:"center", padding:"40px 20px", color:"var(--stone-400)" }}>
                      <div style={{ fontSize:32, marginBottom:8, opacity:0.3 }}>📄</div>
                      <div style={{ fontSize:14, fontWeight:600 }}>No estimates found</div>
                    </div>
                  ) : filteredPastEsts.map(est => (
                    <div key={est.id} style={{ background:"var(--stone-50)", borderRadius:10, border:"1px solid var(--stone-200)", marginBottom:10, overflow:"hidden" }}>
                      <div onClick={() => { setTplPastExpanded(tplPastExpanded===est.id ? null : est.id); setTplSelected({}); }}
                        style={{ padding:"12px 16px", cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                        <div>
                          <div style={{ fontWeight:700, fontSize:14, color:"var(--stone-900)" }}>{est.customer} — {est.project}</div>
                          <div style={{ fontSize:11, color:"var(--stone-400)", marginTop:2 }}>
                            <span style={{ background:"rgba(59,130,246,0.1)", color:"var(--accent-blue)", padding:"1px 8px", borderRadius:4, fontWeight:600, fontSize:10, marginRight:8 }}>{est.id}</span>
                            {(est.items||[]).length} items · ${getTotal(est.items||[]).toLocaleString()} · {est.date}
                          </div>
                        </div>
                        <span style={{ fontSize:14, color:"var(--stone-400)", transform: tplPastExpanded===est.id ? "rotate(180deg)" : "rotate(0)", transition:"transform 0.2s", display:"inline-block" }}>▾</span>
                      </div>
                      {tplPastExpanded === est.id && (
                        <div style={{ borderTop:"1px solid var(--stone-200)", padding:"10px 16px 14px" }}>
                          {(est.items||[]).map((it, i) => (
                            <label key={i} style={{ display:"flex", gap:10, alignItems:"flex-start", padding:"8px 10px", borderRadius:8, cursor:"pointer", marginBottom:4,
                              background: tplSelected[i] ? "rgba(201,169,110,0.08)" : "transparent", border:`1px solid ${tplSelected[i] ? "rgba(201,169,110,0.25)" : "transparent"}` }}>
                              <input type="checkbox" checked={!!tplSelected[i]} onChange={e => setTplSelected(p => ({...p,[i]:e.target.checked}))} style={{ marginTop:2, accentColor:"var(--warm-gold)" }} />
                              <div style={{ flex:1, minWidth:0 }}>
                                <div style={{ fontWeight:600, fontSize:13, color:"var(--stone-900)" }}>{it.desc}</div>
                                {it.laborDesc && <div style={{ fontSize:11, color:"var(--stone-500)", marginTop:2, lineHeight:1.4, fontStyle:"italic", overflow:"hidden", display:"-webkit-box", WebkitLineClamp:2, WebkitBoxOrient:"vertical" }}>{it.laborDesc}</div>}
                                <div style={{ fontSize:11, color:"var(--stone-400)", marginTop:2 }}>
                                  {it.qty} {it.unit} × ${Number(it.price).toLocaleString()}
                                  {(it.materials||[]).length > 0 && <span style={{ color:"var(--warm-gold)", marginLeft:8 }}>+{it.materials.length} materials</span>}
                                </div>
                              </div>
                            </label>
                          ))}
                          {Object.values(tplSelected).some(v=>v) && (
                            <button onClick={() => loadSelectedItems(est.items||[], est.id)}
                              style={{ width:"100%", padding:8, borderRadius:8, border:"none", background:"var(--stone-800)", color:"var(--warm-gold)", fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"var(--font-body)", marginTop:6 }}>
                              Add {Object.values(tplSelected).filter(v=>v).length} Selected Item{Object.values(tplSelected).filter(v=>v).length>1?"s":""}
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* ── Save Current tab ── */}
              {tplTab === "save" && (
                <div>
                  <div style={{ fontSize:13, color:"var(--stone-500)", marginBottom:16, lineHeight:1.6 }}>
                    Save your current {form.items.filter(it => it.desc.trim()).length} line item{form.items.filter(it => it.desc.trim()).length !== 1 ? "s" : ""} as a reusable template.
                  </div>
                  {form.items.filter(it => it.desc.trim()).length === 0 ? (
                    <div style={{ textAlign:"center", padding:"32px 20px", background:"var(--stone-50)", borderRadius:10, border:"1px solid var(--stone-200)" }}>
                      <div style={{ fontSize:28, marginBottom:8, opacity:0.3 }}>📋</div>
                      <div style={{ fontSize:14, fontWeight:600, color:"var(--stone-400)" }}>No line items to save</div>
                      <div style={{ fontSize:12, color:"var(--stone-400)", marginTop:4 }}>Add scope items to the estimate first.</div>
                    </div>
                  ) : (
                    <>
                      <div style={{ background:"var(--stone-50)", borderRadius:10, border:"1px solid var(--stone-200)", padding:"14px 16px", marginBottom:16 }}>
                        <div style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--stone-400)", marginBottom:8 }}>Items to save</div>
                        {form.items.filter(it => it.desc.trim()).map((it, i) => (
                          <div key={i} style={{ padding:"6px 0", borderBottom: i < form.items.filter(x=>x.desc.trim()).length-1 ? "1px solid var(--stone-200)" : "none" }}>
                            <div style={{ fontWeight:600, fontSize:13, color:"var(--stone-900)" }}>{it.desc}</div>
                            <div style={{ fontSize:11, color:"var(--stone-400)" }}>{it.qty} {it.unit} × ${Number(it.price).toLocaleString()}{(it.materials||[]).length > 0 ? ` · ${it.materials.length} materials` : ""}</div>
                          </div>
                        ))}
                      </div>
                      <div style={{ marginBottom:12 }}>
                        <label style={{ fontSize:11, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--stone-500)", display:"block", marginBottom:4 }}>Template Name</label>
                        <input value={tplSaveName} onChange={e => setTplSaveName(e.target.value)} placeholder="e.g. Standard Bathroom, Pool Deck…"
                          style={{ width:"100%", padding:"10px 12px", border:"1.5px solid var(--stone-300)", borderRadius:8, fontSize:14, fontWeight:600, fontFamily:"var(--font-body)" }} />
                      </div>
                      <div style={{ marginBottom:16 }}>
                        <label style={{ fontSize:11, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--stone-500)", display:"block", marginBottom:4 }}>Category</label>
                        <div style={{ display:"flex", gap:4, flexWrap:"wrap" }}>
                          {TPL_CATEGORIES.filter(c=>c!=="All").map(c => (
                            <button key={c} onClick={() => setTplSaveCat(c)}
                              style={{ padding:"6px 14px", borderRadius:6, border:"none", cursor:"pointer", fontSize:12, fontWeight:600, fontFamily:"var(--font-body)",
                                background: tplSaveCat===c ? "var(--stone-800)" : "var(--stone-100)", color: tplSaveCat===c ? "var(--warm-gold)" : "var(--stone-500)" }}>{c}</button>
                          ))}
                        </div>
                      </div>
                      <button onClick={saveAsTemplate} disabled={!tplSaveName.trim()}
                        style={{ width:"100%", padding:12, borderRadius:10, border:"none",
                          background: tplSaveName.trim() ? "var(--warm-gold)" : "var(--stone-300)", color: tplSaveName.trim() ? "white" : "var(--stone-500)",
                          fontSize:14, fontWeight:700, cursor: tplSaveName.trim() ? "pointer" : "not-allowed", fontFamily:"var(--font-body)", transition:"all 0.2s" }}>
                        💾 Save Template
                      </button>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

// ── INVOICING ─────────────────────────────────────────────────────────────────
const PAYMENT_METHODS = ["Check", "Zelle", "Cash", "Wire Transfer", "Found Bank", "Stripe", "Venmo", "PayPal", "Other"];

const Invoicing = ({ invoices, setInvoices, jobs, customers, estimates, addNotification, requestDelete }) => {
  const [filter, setFilter] = useState("All");
  const [modal, setModal] = useState(null);
  const [payModal, setPayModal] = useState(null); // { invId, pmtId }
  const [payForm, setPayForm] = useState({ method: "Found Bank", paidDate: "", note: "", sendReceipt: true, amount: "" });
  const [stripeModal, setStripeModal] = useState(null); // { invId, pmtId, label, amount, customer }
  const [splitModal, setSplitModal] = useState(null);   // { invId, pmtId, label, amount }
  const [splitForm, setSplitForm] = useState({ label:"", amount:"", due:"" });
  const [form, setForm] = useState({ customer:"", project:"", contractTotal:"", issued:"", status:"Draft", estimateId:"" });

  // Derived totals using new payments structure
  const getPaidToDate = (inv) => (inv.payments||[]).filter(p=>p.status==="Paid").reduce((s,p)=>s+p.amount,0);
  const getRemaining = (inv) => (inv.contractTotal||0) - getPaidToDate(inv);
  const getInvStatus = (inv) => {
    const pmts = inv.payments || [];
    if (pmts.every(p=>p.status==="Paid")) return "Paid";
    if (pmts.some(p=>p.status==="Paid")) return "Partial";
    const today = new Date().toISOString().slice(0,10);
    if (pmts.some(p=>p.status!=="Paid" && p.due < today)) return "Overdue";
    return inv.status || "Invoiced";
  };

  const filtered = invoices.filter(inv => {
    if (filter === "All") return true;
    return getInvStatus(inv) === filter;
  });

  const totalCollected = filtered.reduce((s,inv) => s + getPaidToDate(inv), 0);
  const totalOutstanding = filtered.reduce((s,inv) => s + Math.max(getRemaining(inv), 0), 0);
  const totalOverdue = filtered.filter(inv => getInvStatus(inv)==="Overdue").reduce((s,inv)=>s+getRemaining(inv),0);

  const recordPayment = () => {
    if (!payModal) return;
    const inv = invoices.find(i => i.id === payModal.invId);
    const enteredAmount = Number(payForm.amount) || payModal.amount;
    setInvoices(p => p.map(inv => {
      if (inv.id !== payModal.invId) return inv;
      const milestone = inv.payments.find(pmt => pmt.id === payModal.pmtId);
      const milestoneAmount = milestone?.amount || 0;
      const isPartial = enteredAmount < milestoneAmount;

      let updatedPmts = inv.payments.map(pmt => {
        if (pmt.id !== payModal.pmtId) return pmt;
        return { ...pmt, amount: enteredAmount, status:"Paid", paidDate: payForm.paidDate || new Date().toISOString().slice(0,10), method: payForm.method, note: payForm.note };
      });

      // If partial payment, create a new pending milestone for the remainder
      if (isPartial) {
        const remainder = milestoneAmount - enteredAmount;
        const remainderLabel = (milestone?.label || "Payment") + " (Remaining)";
        const remainderPmt = {
          id: `pmt-${Date.now()}`,
          label: remainderLabel,
          amount: remainder,
          due: milestone?.due || "",
          status: "Pending",
          paidDate: null,
          method: "",
          note: ""
        };
        // Insert the remainder right after the paid milestone
        const paidIdx = updatedPmts.findIndex(pmt => pmt.id === payModal.pmtId);
        updatedPmts.splice(paidIdx + 1, 0, remainderPmt);
      }

      const allPaid = updatedPmts.every(p=>p.status==="Paid");
      if (addNotification) {
        addNotification("invoice", `✅ ${inv.id} · $${enteredAmount.toLocaleString()} received · ${payForm.method}${isPartial ? ` (partial — $${(milestoneAmount - enteredAmount).toLocaleString()} remaining)` : ""}`, "invoicing");
      }
      return { ...inv, payments: updatedPmts, status: allPaid ? "Paid" : "Invoiced" };
    }));
    // Send receipt email if checkbox is checked
    if (payForm.sendReceipt && inv) {
      fetch('/api/record-client-payment', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          estimateId: inv.estimate_id || inv.id,
          customer: inv.customer, project: inv.project,
          amount: enteredAmount, type: 'manual',
          paymentIntentId: `Manual-${payForm.method}`, sendReceipt: true
        })
      }).then(r => r.json()).then(d => {
        if (d.receiptSent && addNotification) addNotification("invoice", `📧 Receipt sent to ${inv.customer}`, "invoicing");
      }).catch(() => {});
    }
    setPayModal(null);
    setPayForm({ method:"Found Bank", paidDate:"", note:"", sendReceipt: true, amount: "" });
  };

  // ── Split a pending milestone into two draws ───────────────────────────────
  // The two amounts always sum to the original, so contract_total never moves.
  // Splitting changes WHEN money is due, never HOW MUCH.
  const applySplit = () => {
    if (!splitModal) return;
    const origAmt = Math.round(Number(splitModal.amount) * 100) / 100;
    const drawAmt = Math.round(Number(splitForm.amount) * 100) / 100;
    if (!(drawAmt > 0) || drawAmt >= origAmt) return;

    setInvoices(p => p.map(inv => {
      if (inv.id !== splitModal.invId) return inv;
      const pmts = inv.payments || [];
      const idx = pmts.findIndex(pmt => pmt.id === splitModal.pmtId);
      if (idx === -1) return inv;
      const orig = pmts[idx];
      if (orig.status === "Paid") return inv;   // never split money already collected

      const drawPmt = {
        id: `pmt-${Date.now()}`,
        label: (splitForm.label || "").trim() || "Draw",
        amount: drawAmt,
        due: splitForm.due || orig.due || "",
        status: "Pending", paidDate: null, method: "", note: ""
      };
      // Remainder keeps the original milestone's id, label and due date
      const remainderPmt = { ...orig, amount: Math.round((origAmt - drawAmt) * 100) / 100 };

      const updated = [...pmts];
      updated.splice(idx, 1, drawPmt, remainderPmt);   // new draw first — it's due sooner

      if (addNotification) {
        addNotification("invoice", `✂️ ${inv.display_id || inv.id} · ${drawPmt.label} $${drawAmt.toLocaleString()} split from ${orig.label} · balance $${remainderPmt.amount.toLocaleString()}`, "invoicing");
      }
      return { ...inv, payments: updated };
    }));
    setSplitModal(null);
    setSplitForm({ label:"", amount:"", due:"" });
  };

  const save = () => {
    const total = Number(form.contractTotal);
    const half = Math.round(total / 2);
    const today = new Date().toISOString().slice(0,10);
    const { estimateId, ...rest } = form;          // estimateId is form-only; DB column is estimate_id
    const estLink = estimateId || null;
    if (modal === "add") {
      // max existing number, NOT row count — count reuses IDs after a delete
      const maxNum = (invoices||[]).reduce((m, i) => {
        const n = parseInt(String(i.id || "").replace(/\D/g, ""), 10);
        return Number.isFinite(n) && n > m ? n : m;
      }, 0);
      const invId = `INV-${String(maxNum + 1).padStart(3,"0")}`;
      setInvoices(p => [...p, {
        ...rest, id: invId, display_id: invId,
        contractTotal: total, estimate_id: estLink,
        payments: [
          { id:"pmt-1", label:"Deposit (50%)", amount:half, due: form.issued || today, status:"Pending", paidDate:null, method:"", note:"" },
          { id:"pmt-2", label:"Balance (50%)", amount:total-half, due:"", status:"Pending", paidDate:null, method:"", note:"" },
        ]
      }]);
    } else {
      setInvoices(p => p.map(inv => inv.id === modal.id ? { ...inv, ...rest, contractTotal: total, estimate_id: estLink ?? inv.estimate_id ?? null } : inv));
    }
    setModal(null);
  };

  const statusColor = { "Paid":"var(--accent-green)", "Partial":"var(--accent-blue)", "Overdue":"var(--accent-red)", "Invoiced":"var(--accent-amber)", "Draft":"var(--stone-400)" };

  return (
    <div className="fade-in" style={{ minHeight: "calc(100vh - 120px)" }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:"20px", flexWrap:"wrap", gap:"12px" }}>
        <div><h1 className="section-title">Invoicing</h1><p className="section-sub">Track payments and outstanding balances.</p></div>
        <button className="btn btn-primary" onClick={() => { setForm({ customer:"", project:"", contractTotal:"", issued:new Date().toISOString().slice(0,10), status:"Draft", estimateId:"" }); setModal("add"); }}><Icon name="plus" size={14} /> New Invoice</button>
      </div>

      {/* Summary cards */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))", gap:"14px", marginBottom:"20px" }}>
        <div className="stat-card"><div className="stat-value" style={{ fontSize:"26px", color:"var(--accent-green)" }}>${totalCollected.toLocaleString()}</div><div className="stat-label">{filter === "All" ? "Total Collected" : `Collected (${filter})`}</div></div>
        <div className="stat-card"><div className="stat-value" style={{ fontSize:"26px", color:"var(--accent-amber)" }}>${totalOutstanding.toLocaleString()}</div><div className="stat-label">{filter === "All" ? "Outstanding" : `Outstanding (${filter})`}</div></div>
        <div className="stat-card"><div className="stat-value" style={{ fontSize:"26px", color:"var(--accent-red)" }}>${totalOverdue.toLocaleString()}</div><div className="stat-label">{filter === "All" ? "Overdue" : `Overdue (${filter})`}</div></div>
      </div>

      {/* Filter tabs */}
      <div style={{ display:"flex", gap:"8px", marginBottom:"16px", flexWrap:"wrap" }}>
        {["All","Invoiced","Partial","Paid","Overdue","Draft"].map(s => (
          <button key={s} className="btn btn-sm" style={{ background:filter===s?"var(--warm-gold)":"var(--stone-200)", color:filter===s?"white":"var(--stone-700)" }} onClick={() => setFilter(s)}>{s}</button>
        ))}
      </div>

      {/* Invoice cards */}
      <div style={{ display:"flex", flexDirection:"column", gap:"14px" }}>
        {filtered.map(inv => {
          const paidToDate = getPaidToDate(inv);
          const remaining = getRemaining(inv);
          const invStatus = getInvStatus(inv);
          const pct = (inv.contractTotal||0) > 0 ? Math.round((paidToDate / (inv.contractTotal||1)) * 100) : 0;
          return (
            <div key={inv.id} className="card" style={{ padding:0, overflow:"hidden" }}>
              {/* Invoice header */}
              <div style={{ padding:"16px 20px", display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:"10px", borderBottom:"1px solid var(--stone-100)" }}>
                <div>
                  <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"4px" }}>
                    <span style={{ fontWeight:700, color:"var(--warm-gold)", fontSize:"15px" }}>{inv.display_id || inv.id}</span>
                    <span style={{ background: statusColor[invStatus] + "22", color: statusColor[invStatus], fontSize:"11px", fontWeight:700, padding:"2px 8px", borderRadius:99 }}>{invStatus}</span>
                    {inv.jobId && <span style={{ fontSize:"11px", color:"var(--stone-400)" }}>Job #{inv.jobId}</span>}
                  </div>
                  <div style={{ fontWeight:600, fontSize:"14px" }}>{inv.customer}</div>
                  <div style={{ fontSize:"13px", color:"var(--stone-500)" }}>{inv.project}</div>
                  <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:"3px" }}>Issued {inv.issued}</div>
                </div>
                <div style={{ textAlign:"right" }}>
                  <div style={{ fontFamily:"var(--font-display)", fontSize:"22px", fontWeight:700, color:"var(--stone-900)" }}>${(inv.contractTotal||0).toLocaleString()}</div>
                  <div style={{ fontSize:"12px", color:"var(--accent-green)", fontWeight:600 }}>${paidToDate.toLocaleString()} paid</div>
                  <div style={{ fontSize:"12px", color: remaining>0?"var(--accent-amber)":"var(--accent-green)", fontWeight:600 }}>{remaining<0?`Overpaid $${Math.abs(remaining).toLocaleString()}`:`$${remaining.toLocaleString()} remaining`}</div>
                </div>
              </div>

              {/* Progress bar */}
              <div style={{ height:5, background:"var(--stone-100)" }}>
                <div style={{ height:"100%", width:`${pct}%`, background: pct===100?"var(--accent-green)":"var(--warm-gold)", transition:"width 0.4s ease", borderRadius:"0 4px 4px 0" }}/>
              </div>

              {/* Payment milestones */}
              <div style={{ padding:"14px 20px" }}>
                <div style={{ fontSize:"11px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--stone-400)", marginBottom:"10px" }}>Payment Schedule</div>
                <div style={{ display:"flex", flexDirection:"column", gap:"8px" }}>
                  {(inv.payments||[]).map((pmt, i) => (
                    <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 14px", background: pmt.status==="Paid"?"rgba(74,156,109,0.06)":"var(--stone-50)", borderRadius:"var(--radius)", border:`1px solid ${pmt.status==="Paid"?"rgba(74,156,109,0.2)":"var(--stone-200)"}` }}>
                      <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
                        <div style={{ width:28, height:28, borderRadius:"50%", background: pmt.status==="Paid"?"var(--accent-green)":"var(--stone-200)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"12px", flexShrink:0 }}>
                          {pmt.status==="Paid" ? "✓" : (i+1)}
                        </div>
                        <div>
                          <div style={{ fontWeight:600, fontSize:"13px" }}>{pmt.label}</div>
                          {pmt.status==="Paid"
                            ? <div style={{ fontSize:"11px", color:"var(--accent-green)" }}>Received {pmt.paidDate} · {pmt.method}{pmt.note ? ` · ${pmt.note}` : ""}</div>
                            : <div style={{ fontSize:"11px", color:"var(--stone-400)" }}>Due {pmt.due || "upon completion"}</div>
                          }
                        </div>
                      </div>
                      <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
                        <span style={{ fontFamily:"var(--font-display)", fontSize:"17px", fontWeight:700, color: pmt.status==="Paid"?"var(--accent-green)":"var(--stone-700)" }}>${pmt.amount.toLocaleString()}</span>
                        {pmt.status !== "Paid" && (
                          <div style={{ display:"flex", gap:6 }}>
                            <button onClick={() => { setSplitModal({ invId:inv.id, pmtId:pmt.id, label:pmt.label, amount:pmt.amount }); setSplitForm({ label:`Draw ${i+1}`, amount:String(Math.round(pmt.amount/2)), due:"" }); }}
                              title="Split this milestone into two draws"
                              style={{ background:"white", color:"var(--warm-gold)", border:"1px solid var(--warm-gold)", borderRadius:"var(--radius)", padding:"5px 10px", fontSize:"12px", cursor:"pointer", fontWeight:600, whiteSpace:"nowrap" }}>
                              ✂ Split
                            </button>
                            <button onClick={() => setStripeModal({ invId:inv.id, pmtId:pmt.id, label:pmt.label, amount:pmt.amount, customer:inv.customer })}
                              style={{ background:"#635bff", color:"white", border:"none", borderRadius:"var(--radius)", padding:"5px 12px", fontSize:"12px", cursor:"pointer", fontWeight:600, whiteSpace:"nowrap", display:"flex", alignItems:"center", gap:4 }}>
                              💳 Charge Card
                            </button>
                            <button onClick={() => { setPayModal({ invId:inv.id, pmtId:pmt.id, label:pmt.label, amount:pmt.amount, customer:inv.customer }); setPayForm({ method:"Found Bank", paidDate:new Date().toISOString().slice(0,10), note:"", sendReceipt:true, amount:String(pmt.amount) }); }}
                              style={{ background:"var(--accent-green)", color:"white", border:"none", borderRadius:"var(--radius)", padding:"5px 12px", fontSize:"12px", cursor:"pointer", fontWeight:600, whiteSpace:"nowrap" }}>
                              <Icon name="check" size={11} color="white" /> Record Payment
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Footer actions */}
              <div style={{ padding:"10px 20px", borderTop:"1px solid var(--stone-100)", display:"flex", justifyContent:"space-between", gap:"6px", background:"var(--stone-50)" }}>
                <div style={{ display:"flex", gap:"6px" }}>
                  <button className="btn-icon" title="Edit" onClick={() => { setForm({ customer:inv.customer, project:inv.project, contractTotal:inv.contractTotal, issued:inv.issued, status:inv.status, estimateId: inv.estimate_id || "" }); setModal(inv); }}><Icon name="edit" size={14}/></button>
                  <button className="btn-icon" title="Delete" onClick={() => requestDelete("invoices", inv)}><Icon name="trash" size={14} color="var(--accent-red)"/></button>
                </div>
                {getPaidToDate(inv) > 0 && (() => { const job = (jobs||[]).find(j => j.id === inv.jobId || j.id === inv.job_id); const est = (estimates||[]).find(e => e.id === (inv.estimate_id || job?.estimateId)); const custRec = (customers||[]).find(c => c.name?.toLowerCase() === inv.customer?.toLowerCase()); const buildReceiptUrl = () => { const payload = { invoiceId: inv.display_id||inv.id, estimateId: est?.id||inv.estimate_id||"", customer: inv.customer, customerAddress: custRec?.address||"", customerEmail: custRec?.email||"", project: inv.project, startDate: job?.startDate||job?.start_date||"", endDate: job?.endDate||job?.end_date||"", items: est?.items||[], payments: inv.payments||[], contractTotal: inv.contractTotal||inv.contract_total||0, paidToDate: getPaidToDate(inv), surcharge: est?.surcharge||false, surchargeAmt: est?.surcharge ? Math.round((est.override_total||est.items?.reduce((s,i)=>s+(Number(i.qty||0)*Number(i.price||0)),0)||0)*0.03) : 0, crew: job?.crew||job?.crewName||"", notes: "" }; return `${window.location.origin}/api/project-receipt?d=${encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(payload)))))}`; }; return <div style={{ display:"flex", gap:"6px" }}>
                  <button onClick={() => window.open(buildReceiptUrl(), "_blank")} style={{ background:"#6b5b3e", color:"white", border:"none", borderRadius:"var(--radius)", padding:"4px 10px", fontSize:"11px", cursor:"pointer", fontWeight:600, display:"flex", alignItems:"center", gap:"4px" }}>🧾 Receipt</button>
                  {custRec?.email && <button onClick={async () => { const url = buildReceiptUrl(); try { const r = await fetch("/api/send-estimate-email", { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({ to: custRec.email, customerName: inv.customer, customerAddress: custRec.address||"", estimateId: inv.display_id||inv.id, project: inv.project, total: inv.contractTotal||0, deposit: 0, estimateUrl: url, surcharge: false, surchargeAmt: 0, isReceipt: true }) }); if (r.ok) { if (addNotification) addNotification("invoice", `📧 Project receipt emailed to ${inv.customer}`, "invoicing"); } else { if (addNotification) addNotification("invoice", `⚠️ Failed to send receipt email`, "invoicing"); } } catch(e) { if (addNotification) addNotification("invoice", `⚠️ Email error: ${e.message}`, "invoicing"); } }} style={{ background:"var(--accent-green)", color:"white", border:"none", borderRadius:"var(--radius)", padding:"4px 10px", fontSize:"11px", cursor:"pointer", fontWeight:600, display:"flex", alignItems:"center", gap:"4px" }}><Icon name="mail" size={11} color="white"/> Email</button>}
                </div>; })()}
              </div>
            </div>
          );
        })}
        {filtered.length === 0 && <div className="empty-state"><div style={{ fontSize:36, marginBottom:8 }}>🧾</div><div>No invoices found.</div></div>}
      </div>

      {/* ── Split Draw Modal ── */}
      {splitModal && (() => {
        const origAmt = Number(splitModal.amount) || 0;
        const drawAmt = Number(splitForm.amount);
        const valid = drawAmt > 0 && drawAmt < origAmt;
        const remainder = valid ? Math.round((origAmt - drawAmt) * 100) / 100 : 0;
        return (
          <Modal title={`Split Draw — ${splitModal.label}`} onClose={() => setSplitModal(null)}>
            <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius)", padding:"12px 16px", marginBottom:"16px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div style={{ fontSize:"13px", color:"var(--stone-500)" }}>Splitting</div>
              <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700 }}>${origAmt.toLocaleString()}</div>
            </div>

            <div className="form-grid">
              <div className="form-group form-full"><label>This draw — label</label>
                <input value={splitForm.label} onChange={e => setSplitForm(p=>({...p,label:e.target.value}))} placeholder="e.g. Draw 3 — tile set" />
              </div>
              <div className="form-group"><label>Amount ($)</label>
                <input type="number" step="0.01" value={splitForm.amount} onChange={e => setSplitForm(p=>({...p,amount:e.target.value}))} />
              </div>
              <div className="form-group"><label>Due date (optional)</label>
                <input type="date" value={splitForm.due} onChange={e => setSplitForm(p=>({...p,due:e.target.value}))} />
              </div>
            </div>

            {!valid && splitForm.amount !== "" && (
              <div style={{ background:"rgba(196,74,74,0.08)", border:"1px solid rgba(196,74,74,0.25)", borderRadius:"var(--radius)", padding:"10px 14px", marginBottom:"14px", fontSize:"12px", color:"var(--accent-red)" }}>
                Enter an amount greater than $0 and less than ${origAmt.toLocaleString()}.
              </div>
            )}

            {valid && (
              <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius)", padding:"12px 16px", marginBottom:"16px" }}>
                <div style={{ display:"flex", justifyContent:"space-between", fontSize:"13px", marginBottom:"6px" }}>
                  <span style={{ color:"var(--stone-500)" }}>{(splitForm.label || "").trim() || "Draw"}</span>
                  <strong>${drawAmt.toLocaleString(undefined,{minimumFractionDigits:2})}</strong>
                </div>
                <div style={{ display:"flex", justifyContent:"space-between", fontSize:"13px" }}>
                  <span style={{ color:"var(--stone-500)" }}>{splitModal.label}</span>
                  <strong>${remainder.toLocaleString(undefined,{minimumFractionDigits:2})}</strong>
                </div>
                <div style={{ display:"flex", justifyContent:"space-between", fontSize:"12px", borderTop:"1px solid var(--stone-200)", marginTop:"8px", paddingTop:"8px", color:"var(--accent-green)" }}>
                  <span>Contract total unchanged</span>
                  <span>✓ ${origAmt.toLocaleString()}</span>
                </div>
              </div>
            )}

            <div style={{ display:"flex", justifyContent:"flex-end", gap:"8px" }}>
              <button className="btn btn-secondary" onClick={() => setSplitModal(null)}>Cancel</button>
              <button className="btn btn-primary" onClick={applySplit} disabled={!valid} style={!valid ? { opacity:0.5, cursor:"not-allowed" } : {}}>
                <Icon name="check" size={14}/> Create Draw
              </button>
            </div>
          </Modal>
        );
      })()}

      {/* ── Record Payment Modal ── */}
      {payModal && (
        <Modal title={`Record Payment — ${payModal.label}`} onClose={() => setPayModal(null)}>
          <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius)", padding:"14px 16px", marginBottom:"16px" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"12px" }}>
              <div>
                <div style={{ fontSize:"13px", color:"var(--stone-500)" }}>{payModal.customer}</div>
                <div style={{ fontWeight:700, fontSize:"15px" }}>{payModal.label}</div>
              </div>
              <div style={{ textAlign:"right" }}>
                <div style={{ fontSize:"11px", color:"var(--stone-400)", marginBottom:2 }}>Milestone Amount</div>
                <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, color:"var(--stone-500)" }}>${payModal.amount?.toLocaleString()}</div>
              </div>
            </div>
            <div>
              <label style={{ fontSize:"12px", fontWeight:600, color:"var(--stone-600)", marginBottom:4, display:"block" }}>Amount Received ($)</label>
              <input type="number" step="0.01" value={payForm.amount} onChange={e => setPayForm(p=>({...p,amount:e.target.value}))} placeholder={String(payModal.amount)} style={{ width:"100%", padding:"10px 14px", border:"2px solid var(--warm-gold)", borderRadius:"var(--radius)", fontSize:"18px", fontWeight:700, fontFamily:"var(--font-display)", textAlign:"right", background:"white" }} />
            </div>
            {Number(payForm.amount) > 0 && Number(payForm.amount) < payModal.amount && (
              <div style={{ marginTop:"8px", fontSize:"12px", color:"var(--accent-amber)", background:"rgba(196,148,74,0.1)", border:"1px solid rgba(196,148,74,0.25)", borderRadius:6, padding:"8px 12px", display:"flex", alignItems:"center", gap:6 }}>
                ⚠️ Partial payment — a remaining balance of <strong>${(payModal.amount - Number(payForm.amount)).toLocaleString(undefined, {minimumFractionDigits:2})}</strong> will be created as a pending milestone.
              </div>
            )}
            {Number(payForm.amount) > payModal.amount && (
              <div style={{ marginTop:"8px", fontSize:"12px", color:"var(--accent-blue)", background:"rgba(107,140,174,0.1)", border:"1px solid rgba(107,140,174,0.25)", borderRadius:6, padding:"8px 12px", display:"flex", alignItems:"center", gap:6 }}>
                ℹ️ Amount exceeds milestone — overpayment of <strong>${(Number(payForm.amount) - payModal.amount).toLocaleString(undefined, {minimumFractionDigits:2})}</strong> will be recorded.
              </div>
            )}
          </div>
          <div className="form-grid">
            <div className="form-group"><label>Payment Method</label>
              <select value={payForm.method} onChange={e => setPayForm(p=>({...p,method:e.target.value}))}>
                {PAYMENT_METHODS.map(m => <option key={m}>{m}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Date Received</label>
              <input type="date" value={payForm.paidDate} onChange={e => setPayForm(p=>({...p,paidDate:e.target.value}))} />
            </div>
            <div className="form-group form-full"><label>Note (optional)</label>
              <input placeholder="e.g. Check #1042, Zelle confirmation..." value={payForm.note} onChange={e => setPayForm(p=>({...p,note:e.target.value}))} />
            </div>
            <div className="form-group form-full">
              <label style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:13 }}>
                <input type="checkbox" checked={payForm.sendReceipt} onChange={e => setPayForm(p=>({...p,sendReceipt:e.target.checked}))} style={{ width:16, height:16, accentColor:"var(--accent-green)" }} />
                Send payment receipt email to client
              </label>
            </div>
          </div>
          <div style={{ display:"flex", justifyContent:"flex-end", gap:"8px" }}>
            <button className="btn btn-secondary" onClick={() => setPayModal(null)}>Cancel</button>
            <button className="btn btn-primary" style={{ background:"var(--accent-green)" }} onClick={recordPayment} disabled={!payForm.amount || Number(payForm.amount) <= 0}><Icon name="check" size={14}/> Confirm ${Number(payForm.amount) > 0 ? `$${Number(payForm.amount).toLocaleString()}` : ""} Payment</button>
          </div>
        </Modal>
      )}

      {/* ── Stripe Payment Modal ── */}
      {stripeModal && (
        <StripePaymentModal
          amount={stripeModal.amount}
          label={stripeModal.label}
          metadata={{ estimateId: stripeModal.invId, customer: stripeModal.customer, project: stripeModal.label }}
          onSuccess={(pi) => {
            // Auto-record the payment after Stripe confirms
            setInvoices(prev => prev.map(inv => {
              if (inv.id !== stripeModal.invId) return inv;
              return {
                ...inv,
                payments: (inv.payments||[]).map(p =>
                  p.id === stripeModal.pmtId
                    ? { ...p, status:"Paid", method:"Stripe", paidDate: new Date().toISOString().slice(0,10), note:"Stripe · " + (pi?.id||"") }
                    : p
                )
              };
            }));
            if (addNotification) addNotification("invoice", "💳 Stripe payment received · " + stripeModal.customer + " · $" + stripeModal.amount.toLocaleString(), "invoicing");
            setStripeModal(null);
          }}
          onClose={() => setStripeModal(null)}
        />
      )}

      {/* ── Add/Edit Invoice Modal ── */}
      {modal && (
        <Modal title={modal==="add"?"New Invoice":`Edit ${modal.id}`} onClose={() => setModal(null)}>
          <div className="form-grid">
            <div className="form-group"><label>Customer</label>
              <select value={form.customer} onChange={e => setForm(p=>({...p,customer:e.target.value}))}>
                <option value="">Select customer</option>
                {customers.map(c => <option key={c.id}>{c.name}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Project</label><input value={form.project} onChange={e => setForm(p=>({...p,project:e.target.value}))} /></div>
            <div className="form-group"><label>Contract Total ($)</label><input type="number" value={form.contractTotal} onChange={e => setForm(p=>({...p,contractTotal:e.target.value}))} /></div>
            <div className="form-group"><label>Issue Date</label><input type="date" value={form.issued} onChange={e => setForm(p=>({...p,issued:e.target.value}))} /></div>
            <div className="form-group form-full"><label>Linked Estimate</label>
              <select value={form.estimateId} onChange={e => setForm(p=>({...p,estimateId:e.target.value}))}>
                <option value="">— none —</option>
                {(estimates||[])
                  .filter(e => !form.customer || e.customer?.toLowerCase() === form.customer.toLowerCase())
                  .map(e => <option key={e.id} value={e.id}>{e.id} · {e.project}</option>)}
              </select>
              <div style={{ fontSize:"11px", color:"var(--stone-500)", marginTop:"4px" }}>
                Required for draw / progress invoices — this is what makes payments show up on the client's estimate page.
              </div>
            </div>
          </div>
          {form.contractTotal > 0 && (
            <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius)", padding:"12px 14px", marginBottom:"14px", fontSize:"13px", color:"var(--stone-600)" }}>
              <strong>50/50 Split Preview:</strong> Deposit ${Math.round(Number(form.contractTotal)/2).toLocaleString()} · Balance ${(Number(form.contractTotal) - Math.round(Number(form.contractTotal)/2)).toLocaleString()}
            </div>
          )}
          <div style={{ display:"flex", justifyContent:"flex-end", gap:"8px" }}>
            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancel</button>
            <button className="btn btn-primary" onClick={save}><Icon name="check" size={14}/> Save Invoice</button>
          </div>
        </Modal>
      )}
    </div>
  );
};

// ── MATERIALS & SUPPLY TRACKER ────────────────────────────────────────────────
const MAT_CATS = {
  "Tile":            { color:"var(--warm-gold)",    bg:"rgba(196,149,74,0.12)",  icon:"🏛️" },
  "Adhesive/Grout":  { color:"var(--accent-blue)",  bg:"rgba(74,123,196,0.12)",  icon:"🪣" },
  "Backer/Membrane": { color:"#7b6bc4",             bg:"rgba(123,107,196,0.12)", icon:"📐" },
  "Tools":           { color:"var(--stone-600)",    bg:"rgba(100,95,85,0.12)",   icon:"🔧" },
  "Subcontractor":   { color:"var(--accent-amber)", bg:"rgba(196,148,74,0.12)",  icon:"👷" },
  "Other":           { color:"var(--stone-500)",    bg:"rgba(140,132,120,0.12)", icon:"📦" },
};
const MAT_SUPPLIERS = ["The Tile Shop","Home Depot","Lowe's","Floor & Decor","Local Vendor","Other"];

const Materials = ({ materials, setMaterials, jobs, invoices, currentUser }) => {
  const [view, setView]         = useState("job");   // "job" | "pl"
  const [activeJob, setActiveJob] = useState(jobs[0]?.id || null);
  const [catFilter, setCatFilter] = useState("All");
  const [catTimeframe, setCatTimeframe] = useState("all");
  const [modal, setModal]       = useState(false);
  const [form, setForm]         = useState({ jobId:"", invId:"", item:"", cat:"Tile", supplier:"The Tile Shop", qty:1, price:"", date:new Date().toISOString().slice(0,10), ref:"", reimb:false });

  const isOwnerAdmin = currentUser?.role === "owner" || currentUser?.role === "admin";
  const lt  = e => Number(e.qty) * Number(e.price);
  const fmt = n => "$" + Number(n).toLocaleString("en-US", { minimumFractionDigits:2, maximumFractionDigits:2 });
  const fmtK = n => n >= 1000 ? "$" + (n/1000).toFixed(1) + "k" : fmt(n);

  const jobEntries = (id) => materials.filter(e => e.jobId === id);
  const jobSpend   = (id) => jobEntries(id).reduce((s,e) => s + lt(e), 0);
  const invSpend   = (id) => materials.filter(e => e.invId === id).reduce((s,e) => s + lt(e), 0);

  const jobInvoices = (jobId) => invoices.filter(i => i.jobId === jobId);

  // ── Summary stats ──
  const totalSpend  = materials.reduce((s,e) => s + lt(e), 0);
  const totalBudget = jobs.reduce((s,j) => s + (Number(j.cost)||0), 0);
  const reimb       = materials.filter(e=>e.reimb).reduce((s,e)=>s+lt(e),0);
  const overCount   = jobs.filter(j=>jobSpend(j.id)>(Number(j.cost)||0)&&(Number(j.cost)||0)>0).length;

  const openModal = () => {
    const jobId = activeJob || jobs[0]?.id || "";
    const jobInvs = jobInvoices(jobId);
    setForm({ jobId, invId: jobInvs.length===1 ? jobInvs[0].id : "", item:"", cat:"Tile", supplier:"The Tile Shop", qty:1, price:"", date:new Date().toISOString().slice(0,10), ref:"", reimb:false });
    setModal(true);
  };

  const save = () => {
    if (!form.item || !form.price || !form.qty) return;
    const newEntry = { ...form, id: Date.now(), qty: Number(form.qty), price: Number(form.price) };
    setMaterials(p => [...p, newEntry]);
    setModal(false);
  };

  const del = (id) => setMaterials(p => p.filter(e => e.id !== id));

  // Update invoice dropdown when job changes
  const handleJobChange = (jobId) => {
    const jid = Number(jobId);
    const jobInvs = jobInvoices(jid);
    setForm(p => ({ ...p, jobId: jid, invId: jobInvs.length===1 ? jobInvs[0].id : "" }));
  };

  const filteredEntries = jobEntries(activeJob).filter(e => catFilter==="All" || e.cat===catFilter);

  // ── Breakdowns ──
  const byCat = (es) => {
    const m = {};
    es.forEach(e => { m[e.cat] = (m[e.cat]||0) + lt(e); });
    return Object.entries(m).sort((a,b)=>b[1]-a[1]);
  };
  const byInv = (es) => {
    const m = {};
    es.forEach(e => { const k = e.invId||"Unlinked"; m[k] = (m[k]||0) + lt(e); });
    return Object.entries(m).sort((a,b)=>b[1]-a[1]);
  };

  const TIMEFRAMES = [
    { id:"all",   label:"All Time" },
    { id:"30",    label:"Last 30 Days" },
    { id:"60",    label:"Last 60 Days" },
    { id:"90",    label:"Last 90 Days" },
    { id:"ytd",   label:"Year to Date" },
  ];
  const applyTimeframe = (es) => {
    if (catTimeframe === "all") return es;
    const now = new Date();
    if (catTimeframe === "ytd") {
      const jan1 = new Date(now.getFullYear(), 0, 1).toISOString().slice(0,10);
      return es.filter(e => e.date >= jan1);
    }
    const days = Number(catTimeframe);
    const cutoff = new Date(now - days * 24 * 60 * 60 * 1000).toISOString().slice(0,10);
    return es.filter(e => e.date >= cutoff);
  };

  const activeJobObj = jobs.find(j=>j.id===activeJob);

  return (
    <div className="fade-in" style={{ minHeight: "calc(100vh - 120px)" }}>
      {/* Header */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:"20px", flexWrap:"wrap", gap:"12px" }}>
        <div>
          <h1 className="section-title">Materials & Supplies</h1>
          <p className="section-sub">Purchase costs linked to jobs and invoices. Full P&L per project.</p>
        </div>
        {isOwnerAdmin && <button className="btn btn-primary" onClick={openModal}><Icon name="plus" size={14}/> Add Material</button>}
      </div>

      {/* View toggle */}
      <div style={{ display:"flex", background:"var(--stone-200)", borderRadius:"var(--radius-lg)", padding:"4px", gap:"4px", width:"fit-content", marginBottom:"24px" }}>
        {[["job","📦 Job View"],["pl","📈 P&L View"]].map(([v,label]) => (
          <button key={v} onClick={() => setView(v)} style={{ padding:"8px 18px", borderRadius:"var(--radius)", fontSize:"13px", fontWeight:600, cursor:"pointer", border:"none", fontFamily:"var(--font-body)", background: view===v?"white":"transparent", color: view===v?"var(--stone-900)":"var(--stone-500)", boxShadow: view===v?"0 1px 4px rgba(0,0,0,0.1)":"none", transition:"all 0.2s" }}>{label}</button>
        ))}
      </div>

      {/* ── JOB VIEW ── */}
      {view === "job" && (<>
        {/* Stats */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:"14px", marginBottom:"24px" }}>
          <div className="stat-card"><div className="stat-value">{fmtK(totalSpend)}</div><div className="stat-label">Total Material Spend</div></div>
          <div className="stat-card"><div className="stat-value" style={{ color: totalSpend>totalBudget&&totalBudget>0?"var(--accent-red)":"var(--accent-green)" }}>{fmtK(Math.abs(totalBudget-totalSpend))}</div><div className="stat-label">{totalSpend>totalBudget&&totalBudget>0?"Over Budget":"Under Budget"}</div></div>
          <div className="stat-card"><div className="stat-value" style={{ color:"var(--accent-amber)" }}>{fmtK(reimb)}</div><div className="stat-label">Pending Reimbursement</div></div>
          <div className="stat-card"><div className="stat-value" style={{ color:overCount>0?"var(--accent-red)":"var(--accent-green)" }}>{overCount}</div><div className="stat-label">Jobs Over Budget</div></div>
        </div>

        {/* Job tabs */}
        <div style={{ display:"flex", gap:"8px", marginBottom:"20px", flexWrap:"wrap" }}>
          {jobs.map(j => {
            const spend = jobSpend(j.id);
            const budget = Number(j.cost)||0;
            const over = budget > 0 && spend > budget;
            const pct = budget > 0 ? Math.round(spend/budget*100) : 0;
            return (
              <div key={j.id} onClick={() => { setActiveJob(j.id); setCatFilter("All"); }}
                style={{ padding:"8px 16px", borderRadius:"var(--radius-lg)", fontSize:"13px", fontWeight:500, cursor:"pointer", border:`1.5px solid ${activeJob===j.id?"var(--stone-900)":"var(--stone-200)"}`, background:activeJob===j.id?"var(--stone-900)":"white", color:activeJob===j.id?"white":"var(--stone-600)", transition:"all 0.2s", lineHeight:1.3 }}>
                <div style={{ fontWeight:600 }}>{j.project}</div>
                <div style={{ fontSize:"10px", opacity:0.65, marginTop:2 }}>{j.customer} · {fmtK(spend)} · <span style={{ color: activeJob===j.id?(over?"#fca5a5":"#86efac"):(over?"var(--accent-red)":"var(--accent-green)") }}>{over?`▲${Math.round(pct-100)}% over`:`▼${Math.max(0,100-pct)}% under`}</span></div>
              </div>
            );
          })}
        </div>

        {/* Budget bar card */}
        {activeJobObj && (() => {
          const spend  = jobSpend(activeJob);
          const budget = Number(activeJobObj.cost)||0;
          const pct    = budget > 0 ? Math.min(Math.round(spend/budget*100),100) : 0;
          const over   = budget > 0 && spend > budget;
          const color  = over?"var(--accent-red)":pct>80?"var(--accent-amber)":"var(--accent-green)";
          const linkedInvs = jobInvoices(activeJob);
          return (
            <div className="card" style={{ padding:"20px", marginBottom:"20px" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:"16px", flexWrap:"wrap", gap:"10px" }}>
                <div>
                  <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700 }}>{activeJobObj.project}</div>
                  <div style={{ fontSize:"12px", color:"var(--stone-500)", marginTop:3, display:"flex", gap:8, flexWrap:"wrap", alignItems:"center" }}>
                    <span>{activeJobObj.customer}</span>
                    <span className={`badge badge-${activeJobObj.status.toLowerCase().replace(" ","-")}`}>{activeJobObj.status}</span>
                    {linkedInvs.map(inv => (
                      <span key={inv.id} style={{ background:"rgba(74,123,196,0.1)", color:"var(--accent-blue)", padding:"2px 8px", borderRadius:99, fontSize:"11px", fontWeight:600 }}>🧾 {inv.id}</span>
                    ))}
                  </div>
                </div>
                <div style={{ display:"flex", gap:"20px", textAlign:"right", flexWrap:"wrap" }}>
                  {linkedInvs[0] && <div><div style={{ fontSize:"11px", color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:2 }}>Invoice Value</div><div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, color:"var(--accent-blue)" }}>{fmt(invTotal(linkedInvs[0]))}</div></div>}
                  {budget > 0 && <div><div style={{ fontSize:"11px", color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:2 }}>Material Budget</div><div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, color:"var(--stone-600)" }}>{fmt(budget)}</div></div>}
                  <div><div style={{ fontSize:"11px", color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:2 }}>Actual Spend</div><div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, color:color }}>{fmt(spend)}</div></div>
                  {budget > 0 && <div><div style={{ fontSize:"11px", color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:2 }}>{over?"Over":"Remaining"}</div><div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, color:color }}>{fmt(Math.abs(budget-spend))}</div></div>}
                </div>
              </div>
              {budget > 0 && (
                <div>
                  <div style={{ display:"flex", justifyContent:"space-between", fontSize:"12px", color:"var(--stone-500)", marginBottom:5 }}>
                    <span>{pct}% of material budget used</span>
                    <span style={{ color, fontWeight:600 }}>{over?"⚠️ Over budget":"✓ On track"}</span>
                  </div>
                  <div style={{ height:10, background:"var(--stone-100)", borderRadius:99, overflow:"hidden" }}>
                    <div style={{ height:"100%", width:`${pct}%`, background:color, borderRadius:99, transition:"width 0.5s ease" }}/>
                  </div>
                </div>
              )}
            </div>
          );
        })()}

        {/* Breakdowns */}
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"16px", marginBottom:"20px" }}>
          {/* By Category */}
          <div className="card" style={{ padding:0, overflow:"hidden" }}>
            <div style={{ padding:"13px 18px", borderBottom:"1px solid var(--stone-100)", display:"flex", justifyContent:"space-between", alignItems:"center", gap:8, flexWrap:"wrap" }}>
              <span style={{ fontFamily:"var(--font-display)", fontSize:"16px", fontWeight:700 }}>By Category</span>
              <select value={catTimeframe} onChange={e => setCatTimeframe(e.target.value)}
                style={{ padding:"4px 8px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"12px", fontWeight:600, color:"var(--stone-600)", background:"var(--stone-50)", cursor:"pointer", fontFamily:"var(--font-body)" }}>
                {TIMEFRAMES.map(t => <option key={t.id} value={t.id}>{t.label}</option>)}
              </select>
            </div>
            <div style={{ padding:"14px 18px" }}>
              {(() => {
                const filtered = applyTimeframe(jobEntries(activeJob));
                const cats = byCat(filtered);
                const total = filtered.reduce((s,e)=>s+lt(e),0)||1;
                if (cats.length === 0) return <div style={{ fontSize:"13px", color:"var(--stone-400)", padding:"8px 0" }}>No entries for this timeframe.</div>;
                return cats.map(([cat,amt]) => {
                  const c = MAT_CATS[cat]||MAT_CATS["Other"];
                  const pct = Math.round(amt/total*100);
                  const count = filtered.filter(e=>e.cat===cat).length;
                  return (
                    <div key={cat} style={{ marginBottom:12 }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:4 }}>
                        <span style={{ fontSize:"12px", fontWeight:600 }}>{c.icon} {cat}</span>
                        <span style={{ fontSize:"12px", fontWeight:700, color:c.color }}>{fmt(amt)}</span>
                      </div>
                      <div style={{ height:7, background:"var(--stone-100)", borderRadius:99, overflow:"hidden" }}>
                        <div style={{ height:"100%", width:`${pct}%`, background:c.color, borderRadius:99 }}/>
                      </div>
                      <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:2 }}>{pct}% · {count} item{count!==1?"s":""}</div>
                    </div>
                  );
                });
              })()}
            </div>
          </div>

          {/* By Invoice */}
          <div className="card" style={{ padding:0, overflow:"hidden" }}>
            <div style={{ padding:"13px 18px", borderBottom:"1px solid var(--stone-100)", fontFamily:"var(--font-display)", fontSize:"16px", fontWeight:700 }}>By Invoice</div>
            <div style={{ padding:"14px 18px" }}>
              {byInv(jobEntries(activeJob)).length === 0
                ? <div style={{ fontSize:"13px", color:"var(--stone-400)", padding:"8px 0" }}>No entries yet.</div>
                : (() => {
                  const total = jobSpend(activeJob)||1;
                  return byInv(jobEntries(activeJob)).map(([invId,amt]) => {
                    const inv = invoices.find(i=>i.id===invId);
                    const pct = Math.round(amt/total*100);
                    const margin = inv ? Math.round(((invTotal(inv)-amt)/invTotal(inv))*100) : null;
                    return (
                      <div key={invId} style={{ marginBottom:14 }}>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:4 }}>
                          <span style={{ background:"rgba(74,123,196,0.1)", color:"var(--accent-blue)", padding:"2px 8px", borderRadius:99, fontSize:"11px", fontWeight:600 }}>🧾 {invId}</span>
                          <span style={{ fontSize:"12px", fontWeight:700, color:"var(--accent-blue)" }}>{fmt(amt)}</span>
                        </div>
                        <div style={{ height:7, background:"var(--stone-100)", borderRadius:99, overflow:"hidden" }}>
                          <div style={{ height:"100%", width:`${pct}%`, background:"var(--accent-blue)", borderRadius:99 }}/>
                        </div>
                        <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:2 }}>
                          {inv ? `Invoice: ${fmt(invTotal(inv))} · Material: ${pct}% · Est. margin: ` : `${pct}% of spend`}
                          {inv && <span style={{ color: margin>40?"var(--accent-green)":"var(--accent-amber)", fontWeight:600 }}>~{margin}%</span>}
                        </div>
                      </div>
                    );
                  });
                })()
              }
            </div>
          </div>
        </div>

        {/* Purchase log table */}
        <div className="card" style={{ padding:0, overflow:"hidden" }}>
          <div style={{ padding:"13px 18px", borderBottom:"1px solid var(--stone-100)", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:8 }}>
            <span style={{ fontFamily:"var(--font-display)", fontSize:"16px", fontWeight:700 }}>Purchase Log</span>
            <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
              {["All",...Object.keys(MAT_CATS)].map(c => (
                <button key={c} onClick={()=>setCatFilter(c)} style={{ padding:"4px 10px", borderRadius:"var(--radius)", fontSize:"11px", fontWeight:600, border:"none", cursor:"pointer", background:catFilter===c?"var(--stone-800)":"var(--stone-100)", color:catFilter===c?"white":"var(--stone-600)" }}>{c}</button>
              ))}
            </div>
          </div>
          <table>
            <thead><tr>
              <th>Item</th><th>Category</th><th>Invoice</th><th>Supplier</th>
              <th style={{ textAlign:"right" }}>Qty</th><th style={{ textAlign:"right" }}>Unit $</th><th style={{ textAlign:"right" }}>Total</th>
              <th>Date</th><th>Ref</th>{isOwnerAdmin&&<th></th>}
            </tr></thead>
            <tbody>
              {filteredEntries.length === 0
                ? <tr><td colSpan="10" style={{ textAlign:"center", padding:"32px", color:"var(--stone-400)", fontSize:"13px" }}>No entries for this filter yet.</td></tr>
                : filteredEntries.map(e => {
                  const c   = MAT_CATS[e.cat]||MAT_CATS["Other"];
                  const inv = invoices.find(i=>i.id===e.invId);
                  return (
                    <tr key={e.id}>
                      <td>
                        <div style={{ fontWeight:600 }}>{e.item}</div>
                        {e.reimb && <span style={{ fontSize:"10px", background:"rgba(196,148,74,0.12)", color:"var(--accent-amber)", padding:"1px 7px", borderRadius:99, fontWeight:600 }}>Reimbursable</span>}
                      </td>
                      <td><span style={{ background:c.bg, color:c.color, padding:"2px 9px", borderRadius:99, fontSize:"11px", fontWeight:600 }}>{c.icon} {e.cat}</span></td>
                      <td>{inv ? <span style={{ background:"rgba(74,123,196,0.1)", color:"var(--accent-blue)", padding:"2px 8px", borderRadius:99, fontSize:"11px", fontWeight:600 }}>🧾 {inv.id}</span> : <span style={{ fontSize:"11px", color:"var(--stone-400)" }}>—</span>}</td>
                      <td style={{ fontSize:"12px", color:"var(--stone-600)" }}>{e.supplier}</td>
                      <td style={{ textAlign:"right" }}>{e.qty}</td>
                      <td style={{ textAlign:"right", color:"var(--stone-500)" }}>{fmt(e.price)}</td>
                      <td style={{ textAlign:"right", fontWeight:700, fontFamily:"var(--font-display)", fontSize:"15px" }}>{fmt(lt(e))}</td>
                      <td style={{ fontSize:"12px", color:"var(--stone-500)" }}>{e.date}</td>
                      <td style={{ fontSize:"12px", color:"var(--stone-400)" }}>{e.ref||"—"}</td>
                      {isOwnerAdmin && <td><button className="btn-icon" onClick={()=>del(e.id)} title="Delete"><Icon name="trash" size={13} color="var(--accent-red)"/></button></td>}
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </>)}

      {/* ── P&L VIEW ── */}
      {view === "pl" && (<>
        {/* P&L summary stats */}
        {(() => {
          const totalRev  = invoices.reduce((s,i)=>s+invTotal(i),0);
          const totalMat  = materials.reduce((s,e)=>s+lt(e),0);
          const totalGP   = totalRev - totalMat;
          const avgMargin = totalRev > 0 ? Math.round((totalGP/totalRev)*100) : 0;
          return (
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:"14px", marginBottom:"24px" }}>
              <div className="stat-card"><div className="stat-value" style={{ color:"var(--accent-blue)" }}>{fmtK(totalRev)}</div><div className="stat-label">Total Contract Value</div><div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:3 }}>{invoices.length} invoices</div></div>
              <div className="stat-card"><div className="stat-value" style={{ color:"var(--accent-red)" }}>{fmtK(totalMat)}</div><div className="stat-label">Total Material Cost</div><div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:3 }}>{materials.length} line items</div></div>
              <div className="stat-card"><div className="stat-value" style={{ color:"var(--accent-green)" }}>{fmtK(totalGP)}</div><div className="stat-label">Gross Profit</div><div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:3 }}>Excl. labor costs</div></div>
              <div className="stat-card"><div className="stat-value" style={{ color:avgMargin>50?"var(--accent-green)":"var(--accent-amber)" }}>{avgMargin}%</div><div className="stat-label">Avg Gross Margin</div><div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:3 }}>Materials only</div></div>
            </div>
          );
        })()}

        {/* Per-invoice P&L cards */}
        {invoices.map(inv => {
          const job     = jobs.find(j=>j.id===inv.jobId);
          const matCost = invSpend(inv.id);
          const rev     = invTotal(inv);
          const gp      = rev - matCost;
          const margin  = rev > 0 ? Math.round((gp/rev)*100) : 0;
          const matPct  = rev > 0 ? Math.round((matCost/rev)*100) : 0;
          const gpColor = margin>60?"var(--accent-green)":margin>40?"var(--accent-amber)":"var(--accent-red)";
          const es      = materials.filter(e=>e.invId===inv.id);
          const catTots = byCat(es);
          const totalCat = es.reduce((s,e)=>s+lt(e),0)||1;
          const paidToDate = invPaidToDate(inv);

          return (
            <div key={inv.id} style={{ borderRadius:"var(--radius-lg)", overflow:"hidden", marginBottom:"16px", border:"1px solid var(--stone-200)", boxShadow:"0 2px 8px rgba(0,0,0,0.05)" }}>
              {/* Header */}
              <div style={{ background:"var(--stone-800)", padding:"14px 20px", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:8 }}>
                <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                  <span style={{ fontFamily:"var(--font-display)", fontSize:"17px", fontWeight:700, color:"white" }}>{job?.project||"Unknown Job"}</span>
                  <span style={{ background:"rgba(74,123,196,0.25)", color:"#93c5fd", padding:"2px 8px", borderRadius:99, fontSize:"11px", fontWeight:600 }}>🧾 {inv.id}</span>
                </div>
                <span style={{ fontSize:"12px", color:"var(--stone-400)" }}>{inv.customer}</span>
              </div>

              {/* P&L cells */}
              <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", borderBottom:"1px solid var(--stone-100)" }}>
                {[
                  ["Contract Value",  fmt(rev),     "var(--accent-blue)",  "Invoiced to client"],
                  ["Material Cost",   fmt(matCost), "var(--accent-red)",   `${matPct}% of contract · ${es.length} items`],
                  ["Gross Profit",    fmt(gp),      gpColor,               "Excl. labor costs"],
                  ["Paid to Date",    fmt(paidToDate), paidToDate>=rev?"var(--accent-green)":"var(--accent-amber)", `${fmt(rev-paidToDate)} remaining`],
                ].map(([label,val,color,sub]) => (
                  <div key={label} style={{ padding:"16px 20px", borderRight:"1px solid var(--stone-100)" }}>
                    <div style={{ fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--stone-400)", marginBottom:4 }}>{label}</div>
                    <div style={{ fontFamily:"var(--font-display)", fontSize:"22px", fontWeight:700, color }}>{val}</div>
                    <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:3 }}>{sub}</div>
                  </div>
                ))}
              </div>

              {/* Margin badge + category bar */}
              <div style={{ padding:"14px 20px", background:"var(--stone-50)", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:12 }}>
                <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                  <div style={{ background:gpColor+"22", border:`1px solid ${gpColor}44`, borderRadius:"var(--radius)", padding:"6px 14px" }}>
                    <span style={{ fontFamily:"var(--font-display)", fontSize:"20px", fontWeight:700, color:gpColor }}>{margin}% margin</span>
                    <span style={{ fontSize:"12px", color:gpColor, marginLeft:8, fontWeight:600 }}>{margin>60?"✓ Strong":margin>40?"⚠️ Watch":"🚨 Low"}</span>
                  </div>
                </div>
                {catTots.length > 0 && (
                  <div style={{ flex:1, maxWidth:400 }}>
                    <div style={{ display:"flex", height:10, borderRadius:99, overflow:"hidden", gap:1, marginBottom:6 }}>
                      {catTots.map(([cat,amt]) => {
                        const c = MAT_CATS[cat]||MAT_CATS["Other"];
                        const w = Math.round((amt/totalCat)*100);
                        return <div key={cat} style={{ width:`${w}%`, background:c.color, height:"100%" }} title={`${cat}: ${fmt(amt)}`}/>;
                      })}
                    </div>
                    <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
                      {catTots.map(([cat,amt]) => {
                        const c = MAT_CATS[cat]||MAT_CATS["Other"];
                        return <span key={cat} style={{ fontSize:"11px", display:"flex", alignItems:"center", gap:4 }}><span style={{ width:7, height:7, borderRadius:"50%", background:c.color, display:"inline-block" }}/>{c.icon} {cat}: <strong>{fmt(amt)}</strong></span>;
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </>)}

      {/* ── Add Material Modal ── */}
      {modal && (
        <Modal title="Add Material / Supply" onClose={()=>setModal(false)}>
          <div className="form-grid">
            <div className="form-group form-full"><label>Item Name</label><input value={form.item} onChange={e=>setForm(p=>({...p,item:e.target.value}))} placeholder="e.g. Porcelain Tile 24x48, Mapei Grout, Schluter Strip…" /></div>
            <div className="form-group"><label>Job</label>
              <select value={form.jobId} onChange={e=>handleJobChange(e.target.value)}>
                {jobs.map(j=><option key={j.id} value={j.id}>{j.project} — {j.customer}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Linked Invoice</label>
              <select value={form.invId} onChange={e=>setForm(p=>({...p,invId:e.target.value}))}>
                <option value="">— No invoice linked —</option>
                {jobInvoices(Number(form.jobId)).map(i=><option key={i.id} value={i.id}>{i.id} · {i.customer} · {fmt(invTotal(i))}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Category</label>
              <select value={form.cat} onChange={e=>setForm(p=>({...p,cat:e.target.value}))}>
                {Object.keys(MAT_CATS).map(c=><option key={c}>{c}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Supplier</label>
              <select value={form.supplier} onChange={e=>setForm(p=>({...p,supplier:e.target.value}))}>
                {MAT_SUPPLIERS.map(s=><option key={s}>{s}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Qty</label><input type="number" value={form.qty} onChange={e=>setForm(p=>({...p,qty:e.target.value}))} min="0.1" step="0.1" /></div>
            <div className="form-group"><label>Unit Cost ($)</label><input type="number" value={form.price} onChange={e=>setForm(p=>({...p,price:e.target.value}))} placeholder="0.00" step="0.01" /></div>
            <div className="form-group"><label>Date Purchased</label><input type="date" value={form.date} onChange={e=>setForm(p=>({...p,date:e.target.value}))} /></div>
            <div className="form-group"><label>Receipt / PO Ref</label><input value={form.ref} onChange={e=>setForm(p=>({...p,ref:e.target.value}))} placeholder="Optional" /></div>
            <div className="form-group">
              <label>Reimbursable?</label>
              <select value={form.reimb?"yes":"no"} onChange={e=>setForm(p=>({...p,reimb:e.target.value==="yes"}))}>
                <option value="no">No — Company Purchase</option>
                <option value="yes">Yes — Crew Reimbursement</option>
              </select>
            </div>
          </div>
          {form.qty && form.price && (
            <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius)", padding:"11px 14px", display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
              <span style={{ fontSize:"13px", color:"var(--stone-500)" }}>Line Total</span>
              <span style={{ fontFamily:"var(--font-display)", fontSize:"22px", fontWeight:700, color:"var(--warm-gold)" }}>${(Number(form.qty)*Number(form.price)).toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
            </div>
          )}
          <div style={{ display:"flex", justifyContent:"flex-end", gap:8 }}>
            <button className="btn btn-secondary" onClick={()=>setModal(false)}>Cancel</button>
            <button className="btn btn-primary" onClick={save}><Icon name="check" size={14}/> Save Entry</button>
          </div>
        </Modal>
      )}
    </div>
  );
};

// ── REVIEWS ───────────────────────────────────────────────────────────────────
const StarRating = ({ value, onChange, size = 22 }) => (
  <div style={{ display:"flex", gap:3 }}>
    {[1,2,3,4,5].map(n => (
      <span key={n} onClick={() => onChange && onChange(n)}
        style={{ fontSize:size, cursor:onChange?"pointer":"default", color: n <= (value||0) ? "#f59e0b" : "var(--stone-200)", transition:"color 0.15s", lineHeight:1 }}>★</span>
    ))}
  </div>
);

const Reviews = ({ reviews, setReviews, jobs, addNotification, requestDelete }) => {
  const [filter, setFilter]       = useState("All");
  const [modal, setModal]         = useState(null);
  const [detailModal, setDetailModal] = useState(null);
  const [reqForm, setReqForm]     = useState({ jobId:"", customer:"", project:"", crew:"" });
  const [resp, setResp]           = useState({ rating:0, cleanliness:0, communication:0, comment:"" });
  const [toast, setToast]         = useState(null);
  const [emailPreview, setEmailPreview] = useState(false);

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 5000); };

  const responded = reviews.filter(r => r.status === "Responded");
  const avgRating = responded.length ? (responded.reduce((s,r)=>s+r.rating,0)/responded.length).toFixed(1) : "—";
  const avgClean  = responded.length ? (responded.reduce((s,r)=>s+r.cleanliness,0)/responded.length).toFixed(1) : "—";
  const avgComm   = responded.length ? (responded.reduce((s,r)=>s+r.communication,0)/responded.length).toFixed(1) : "—";
  const fiveStars = responded.filter(r=>r.rating===5).length;
  const flagged   = reviews.filter(r=>r.flagged).length;

  const filtered = reviews.filter(r => {
    if (filter === "All") return true;
    if (filter === "Flagged") return r.flagged;
    return r.status === filter;
  });

  const completedJobs = jobs.filter(j => j.status === "Completed");

  const openRequest = () => {
    const first = completedJobs[0];
    setReqForm({ jobId: first?.id||"", customer: first?.customer||"", project: first?.project||"", crew: first?.crew||first?.crewName||"" });
    setModal("request");
  };

  const handleJobSelect = (jobId) => {
    const j = jobs.find(j=>j.id===Number(jobId));
    setReqForm({ jobId: j?.id||"", customer: j?.customer||"", project: j?.project||"", crew: j?.crew||j?.crewName||"" });
  };

  const sendRequest = async () => {
    if (!reqForm.jobId) return;
    const already = reviews.find(r=>(r.jobId===Number(reqForm.jobId)||r.job_id===Number(reqForm.jobId))&&r.status!=="Flagged");
    if (already) { showToast("⚠️ A review request already exists for this job."); setModal(null); return; }
    const newReview = {
      id: Date.now(), jobId: Number(reqForm.jobId), job_id: Number(reqForm.jobId),
      customer: reqForm.customer, project: reqForm.project, crew: reqForm.crew,
      requestedDate: new Date().toISOString().slice(0,10),
      respondedDate: null, status: "Pending",
      rating: null, cleanliness: null, communication: null,
      comment: "", googleSent: false, flagged: false,
    };
    setReviews(p => [...p, newReview]);
    // Persist to Supabase
    try {
      await supabase.from('reviews').upsert({
        id: newReview.id, job_id: newReview.jobId,
        customer: newReview.customer, project: newReview.project, crew: newReview.crew,
        requestedDate: newReview.requestedDate, status: 'Pending',
      }, { onConflict: 'id' });
    } catch (e) { console.log('[reviews] Supabase insert error:', e.message); }
    if (addNotification) addNotification("review", `⭐ Review request sent to ${reqForm.customer} · ${reqForm.project}`, "reviews");
    showToast(`✅ Review request sent to ${reqForm.customer}`);
    setModal(null);
  };

  const recordResponse = (review, data) => {
    const googleSent = data.rating === 5;
    setReviews(p => p.map(r => r.id === review.id ? {
      ...r, ...data,
      respondedDate: new Date().toISOString().slice(0,10),
      status: "Responded",
      googleSent,
      flagged: data.rating <= 2,
    } : r));
    if (addNotification) {
      const stars = "⭐".repeat(data.rating);
      addNotification("review", `${stars} ${review.customer} left a ${data.rating}-star review · ${review.project}`, "reviews");
    }
    if (data.rating === 5) showToast("⭐ 5-star review! Google review link was included in the response.");
    else if (data.rating <= 2) showToast("⚠️ Low rating flagged for follow-up.");
    setDetailModal(null);
  };

  const toggleFlag = (id) => setReviews(p => p.map(r => r.id===id ? {...r, flagged:!r.flagged} : r));

  const statusColor = { Pending:"var(--accent-amber)", Responded:"var(--accent-green)", Flagged:"var(--accent-red)" };

  return (
    <div className="fade-in">
      {/* Header */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:"20px", flexWrap:"wrap", gap:"12px" }}>
        <div>
          <h1 className="section-title">Customer Reviews</h1>
          <p className="section-sub">Request feedback, track ratings, and route 5-star clients to Google.</p>
        </div>
        <button className="btn btn-primary" onClick={openRequest}><Icon name="star" size={14}/> Request Review</button>
      </div>

      {/* Summary stats */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))", gap:"14px", marginBottom:"24px" }}>
        <div className="stat-card">
          <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:4 }}>
            <span style={{ fontSize:22, color:"#f59e0b" }}>★</span>
            <div className="stat-value" style={{ fontSize:"26px" }}>{avgRating}</div>
          </div>
          <div className="stat-label">Avg Overall Rating</div>
          <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:2 }}>{responded.length} responses</div>
        </div>
        <div className="stat-card">
          <div className="stat-value" style={{ color:"var(--accent-green)" }}>{fiveStars}</div>
          <div className="stat-label">5-Star Reviews</div>
          <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:2 }}>Google link sent</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{avgClean}</div>
          <div className="stat-label">Avg Cleanliness</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{avgComm}</div>
          <div className="stat-label">Avg Communication</div>
        </div>
        <div className="stat-card">
          <div className="stat-value" style={{ color: flagged>0?"var(--accent-red)":"var(--accent-green)" }}>{flagged}</div>
          <div className="stat-label">Flagged for Follow-up</div>
        </div>
      </div>

      {/* Google review link banner */}
      <div style={{ background:"rgba(74,123,196,0.08)", border:"1px solid rgba(74,123,196,0.2)", borderRadius:"var(--radius-lg)", padding:"12px 18px", marginBottom:"20px", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:10 }}>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <span style={{ fontSize:20 }}>🔗</span>
          <div>
            <div style={{ fontWeight:600, fontSize:"13px" }}>Google Review Link</div>
            <div style={{ fontSize:"11px", color:"var(--stone-500)", marginTop:1 }}>Automatically included in responses when a client rates 5 stars</div>
          </div>
        </div>
        <a href={GOOGLE_REVIEW_LINK} target="_blank" rel="noreferrer"
          style={{ fontSize:"12px", color:"var(--accent-blue)", fontWeight:600, background:"rgba(74,123,196,0.1)", padding:"5px 12px", borderRadius:99, textDecoration:"none", border:"1px solid rgba(74,123,196,0.2)" }}>
          {GOOGLE_REVIEW_LINK.replace("https://","")}</a>
      </div>

      {/* Filter tabs */}
      <div style={{ display:"flex", gap:8, marginBottom:16, flexWrap:"wrap" }}>
        {["All","Pending","Responded","Flagged"].map(f => (
          <button key={f} className="btn btn-sm" onClick={() => setFilter(f)}
            style={{ background:filter===f?"var(--warm-gold)":"var(--stone-200)", color:filter===f?"white":"var(--stone-700)", border:"none" }}>
            {f} {f==="Flagged"&&flagged>0&&<span style={{ background:"var(--accent-red)", color:"white", borderRadius:99, fontSize:"10px", padding:"1px 5px", marginLeft:3 }}>{flagged}</span>}
          </button>
        ))}
      </div>

      {/* Reviews list */}
      <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
        {filtered.length === 0 && <div className="empty-state"><div style={{ fontSize:36, marginBottom:8 }}>⭐</div><div>No reviews in this category yet.</div></div>}
        {filtered.map(r => (
          <div key={r.id} className="card" style={{ padding:0, overflow:"hidden", border: r.flagged?"1.5px solid rgba(196,74,74,0.3)":"1px solid var(--stone-200)" }}>
            <div style={{ padding:"16px 20px", display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:10 }}>
              <div style={{ flex:1 }}>
                <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4, flexWrap:"wrap" }}>
                  <span style={{ fontWeight:700, fontSize:"15px" }}>{r.customer}</span>
                  <span style={{ background: statusColor[r.flagged?"Flagged":r.status]+"22", color: statusColor[r.flagged?"Flagged":r.status], fontSize:"11px", fontWeight:700, padding:"2px 8px", borderRadius:99 }}>
                    {r.flagged ? "🚨 Flagged" : r.status}
                  </span>
                  {r.googleSent && <span style={{ background:"rgba(74,123,196,0.1)", color:"var(--accent-blue)", fontSize:"11px", fontWeight:600, padding:"2px 8px", borderRadius:99 }}>🔗 Google Sent</span>}
                </div>
                <div style={{ fontSize:"13px", color:"var(--stone-500)" }}>{r.project}{r.crew ? ` · ${r.crew}` : ""}</div>
                <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:3 }}>
                  Requested {r.requestedDate}{r.respondedDate ? ` · Responded ${r.respondedDate}` : ""}
                  {(r.sent_count||1) > 1 && <span style={{ color:"var(--accent-amber)", fontWeight:600 }}> · Sent {r.sent_count}×</span>}
                </div>
                {r.status === "Pending" && (
                  <div style={{ display:"flex", alignItems:"center", gap:8, marginTop:6 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:4 }}>
                      <span style={{ width:7, height:7, borderRadius:"50%", background:"var(--accent-amber)" }}/>
                      <span style={{ fontSize:"11px", fontWeight:600, color:"var(--accent-amber)" }}>Sent — Awaiting Response</span>
                    </div>
                    <button onClick={(e) => { e.stopPropagation(); setReviews(p => p.map(rv => rv.id === r.id ? { ...rv, sent_count: (rv.sent_count||1)+1, requestedDate: new Date().toISOString().slice(0,10) } : rv)); if (addNotification) addNotification("review", `📧 Review request resent to ${r.customer} (send #${(r.sent_count||1)+1})`, "reviews"); showToast(`✅ Resent review request to ${r.customer}`); }}
                      style={{ fontSize:11, background:"var(--accent-green)", color:"white", border:"none", borderRadius:6, padding:"3px 10px", cursor:"pointer", fontWeight:600 }}>
                      Resend
                    </button>
                  </div>
                )}
              </div>
              <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:6 }}>
                {r.rating
                  ? <StarRating value={r.rating} size={18} />
                  : <span style={{ fontSize:"12px", color:"var(--stone-400)", fontStyle:"italic" }}>Awaiting response…</span>
                }
                {r.rating && (
                  <div style={{ display:"flex", gap:12, fontSize:"11px", color:"var(--stone-500)" }}>
                    <span>🧹 {r.cleanliness}/5</span>
                    <span>💬 {r.communication}/5</span>
                  </div>
                )}
              </div>
            </div>

            {r.comment && (
              <div style={{ padding:"0 20px 14px" }}>
                <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius)", padding:"10px 14px", fontSize:"13px", color:"var(--stone-700)", fontStyle:"italic", borderLeft:"3px solid var(--warm-gold)" }}>
                  "{r.comment}"
                </div>
              </div>
            )}

            <div style={{ padding:"10px 20px", borderTop:"1px solid var(--stone-100)", background:"var(--stone-50)", display:"flex", justifyContent:"space-between", alignItems:"center", gap:8 }}>
              <div style={{ display:"flex", gap:6 }}>
                <button className="btn-icon" title={r.flagged?"Unflag":"Flag for follow-up"} onClick={()=>toggleFlag(r.id)}>
                  <Icon name={r.flagged?"check":"warning"} size={14} color={r.flagged?"var(--accent-green)":"var(--accent-amber)"}/>
                </button>
                <button className="btn-icon" title="Delete" onClick={()=>requestDelete("reviews", r)}>
                  <Icon name="trash" size={14} color="var(--accent-red)"/>
                </button>
              </div>
              {r.status === "Pending" && (
                <button className="btn btn-sm btn-primary" onClick={()=>{ setResp({ rating:0, cleanliness:0, communication:0, comment:"" }); setDetailModal(r); }}>
                  <Icon name="star" size={12}/> Record Response
                </button>
              )}
              {r.status === "Responded" && r.rating === 5 && (
                <a href={GOOGLE_REVIEW_LINK} target="_blank" rel="noreferrer" className="btn btn-sm"
                  style={{ background:"var(--accent-blue)", color:"white", border:"none", textDecoration:"none" }}>
                  🔗 Open Google Review
                </a>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* ── Request Review Modal ── */}
      {modal === "request" && (
        <Modal title="Request Customer Review" onClose={()=>setModal(null)}>
          <div style={{ background:"rgba(196,149,74,0.07)", border:"1px solid rgba(196,149,74,0.2)", borderRadius:"var(--radius)", padding:"12px 14px", marginBottom:"16px", fontSize:"13px", color:"var(--stone-600)" }}>
            <strong>How it works:</strong> A feedback request is logged for this job. When the client responds with 5 stars, the Google review link is automatically included in the follow-up message.
          </div>
          {completedJobs.length === 0
            ? <div style={{ textAlign:"center", padding:"20px", color:"var(--stone-400)", fontSize:"13px" }}>No completed jobs found. Mark a job as Completed first.</div>
            : (
              <div className="form-grid">
                <div className="form-group form-full"><label>Select Completed Job</label>
                  <select value={reqForm.jobId} onChange={e=>handleJobSelect(e.target.value)}>
                    {completedJobs.map(j=><option key={j.id} value={j.id}>{j.project} — {j.customer}</option>)}
                  </select>
                </div>
                <div className="form-group"><label>Customer</label><input value={reqForm.customer} readOnly style={{ background:"var(--stone-50)", color:"var(--stone-500)" }}/></div>
                <div className="form-group"><label>Crew</label><input value={reqForm.crew} readOnly style={{ background:"var(--stone-50)", color:"var(--stone-500)" }}/></div>
              </div>
            )
          }
          <div style={{ display:"flex", justifyContent:"space-between", gap:8, marginTop:4 }}>
            <button className="btn btn-secondary" style={{ fontSize:12 }} onClick={()=>setEmailPreview(true)}>👁 Preview Email</button>
            <div style={{ display:"flex", gap:8 }}>
              <button className="btn btn-secondary" onClick={()=>setModal(null)}>Cancel</button>
              {completedJobs.length > 0 && <button className="btn btn-primary" onClick={sendRequest}><Icon name="mail" size={14}/> Send Request</button>}
            </div>
          </div>
        </Modal>
      )}

      {/* ── Email Preview Modal ── */}
      {emailPreview && (
        <Modal title="📧 Review Request Email Preview" onClose={()=>setEmailPreview(false)}>
          <div style={{ background:"white", border:"1px solid var(--stone-200)", borderRadius:12, overflow:"hidden", maxHeight:"65vh", overflowY:"auto" }}>
            {/* Email header */}
            <div style={{ background:"#1a1714", padding:"24px 28px", textAlign:"center" }}>
              <div style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:"white" }}>Timeless Tile Pro</div>
              <div style={{ fontSize:11, color:"rgba(255,255,255,0.4)", marginTop:4 }}>Virginia Beach, VA · (757) 263-0978</div>
            </div>
            <div style={{ height:3, background:"linear-gradient(90deg,#c9a96e,#e8d5a3,transparent)" }}/>
            {/* Email body */}
            <div style={{ padding:"28px 28px" }}>
              <p style={{ fontSize:15, color:"#2c2820", marginBottom:8 }}>Hi {reqForm.customer || "Client Name"},</p>
              <p style={{ fontSize:14, color:"#5a5248", lineHeight:1.7, marginBottom:20 }}>Thank you for choosing Timeless Tile Pro for your <strong>{reqForm.project || "project"}</strong>! We hope you're thrilled with the results.</p>
              <p style={{ fontSize:14, color:"#5a5248", lineHeight:1.7, marginBottom:20 }}>Your feedback helps us maintain the highest quality standards and helps other homeowners find trusted contractors. We'd love to hear about your experience.</p>
              {/* Rating section */}
              <div style={{ background:"#f5f3ef", borderRadius:12, padding:"20px 24px", marginBottom:20, textAlign:"center" }}>
                <div style={{ fontSize:12, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.08em", color:"#a09880", marginBottom:12 }}>How would you rate your experience?</div>
                <div style={{ fontSize:32, letterSpacing:8 }}>⭐ ⭐ ⭐ ⭐ ⭐</div>
                <div style={{ fontSize:12, color:"#a09880", marginTop:8 }}>Click a star to submit your rating</div>
              </div>
              {/* Categories */}
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:20 }}>
                <div style={{ background:"#f5f3ef", borderRadius:8, padding:"12px 16px", textAlign:"center" }}>
                  <div style={{ fontSize:11, fontWeight:700, color:"#a09880", textTransform:"uppercase", marginBottom:4 }}>Cleanliness</div>
                  <div style={{ fontSize:14, color:"#5a5248" }}>🧹 Rate 1-5</div>
                </div>
                <div style={{ background:"#f5f3ef", borderRadius:8, padding:"12px 16px", textAlign:"center" }}>
                  <div style={{ fontSize:11, fontWeight:700, color:"#a09880", textTransform:"uppercase", marginBottom:4 }}>Communication</div>
                  <div style={{ fontSize:14, color:"#5a5248" }}>💬 Rate 1-5</div>
                </div>
              </div>
              {/* Comment box */}
              <div style={{ border:"1.5px solid #e8e0d8", borderRadius:8, padding:"12px 16px", marginBottom:20 }}>
                <div style={{ fontSize:11, fontWeight:700, color:"#a09880", textTransform:"uppercase", marginBottom:6 }}>Additional Comments</div>
                <div style={{ fontSize:13, color:"#b0a095", fontStyle:"italic" }}>Share any details about your experience…</div>
              </div>
              {/* CTA button */}
              <div style={{ textAlign:"center", marginBottom:20 }}>
                <div style={{ display:"inline-block", background:"#1a1714", color:"#c9a96e", fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, padding:"14px 36px", borderRadius:10 }}>Submit My Review →</div>
                <div style={{ fontSize:11, color:"#a09880", marginTop:8 }}>Takes less than 2 minutes</div>
              </div>
              {/* Note about Google */}
              <div style={{ background:"rgba(74,123,196,0.08)", border:"1px solid rgba(74,123,196,0.2)", borderRadius:8, padding:"12px 16px", marginBottom:16 }}>
                <div style={{ fontSize:12, color:"#6b8cae" }}><strong>🔗 5-star reviews:</strong> If you rate us 5 stars, we'll include a link to leave a Google review — helping other homeowners find quality tile work.</div>
              </div>
              <p style={{ fontSize:13, color:"#a09880", borderTop:"1px solid #ece9e3", paddingTop:16 }}>Thank you for trusting Timeless Tile Pro with your project. We look forward to working with you again!</p>
            </div>
            {/* Email footer */}
            <div style={{ background:"#242018", padding:"14px 28px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <span style={{ fontFamily:"var(--font-display)", fontSize:13, color:"rgba(255,255,255,0.35)", fontStyle:"italic" }}>Timeless Tile Pro LLC</span>
              <span style={{ fontSize:11, color:"rgba(255,255,255,0.25)" }}>timelesstilepro.com</span>
            </div>
          </div>
          <div style={{ display:"flex", justifyContent:"flex-end", gap:8, marginTop:12 }}>
            <button className="btn btn-secondary" onClick={()=>setEmailPreview(false)}>Close</button>
          </div>
        </Modal>
      )}

      {/* ── Record Response Modal ── */}
      {detailModal && (() => {
        const googleWillSend = resp.rating === 5;
        return (
          <Modal title={`Record Response — ${detailModal.customer}`} onClose={()=>setDetailModal(null)}>
            <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius)", padding:"12px 14px", marginBottom:"16px" }}>
              <div style={{ fontWeight:600 }}>{detailModal.project}</div>
              <div style={{ fontSize:"12px", color:"var(--stone-500)" }}>{detailModal.crew} · Requested {detailModal.requestedDate}</div>
            </div>

            {/* Overall rating */}
            <div style={{ marginBottom:18 }}>
              <div style={{ fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--stone-500)", marginBottom:8 }}>Overall Rating</div>
              <StarRating value={resp.rating} onChange={v=>setResp(p=>({...p,rating:v}))} size={32}/>
            </div>

            {/* Sub-ratings */}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:18 }}>
              <div>
                <div style={{ fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--stone-500)", marginBottom:8 }}>🧹 Cleanliness</div>
                <StarRating value={resp.cleanliness} onChange={v=>setResp(p=>({...p,cleanliness:v}))} size={24}/>
              </div>
              <div>
                <div style={{ fontSize:"11px", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em", color:"var(--stone-500)", marginBottom:8 }}>💬 Communication</div>
                <StarRating value={resp.communication} onChange={v=>setResp(p=>({...p,communication:v}))} size={24}/>
              </div>
            </div>

            {/* Comment */}
            <div className="form-group" style={{ marginBottom:16 }}>
              <label>Client's Written Comment</label>
              <textarea rows={3} value={resp.comment} onChange={e=>setResp(p=>({...p,comment:e.target.value}))} placeholder="Paste the client's feedback here…" style={{ width:"100%", padding:"8px 10px", border:"1px solid var(--stone-200)", borderRadius:"var(--radius)", fontSize:"13px", fontFamily:"var(--font-body)", resize:"vertical" }}/>
            </div>

            {/* Google routing preview */}
            <div style={{ borderRadius:"var(--radius)", padding:"12px 14px", marginBottom:16, background: googleWillSend?"rgba(74,123,196,0.08)":"rgba(140,132,120,0.08)", border:`1px solid ${googleWillSend?"rgba(74,123,196,0.25)":"rgba(140,132,120,0.2)"}` }}>
              {googleWillSend
                ? <div style={{ fontSize:"13px", color:"var(--accent-blue)", fontWeight:500 }}>🔗 <strong>5 stars!</strong> Google review link will be included in the thank-you message sent to {detailModal.customer}.</div>
                : <div style={{ fontSize:"13px", color:"var(--stone-500)" }}>ℹ️ Google review link is only sent for 5-star ratings. {resp.rating > 0 && resp.rating < 5 ? "Feedback will be kept private." : "Select a rating above."}</div>
              }
            </div>

            <div style={{ display:"flex", justifyContent:"flex-end", gap:8 }}>
              <button className="btn btn-secondary" onClick={()=>setDetailModal(null)}>Cancel</button>
              <button className="btn btn-primary" disabled={!resp.rating||!resp.cleanliness||!resp.communication}
                onClick={()=>recordResponse(detailModal,resp)}
                style={{ opacity:(!resp.rating||!resp.cleanliness||!resp.communication)?0.5:1 }}>
                <Icon name="check" size={14}/> Save Response
              </button>
            </div>
          </Modal>
        );
      })()}

      {toast && <PipelineToast message={toast} onClose={()=>setToast(null)}/>}
    </div>
  );
};

// ── PHOTO GALLERY ─────────────────────────────────────────────────────────────
const Gallery = ({ jobs, setJobs, loadAllJobPhotos }) => {
  // Gallery needs every photo — fetch them once when the page opens
  useEffect(() => { loadAllJobPhotos && loadAllJobPhotos(); }, []); // eslint-disable-line
  const [selectedJob, setSelectedJob] = useState(null);
  const [lightbox, setLightbox] = useState(null);
  const fileRef = useRef();

  const allPhotos = jobs.flatMap(j => j.photos.map(p => ({ emoji: p, job: j.project, customer: j.customer, jobId: j.id })));

  const handleUpload = (jobId) => {
    const emojis = ["🏠","🪨","🏡","✨","⬜","🟫","🪵","🏗️","🛁","🍳","🌿","⚪","🔲","◼️"];
    const random = emojis[Math.floor(Math.random() * emojis.length)];
    setJobs(p => p.map(j => j.id === jobId ? { ...j, photos: [...j.photos, random] } : j));
  };

  return (
    <div className="fade-in">
      <div style={{ marginBottom: "24px" }}>
        <h1 className="section-title">Photo Gallery</h1>
        <p className="section-sub">Before & after photos organized by job.</p>
      </div>

      <div style={{ display: "flex", gap: "8px", marginBottom: "20px", flexWrap: "wrap" }}>
        <button className="btn btn-sm" style={{ background: !selectedJob ? "var(--warm-gold)" : "var(--stone-200)", color: !selectedJob ? "white" : "var(--stone-700)" }} onClick={() => setSelectedJob(null)}>All Jobs</button>
        {jobs.map(j => (
          <button key={j.id} className="btn btn-sm" style={{ background: selectedJob===j.id ? "var(--warm-gold)" : "var(--stone-200)", color: selectedJob===j.id ? "white" : "var(--stone-700)" }} onClick={() => setSelectedJob(j.id)}>{j.project}</button>
        ))}
      </div>

      {selectedJob ? (
        <div>
          {(() => {
            const job = jobs.find(j => j.id === selectedJob);
            return (
              <div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                  <div>
                    <h2 style={{ fontFamily: "var(--font-display)", fontSize: "20px", fontWeight: 600 }}>{job.project}</h2>
                    <p className="text-muted">{job.customer} · {job.address}</p>
                  </div>
                  <button className="btn btn-primary btn-sm" onClick={() => handleUpload(selectedJob)}><Icon name="upload" size={13} /> Add Photo</button>
                </div>
                {job.photos.length === 0 ? (
                  <div className="empty-state"><div style={{ fontSize: 40 }}>📷</div><div>No photos yet. Click "Add Photo" to upload.</div></div>
                ) : (
                  <div className="photo-grid">
                    {job.photos.map((p,i) => (
                      <div key={i} className="photo-thumb" onClick={() => setLightbox({ emoji: p, job: job.project })} style={{ fontSize: "40px" }}>{p}</div>
                    ))}
                    <div className="photo-thumb" style={{ border: "2px dashed var(--stone-300)", background: "transparent", cursor: "pointer", color: "var(--stone-400)", fontSize: "28px" }} onClick={() => handleUpload(selectedJob)}>+</div>
                  </div>
                )}
              </div>
            );
          })()}
        </div>
      ) : (
        <div style={{ display: "grid", gap: "20px" }}>
          {jobs.map(j => (
            <div className="card" key={j.id}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                <div>
                  <div style={{ fontWeight: 600 }}>{j.project}</div>
                  <div className="text-muted">{j.customer} · <span className={`badge badge-${j.status.toLowerCase().replace(" ","-")}`} style={{ marginLeft: 4 }}>{j.status}</span></div>
                </div>
                <div style={{ display: "flex", gap: "8px" }}>
                  <button className="btn btn-ghost btn-sm" onClick={() => setSelectedJob(j.id)}>View All ({j.photos.length})</button>
                  <button className="btn btn-primary btn-sm" onClick={() => handleUpload(j.id)}><Icon name="upload" size={12} /> Add</button>
                </div>
              </div>
              {j.photos.length === 0 ? (
                <div style={{ color: "var(--stone-400)", fontSize: "13px", padding: "16px", textAlign: "center", background: "var(--stone-100)", borderRadius: 6 }}>No photos yet</div>
              ) : (
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                  {j.photos.slice(0,6).map((p,i) => (
                    <div key={i} style={{ width: 70, height: 70, borderRadius: 8, background: "var(--stone-200)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28, cursor: "pointer", border: "2px solid var(--stone-200)" }} onClick={() => setLightbox({ emoji: p, job: j.project })}>{p}</div>
                  ))}
                  {j.photos.length > 6 && <div style={{ width: 70, height: 70, borderRadius: 8, background: "var(--stone-200)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, color: "var(--stone-500)", cursor: "pointer" }} onClick={() => setSelectedJob(j.id)}>+{j.photos.length-6}</div>}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {lightbox && (
        <div className="modal-overlay" onClick={() => setLightbox(null)}>
          <div style={{ background: "var(--stone-900)", borderRadius: 16, padding: 40, textAlign: "center", maxWidth: 400 }}>
            <div style={{ fontSize: 120, marginBottom: 16 }}>{lightbox.emoji}</div>
            <div style={{ color: "var(--stone-300)", fontFamily: "var(--font-display)", fontSize: 20 }}>{lightbox.job}</div>
            <button className="btn btn-ghost" style={{ color: "var(--stone-400)", marginTop: 12 }} onClick={() => setLightbox(null)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

// ── TRAINING ──────────────────────────────────────────────────────────────────
// ── TRAINING CENTER ───────────────────────────────────────────────────────────
const Training = () => {
  const [tab, setTab]                         = useState("library");
  const [activeVideo, setActiveVideo]         = useState(null);
  const [libFilter, setLibFilter]             = useState("All");
  const [activeLevel, setActiveLevel]         = useState(null);   // level key string
  const [assessTab, setAssessTab]             = useState("written");
  const [examAnswers, setExamAnswers]         = useState({});
  const [practicalScores, setPracticalScores] = useState({});
  const [examResult, setExamResult]           = useState(null);
  const [practicalResult, setPracticalResult] = useState(null);
  const [certModal, setCertModal]             = useState(null);
  const [learnerName, setLearnerName]         = useState("");
  const [completedLevels, setCompletedLevels] = useState({});
  const [editingModule, setEditingModule]     = useState(null);  // module obj being edited
  const [editForm, setEditForm]               = useState(null);  // working copy

  // ─────────────────────────────────────────────────────────────────────────────
  // VIDEO LIBRARY  (exact modules from Timeless_Tile_Pro-Video_Training_Script_Library.docx)
  // ─────────────────────────────────────────────────────────────────────────────
  const [videoModules, setVideoModules] = useState([
    {
      id:1, title:"Welcome to Timeless Tile Pro",
      category:"Orientation", forLevel:"All", duration:"~8 min", color:"var(--accent-blue)",
      desc:"Company mission, culture, core values, and an overview of the full training series. Required first watch for all new team members.",
      scenes:[
        { label:"Scene 1 — Opening Shot",
          camera:"Owner standing in workshop or on a finished jobsite.",
          vo:"\"Welcome to Timeless Tile Pro. Our mission is to deliver high-quality kitchen and bathroom renovations with craftsmanship, professionalism, and integrity. In this training series, you'll learn the systems, standards, and installation methods that make our work stand out in the Hampton Roads region. Let's get started.\"",
          onScreen:"Timeless Tile Pro — Training Series" },
      ]
    },
    {
      id:2, title:"Tool Safety & Jobsite Setup",
      category:"Safety", forLevel:"Apprentice", duration:"~12 min", color:"var(--accent-red)",
      desc:"Required PPE items, safe tool handling, grinder and wet saw safety, and protecting the client's home from dust and damage.",
      scenes:[
        { label:"Scene 1 — PPE Overview",
          camera:"Table with all required PPE items laid out.",
          vo:"\"Before any tile work begins, safety is the priority. These are the required PPE items for every job: gloves, safety glasses, respirator, knee pads, and work boots. These items are non-negotiable on every Timeless Tile Pro jobsite.\"",
          onScreen:"Safety First — Professionalism Always" },
        { label:"Scene 2 — Tool Demonstration",
          camera:"Close-up shots demonstrating correct tool handling technique.",
          vo:"\"Always handle tools with respect. Ensure cords are free from debris, use two hands when necessary, and never bypass guards on grinders or saws.\"",
          onScreen:"Never Bypass Safety Guards" },
        { label:"Scene 3 — Jobsite Protection",
          camera:"Installer laying ram board, plastic barriers, and drop cloths.",
          vo:"\"Protecting the client's home is just as important as installing tile. We use plastic barriers, ram board, and drop cloths to prevent dust and damage.\"",
          onScreen:"Safety First — Professionalism Always" },
      ]
    },
    {
      id:3, title:"Subfloor Prep & Leveling",
      category:"Prep", forLevel:"Apprentice", duration:"~14 min", color:"var(--accent-amber)",
      desc:"Subfloor inspection technique, identifying structural issues, patch compound application, self-leveling compound mixing and pouring.",
      scenes:[
        { label:"Scene 1 — Subfloor Inspection",
          camera:"Show uneven or damaged floor; 10-ft straightedge demonstration.",
          vo:"\"Subfloor preparation determines the longevity of a tile installation. Always begin with inspection for dips, cracks, or structural issues.\"",
          onScreen:"Flat Floors = Professional Installations" },
        { label:"Scene 2 — Patching & Leveling",
          camera:"Demonstrate skim coating, patching, and SLC mixing.",
          vo:"\"Use patch compounds to correct small imperfections. For larger dips, mix and pour self-leveling compound following manufacturer ratios.\"",
          onScreen:"Flat Floors = Professional Installations" },
      ]
    },
    {
      id:4, title:"Schluter Waterproofing System",
      category:"Waterproofing", forLevel:"Junior Installer", duration:"~18 min", color:"var(--accent-blue)",
      desc:"Complete Schluter Kerdi installation: membrane embedding, Kerdi-Band seam overlaps, pre-formed corners, niche wrapping, and bench waterproofing.",
      scenes:[
        { label:"Scene 1 — Kerdi Installation",
          camera:"Installer applying Kerdi sheet to shower wall panel.",
          vo:"\"Schluter waterproofing must be installed with precision. Use the correct trowel size, maintain full thinset coverage, and embed Kerdi sheets firmly with a drywall knife.\"",
          onScreen:"Waterproofing = Zero Leaks" },
        { label:"Scene 2 — Kerdi-Band & Corners",
          camera:"Close-up of 2-inch seam overlap and pre-formed corner installation.",
          vo:"\"All seams must overlap at least two inches. Corners should be sealed with pre-formed Schluter corners for maximum protection.\"",
          onScreen:"Overlap Minimum 2 Inches" },
        { label:"Scene 3 — Niches & Benches",
          camera:"Step-by-step demonstration of waterproofing a niche and bench.",
          vo:"\"Niches require special attention. Apply Kerdi-Band around all edges and ensure no voids are present. Benches must be fully wrapped.\"",
          onScreen:"Waterproofing = Zero Leaks" },
      ]
    },
    {
      id:5, title:"Tile Layout",
      category:"Installation", forLevel:"Junior Installer", duration:"~15 min", color:"var(--warm-gold)",
      desc:"Identifying focal points, laser level line setup, dry lay process for pattern confirmation, clip spacing, and large format tile warpage assessment.",
      scenes:[
        { label:"Scene 1 — Layout Planning",
          camera:"Installer marking focal point and snapping laser lines.",
          vo:"\"Tile layout starts with understanding focal points. Use a laser level to mark lines and determine where cuts will fall. Avoid sliver cuts whenever possible.\"",
          onScreen:"Precision Layout = Professional Finish" },
        { label:"Scene 2 — Dry Lay Process",
          camera:"Tile pieces arranged on floor without adhesive.",
          vo:"\"Dry laying ensures your pattern flows correctly and transitions align. Large format tile requires extra consideration for warpage.\"",
          onScreen:"Always Dry Lay Before Setting" },
        { label:"Scene 3 — Marking & Spacing",
          camera:"Chalk line snapping, clip placement, back-buttering demonstration.",
          vo:"\"Mark tiles clearly and use premium clips for consistency. Always back-butter large format tile.\"",
          onScreen:"Precision Layout = Professional Finish" },
      ]
    },
    {
      id:6, title:"Tile Installation",
      category:"Installation", forLevel:"Junior Installer", duration:"~20 min", color:"var(--warm-gold)",
      desc:"Thinset mixing to correct consistency, slaking, proper 45° trowel technique with parallel ridges, setting tile with back-and-forth motion, and pull-test coverage verification.",
      scenes:[
        { label:"Scene 1 — Thinset Mixing",
          camera:"Mixing thinset in bucket with drill paddle.",
          vo:"\"Mix thinset thoroughly until creamy without lumps. Let it slake for 5–10 minutes and remix.\"",
          onScreen:"Coverage = Strength" },
        { label:"Scene 2 — Proper Trowel Use",
          camera:"Overhead view showing 45° trowel angle and parallel ridge combing.",
          vo:"\"Hold your trowel at a consistent angle, usually 45 degrees, and comb lines all in the same direction for full coverage.\"",
          onScreen:"45° Angle · Parallel Ridges · One Direction" },
        { label:"Scene 3 — Setting Tile",
          camera:"Installer pressing and sliding tile; pull test showing thinset coverage.",
          vo:"\"Press firmly, move tile slightly back and forth, and verify coverage by pulling a tile every so often.\"",
          onScreen:"Coverage = Strength" },
      ]
    },
    {
      id:7, title:"Grouting: Cement & Epoxy",
      category:"Finishing", forLevel:"Installer", duration:"~16 min", color:"var(--accent-green)",
      desc:"Cement grout mixing to peanut-butter consistency, diagonal application, haze timing, epoxy grout two-bucket technique, and grout sealing procedures.",
      scenes:[
        { label:"Scene 1 — Cement Grout",
          camera:"Installer working grout diagonally across joints.",
          vo:"\"Cement grout should be mixed to a peanut-butter consistency. Work diagonally across joints and remove haze after initial set.\"",
          onScreen:"Work Diagonally · Remove Haze Within 30 Min" },
        { label:"Scene 2 — Epoxy Grout",
          camera:"Installer working in small sections with two labeled buckets.",
          vo:"\"Epoxy grout sets quickly, so work in small sections. Use two buckets — one for washing, one for final cleanup.\"",
          onScreen:"Epoxy = Premium Finish" },
      ]
    },
    {
      id:8, title:"Caulking & Metal Trim",
      category:"Finishing", forLevel:"Installer", duration:"~10 min", color:"var(--accent-green)",
      desc:"Silicone caulk application at all changes of plane, smoothing technique, Schluter metal trim measuring, cutting, and embedding in thinset.",
      scenes:[
        { label:"Scene 1 — Silicone Application",
          camera:"Caulk bead applied at floor-to-wall transition.",
          vo:"\"Apply silicone at all changes of plane. Smooth the bead using a damp finger or caulking tool for clean lines.\"",
          onScreen:"Changes of Plane = Caulk, Never Grout" },
        { label:"Scene 2 — Metal Trim",
          camera:"Installer measuring, cutting, and embedding trim profile.",
          vo:"\"Metal trim provides clean edges. Measure twice, cut clean, and ensure trim sits flush with tile height.\"",
          onScreen:"Set Trim Before Adjacent Tile" },
      ]
    },
    {
      id:9, title:"Jobsite Cleanup & Final Presentation",
      category:"Professionalism", forLevel:"All", duration:"~8 min", color:"var(--accent-amber)",
      desc:"Daily cleanup non-negotiables, end-of-day client communication, final QC walkthrough checklist, and presenting a polished, professional finished space.",
      scenes:[
        { label:"Scene 1 — Cleaning Procedures",
          camera:"Crew sweeping, vacuuming, organizing tools and materials.",
          vo:"\"A clean jobsite reflects professionalism. Sweep floors, vacuum dust, and wipe surfaces at the end of every day.\"",
          onScreen:"Clean Space = Happy Client" },
        { label:"Scene 2 — Final Walkthrough",
          camera:"PM and installer conducting QC review before client walk-through.",
          vo:"\"Perform a final QC check: spacing, grouting, caulking, and edge finishing. Present a clean, polished space to the client.\"",
          onScreen:"Find It Before the Client Does" },
      ]
    },
    {
      id:10, title:"Client Communication on the Job",
      category:"Professionalism", forLevel:"All", duration:"~10 min", color:"var(--accent-blue)",
      desc:"Daily end-of-day progress updates, handling client questions on-site professionally, and the correct escalation path for concerns to the PM.",
      scenes:[
        { label:"Scene 1 — Daily Updates",
          camera:"Installer giving brief end-of-day update to homeowner.",
          vo:"\"Communicate progress and next steps with the client every day. Clear communication prevents misunderstandings.\"",
          onScreen:"Communication Builds Trust" },
        { label:"Scene 2 — Handling Concerns",
          camera:"Calm, attentive conversation between installer and homeowner.",
          vo:"\"Always listen respectfully to client concerns. Document the issue, notify the owner, and take corrective steps immediately.\"",
          onScreen:"Listen · Document · Escalate" },
      ]
    },
  ]);

  const CAT_COLOR = { Orientation:"var(--accent-blue)", Safety:"var(--accent-red)", Prep:"var(--accent-amber)", Waterproofing:"var(--accent-blue)", Installation:"var(--warm-gold)", Finishing:"var(--accent-green)", Professionalism:"var(--stone-600)" };
  const allCategories = ["All","Orientation","Safety","Prep","Waterproofing","Installation","Finishing","Professionalism"];
  const filteredModules = libFilter === "All" ? videoModules : videoModules.filter(m => m.category === libFilter);

  // ── Edit helpers ──
  const openEdit = (mod) => {
    setEditForm(JSON.parse(JSON.stringify(mod))); // deep clone
    setEditingModule(mod.id);
  };
  const cancelEdit = () => { setEditingModule(null); setEditForm(null); };
  const saveEdit = () => {
    setVideoModules(p => p.map(m => m.id === editForm.id ? editForm : m));
    // also update activeVideo if we're viewing the same one
    setActiveVideo(v => v && v.id === editForm.id ? editForm : v);
    cancelEdit();
  };
  const updateScene = (idx, field, val) =>
    setEditForm(p => { const s = [...p.scenes]; s[idx] = {...s[idx],[field]:val}; return {...p,scenes:s}; });
  const addScene = () =>
    setEditForm(p => ({ ...p, scenes: [...p.scenes, { label:`Scene ${p.scenes.length+1} — New Scene`, camera:"", vo:"", onScreen:"" }] }));
  const removeScene = (idx) =>
    setEditForm(p => ({ ...p, scenes: p.scenes.filter((_,i) => i !== idx) }));

  // ─────────────────────────────────────────────────────────────────────────────
  // CERTIFICATION LEVELS  (from Timeless_Tile_Pro-Certification_and_Skill_test_system.docx)
  // ─────────────────────────────────────────────────────────────────────────────
  const LEVELS = {
    "Apprentice": {
      num:1, color:"var(--accent-blue)", emoji:"🔵",
      focus:"Basic tools, prep, demolition, mixing, and learning.",
      writingPassPct: 80, rubricMin: 3.0,
      practicalCriteria:"Must demonstrate safe tool handling and basic competency.",
      practicalTasks:[
        "Safely handle all required tools (grinder, wet saw, trowel)",
        "Assist with demo — correct technique, no property damage",
        "Mix thinset correctly to manufacturer specifications",
        "Clean jobsite thoroughly to Timeless Tile Pro end-of-day standard",
      ],
      questions:[
        { id:1,  q:"What PPE items are required on every Timeless Tile Pro jobsite?",
          opts:["Hard hat and vest only","Safety glasses, gloves, respirator, knee pads, and work boots","Safety glasses only","Gloves and boots only"], ans:1 },
        { id:2,  q:"What is thinset mortar primarily used for?",
          opts:["Sealing grout joints","Bonding tile to a substrate","Waterproofing shower walls","Filling subfloor cracks"], ans:1 },
        { id:3,  q:"Why is surface preparation the most critical step before tiling?",
          opts:["It makes tile easier to cut","Poor prep causes lippage, hollow tiles, and early bond failure","It speeds up the grouting process","It is a code requirement only"], ans:1 },
        { id:4,  q:"What is the primary purpose of a wet saw on a tile job?",
          opts:["Mixing thinset","Cutting tile accurately with water cooling the blade","Grinding subfloor high spots","Applying grout"], ans:1 },
        { id:5,  q:"How often should tile debris be removed from the jobsite?",
          opts:["Once per week","Only at job completion","At the end of every work day","When the client requests it"], ans:2 },
        { id:6,  q:"What is the purpose of ram board on a jobsite?",
          opts:["Mixing thinset on","Protecting existing floors and finished surfaces from damage","Creating a layout reference line","Waterproofing the shower floor"], ans:1 },
        { id:7,  q:"What does 'slaking' thinset mean?",
          opts:["Applying it to the wall surface","Letting it rest after initial mix, then remixing before use","Heating the thinset","Adding extra water for consistency"], ans:1 },
        { id:8,  q:"Which tool is used to check if a subfloor is flat enough for tile?",
          opts:["A standard 2-foot level","A 10-foot straightedge","A chalk line","A rubber mallet"], ans:1 },
        { id:9,  q:"Why is cement backer board required in wet areas instead of tiling over plywood?",
          opts:["Plywood is too thick","Plywood absorbs moisture and expands, causing tile failure","Plywood is too heavy","Backer board is required by law in all rooms"], ans:1 },
        { id:10, q:"When handling a grinder, what safety rule is non-negotiable?",
          opts:["Use one hand for control","Never bypass the blade guard under any circumstance","Only use it after noon","Wear only gloves"], ans:1 },
        { id:11, q:"What is the correct PPE for mixing thinset or grout compounds?",
          opts:["No PPE needed for mixing","Gloves and a respirator because compounds are alkaline and generate dust","Safety glasses only","Steel-toed boots only"], ans:1 },
        { id:12, q:"What does 'protect the client's home' mean in practice?",
          opts:["Being polite to the homeowner","Using plastic barriers, drop cloths, and ram board before any work begins","Cleaning up at the end of the job only","Asking the client where to put debris"], ans:1 },
        { id:13, q:"What is self-leveling compound (SLC) used for?",
          opts:["Mixing grout","Filling low spots and leveling uneven concrete or wood subfloors","Waterproofing shower walls","Bonding backer board"], ans:1 },
        { id:14, q:"How quickly does self-leveling compound typically begin to set?",
          opts:["2–3 hours","20–30 minutes","5 minutes","Only after it dries overnight"], ans:1 },
        { id:15, q:"What is the maximum acceptable variation in a subfloor measured over 10 feet?",
          opts:["1/2 inch","1/4 inch","1/8 inch","1/16 inch"], ans:2 },
        { id:16, q:"If you notice a soft spot in a subfloor during inspection, what should you do?",
          opts:["Tile over it — it will be fine once the tile is set","Stop and notify the PM before proceeding","Apply extra thinset over the area","Pour self-leveling compound without notifying anyone"], ans:1 },
        { id:17, q:"What do you do with tools at the end of the work day?",
          opts:["Leave them wherever they were last used","Consolidate all tools in one location, secure power tools, and photograph the staging area","Leave them on the client's porch","Return them to the office"], ans:1 },
        { id:18, q:"Why must you never leave broken tile pieces on-site overnight?",
          opts:["They attract rodents","They are a safety hazard — sharp edges can injure the client, children, or pets","They are recyclable","It is only an issue on outdoor jobs"], ans:1 },
        { id:19, q:"What should you do before leaving a jobsite at the end of the day?",
          opts:["Just pack up your tools","Inform the client what was completed and what happens tomorrow, and identify any areas to avoid walking on","Only send a text message","Ask the PM to handle client communication"], ans:1 },
        { id:20, q:"What does it mean to 'demonstrate basic competency' for the Apprentice practical test?",
          opts:["Complete a full tile installation independently","Show safe, correct execution of foundational tasks: tool handling, thinset mixing, demo assist, and cleanup","Install at least one full tile","Grout a section of floor"], ans:1 },
        { id:21, q:"What is the minimum thinset coverage required in dry areas?",
          opts:["75%","80%","95%","100%"], ans:2 },
        { id:22, q:"Why is it important to follow manufacturer mix ratios for thinset and SLC?",
          opts:["Manufacturers require documentation","Incorrect ratios weaken the bond or compound, causing installation failure","It only matters for large format tile","It speeds up drying time"], ans:1 },
        { id:23, q:"Which of the following is a correct statement about PPE on a tile job?",
          opts:["Experienced installers can skip PPE","PPE is required at all times regardless of experience level","PPE is only needed for power tools","PPE is optional if the client isn't home"], ans:1 },
        { id:24, q:"What is the correct way to handle an on-site injury or property damage?",
          opts:["Handle it independently without telling the company","Report it to the PM on the same day with photos of any damage","Wait to see if it becomes a problem","Only report injuries that require a doctor"], ans:1 },
        { id:25, q:"In the Timeless Tile Pro scoring rubric, what does a score of 3 represent?",
          opts:["Poor","Needs Improvement","Acceptable","Proficient"], ans:2 },
      ]
    },

    "Junior Installer": {
      num:2, color:"var(--accent-green)", emoji:"🟢",
      focus:"Basic installs, accurate cuts, layout fundamentals.",
      writingPassPct: 80, rubricMin: 3.5,
      practicalCriteria:"Tile must be level, spaced correctly, and clean. Grout applied correctly.",
      practicalTasks:[
        "Lay 10 sq ft of tile evenly with consistent spacing",
        "Apply correct trowel technique at 45° with parallel ridges",
        "Make accurate straight and angle cuts with wet saw",
        "Apply cement grout correctly and remove haze",
      ],
      questions:[
        { id:1,  q:"What trowel size is recommended for 12x24 inch tile?",
          opts:["3/16\" V-notch","1/4\" square-notch","3/8\" square-notch","1/2\" square-notch"], ans:2 },
        { id:2,  q:"Why is back-buttering required for large format tile?",
          opts:["It helps the tile dry faster","It ensures full thinset coverage and prevents hollow spots","It is only needed for natural stone","It makes cuts easier"], ans:1 },
        { id:3,  q:"What is tile lippage?",
          opts:["The hollow sound a tile makes when tapped","A height difference between the edges of adjacent installed tiles","The angle of the trowel during application","A pattern starting point"], ans:1 },
        { id:4,  q:"What is the minimum Kerdi-Band overlap required at all seams?",
          opts:["1/2 inch","1 inch","2 inches","3 inches"], ans:2 },
        { id:5,  q:"What most commonly causes tile to crack after installation?",
          opts:["Tiles that are too large","Insufficient thinset coverage and poor substrate preparation","Using premium thinset brand","Grouting too quickly"], ans:1 },
        { id:6,  q:"What is the primary purpose of a dry lay before setting tile?",
          opts:["Checking if you ordered enough tile","Confirming pattern flow, alignment, and cut placement before committing adhesive","Practicing trowel technique","Measuring the room"], ans:1 },
        { id:7,  q:"Why must all trowel ridges run in the same direction (not swirled)?",
          opts:["It looks more professional","Parallel ridges collapse uniformly when tile is set, ensuring consistent full coverage","It uses less thinset","It is easier on the wrist"], ans:1 },
        { id:8,  q:"What is the maximum allowable lippage for rectified tile per ANSI standards?",
          opts:["1/8 inch","1/16 inch","1/32 inch","1/4 inch"], ans:2 },
        { id:9,  q:"Why should tile layout never begin from a wall?",
          opts:["Walls are load-bearing","Walls are rarely perfectly square or plumb — always work from laser lines","It wastes tile","It is harder to use a trowel near a wall"], ans:1 },
        { id:10, q:"What minimum thinset coverage is required in wet areas like showers?",
          opts:["75%","85%","95%","100%"], ans:3 },
        { id:11, q:"What is the correct trowel size for mosaic or small tiles under 4 inches?",
          opts:["3/8\" square-notch","1/4\" square-notch","3/16\" V-notch","1/2\" square-notch"], ans:2 },
        { id:12, q:"What is a 'focal point' in tile layout?",
          opts:["The center of the room","The most visible wall or area the eye goes to first when entering the space","The location of the drain","The doorway threshold"], ans:1 },
        { id:13, q:"When dry laying tile, what should you check for in large format tiles?",
          opts:["Color consistency only","Warpage — hold two tiles face-to-face and check for bow","Weight of each tile","Grout joint size"], ans:1 },
        { id:14, q:"Cement grout joints under 1/8 inch require which type of grout?",
          opts:["Sanded grout","Epoxy grout","Unsanded grout","Any grout will work"], ans:2 },
        { id:15, q:"What is the purpose of a tile leveling clip system?",
          opts:["To hold tiles temporarily until thinset dries","To ensure consistent grout joint width and prevent lippage during installation","To measure tile dimensions","To back-butter tiles"], ans:1 },
        { id:16, q:"How do you verify adequate thinset coverage during installation?",
          opts:["Tap the tile and listen","Pull a tile approximately every 20 tiles and inspect the back for coverage","Check visually from above","Measure the thinset depth"], ans:1 },
        { id:17, q:"What grout type is required for joints between 1/8 inch and 1/2 inch?",
          opts:["Unsanded grout","Sanded grout","Epoxy grout only","No grout — caulk only"], ans:1 },
        { id:18, q:"When should you grout after setting tile?",
          opts:["Immediately after setting","After thinset has cured for a minimum of 24 hours (48 for large format)","After 6 hours","Whenever the thinset feels dry to touch"], ans:1 },
        { id:19, q:"What is the purpose of snapping a chalk line from the center of the room?",
          opts:["To mark where the drain goes","To establish perpendicular reference lines for accurate, square tile layout","To measure square footage","To show the client where tile will go"], ans:1 },
        { id:20, q:"What does a 'sliver cut' refer to, and why should it be avoided?",
          opts:["Any cut under 12 inches — always acceptable","A thin, narrow cut piece less than half a tile width — appears amateur and is difficult to cut cleanly","A cut made with the wrong blade","A cut at a 45° angle"], ans:1 },
        { id:21, q:"Why is mesh tape and thinset required at backer board seams?",
          opts:["For waterproofing","To prevent cracks from telegraphing through to the tile surface","For extra structural support","It is purely cosmetic"], ans:1 },
        { id:22, q:"What should you do if a client asks you to change the tile pattern mid-installation?",
          opts:["Change it immediately to keep the client happy","Stop work, notify the PM, and document the request — any scope change requires a change order before proceeding","Refuse the request","Change the pattern in the area they can see only"], ans:1 },
        { id:23, q:"What is the 3-4-5 method used for?",
          opts:["Mixing thinset ratios","Verifying that two layout lines are perfectly perpendicular (square) to each other","Measuring grout joint consistency","Calculating material overage"], ans:1 },
        { id:24, q:"What is grout haze, and when must it be removed?",
          opts:["Excess thinset on the tile — removed before grouting","A milky residue left on tile after grouting — must be buffed within 24 hours before it fully hardens","Water on the tile surface — wipe any time","Epoxy residue — only removed by professionals"], ans:1 },
        { id:25, q:"In the scoring rubric, what average is required for Junior Installer certification?",
          opts:["3.0","3.5","4.0","4.5"], ans:1 },
        { id:26, q:"What is the correct process if a subfloor inspection reveals moisture?",
          opts:["Continue — moisture evaporates","Stop work, notify the PM, and do not set tile until the moisture issue is assessed and resolved","Apply extra thinset to compensate","Apply Kerdi over the wet area and tile immediately"], ans:1 },
        { id:27, q:"What angle should the trowel be held at when combing thinset?",
          opts:["90 degrees (straight up)","30 degrees","45 degrees","60 degrees"], ans:2 },
        { id:28, q:"What material must be used at inside corners in a shower instead of grout?",
          opts:["Extra thinset","Epoxy grout","Color-matched sanded caulk","Unsanded grout"], ans:2 },
        { id:29, q:"When is a change order required?",
          opts:["Only when the client requests additions","Any time the scope, materials, or cost changes from the signed estimate — before work proceeds","Only for large projects over $10,000","At the end of the project if scope changed"], ans:1 },
        { id:30, q:"What should you always do before leaving the jobsite at end of day?",
          opts:["Lock your tools in the truck","Tell the client what was completed today and what happens tomorrow","Send the PM a text","Clean only the work area"], ans:1 },
      ]
    },

    "Installer": {
      num:3, color:"var(--warm-gold)", emoji:"🟡",
      focus:"Complete showers, floors, and backsplashes with minimal oversight.",
      writingPassPct: 85, rubricMin: 4.0,
      practicalCriteria:"All waterproofing seams sealed; tile installed with minimal lippage and correct coverage.",
      practicalTasks:[
        "Build a fully waterproofed niche on a test wall panel",
        "Install Kerdi membrane on a test shower wall with correct seams and corners",
        "Install 15 sq ft of tile using a leveling clip system",
        "Perform a complete epoxy grout installation in a small section",
      ],
      questions:[
        { id:1,  q:"What is the correct sequence for Schluter Kerdi waterproofing on a shower floor?",
          opts:["Apply Kerdi to walls first, then the floor","Pre-slope the floor, apply thinset, embed the Kerdi sheet, then apply Kerdi-Band at all plane changes","Apply Kerdi-Band first, then fill with thinset","Tile the floor first, then waterproof on top"], ans:1 },
        { id:2,  q:"When must expansion joints be used in a tile installation?",
          opts:["Only in exterior applications","At all changes of plane, the perimeter of large floor installations, and wherever tile meets a different material","Only in commercial projects","Only when specified in writing by the architect"], ans:1 },
        { id:3,  q:"What is the minimum thinset coverage required in a shower installation?",
          opts:["75%","85%","95%","100%"], ans:3 },
        { id:4,  q:"How do you properly mix two-part epoxy grout?",
          opts:["Mix equal parts A and B in one bucket with water","Combine Part A (resin) and Part B (hardener) in the exact manufacturer ratio and mix until fully uniform — typically 3–5 minutes","Mix with water just like cement grout","Let it sit 10 minutes before mixing"], ans:1 },
        { id:5,  q:"What is the correct layout strategy for a shower with a dominant focal wall?",
          opts:["Start from the floor drain and work outward","Center the layout on the focal wall so full tiles are prominent and cuts are hidden in corners","Start from the bottom-left corner","Always start from the showerhead wall"], ans:1 },
        { id:6,  q:"What is the proper trowel size for setting large format tile 18x36 inches?",
          opts:["1/4\" square-notch","3/8\" square-notch","1/2\" square-notch with back-buttering required","3/16\" V-notch"], ans:2 },
        { id:7,  q:"Why must inside shower corners never be grouted?",
          opts:["Grout looks bad in corners","Corners experience thermal and structural movement — grout will crack. Color-matched caulk is required.","Grout is too thick for corners","It is a preference, not a technical requirement"], ans:1 },
        { id:8,  q:"Why is epoxy grout haze particularly difficult to remove once cured?",
          opts:["It is applied in a thicker coat","It bonds more strongly to tile than cement grout as it cures chemically","It reacts with tile glaze","Water reactivates it"], ans:1 },
        { id:9,  q:"What is the correct subfloor flatness tolerance for large format tile?",
          opts:["1/4 inch over 10 feet","1/8 inch over 10 feet","1/2 inch over 10 feet","There is no standard tolerance"], ans:1 },
        { id:10, q:"When installing a shower niche, what is the single most critical waterproofing step?",
          opts:["Caulking the front tile edge","Applying Kerdi-Band to all four interior edges before the niche bottom tile is set","Sealing the outside face of the niche","Applying two coats of liquid membrane"], ans:1 },
        { id:11, q:"What is the correct thinset for installing Kerdi membrane?",
          opts:["Standard gray thinset","Unmodified white thinset (Schluter ALL-SET or equivalent unmodified)","Mastic","Epoxy mortar"], ans:1 },
        { id:12, q:"How long must thinset cure before grouting large format tile (18 inches or larger)?",
          opts:["6 hours","24 hours","48 hours","72 hours"], ans:2 },
        { id:13, q:"What does L/720 refer to in substrate assessment?",
          opts:["Tile lippage tolerance","The minimum floor joist stiffness (deflection limit) required for tile installation","The maximum moisture content","A grout joint specification"], ans:1 },
        { id:14, q:"In epoxy grout installation, why use two separate buckets?",
          opts:["One for Part A, one for Part B","One bucket for washing the sponge, one for a final clean rinse — keeps wash water from redepositing epoxy on the tile","One for mixing, one for application","One for the float, one for the bucket"], ans:1 },
        { id:15, q:"What is the function of Schluter pre-formed corners vs. hand-cut Kerdi at corners?",
          opts:["They are interchangeable","Pre-formed corners provide a factory-guaranteed watertight fit at inside and outside corners without relying on hand-cut overlap accuracy","Pre-formed corners are faster only","Hand-cut is the preferred method"], ans:1 },
        { id:16, q:"What must be done to cement grout 72 hours after installation?",
          opts:["Apply a second coat","Apply a penetrating grout sealer","Buff with dry cloth again","Nothing — it is complete"], ans:1 },
        { id:17, q:"Describe the correct punch list process before a client walk-through.",
          opts:["Walk through quickly and fix obvious items","PM performs a complete inspection covering: grout consistency, haze removal, all caulk complete, transitions installed, full cleanup — all items documented and resolved before client enters","Ask the installer if there are any issues","Review the estimate for scope only"], ans:1 },
        { id:18, q:"What causes a tile to sound hollow when tapped?",
          opts:["The tile is too thin","A void in thinset coverage beneath the tile — it may de-bond under load or moisture","The grout is still curing","The floor has natural vibration"], ans:1 },
        { id:19, q:"When should Schluter metal trim be installed relative to adjacent tile?",
          opts:["After all tile is set","Before the adjacent tile — embedded in thinset so it sits flush with finished tile height","It can be applied any time","After grouting"], ans:1 },
        { id:20, q:"What is the correct sequence when installing a fully tiled shower from scratch?",
          opts:["Tile walls first, then floor, then waterproof","Subfloor prep → backer board → waterproofing membrane → tile floor → tile walls → grout → caulk → trim","Waterproof then tile walls and floor simultaneously","Tile floor first to establish height, then walls, then waterproof"], ans:1 },
      ]
    },

    "Lead Installer": {
      num:4, color:"var(--accent-amber)", emoji:"🟠",
      focus:"Jobsite leadership, advanced layouts, niches, benches, and client communication.",
      writingPassPct: 90, rubricMin: 4.5,
      practicalCriteria:"Full shower mockup meets Timeless Tile Pro standards without supervision.",
      practicalTasks:[
        "Build a full shower mockup including bench, niche, and complete Kerdi waterproofing system",
        "Execute an advanced layout pattern (herringbone or 45° diagonal) on a test floor",
        "Supervise and coach an apprentice through a tiling task with real-time feedback",
        "Perform a complete final QC inspection using the company punch list standard",
      ],
      questions:[
        { id:1,  q:"How do you coordinate a multi-day project when a material delivery is delayed?",
          opts:["Stop all work and wait for the delivery","Notify the PM immediately, identify what work can proceed independently, and communicate a revised timeline to the client","Continue with whatever materials are on hand","Inform the client the supplier is responsible"], ans:1 },
        { id:2,  q:"What are all the QC checks required before requesting final payment from a client?",
          opts:["Tile is set and grouted","Grout lines consistent, full haze removal, all caulk joints complete, all transitions installed, complete cleanup, and client walk-through approval","Tile is set and the client appears happy","The final invoice has been sent"], ans:1 },
        { id:3,  q:"How do you handle a client who is dissatisfied with the appearance of a completed installation?",
          opts:["Explain that natural tile variation is normal and they accepted the material","Listen without defending, acknowledge the concern sincerely, schedule an in-person assessment within 24 hours, and escalate to the owner before committing to any remedy","Offer to redo the full installation immediately","Direct them to the warranty policy document"], ans:1 },
        { id:4,  q:"How do you assess substrate structural adequacy for large format tile?",
          opts:["Walk across the floor and feel for bounce","Check deflection (L/720 minimum), use a 10-foot straightedge for flatness, tap for hollow spots, and assess moisture with a moisture meter","Look for visible cracks only","Apply the same checklist used for small format tile"], ans:1 },
        { id:5,  q:"What is the correct construction and waterproofing sequence for a shower bench?",
          opts:["Frame bench, tile the top to establish height, then wrap the sides","Frame bench, fully waterproof all bench surfaces (top, sides, and all plane changes) with Kerdi before any tile is set","Tile the bench top first to confirm height, then waterproof sides","Waterproof the walls first, build the bench after, then tile everything together"], ans:1 },
        { id:6,  q:"When supervising an apprentice, what is your primary responsibility beyond task assignment?",
          opts:["Making sure they work at maximum speed","Ensuring safety compliance, demonstrating correct technique, checking quality at each stage, and providing real-time coaching feedback","Tracking their time accurately","Doing the skilled portions of the work yourself"], ans:1 },
        { id:7,  q:"What is the minimum practical scoring rubric average required for Lead Installer certification?",
          opts:["3.0 average","3.5 average","4.0 average","4.5 average"], ans:3 },
        { id:8,  q:"At what point must a change order be issued?",
          opts:["Only when the client verbally requests additions","Any time scope, materials, or cost deviates from the signed estimate — before additional work proceeds","At the end of the project if the scope expanded","Only for additions; deletions do not require documentation"], ans:1 },
        { id:9,  q:"How do you set up the layout spine for a herringbone pattern?",
          opts:["Snap diagonal lines from corner to corner of the room","Mark a center spine line the full length of the room, then set tiles at 45° in alternating directions off the spine — checking straightness every 6 tiles","Start from the doorway and angle outward","Use the room's natural diagonal as the spine reference"], ans:1 },
        { id:10, q:"A client calls 6 months post-completion to report a hollow tile. What is the correct response?",
          opts:["Inform them it is likely structural settling and may not be a workmanship issue","Log the call in CRM, acknowledge within 4 business hours, schedule a site assessment within 3 business days, assess the issue before committing to any remedy, and escalate to the owner","Send a written warranty denial letter","Offer to fix it immediately over the phone to retain goodwill"], ans:1 },
        { id:11, q:"What is the 'L/720 rule' and why does it matter for large format tile?",
          opts:["A grout joint specification","The minimum floor structural stiffness — the joist span divided by 720 gives the maximum allowable deflection. Large format tile will crack if this is not met.","A thinset mixing ratio","A slope standard for shower floors"], ans:1 },
        { id:12, q:"How do you document a performance issue with a crew member?",
          opts:["Tell them verbally and trust they will improve","Record the issue in internal notes with date and specifics, address it directly within 24 hours, and escalate to the owner if a pattern develops","Only document if the client complains","Wait for their annual review"], ans:1 },
        { id:13, q:"What is the minimum cure time for a Kerdi waterproofing installation before tile can be set?",
          opts:["No wait time required","The thinset used to embed Kerdi must cure per manufacturer spec (typically 24 hours) before tile is set over it","6 hours","72 hours"], ans:1 },
        { id:14, q:"What is the correct slope for a shower floor, and why?",
          opts:["Perfectly flat — tile is level","1/4 inch per foot minimum slope toward the drain to ensure complete water drainage and prevent pooling","1 inch per foot","Slope only matters for outdoor installations"], ans:1 },
        { id:15, q:"When managing a multi-crew job, how do you hand off shift information?",
          opts:["Leave a verbal message","Update the CRM job record with work completed, remaining tasks, any issues found, and material status — every day, before leaving the site","Call the next crew in the morning","Text the PM a summary"], ans:1 },
        { id:16, q:"What is the correct process when a subcontractor shows up without a valid certificate of insurance?",
          opts:["Allow them to start — you can get the COI later","Do not allow the subcontractor to begin work. Contact the PM immediately. Work cannot proceed without verified insurance on file.","Ask them to bring it tomorrow","Have them sign a waiver"], ans:1 },
        { id:17, q:"A tile in the completed installation shows more than 1/32-inch lippage. What must happen?",
          opts:["Accept it — all tile has some variation","Document it, flag for PM review, and if outside ANSI tolerance, the tile must be removed and reset before the job is considered complete","Grind the high edge down","Apply grout thicker on the low side"], ans:1 },
        { id:18, q:"How should a lead installer brief the crew before a job starts?",
          opts:["Tell them the address and start time by text","Provide a written job brief: address, full scope, tile selection, special client sensitivities, start time, estimated duration, and any substrate or access issues identified during site visit","Explain only the first day's tasks","Let the crew figure out the scope from the estimate"], ans:1 },
        { id:19, q:"What is the role of a lead installer during a client final walk-through?",
          opts:["Stay outside — only the PM interacts with the client","Walk every area of tile with the PM and client, respond calmly to any concerns without defending, document all items the client raises, and commit only to specific resolution timelines — not immediate fixes","Answer all client questions independently","Present the invoice to the client"], ans:1 },
        { id:20, q:"In the certification system, when is certification renewal required?",
          opts:["Every 5 years","Every 3 years","Annually","Only when the installer moves to a new level"], ans:2 },
      ]
    },
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // ASSESSMENT ENGINE
  // ─────────────────────────────────────────────────────────────────────────────
  const startAssessment = (levelKey) => {
    setActiveLevel(levelKey);
    setAssessTab("written");
    setExamAnswers({});
    setPracticalScores({});
    setExamResult(null);
    setPracticalResult(null);
  };

  const submitWritten = () => {
    const lvl = LEVELS[activeLevel];
    const qs  = lvl.questions;
    let correct = 0;
    qs.forEach(q => { if (examAnswers[q.id] === q.ans) correct++; });
    const score  = Math.round((correct / qs.length) * 100);
    const passed = score >= lvl.writingPassPct;
    setExamResult({ score, passed, correct, total: qs.length });
    if (passed) setAssessTab("practical");
  };

  const submitPractical = () => {
    const lvl    = LEVELS[activeLevel];
    const tasks  = lvl.practicalTasks;
    const scores = tasks.map((_, i) => practicalScores[i] || 0);
    const valid  = scores.every(s => s > 0);
    if (!valid) return;
    const avg    = scores.reduce((a,b) => a+b, 0) / scores.length;
    const passed = avg >= lvl.rubricMin;
    const result = { avg: avg.toFixed(2), passed, scores, date: new Date().toLocaleDateString() };
    setPracticalResult(result);
    if (passed && examResult?.passed) {
      setCompletedLevels(p => ({
        ...p,
        [activeLevel]: { written: examResult, practical: result, date: new Date().toLocaleDateString() }
      }));
    }
  };

  const RUBRIC = [[1,"Poor","var(--accent-red)"],[2,"Needs Improvement","var(--accent-amber)"],[3,"Acceptable","var(--stone-500)"],[4,"Proficient","var(--accent-green)"],[5,"Expert","var(--warm-gold)"]];

  // ─────────────────────────────────────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="fade-in">
      {/* Page header */}
      <div style={{ marginBottom:22 }}>
        <h1 className="section-title">Training Center</h1>
        <p className="section-sub">Video training library, competency assessments, and certification tracking for your team.</p>
      </div>

      {/* Main tab bar */}
      <div className="tab-bar" style={{ marginBottom:28 }}>
        {[["library","📹  Video Library"],["assessments","📝  Assessments & Skills"],["certifications","🏆  Certifications"]].map(([k,l]) => (
          <div key={k} className={`tab${tab===k?" active":""}`} onClick={() => { setTab(k); setActiveVideo(null); setActiveLevel(null); }}>{l}</div>
        ))}
      </div>

      {/* ══════════════════════════ VIDEO LIBRARY ══════════════════════════ */}
      {tab === "library" && !activeVideo && (
        <div className="fade-in">
          {/* Category filter */}
          <div style={{ display:"flex", gap:"8px", marginBottom:20, flexWrap:"wrap" }}>
            {allCategories.map(c => (
              <button key={c} className="btn btn-sm"
                style={{ background: libFilter===c ? "var(--warm-gold)" : "var(--stone-200)", color: libFilter===c ? "white" : "var(--stone-700)" }}
                onClick={() => setLibFilter(c)}>{c}</button>
            ))}
          </div>

          {/* Stats bar */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:12, marginBottom:22 }}>
            {[["Total Modules","10","var(--stone-700)"],["Safety & Prep","3","var(--accent-red)"],["Installation","4","var(--warm-gold)"],["Finishing","2","var(--accent-green)"],["Professionalism","2","var(--accent-blue)"]].map(([l,v,c]) => (
              <div key={l} className="stat-card">
                <div className="stat-value" style={{ color:c }}>{v}</div>
                <div className="stat-label">{l}</div>
              </div>
            ))}
          </div>

          {/* Module grid */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))", gap:16 }}>
            {filteredModules.map(v => (
              <div key={v.id} className="card" style={{ padding:0, overflow:"hidden", cursor:"pointer", transition:"transform 0.18s, box-shadow 0.18s" }}
                onClick={() => setActiveVideo(v)}
                onMouseEnter={e => { e.currentTarget.style.transform="translateY(-3px)"; e.currentTarget.style.boxShadow="0 10px 28px rgba(0,0,0,0.13)"; }}
                onMouseLeave={e => { e.currentTarget.style.transform=""; e.currentTarget.style.boxShadow=""; }}>
                {/* Thumbnail */}
                <div style={{ height:130, background:"linear-gradient(135deg,#1c1a17 0%,#2c2a25 100%)", display:"flex", alignItems:"center", justifyContent:"center", position:"relative", borderLeft:`5px solid ${v.color}` }}>
                  <div style={{ width:48, height:48, borderRadius:"50%", background:"rgba(255,255,255,0.1)", border:"2px solid rgba(255,255,255,0.25)", display:"flex", alignItems:"center", justifyContent:"center" }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                  </div>
                  <div style={{ position:"absolute", top:9, left:13, fontSize:"10px", fontWeight:700, color:"rgba(255,255,255,0.45)", letterSpacing:"0.1em", textTransform:"uppercase" }}>Module {v.id}</div>
                  <div style={{ position:"absolute", bottom:9, right:11, background:"rgba(0,0,0,0.55)", color:"white", fontSize:"11px", padding:"2px 8px", borderRadius:99 }}>{v.duration}</div>
                  <div style={{ position:"absolute", top:9, right:11, background:v.color, color:"white", fontSize:"10px", fontWeight:700, padding:"2px 8px", borderRadius:99 }}>{v.forLevel}</div>
                  {/* Edit button overlay */}
                  <button
                    style={{ position:"absolute", bottom:9, left:11, background:"rgba(201,169,110,0.85)", border:"none", borderRadius:6, padding:"3px 8px", fontSize:"11px", fontWeight:700, color:"white", cursor:"pointer", display:"flex", alignItems:"center", gap:4 }}
                    onClick={e => { e.stopPropagation(); openEdit(v); }}
                  >
                    <Icon name="edit" size={11} color="white"/> Edit
                  </button>
                </div>
                {/* Info */}
                <div style={{ padding:"13px 15px" }}>
                  <div style={{ fontWeight:600, fontSize:"14px", marginBottom:6, lineHeight:1.3 }}>{v.title}</div>
                  <div style={{ display:"flex", gap:6, marginBottom:8 }}>
                    <span style={{ fontSize:"11px", background:`${CAT_COLOR[v.category]}18`, color:CAT_COLOR[v.category], padding:"2px 8px", borderRadius:99, fontWeight:600 }}>{v.category}</span>
                    <span style={{ fontSize:"11px", color:"var(--stone-400)", padding:"2px 4px" }}>{v.scenes.length} scenes</span>
                  </div>
                  <div style={{ fontSize:"12px", color:"var(--stone-500)", lineHeight:1.5 }}>{v.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── Video Detail ── */}
      {tab === "library" && activeVideo && (
        <div className="fade-in">
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:18 }}>
            <button className="btn btn-secondary btn-sm" onClick={() => setActiveVideo(null)}>← Back to Library</button>
            <button className="btn btn-primary btn-sm" onClick={() => openEdit(activeVideo)}>
              <Icon name="edit" size={13}/> Edit Script
            </button>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 300px", gap:20, alignItems:"start" }}>
            <div>
              {/* Player placeholder */}
              <div style={{ height:210, borderRadius:"var(--radius-lg)", background:"linear-gradient(135deg,#1c1a17,#2c2a25)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", marginBottom:18, borderLeft:`5px solid ${activeVideo.color}`, position:"relative" }}>
                <div style={{ width:58, height:58, borderRadius:"50%", background:"rgba(255,255,255,0.09)", border:"2px solid rgba(255,255,255,0.25)", display:"flex", alignItems:"center", justifyContent:"center", marginBottom:10 }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="white"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                </div>
                <div style={{ color:"rgba(255,255,255,0.6)", fontSize:"13px" }}>Video player — upload your recording to activate</div>
                <div style={{ position:"absolute", top:14, left:18, color:"white" }}>
                  <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700 }}>Module {activeVideo.id}: {activeVideo.title}</div>
                  <div style={{ color:"rgba(255,255,255,0.45)", fontSize:"11px", marginTop:2 }}>{activeVideo.duration} · {activeVideo.forLevel} Level · {activeVideo.category}</div>
                </div>
              </div>

              {/* Scene scripts — exact from document */}
              <h3 style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:600, marginBottom:14 }}>Production Script</h3>
              <div style={{ display:"grid", gap:12 }}>
                {activeVideo.scenes.map((s,i) => (
                  <div key={i} className="card" style={{ padding:"15px 18px", borderLeft:`3px solid ${activeVideo.color}` }}>
                    <div style={{ display:"flex", justifyContent:"space-between", marginBottom:8 }}>
                      <span style={{ fontWeight:700, fontSize:"13px", color:"var(--stone-700)" }}>{s.label}</span>
                      <span style={{ fontSize:"11px", background:"var(--stone-200)", padding:"2px 8px", borderRadius:99, color:"var(--stone-500)" }}>Scene {i+1}</span>
                    </div>
                    {s.camera && (
                      <div style={{ fontSize:"12px", color:"var(--accent-blue)", marginBottom:7, display:"flex", gap:5 }}>
                        <span>🎥</span><span><strong>Camera:</strong> {s.camera}</span>
                      </div>
                    )}
                    <div style={{ fontSize:"13px", color:"var(--stone-700)", background:"var(--stone-100)", borderRadius:6, padding:"10px 12px", lineHeight:1.75, fontStyle:"italic", marginBottom: s.onScreen ? 8 : 0 }}>
                      {s.vo}
                    </div>
                    {s.onScreen && (
                      <div style={{ fontSize:"12px", color:"var(--warm-gold)", display:"flex", gap:5, marginTop:6 }}>
                        <span>📺</span><span><strong>On-Screen Text:</strong> {s.onScreen}</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Sidebar */}
            <div>
              <div className="card" style={{ padding:18, marginBottom:14 }}>
                <div style={{ fontWeight:700, fontSize:"13px", marginBottom:12 }}>Module Info</div>
                {[["Module",`#${activeVideo.id}`],["Category",activeVideo.category],["Target Level",activeVideo.forLevel],["Est. Duration",activeVideo.duration],["Scenes",`${activeVideo.scenes.length}`]].map(([k,v]) => (
                  <div key={k} style={{ display:"flex", justifyContent:"space-between", fontSize:"13px", padding:"6px 0", borderBottom:"1px solid var(--stone-100)" }}>
                    <span style={{ color:"var(--stone-500)" }}>{k}</span>
                    <span style={{ fontWeight:500 }}>{v}</span>
                  </div>
                ))}
              </div>
              <div className="card" style={{ padding:16, background:"rgba(201,169,110,0.07)", border:"1.5px solid var(--sand-300)" }}>
                <div style={{ fontWeight:700, fontSize:"13px", color:"var(--warm-gold)", marginBottom:7 }}>💡 Production Notes</div>
                <div style={{ fontSize:"12px", color:"var(--stone-600)", lineHeight:1.6, marginBottom:12 }}>
                  Each scene contains the exact camera direction, voiceover script, and on-screen text overlay from the Timeless Tile Pro Video Training Script Library.
                </div>
                <button className="btn btn-primary btn-sm" style={{ width:"100%" }}><Icon name="upload" size={13}/> Upload Video Recording</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════ ASSESSMENTS & SKILLS ══════════════════════ */}
      {tab === "assessments" && !activeLevel && (
        <div className="fade-in">
          <div style={{ marginBottom:18, padding:"13px 16px", background:"rgba(201,169,110,0.08)", border:"1.5px solid var(--sand-300)", borderRadius:"var(--radius)", display:"flex", gap:10, alignItems:"flex-start" }}>
            <span style={{ fontSize:18 }}>📋</span>
            <div style={{ fontSize:"13px", color:"var(--stone-700)", lineHeight:1.6 }}>
              <strong>Assessment System:</strong> Each level has a written knowledge exam and a practical skill evaluation scored on a 1–5 rubric. Both must be passed to earn certification. Apprentice &amp; Junior Installer require 80% written. Installer requires 85%. Lead Installer requires 90%. Practical rubric minimums: Apprentice 3.0 · Junior 3.5 · Installer 4.0 · Lead 4.5.
            </div>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(270px,1fr))", gap:16 }}>
            {Object.entries(LEVELS).map(([key, lvl]) => {
              const done = completedLevels[key];
              return (
                <div key={key} className="card" style={{ padding:0, overflow:"hidden", borderTop:`4px solid ${lvl.color}` }}>
                  <div style={{ padding:"18px 20px" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:10 }}>
                      <div>
                        <div style={{ fontSize:22, marginBottom:3 }}>{lvl.emoji}</div>
                        <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700 }}>Level {lvl.num}</div>
                        <div style={{ fontSize:"13px", fontWeight:600, color:lvl.color }}>{key}</div>
                      </div>
                      {done && (
                        <span style={{ fontSize:"11px", fontWeight:700, background:"#d3f9d8", color:"#2b8a3e", padding:"3px 10px", borderRadius:99 }}>CERTIFIED</span>
                      )}
                    </div>
                    <div style={{ fontSize:"12px", color:"var(--stone-500)", marginBottom:12, lineHeight:1.5 }}>{lvl.focus}</div>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:7, marginBottom:14 }}>
                      {[["Written Pass",`${lvl.writingPassPct}%`],["Practical Min",`${lvl.rubricMin} avg`],["Questions",`${lvl.questions.length}`],["Practical Tasks",`${lvl.practicalTasks.length}`]].map(([k,v]) => (
                        <div key={k} style={{ background:"var(--stone-100)", borderRadius:6, padding:"7px 9px" }}>
                          <div style={{ fontSize:"10px", fontWeight:700, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:2 }}>{k}</div>
                          <div style={{ fontSize:"13px", fontWeight:700, color:"var(--stone-800)" }}>{v}</div>
                        </div>
                      ))}
                    </div>
                    <button className="btn btn-primary" style={{ width:"100%", background:lvl.color, borderColor:lvl.color }} onClick={() => startAssessment(key)}>
                      {done ? "Retake Assessment" : "Begin Assessment"} →
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── Active Assessment ── */}
      {tab === "assessments" && activeLevel && (
        <div className="fade-in">
          {(() => {
            const lvl  = LEVELS[activeLevel];

            return (
              <div>
                {/* Assessment header */}
                <div style={{ background:"var(--stone-800)", borderRadius:"var(--radius-lg)", padding:"16px 20px", marginBottom:20, display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:10 }}>
                  <div>
                    <div style={{ fontFamily:"var(--font-display)", fontSize:"19px", fontWeight:700, color:"white" }}>{activeLevel} Certification Assessment</div>
                    <div style={{ fontSize:"12px", color:"var(--stone-400)", marginTop:2 }}>Timeless Tile Pro · Passing: {lvl.writingPassPct}% written · {lvl.rubricMin} practical avg</div>
                  </div>
                  <div style={{ display:"flex", gap:8 }}>
                    <button className={`tab${assessTab==="written"?" active":""}`} style={{ background: assessTab==="written"?"var(--warm-gold)":"var(--stone-600)", color:"white", border:"none", borderRadius:"var(--radius)", padding:"6px 14px", cursor:"pointer", fontSize:"12px", fontWeight:600 }}>📝 Written</button>
                    <button className={`tab${assessTab==="practical"?" active":""}`} style={{ background: assessTab==="practical"?"var(--warm-gold)": examResult?.passed ? "var(--stone-600)" : "var(--stone-700)", color: examResult?.passed ? "white" : "var(--stone-500)", border:"none", borderRadius:"var(--radius)", padding:"6px 14px", cursor: examResult?.passed ? "pointer" : "not-allowed", fontSize:"12px", fontWeight:600 }}
                      onClick={() => { if (examResult?.passed) setAssessTab("practical"); }}>🛠 Practical {!examResult?.passed && "(Pass written first)"}</button>
                  </div>
                </div>

                {/* Learner name prompt */}
                {!learnerName && (
                  <div style={{ marginBottom:16, padding:"12px 16px", background:"rgba(201,169,110,0.08)", border:"1.5px solid var(--sand-300)", borderRadius:"var(--radius)", display:"flex", gap:10, alignItems:"center", flexWrap:"wrap" }}>
                    <Icon name="leads" size={15} color="var(--warm-gold)"/>
                    <span style={{ fontSize:"13px", fontWeight:500 }}>Learner name (for certificate):</span>
                    <input placeholder="Enter full name" style={{ flex:1, minWidth:200 }} value={learnerName} onChange={e => setLearnerName(e.target.value)} />
                  </div>
                )}

                {/* ── WRITTEN EXAM ── */}
                {assessTab === "written" && (
                  <div>
                    {!examResult ? (
                      <div>
                        <div style={{ marginBottom:14, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                          <span style={{ fontSize:"13px", color:"var(--stone-500)" }}>{Object.keys(examAnswers).length} of {lvl.questions.length} answered</span>
                          <div style={{ width:200, height:5, background:"var(--stone-200)", borderRadius:3 }}>
                            <div style={{ width:`${(Object.keys(examAnswers).length/lvl.questions.length)*100}%`, height:"100%", background:lvl.color, borderRadius:3, transition:"width 0.3s" }}/>
                          </div>
                        </div>
                        <div style={{ display:"grid", gap:14, marginBottom:22 }}>
                          {lvl.questions.map((q,qi) => (
                            <div key={q.id} className="card" style={{ padding:"16px 18px", borderLeft:`3px solid ${examAnswers[q.id]!==undefined?lvl.color:"var(--stone-200)"}` }}>
                              <div style={{ fontWeight:600, fontSize:"14px", marginBottom:12, lineHeight:1.5 }}>
                                <span style={{ color:lvl.color, fontWeight:700, marginRight:8 }}>Q{qi+1}.</span>{q.q}
                              </div>
                              <div style={{ display:"grid", gap:7 }}>
                                {q.opts.map((opt,oi) => (
                                  <label key={oi} style={{ display:"flex", gap:10, padding:"9px 13px", borderRadius:"var(--radius)", border:`1.5px solid ${examAnswers[q.id]===oi?"var(--warm-gold)":"var(--stone-200)"}`, background:examAnswers[q.id]===oi?"rgba(201,169,110,0.1)":"white", cursor:"pointer", transition:"all 0.15s", fontSize:"13px", lineHeight:1.5 }}>
                                    <input type="radio" name={`q${q.id}`} value={oi} checked={examAnswers[q.id]===oi} onChange={() => setExamAnswers(p => ({...p,[q.id]:oi}))} style={{ marginTop:2, flexShrink:0, accentColor:"var(--warm-gold)" }}/>
                                    <span>{opt}</span>
                                  </label>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:10 }}>
                          <button className="btn btn-secondary" onClick={() => { setActiveLevel(null); setExamAnswers({}); }}>Cancel</button>
                          <button className="btn btn-primary" style={{ opacity: Object.keys(examAnswers).length < lvl.questions.length ? 0.55 : 1 }}
                            disabled={Object.keys(examAnswers).length < lvl.questions.length} onClick={submitWritten}>
                            <Icon name="check" size={14}/> Submit Written Exam ({Object.keys(examAnswers).length}/{lvl.questions.length})
                          </button>
                        </div>
                      </div>
                    ) : (
                      /* Written result */
                      <div className="card" style={{ padding:"28px", textAlign:"center", borderTop:`5px solid ${examResult.passed?"var(--accent-green)":"var(--accent-red)"}`, maxWidth:520, margin:"0 auto" }}>
                        <div style={{ fontSize:48, marginBottom:10 }}>{examResult.passed?"✅":"❌"}</div>
                        <div style={{ fontFamily:"var(--font-display)", fontSize:"22px", fontWeight:700, marginBottom:4 }}>
                          {examResult.passed ? "Written Exam Passed!" : "Written Exam Not Passed"}
                        </div>
                        <div style={{ fontSize:"40px", fontWeight:800, color:examResult.passed?"var(--accent-green)":"var(--accent-red)", fontFamily:"var(--font-display)", margin:"14px 0" }}>{examResult.score}%</div>
                        <div style={{ fontSize:"13px", color:"var(--stone-500)", marginBottom:18 }}>{examResult.correct} of {examResult.total} correct · Required: {lvl.writingPassPct}%</div>
                        {examResult.passed ? (
                          <div>
                            <div style={{ fontSize:"13px", color:"var(--stone-600)", marginBottom:16, lineHeight:1.6 }}>Great work! Now complete the Practical Skills Evaluation below to finish your certification.</div>
                            <button className="btn btn-primary" onClick={() => setAssessTab("practical")} style={{ background:lvl.color, borderColor:lvl.color }}>
                              Continue to Practical Evaluation →
                            </button>
                          </div>
                        ) : (
                          <div>
                            <div style={{ fontSize:"13px", color:"var(--stone-600)", marginBottom:16 }}>Review the training videos and SOP materials for this level, then retake.</div>
                            <div style={{ display:"flex", gap:8, justifyContent:"center" }}>
                              <button className="btn btn-secondary" onClick={() => { setActiveLevel(null); setExamAnswers({}); setExamResult(null); }}>Back to Levels</button>
                              <button className="btn btn-primary" onClick={() => { setExamAnswers({}); setExamResult(null); }}>Retake Written Exam</button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* ── PRACTICAL SKILLS EVALUATION ── */}
                {assessTab === "practical" && (
                  <div>
                    <div style={{ marginBottom:16, padding:"13px 16px", background:"rgba(201,169,110,0.08)", border:"1.5px solid var(--sand-300)", borderRadius:"var(--radius)" }}>
                      <div style={{ fontWeight:600, fontSize:"13px", marginBottom:4 }}>Practical Evaluation — Score Each Task 1–5</div>
                      <div style={{ fontSize:"12px", color:"var(--stone-600)", lineHeight:1.6 }}><strong>Pass/Fail Criteria:</strong> {lvl.practicalCriteria} · Minimum average to pass: <strong>{lvl.rubricMin}</strong></div>
                    </div>

                    {/* Rubric legend */}
                    <div style={{ display:"flex", gap:8, marginBottom:18, flexWrap:"wrap" }}>
                      {RUBRIC.map(([n,l,c]) => (
                        <div key={n} style={{ display:"flex", alignItems:"center", gap:5, background:"var(--stone-100)", borderRadius:6, padding:"4px 10px" }}>
                          <div style={{ width:18, height:18, borderRadius:"50%", background:c, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"10px", fontWeight:800, color:"white", flexShrink:0 }}>{n}</div>
                          <span style={{ fontSize:"11px", fontWeight:500 }}>{l}</span>
                        </div>
                      ))}
                    </div>

                    {!practicalResult ? (
                      <div>
                        <div style={{ display:"grid", gap:14, marginBottom:22 }}>
                          {lvl.practicalTasks.map((task, i) => (
                            <div key={i} className="card" style={{ padding:"16px 18px", borderLeft:`3px solid ${practicalScores[i]?lvl.color:"var(--stone-200)"}` }}>
                              <div style={{ fontWeight:600, fontSize:"14px", marginBottom:12 }}>
                                <span style={{ color:lvl.color, marginRight:8 }}>Task {i+1}.</span>{task}
                              </div>
                              <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                                {RUBRIC.map(([n,l,c]) => (
                                  <label key={n} style={{ display:"flex", alignItems:"center", gap:6, padding:"8px 14px", borderRadius:"var(--radius)", border:`1.5px solid ${practicalScores[i]===n?c:"var(--stone-200)"}`, background:practicalScores[i]===n?`${c}18`:"white", cursor:"pointer", transition:"all 0.15s", fontSize:"12px", fontWeight: practicalScores[i]===n ? 700 : 400 }}>
                                    <input type="radio" name={`task${i}`} value={n} checked={practicalScores[i]===n} onChange={() => setPracticalScores(p => ({...p,[i]:n}))} style={{ display:"none" }}/>
                                    <div style={{ width:20, height:20, borderRadius:"50%", background: practicalScores[i]===n?c:"var(--stone-200)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"11px", fontWeight:800, color:"white", flexShrink:0 }}>{n}</div>
                                    <span style={{ color: practicalScores[i]===n?c:"var(--stone-600)" }}>{l}</span>
                                  </label>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:10 }}>
                          <button className="btn btn-secondary" onClick={() => setAssessTab("written")}>← Back to Written Results</button>
                          <button className="btn btn-primary"
                            style={{ opacity: Object.keys(practicalScores).length < lvl.practicalTasks.length ? 0.55 : 1 }}
                            disabled={Object.keys(practicalScores).length < lvl.practicalTasks.length}
                            onClick={submitPractical}>
                            <Icon name="check" size={14}/> Submit Practical Evaluation
                          </button>
                        </div>
                      </div>
                    ) : (
                      /* Practical result */
                      <div className="card" style={{ padding:"28px", textAlign:"center", borderTop:`5px solid ${practicalResult.passed?"var(--accent-green)":"var(--accent-red)"}`, maxWidth:520, margin:"0 auto" }}>
                        <div style={{ fontSize:48, marginBottom:10 }}>{practicalResult.passed && examResult?.passed ? "🏆" : "📋"}</div>
                        <div style={{ fontFamily:"var(--font-display)", fontSize:"22px", fontWeight:700, marginBottom:4 }}>
                          {practicalResult.passed && examResult?.passed ? "Certification Complete!" : "Practical Evaluation Not Passed"}
                        </div>
                        <div style={{ fontSize:"36px", fontWeight:800, color:practicalResult.passed?"var(--accent-green)":"var(--accent-red)", fontFamily:"var(--font-display)", margin:"12px 0" }}>
                          {practicalResult.avg} avg
                        </div>
                        <div style={{ fontSize:"13px", color:"var(--stone-500)", marginBottom:8 }}>Required: {lvl.rubricMin} minimum average</div>

                        {/* Per-task scores */}
                        <div style={{ background:"var(--stone-100)", borderRadius:"var(--radius)", padding:"14px 16px", marginBottom:18, textAlign:"left" }}>
                          {lvl.practicalTasks.map((t,i) => {
                            const s = practicalResult.scores[i];
                            const rubricEntry = RUBRIC.find(r=>r[0]===s);
                            return (
                              <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:"13px", padding:"5px 0", borderBottom:"1px solid var(--stone-200)" }}>
                                <span style={{ color:"var(--stone-600)", flex:1, marginRight:8 }}>Task {i+1}: {t.substring(0,40)}{t.length>40?"…":""}</span>
                                <span style={{ fontWeight:700, color:rubricEntry?.[2]||"var(--stone-600)" }}>{s} — {rubricEntry?.[1]}</span>
                              </div>
                            );
                          })}
                        </div>

                        {practicalResult.passed && examResult?.passed ? (
                          <div>
                            <div style={{ fontSize:"13px", color:"var(--stone-600)", marginBottom:16, lineHeight:1.6 }}>
                              Both the written exam and practical evaluation have been passed. Complete your performance review with the owner to receive your official Timeless Tile Pro certificate.
                            </div>
                            <div style={{ display:"flex", gap:8, justifyContent:"center", flexWrap:"wrap" }}>
                              <button className="btn btn-secondary" onClick={() => { setActiveLevel(null); setExamResult(null); setPracticalResult(null); }}>Back to Assessments</button>
                              <button className="btn btn-primary" style={{ background:lvl.color, borderColor:lvl.color }} onClick={() => { setTab("certifications"); setActiveLevel(null); }}>
                                <Icon name="star" size={14}/> View Certification →
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div style={{ fontSize:"13px", color:"var(--stone-600)", marginBottom:16 }}>Review the practical skill areas where you scored below {lvl.rubricMin} with your supervisor, then retake.</div>
                            <div style={{ display:"flex", gap:8, justifyContent:"center" }}>
                              <button className="btn btn-secondary" onClick={() => { setActiveLevel(null); }}>Back to Levels</button>
                              <button className="btn btn-primary" onClick={() => { setPracticalScores({}); setPracticalResult(null); }}>Retake Practical</button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })()}
        </div>
      )}

      {/* ══════════════════════════ CERTIFICATIONS ══════════════════════════ */}
      {tab === "certifications" && (
        <div className="fade-in">
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(290px,1fr))", gap:16, marginBottom:24 }}>
            {Object.entries(LEVELS).map(([key, lvl]) => {
              const done = completedLevels[key];
              const steps = [
                { label:"Written Assessment", done:!!done, detail: done ? `${done.written.score}% · ${done.written.correct}/${done.written.total} correct` : null },
                { label:"Practical Evaluation", done:!!(done?.practical?.passed), detail: done?.practical ? `${done.practical.avg} avg score · ${done.practical.date}` : null },
                { label:"Performance Review", done:false, detail:null },
                { label:"Certification Issued", done:false, detail:null },
              ];
              return (
                <div key={key} className="card" style={{ padding:0, overflow:"hidden" }}>
                  <div style={{ background:"linear-gradient(135deg,var(--stone-800),var(--stone-900))", padding:"18px 20px", borderTop:`4px solid ${lvl.color}` }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <div style={{ fontSize:26 }}>{lvl.emoji}</div>
                      {done
                        ? <span style={{ fontSize:"11px", fontWeight:700, background:"rgba(122,158,126,0.3)", color:"#7ee787", padding:"3px 10px", borderRadius:99 }}>WRITTEN + PRACTICAL PASSED</span>
                        : <span style={{ fontSize:"11px", background:"rgba(255,255,255,0.07)", color:"var(--stone-400)", padding:"3px 10px", borderRadius:99 }}>In Progress</span>
                      }
                    </div>
                    <div style={{ fontFamily:"var(--font-display)", fontSize:"19px", fontWeight:700, color:"white", marginTop:8 }}>Level {lvl.num} — {key}</div>
                    <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:2 }}>Timeless Tile Pro Certification Program</div>
                  </div>
                  <div style={{ padding:"16px 20px" }}>
                    <div style={{ fontSize:"12px", color:"var(--stone-500)", marginBottom:14, lineHeight:1.5 }}>{lvl.focus}</div>
                    <div style={{ display:"grid", gap:9, marginBottom:16 }}>
                      {steps.map((s,i) => (
                        <div key={i} style={{ display:"flex", alignItems:"flex-start", gap:9, fontSize:"13px" }}>
                          <div style={{ width:20, height:20, borderRadius:"50%", background:s.done?lvl.color:"var(--stone-200)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, marginTop:1 }}>
                            {s.done ? <Icon name="check" size={11} color="white"/> : <span style={{ fontSize:"8px", color:"var(--stone-400)" }}>○</span>}
                          </div>
                          <div>
                            <div style={{ color:s.done?"var(--stone-800)":"var(--stone-400)", fontWeight:s.done?600:400 }}>{s.label}</div>
                            {s.detail && <div style={{ fontSize:"11px", color:lvl.color, fontWeight:600, marginTop:1 }}>{s.detail}</div>}
                          </div>
                        </div>
                      ))}
                    </div>
                    <div style={{ display:"flex", gap:8 }}>
                      <button className="btn btn-secondary btn-sm" style={{ flex:1 }} onClick={() => { setTab("assessments"); startAssessment(key); }}>
                        {done ? "Retake" : "Start Assessment"}
                      </button>
                      {done && (
                        <button className="btn btn-primary btn-sm" style={{ flex:1, background:lvl.color, borderColor:lvl.color }} onClick={() => setCertModal(key)}>
                          <Icon name="star" size={12}/> Certificate
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Scoring rubric reference */}
          <div className="card" style={{ padding:"20px 24px" }}>
            <div style={{ fontFamily:"var(--font-display)", fontSize:"17px", fontWeight:600, marginBottom:14 }}>Scoring Rubric Reference — Practical Evaluations</div>
            <div style={{ display:"flex", gap:10, flexWrap:"wrap", marginBottom:14 }}>
              {RUBRIC.map(([n,l,c]) => (
                <div key={n} style={{ display:"flex", alignItems:"center", gap:7, padding:"8px 14px", background:"var(--stone-100)", borderRadius:"var(--radius)", flex:"1 1 160px" }}>
                  <div style={{ width:26, height:26, borderRadius:"50%", background:c, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"12px", fontWeight:800, color:"white", flexShrink:0 }}>{n}</div>
                  <span style={{ fontSize:"13px", fontWeight:500 }}>{l}</span>
                </div>
              ))}
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))", gap:8 }}>
              {Object.entries(LEVELS).map(([key,lvl]) => (
                <div key={key} style={{ display:"flex", justifyContent:"space-between", padding:"9px 13px", background:"var(--stone-100)", borderRadius:"var(--radius)", alignItems:"center" }}>
                  <span style={{ fontSize:"13px", color:"var(--stone-600)" }}>{key}</span>
                  <span style={{ fontWeight:700, color:lvl.color, fontSize:"13px" }}>Min {lvl.rubricMin}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ── Edit Script Modal ── */}
      {editingModule && editForm && (
        <Modal title={`Edit Script — Module ${editForm.id}: ${editForm.title}`} onClose={cancelEdit}>
          <div style={{ maxHeight:"72vh", overflowY:"auto", paddingRight:4 }}>

            {/* Module meta */}
            <div style={{ background:"var(--stone-100)", borderRadius:"var(--radius)", padding:"14px 16px", marginBottom:20 }}>
              <div style={{ fontWeight:700, fontSize:"12px", color:"var(--stone-500)", textTransform:"uppercase", letterSpacing:"0.07em", marginBottom:12 }}>Module Details</div>
              <div className="form-grid">
                <div className="form-group">
                  <label>Module Title</label>
                  <input value={editForm.title} onChange={e => setEditForm(p => ({...p,title:e.target.value}))} />
                </div>
                <div className="form-group">
                  <label>Category</label>
                  <select value={editForm.category} onChange={e => setEditForm(p => ({...p,category:e.target.value}))}>
                    {["Orientation","Safety","Prep","Waterproofing","Installation","Finishing","Professionalism"].map(c => <option key={c}>{c}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Target Level</label>
                  <select value={editForm.forLevel} onChange={e => setEditForm(p => ({...p,forLevel:e.target.value}))}>
                    {["All","Apprentice","Junior Installer","Installer","Lead Installer"].map(l => <option key={l}>{l}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Est. Duration</label>
                  <input value={editForm.duration} onChange={e => setEditForm(p => ({...p,duration:e.target.value}))} placeholder="e.g. ~12 min" />
                </div>
                <div className="form-group form-full">
                  <label>Module Description</label>
                  <textarea rows={2} value={editForm.desc} onChange={e => setEditForm(p => ({...p,desc:e.target.value}))} />
                </div>
              </div>
            </div>

            {/* Scenes */}
            <div style={{ fontWeight:700, fontSize:"13px", marginBottom:12, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <span>Production Scenes ({editForm.scenes.length})</span>
              <button className="btn btn-primary btn-sm" onClick={addScene}><Icon name="plus" size={13}/> Add Scene</button>
            </div>

            <div style={{ display:"grid", gap:14 }}>
              {editForm.scenes.map((scene, idx) => (
                <div key={idx} style={{ border:"1.5px solid var(--stone-200)", borderRadius:"var(--radius-lg)", padding:"16px 18px", background:"white", position:"relative" }}>
                  {/* Scene number badge */}
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                      <div style={{ width:24, height:24, borderRadius:"50%", background:"var(--warm-gold)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"11px", fontWeight:800, color:"white", flexShrink:0 }}>{idx+1}</div>
                      <span style={{ fontWeight:700, fontSize:"13px", color:"var(--stone-700)" }}>Scene {idx+1}</span>
                    </div>
                    {editForm.scenes.length > 1 && (
                      <button className="btn-icon" title="Remove scene" onClick={() => removeScene(idx)}>
                        <Icon name="trash" size={13} color="var(--accent-red)"/>
                      </button>
                    )}
                  </div>

                  <div className="form-group" style={{ marginBottom:10 }}>
                    <label>Scene Label</label>
                    <input value={scene.label} onChange={e => updateScene(idx,"label",e.target.value)} placeholder="e.g. Scene 1 — PPE Overview" />
                  </div>

                  <div className="form-group" style={{ marginBottom:10 }}>
                    <label>🎥 Camera Direction</label>
                    <input value={scene.camera} onChange={e => updateScene(idx,"camera",e.target.value)} placeholder="Describe the shot setup" />
                  </div>

                  <div className="form-group" style={{ marginBottom:10 }}>
                    <label>🎙 Voiceover / Script</label>
                    <textarea rows={5}
                      value={scene.vo}
                      onChange={e => updateScene(idx,"vo",e.target.value)}
                      placeholder="Enter the full voiceover or spoken script for this scene..."
                      style={{ fontSize:"13px", lineHeight:1.7, fontFamily:"var(--font-body)" }}
                    />
                  </div>

                  <div className="form-group" style={{ marginBottom:0 }}>
                    <label>📺 On-Screen Text Overlay</label>
                    <input value={scene.onScreen} onChange={e => updateScene(idx,"onScreen",e.target.value)} placeholder="e.g. Safety First — Professionalism Always" />
                  </div>
                </div>
              ))}
            </div>

            {/* Add scene prompt at bottom */}
            <div
              onClick={addScene}
              style={{ marginTop:12, padding:"12px", border:"1.5px dashed var(--stone-300)", borderRadius:"var(--radius)", textAlign:"center", cursor:"pointer", color:"var(--stone-400)", fontSize:"13px", transition:"all 0.15s" }}
              onMouseEnter={e => { e.currentTarget.style.borderColor="var(--warm-gold)"; e.currentTarget.style.color="var(--warm-gold)"; e.currentTarget.style.background="rgba(201,169,110,0.05)"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor="var(--stone-300)"; e.currentTarget.style.color="var(--stone-400)"; e.currentTarget.style.background="transparent"; }}
            >
              <Icon name="plus" size={14}/> Add another scene
            </div>
          </div>

          {/* Footer actions */}
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:18, paddingTop:14, borderTop:"1px solid var(--stone-200)" }}>
            <div style={{ fontSize:"12px", color:"var(--stone-400)" }}>
              {editForm.scenes.length} scene{editForm.scenes.length!==1?"s":""} · Changes save immediately
            </div>
            <div style={{ display:"flex", gap:8 }}>
              <button className="btn btn-secondary" onClick={cancelEdit}>Cancel</button>
              <button className="btn btn-primary" onClick={saveEdit}><Icon name="check" size={14}/> Save Script</button>
            </div>
          </div>
        </Modal>
      )}

      {/* ── Certificate Modal ── */}
      {certModal && (
        <Modal title="Certificate of Completion" onClose={() => setCertModal(null)}>
          {(() => {
            const lvl    = LEVELS[certModal];
            const done   = completedLevels[certModal];
            const name   = learnerName || "___________________________";
            const issued = done?.date || new Date().toLocaleDateString();
            return (
              <div>
                <div style={{ background:"var(--stone-50)", border:`3px solid ${lvl.color}`, borderRadius:"var(--radius-lg)", padding:"34px 28px", textAlign:"center" }}>
                  {/* Header ornament */}
                  <div style={{ display:"flex", justifyContent:"center", gap:12, marginBottom:18, alignItems:"center" }}>
                    <div style={{ height:1, background:`linear-gradient(to right, transparent, ${lvl.color})`, flex:1 }}/>
                    <span style={{ fontSize:28 }}>{lvl.emoji}</span>
                    <div style={{ height:1, background:`linear-gradient(to left, transparent, ${lvl.color})`, flex:1 }}/>
                  </div>
                  <div style={{ fontFamily:"var(--font-display)", fontSize:"11px", fontWeight:700, letterSpacing:"0.18em", textTransform:"uppercase", color:"var(--stone-400)", marginBottom:12 }}>Certificate of Completion</div>
                  <div style={{ fontFamily:"var(--font-display)", fontSize:"30px", fontWeight:800, color:"var(--stone-900)", marginBottom:4 }}>Timeless Tile Pro</div>
                  <div style={{ width:56, height:3, background:lvl.color, margin:"0 auto 18px" }}/>
                  <div style={{ fontSize:"13px", color:"var(--stone-500)", marginBottom:6 }}>This certifies that</div>
                  <div style={{ fontFamily:"var(--font-display)", fontSize:"24px", fontWeight:700, color:lvl.color, borderBottom:`1.5px solid ${lvl.color}`, display:"inline-block", paddingBottom:4, minWidth:280, marginBottom:12 }}>{name}</div>
                  <div style={{ fontSize:"13px", color:"var(--stone-500)", marginBottom:6 }}>has successfully completed the</div>
                  <div style={{ fontFamily:"var(--font-display)", fontSize:"20px", fontWeight:700, color:"var(--stone-900)", marginBottom:4 }}>Level {lvl.num} — {certModal} Certification</div>
                  <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:20 }}>and is recognized as a qualified professional within the Timeless Tile Pro organization</div>
                  {/* Scores */}
                  {done && (
                    <div style={{ display:"flex", justifyContent:"center", gap:16, marginBottom:22, flexWrap:"wrap" }}>
                      <div style={{ background:"var(--stone-100)", borderRadius:8, padding:"8px 16px", textAlign:"center" }}>
                        <div style={{ fontSize:"10px", fontWeight:700, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em" }}>Written</div>
                        <div style={{ fontSize:"18px", fontWeight:800, color:lvl.color }}>{done.written.score}%</div>
                      </div>
                      <div style={{ background:"var(--stone-100)", borderRadius:8, padding:"8px 16px", textAlign:"center" }}>
                        <div style={{ fontSize:"10px", fontWeight:700, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em" }}>Practical</div>
                        <div style={{ fontSize:"18px", fontWeight:800, color:lvl.color }}>{done.practical.avg} avg</div>
                      </div>
                    </div>
                  )}
                  {/* Signatures */}
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:20, marginTop:4 }}>
                    {[["Owner / Supervisor Signature",""],["Date Issued", issued],["Renewal Due","Annual"]].map(([k,v]) => (
                      <div key={k} style={{ borderTop:"1px solid var(--stone-300)", paddingTop:10 }}>
                        {v && <div style={{ fontSize:"13px", fontWeight:600, color:"var(--stone-600)", marginBottom:2 }}>{v}</div>}
                        <div style={{ fontSize:"11px", color:"var(--stone-400)" }}>{k}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div style={{ display:"flex", justifyContent:"flex-end", gap:8, marginTop:14 }}>
                  <button className="btn btn-secondary" onClick={() => setCertModal(null)}>Close</button>
                  <button className="btn btn-primary"><Icon name="download" size={14}/> Download PDF</button>
                </div>
              </div>
            );
          })()}
        </Modal>
      )}
    </div>
  );
};

// ── COMPANY PLAYBOOK ──────────────────────────────────────────────────────────
const Playbook = () => {
  const [activeSection, setActiveSection] = useState("sop");
  const [sopTab, setSopTab]               = useState("scripts");
  const [scriptTab, setScriptTab]         = useState("phone");
  const [docModal, setDocModal]           = useState(null);   // { section, doc } for viewing
  const [addDocModal, setAddDocModal]     = useState(null);   // section key for adding
  const [editScript, setEditScript]       = useState(null);   // script obj
  const fileInputRef = useRef();
  const uploadSectionRef = useRef(null);

  // ── Script state ──
  const [phoneScripts, setPhoneScripts] = useState([
    {
      id: 1, title: "Initial Inbound Inquiry", tag: "Phone",
      body: `"Thank you for calling Timeless Tile Pro, this is [Your Name] — how can I help you today?"\n\n[Listen to their project description]\n\n"Great, it sounds like we can definitely help with that. To get you an accurate estimate, I'd like to schedule a quick site visit. What does your availability look like this week or next?"\n\n[If they ask for a price range]\n"Every project is unique, so we always do a complimentary site assessment before quoting — that way there are no surprises. Most [project type] projects in the area typically run between $[X] and $[X], but we'll give you an exact number after the visit."\n\n"Can I get your name, address, and best callback number to get that set up?"`,
      tip: "Smile while you speak — clients can hear your energy. Always close by scheduling the next step, never leave the call open-ended."
    },
    {
      id: 2, title: "Following Up on a Quote", tag: "Phone",
      body: `"Hi [Client Name], this is [Your Name] with Timeless Tile Pro. I'm reaching out to follow up on the estimate we sent over for your [project type] — just wanted to make sure you received it and see if you had any questions."\n\n[If they haven't looked at it]\n"No worries at all! Take your time reviewing it. I'm happy to walk you through any of the line items if anything looks unclear. Would it be easier to connect later this week?"\n\n[If they have concerns about price]\n"I completely understand. Would it help if we hopped on a quick call to talk through some options? Sometimes there are ways we can phase the project or adjust the scope to better fit your budget while still getting you a beautiful result."`,
      tip: "Wait 2–3 business days after sending an estimate before following up. Always lead with value, not pressure."
    },
    {
      id: 3, title: "Scheduling a Site Visit", tag: "Phone",
      body: `"Perfect! To get your project started, I'd love to come take a look at the space — it usually only takes about 20–30 minutes and it's completely free.\n\nI have [Day] at [Time] or [Day] at [Time] available. Which of those works better for you?"\n\n[Confirm the appointment]\n"Great, I've got you down for [Day, Date] at [Time] at [Address]. You'll receive a confirmation text as well. Is there anything specific you'd like me to focus on when I'm there?"`,
      tip: "Always offer two specific time options — it avoids back-and-forth and makes it easy for the client to commit."
    },
    {
      id: 4, title: "Missed Call Callback", tag: "Phone",
      body: `"Hi, this is [Your Name] from Timeless Tile Pro returning a missed call. Sorry I missed you! Please give us a call back at [Your Number] or feel free to text us and we'll get right back to you. We look forward to hearing from you — have a great day!"`,
      tip: "Return missed calls within 2 hours during business hours. Speed to respond is one of the biggest factors in converting leads."
    },
    {
      id: 5, title: "Client Complaint — De-escalation Script", tag: "Phone",
      body: `[When client opens with frustration or dissatisfaction]\n\n"[Client Name], thank you for calling me directly — I'm really glad you did. I want to make sure we make this right for you."\n\n[Let them speak without interrupting. Do not defend.]\n\n"I completely understand why that would be frustrating. Here's what I'd like to do — can I come by [tomorrow / as soon as possible] to see it for myself? I want to look at it with you in person, not try to assess it over the phone, because you deserve a thorough response."\n\n[If they push for an immediate answer]\n"I hear you, and I want to give you a real answer — not a guessed one. Let me see it firsthand so I can tell you exactly what happened and exactly what we're going to do. I'll come [specific day/time]. Does that work?"\n\n[Before hanging up]\n"Thank you again for letting me know. This is important to me and I take it seriously. I'll be there [day/time] and I'll make sure we get you taken care of."`,
      tip: "Never apologize for the work before you've seen the issue — it implies automatic fault. Apologize for the inconvenience, not the work. Empathy and speed are your best tools."
    },
  ]);

  const [emailScripts, setEmailScripts] = useState([
    {
      id: 1, title: "Estimate Follow-Up Email", tag: "Email",
      subject: "Your Timeless Tile Pro Estimate – [Project Name]",
      body: `Hi [Client Name],\n\nThank you so much for the opportunity to visit your home and learn about your project. It was great meeting you!\n\nPlease find your estimate attached for the [Project Type] at [Address]. The quote is valid for 30 days and includes all materials, labor, and cleanup.\n\nA few highlights from what we discussed:\n• [Key material or design choice]\n• [Timeline or special consideration]\n• [Any unique aspect of the project]\n\nIf you have any questions or would like to discuss any adjustments, I'm just a call or text away at [Your Number]. We'd love the opportunity to transform your space!\n\nWarm regards,\n[Your Name]\nTimeless Tile Pro\n[Phone] | [Email] | timelesstile.pro`,
      tip: "Personalize at least 2–3 details from the actual site visit. Generic emails lose deals."
    },
    {
      id: 2, title: "New Lead Acknowledgment", tag: "Email",
      subject: "We received your inquiry – Timeless Tile Pro",
      body: `Hi [Client Name],\n\nThank you for reaching out to Timeless Tile Pro! We're excited to learn more about your project.\n\nWe'll be in touch within 1 business day to schedule your free site assessment and discuss your vision.\n\nIn the meantime, feel free to send us any photos of your space — the more we can see, the better we can prepare to bring your project to life!\n\nTalk soon,\n[Your Name]\nTimeless Tile Pro`,
      tip: "Send this within 15 minutes of receiving an inquiry. Automated or manual — speed wins."
    },
    {
      id: 3, title: "Project Kickoff Confirmation", tag: "Email",
      subject: "Project Start Confirmed – [Project Name] · [Start Date]",
      body: `Hi [Client Name],\n\nWe're excited to get started on your [project type]! Here's a quick summary of what to expect:\n\n📅 Start Date: [Date]\n🏠 Location: [Address]\n👷 Lead Installer: [Crew Name]\n⏱ Estimated Duration: [X] days\n\nA few things to prepare:\n• Please clear the work area of personal items before our arrival\n• Ensure our crew has access to the space by [Time]\n• Our team will protect surrounding areas before beginning work\n\nWe'll send a progress update at the end of each day. Don't hesitate to reach out with any questions.\n\nLooking forward to a great project!\n[Your Name]\nTimeless Tile Pro`,
      tip: "This email reduces day-of confusion and sets a professional tone. Send it 48 hours before start."
    },
    {
      id: 4, title: "Project Completion & Review Request", tag: "Email",
      subject: "Your Project is Complete – We'd Love Your Feedback!",
      body: `Hi [Client Name],\n\nWe're thrilled to have completed your [project type] at [Address] — it looks absolutely stunning!\n\nThank you for trusting Timeless Tile Pro with your home. It was a pleasure working with you.\n\n⭐ If you're happy with how everything turned out, we'd be incredibly grateful if you'd take 2 minutes to leave us a Google review. It means the world to a small business like ours and helps other homeowners find us:\n\n[Google Review Link]\n\nAlso, if you have friends, family, or neighbors who might need tile work, we offer a referral credit for every new client you send our way!\n\nThank you again,\n[Your Name]\nTimeless Tile Pro`,
      tip: "The best time to ask for a review is within 24 hours of project completion while the excitement is fresh."
    },
    {
      id: 5, title: "Warranty Callback Acknowledgment", tag: "Email",
      subject: "We Received Your Message – Timeless Tile Pro Will Follow Up",
      body: `Hi [Client Name],\n\nThank you for reaching out. We take every concern seriously and want to make sure your installation continues to perform exactly as it should.\n\nWe've received your message regarding [brief description of issue] and one of our project managers will be in touch within 1 business day to schedule a time to come assess the situation in person.\n\nA few things to note in the meantime:\n• Please avoid applying any cleaners or sealers to the affected area until we've had a chance to inspect it\n• If you can, take a photo of the concern and reply to this email — it helps us prepare before arriving\n• Our standard workmanship warranty covers installation defects for 1 year from project completion\n\nWe appreciate your patience and look forward to resolving this for you quickly.\n\nWarm regards,\n[Your Name]\nTimeless Tile Pro\n[Phone] | timelesstile.pro`,
      tip: "Send this acknowledgment within 4 hours of any warranty contact — even if you have no answers yet. Clients who feel heard and responded to quickly are far less likely to escalate or leave negative reviews."
    },
  ]);

  // ── Document resource state per section ──
  const [docs, setDocs] = useState({
    admin:     [{ id: 1, name: "Admin Onboarding Checklist.pdf",    size: "1.2 MB", date: "2024-01-15", tag: "Onboarding" }],
    installer: [{ id: 1, name: "Installation Safety Standards.pdf", size: "2.4 MB", date: "2024-02-01", tag: "Safety"     }],
    pm:        [{ id: 1, name: "Project Handoff Template.pdf",       size: "890 KB", date: "2024-02-10", tag: "Templates"  }],
  });

  // ── Built-in SOP content ──
  const SOP_CONTENT = {
    admin: [
      {
        id: "a1", title: "Client Intake & Onboarding Procedure", tag: "Onboarding", icon: "leads",
        body: [
          { heading: "Step 1 — Initial Contact Logged", text: "Within 15 minutes of receiving any inquiry (phone, web form, social), create a new Lead record in the CRM. Enter: full name, phone, email, source, project type, and estimated value. Set status to 'New'." },
          { heading: "Step 2 — Acknowledgment Sent", text: "Send the New Lead Acknowledgment email script within 15 minutes. Ask the client to send photos of their space. Log the outreach as a call or note in the CRM." },
          { heading: "Step 3 — Site Visit Scheduled", text: "Contact the lead within 1 business day to schedule a free site assessment. Offer two specific time slots. Create a Calendar event in the CRM linked to the lead. Update lead status to 'Contacted'." },
          { heading: "Step 4 — Pre-Visit Preparation", text: "24 hours before the visit, confirm via text or call. Review any photos the client submitted. Print or pull up the lead profile on your device before arriving." },
          { heading: "Step 5 — Post-Visit Follow-Through", text: "Within 24 hours of the site visit: update the lead record with notes, move status to 'Quoted', create an Estimate in the CRM, and send the Estimate Follow-Up email. Set a follow-up reminder for 3 business days if no response." },
        ],
        tip: "Speed and professionalism at intake sets the tone for the entire client relationship. Clients who receive a fast, organized response are significantly more likely to convert.",
      },
      {
        id: "a2", title: "Estimate & Invoice Sending Procedures", tag: "Billing", icon: "invoice",
        body: [
          { heading: "Estimate Creation Standards", text: "All estimates must be built in the CRM Estimates module. Every line item requires: description, quantity, unit (sqft, job, etc.), and unit price. Never quote a lump sum without line items — itemized estimates reduce disputes and build trust." },
          { heading: "Estimate Review Before Sending", text: "Before sending, verify: customer name and address match the site visit, all materials and labor are accounted for, notes section includes any special conditions discussed, and the estimate total aligns with your verbal range." },
          { heading: "Sending the Estimate", text: "Send via email using the Estimate Follow-Up Script. Attach the estimate PDF. Update the estimate status from Draft to Sent in the CRM. Note the send date — estimates are valid for 30 days." },
          { heading: "Invoice Procedures", text: "Invoices are generated from the Invoicing module after a job is complete or at project milestones (typically 50% deposit, 50% on completion). Invoice must reference the job name, address, and include a clear due date (net 14 days standard)." },
          { heading: "Overdue Invoice Protocol", text: "At 3 days past due: send a friendly reminder email. At 7 days past due: call the client directly. At 14 days past due: flag for owner review. Never begin a new project for a client with an outstanding overdue invoice." },
        ],
        tip: "Document every estimate conversation in the CRM notes. If a client disputes a charge later, your records are your protection.",
      },
      {
        id: "a3", title: "Scheduling & Calendar Management SOP", tag: "Scheduling", icon: "calendar",
        body: [
          { heading: "CRM Calendar Is the Source of Truth", text: "All jobs, site visits, follow-ups, and client appointments must be entered in the CRM Calendar. Do not manage scheduling through personal calendars or text messages alone." },
          { heading: "Scheduling New Jobs", text: "Once an estimate is approved and deposit received: create a Job record in the CRM, set start and end dates, assign the crew, link the estimate, and add a Calendar event. Notify the crew 72 hours in advance with the job address, scope, and start time." },
          { heading: "Scheduling Conflicts", text: "If a scheduling conflict arises, the Project Manager is notified first. Adjust job dates in the CRM immediately. Notify the affected client via phone (not just text) and offer a specific alternative date within 48 hours." },
          { heading: "Buffer Time Standards", text: "Never schedule jobs back-to-back on the same day without a 2-hour buffer. Tile work is precision work — rushing between jobs compromises quality. Allow 1 day between project completion and the next start for the same crew." },
        ],
        tip: "A clean calendar prevents the two biggest client complaints in contracting: 'I didn't know when you were coming' and 'You were late.' Both are fully preventable with good scheduling hygiene.",
      },
      {
        id: "a4", title: "CRM Data Entry & Record-Keeping Standards", tag: "CRM", icon: "note",
        body: [
          { heading: "Required Fields for Every Lead", text: "Full name, phone, email, address, project type, estimated value, lead source, and initial notes from the first conversation. Incomplete records cause confusion and missed follow-ups." },
          { heading: "Required Fields for Every Job", text: "Customer link, project name, full address, start and end dates, assigned crew, contract value, and linked estimate. Upload the signed contract to the job record if applicable." },
          { heading: "Call Logging Standards", text: "Every phone conversation with a client or lead must be logged in Call Tracking within 1 hour. Include: direction, outcome, duration, and a 1–2 sentence summary of what was discussed and any commitments made." },
          { heading: "Note-Taking Standards", text: "Notes should be factual, dated, and written in third person where possible (e.g., 'Client confirmed tile selection via phone'). Avoid opinions or informal language — records may be referenced in disputes." },
          { heading: "Photo Upload Standards", text: "Client-submitted space photos must be uploaded to the Lead record immediately upon receipt. Post-job progress photos must be uploaded to the Job record within 24 hours of being taken. All photos should be tagged appropriately." },
        ],
        tip: "Think of the CRM as your business's memory. Anyone on the team should be able to open any record and understand the full history of that client without asking anyone else.",
      },
      {
        id: "a5", title: "Complaint & Client Dispute Resolution Protocol", tag: "Client Relations", icon: "warning",
        body: [
          { heading: "Rule #1 — Listen First, Defend Never", text: "When a client expresses dissatisfaction, your first response is always to listen fully without interrupting or immediately defending the work. Acknowledge their concern: 'I understand, and I want to make sure we get this right for you.'" },
          { heading: "Step 1 — Log the Complaint", text: "Create a note in the client's CRM record immediately with: date, nature of the complaint, and exact words used. This protects the business if the situation escalates." },
          { heading: "Step 2 — Assess Within 24 Hours", text: "Schedule a physical site visit within 24 hours to assess the concern firsthand. Do not offer solutions, refunds, or fixes over the phone before seeing the issue. Bring your job photos and estimate for reference." },
          { heading: "Step 3 — Determine Responsibility", text: "After assessing: is this a workmanship issue, a materials issue, or a client expectation issue? Workmanship issues are addressed at no cost. Materials issues require supplier coordination. Expectation issues require a calm, documented conversation referencing the signed estimate." },
          { heading: "Step 4 — Communicate the Resolution Plan", text: "Within 48 hours of the site visit, provide the client with a clear written plan (email is preferred — it creates a record): what will be done, when, and by whom. Get their written acknowledgment before proceeding." },
          { heading: "Step 5 — Follow Up After Resolution", text: "After the issue is resolved, call the client personally to confirm their satisfaction. Update the CRM record. If appropriate, ask for a revised review." },
        ],
        tip: "Most client disputes escalate because of communication delays, not the actual issue. A fast, professional response often turns an unhappy client into a loyal advocate.",
      },
      {
        id: "a6", title: "Vendor & Supplier Management Procedures", tag: "Procurement", icon: "note",
        body: [
          { heading: "Approved Supplier Directory", text: "Maintain an up-to-date supplier contact list in the Admin SOP resource center. Include: company name, rep name, phone, email, account number, lead time, and minimum order quantities. Review and update quarterly." },
          { heading: "Material Ordering Standards", text: "All material orders must be initiated by the Project Manager or Admin, never by field installers independently. Orders should be placed at minimum 5 business days before the job start date. Always order 10–15% overage to account for cuts and breakage." },
          { heading: "Order Confirmation", text: "Every order must have a written confirmation (email or order receipt) saved in the project's CRM job notes. Verbal confirmations are not sufficient for order tracking." },
          { heading: "Delivery Coordination", text: "Confirm delivery window 24 hours in advance. Ensure someone is available to receive and inspect the delivery. Document any damage or shortages immediately with photos before signing delivery receipts." },
        ],
        tip: "Material delays are the #1 cause of job postponements. Build supplier relationships and always have a backup supplier for your most common materials.",
      },
      {
        id: "a7", title: "Automation Awareness — What Runs on Autopilot", tag: "Automation", icon: "star",
        body: [
          { heading: "Understanding the Cron System", text: "The CRM runs 6 automated cron jobs that handle repetitive tasks 24/7. You do not need to trigger these — they fire on schedule. Your job is to understand what they do so you don't duplicate effort or override automated actions." },
          { heading: "Estimate Follow-Up (Hourly)", text: "When an estimate is viewed but not signed, the system sends automated SMS nudges at 48 hours, 5 days, and 14 days. Do NOT send manual follow-ups during these windows unless the client calls or messages first. After 14 days, the estimate is flagged as Expired." },
          { heading: "Review Requests (Daily 10am)", text: "When a job is marked Completed, the system sends: a thank-you SMS on Day 0, a Google review request on Day 3, a follow-up on Day 7, and a final email on Day 14. You do not need to send review requests manually — the system handles the full sequence." },
          { heading: "Appointment Reminders (Daily 7am)", text: "Customers with scheduled events receive: a day-before SMS + email, and a morning-of SMS. Ensure all events in the Calendar have the customer's phone number and email attached so reminders fire correctly." },
          { heading: "Stale Lead Digest (Monday 9am)", text: "Every Monday, the owner receives an AI-generated SMS with the top 3 pipeline actions for the week. This analyzes stale leads, pending estimates, overdue invoices, and completing jobs. The admin should review the same data in the Marketing Center Overview tab." },
          { heading: "Repeat Outreach (1st of Month)", text: "On the 1st of each month, the system identifies past customers with no work in 6+ months and generates personalized outreach drafts. These are stored in Outreach Drafts (sidebar) for review — they are NOT auto-sent. Admin must review and approve each draft before sending." },
          { heading: "GBP Sync (Every 2 Hours)", text: "Google reviews sync into the CRM automatically. Completed jobs with 'After' tagged photos get auto-posted to the Google Business Profile. Negative reviews trigger an instant SMS to the owner. You can manually trigger a sync from Marketing > Google Business > Sync Now." },
        ],
        tip: "The automation handles the follow-up cadence — your job is to handle the conversations. When a lead responds to an automated nudge, that's your cue to jump in personally.",
      },
      {
        id: "a8", title: "Auto-Lead System — How Leads Create Themselves", tag: "Leads", icon: "leads",
        body: [
          { heading: "How Auto-Leads Work", text: "When someone calls or texts any Twilio tracking number and they don't match an existing lead or customer, the system automatically creates a new lead in the CRM. The AI extracts: name, project type, estimated value, and any details from the message or voicemail transcription." },
          { heading: "Website Form Leads", text: "The contact form on timelesstilepro.com/contact sends submissions directly into the CRM. These leads include: project type, square footage, timeline, address, and any uploaded photos. The owner receives an SMS alert and an email with full details." },
          { heading: "Source Tracking", text: "Every auto-lead is tagged with its source based on which phone number was called (Google, Facebook, Direct, etc.) or utm_source from the website form. Never change the source on an auto-created lead — it feeds the Marketing Dashboard attribution data." },
          { heading: "Your Role with Auto-Leads", text: "Auto-leads arrive as status 'New'. Your job: review the AI-extracted details, call or text the customer within 1 hour, update the status to 'Contacted', and add notes from the conversation. The lead already exists — you just need to work it." },
          { heading: "Duplicate Handling", text: "The system checks for duplicates before creating a lead. If the phone number already exists, it updates the existing lead instead. If you see what looks like a duplicate, check the notes — it may be a returning inquiry appended to the original record." },
        ],
        tip: "Auto-leads are your fastest path to a sale — the customer just reached out. Every minute you wait to respond reduces conversion probability. Treat auto-leads as higher priority than manual entries.",
      },
      {
        id: "a9", title: "Google Business Profile Management", tag: "Marketing", icon: "star",
        body: [
          { heading: "Accessing GBP in the CRM", text: "Go to Marketing Center (sidebar) > Google Business tab. This shows: connection status, average rating, review count, search impressions, website clicks, call clicks, and direction requests." },
          { heading: "Review Management", text: "Reviews sync every 2 hours. The Reviews sub-tab shows all Google reviews with reviewer name, rating, comment, and reply status. For unreplied reviews: click 'Draft AI Reply' to generate a response, edit if needed, then click 'Post Reply to Google'." },
          { heading: "Negative Review Protocol", text: "1-3 star reviews trigger an instant SMS to the owner. Admin should: check the Google Business tab immediately, identify the reviewer (match to CRM customer if possible), draft a response using AI (always edit for accuracy), and flag the review for owner discussion before posting the reply." },
          { heading: "Auto-Posts", text: "Completed jobs with 'After' tagged photos are automatically posted to the Google Business Profile with an AI-generated caption. The Posts sub-tab shows all published posts. You do not need to create posts manually — the system handles it." },
          { heading: "Insights", text: "The Insights sub-tab shows profile performance: search impressions, website clicks, phone calls, and direction requests. Review these weekly to understand how visible the business is on Google." },
        ],
        tip: "Responding to every Google review within 24 hours — positive or negative — improves search ranking and shows potential customers that the business is attentive and professional.",
      },
      {
        id: "a10", title: "Material Flag Response Procedure", tag: "Operations", icon: "warning",
        body: [
          { heading: "What Is a Material Flag?", text: "Crew members in the field can flag material shortages directly from the Crew App. When they do, you receive an instant SMS with: crew member name, job name, material needed, quantity, and urgency level (Normal, Urgent, Critical)." },
          { heading: "Urgency Levels", text: "Normal — can wait until the next supply run or delivery. Urgent — needed same day to avoid job delays. Critical — the job is stopped until this material arrives. Respond accordingly." },
          { heading: "Response Procedure", text: "1. Acknowledge receipt to the crew member (text or call). 2. Source the material from preferred suppliers (check the Vendor SOP for contacts). 3. Arrange delivery or pickup. 4. Confirm resolution with the crew. 5. Mark the flag as resolved in the system." },
          { heading: "Prevention", text: "Most material flags are preventable. Before each job start, verify the material order matches the estimate scope. Order 10-15% overage. Confirm delivery arrived complete. If shortages are recurring from a specific supplier, document and escalate per the Vendor SOP." },
        ],
        tip: "A crew waiting on materials is a crew not earning revenue. Treat every material flag as time-sensitive — even 'Normal' urgency should be resolved within 24 hours.",
      },
      {
        id: "a11", title: "Photo Tagging Standards & GBP Integration", tag: "Documentation", icon: "gallery",
        body: [
          { heading: "The Tagging System", text: "Every photo uploaded in Job Tracking or the Crew App triggers a tag picker with 5 options: Before (existing conditions), During (work in progress), After (final result), Substrate (prep work), and Other (reference). The tag determines how the photo is used." },
          { heading: "What Gets Posted to Google", text: "ONLY photos tagged 'After' are eligible for auto-posting to the Google Business Profile. The GBP cron checks completed jobs for After-tagged photos and creates a post with an AI-generated caption. All other tags stay internal." },
          { heading: "Photo Quality for GBP", text: "Since After photos become public marketing material: ensure the space is fully cleaned and staged, use landscape orientation, ensure good lighting (natural light is ideal), remove all tools and materials from frame, and take both a wide shot and a detail shot." },
          { heading: "Admin Responsibility", text: "Before a job is considered fully complete, verify that at least one quality 'After' photo has been uploaded and tagged. If the crew only tagged photos as 'During', ask them to retag or upload final shots. The GBP auto-post will not fire without an 'After' tag." },
          { heading: "Retagging Photos", text: "If a photo was tagged incorrectly, it currently needs to be deleted and re-uploaded with the correct tag. Train crew to be intentional about tagging at the moment of upload." },
        ],
        tip: "Your Google Business Profile photos are often the first thing a potential customer sees. One great Before/After pair is worth more than ten untagged progress shots.",
      },
      {
        id: "a12", title: "AI Assistant Usage Guide", tag: "Tools", icon: "star",
        body: [
          { heading: "What the AI Assistant Can Do", text: "Search leads by name, status, source, or staleness. Search customers and jobs. Check calendar events. Draft follow-up SMS messages. Send SMS directly from the chat. Get pipeline summaries (owner only). The assistant understands natural language — ask it like you'd ask a coworker." },
          { heading: "Example Commands", text: "Try: 'What leads need follow-up this week?' or 'Show me all Google leads from March' or 'Draft a follow-up text for Sandra Kim about her bathroom project' or 'What jobs are completing this week?' or 'Send a text to (757) 555-0184 saying we'll be there at 9am tomorrow'." },
          { heading: "What It Cannot Do", text: "The AI cannot: create estimates or invoices, delete records, access Supabase directly, or make phone calls. It also cannot see real-time data that hasn't been synced to the database yet." },
          { heading: "Best Practices", text: "Use the AI for quick lookups instead of scrolling through the CRM manually. Use it to draft messages — the AI writes in the TTP brand voice. Always review AI-drafted messages before sending. The AI remembers context within a conversation, so you can ask follow-up questions." },
        ],
        tip: "The AI Assistant is most useful for the tasks you do 10+ times a day: looking up a lead, checking who needs a callback, and drafting that follow-up text. Let it handle the repetitive work so you can focus on the conversations.",
      },
      {
        id: "a13", title: "Marketing Dashboard — Weekly Review Procedure", tag: "Marketing", icon: "note",
        body: [
          { heading: "When to Review", text: "Review the Marketing Dashboard every Monday morning. This aligns with the Monday pipeline digest the owner receives and ensures you're working from the same data." },
          { heading: "Overview Tab", text: "Check: total leads this period, conversion rate, pipeline value by stage, and auto-created vs manual lead ratio. If auto-created leads are low, investigate whether tracking numbers or the website form are functioning." },
          { heading: "Lead Sources Tab", text: "Identify which sources are generating the most leads AND the highest conversion rates. A source with many leads but low conversion may need better qualification at intake. Share insights with the owner for ad budget decisions." },
          { heading: "Trends Tab", text: "The 12-week trend chart shows volume patterns. Look for: seasonal dips (plan outreach campaigns), sudden drops (check tracking numbers or website form), and spikes (identify what campaign drove them)." },
          { heading: "Actionable Takeaway", text: "After reviewing, identify 1-2 actions: 'Follow up on the 3 stale Google leads from last week' or 'Website form leads dropped — test the contact page' or 'Referral conversion is 80% — ask completed customers for referrals.' Note actions in the CRM or communicate to the owner." },
        ],
        tip: "Data without action is just numbers. Every dashboard review should produce at least one specific action item for the week.",
      },
      {
        id: "a14", title: "Project Budget Builder — Setup & Workflow", tag: "Financial", icon: "estimate",
        body: [
          { heading: "Purpose", text: "The Project Budget Builder replaces Excel-based budget tracking. It stores phase-level material budgets and actuals, labor costs per phase, and links directly to jobs and estimates. All budget data feeds into the P&L Dashboard automatically." },
          { heading: "Creating a Budget — Seed from Estimate", text: "The preferred workflow is: approve an estimate → create the job → go to Project Budgets → click 'Seed from Estimate.' This auto-creates a budget with phases matching the estimate scope items, pre-populated material lines, and the quote total. The job_id link is set automatically." },
          { heading: "Creating a Budget — Manual", text: "Click '+ New Project Budget.' Fill in project name, customer, location, type, and original quote. Optionally link to a job using the job picker dropdown (required for crew material flags and P&L by Invoice). Add phases and line items manually from the Materials Catalog." },
          { heading: "Tracking Actuals", text: "As materials are purchased, update the 'Actual Qty' and 'Actual Price' columns for each line item. The variance (budget vs actual) calculates automatically. Labor costs are entered per phase using the 'Labor Budget' and 'Labor Actual' fields." },
          { heading: "Crew Material Flags", text: "When installers flag materials from the Crew App, pending flags appear at the top of the linked project. Approve each flag into a target phase — it creates a line item with a red 'CREW' badge. Reject flags that are duplicates or errors." },
          { heading: "P&L by Invoice (Owner Only)", text: "Scroll below the phase breakdown cards to see the 'P&L by Invoice' section. This shows each linked invoice with contract value, material cost from actuals, gross profit, and margin. Link line items to specific invoices using the invId field for multi-invoice jobs." },
        ],
        tip: "Always seed from estimate when possible — it ensures the budget is linked to the job, phases match the scope, and nothing is missed. Manual budgets should be the exception, not the rule.",
      },
      {
        id: "a15", title: "P&L Dashboard — Reading & EBITDA Guide", tag: "Financial", icon: "dashboard",
        body: [
          { heading: "Accessing the Dashboard", text: "Navigate to P&L Dashboard in the sidebar (Owner only). The dashboard pulls live data from project budgets, jobs, and invoices. No manual data entry is needed — it reflects your current CRM data in real time." },
          { heading: "Time Period Filtering", text: "Use the period selector bar to filter by This Month, Last Month, This Quarter, Last Quarter, This Year, Last Year, or All Time. KPI cards show comparison deltas (e.g., '↑ 12% vs last quarter') when a specific period is selected." },
          { heading: "Overview Tab", text: "Shows six top-line KPIs (Revenue, Material Spend, Labor, Gross Profit, Avg Margin, Budget Variance), a revenue waterfall chart, budget accuracy per project, category spend breakdown, and best/worst margin insights." },
          { heading: "Enhanced KPIs", text: "Below the insights row: Average Revenue per Job, Cost Overrun Rate (% of budgeted jobs that exceeded their material budget), Completed Job Margin, Margin Distribution chart (how many jobs fall in each bracket), Revenue Trend (last 6 months), and Margin Alerts for active jobs below 25%." },
          { heading: "EBITDA Tab", text: "Shows the full waterfall from Revenue through COGS to Gross Profit, then subtracts Operating Expenses to calculate EBITDA. The monthly breakdown table shows each month's P&L with an 'Edit' button to enter operating expenses." },
          { heading: "Operating Expenses", text: "Click '+ Add Expenses' or 'Edit' on a month row to enter monthly overhead: Vehicle & Fuel, Insurance, Tools & Equipment, Software & Subscriptions, Marketing & Advertising, Office & Admin, Licensing & Permits, and Depreciation. Set these monthly and review quarterly for accuracy." },
          { heading: "Export", text: "Click 'Export CSV' to download the current view as a spreadsheet. The P&L summary and EBITDA data export separately for accounting or tax review." },
        ],
        tip: "Review the P&L Dashboard weekly — it's your financial pulse. The Margin Alerts section is the most actionable: if an active job is below 25%, investigate immediately before completion locks in the loss.",
      },
      {
        id: "a16", title: "Crew Pay — Setting & Managing Installer Compensation", tag: "Team Management", icon: "dollar",
        body: [
          { heading: "Where to Set Crew Pay", text: "Open any job in Job Tracking → Edit → scroll to the crew assignment section. Below the crew member pills, a green 'Crew Pay (per member)' section appears. Enter the flat rate for each assigned crew member individually." },
          { heading: "How It Works", text: "Crew pay is stored per job as a flat rate for each member. If Cameron earns $1,500 and Marcus earns $1,200 on the same job, enter those amounts separately. The total crew cost displays at the bottom of the section." },
          { heading: "Crew Visibility", text: "Each crew member sees ONLY their own pay in the Crew App. Cameron sees 'Your Pay: $1,500' — he cannot see what Marcus earns. The pay appears on both the job list card and the job detail header." },
          { heading: "When to Set Pay", text: "Set crew pay when you create or schedule the job — before the crew sees it in their app. You can update it anytime by editing the job. Changes are reflected immediately in the Crew App." },
          { heading: "Important Notes", text: "Crew pay is owner-only — Jordan (admin) cannot see or edit these fields. The amounts are informational and do not trigger any payment processing. Crew pay is separate from the 'Job Cost' field, which represents total materials + labor for margin calculations." },
        ],
        tip: "Setting crew pay before the job starts sets clear expectations. Crew members appreciate knowing their compensation upfront — it reduces questions and builds trust.",
      },
    ],
    installer: [
      {
        id: "i1", title: "Pre-Job Arrival & Site Preparation", tag: "Pre-Job", icon: "hardhat",
        body: [
          { heading: "Night Before Preparation", text: "Review the job brief, estimate, and any client-submitted photos in the CRM. Confirm the job address, start time, and scope with the PM. Verify all required tools and materials are loaded." },
          { heading: "Arrival Standards", text: "Arrive no later than the scheduled start time. Introduce yourself to the client or homeowner. Do a brief walk-through of the work area before touching anything. Confirm scope matches your job brief." },
          { heading: "Site Protection", text: "Before any work begins: lay protective floor covering on all pathways from entry to work area, cover furniture and belongings within 6 feet of the work zone, and use door jamb protectors when moving materials. Photograph the space before beginning." },
          { heading: "Pre-Installation Surface Check", text: "Inspect substrate for: levelness (max 1/8\" variation per 10 feet), moisture, cracks, soft spots, and existing adhesive. Do not proceed if substrate fails the check — notify the PM and document the issue with photos." },
        ],
        tip: "Clients judge professionalism in the first 5 minutes. A crew that protects the home and communicates clearly before swinging a hammer wins more referrals than a crew that just does good tile work.",
      },
      {
        id: "i2", title: "Surface Preparation Standards", tag: "Installation", icon: "hardhat",
        body: [
          { heading: "Concrete Subfloor Prep", text: "Grind down high spots, fill low spots and cracks with floor-leveling compound. Allow to cure per manufacturer specifications (typically 24 hours). Final surface must be within 1/8\" across a 10-foot straightedge. Vacuum all debris before setting tile." },
          { heading: "Plywood Subfloor Prep", text: "Ensure all screws are countersunk. Apply cement backer board using the thin-set method with 1/4\" screws every 6 inches. Tape and thin-set all seams. Never tile directly over plywood without backer board in wet areas." },
          { heading: "Wall Surface Prep", text: "Remove all existing tile, loose paint, or damaged drywall. In wet areas (showers, tub surrounds), cement board or waterproof membrane is mandatory. Use mesh tape and thin-set on all seams. Let dry 24 hours before tiling." },
          { heading: "Waterproofing Protocol", text: "In all wet areas, apply waterproof membrane to the full shower floor, 6 inches up all walls, and 12 inches beyond the shower curb. Test all drains before tile installation. Document waterproofing completion with photos." },
        ],
        tip: "90% of tile callbacks come from poor substrate prep, not bad installation. Never rush the prep phase — it is the most important step of every job.",
      },
      {
        id: "i3", title: "Tile Layout & Pattern Execution", tag: "Installation", icon: "hardhat",
        body: [
          { heading: "Layout Planning", text: "Always do a dry layout before setting any tile. Start from the center of the room or focal wall. Ensure full tiles are visible at doorways and focal points. Cuts should be hidden in corners, under cabinets, or in the least visible areas. Never start from a wall — walls are rarely square." },
          { heading: "Straight Lay Pattern", text: "Snap perpendicular chalk lines from the center of the room. Check for square using the 3-4-5 method. Use tile spacers consistently throughout. Check alignment every 4–5 rows with a straightedge." },
          { heading: "Diagonal / 45° Pattern", text: "Find the center of the room and snap lines at 45° to the walls. Expect 20–25% higher material waste. Layout planning is critical — present the dry layout to the client before setting to confirm direction and cut placement." },
          { heading: "Herringbone Pattern", text: "Mark a center spine line the length of the room. Set tiles at 45° angles off the spine in alternating directions. Use smaller spacers (1/16\") for tight joints. Check straightness of the spine every 6 tiles." },
          { heading: "Large Format Tile (18\"+ )", text: "Requires back-buttering in addition to notched trowel application. Use a minimum 1/2\" square-notch trowel. Check lippage after every tile with a straightedge — maximum allowable lippage is 1/32\" per ANSI standards. Consider using a lippage leveling system for premium projects." },
        ],
        tip: "A 5-minute investment in layout planning saves hours of cutting and resetting. Always present the dry layout to the homeowner before committing to set tile.",
      },
      {
        id: "i4", title: "Thin-Set, Grout & Adhesive Standards", tag: "Installation", icon: "hardhat",
        body: [
          { heading: "Thin-Set Selection", text: "Standard floors: gray polymer-modified thin-set. Wet areas and natural stone: white polymer-modified. Large format (18\"+): use a medium-bed mortar. Never use mastic in wet areas. Follow manufacturer mixing ratios precisely — eyeballing causes bond failure." },
          { heading: "Trowel Size Selection", text: "Mosaic / small tiles (under 4\"): 3/16\" V-notch. Medium tiles (4\"–12\"): 1/4\" square-notch. Large tiles (12\"–18\"): 3/8\" square-notch. Extra-large (18\"+): 1/2\" square-notch with back-buttering. Minimum 95% coverage required in wet areas." },
          { heading: "Grout Selection Guide", text: "Joints under 1/8\": unsanded grout. Joints 1/8\"–1/2\": sanded grout. Joints over 1/2\": use an epoxy or large-joint grout. In exterior or radiant heat applications: always use an epoxy or flexible grout additive. Match grout color sample to client approval in writing before installing." },
          { heading: "Grouting Procedure", text: "Allow thin-set to cure minimum 24 hours (48 for large format) before grouting. Remove all spacers. Dampen tile surface before grouting in dry conditions. Work grout diagonally across joints. Remove excess grout within 20–30 minutes. Haze should be buffed within 24 hours before it fully hardens." },
          { heading: "Caulk Joint Placement", text: "All changes of plane (floor-to-wall, wall-to-cabinet, inside corners) must use sanded caulk, never grout. Caulk must be applied after grout has cured. Use a color-matched caulk. Smooth with a wet finger or caulk tool. No voids or gaps." },
        ],
        tip: "Document the thin-set and grout product names and batch numbers on every job. If a callback occurs, you'll need to source a matching grout — batch numbers ensure a color match.",
      },
      {
        id: "i5", title: "Jobsite Safety & PPE Requirements", tag: "Safety", icon: "warning",
        body: [
          { heading: "Required PPE — Always", text: "Safety glasses when cutting tile or grinding. Knee pads for all floor work. Dust mask (N95 minimum) when cutting, grinding, or mixing materials. Steel-toed boots on all job sites. Cut-resistant gloves when handling large format tiles or glass tile." },
          { heading: "Wet Saw Safety", text: "Ensure the water reservoir is full before operating. Never cut without the blade guard in place. Keep hands minimum 4 inches from the blade. Do not leave a running wet saw unattended. Disconnect power before changing blades. Keep power cords away from water." },
          { heading: "Chemical Safety", text: "Thin-set and grout are alkaline — wear gloves when handling. Grout haze removers and tile cleaners may contain acids — read SDS sheets, ensure ventilation, and wear gloves and eye protection. Never mix cleaning chemicals. Store in original labeled containers." },
          { heading: "Client Home Safety", text: "Secure all tools and materials at end of day so they are not accessible to children or pets. Lock gate access if working in a backyard. Do not leave trip hazards in doorways or walkways. Place wet floor signage where tile is freshly set." },
          { heading: "Incident Reporting", text: "Any injury, property damage, or near-miss must be reported to the PM on the same day it occurs. Photograph all property damage immediately before disturbing the area. Do not admit fault or offer to pay for damages independently — route through the company." },
        ],
        tip: "One injury or one damaged item in a client's home can erase the profit from an entire job and damage your reputation. Safety is not optional.",
      },
      {
        id: "i6", title: "End-of-Day Site Cleanup & Security SOP", tag: "Cleanup", icon: "hardhat",
        body: [
          { heading: "Daily Cleanup Minimum Standard", text: "Sweep or vacuum the full work area. Remove all tile debris and broken tile pieces — never leave on-site overnight. Consolidate tools to one corner of the work area. Wipe down any grout haze or thin-set splatter that has occurred during the day." },
          { heading: "Material Storage", text: "Stack unused tiles neatly on a pallet or protective surface — never directly on hardwood or finished flooring. Store adhesives and chemicals in a single location, away from heat sources and client belongings. Keep an accurate count of remaining materials and report to PM if running low." },
          { heading: "Tool Security", text: "Do not leave power tools in a vehicle overnight if avoidable. If tools must remain on-site, store in a locked toolbox or locked room. Photograph tool staging area at end of day — timestamp photos serve as documentation in the event of theft." },
          { heading: "Client Communication at End of Day", text: "Before leaving, inform the client (or leave a written note) of: what was completed today, what will be done tomorrow, and any areas they should avoid walking on. Never leave without the client knowing the current state of the project." },
        ],
        tip: "The end-of-day walkthrough takes 10 minutes and costs nothing. Clients who see a clean, organized site every evening have dramatically fewer concerns and disputes.",
      },
      {
        id: "i7", title: "Quality Control — Pre-Completion Inspection", tag: "Quality Control", icon: "star",
        body: [
          { heading: "Grout Line Consistency", text: "Walk the entire installation and visually inspect grout line width consistency. No joint should vary more than 1/16\" from adjacent joints. Look for 'smile' or 'frown' lines on diagonal cuts — these indicate layout drift and must be corrected before grouting." },
          { heading: "Tile Alignment & Lippage Check", text: "Run a 4-foot straightedge across the finished tile surface in multiple directions. Maximum allowable lippage (lip between adjacent tiles): 1/32\" for rectified tile, 1/16\" for non-rectified. Any tile exceeding this must be documented and flagged for PM review." },
          { heading: "Full Coverage Confirmation", text: "On a sampling basis (at least 5 tiles per 100 sq ft), tap installed tiles with a rubber mallet. A hollow sound indicates a void in adhesive coverage. All hollow tiles must be removed and reset before the job is considered complete." },
          { heading: "Grout Haze Removal", text: "After grout has cured, use a clean damp cloth to buff the entire surface in a circular motion. Inspect from multiple angles and in different lighting. All haze must be removed before client walk-through. For stubborn haze, use a manufacturer-approved grout haze remover." },
          { heading: "Caulk & Transition Inspection", text: "Verify all plane-change joints are caulked (not grouted). Caulk must have no voids, gaps, or bubbles. Transitions between tile and other flooring surfaces must be installed with appropriate transition strips — no raw exposed edges." },
          { heading: "Final Cleanup Standard", text: "Remove all protective covering. Vacuum and damp-mop the finished tile surface. Clean all adjacent surfaces (baseboards, cabinets, walls) of any adhesive, grout, or dust. The space should look better than when you arrived." },
        ],
        tip: "Run this checklist yourself before calling the PM for the client walk-through. Every item you catch internally is one the client won't find — which protects your reputation and avoids callbacks.",
      },
      {
        id: "i8", title: "Photo Documentation Standards", tag: "Documentation", icon: "gallery",
        body: [
          { heading: "Why We Document", text: "Progress photos protect the company in disputes, demonstrate quality to future clients, and keep the PM and admin informed without requiring site visits. Every installer is responsible for their own photo documentation — it is part of the job, not optional." },
          { heading: "Required Photo Stages", text: "The following photos are required on every job and must be uploaded to the CRM Job record within 24 hours of each stage: (1) Before/Demo — existing conditions before any work. (2) Substrate — after prep, before any tile is set. (3) Dry Layout — tile laid out without adhesive for pattern confirmation. (4) Mid-Install — tile approximately 50% complete. (5) Grouted — after grout is applied and haze is removed. (6) Final Completion — finished installation, fully cleaned." },
          { heading: "Photo Quality Standards", text: "Use landscape orientation. Ensure adequate lighting — use a work light if needed, natural light is ideal. Include at least one wide shot of the full area and one close-up detail shot per stage. Photos should be in focus and representative of the actual work quality." },
          { heading: "CRM Upload Procedure", text: "Open the Job record in the CRM. Navigate to the Progress Photos section. Upload all photos for the stage. Tag each photo with the appropriate stage label. Add a short caption describing what is shown if it isn't obvious." },
          { heading: "Client-Facing Photos", text: "The final completion photos are the most important — these are used in marketing, reviews, and future estimates. For premium projects, clean and stage the space before the final photo session. Remove all tools, materials, and debris completely." },
        ],
        tip: "Before and after photos are your most powerful sales tool. Clients who see real project photos on estimates are significantly more likely to approve them.",
      },
    ],
    pm: [
      {
        id: "p1", title: "Pre-Project Planning & Kickoff Procedure", tag: "Planning", icon: "clipboard",
        body: [
          { heading: "30 Days Before Start — Materials", text: "Confirm final tile selection with the client in writing (email). Place all material orders with minimum 10–15% overage. Confirm delivery date and coordinate with job start date. Save order confirmations in the CRM job notes." },
          { heading: "1 Week Before Start — Crew Briefing", text: "Assign the lead installer and any supporting crew in the CRM job record. Send the crew a written job brief: address, scope, start time, tile selection, special conditions, and any client-specific preferences or sensitivities noted during the site visit." },
          { heading: "48 Hours Before Start — Client Confirmation", text: "Send the Project Kickoff Confirmation email. Confirm access to the property. Remind the client to clear the work area. Confirm parking and material delivery logistics if applicable." },
          { heading: "Day-Of Kickoff", text: "PM or lead installer conducts a 10-minute walk-through with the client before work begins. Confirm scope, identify any changes or concerns, photograph existing conditions, and introduce the crew by name. Set expectations for daily communication." },
        ],
        tip: "The 30 minutes you invest in pre-job coordination prevents 5 hours of mid-job problem-solving. Every delay and change order traces back to inadequate planning.",
      },
      {
        id: "p2", title: "Daily Progress Reporting Standard", tag: "Communication", icon: "note",
        body: [
          { heading: "What to Report Daily", text: "By 5:30 PM on every active job day, update the CRM job record with: work completed that day, percentage of overall completion, any issues encountered (substrate problems, material shortages, client requests), and next day's planned tasks." },
          { heading: "Client Updates", text: "For jobs lasting 3+ days, send the client a brief end-of-day text or email with a 1–2 sentence progress summary. Upload at least one progress photo to the CRM job record. Clients should never feel they are in the dark about their project." },
          { heading: "Issue Escalation Protocol", text: "Any issue that may affect the completion date, scope, or cost must be communicated to the owner within 1 hour of discovery. Do not wait until end-of-day. Create a written note in the CRM with: what was found, when, and how you plan to address it." },
          { heading: "Change Order Management", text: "Any change to the original scope — additions, deletions, material substitutions — requires a written change order before work proceeds. Create a revised estimate in the CRM, get client approval via email, and note the change in the job record." },
        ],
        tip: "Clients become difficult when they feel ignored. Daily progress communication is the single most effective tool for managing client expectations and preventing disputes.",
      },
      {
        id: "p3", title: "Subcontractor & Crew Management Procedures", tag: "Team Management", icon: "clipboard",
        body: [
          { heading: "Assignment Standards", text: "Crew assignments must be made in the CRM job record at minimum 72 hours before job start. Never verbally assign work without logging it. The crew must have written confirmation of the job address, scope summary, start time, and estimated duration." },
          { heading: "Performance Standards", text: "All crew members are expected to maintain: punctuality (on-site within 10 minutes of scheduled time), site protection protocols, daily cleanup standards, professional client communication, and photo documentation as required by the installer SOP." },
          { heading: "Subcontractor Requirements", text: "All subcontractors must provide a current certificate of insurance before being assigned to any job. Keep copies on file. Do not use uninsured subcontractors — liability transfers to the company in the event of an injury or property damage." },
          { heading: "Performance Issues", text: "Document any performance issue (tardiness, quality concern, client complaint) in the PM's internal notes with date and specifics. Address the issue directly with the crew member within 24 hours of occurrence. Patterns of issues are escalated to the owner with documentation." },
        ],
        tip: "Your crew represents the Timeless Tile Pro brand on every job. How they behave and communicate in the client's home is as important as the tile they install.",
      },
      {
        id: "p4", title: "Client Walk-Through & Project Sign-Off", tag: "Completion", icon: "check",
        body: [
          { heading: "Pre-Walk-Through Checklist", text: "Before calling the client for the final walk-through, confirm: all tile is fully grouted and haze-free, all caulk joints are complete, all transitions are installed, the space is fully cleaned, and all tools and materials are removed from the property." },
          { heading: "Walk-Through Procedure", text: "Walk every area of tile with the client. Move slowly and let the client look at everything. Do not rush. Ask open-ended questions: 'Is there anything here you'd like us to take a second look at?' Remain positive and collaborative throughout." },
          { heading: "Handling Walk-Through Concerns", text: "If the client identifies a legitimate concern: agree to address it, note the exact item in the CRM, and set a specific date for resolution (within 48 hours for minor items, within 1 week for significant repairs). Never dismiss a concern or debate it on the spot." },
          { heading: "Sign-Off & Invoice Trigger", text: "Once the client verbally confirms satisfaction, follow up with the Project Completion email within 24 hours. This email confirms completion and requests a review. Trigger the final invoice from the CRM Invoicing module on the same day as walk-through approval." },
        ],
        tip: "The walk-through is your final quality checkpoint and your best opportunity to convert a completed project into a 5-star review. Treat it as importantly as the installation itself.",
      },
      {
        id: "p5", title: "Warranty & Callback Policy", tag: "Warranty", icon: "warning",
        body: [
          { heading: "Workmanship Warranty — Standard", text: "Timeless Tile Pro provides a 1-year workmanship warranty on all installations. This covers defects in installation including: loose or hollow tiles, grout cracking from installation error, lippage beyond ANSI tolerance, and caulk failure at plane-change joints." },
          { heading: "What Is Not Covered", text: "The workmanship warranty does not cover: damage caused by subsequent construction trades, damage from improper cleaning products or methods, substrate movement or structural settling, natural stone veining or variation (cosmetic), or tile manufacturer defects (covered by manufacturer warranty)." },
          { heading: "Callback Request Procedure", text: "When a client contacts us about a potential warranty issue: (1) Log the contact in the CRM call log immediately. (2) Acknowledge receipt within 4 business hours. (3) Schedule a physical assessment within 3 business days. (4) Do not commit to repair coverage until the issue has been assessed in person." },
          { heading: "Repair Authorization", text: "After assessing the issue, the PM determines: is this a covered workmanship issue, a materials issue, or outside warranty scope? PM documents the finding in the CRM job record. Owner approves all warranty repairs before work is scheduled." },
          { heading: "Materials Warranty Coordination", text: "For tile or materials defects, contact the supplier's warranty department with: product name, batch number, photo documentation, and a description of the issue. Escalate to the owner if the supplier does not respond within 5 business days." },
        ],
        tip: "A clearly communicated warranty policy prevents almost all warranty disputes. Share the key coverage points verbally during the client walk-through and reference them in the completion email.",
      },
      {
        id: "p6", title: "Punch List & Quality Inspection Procedure", tag: "Quality Control", icon: "star",
        body: [
          { heading: "What Is a Punch List?", text: "A punch list is a written record of all remaining items to be completed or corrected before a project is considered officially done. It is created by the PM during a pre-walkthrough inspection — before the client sees the finished work." },
          { heading: "Creating the Punch List", text: "Walk the entire installation systematically. Use the Quality Control checklist from the Installer SOP as a guide. Note every item that does not meet the completion standard: any loose tile, grout inconsistency, unhazed section, incomplete caulk, uncleaned surface, or missing transition." },
          { heading: "Punch List Resolution", text: "Assign each item to the lead installer with a specific resolution deadline (typically within 24–48 hours). Confirm each item is resolved by physically re-inspecting — do not accept verbal confirmation alone. Document resolution with photos in the CRM." },
          { heading: "Final Approval Standard", text: "A project is ready for client walk-through when every item on the punch list is resolved and documented. The PM signs off on the punch list in the CRM before scheduling the walk-through. This creates an auditable quality record for every job." },
        ],
        tip: "The PM punch list is your last line of defense against a difficult client walk-through. Everything you find and fix internally saves 3x the time it would take to address it after the client has seen it.",
      },
      {
        id: "p7", title: "Materials & Supplier Reference Standards", tag: "Procurement", icon: "note",
        body: [
          { heading: "Approved Materials List", text: "Timeless Tile Pro maintains a preferred materials list for thin-set, grout, backer board, waterproofing membrane, adhesive, and caulk. Deviations from the preferred list require PM approval. Consistency across jobs allows for bulk pricing and predictable results." },
          { heading: "Material Ordering Lead Times", text: "Standard tile (in-stock): order 5 business days before job start. Special order tile: order minimum 3 weeks before job start — confirm with supplier and communicate lead time to client before signing the estimate. Waterproofing membrane and backer board: keep standard quantities in stock, reorder when supply drops below 2 jobs' worth." },
          { heading: "Overage Standards", text: "Standard rectangular rooms: 10% overage. Diagonal or complex patterns: 20% overage. Natural stone with significant variation: 15–20% overage. Always err toward more material — overage waste costs far less than a return trip and partial tile order." },
          { heading: "Leftover Material Protocol", text: "At job completion, offer the client a small quantity of matching tile (5–10 sq ft) for future repairs. Note this in the CRM job record. Remaining material above the client allocation is returned to company inventory and logged." },
          { heading: "Supplier Performance Tracking", text: "Log any supplier issues (late delivery, wrong material, quality defect) in the admin notes. Review supplier performance quarterly. If a supplier causes a job delay, the PM documents the incident and the owner evaluates continued use." },
        ],
        tip: "Your material quality directly determines your installation quality. Cheap thin-set and grout are false economies — the difference in material cost on a typical job is $50–200. The cost of a callback from material failure is $500–2,000.",
      },
    ],
  };

  const [expandedSOP, setExpandedSOP] = useState({});
  const toggleSOP = (id) => setExpandedSOP(p => ({ ...p, [id]: !p[id] }));

  const DOC_SECTIONS = {
    admin:     { label: "Admin SOP",                        icon: "admin",    color: "var(--accent-blue)",  desc: "Office procedures, client communication standards, scheduling protocols, and administrative workflows for your admin team." },
    installer: { label: "Lead Installer Field Ops SOP",     icon: "hardhat",  color: "var(--accent-amber)", desc: "On-site procedures, surface prep standards, installation quality checklists, tool protocols, and end-of-day site cleanup requirements." },
    pm:        { label: "Project Manager Field Ops SOP",    icon: "clipboard",color: "var(--accent-green)", desc: "Project planning, subcontractor coordination, client walk-through procedures, punch list management, and final sign-off protocols." },
  };

  // ── Upload handler ──
  const handleDocUpload = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length || !uploadSectionRef.current) return;
    const section = uploadSectionRef.current;
    const newDocs = files.map(f => ({
      id: Date.now() + Math.random(),
      name: f.name,
      size: f.size > 1048576 ? `${(f.size/1048576).toFixed(1)} MB` : `${(f.size/1024).toFixed(0)} KB`,
      date: new Date().toLocaleDateString(),
      tag: "Uploaded",
    }));
    setDocs(prev => ({ ...prev, [section]: [...(prev[section] || []), ...newDocs] }));
    e.target.value = "";
  };

  const triggerUpload = (section) => { uploadSectionRef.current = section; fileInputRef.current.click(); };
  const removeDoc = (section, id) => setDocs(prev => ({ ...prev, [section]: prev[section].filter(d => d.id !== id) }));

  // ── Script helpers ──
  const BLANK_PHONE = { id: null, title:"", tag:"Phone", body:"", tip:"" };
  const BLANK_EMAIL = { id: null, title:"", tag:"Email", subject:"", body:"", tip:"" };
  const saveScript = (type, data) => {
    if (type === "phone") {
      if (data.id) setPhoneScripts(p => p.map(s => s.id === data.id ? data : s));
      else setPhoneScripts(p => [...p, { ...data, id: Date.now() }]);
    } else {
      if (data.id) setEmailScripts(p => p.map(s => s.id === data.id ? data : s));
      else setEmailScripts(p => [...p, { ...data, id: Date.now() }]);
    }
    setEditScript(null);
  };
  const deleteScript = (type, id) => {
    if (type === "phone") setPhoneScripts(p => p.filter(s => s.id !== id));
    else setEmailScripts(p => p.filter(s => s.id !== id));
  };

  // ── SUB-COMPONENTS ──

  const ScriptCard = ({ script, type, onEdit, onDelete, onView }) => (
    <div className="card" style={{ borderLeft:`4px solid ${type==="phone"?"var(--accent-green)":"var(--accent-blue)"}`, padding:"18px 20px" }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:"10px", marginBottom:"8px" }}>
        <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
          <div style={{ width:32, height:32, borderRadius:8, background:type==="phone"?"rgba(122,158,126,0.15)":"rgba(107,140,174,0.15)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
            <Icon name={type==="phone"?"calls":"mail"} size={15} color={type==="phone"?"var(--accent-green)":"var(--accent-blue)"} />
          </div>
          <div>
            <div style={{ fontWeight:600, fontSize:"14px" }}>{script.title}</div>
            <span style={{ fontSize:"11px", background:type==="phone"?"rgba(122,158,126,0.15)":"rgba(107,140,174,0.15)", color:type==="phone"?"var(--accent-green)":"var(--accent-blue)", padding:"1px 8px", borderRadius:99, fontWeight:600 }}>{script.tag}</span>
          </div>
        </div>
        <div style={{ display:"flex", gap:"4px", flexShrink:0 }}>
          <button className="btn-icon" title="View / Copy" onClick={() => onView(script)}><Icon name="eye" size={14} color="var(--accent-amber)"/></button>
          <button className="btn-icon" title="Edit" onClick={() => onEdit(script)}><Icon name="edit" size={14}/></button>
          <button className="btn-icon" title="Delete" onClick={() => onDelete(type, script.id)}><Icon name="trash" size={14} color="var(--accent-red)"/></button>
        </div>
      </div>
      {/* Preview snippet */}
      <div style={{ fontSize:"12px", color:"var(--stone-500)", background:"var(--stone-100)", borderRadius:6, padding:"8px 10px", fontStyle:"italic", lineHeight:1.5, overflow:"hidden", display:"-webkit-box", WebkitLineClamp:2, WebkitBoxOrient:"vertical" }}>
        {script.body.split("\n")[0]}
      </div>
      {script.tip && (
        <div style={{ marginTop:"8px", display:"flex", gap:"6px", alignItems:"flex-start", fontSize:"12px", color:"var(--accent-amber)", background:"rgba(196,149,74,0.08)", borderRadius:6, padding:"6px 10px" }}>
          <span style={{ flexShrink:0, marginTop:1 }}>💡</span>
          <span>{script.tip}</span>
        </div>
      )}
    </div>
  );

  const DocRow = ({ doc, section }) => (
    <div style={{ display:"flex", alignItems:"center", gap:"12px", padding:"12px 16px", borderBottom:"1px solid var(--stone-200)", transition:"background 0.15s" }}
      onMouseEnter={e => e.currentTarget.style.background="var(--stone-100)"}
      onMouseLeave={e => e.currentTarget.style.background="transparent"}
    >
      <div style={{ width:36, height:36, borderRadius:8, background:"rgba(201,169,110,0.12)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
        <Icon name="sop" size={16} color="var(--warm-gold)"/>
      </div>
      <div style={{ flex:1, minWidth:0 }}>
        <div style={{ fontWeight:500, fontSize:"13px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{doc.name}</div>
        <div style={{ fontSize:"11px", color:"var(--stone-400)", display:"flex", gap:"10px" }}>
          <span>{doc.size}</span>
          <span>Uploaded {doc.date}</span>
        </div>
      </div>
      <span style={{ fontSize:"11px", background:"var(--stone-100)", border:"1px solid var(--stone-200)", padding:"2px 8px", borderRadius:99, color:"var(--stone-600)", flexShrink:0 }}>{doc.tag}</span>
      <button className="btn-icon" title="Delete" onClick={() => removeDoc(section, doc.id)}>
        <Icon name="trash" size={13} color="var(--accent-red)"/>
      </button>
    </div>
  );

  // ── VIEW SCRIPT MODAL ──
  const ViewScriptModal = ({ script, type, onClose }) => {
    const [copied, setCopied] = useState(false);
    const copy = () => {
      const text = type === "email"
        ? `Subject: ${script.subject}\n\n${script.body}`
        : script.body;
      navigator.clipboard?.writeText(text).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); });
    };
    return (
      <Modal title={script.title} onClose={onClose}>
        {type === "email" && (
          <div style={{ marginBottom:"12px", padding:"8px 12px", background:"var(--stone-100)", borderRadius:6, fontSize:"13px" }}>
            <span style={{ fontWeight:600, color:"var(--stone-500)" }}>Subject: </span>{script.subject}
          </div>
        )}
        <div style={{ background:"var(--stone-100)", borderRadius:"var(--radius)", padding:"16px", fontSize:"13px", lineHeight:1.8, whiteSpace:"pre-wrap", color:"var(--stone-800)", maxHeight:"320px", overflowY:"auto", border:"1px solid var(--stone-200)", fontFamily:"var(--font-body)" }}>
          {script.body}
        </div>
        {script.tip && (
          <div style={{ marginTop:"12px", display:"flex", gap:"8px", background:"rgba(196,149,74,0.1)", borderRadius:6, padding:"10px 12px", fontSize:"13px", color:"var(--accent-amber)" }}>
            <span>💡</span><span><strong>Pro Tip:</strong> {script.tip}</span>
          </div>
        )}
        <div style={{ display:"flex", justifyContent:"flex-end", gap:"8px", marginTop:"16px" }}>
          <button className="btn btn-secondary" onClick={onClose}>Close</button>
          <button className="btn btn-primary" onClick={copy}>
            <Icon name={copied?"check":"copy"} size={14}/> {copied ? "Copied!" : "Copy Script"}
          </button>
        </div>
      </Modal>
    );
  };

  // ── EDIT SCRIPT MODAL ──
  const EditScriptModal = ({ script, type, onSave, onClose }) => {
    const [f, setF] = useState({ ...script });
    return (
      <Modal title={f.id ? `Edit: ${f.title}` : `New ${type === "phone" ? "Phone" : "Email"} Script`} onClose={onClose}>
        <div className="form-group"><label>Script Title</label><input value={f.title} onChange={e => setF(p => ({...p,title:e.target.value}))} placeholder="e.g. First Call Inquiry" /></div>
        {type === "email" && <div className="form-group"><label>Email Subject Line</label><input value={f.subject||""} onChange={e => setF(p => ({...p,subject:e.target.value}))} placeholder="e.g. Your Estimate is Ready – Timeless Tile Pro" /></div>}
        <div className="form-group"><label>Script Body</label><textarea rows={10} value={f.body} onChange={e => setF(p => ({...p,body:e.target.value}))} style={{ fontSize:"13px", lineHeight:1.7 }} /></div>
        <div className="form-group"><label>Pro Tip (optional)</label><input value={f.tip||""} onChange={e => setF(p => ({...p,tip:e.target.value}))} placeholder="A short coaching note for whoever uses this script" /></div>
        <div style={{ display:"flex", justifyContent:"flex-end", gap:"8px" }}>
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={() => onSave(type, f)}><Icon name="check" size={14}/> Save Script</button>
        </div>
      </Modal>
    );
  };

  // ── RENDER ──
  return (
    <div className="fade-in">
      <input ref={fileInputRef} type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt" multiple style={{ display:"none" }} onChange={handleDocUpload} />

      {/* Header */}
      <div style={{ marginBottom:"24px" }}>
        <h1 className="section-title">Company Playbook</h1>
        <p className="section-sub">Your operational bible — scripts, procedures, and team resources all in one place.</p>
      </div>

      {/* Top-level section tabs */}
      <div style={{ display:"flex", gap:"10px", marginBottom:"28px", flexWrap:"wrap" }}>
        {[
          { id:"sop",    label:"Standard Operating Procedures", icon:"sop",      color:"var(--warm-gold)" },
        ].map(s => (
          <button key={s.id} onClick={() => setActiveSection(s.id)}
            style={{ display:"flex", alignItems:"center", gap:"8px", padding:"10px 20px", borderRadius:"var(--radius)", fontFamily:"var(--font-body)", fontSize:"13px", fontWeight:600, cursor:"pointer", border:`2px solid ${activeSection===s.id?"var(--warm-gold)":"var(--stone-200)"}`, background:activeSection===s.id?"rgba(201,169,110,0.1)":"var(--stone-50)", color:activeSection===s.id?"var(--warm-gold)":"var(--stone-600)", transition:"all 0.2s" }}>
            <Icon name={s.icon} size={15} color={activeSection===s.id?s.color:"var(--stone-400)"} />
            {s.label}
          </button>
        ))}
      </div>

      {/* ══ SOP SECTION ══ */}
      {activeSection === "sop" && (
        <div>
          {/* SOP sub-nav */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(200px,1fr))", gap:"12px", marginBottom:"28px" }}>
            {[
              { id:"scripts",   label:"Communication Scripts",       icon:"script",    color:"var(--accent-green)",  desc:"Phone & email templates for every client touchpoint" },
              { id:"admin",     label:"Admin SOP",                   icon:"admin",     color:"var(--accent-blue)",   desc:"Office procedures & administrative workflows" },
              { id:"installer", label:"Lead Installer Field Ops",    icon:"hardhat",   color:"var(--accent-amber)",  desc:"On-site standards, safety, and installation procedures" },
              { id:"pm",        label:"Project Manager Field Ops",   icon:"clipboard", color:"var(--accent-green)",  desc:"Project planning, coordination & sign-off protocols" },
            ].map(t => (
              <button key={t.id} onClick={() => setSopTab(t.id)}
                style={{ textAlign:"left", padding:"16px", borderRadius:"var(--radius-lg)", border:`2px solid ${sopTab===t.id?t.color:"var(--stone-200)"}`, background:sopTab===t.id?`${t.color}12`:"var(--stone-50)", cursor:"pointer", transition:"all 0.2s", fontFamily:"var(--font-body)" }}>
                <div style={{ display:"flex", alignItems:"center", gap:"8px", marginBottom:"6px" }}>
                  <Icon name={t.icon} size={16} color={sopTab===t.id?t.color:"var(--stone-400)"} />
                  <span style={{ fontWeight:700, fontSize:"13px", color:sopTab===t.id?t.color:"var(--stone-700)" }}>{t.label}</span>
                </div>
                <div style={{ fontSize:"11px", color:"var(--stone-400)", lineHeight:1.4 }}>{t.desc}</div>
              </button>
            ))}
          </div>

          {/* ── Communication Scripts ── */}
          {sopTab === "scripts" && (
            <div className="fade-in">
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"16px", flexWrap:"wrap", gap:"10px" }}>
                <div>
                  <h2 style={{ fontFamily:"var(--font-display)", fontSize:"22px", fontWeight:600 }}>Communication Quick Scripts</h2>
                  <p style={{ fontSize:"13px", color:"var(--stone-500)", marginTop:2 }}>Ready-to-use phone and email scripts for your team. Click any script to view and copy.</p>
                </div>
              </div>

              {/* Script type tabs */}
              <div className="tab-bar" style={{ marginBottom:"20px" }}>
                {[["phone","📞  Phone Scripts"],["email","✉️  Email Scripts"]].map(([k,l]) => (
                  <div key={k} className={`tab${scriptTab===k?" active":""}`} onClick={() => setScriptTab(k)}>{l}</div>
                ))}
              </div>

              {scriptTab === "phone" && (
                <div>
                  <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:"14px" }}>
                    <button className="btn btn-primary btn-sm" onClick={() => setEditScript({ ...BLANK_PHONE, _type:"phone" })}><Icon name="plus" size={13}/> New Phone Script</button>
                  </div>
                  <div style={{ display:"grid", gap:"14px" }}>
                    {phoneScripts.map(s => (
                      <ScriptCard key={s.id} script={s} type="phone"
                        onEdit={(s) => setEditScript({ ...s, _type:"phone" })}
                        onDelete={deleteScript}
                        onView={(s) => setDocModal({ type:"phone", script:s })}
                      />
                    ))}
                  </div>
                </div>
              )}

              {scriptTab === "email" && (
                <div>
                  <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:"14px" }}>
                    <button className="btn btn-primary btn-sm" onClick={() => setEditScript({ ...BLANK_EMAIL, _type:"email" })}><Icon name="plus" size={13}/> New Email Script</button>
                  </div>
                  <div style={{ display:"grid", gap:"14px" }}>
                    {emailScripts.map(s => (
                      <ScriptCard key={s.id} script={s} type="email"
                        onEdit={(s) => setEditScript({ ...s, _type:"email" })}
                        onDelete={deleteScript}
                        onView={(s) => setDocModal({ type:"email", script:s })}
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* ── Document Resource Sections (Admin, Installer, PM) ── */}
          {["admin","installer","pm"].includes(sopTab) && (
            <div className="fade-in">
              {(() => {
                const sec = DOC_SECTIONS[sopTab];
                const sectionDocs = docs[sopTab] || [];
                const sopItems = SOP_CONTENT[sopTab] || [];
                const tagColors = { "Onboarding":"var(--accent-blue)", "Billing":"var(--accent-amber)", "Scheduling":"var(--accent-green)", "CRM":"var(--accent-blue)", "Client Relations":"var(--accent-red)", "Procurement":"var(--stone-600)", "Pre-Job":"var(--accent-amber)", "Installation":"var(--accent-amber)", "Safety":"var(--accent-red)", "Cleanup":"var(--accent-green)", "Quality Control":"var(--warm-gold)", "Documentation":"var(--accent-blue)", "Planning":"var(--accent-green)", "Communication":"var(--accent-blue)", "Team Management":"var(--accent-amber)", "Completion":"var(--accent-green)", "Warranty":"var(--accent-red)", "Templates":"var(--stone-600)" };

                return (
                  <div>
                    {/* Section header */}
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:"24px", flexWrap:"wrap", gap:"12px" }}>
                      <div style={{ display:"flex", gap:"14px", alignItems:"flex-start" }}>
                        <div style={{ width:46, height:46, borderRadius:12, background:`${sec.color}1a`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                          <Icon name={sec.icon} size={22} color={sec.color}/>
                        </div>
                        <div>
                          <h2 style={{ fontFamily:"var(--font-display)", fontSize:"22px", fontWeight:600, marginBottom:4 }}>{sec.label}</h2>
                          <p style={{ fontSize:"13px", color:"var(--stone-500)", maxWidth:540, lineHeight:1.5 }}>{sec.desc}</p>
                        </div>
                      </div>
                      <button className="btn btn-primary" onClick={() => triggerUpload(sopTab)}>
                        <Icon name="upload" size={14}/> Upload Document
                      </button>
                    </div>

                    {/* ── Built-in SOP Cards ── */}
                    <div style={{ display:"grid", gap:"14px", marginBottom:"28px" }}>
                      {sopItems.map(sop => {
                        const isOpen = expandedSOP[sop.id];
                        const tagColor = tagColors[sop.tag] || "var(--stone-500)";
                        return (
                          <div key={sop.id} className="card" style={{ padding:0, overflow:"hidden", border:`1px solid var(--stone-200)`, borderLeft:`4px solid ${sec.color}` }}>
                            {/* Card header — always visible, click to expand */}
                            <div
                              onClick={() => toggleSOP(sop.id)}
                              style={{ display:"flex", alignItems:"center", gap:"14px", padding:"16px 20px", cursor:"pointer", background: isOpen ? "var(--stone-100)" : "white", transition:"background 0.2s", userSelect:"none" }}
                              onMouseEnter={e => { if (!isOpen) e.currentTarget.style.background="var(--stone-50)"; }}
                              onMouseLeave={e => { if (!isOpen) e.currentTarget.style.background="white"; }}
                            >
                              <div style={{ width:36, height:36, borderRadius:9, background:`${sec.color}1a`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                                <Icon name={sop.icon} size={17} color={sec.color}/>
                              </div>
                              <div style={{ flex:1, minWidth:0 }}>
                                <div style={{ fontWeight:600, fontSize:"14px", marginBottom:3 }}>{sop.title}</div>
                                <span style={{ fontSize:"11px", fontWeight:600, padding:"2px 9px", borderRadius:99, background:`${tagColor}18`, color:tagColor }}>{sop.tag}</span>
                              </div>
                              <div style={{ display:"flex", alignItems:"center", gap:"6px", flexShrink:0 }}>
                                <span style={{ fontSize:"11px", color:"var(--stone-400)" }}>{sop.body.length} steps</span>
                                <div style={{ width:26, height:26, borderRadius:"50%", background:"var(--stone-200)", display:"flex", alignItems:"center", justifyContent:"center", transition:"transform 0.2s", transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}>
                                  <Icon name="chevron_down" size={14} color="var(--stone-600)"/>
                                </div>
                              </div>
                            </div>

                            {/* Expanded body */}
                            {isOpen && (
                              <div style={{ borderTop:`1px solid var(--stone-200)`, padding:"20px 24px", animation:"fadeIn 0.2s ease" }}>
                                <div style={{ display:"grid", gap:"16px" }}>
                                  {sop.body.map((step, i) => (
                                    <div key={i} style={{ display:"flex", gap:"14px" }}>
                                      <div style={{ width:26, height:26, borderRadius:"50%", background:`${sec.color}18`, border:`1.5px solid ${sec.color}40`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, fontSize:"11px", fontWeight:700, color:sec.color, marginTop:2 }}>
                                        {i + 1}
                                      </div>
                                      <div style={{ flex:1 }}>
                                        <div style={{ fontWeight:700, fontSize:"13px", color:"var(--stone-800)", marginBottom:5 }}>{step.heading}</div>
                                        <div style={{ fontSize:"13px", color:"var(--stone-600)", lineHeight:1.7 }}>{step.text}</div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                                {sop.tip && (
                                  <div style={{ marginTop:"18px", display:"flex", gap:"10px", background:"rgba(196,149,74,0.08)", border:"1px solid rgba(196,149,74,0.25)", borderRadius:"var(--radius)", padding:"12px 14px" }}>
                                    <span style={{ fontSize:16, flexShrink:0 }}>💡</span>
                                    <div>
                                      <div style={{ fontWeight:700, fontSize:"12px", color:"var(--accent-amber)", marginBottom:3, textTransform:"uppercase", letterSpacing:"0.04em" }}>Pro Note</div>
                                      <div style={{ fontSize:"13px", color:"var(--stone-700)", lineHeight:1.6 }}>{sop.tip}</div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>

                    {/* ── Your Uploaded Documents ── */}
                    <div style={{ marginBottom:"8px" }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"12px" }}>
                        <div>
                          <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:600 }}>Your Uploaded Documents</div>
                          <div style={{ fontSize:"12px", color:"var(--stone-400)", marginTop:2 }}>Add your own SOPs, checklists, and forms to supplement the content above.</div>
                        </div>
                        <button className="btn btn-secondary btn-sm" onClick={() => triggerUpload(sopTab)}><Icon name="upload" size={13}/> Upload</button>
                      </div>
                      <div className="card" style={{ padding:0 }}>
                        {sectionDocs.length === 0 ? (
                          <div
                            onClick={() => triggerUpload(sopTab)}
                            style={{ padding:"32px 20px", textAlign:"center", cursor:"pointer", borderRadius:"var(--radius-lg)" }}
                            onMouseEnter={e => e.currentTarget.style.background="var(--stone-100)"}
                            onMouseLeave={e => e.currentTarget.style.background="transparent"}
                          >
                            <div style={{ fontSize:32, marginBottom:8 }}>📂</div>
                            <div style={{ fontWeight:600, color:"var(--stone-500)", marginBottom:4 }}>No documents uploaded yet</div>
                            <div style={{ fontSize:"12px", color:"var(--stone-400)" }}>Click here to upload your own SOPs, checklists, and reference documents</div>
                          </div>
                        ) : (
                          <div>
                            {sectionDocs.map(doc => <DocRow key={doc.id} doc={doc} section={sopTab} />)}
                            <div
                              onClick={() => triggerUpload(sopTab)}
                              style={{ display:"flex", alignItems:"center", gap:"10px", padding:"12px 16px", cursor:"pointer", color:"var(--stone-400)", fontSize:"13px", borderTop:"1px dashed var(--stone-300)" }}
                              onMouseEnter={e => { e.currentTarget.style.background="var(--stone-100)"; e.currentTarget.style.color="var(--warm-gold)"; }}
                              onMouseLeave={e => { e.currentTarget.style.background="transparent"; e.currentTarget.style.color="var(--stone-400)"; }}
                            >
                              <Icon name="upload" size={14}/> Upload another document…
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      )}

      {/* ── View Script Modal ── */}
      {docModal && docModal.script && (
        <ViewScriptModal script={docModal.script} type={docModal.type} onClose={() => setDocModal(null)} />
      )}

      {/* ── Edit / Add Script Modal ── */}
      {editScript && (
        <EditScriptModal
          script={editScript}
          type={editScript._type}
          onSave={saveScript}
          onClose={() => setEditScript(null)}
        />
      )}
    </div>
  );
};

// ── CALL TRACKING ─────────────────────────────────────────────────────────────
const CallTracking = ({ calls, setCalls, messages, setMessages, leads, customers, requestDelete }) => {
  const [modal, setModal]       = useState(null); // "add" | call obj
  const [filter, setFilter]     = useState("All");
  const [dirFilter, setDirFilter] = useState("All");
  const [sourceFilter, setSourceFilter] = useState("All");
  const [search, setSearch]     = useState("");
  const [apiTab, setApiTab]     = useState(false);
  const [activeTab, setActiveTab] = useState("calls"); // calls | sms | voicemails
  const [smsConvo, setSmsConvo] = useState(null); // phone number for open convo
  const [smsText, setSmsText]   = useState("");
  const [smsSending, setSmsSending] = useState(false);
  // ── SMS search (queries the database directly — finds texts of any age) ──
  const [smsSearch, setSmsSearch] = useState("");
  const [smsResults, setSmsResults] = useState(null); // null = not searching
  const [smsSearching, setSmsSearching] = useState(false);
  const runSmsSearch = async () => {
    const q = smsSearch.trim().replace(/[,()%*]/g, " ").trim();
    if (q.length < 2) return;
    setSmsSearching(true);
    try {
      const digits = q.replace(/\D/g, "");
      const filters = [`body.ilike.%${q}%`, `contact_name.ilike.%${q}%`];
      if (digits.length >= 3) filters.push(`phone.ilike.%${digits}%`);
      const { data, error } = await supabase.from("messages").select("*")
        .or(filters.join(","))
        .order("created_at", { ascending: false }).limit(100);
      if (error) throw error;
      setSmsResults(data || []);
    } catch (e) {
      console.error("[SMS search]", e);
      setSmsResults([]);
    }
    setSmsSearching(false);
  };
  const clearSmsSearch = () => { setSmsSearch(""); setSmsResults(null); };
  // Open a result: load that whole conversation (any date) and show it
  const openSearchResult = async (m) => {
    const key = (m.phone || "").replace(/\D/g, "").slice(-10);
    if (!key) return;
    try {
      const { data } = await supabase.from("messages").select("*")
        .ilike("phone", `%${key}%`).order("created_at", { ascending: false }).limit(300);
      if (data?.length) setMessages(p => mergeMessages(p, data));
    } catch (e) { console.error("[SMS search] thread load failed:", e); }
    setQuickDate("all"); // make sure the date filter doesn't hide an older thread
    setSmsConvo(key);
  };
  const highlight = (text, q) => {
    const t = text || "";
    const needle = (q || "").trim();
    const i = needle ? t.toLowerCase().indexOf(needle.toLowerCase()) : -1;
    if (i < 0) return t.length > 90 ? t.slice(0, 90) + "…" : t;
    const from = Math.max(0, i - 30);
    return (<>{from > 0 ? "…" : ""}{t.slice(from, i)}<mark style={{ background:"rgba(201,169,110,0.35)", color:"inherit", padding:0 }}>{t.slice(i, i + needle.length)}</mark>{t.slice(i + needle.length, i + needle.length + 50)}{i + needle.length + 50 < t.length ? "…" : ""}</>);
  };
  const [smsMedia, setSmsMedia] = useState([]); // [{preview, file}] — photos queued to send
  const [smsMediaUploading, setSmsMediaUploading] = useState(false);
  const smsFileRef = useRef(null);
  // ── New SMS compose modal state ──
  const [newSmsModal, setNewSmsModal] = useState(false);
  const [newSmsPhone, setNewSmsPhone] = useState("");
  const [newSmsName, setNewSmsName]   = useState("");
  const [newSmsBody, setNewSmsBody]   = useState("");
  const [newSmsSending, setNewSmsSending] = useState(false);
  const [dateFrom, setDateFrom]   = useState("");
  const [dateTo, setDateTo]       = useState("");
  const [dateQuick, setDateQuick] = useState("all"); // all | today | week | month | custom
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" ? window.innerWidth < 768 : false);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);
  const [form, setForm] = useState({
    contact:"", phone:"", direction:"inbound", outcome:"Answered",
    duration:"", date: new Date().toISOString().slice(0,10), time:"", notes:"",
    source:"Direct", linkedLead: null, linkedCustomer: null
  });

  // ── Source config ──
  const SOURCE_STYLE = {
    Google:   { color:"#4285f4", bg:"rgba(66,133,244,0.12)",  icon:"🔍" },
    Website:  { color:"var(--warm-gold)", bg:"rgba(201,169,110,0.12)", icon:"🌐" },
    Facebook: { color:"#1877f2", bg:"rgba(24,119,242,0.12)",  icon:"📘" },
    Yelp:     { color:"#d32323", bg:"rgba(211,35,35,0.12)",   icon:"⭐" },
    Referral: { color:"var(--accent-green)", bg:"rgba(122,158,126,0.12)", icon:"🤝" },
    Direct:   { color:"var(--stone-600)", bg:"var(--stone-100)", icon:"📞" },
    CRM:      { color:"var(--accent-blue)", bg:"rgba(107,140,174,0.12)", icon:"💻" },
    Unknown:  { color:"var(--stone-400)", bg:"var(--stone-100)", icon:"❓" },
  };

  // ── Date filter helpers ──
  const todayStr = new Date().toISOString().slice(0, 10);
  const weekAgoStr = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
  const monthAgoStr = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);

  const setQuickDate = (q) => {
    setDateQuick(q);
    if (q === "all") { setDateFrom(""); setDateTo(""); }
    else if (q === "today") { setDateFrom(todayStr); setDateTo(todayStr); }
    else if (q === "week") { setDateFrom(weekAgoStr); setDateTo(todayStr); }
    else if (q === "month") { setDateFrom(monthAgoStr); setDateTo(todayStr); }
    else if (q === "custom") { /* user picks manually */ }
  };

  const matchesDate = (itemDate) => {
    if (!dateFrom && !dateTo) return true;
    const d = itemDate || "";
    if (dateFrom && d < dateFrom) return false;
    if (dateTo && d > dateTo) return false;
    return true;
  };

  // ── stats (reflect date filter) ──
  const dateCalls = calls.filter(c => matchesDate(c.date));
  const total     = dateCalls.length;
  const answered  = dateCalls.filter(c => c.outcome === "Answered").length;
  const missed    = dateCalls.filter(c => c.outcome === "Missed").length;
  const voicemail = dateCalls.filter(c => c.outcome === "Voicemail").length;
  const avgDur    = (() => {
    const answered = dateCalls.filter(c => c.duration && c.duration !== "0:00");
    if (!answered.length) return "0:00";
    const total = answered.reduce((s, c) => {
      const [m,sec] = c.duration.split(":").map(Number);
      return s + m * 60 + sec;
    }, 0);
    const avg = Math.round(total / answered.length);
    return `${Math.floor(avg/60)}:${String(avg%60).padStart(2,"0")}`;
  })();

  // Source breakdown (date-filtered)
  const sourceCounts = {};
  dateCalls.forEach(c => {
    const src = c.source || "Direct";
    sourceCounts[src] = (sourceCounts[src] || 0) + 1;
  });
  const uniqueSources = Object.keys(sourceCounts).sort((a,b) => sourceCounts[b] - sourceCounts[a]);

  const filtered = calls.filter(c => {
    const matchOut = filter === "All" || c.outcome === filter;
    const matchDir = dirFilter === "All" || c.direction === dirFilter;
    const matchSource = sourceFilter === "All" || (c.source || "Direct") === sourceFilter;
    const matchSearch = c.contact.toLowerCase().includes(search.toLowerCase()) ||
                        (c.phone||"").includes(search) ||
                        (c.notes || "").toLowerCase().includes(search.toLowerCase());
    const matchDt = matchesDate(c.date);
    return matchOut && matchDir && matchSource && matchSearch && matchDt;
  });

  const save = () => {
    if (modal === "add") {
      setCalls(p => [...p, { ...form, id: Date.now() }]);
    } else {
      setCalls(p => p.map(c => c.id === modal.id ? { ...form, id: c.id } : c));
    }
    setModal(null);
  };

  const openAdd = () => {
    setForm({ contact:"", phone:"", direction:"inbound", outcome:"Answered", duration:"", date: new Date().toISOString().slice(0,10), time:"", notes:"", source:"Direct", linkedLead: null, linkedCustomer: null });
    setModal("add");
  };

  // ── SMS helpers ──
  const smsThreads = {};
  (messages || []).forEach(m => {
    // Apply date filter to messages
    const msgDate = m.created_at ? m.created_at.slice(0, 10) : '';
    if (!matchesDate(msgDate)) return;
    const key = m.phone?.replace(/\D/g, '').slice(-10) || 'unknown';
    if (!smsThreads[key]) smsThreads[key] = { phone: m.phone, name: m.contact_name, messages: [], unread: 0 };
    smsThreads[key].messages.push(m);
    if (!m.read && m.direction === 'inbound') smsThreads[key].unread++;
  });
  const threadList = Object.values(smsThreads).sort((a, b) => {
    const aLast = a.messages[0]?.created_at || '';
    const bLast = b.messages[0]?.created_at || '';
    return bLast.localeCompare(aLast);
  });
  const totalUnread = threadList.reduce((s, t) => s + t.unread, 0);

  // ── MMS photo pick handler ──
  const handleSmsPhoto = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    files.forEach(file => {
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const compressed = await compressImage(ev.target.result, 800, 0.7);
        setSmsMedia(p => [...p, { preview: compressed, file }]);
      };
      reader.readAsDataURL(file);
    });
    if (smsFileRef.current) smsFileRef.current.value = '';
  };

  const sendSms = async () => {
    if ((!smsText.trim() && smsMedia.length === 0) || !smsConvo || smsSending) return;
    setSmsSending(true);
    try {
      const thread = threadList.find(t => t.phone?.replace(/\D/g, '').slice(-10) === smsConvo);

      // Upload photos to Supabase Storage if attached
      let mediaUrl = null;
      if (smsMedia.length > 0) {
        setSmsMediaUploading(true);
        const uploadedUrls = [];
        for (const item of smsMedia) {
          try {
            const base64 = item.preview.split(',')[1];
            const byteArr = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
            const blob = new Blob([byteArr], { type: 'image/jpeg' });
            const path = `sms/outbound-${Date.now()}-${Math.random().toString(36).slice(2, 6)}.jpg`;
            const { error: upErr } = await supabase.storage.from('photos').upload(path, blob, { contentType: 'image/jpeg', upsert: false });
            if (upErr) { console.error('[MMS] Upload error:', upErr.message); continue; }
            const { data: urlData } = supabase.storage.from('photos').getPublicUrl(path);
            if (urlData?.publicUrl) uploadedUrls.push(urlData.publicUrl);
          } catch (ue) { console.error('[MMS] Upload failed:', ue); }
        }
        setSmsMediaUploading(false);
        if (uploadedUrls.length > 0) mediaUrl = uploadedUrls;
      }

      const payload = { to: thread?.phone || smsConvo, body: smsText || '', contactName: thread?.name || '' };
      if (mediaUrl) payload.mediaUrl = mediaUrl;

      const res = await fetch('/api/twilio/send-sms', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (data.success) {
        setSmsText("");
        setSmsMedia([]);
        // Fetch fresh messages from Supabase instead of optimistic add to prevent duplicates
        const { data: freshMsgs } = await supabase.from('messages').select('*').order('created_at', { ascending: false }).limit(50);
        if (freshMsgs?.length) setMessages(p => mergeMessages(p, freshMsgs));
      }
    } catch (e) { console.error('SMS send error:', e); }
    setSmsSending(false);
  };

  // ── Voicemails ──
  const voicemails = calls.filter(c => (c.outcome === "Voicemail" || c.recording_url || c.transcription) && matchesDate(c.date));

  // ── Click-to-call: use the Softphone if ready, fall back to native dialer (tel:) only if it hasn't registered yet ──
  const handleCallClick = (phone) => {
    const clean = (phone || "").replace(/\D/g, "");
    if (!clean) return;
    if (typeof window !== "undefined" && typeof window.__ttpMakeCall === "function") {
      window.__ttpMakeCall(phone);
    } else {
      const formatted = clean.length === 10 ? `+1${clean}` : `+${clean}`;
      if (typeof window !== "undefined") window.location.href = `tel:${formatted}`;
    }
  };

  // ── Open the New SMS modal (blank) ──
  const openNewSms = () => {
    setNewSmsPhone(""); setNewSmsName(""); setNewSmsBody("");
    setNewSmsModal(true);
  };

  // ── Click "SMS" on a call row: open existing thread if one exists, otherwise prefill New SMS modal ──
  const openNewSmsFor = (phone, name) => {
    const clean = (phone || "").replace(/\D/g, "");
    if (!clean) return;
    const key = clean.slice(-10);
    const existing = threadList.find(t => t.phone?.replace(/\D/g, "").slice(-10) === key);
    if (existing) {
      setActiveTab("sms");
      setSmsConvo(key);
      markThreadRead(messages, key);
      setMessages(p => p.map(m => m.phone?.replace(/\D/g, "").slice(-10) === key ? { ...m, read: true } : m));
      return;
    }
    setNewSmsPhone(phone || "");
    setNewSmsName(name || "");
    setNewSmsBody("");
    setNewSmsModal(true);
  };

  // ── Send the message composed in the New SMS modal ──
  const sendNewSms = async () => {
    if (newSmsSending) return;
    const clean = (newSmsPhone || "").replace(/\D/g, "");
    if (clean.length < 10) { alert("Please enter a valid 10-digit phone number."); return; }
    if (!newSmsBody.trim()) { alert("Please type a message."); return; }
    setNewSmsSending(true);
    try {
      const formatted = clean.length === 10 ? `+1${clean}` : `+${clean}`;
      const res = await fetch("/api/twilio/send-sms", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ to: formatted, body: newSmsBody, contactName: newSmsName || "" }),
      });
      const data = await res.json();
      if (data.success) {
        // Refresh messages from Supabase so the new thread appears
        try {
          const { data: freshMsgs } = await supabase.from("messages").select("*").order("created_at", { ascending: false }).limit(50);
          if (freshMsgs?.length) setMessages(p => mergeMessages(p, freshMsgs));
        } catch (e) { console.error("[NewSMS] Refresh error:", e); }
        setNewSmsModal(false);
        setActiveTab("sms");
        setSmsConvo(clean.slice(-10));
        setNewSmsPhone(""); setNewSmsName(""); setNewSmsBody("");
      } else {
        alert("Failed to send SMS: " + (data.error || "Unknown error"));
      }
    } catch (e) {
      console.error("[NewSMS] Send error:", e);
      alert("Error sending SMS: " + (e.message || e));
    }
    setNewSmsSending(false);
  };

  const OUTCOME_STYLE = {
    Answered:  { bg:"#e8f5e9", color:"#2d6a4f" },
    Missed:    { bg:"#ffe3e3", color:"#c92a2a" },
    Voicemail: { bg:"#fff3bf", color:"#946c00" },
  };

  const DIR_ICON = {
    inbound:  { icon:"phone_in",  color:"var(--accent-green)", label:"Inbound" },
    outbound: { icon:"phone_out", color:"var(--accent-blue)",  label:"Outbound" },
  };

  return (
    <div className="fade-in">

      {/* ── Header ── */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:"12px", flexWrap:"wrap", gap:"12px" }}>
        <div>
          <h1 className="section-title">Call Tracking</h1>
          <p className="section-sub">Calls, SMS messages, and voicemails — all in one place.</p>
        </div>
        <div style={{ display:"flex", gap:"8px" }}>
          {activeTab === "sms" ? (
            <button className="btn btn-primary" onClick={openNewSms}>
              <Icon name="plus" size={14} /> New SMS
            </button>
          ) : (
            <button className="btn btn-primary" onClick={openAdd}>
              <Icon name="plus" size={14} /> Log Call
            </button>
          )}
        </div>
      </div>

      {/* ── Tab Bar ── */}
      <div style={{ display:"flex", gap:"4px", background:"var(--stone-200)", borderRadius:"var(--radius)", padding:"4px", marginBottom:"20px", maxWidth:420 }}>
        {[
          { id:"calls", label:"Calls", icon:"calls", count:total },
          { id:"sms", label:"SMS", icon:"mail", count:totalUnread },
          { id:"voicemails", label:"Voicemails", icon:"voicemail", count:voicemails.length },
        ].map(t => (
          <button key={t.id} onClick={() => setActiveTab(t.id)} style={{
            flex:1, padding:"8px 14px", borderRadius:6, border:"none", cursor:"pointer",
            background: activeTab===t.id ? "white" : "transparent",
            color: activeTab===t.id ? "var(--stone-900)" : "var(--stone-500)",
            fontWeight: activeTab===t.id ? 700 : 500, fontSize:"13px",
            boxShadow: activeTab===t.id ? "0 1px 4px rgba(0,0,0,0.1)" : "none",
            display:"flex", alignItems:"center", justifyContent:"center", gap:6, transition:"all 0.15s"
          }}>
            <Icon name={t.icon} size={14} />
            {t.label}
            {t.count > 0 && <span style={{ background: activeTab===t.id ? "var(--warm-gold)" : "var(--stone-300)", color:"white", fontSize:"10px", fontWeight:800, padding:"1px 6px", borderRadius:99, minWidth:18, textAlign:"center" }}>{t.count}</span>}
          </button>
        ))}
      </div>

      {/* ── Date Filter Bar ── */}
      <div style={{ display:"flex", gap:"8px", marginBottom:"20px", flexWrap:"wrap", alignItems:"center" }}>
        <div style={{ display:"flex", background:"var(--stone-200)", borderRadius:"var(--radius)", padding:"3px", gap:"2px" }}>
          {[
            { id:"all", label:"All Time" },
            { id:"today", label:"Today" },
            { id:"week", label:"7 Days" },
            { id:"month", label:"30 Days" },
            { id:"custom", label:"Custom" },
          ].map(q => (
            <button key={q.id} onClick={() => setQuickDate(q.id)} style={{
              padding:"6px 12px", borderRadius:6, border:"none", cursor:"pointer", fontSize:"12px", fontWeight:600,
              background: dateQuick===q.id ? "white" : "transparent",
              color: dateQuick===q.id ? "var(--stone-900)" : "var(--stone-500)",
              boxShadow: dateQuick===q.id ? "0 1px 4px rgba(0,0,0,0.1)" : "none",
              transition:"all 0.15s"
            }}>{q.label}</button>
          ))}
        </div>
        {(dateQuick === "custom" || dateFrom || dateTo) && dateQuick !== "all" && (
          <div style={{ display:"flex", gap:"6px", alignItems:"center" }}>
            <input type="date" value={dateFrom} onChange={e => { setDateFrom(e.target.value); setDateQuick("custom"); }}
              style={{ padding:"6px 10px", border:"1.5px solid var(--stone-300)", borderRadius:"var(--radius)", fontSize:"12px", color:"var(--stone-700)" }} />
            <span style={{ fontSize:"12px", color:"var(--stone-400)" }}>to</span>
            <input type="date" value={dateTo} onChange={e => { setDateTo(e.target.value); setDateQuick("custom"); }}
              style={{ padding:"6px 10px", border:"1.5px solid var(--stone-300)", borderRadius:"var(--radius)", fontSize:"12px", color:"var(--stone-700)" }} />
            {dateFrom && (
              <button onClick={() => { setDateFrom(""); setDateTo(""); setDateQuick("all"); }}
                style={{ background:"none", border:"none", cursor:"pointer", color:"var(--stone-400)", fontSize:"12px", padding:"4px 6px" }}>
                Clear
              </button>
            )}
          </div>
        )}
        {dateFrom && (
          <span style={{ fontSize:"12px", color:"var(--warm-gold)", fontWeight:600 }}>
            {dateFrom === dateTo ? `Showing: ${dateFrom}` : `${dateFrom} → ${dateTo}`}
          </span>
        )}
      </div>

      {/* ══════ CALLS TAB ══════ */}
      {activeTab === "calls" && (<>

      {/* ── Stat Cards ── */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:"14px", marginBottom:"22px" }}>
        {[
          { label:"Total Calls",   value:total,     color:"var(--stone-700)", bg:"var(--stone-200)" },
          { label:"Answered",      value:answered,  color:"var(--accent-green)", bg:"#e8f5e9" },
          { label:"Missed",        value:missed,    color:"var(--accent-red)",   bg:"#ffe3e3" },
          { label:"Voicemail",     value:voicemail, color:"var(--accent-amber)", bg:"#fff3bf" },
          { label:"Avg Duration",  value:avgDur,    color:"var(--accent-blue)",  bg:"#e3fafc" },
        ].map(s => (
          <div key={s.label} className="stat-card" style={{ display:"flex", alignItems:"center", gap:"14px" }}>
            <div style={{ width:38, height:38, borderRadius:9, background:s.bg, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              <Icon name="calls" size={18} color={s.color} />
            </div>
            <div>
              <div className="stat-value" style={{ fontSize:"24px", color:s.color }}>{s.value}</div>
              <div className="stat-label">{s.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* ── Source Breakdown ── */}
      {uniqueSources.length > 1 && (
        <div className="card" style={{ padding:"16px 20px", marginBottom:"22px" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"14px" }}>
            <div style={{ fontFamily:"var(--font-display)", fontSize:"16px", fontWeight:700 }}>Call Sources</div>
            <div style={{ fontSize:"12px", color:"var(--stone-400)" }}>{total} total calls</div>
          </div>
          <div style={{ display:"flex", gap:"10px", flexWrap:"wrap" }}>
            {uniqueSources.map(src => {
              const style = SOURCE_STYLE[src] || SOURCE_STYLE.Unknown;
              const count = sourceCounts[src];
              const pct = total > 0 ? Math.round((count / total) * 100) : 0;
              return (
                <div key={src} onClick={() => setSourceFilter(sourceFilter === src ? "All" : src)}
                  style={{ flex:"1 1 120px", minWidth:120, padding:"12px 14px", borderRadius:"var(--radius)", border: sourceFilter === src ? `2px solid ${style.color}` : "1px solid var(--stone-200)", background: sourceFilter === src ? style.bg : "var(--stone-50)", cursor:"pointer", transition:"all 0.15s" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:"6px", marginBottom:"6px" }}>
                    <span style={{ fontSize:"16px" }}>{style.icon}</span>
                    <span style={{ fontSize:"12px", fontWeight:700, color:style.color }}>{src}</span>
                  </div>
                  <div style={{ fontFamily:"var(--font-display)", fontSize:"22px", fontWeight:700, color:"var(--stone-900)" }}>{count}</div>
                  <div style={{ height:4, background:"var(--stone-200)", borderRadius:2, marginTop:"6px", overflow:"hidden" }}>
                    <div style={{ height:"100%", width:`${pct}%`, background:style.color, borderRadius:2 }}/>
                  </div>
                  <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:"4px" }}>{pct}% of calls</div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── Filters ── */}
      <div style={{ display:"flex", gap:"10px", marginBottom:"18px", flexWrap:"wrap", alignItems:"center" }}>
        <div style={{ position:"relative", flex:1, minWidth:"200px" }}>
          <span style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)" }}><Icon name="search" size={14} color="var(--stone-400)"/></span>
          <input style={{ paddingLeft:"34px" }} placeholder="Search by name, number, notes…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <div style={{ display:"flex", background:"var(--stone-200)", borderRadius:"var(--radius)", padding:"3px", gap:"2px" }}>
          {["All","Inbound","Outbound"].map(d => (
            <button key={d} className="btn btn-sm" style={{ background: dirFilter===d?"var(--stone-50)":"transparent", color: dirFilter===d?"var(--stone-900)":"var(--stone-500)", boxShadow: dirFilter===d?"var(--shadow-sm)":"none", border:"none" }} onClick={() => setDirFilter(d === "Inbound" ? "inbound" : d === "Outbound" ? "outbound" : "All")}>{d}</button>
          ))}
        </div>
        <div style={{ display:"flex", gap:"6px", flexWrap:"wrap" }}>
          {["All","Answered","Missed","Voicemail"].map(o => (
            <button key={o} className="btn btn-sm" style={{ background: filter===o?"var(--warm-gold)":"var(--stone-200)", color: filter===o?"white":"var(--stone-700)" }} onClick={() => setFilter(o)}>{o}</button>
          ))}
        </div>
      </div>

      {/* ── Call Log Table ── */}
      <div className="card" style={{ padding:0 }}>
        <table>
          <thead>
            <tr>
              <th>Direction</th>
              <th>Contact</th>
              <th>Phone</th>
              <th>Source</th>
              <th>Date &amp; Time</th>
              <th>Duration</th>
              <th>Outcome</th>
              <th>Linked To</th>
              <th>Notes</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={10} style={{ textAlign:"center", padding:"40px", color:"var(--stone-400)" }}>No calls found</td></tr>
            ) : filtered.map(c => {
              const dir  = DIR_ICON[c.direction] || DIR_ICON.inbound;
              const out  = OUTCOME_STYLE[c.outcome] || OUTCOME_STYLE.Answered;
              const linked = c.linkedLead
                ? leads.find(l => l.id === c.linkedLead)
                : c.linkedCustomer
                  ? customers.find(cu => cu.id === c.linkedCustomer)
                  : null;
              return (
                <tr key={c.id}>
                  {/* Direction */}
                  <td>
                    <div style={{ display:"flex", alignItems:"center", gap:"6px" }}>
                      <div style={{ width:28, height:28, borderRadius:7, background: c.direction==="inbound"?"rgba(122,158,126,0.15)":"rgba(107,140,174,0.15)", display:"flex", alignItems:"center", justifyContent:"center" }}>
                        <Icon name={dir.icon} size={13} color={dir.color} />
                      </div>
                      <span style={{ fontSize:"12px", color:dir.color, fontWeight:600 }}>{dir.label}</span>
                    </div>
                  </td>
                  {/* Contact */}
                  <td>
                    <div style={{ fontWeight:500 }}>{c.contact}</div>
                  </td>
                  {/* Phone */}
                  <td style={{ fontFamily:"monospace", fontSize:"13px", color:"var(--stone-600)" }}>{c.phone}</td>
                  {/* Source */}
                  <td>
                    {(() => {
                      const src = c.source || "Direct";
                      const s = SOURCE_STYLE[src] || SOURCE_STYLE.Unknown;
                      return (
                        <span style={{ display:"inline-flex", alignItems:"center", gap:"4px", background:s.bg, color:s.color, fontSize:"11px", fontWeight:700, padding:"3px 10px", borderRadius:99 }}>
                          <span style={{ fontSize:"12px" }}>{s.icon}</span> {src}
                        </span>
                      );
                    })()}
                  </td>
                  {/* Date & Time */}
                  <td>
                    <div style={{ fontSize:"13px" }}>{c.date}</div>
                    <div style={{ fontSize:"11px", color:"var(--stone-400)" }}>{c.time}</div>
                  </td>
                  {/* Duration */}
                  <td>
                    <div style={{ display:"flex", alignItems:"center", gap:"5px", fontSize:"13px" }}>
                      <Icon name="clock" size={12} color="var(--stone-400)" />
                      <span style={{ fontWeight: c.duration !== "0:00" ? 500 : 400, color: c.duration !== "0:00" ? "var(--stone-800)" : "var(--stone-400)" }}>{c.duration || "—"}</span>
                    </div>
                  </td>
                  {/* Outcome */}
                  <td>
                    <span style={{ background:out.bg, color:out.color, fontSize:"11px", fontWeight:700, padding:"3px 10px", borderRadius:99 }}>{c.outcome}</span>
                  </td>
                  {/* Linked */}
                  <td>
                    {linked ? (
                      <span style={{ fontSize:"12px", background:"var(--stone-100)", padding:"3px 8px", borderRadius:99, color:"var(--stone-600)", display:"flex", alignItems:"center", gap:"4px", width:"fit-content" }}>
                        <Icon name={c.linkedLead ? "leads" : "customers"} size={11} />
                        {linked.name}
                      </span>
                    ) : <span style={{ color:"var(--stone-300)", fontSize:"12px" }}>—</span>}
                  </td>
                  {/* Notes */}
                  <td style={{ maxWidth:"200px" }}>
                    <div style={{ fontSize:"12px", color:"var(--stone-600)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{c.notes || "—"}</div>
                  </td>
                  {/* Actions */}
                  <td>
                    <div style={{ display:"flex", gap:"4px", alignItems:"center" }}>
                      {c.phone && (
                        <button className="btn-icon" onClick={() => handleCallClick(c.phone)} title="Call back">
                          <Icon name="phone_out" size={14} color="var(--accent-green)"/>
                        </button>
                      )}
                      {c.phone && (
                        <button className="btn-icon" onClick={() => openNewSmsFor(c.phone, c.contact)} title="Send SMS">
                          <Icon name="mail" size={14} color="var(--accent-blue)"/>
                        </button>
                      )}
                      <button className="btn-icon" onClick={() => { setForm({ ...c }); setModal(c); }}><Icon name="edit" size={14}/></button>
                      <button className="btn-icon" onClick={() => requestDelete("calls", c)}><Icon name="trash" size={14} color="var(--accent-red)"/></button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      </>)}

      {/* ══════ SMS TAB ══════ */}
      {activeTab === "sms" && (
        <div style={{ display:"grid", gridTemplateColumns: smsConvo && !isMobile ? "280px 1fr" : "1fr", gap:"16px", minHeight:400 }}>
          {/* Thread list */}
          <div className="card" style={{ padding:0, overflow:"hidden", display: isMobile && smsConvo ? "none" : "block" }}>
            <div style={{ padding:"12px 14px", borderBottom:"1px solid var(--stone-200)" }}>
              <div style={{ fontSize:"13px", fontWeight:700, marginBottom:8 }}>Conversations</div>
              <div style={{ display:"flex", gap:6 }}>
                <div style={{ position:"relative", flex:1 }}>
                  <span style={{ position:"absolute", left:9, top:"50%", transform:"translateY(-50%)" }}><Icon name="search" size={13} color="var(--stone-400)"/></span>
                  <input value={smsSearch} onChange={e => { setSmsSearch(e.target.value); if (!e.target.value) setSmsResults(null); }}
                    onKeyDown={e => { if (e.key === "Enter") runSmsSearch(); if (e.key === "Escape") clearSmsSearch(); }}
                    placeholder="Search all texts — words, name, number"
                    style={{ paddingLeft:28, fontSize:12, padding:"7px 10px 7px 28px" }} />
                </div>
                <button className="btn btn-sm btn-primary" onClick={runSmsSearch} disabled={smsSearching || smsSearch.trim().length < 2}>
                  {smsSearching ? "…" : "Search"}
                </button>
              </div>
            </div>
            {smsResults !== null ? (
              <div>
                <div style={{ padding:"8px 14px", fontSize:11, color:"var(--stone-500)", display:"flex", justifyContent:"space-between", alignItems:"center", background:"var(--stone-50)", borderBottom:"1px solid var(--stone-100)" }}>
                  <span>{smsResults.length === 0 ? "No matches" : `${smsResults.length}${smsResults.length === 100 ? "+" : ""} match${smsResults.length === 1 ? "" : "es"} · all dates`}</span>
                  <button onClick={clearSmsSearch} style={{ background:"none", border:"none", color:"var(--warm-gold)", cursor:"pointer", fontSize:11, fontWeight:600 }}>Clear</button>
                </div>
                {smsResults.map(m => (
                  <div key={m.id} onClick={() => openSearchResult(m)}
                    style={{ padding:"10px 14px", borderBottom:"1px solid var(--stone-100)", cursor:"pointer" }}
                    onMouseEnter={e => e.currentTarget.style.background="var(--stone-50)"}
                    onMouseLeave={e => e.currentTarget.style.background="white"}>
                    <div style={{ display:"flex", justifyContent:"space-between", gap:8, marginBottom:2 }}>
                      <span style={{ fontWeight:600, fontSize:12 }}>{m.contact_name || m.phone}</span>
                      <span style={{ fontSize:10, color:"var(--stone-400)", whiteSpace:"nowrap" }}>{m.created_at ? new Date(m.created_at).toLocaleDateString("en-US", { month:"short", day:"numeric", year:"numeric" }) : ""}</span>
                    </div>
                    <div style={{ fontSize:12, color:"var(--stone-500)", lineHeight:1.4 }}>
                      {m.direction === "outbound" && <span style={{ color:"var(--stone-300)" }}>You: </span>}
                      {highlight(m.body, smsSearch)}
                    </div>
                  </div>
                ))}
              </div>
            ) : threadList.length === 0 ? (
              <div style={{ padding:"40px 20px", textAlign:"center", color:"var(--stone-400)", fontSize:13 }}>
                <div style={{ fontSize:32, marginBottom:8 }}>💬</div>
                No messages yet. Incoming SMS will appear here.
              </div>
            ) : threadList.map(t => {
              const key = t.phone?.replace(/\D/g, '').slice(-10) || 'unknown';
              const lastMsg = t.messages[0];
              const isActive = smsConvo === key;
              return (
                <div key={key} onClick={() => { setSmsConvo(key); markThreadRead(messages, key); setMessages(p => p.map(m => m.phone?.replace(/\D/g, '').slice(-10) === key ? {...m, read:true} : m)); }}
                  style={{ padding:"12px 16px", borderBottom:"1px solid var(--stone-100)", cursor:"pointer", background: isActive ? "rgba(201,169,110,0.08)" : t.unread ? "rgba(107,140,174,0.05)" : "white", display:"flex", gap:10, alignItems:"flex-start", transition:"background 0.1s" }}
                  onMouseEnter={e => { if (!isActive) e.currentTarget.style.background="var(--stone-50)"; }}
                  onMouseLeave={e => { if (!isActive) e.currentTarget.style.background= t.unread ? "rgba(107,140,174,0.05)" : "white"; }}>
                  <div className="avatar" style={{ width:36, height:36, fontSize:12, flexShrink:0 }}>{(t.name || "?").slice(0,2).toUpperCase()}</div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", marginBottom:2 }}>
                      <span style={{ fontWeight: t.unread ? 700 : 500, fontSize:13 }}>{t.name || t.phone}</span>
                      {t.unread > 0 && <span style={{ background:"var(--accent-blue)", color:"white", fontSize:9, fontWeight:800, borderRadius:99, padding:"1px 6px", minWidth:16, textAlign:"center" }}>{t.unread}</span>}
                    </div>
                    <div style={{ fontSize:12, color:"var(--stone-400)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                      {lastMsg?.direction === "outbound" && <span style={{ color:"var(--stone-300)" }}>You: </span>}
                      {(lastMsg?.media_urls?.length || lastMsg?.media_url) && <span>📷 </span>}
                      {lastMsg?.body?.slice(0,50) || (lastMsg?.media_urls?.length || lastMsg?.media_url ? "Photo" : "...")}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Conversation view */}
          {smsConvo && (() => {
            const thread = threadList.find(t => t.phone?.replace(/\D/g, '').slice(-10) === smsConvo);
            if (!thread) return null;
            const sorted = [...thread.messages].sort((a,b) => (a.created_at||'').localeCompare(b.created_at||''));
            return (
              <div className="card" style={{ padding:0, display:"flex", flexDirection:"column", overflow:"hidden" }}>
                {/* Convo header */}
                <div style={{ padding:"14px 18px", borderBottom:"1px solid var(--stone-200)", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <div>
                    <div style={{ fontWeight:700, fontSize:14 }}>{thread.name || thread.phone}</div>
                    <div style={{ fontSize:12, color:"var(--stone-400)", fontFamily:"monospace" }}>{thread.phone}</div>
                  </div>
                  <button className="btn-icon" onClick={() => setSmsConvo(null)} style={isMobile ? { display:"flex", alignItems:"center", gap:4, background:"var(--stone-100)", borderRadius:8, padding:"6px 10px" } : {}}>
                    {isMobile ? <span style={{ fontSize:13, fontWeight:600 }}>← Back</span> : <Icon name="x" size={16}/>}
                  </button>
                </div>
                {/* Messages */}
                <div style={{ flex:1, overflowY:"auto", padding:"16px 18px", display:"flex", flexDirection:"column", gap:8, minHeight:250, maxHeight:400 }}>
                  {sorted.map(m => (
                    <div key={m.id} style={{ display:"flex", justifyContent: m.direction === "outbound" ? "flex-end" : "flex-start" }}>
                      <div style={{
                        maxWidth:"75%", padding:"10px 14px", borderRadius: m.direction === "outbound" ? "14px 14px 4px 14px" : "14px 14px 14px 4px",
                        background: m.direction === "outbound" ? "var(--warm-gold)" : "var(--stone-100)",
                        color: m.direction === "outbound" ? "white" : "var(--stone-900)", fontSize:13, lineHeight:1.5
                      }}>
                        {/* MMS images */}
                        {(() => {
                          const urls = m.media_urls || (m.media_url ? [m.media_url] : []);
                          return urls.length > 0 && (
                            <div style={{ display:"flex", flexDirection:"column", gap:4, marginBottom: m.body ? 6 : 0 }}>
                              {urls.map((url, i) => (
                                <img key={i} src={url.startsWith('https://api.twilio.com/') ? `/api/twilio/media?url=${encodeURIComponent(url)}` : url}
                                  alt="MMS" onClick={() => window.open(url.startsWith('https://api.twilio.com/') ? `/api/twilio/media?url=${encodeURIComponent(url)}` : url, '_blank')}
                                  style={{ maxWidth:"100%", maxHeight:240, borderRadius:8, cursor:"pointer", objectFit:"cover" }}
                                  onError={e => { e.target.style.display='none'; }} />
                              ))}
                            </div>
                          );
                        })()}
                        {m.body}
                        <div style={{ fontSize:10, marginTop:4, opacity:0.6, textAlign:"right" }}>
                          {m.created_at ? new Date(m.created_at).toLocaleDateString('en-US', { month:'short', day:'numeric' }) + ', ' + new Date(m.created_at).toLocaleTimeString('en-US', { hour:'numeric', minute:'2-digit', hour12:true }) : ''}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {/* Photo preview strip */}
                {smsMedia.length > 0 && (
                  <div style={{ padding:"8px 16px 0", borderTop:"1px solid var(--stone-200)", display:"flex", gap:8, flexWrap:"wrap" }}>
                    {smsMedia.map((item, i) => (
                      <div key={i} style={{ position:"relative", width:56, height:56 }}>
                        <img src={item.preview} alt="" style={{ width:56, height:56, borderRadius:8, objectFit:"cover", border:"1.5px solid var(--stone-300)" }} />
                        <button onClick={() => setSmsMedia(p => p.filter((_, j) => j !== i))}
                          style={{ position:"absolute", top:-6, right:-6, width:18, height:18, borderRadius:"50%", background:"var(--stone-700)", color:"white", border:"none", cursor:"pointer", fontSize:11, lineHeight:1, display:"flex", alignItems:"center", justifyContent:"center" }}>×</button>
                      </div>
                    ))}
                    {smsMediaUploading && <div style={{ fontSize:11, color:"var(--stone-400)", alignSelf:"center" }}>Uploading…</div>}
                  </div>
                )}
                {/* Compose */}
                <div style={{ padding:"12px 16px", borderTop: smsMedia.length > 0 ? "none" : "1px solid var(--stone-200)", display:"flex", gap:8, alignItems:"center" }}>
                  <input type="file" ref={smsFileRef} accept="image/*" multiple style={{ display:"none" }} onChange={handleSmsPhoto} />
                  <button onClick={() => smsFileRef.current?.click()} title="Attach Photo"
                    style={{ width:36, height:36, borderRadius:"50%", background:"var(--stone-100)", border:"none", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, transition:"background 0.15s" }}
                    onMouseEnter={e => e.currentTarget.style.background="var(--stone-200)"} onMouseLeave={e => e.currentTarget.style.background="var(--stone-100)"}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--stone-500)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                  </button>
                  <input value={smsText} onChange={e => setSmsText(e.target.value)} placeholder="Type a message…"
                    style={{ flex:1, padding:"10px 14px", border:"1.5px solid var(--stone-300)", borderRadius:20, fontSize:13 }}
                    onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendSms(); } }} />
                  <button onClick={sendSms} disabled={(!smsText.trim() && smsMedia.length === 0) || smsSending}
                    style={{ width:40, height:40, borderRadius:"50%", background: (smsText.trim() || smsMedia.length > 0) ? "var(--warm-gold)" : "var(--stone-200)", border:"none", cursor: (smsText.trim() || smsMedia.length > 0) ? "pointer" : "default", display:"flex", alignItems:"center", justifyContent:"center", transition:"all 0.15s", flexShrink:0 }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={(smsText.trim() || smsMedia.length > 0)?"white":"var(--stone-400)"} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                  </button>
                </div>
              </div>
            );
          })()}

          {!smsConvo && threadList.length > 0 && (
            <div style={{ display:"flex", alignItems:"center", justifyContent:"center", color:"var(--stone-400)", fontSize:14 }}>
              ← Select a conversation
            </div>
          )}
        </div>
      )}

      {/* ══════ VOICEMAILS TAB ══════ */}
      {activeTab === "voicemails" && (
        <div>
          {voicemails.length === 0 ? (
            <div className="empty-state">
              <div style={{ fontSize:48, marginBottom:12 }}>🎙</div>
              <div style={{ fontSize:14, color:"var(--stone-400)" }}>No voicemails yet</div>
              <div style={{ fontSize:12, color:"var(--stone-300)", marginTop:4 }}>Missed calls that go to voicemail will appear here with transcriptions.</div>
            </div>
          ) : (
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {voicemails.sort((a,b) => (b.date||'').localeCompare(a.date||'')).map(vm => (
                <div key={vm.id} className="card" style={{ padding:"16px 20px" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:10, flexWrap:"wrap", gap:8 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                      <div style={{ width:40, height:40, borderRadius:"50%", background:"rgba(196,149,74,0.12)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:18 }}>🎙</div>
                      <div>
                        <div style={{ fontWeight:600, fontSize:14 }}>{vm.contact || "Unknown"}</div>
                        <div style={{ fontSize:12, color:"var(--stone-400)", fontFamily:"monospace" }}>{vm.phone || "—"}</div>
                      </div>
                    </div>
                    <div style={{ textAlign:"right" }}>
                      <div style={{ fontSize:12, color:"var(--stone-500)" }}>{vm.date}</div>
                      <div style={{ fontSize:11, color:"var(--stone-400)" }}>{vm.time}</div>
                    </div>
                  </div>
                  {/* Transcription */}
                  {(vm.transcription || vm.notes) && (
                    <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius)", padding:"12px 16px", marginBottom:10, borderLeft:"3px solid var(--warm-gold)" }}>
                      <div style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--stone-400)", marginBottom:4 }}>Transcription</div>
                      <div style={{ fontSize:13, color:"var(--stone-700)", lineHeight:1.6, fontStyle:"italic" }}>"{vm.transcription || vm.notes}"</div>
                    </div>
                  )}
                  {/* Audio player */}
                  {vm.recording_url && (
                    <div>
                      <audio controls preload="none" style={{ width:"100%", height:36, borderRadius:8 }}>
                        <source src={`/api/twilio/recording?url=${encodeURIComponent(vm.recording_url)}`} type="audio/mpeg" />
                      </audio>
                    </div>
                  )}
                  {!vm.recording_url && !vm.transcription && !vm.notes && (
                    <div style={{ fontSize:12, color:"var(--stone-400)", fontStyle:"italic" }}>Voicemail recorded — transcription pending…</div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* ── Add / Edit Call Modal ── */}
      {modal && (
        <Modal title={modal === "add" ? "Log New Call" : "Edit Call"} onClose={() => setModal(null)}>
          <div className="form-grid">
            <div className="form-group"><label>Contact Name</label><input placeholder="e.g. Sandra Kim" value={form.contact} onChange={e => setForm(p => ({...p,contact:e.target.value}))} /></div>
            <div className="form-group"><label>Phone Number</label><input placeholder="(757) 555-0000" value={form.phone} onChange={e => setForm(p => ({...p,phone:e.target.value}))} /></div>
            <div className="form-group">
              <label>Direction</label>
              <select value={form.direction} onChange={e => setForm(p => ({...p,direction:e.target.value}))}>
                <option value="inbound">Inbound (they called you)</option>
                <option value="outbound">Outbound (you called them)</option>
              </select>
            </div>
            <div className="form-group">
              <label>Outcome</label>
              <select value={form.outcome} onChange={e => setForm(p => ({...p,outcome:e.target.value}))}>
                {["Answered","Missed","Voicemail"].map(o => <option key={o}>{o}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Date</label><input type="date" value={form.date} onChange={e => setForm(p => ({...p,date:e.target.value}))} /></div>
            <div className="form-group"><label>Time</label><input placeholder="e.g. 10:30 AM" value={form.time} onChange={e => setForm(p => ({...p,time:e.target.value}))} /></div>
            <div className="form-group"><label>Duration (m:ss)</label><input placeholder="e.g. 4:32" value={form.duration} onChange={e => setForm(p => ({...p,duration:e.target.value}))} /></div>
            <div className="form-group">
              <label>Call Source</label>
              <select value={form.source || "Direct"} onChange={e => setForm(p => ({...p,source:e.target.value}))}>
                {["Direct","Google","Website","Facebook","Yelp","Referral","CRM","Unknown"].map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Link to Lead</label>
              <select value={form.linkedLead || ""} onChange={e => setForm(p => ({...p, linkedLead: e.target.value ? Number(e.target.value) : null, linkedCustomer: null}))}>
                <option value="">— None —</option>
                {leads.map(l => <option key={l.id} value={l.id}>{l.name} · {l.project}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Link to Customer</label>
              <select value={form.linkedCustomer || ""} onChange={e => setForm(p => ({...p, linkedCustomer: e.target.value ? Number(e.target.value) : null, linkedLead: null}))}>
                <option value="">— None —</option>
                {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
            <div className="form-group form-full"><label>Call Notes</label><textarea rows={3} placeholder="What was discussed?" value={form.notes} onChange={e => setForm(p => ({...p,notes:e.target.value}))} /></div>
          </div>
          <div style={{ display:"flex", justifyContent:"flex-end", gap:"8px" }}>
            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancel</button>
            <button className="btn btn-primary" onClick={save}><Icon name="check" size={14}/> Save Call</button>
          </div>
        </Modal>
      )}

      {/* ── New SMS Compose Modal ── */}
      {newSmsModal && (
        <Modal title="New SMS" onClose={() => setNewSmsModal(false)}>
          <div className="form-grid">
            <div className="form-group form-full">
              <label>Pick from Contacts (optional)</label>
              <select
                value=""
                onChange={(e) => {
                  if (!e.target.value) return;
                  const [type, id] = e.target.value.split(":");
                  const list = type === "lead" ? leads : customers;
                  const c = list.find(x => String(x.id) === id);
                  if (c) {
                    setNewSmsPhone(c.phone || "");
                    setNewSmsName(c.name || "");
                  }
                }}>
                <option value="">— Choose a lead or customer —</option>
                {leads.length > 0 && (
                  <optgroup label="Leads">
                    {leads.filter(l => l.phone).map(l => (
                      <option key={`lead-${l.id}`} value={`lead:${l.id}`}>{l.name} · {l.phone}</option>
                    ))}
                  </optgroup>
                )}
                {customers.length > 0 && (
                  <optgroup label="Customers">
                    {customers.filter(c => c.phone).map(c => (
                      <option key={`cust-${c.id}`} value={`cust:${c.id}`}>{c.name} · {c.phone}</option>
                    ))}
                  </optgroup>
                )}
              </select>
            </div>
            <div className="form-group">
              <label>Phone Number *</label>
              <input placeholder="(757) 555-0000" value={newSmsPhone} onChange={e => setNewSmsPhone(e.target.value)} />
            </div>
            <div className="form-group">
              <label>Recipient Name (optional)</label>
              <input placeholder="e.g. John Doe" value={newSmsName} onChange={e => setNewSmsName(e.target.value)} />
            </div>
            <div className="form-group form-full">
              <label>Message *</label>
              <textarea
                rows={5}
                placeholder="Type your message…"
                value={newSmsBody}
                onChange={e => setNewSmsBody(e.target.value)}
                onKeyDown={e => { if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) { e.preventDefault(); sendNewSms(); } }}
              />
              <div style={{ fontSize:11, color:"var(--stone-400)", marginTop:4, textAlign:"right" }}>
                {newSmsBody.length} chars · {Math.max(1, Math.ceil(newSmsBody.length / 160))} segment{newSmsBody.length > 160 ? "s" : ""}
              </div>
            </div>
          </div>
          <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius)", padding:"10px 14px", marginBottom:14, fontSize:11, color:"var(--stone-500)", lineHeight:1.5 }}>
            ℹ️ Sent from your business line. Reply STOP to opt out. Msg & data rates may apply.
          </div>
          <div style={{ display:"flex", justifyContent:"flex-end", gap:"8px" }}>
            <button className="btn btn-secondary" onClick={() => setNewSmsModal(false)} disabled={newSmsSending}>Cancel</button>
            <button
              className="btn btn-primary"
              onClick={sendNewSms}
              disabled={newSmsSending || !newSmsBody.trim() || (newSmsPhone || "").replace(/\D/g, "").length < 10}
            >
              <Icon name={newSmsSending ? "clock" : "mail"} size={14}/> {newSmsSending ? "Sending…" : "Send SMS"}
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
};

// ── SOFTPHONE ─────────────────────────────────────────────────────────────────
const Softphone = ({ calls, setCalls, currentUser }) => {
  const [device, setDevice] = useState(null);
  const [status, setStatus] = useState("offline"); // offline | ready | connecting | ringing | on-call
  const [expanded, setExpanded] = useState(false);
  const [dialNumber, setDialNumber] = useState("");
  const [activeCall, setActiveCall] = useState(null);
  const [incoming, setIncoming] = useState(null);
  const [callQueue, setCallQueue] = useState([]); // 🔁 queued calls when already ringing/on-call
  const [muted, setMuted] = useState(false);
  const [callTimer, setCallTimer] = useState(0);
  const [callerName, setCallerName] = useState("");
  const [error, setError] = useState(null);
  const timerRef = useRef(null);
  const deviceRef = useRef(null);
  const mountedRef = useRef(true);
  const reinitLockRef = useRef(false); // prevent overlapping reinit attempts
  const statusRef = useRef("offline");
  // Keep statusRef in sync so incoming handler reads current value
  useEffect(() => { statusRef.current = status; }, [status]);

  // ── Fetch a fresh token ──
  const fetchToken = async () => {
    const res = await fetch('/api/twilio/token');
    if (!res.ok) throw new Error(`Token fetch failed: ${res.status}`);
    const data = await res.json();
    if (!data.token) throw new Error("No token returned");
    return data.token;
  };

  // ── Full device reinitialize (used for error recovery) ──
  const reinitDevice = async () => {
    if (reinitLockRef.current) return;
    reinitLockRef.current = true;
    console.log("[softphone] 🔄 Reinitializing device…");
    try {
      if (deviceRef.current) { try { deviceRef.current.destroy(); } catch(e) {} }
      deviceRef.current = null;
      if (mountedRef.current) { setDevice(null); setStatus("offline"); }

      const token = await fetchToken();
      const dev = new Device(token, {
        codecPreferences: ["opus", "pcmu"],
        enableRingingState: true,
        logLevel: 1,
      });

      dev.on("registered", () => { if (mountedRef.current) { setStatus("ready"); setError(null); } console.log("[softphone] ✅ Re-registered"); });
      dev.on("unregistered", () => { if (mountedRef.current) setStatus("offline"); });
      dev.on("tokenWillExpire", async () => {
        console.log("[softphone] ⏰ Token expiring soon — refreshing");
        try {
          const t = await fetchToken();
          if (deviceRef.current) { deviceRef.current.updateToken(t); console.log("[softphone] ✅ Token refreshed (tokenWillExpire)"); }
        } catch (e) { console.error("[softphone] Token refresh failed:", e.message); }
      });
      dev.on("error", (err) => {
        console.error("[softphone] Device error:", err.code, err.message);
        if (mountedRef.current) setError(err.message);
        // 20104 = AccessTokenExpired — full reinit needed
        if (err.code === 20104 || (err.message && err.message.includes("AccessTokenExpired"))) {
          console.log("[softphone] 🔄 Token expired — triggering reinit");
          reinitLockRef.current = false;
          reinitDevice();
        }
      });

      // ── Incoming call (with queue support) ──
      dev.on("incoming", (call) => {
        const caller = call.parameters.From || "Unknown";
        console.log("[softphone] 📞 Incoming call from:", caller);
        if (mountedRef.current) {
          const curStatus = statusRef.current;
          // If already ringing or on a call, queue this one
          if (curStatus === "ringing" || curStatus === "on-call" || curStatus === "connecting") {
            console.log("[softphone] 📋 Queuing second incoming call from:", caller);
            setCallQueue(q => [...q, { call, from: caller, time: Date.now() }]);
          } else {
            setIncoming(call);
            setCallerName(caller);
            setStatus("ringing");
          }
          setExpanded(true);
        }
        call.on("cancel", () => {
          if (mountedRef.current) {
            // Remove from queue if it was queued
            setCallQueue(q => q.filter(qc => qc.call !== call));
            setIncoming(prev => {
              if (prev === call) {
                // Primary incoming was cancelled — promote from queue if available
                setCallQueue(q => {
                  if (q.length > 0) {
                    const next = q[0];
                    setIncoming(next.call);
                    setCallerName(next.from);
                    setStatus("ringing");
                    return q.slice(1);
                  }
                  setStatus(prev2 => activeCall ? prev2 : "ready");
                  return q;
                });
                return null;
              }
              return prev;
            });
          }
        });
        call.on("disconnect", () => {
          if (mountedRef.current) {
            setCallQueue(q => q.filter(qc => qc.call !== call));
            // Check if this was the active or incoming call
            setActiveCall(prev => {
              if (prev === call) {
                setMuted(false); stopTimer();
                // Promote next queued call
                setCallQueue(q => {
                  if (q.length > 0) {
                    const next = q[0];
                    setIncoming(next.call);
                    setCallerName(next.from);
                    setStatus("ringing");
                    return q.slice(1);
                  }
                  setStatus("ready");
                  return q;
                });
                return null;
              }
              return prev;
            });
            setIncoming(prev => {
              if (prev === call) return null;
              return prev;
            });
          }
        });
      });

      await dev.register();
      if (mountedRef.current) { setDevice(dev); deviceRef.current = dev; }
    } catch (err) {
      console.error("[softphone] Reinit failed:", err.message);
      if (mountedRef.current) setError(err.message);
    } finally {
      reinitLockRef.current = false;
    }
  };

  // ── Initialize Twilio Device ──
  useEffect(() => {
    mountedRef.current = true;
    reinitDevice();

    // Refresh token every 45 minutes as a safety net
    const refreshInterval = setInterval(async () => {
      try {
        const t = await fetchToken();
        if (deviceRef.current) { deviceRef.current.updateToken(t); console.log("[softphone] ✅ Token refreshed (interval)"); }
      } catch (e) { console.log("[softphone] Token refresh failed:", e.message); }
    }, 45 * 60 * 1000);

    // 🔑 Visibility change — refresh token when tab/app comes back to foreground
    const handleVisibility = async () => {
      if (document.visibilityState === "visible" && deviceRef.current) {
        console.log("[softphone] 👁️ Tab visible — checking token");
        try {
          const t = await fetchToken();
          deviceRef.current.updateToken(t);
          console.log("[softphone] ✅ Token refreshed (visibility)");
          if (mountedRef.current) setError(null);
        } catch (e) {
          console.log("[softphone] Visibility refresh failed — reinitializing");
          reinitDevice();
        }
      } else if (document.visibilityState === "visible" && !deviceRef.current) {
        console.log("[softphone] 👁️ Tab visible but no device — reinitializing");
        reinitDevice();
      }
    };
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      mountedRef.current = false;
      clearInterval(refreshInterval);
      document.removeEventListener("visibilitychange", handleVisibility);
      if (deviceRef.current) { try { deviceRef.current.destroy(); } catch(e) {} }
    };
  }, []); // eslint-disable-line

  // ── Timer ──
  const startTimer = () => { setCallTimer(0); timerRef.current = setInterval(() => setCallTimer(t => t + 1), 1000); };
  const stopTimer = () => { if (timerRef.current) clearInterval(timerRef.current); timerRef.current = null; };
  const fmtTime = (s) => `${Math.floor(s/60)}:${String(s%60).padStart(2,"0")}`;

  // ── Make outbound call ──
  const makeCall = async (number) => {
    if (!device || !number) return;
    const cleaned = number.replace(/\D/g, "");
    const formatted = cleaned.length === 10 ? `+1${cleaned}` : cleaned.length === 11 ? `+${cleaned}` : `+${cleaned}`;
    try {
      setStatus("connecting");
      setCallerName(number);
      setExpanded(true);
      const call = await device.connect({ params: { To: formatted } });
      setActiveCall(call);
      call.on("accept", () => { setStatus("on-call"); startTimer(); });
      call.on("disconnect", () => { setActiveCall(null); setStatus("ready"); setMuted(false); stopTimer(); logCall(number, "outbound", callTimer); });
      call.on("error", (err) => { setError(err.message); setStatus("ready"); });
    } catch (err) { setError(err.message); setStatus("ready"); }
  };

  // ── Expose makeCall globally so other components (e.g. Call Tracking "Call" buttons) can trigger outbound calls ──
  const makeCallRef = useRef(null);
  makeCallRef.current = makeCall;
  useEffect(() => {
    window.__ttpMakeCall = (num) => {
      if (typeof makeCallRef.current === "function") makeCallRef.current(num);
    };
    return () => { if (window.__ttpMakeCall) delete window.__ttpMakeCall; };
  }, []);

  // ── Answer incoming ──
  const answerCall = () => {
    if (incoming) {
      incoming.accept();
      setActiveCall(incoming);
      setIncoming(null);
      setStatus("on-call");
      startTimer();
    }
  };

  // ── Reject incoming ──
  const rejectCall = () => {
    if (incoming) {
      incoming.reject();
      setIncoming(null);
      // Promote next queued call
      setCallQueue(q => {
        if (q.length > 0) {
          const next = q[0];
          setIncoming(next.call);
          setCallerName(next.from);
          setStatus("ringing");
          return q.slice(1);
        }
        if (!activeCall) setStatus("ready");
        return q;
      });
    }
  };

  // ── Hang up ──
  const hangUp = () => {
    if (activeCall) {
      const dur = callTimer;
      const name = callerName;
      const dir = incoming ? "inbound" : "outbound";
      activeCall.disconnect();
      setActiveCall(null); setIncoming(null); setMuted(false); stopTimer();
      logCall(name, dir, dur);
      // Promote next queued call
      setCallQueue(q => {
        if (q.length > 0) {
          const next = q[0];
          setIncoming(next.call);
          setCallerName(next.from);
          setStatus("ringing");
          return q.slice(1);
        }
        setStatus("ready");
        return q;
      });
    }
  };

  // ── Answer a queued call (switch to it) ──
  const answerQueued = (queuedItem) => {
    // Reject or hold current incoming if any
    if (incoming && !activeCall) { incoming.reject(); }
    if (activeCall) { activeCall.disconnect(); setMuted(false); stopTimer(); }
    setCallQueue(q => q.filter(qc => qc !== queuedItem));
    queuedItem.call.accept();
    setActiveCall(queuedItem.call);
    setIncoming(null);
    setCallerName(queuedItem.from);
    setStatus("on-call");
    startTimer();
  };

  // ── Reject a queued call ──
  const rejectQueued = (queuedItem) => {
    queuedItem.call.reject();
    setCallQueue(q => q.filter(qc => qc !== queuedItem));
  };

  // ── Toggle mute ──
  const toggleMute = () => {
    if (activeCall) { activeCall.mute(!muted); setMuted(!muted); }
  };

  // ── Log call to CRM ──
  const logCall = (contact, direction, duration) => {
    if (duration < 2 && direction === "outbound") return; // Skip very short outbound
    const now = new Date();
    setCalls(p => [...p, {
      id: Date.now(), contact: contact || "Unknown", phone: contact || "",
      direction, outcome: duration > 0 ? "Answered" : "Missed",
      duration: fmtTime(duration),
      date: now.toISOString().slice(0, 10),
      time: now.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true }),
      notes: "Via CRM Softphone", linkedLead: null, linkedCustomer: null,
    }]);
  };

  // ── Dial pad ──
  const dialPad = ["1","2","3","4","5","6","7","8","9","*","0","#"];
  const pressKey = (k) => {
    setDialNumber(p => p + k);
    if (activeCall) activeCall.sendDigits(k); // DTMF during call
  };

  const statusColor = { offline:"var(--stone-400)", ready:"var(--accent-green)", connecting:"var(--accent-amber)", ringing:"var(--accent-blue)", "on-call":"var(--accent-green)" };
  const statusLabel = { offline:"Offline", ready:"Ready", connecting:"Connecting…", ringing:"Incoming Call", "on-call":"On Call" };

  // ── Floating pill (minimized) ──
  if (!expanded) {
    return (
      <div onClick={() => setExpanded(true)} style={{
        position:"fixed", bottom:24, right:24, zIndex:2000,
        background: status === "ringing" ? "var(--accent-blue)" : "var(--stone-900)",
        color:"white", borderRadius:99, padding: status === "ringing" ? "12px 20px" : "10px 16px",
        display:"flex", alignItems:"center", gap:10, cursor:"pointer",
        boxShadow:"0 4px 20px rgba(0,0,0,0.3)",
        animation: status === "ringing" ? "pulse 1s ease infinite" : "none",
        transition:"all 0.25s"
      }}>
        <div style={{ width:10, height:10, borderRadius:"50%", background:statusColor[status], boxShadow: status==="ready" ? "0 0 8px var(--accent-green)" : "none" }}/>
        <Icon name="calls" size={16} color="white"/>
        {status === "ringing" && <span style={{ fontSize:13, fontWeight:600, animation:"pulse 1s ease infinite" }}>Incoming Call</span>}
        {status === "on-call" && <span style={{ fontSize:13, fontWeight:600 }}>{fmtTime(callTimer)}</span>}
        {status === "ready" && <span style={{ fontSize:12, color:"var(--stone-400)" }}>Phone</span>}
        {callQueue.length > 0 && <span style={{ background:"var(--accent-red)", color:"white", borderRadius:99, padding:"1px 7px", fontSize:11, fontWeight:700, marginLeft:2 }}>+{callQueue.length}</span>}
      </div>
    );
  }

  // ── Expanded softphone ──
  return (
    <div style={{
      position:"fixed", bottom:24, right:24, zIndex:2000,
      width:320, background:"var(--stone-900)", borderRadius:20,
      boxShadow:"0 12px 40px rgba(0,0,0,0.4)", overflow:"hidden",
      animation:"modalIn 0.25s ease", border:"1px solid var(--stone-700)"
    }}>
      {/* Header */}
      <div style={{ padding:"14px 18px", display:"flex", justifyContent:"space-between", alignItems:"center", borderBottom:"1px solid var(--stone-700)" }}>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          <div style={{ width:8, height:8, borderRadius:"50%", background:statusColor[status], boxShadow: status==="ready"||status==="on-call" ? `0 0 8px ${statusColor[status]}` : "none" }}/>
          <span style={{ fontSize:12, fontWeight:600, color:statusColor[status], textTransform:"uppercase", letterSpacing:"0.06em" }}>{statusLabel[status]}</span>
        </div>
        <button onClick={() => setExpanded(false)} style={{ background:"none", border:"none", color:"var(--stone-400)", cursor:"pointer", padding:4 }}>
          <Icon name="chevron_down" size={16}/>
        </button>
      </div>

      {/* ── Incoming Call Ring UI ── */}
      {status === "ringing" && (
        <div style={{ padding:"24px 18px", textAlign:"center" }}>
          <div style={{ width:64, height:64, borderRadius:"50%", background:"rgba(107,140,174,0.2)", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 14px", animation:"pulse 1.5s ease infinite" }}>
            <Icon name="calls" size={28} color="var(--accent-blue)"/>
          </div>
          <div style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, color:"white", marginBottom:4 }}>Incoming Call</div>
          <div style={{ fontSize:14, color:"var(--stone-300)", marginBottom:20 }}>{callerName}</div>
          <div style={{ display:"flex", gap:16, justifyContent:"center" }}>
            <button onClick={rejectCall} style={{ width:56, height:56, borderRadius:"50%", background:"var(--accent-red)", border:"none", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", transition:"transform 0.15s" }}
              onMouseEnter={e => e.currentTarget.style.transform="scale(1.1)"} onMouseLeave={e => e.currentTarget.style.transform="scale(1)"}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-5.4-5.4A19.79 19.79 0 0 1 2.72 5 2 2 0 0 1 4.5 3h3a2 2 0 0 1 2 1.72"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
            </button>
            <button onClick={answerCall} style={{ width:56, height:56, borderRadius:"50%", background:"var(--accent-green)", border:"none", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", animation:"pulse 1.5s ease infinite", transition:"transform 0.15s" }}
              onMouseEnter={e => e.currentTarget.style.transform="scale(1.1)"} onMouseLeave={e => e.currentTarget.style.transform="scale(1)"}>
              <Icon name="calls" size={24} color="white"/>
            </button>
          </div>
        </div>
      )}

      {/* ── Queued Calls Banner ── */}
      {callQueue.length > 0 && (
        <div style={{ borderTop:"1px solid var(--stone-700)", padding:"10px 18px" }}>
          <div style={{ fontSize:11, fontWeight:700, color:"var(--accent-amber)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:8 }}>
            📋 {callQueue.length} Call{callQueue.length > 1 ? "s" : ""} Waiting
          </div>
          {callQueue.map((qc, i) => (
            <div key={qc.time} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"6px 0", borderTop: i > 0 ? "1px solid var(--stone-800)" : "none" }}>
              <div style={{ fontSize:13, color:"var(--stone-300)" }}>{qc.from}</div>
              <div style={{ display:"flex", gap:6 }}>
                <button onClick={() => answerQueued(qc)} style={{ padding:"4px 10px", fontSize:11, fontWeight:700, background:"var(--accent-green)", color:"white", border:"none", borderRadius:6, cursor:"pointer" }}>Answer</button>
                <button onClick={() => rejectQueued(qc)} style={{ padding:"4px 8px", fontSize:11, fontWeight:700, background:"rgba(255,255,255,0.06)", color:"var(--stone-400)", border:"1px solid var(--stone-700)", borderRadius:6, cursor:"pointer" }}>✕</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ── Active Call UI ── */}
      {status === "on-call" && (
        <div style={{ padding:"24px 18px", textAlign:"center" }}>
          <div style={{ width:56, height:56, borderRadius:"50%", background:"rgba(122,158,126,0.2)", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 12px" }}>
            <Icon name="calls" size={24} color="var(--accent-green)"/>
          </div>
          <div style={{ fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, color:"white", marginBottom:2 }}>{callerName || "On Call"}</div>
          <div style={{ fontSize:24, fontWeight:300, color:"var(--accent-green)", fontFamily:"monospace", marginBottom:18, letterSpacing:"0.1em" }}>{fmtTime(callTimer)}</div>
          <div style={{ display:"flex", gap:12, justifyContent:"center" }}>
            <button onClick={toggleMute} style={{ width:48, height:48, borderRadius:"50%", background: muted ? "var(--accent-amber)" : "rgba(255,255,255,0.08)", border: muted ? "none" : "1px solid var(--stone-600)", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", transition:"all 0.15s" }}
              title={muted ? "Unmute" : "Mute"}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={muted?"white":"var(--stone-400)"} strokeWidth="2" strokeLinecap="round">
                {muted ? <><line x1="1" y1="1" x2="23" y2="23"/><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"/></> : <><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/></>}
              </svg>
            </button>
            <button onClick={hangUp} style={{ width:48, height:48, borderRadius:"50%", background:"var(--accent-red)", border:"none", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", transition:"transform 0.15s" }}
              onMouseEnter={e => e.currentTarget.style.transform="scale(1.1)"} onMouseLeave={e => e.currentTarget.style.transform="scale(1)"}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-5.4-5.4A19.79 19.79 0 0 1 2.72 5 2 2 0 0 1 4.5 3h3a2 2 0 0 1 2 1.72"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
            </button>
          </div>
        </div>
      )}

      {/* ── Dial Pad (idle state) ── */}
      {(status === "ready" || status === "offline") && (
        <div style={{ padding:"16px 18px" }}>
          {/* Number input */}
          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:14, background:"rgba(255,255,255,0.05)", borderRadius:10, padding:"10px 14px" }}>
            <input value={dialNumber} onChange={e => setDialNumber(e.target.value.replace(/[^\d+*#()-\s]/g,""))}
              placeholder="Enter number…" style={{ flex:1, background:"transparent", border:"none", color:"white", fontSize:18, fontFamily:"var(--font-body)", outline:"none", letterSpacing:"0.03em" }}
              onKeyDown={e => { if (e.key === "Enter" && dialNumber) makeCall(dialNumber); }}
            />
            {dialNumber && (
              <button onClick={() => setDialNumber("")} style={{ background:"none", border:"none", color:"var(--stone-500)", cursor:"pointer", padding:2 }}>
                <Icon name="x" size={14}/>
              </button>
            )}
          </div>

          {/* Dial pad grid */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:6, marginBottom:14 }}>
            {dialPad.map(k => (
              <button key={k} onClick={() => pressKey(k)} style={{
                padding:"12px 0", background:"rgba(255,255,255,0.05)", border:"1px solid var(--stone-700)",
                borderRadius:10, color:"white", fontSize:20, fontWeight:500, cursor:"pointer",
                fontFamily:"var(--font-body)", transition:"all 0.1s", display:"flex", alignItems:"center", justifyContent:"center"
              }}
                onMouseEnter={e => { e.currentTarget.style.background="rgba(201,169,110,0.15)"; e.currentTarget.style.borderColor="var(--warm-gold)"; }}
                onMouseLeave={e => { e.currentTarget.style.background="rgba(255,255,255,0.05)"; e.currentTarget.style.borderColor="var(--stone-700)"; }}
              >{k}</button>
            ))}
          </div>

          {/* Call button */}
          <button onClick={() => dialNumber && makeCall(dialNumber)} disabled={!dialNumber || status === "offline"} style={{
            width:"100%", padding:14, background: dialNumber ? "var(--accent-green)" : "var(--stone-700)",
            border:"none", borderRadius:12, color:"white", fontSize:15, fontWeight:700,
            cursor: dialNumber ? "pointer" : "not-allowed", display:"flex", alignItems:"center", justifyContent:"center", gap:8,
            transition:"all 0.2s", opacity: dialNumber ? 1 : 0.5
          }}>
            <Icon name="calls" size={16} color="white"/> {dialNumber ? `Call ${dialNumber}` : "Enter a number"}
          </button>

          {/* Error message */}
          {error && (
            <div style={{ marginTop:10, fontSize:11, color:"var(--accent-red)", textAlign:"center" }}>{error}</div>
          )}

          {/* Status footer */}
          {status === "offline" && (
            <div style={{ marginTop:10, fontSize:11, color:"var(--stone-500)", textAlign:"center" }}>
              Softphone offline — check Twilio configuration
            </div>
          )}
        </div>
      )}

      {/* Connecting state */}
      {status === "connecting" && (
        <div style={{ padding:"32px 18px", textAlign:"center" }}>
          <div style={{ width:48, height:48, borderRadius:"50%", border:"3px solid var(--stone-600)", borderTopColor:"var(--warm-gold)", animation:"spin 0.7s linear infinite", margin:"0 auto 14px" }}/>
          <div style={{ fontSize:14, color:"var(--stone-300)" }}>Calling {callerName}…</div>
        </div>
      )}
    </div>
  );
};

// ── MAIN APP ──────────────────────────────────────────────────────────────────
// ── ACCESS CONTROL ────────────────────────────────────────────────────────────

// Role definitions
// owner  → full access including Reports (future)
// admin  → all modules except Reports
// installer → Training, Calendar (read-only schedule), their own assessments

const ROLES = {
  owner:     { label: "Owner",     color: "var(--warm-gold)",   badge: "👑", initials: "OW", desc: "Full access including Reports and User Management" },
  admin:     { label: "Admin",     color: "var(--accent-blue)", badge: "🔷", initials: "AD", desc: "Full access except Reports and User Management" },
  installer: { label: "Installer", color: "var(--accent-green)",badge: "🔧", initials: "IN", desc: "Training Center and My Schedule only" },
};

// ═══════════════════════════════════════════════════════════════════════════════
// TEAM BOARD — Internal messaging & handoff notes
// ═══════════════════════════════════════════════════════════════════════════════
// Supabase table required:
// CREATE TABLE team_messages (
//   id BIGINT PRIMARY KEY,
//   user_id INT NOT NULL,
//   user_name TEXT NOT NULL,
//   user_role TEXT DEFAULT 'admin',
//   channel TEXT DEFAULT 'general',
//   content TEXT NOT NULL,
//   pinned BOOLEAN DEFAULT false,
//   mention_id INT,
//   mention_name TEXT,
//   read_by JSONB DEFAULT '[]',
//   media_urls JSONB,                    -- ← photo attachments (array of Supabase Storage public URLs)
//   created_at TIMESTAMPTZ DEFAULT NOW()
// );
// -- If the table already exists, add the new column:
// -- ALTER TABLE team_messages ADD COLUMN IF NOT EXISTS media_urls JSONB;
// ALTER TABLE team_messages ENABLE ROW LEVEL SECURITY;
// CREATE POLICY "Allow all for service role" ON team_messages FOR ALL USING (true);
// -- Enable Realtime on team_messages in Dashboard → Database → Replication
// -- Photos upload to the existing `photos` Storage bucket under the `teamboard/` prefix

const BOARD_CHANNELS = [
  { id: 'general', label: 'General', icon: '💬' },
  { id: 'handoff', label: 'Handoff Notes', icon: '📋' },
];

const TeamBoard = ({ currentUser, users }) => {
  const [msgs, setMsgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [channel, setChannel] = useState('general');
  const [input, setInput] = useState('');
  const [sending, setSending] = useState(false);
  const [mentionTarget, setMentionTarget] = useState(null);
  const [showMentionPicker, setShowMentionPicker] = useState(false);
  const [viewPinned, setViewPinned] = useState(false);
  const [hoveredMsg, setHoveredMsg] = useState(null);
  // ── Photo attachments ──
  const [media, setMedia] = useState([]); // [{ preview, file }]
  const [mediaUploading, setMediaUploading] = useState(false);
  const fileRef = useRef(null);
  const endRef = useRef(null);
  const inputRef = useRef(null);

  const team = (users || []).filter(u => u.role === 'owner' || u.role === 'admin');
  const isOwner = currentUser?.role === 'owner';

  // ── Load messages ──
  // Fetch NEWEST-first within the row limit, then flip to chronological for display.
  // (Ascending + limit returns the OLDEST rows, which silently hides recent posts
  //  once a channel grows past the limit — that was the "saved but vanished" bug.)
  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase.from('team_messages')
        .select('*').eq('channel', channel)
        .order('created_at', { ascending: false }).limit(500);
      if (error) { console.error('[teamboard] load failed:', error.message); }
      else { setMsgs((data || []).reverse()); }
    } catch (e) { console.error('[teamboard] load exception:', e.message); }
    setLoading(false);
  }, [channel]);

  useEffect(() => { load(); }, [load]);

  // ── Scroll to bottom ──
  useEffect(() => {
    if (endRef.current && !viewPinned) {
      endRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [msgs.length, viewPinned]);

  // ── Polling (15s) — realtime WebSocket is unreliable on this project, so we poll
  //    the same way the rest of the CRM does. Merges in new/updated rows without
  //    clobbering the optimistic message you just posted. ──
  useEffect(() => {
    let cancelled = false;
    const poll = async () => {
      try {
        const { data, error } = await supabase.from('team_messages')
          .select('*').eq('channel', channel)
          .order('created_at', { ascending: false }).limit(500);
        if (cancelled || error || !data) return;
        const fresh = data.reverse();
        setMsgs(prev => {
          // Keep any just-posted optimistic rows not yet returned by the server
          const serverIds = new Set(fresh.map(m => m.id));
          const pendingLocal = prev.filter(m => !serverIds.has(m.id));
          return [...fresh, ...pendingLocal];
        });
      } catch (e) { /* silent — next tick retries */ }
    };
    const interval = setInterval(poll, 15000);
    return () => { cancelled = true; clearInterval(interval); };
  }, [channel]);

  // ── Mark read ──
  useEffect(() => {
    if (!currentUser || msgs.length === 0) return;
    const unread = msgs.filter(m => {
      const rb = Array.isArray(m.read_by) ? m.read_by : [];
      return m.user_id !== currentUser.id && !rb.includes(currentUser.id);
    });
    if (unread.length === 0) return;
    Promise.all(unread.map(m => {
      const rb = Array.isArray(m.read_by) ? [...m.read_by, currentUser.id] : [currentUser.id];
      return supabase.from('team_messages').update({ read_by: rb }).eq('id', m.id);
    })).catch(() => {});
  }, [msgs, currentUser]);

  // ── Photo pick handler ──
  const handlePhotoPick = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    files.forEach(file => {
      const reader = new FileReader();
      reader.onload = async (ev) => {
        try {
          const compressed = await compressImage(ev.target.result, 1200, 0.75);
          setMedia(p => [...p, { preview: compressed, file }]);
        } catch (err) {
          console.error('[teamboard] compress error:', err);
        }
      };
      reader.readAsDataURL(file);
    });
    if (fileRef.current) fileRef.current.value = '';
  };

  // ── Send ──
  const send = async () => {
    try {
      const text = input.trim();
      if ((!text && media.length === 0) || sending) return;
      if (!currentUser || currentUser.id == null) {
        window.alert('Team Board could not post: your user session is missing. Try logging out and back in.');
        return;
      }
      setSending(true);

      // Upload photos to Supabase Storage first
      let mediaUrls = [];
      if (media.length > 0) {
        setMediaUploading(true);
        for (const item of media) {
          try {
            const base64 = item.preview.split(',')[1];
            const byteArr = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
            const blob = new Blob([byteArr], { type: 'image/jpeg' });
            const path = `teamboard/${Date.now()}-${Math.random().toString(36).slice(2, 6)}.jpg`;
            const { error: upErr } = await supabase.storage.from('photos').upload(path, blob, { contentType: 'image/jpeg', upsert: false });
            if (upErr) { console.error('[teamboard] photo upload error:', upErr.message); continue; }
            const { data: urlData } = supabase.storage.from('photos').getPublicUrl(path);
            if (urlData?.publicUrl) mediaUrls.push(urlData.publicUrl);
          } catch (ue) { console.error('[teamboard] upload failed:', ue); }
        }
        setMediaUploading(false);
      }

      const msg = {
        id: Date.now(),
        user_id: currentUser.id,
        user_name: currentUser.name,
        user_role: currentUser.role,
        channel,
        content: text,
        pinned: false,
        mention_id: mentionTarget?.id || null,
        mention_name: mentionTarget?.name || null,
        read_by: [currentUser.id],
        media_urls: mediaUrls.length > 0 ? mediaUrls : null,
        created_at: new Date().toISOString(),
      };

      setMsgs(prev => [...prev, msg]);
      setInput('');
      setMedia([]);
      setMentionTarget(null);
      setShowMentionPicker(false);

      // Supabase does NOT throw on RLS / column / constraint errors — it returns { error }.
      // .select() forces the inserted row back so we can confirm it actually persisted.
      let { data, error } = await supabase.from('team_messages').insert(msg).select();

      if (error && /media_urls/i.test(error.message || '')) {
        const { media_urls, ...rest } = msg;
        ({ data, error } = await supabase.from('team_messages').insert(rest).select());
      }

      if (error || !data || data.length === 0) {
        console.error('[teamboard] send failed:', error?.message || 'no row returned', error);
        setMsgs(prev => prev.filter(m => m.id !== msg.id));
        setInput(text);
        window.alert('Team Board did NOT save:\n\n' + (error?.message || 'The database returned no row (row-level security may be filtering the insert).'));
      }
    } catch (ex) {
      console.error('[teamboard] send exception:', ex);
      window.alert('Team Board crashed while posting:\n\n' + (ex?.message || ex));
    } finally {
      setSending(false);
      inputRef.current?.focus();
    }
  };

  // ── Pin toggle ──
  const togglePin = async (m) => {
    setMsgs(prev => prev.map(x => x.id === m.id ? { ...x, pinned: !x.pinned } : x));
    await supabase.from('team_messages').update({ pinned: !m.pinned }).eq('id', m.id);
  };

  // ── Delete (own messages or owner) ──
  const deleteMsg = async (m) => {
    setMsgs(prev => prev.filter(x => x.id !== m.id));
    await supabase.from('team_messages').delete().eq('id', m.id);
  };

  // ── Group by date ──
  const grouped = [];
  let lastDate = '';
  const displayMsgs = viewPinned ? msgs.filter(m => m.pinned) : msgs;
  for (const m of displayMsgs) {
    const d = new Date(m.created_at).toDateString();
    if (d !== lastDate) { lastDate = d; grouped.push({ _dateHeader: true, date: m.created_at }); }
    grouped.push(m);
  }

  const pinnedCount = msgs.filter(m => m.pinned).length;

  // ── Date header label ──
  const dateLbl = (iso) => {
    const d = new Date(iso);
    const t = new Date();
    if (d.toDateString() === t.toDateString()) return 'Today';
    const y = new Date(t); y.setDate(y.getDate() - 1);
    if (d.toDateString() === y.toDateString()) return 'Yesterday';
    return d.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
  };

  const roleColor = (role) => role === 'owner' ? 'var(--warm-gold)' : role === 'admin' ? 'var(--accent-blue)' : 'var(--accent-green)';

  return (
    <div className="fade-in" style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 140px)', minHeight: 500 }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <h1 className="section-title">Team Board</h1>
          <p className="section-sub">Internal messaging and handoff notes.</p>
        </div>
        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
          {team.map(u => (
            <div key={u.id} title={`${u.name} (${u.role})`} style={{
              width: 30, height: 30, borderRadius: '50%',
              background: roleColor(u.role),
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 11, fontWeight: 800, color: 'white',
              border: u.id === currentUser?.id ? '2px solid var(--accent-green)' : '2px solid white',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            }}>
              {u.name.split(' ').map(n => n[0]).join('')}
            </div>
          ))}
        </div>
      </div>

      {/* Channel tabs */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10, gap: 8, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', gap: 4 }}>
          {BOARD_CHANNELS.map(ch => (
            <button key={ch.id} onClick={() => { setChannel(ch.id); setViewPinned(false); }}
              style={{
                padding: '7px 14px', borderRadius: 'var(--radius, 8px)',
                border: `1px solid ${channel === ch.id ? 'var(--warm-gold)' : 'var(--stone-200)'}`,
                background: channel === ch.id ? 'rgba(196,149,74,0.08)' : 'white',
                color: channel === ch.id ? 'var(--warm-gold)' : 'var(--stone-600)',
                fontWeight: 600, fontSize: 13, cursor: 'pointer',
                display: 'flex', alignItems: 'center', gap: 5, transition: 'all 0.15s',
              }}
            >
              {ch.icon} {ch.label}
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 6 }}>
          {pinnedCount > 0 && (
            <button onClick={() => setViewPinned(p => !p)}
              style={{
                padding: '6px 12px', borderRadius: 'var(--radius, 8px)',
                border: `1px solid ${viewPinned ? 'var(--warm-gold)' : 'var(--stone-200)'}`,
                background: viewPinned ? 'rgba(196,149,74,0.08)' : 'white',
                color: viewPinned ? 'var(--warm-gold)' : 'var(--stone-500)',
                fontWeight: 600, fontSize: 12, cursor: 'pointer',
              }}
            >
              📌 {pinnedCount} Pinned
            </button>
          )}
        </div>
      </div>

      {/* Messages area */}
      <div style={{
        flex: 1, background: 'white', borderRadius: 'var(--radius-lg, 12px)',
        border: '1px solid var(--stone-200)', display: 'flex', flexDirection: 'column',
        overflow: 'hidden',
      }}>
        {/* Message list */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '16px 20px' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: 40, color: 'var(--stone-400)', fontSize: 13 }}>Loading messages...</div>
          ) : grouped.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 60, color: 'var(--stone-400)' }}>
              <div style={{ fontSize: 36, marginBottom: 10 }}>{viewPinned ? '📌' : channel === 'handoff' ? '📋' : '💬'}</div>
              <div style={{ fontWeight: 600, fontSize: 14 }}>{viewPinned ? 'No pinned messages' : 'No messages yet'}</div>
              <div style={{ fontSize: 13, marginTop: 4 }}>{viewPinned ? 'Pin important messages to find them quickly.' : channel === 'handoff' ? 'Leave notes here for the next shift.' : 'Start the conversation!'}</div>
            </div>
          ) : (
            grouped.map((item, i) => {
              if (item._dateHeader) {
                return (
                  <div key={`d-${i}`} style={{
                    display: 'flex', alignItems: 'center', gap: 12, margin: '20px 0 12px',
                  }}>
                    <div style={{ flex: 1, height: 1, background: 'var(--stone-200)' }} />
                    <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--stone-400)', textTransform: 'uppercase', letterSpacing: '0.5px', flexShrink: 0 }}>
                      {dateLbl(item.date)}
                    </span>
                    <div style={{ flex: 1, height: 1, background: 'var(--stone-200)' }} />
                  </div>
                );
              }

              const m = item;
              const isMe = m.user_id === currentUser?.id;
              const initials = (m.user_name || '').split(' ').map(n => n[0]).join('');
              const isHovered = hoveredMsg === m.id;

              return (
                <div key={m.id}
                  onMouseEnter={() => setHoveredMsg(m.id)}
                  onMouseLeave={() => setHoveredMsg(null)}
                  style={{
                    display: 'flex', gap: 10, padding: '8px 6px', marginBottom: 2,
                    borderRadius: 8, transition: 'background 0.1s',
                    background: isHovered ? 'var(--stone-50)' : m.pinned ? 'rgba(196,149,74,0.04)' : 'transparent',
                    borderLeft: m.pinned ? '3px solid var(--warm-gold)' : '3px solid transparent',
                  }}
                >
                  {/* Avatar */}
                  <div style={{
                    width: 32, height: 32, borderRadius: '50%', flexShrink: 0,
                    background: roleColor(m.user_role),
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 11, fontWeight: 800, color: 'white', marginTop: 2,
                  }}>
                    {initials}
                  </div>

                  {/* Content */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 2 }}>
                      <span style={{ fontWeight: 700, fontSize: 13, color: 'var(--stone-800)' }}>{m.user_name}</span>
                      <span style={{
                        fontSize: 10, fontWeight: 700, textTransform: 'uppercase',
                        color: roleColor(m.user_role), letterSpacing: '0.04em',
                      }}>{m.user_role}</span>
                      <span style={{ fontSize: 11, color: 'var(--stone-400)' }}>
                        {new Date(m.created_at).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}
                      </span>
                      {m.pinned && <span style={{ fontSize: 10 }}>📌</span>}
                    </div>

                    {/* Mention tag */}
                    {m.mention_name && (
                      <span style={{
                        display: 'inline-block', fontSize: 11, fontWeight: 700,
                        color: 'var(--accent-blue)', background: 'rgba(59,91,219,0.08)',
                        padding: '1px 6px', borderRadius: 4, marginBottom: 4,
                      }}>@{m.mention_name}</span>
                    )}

                    {/* Attached photos */}
                    {(() => {
                      const urls = Array.isArray(m.media_urls) ? m.media_urls : [];
                      if (!urls.length) return null;
                      return (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 2, marginBottom: m.content ? 6 : 0 }}>
                          {urls.map((url, i) => (
                            <img key={i} src={url} alt="attached"
                              onClick={() => window.open(url, '_blank')}
                              style={{
                                maxWidth: 220, maxHeight: 240, borderRadius: 8, cursor: 'pointer',
                                objectFit: 'cover', border: '1px solid var(--stone-200)',
                              }}
                              onError={e => { e.target.style.display = 'none'; }}
                            />
                          ))}
                        </div>
                      );
                    })()}

                    {/* Message text */}
                    {m.content && (
                      <div style={{
                        fontSize: 14, color: 'var(--stone-700)', lineHeight: 1.5,
                        whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                      }}>{m.content}</div>
                    )}
                  </div>

                  {/* Actions (on hover) */}
                  {isHovered && (
                    <div style={{ display: 'flex', gap: 2, flexShrink: 0, alignSelf: 'flex-start', marginTop: 2 }}>
                      <button onClick={() => togglePin(m)} title={m.pinned ? 'Unpin' : 'Pin'}
                        style={{ width: 26, height: 26, borderRadius: 6, border: 'none', background: 'var(--stone-100)', cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        📌
                      </button>
                      {(isMe || isOwner) && (
                        <button onClick={() => deleteMsg(m)} title="Delete"
                          style={{ width: 26, height: 26, borderRadius: 6, border: 'none', background: 'var(--stone-100)', cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent-red)' }}>
                          ✕
                        </button>
                      )}
                    </div>
                  )}
                </div>
              );
            })
          )}
          <div ref={endRef} />
        </div>

        {/* Input area */}
        <div style={{ borderTop: '1px solid var(--stone-200)', padding: '12px 16px', background: 'var(--stone-50)' }}>
          {/* Mention tag */}
          {mentionTarget && (
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 6,
              background: 'rgba(59,91,219,0.08)', padding: '3px 8px', borderRadius: 6,
              marginBottom: 8, fontSize: 12, fontWeight: 600, color: 'var(--accent-blue)',
            }}>
              @{mentionTarget.name}
              <button onClick={() => setMentionTarget(null)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 14, color: 'var(--stone-400)', padding: 0, lineHeight: 1 }}>✕</button>
            </div>
          )}

          {/* Photo preview strip */}
          {media.length > 0 && (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
              {media.map((item, i) => (
                <div key={i} style={{ position: 'relative', width: 64, height: 64 }}>
                  <img src={item.preview} alt="" style={{ width: 64, height: 64, borderRadius: 8, objectFit: 'cover', border: '1.5px solid var(--stone-300)' }} />
                  <button onClick={() => setMedia(p => p.filter((_, j) => j !== i))}
                    style={{ position: 'absolute', top: -6, right: -6, width: 20, height: 20, borderRadius: '50%', background: 'var(--stone-700)', color: 'white', border: 'none', cursor: 'pointer', fontSize: 12, lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
                </div>
              ))}
              {mediaUploading && <div style={{ fontSize: 11, color: 'var(--stone-400)', alignSelf: 'center' }}>Uploading…</div>}
            </div>
          )}

          <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
            {/* @ mention button */}
            <div style={{ position: 'relative' }}>
              <button onClick={() => setShowMentionPicker(p => !p)}
                style={{
                  width: 34, height: 34, borderRadius: 8,
                  border: `1px solid ${showMentionPicker ? 'var(--accent-blue)' : 'var(--stone-200)'}`,
                  background: showMentionPicker ? 'rgba(59,91,219,0.08)' : 'white',
                  cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: showMentionPicker ? 'var(--accent-blue)' : 'var(--stone-500)',
                  fontWeight: 700,
                }}>@</button>

              {showMentionPicker && (
                <div style={{
                  position: 'absolute', bottom: 40, left: 0, background: 'white',
                  borderRadius: 'var(--radius, 8px)', boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                  border: '1px solid var(--stone-200)', overflow: 'hidden', zIndex: 10, minWidth: 180,
                }}>
                  {team.filter(u => u.id !== currentUser?.id).map(u => (
                    <button key={u.id}
                      onClick={() => { setMentionTarget(u); setShowMentionPicker(false); inputRef.current?.focus(); }}
                      style={{
                        display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px',
                        border: 'none', background: 'none', cursor: 'pointer', width: '100%',
                        fontSize: 13, fontWeight: 500, color: 'var(--stone-700)',
                        borderBottom: '1px solid var(--stone-100)',
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = 'var(--stone-50)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'none'}
                    >
                      <div style={{
                        width: 24, height: 24, borderRadius: '50%',
                        background: roleColor(u.role),
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 10, fontWeight: 800, color: 'white',
                      }}>{u.name.split(' ').map(n => n[0]).join('')}</div>
                      {u.name}
                      <span style={{ fontSize: 10, color: 'var(--stone-400)', marginLeft: 'auto', textTransform: 'uppercase' }}>{u.role}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Photo attach button */}
            <input type="file" ref={fileRef} accept="image/*" multiple style={{ display: 'none' }} onChange={handlePhotoPick} />
            <button onClick={() => fileRef.current?.click()} title="Attach photo"
              style={{
                width: 34, height: 34, borderRadius: 8,
                border: `1px solid ${media.length > 0 ? 'var(--warm-gold)' : 'var(--stone-200)'}`,
                background: media.length > 0 ? 'rgba(196,149,74,0.08)' : 'white',
                cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: media.length > 0 ? 'var(--warm-gold)' : 'var(--stone-500)',
              }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <circle cx="8.5" cy="8.5" r="1.5"/>
                <polyline points="21 15 16 10 5 21"/>
              </svg>
            </button>

            {/* Text input */}
            <textarea
              ref={inputRef}
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); } }}
              placeholder={channel === 'handoff' ? 'Leave a note for the next shift…' : 'Type a message…'}
              rows={1}
              style={{
                flex: 1, padding: '8px 12px', borderRadius: 'var(--radius, 8px)',
                border: '1px solid var(--stone-200)', fontSize: 14,
                resize: 'none', fontFamily: 'inherit', lineHeight: 1.4,
                minHeight: 36, maxHeight: 120,
              }}
              onInput={e => { e.target.style.height = 'auto'; e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px'; }}
            />

            {/* Send */}
            <button onClick={send} disabled={(!input.trim() && media.length === 0) || sending}
              style={{
                padding: '8px 18px', borderRadius: 'var(--radius, 8px)',
                background: (input.trim() || media.length > 0) ? 'var(--warm-gold)' : 'var(--stone-200)',
                color: (input.trim() || media.length > 0) ? 'white' : 'var(--stone-400)',
                border: 'none', fontWeight: 700, fontSize: 13, cursor: (input.trim() || media.length > 0) ? 'pointer' : 'default',
                transition: 'all 0.15s', height: 36,
              }}
            >
              {sending ? '…' : 'Send'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const INIT_USERS = [
  { id: 1, name: "Alex Rivera",    role: "owner",     email: "alex@timelesstile.pro",    pin: "1111", active: true },
  { id: 2, name: "Jordan Mills",   role: "admin",     email: "jordan@timelesstile.pro",  pin: "2222", active: true },
  { id: 3, name: "Marcus Chen",    role: "installer", email: "marcus@timelesstile.pro",  pin: "3333", active: true },
  { id: 4, name: "Devon Taylor",   role: "installer", email: "devon@timelesstile.pro",   pin: "4444", active: true },
];

// Page-level permissions per role
const PAGE_ACCESS = {
  owner:     ["dashboard","leads","calls","jobs","customers","calendar","estimates","invoicing",...(SHOW_LEGACY_MATERIALS ? ["materials"] : []),"catalog","budgets","pldash","reviews","gallery","playbook","training","schedule","reports","users","marketing","outreach","aiassistant","teamboard","activity","automations","errorlog","trash"],
  admin:     ["dashboard","leads","calls","jobs","customers","calendar","estimates","invoicing","budgets","reviews","gallery","playbook","training","schedule","aiassistant","teamboard","automations","trash"],
  installer: ["schedule","training"],
};

const ALL_NAV = [
  { id: "dashboard", label: "Dashboard",       icon: "dashboard",  roles: ["owner","admin"] },
  { id: "customers", label: "Customer Database",icon: "customers",  roles: ["owner","admin"] },
  { id: "calls",     label: "Call Tracking",    icon: "calls",      roles: ["owner","admin"] },
  { id: "calendar",  label: "Calendar",         icon: "calendar",   roles: ["owner","admin"] },
  { id: "leads",     label: "Leads",            icon: "leads",      roles: ["owner","admin"] },
  { id: "estimates", label: "Estimates",        icon: "estimate",   roles: ["owner","admin"] },
  { id: "jobs",      label: "Job Tracking",     icon: "jobs",       roles: ["owner","admin"] },
  { id: "invoicing", label: "Invoicing",        icon: "invoice",    roles: ["owner","admin"] },
  { id: "reviews",   label: "Reviews",          icon: "star",       roles: ["owner","admin"] },
  { id: "gallery",   label: "Photo Gallery",    icon: "gallery",    roles: ["owner","admin"] },
  { id: "playbook",  label: "Company Playbook", icon: "playbook",   roles: ["owner","admin"] },
  { id: "training",  label: "Training Center",  icon: "star",       roles: ["owner","admin","installer"] },
  { id: "schedule",  label: "Crew App",         icon: "calendar",   roles: ["owner","admin","installer"] },
  { id: "marketing", label: "Marketing",        icon: "megaphone",  roles: ["owner"], badge: "Owner" },
  { id: "outreach",    label: "Outreach",        icon: "leads",      roles: ["owner"], badge: "Owner" },
  { id: "aiassistant", label: "AI Assistant",     icon: "star",       roles: ["owner","admin"] },
  { id: "materials", label: "Materials",        icon: "dollar",     roles: ["owner"], badge: "Owner", hidden: !SHOW_LEGACY_MATERIALS },
  { id: "catalog",   label: "Materials Catalog", icon: "dollar",     roles: ["owner"], badge: "Owner" },
  { id: "budgets",   label: "Project Budgets",   icon: "estimate",   roles: ["owner", "admin"] },
  { id: "pldash",    label: "P&L Dashboard",     icon: "dashboard",  roles: ["owner"], badge: "Owner" },
  { id: "reports",   label: "Reports",          icon: "dashboard",  roles: ["owner"], badge: "Owner" },
  { id: "users",     label: "User Management",  icon: "customers",  roles: ["owner"], badge: "Owner" },
  { id: "teamboard", label: "Team Board",       icon: "script",     roles: ["owner","admin"] },
  { id: "activity",  label: "Team Activity",    icon: "clock",      roles: ["owner"], badge: "Owner" },
  { id: "automations", label: "Automations",   icon: "clock",      roles: ["owner","admin"], badge: "Owner" },
  { id: "errorlog",  label: "Error Log",        icon: "note",       roles: ["owner"], badge: "Owner" },
  { id: "trash",     label: "Trash",            icon: "trash",      roles: ["owner","admin"] },
];

// ── Automation Health Monitor (Owner only) ───────────────────────────────────
const AUTOMATIONS = [
  { key:"gbp-sync",             label:"GBP Sync",              desc:"Syncs Google reviews, auto-posts completed job photos to Google Business Profile",    schedule:"Every 2 hours",  path:"/api/cron/gbp-sync",             windowMs: 3*60*60*1000,     icon:"megaphone" },
  { key:"estimate-followup",    label:"Estimate Follow-Up",    desc:"Sends automated SMS nudges at 48h, 5d, and 14d for viewed but unsigned estimates",    schedule:"Every hour",     path:"/api/cron/estimate-followup",    windowMs: 2*60*60*1000,     icon:"estimate"  },
  { key:"review-requests",      label:"Review Requests",       desc:"4-touch review sequence: thank-you, Google request, follow-up, final email",          schedule:"Daily 10am ET",  path:"/api/cron/review-requests",      windowMs: 26*60*60*1000,    icon:"star"      },
  { key:"appointment-reminders",label:"Appointment Reminders", desc:"Day-before SMS + email, morning-of SMS for scheduled events",                         schedule:"Daily 7am ET",   path:"/api/cron/appointment-reminders",windowMs: 26*60*60*1000,    icon:"calendar"  },
  { key:"stale-leads",          label:"Stale Lead Digest",     desc:"AI-generated SMS with top 3 pipeline actions for the week",                           schedule:"Mondays 9am ET", path:"/api/cron/stale-leads",          windowMs: 8*24*60*60*1000,  icon:"leads"     },
  { key:"repeat-outreach",      label:"Repeat Outreach",       desc:"Generates personalized outreach drafts for past customers (6+ months inactive)",      schedule:"1st of month",   path:"/api/cron/repeat-outreach",      windowMs: 35*24*60*60*1000, icon:"mail"      },
];

const AutomationHealth = () => {
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [testing, setTesting] = useState(null);
  const [testResults, setTestResults] = useState({});
  const [expanded, setExpanded] = useState(null);

  const fetchRuns = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await supabase.from('automation_runs').select('*').order('ran_at', { ascending: false }).limit(200);
      setRuns(data || []);
    } catch (e) { console.log('[automations] Table not found'); }
    setLoading(false);
  }, []);

  useEffect(() => { fetchRuns(); }, [fetchRuns]);

  const getLatestRun = (key) => runs.find(r => r.automation === key);

  const getStatus = (auto) => {
    const latest = getLatestRun(auto.key);
    if (!latest) return { color: "var(--stone-400)", label: "No Data", bg: "var(--stone-100)" };
    const age = Date.now() - new Date(latest.ran_at).getTime();
    if (latest.status === 'error') return { color: "var(--accent-red)", label: "Error", bg: "rgba(192,97,74,0.1)" };
    if (latest.status === 'partial') return { color: "var(--accent-amber)", label: "Partial", bg: "rgba(196,149,74,0.1)" };
    if (age > auto.windowMs * 2) return { color: "var(--accent-red)", label: "Overdue", bg: "rgba(192,97,74,0.1)" };
    if (age > auto.windowMs) return { color: "var(--accent-amber)", label: "Late", bg: "rgba(196,149,74,0.1)" };
    return { color: "var(--accent-green)", label: "Healthy", bg: "rgba(74,160,74,0.1)" };
  };

  const runNow = async (auto) => {
    setTesting(auto.key);
    setTestResults(p => ({ ...p, [auto.key]: null }));
    try {
      const baseUrl = window.location.origin.includes('localhost') ? 'https://crm.timelesstilepro.com' : window.location.origin;
      const r = await fetch(`${baseUrl}${auto.path}?force=true`);
      const data = await r.json();
      setTestResults(p => ({ ...p, [auto.key]: { ok: r.ok, data } }));
      setTimeout(() => fetchRuns(), 2000);
    } catch (e) {
      setTestResults(p => ({ ...p, [auto.key]: { ok: false, data: { error: e.message } } }));
    }
    setTesting(null);
  };

  const timeAgo = (dateStr) => {
    if (!dateStr) return '—';
    const ms = Date.now() - new Date(dateStr).getTime();
    const mins = Math.floor(ms / 60000);
    if (mins < 1) return 'just now';
    if (mins < 60) return `${mins}m ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h ${mins % 60}m ago`;
    const days = Math.floor(hrs / 24);
    return `${days}d ${hrs % 24}h ago`;
  };

  const healthyCt = AUTOMATIONS.filter(a => getStatus(a).label === "Healthy").length;
  const issueCt = AUTOMATIONS.filter(a => ["Error","Overdue","Late","Partial"].includes(getStatus(a).label)).length;
  const noDataCt = AUTOMATIONS.filter(a => getStatus(a).label === "No Data").length;

  return (
    <div className="fade-in" style={{ minHeight:"calc(100vh - 120px)" }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:20, flexWrap:"wrap", gap:12 }}>
        <div>
          <h1 className="section-title">Automation Health</h1>
          <p className="section-sub">Monitor all automated workflows. Green = running on schedule. Red = needs attention.</p>
        </div>
        <button className="btn btn-secondary" onClick={fetchRuns} disabled={loading}>
          {loading ? "Checking..." : "Refresh Status"}
        </button>
      </div>

      {/* Summary cards */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(180px, 1fr))", gap:12, marginBottom:24 }}>
        <div className="card" style={{ padding:"16px 20px", borderLeft:"4px solid var(--accent-green)" }}>
          <div style={{ fontSize:28, fontWeight:700, color:"var(--accent-green)" }}>{healthyCt}</div>
          <div style={{ fontSize:12, color:"var(--stone-500)", fontWeight:600 }}>HEALTHY</div>
        </div>
        <div className="card" style={{ padding:"16px 20px", borderLeft:`4px solid ${issueCt > 0 ? "var(--accent-red)" : "var(--stone-200)"}` }}>
          <div style={{ fontSize:28, fontWeight:700, color: issueCt > 0 ? "var(--accent-red)" : "var(--stone-400)" }}>{issueCt}</div>
          <div style={{ fontSize:12, color:"var(--stone-500)", fontWeight:600 }}>NEEDS ATTENTION</div>
        </div>
        <div className="card" style={{ padding:"16px 20px", borderLeft:"4px solid var(--stone-300)" }}>
          <div style={{ fontSize:28, fontWeight:700, color:"var(--stone-400)" }}>{noDataCt}</div>
          <div style={{ fontSize:12, color:"var(--stone-500)", fontWeight:600 }}>NOT YET TRACKING</div>
        </div>
      </div>

      {/* Automation list */}
      <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
        {AUTOMATIONS.map(auto => {
          const status = getStatus(auto);
          const latest = getLatestRun(auto.key);
          const result = testResults[auto.key];
          const recentRuns = runs.filter(r => r.automation === auto.key).slice(0, 5);

          return (
            <div key={auto.key} className="card" style={{ padding:0, overflow:"hidden" }}>
              <div style={{ display:"flex", alignItems:"center", gap:14, padding:"16px 20px", flexWrap:"wrap", cursor:"pointer" }} onClick={() => setExpanded(expanded === auto.key ? null : auto.key)}>
                {/* Status indicator */}
                <div style={{ width:12, height:12, borderRadius:"50%", background:status.color, flexShrink:0, boxShadow: status.label === "Healthy" ? `0 0 8px ${status.color}40` : "none" }} />

                {/* Info */}
                <div style={{ flex:1, minWidth:200 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                    <span style={{ fontWeight:700, fontSize:14, color:"var(--stone-800)" }}>{auto.label}</span>
                    <span style={{ fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:99, background:status.bg, color:status.color }}>{status.label}</span>
                    <span style={{ fontSize:11, color:"var(--stone-400)", fontWeight:500 }}>{auto.schedule}</span>
                    <span style={{ fontSize:10, color:"var(--stone-400)", transition:"transform 0.2s", transform: expanded === auto.key ? "rotate(180deg)" : "rotate(0)" }}>▼</span>
                  </div>
                  <div style={{ fontSize:12, color:"var(--stone-500)", marginTop:3 }}>{auto.desc}</div>
                </div>

                {/* Last run */}
                <div style={{ textAlign:"right", minWidth:120 }}>
                  <div style={{ fontSize:12, fontWeight:600, color:"var(--stone-600)" }}>
                    {latest ? timeAgo(latest.ran_at) : "Never run"}
                  </div>
                  {latest?.summary && (
                    <div style={{ fontSize:11, color:"var(--stone-400)", marginTop:2 }}>
                      {latest.summary.postsCreated != null && `${latest.summary.postsCreated} posts`}
                      {latest.summary.reviewsSynced != null && ` · ${latest.summary.reviewsSynced} reviews`}
                      {latest.summary.checked != null && `${latest.summary.checked} checked`}
                      {latest.summary.sent != null && `${latest.summary.sent} sent`}
                      {latest.summary.errors?.length > 0 && <span style={{ color:"var(--accent-red)" }}> · {latest.summary.errors.length} errors</span>}
                    </div>
                  )}
                </div>

                {/* Run Now button */}
                <button
                  className="btn btn-secondary"
                  style={{ fontSize:11, padding:"5px 12px", whiteSpace:"nowrap" }}
                  onClick={(e) => { e.stopPropagation(); runNow(auto); }}
                  disabled={testing === auto.key}
                >
                  {testing === auto.key ? "Running..." : "Run Now"}
                </button>
              </div>

              {/* Expanded error detail panel */}
              {expanded === auto.key && latest?.summary && (
                <div style={{ padding:"12px 20px", borderTop:"1px solid var(--stone-100)", background:"var(--stone-50)" }}>
                  <div style={{ fontSize:11, fontWeight:700, color:"var(--stone-600)", marginBottom:8, textTransform:"uppercase" }}>Last Run Details</div>
                  <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(120px, 1fr))", gap:8, marginBottom: latest.summary.errors?.length > 0 ? 12 : 0 }}>
                    {Object.entries(latest.summary).filter(([k]) => k !== 'errors' && k !== 'error').map(([key, val]) => (
                      <div key={key} style={{ background:"white", padding:"8px 12px", borderRadius:"var(--radius)", border:"1px solid var(--stone-100)" }}>
                        <div style={{ fontSize:10, color:"var(--stone-400)", fontWeight:600, textTransform:"uppercase" }}>{key.replace(/([A-Z])/g, ' $1').trim()}</div>
                        <div style={{ fontSize:14, fontWeight:700, color:"var(--stone-700)", marginTop:2 }}>{typeof val === 'object' ? JSON.stringify(val) : String(val)}</div>
                      </div>
                    ))}
                  </div>
                  {latest.summary.error && (
                    <div style={{ background:"rgba(192,97,74,0.06)", border:"1px solid rgba(192,97,74,0.15)", borderRadius:"var(--radius)", padding:"10px 14px", marginBottom:8 }}>
                      <div style={{ fontSize:11, fontWeight:700, color:"var(--accent-red)", marginBottom:4 }}>FATAL ERROR</div>
                      <div style={{ fontSize:12, color:"var(--stone-700)", fontFamily:"monospace", lineHeight:1.6 }}>{latest.summary.error}</div>
                    </div>
                  )}
                  {latest.summary.errors?.length > 0 && (
                    <div>
                      <div style={{ fontSize:11, fontWeight:700, color:"var(--accent-red)", marginBottom:6 }}>ERRORS ({latest.summary.errors.length})</div>
                      {latest.summary.errors.map((err, i) => (
                        <div key={i} style={{ background:"rgba(192,97,74,0.06)", border:"1px solid rgba(192,97,74,0.15)", borderRadius:"var(--radius)", padding:"8px 12px", marginBottom:4, fontSize:12, color:"var(--stone-700)", fontFamily:"monospace", lineHeight:1.5 }}>
                          {err}
                        </div>
                      ))}
                    </div>
                  )}
                  {!latest.summary.errors?.length && !latest.summary.error && (
                    <div style={{ fontSize:12, color:"var(--accent-green)", fontWeight:600 }}>No errors — clean run</div>
                  )}
                  <div style={{ fontSize:10, color:"var(--stone-400)", marginTop:8 }}>
                    Ran at: {new Date(latest.ran_at).toLocaleString()}
                  </div>
                </div>
              )}

              {/* Expanded run history */}
              {expanded === auto.key && recentRuns.length > 0 && (
                <div style={{ padding:"10px 20px", borderTop:"1px solid var(--stone-100)" }}>
                  <div style={{ fontSize:11, fontWeight:700, color:"var(--stone-600)", marginBottom:6, textTransform:"uppercase" }}>Run History</div>
                  {recentRuns.map((r, i) => (
                    <div key={r.id || i} style={{ display:"flex", alignItems:"center", gap:10, padding:"4px 0", fontSize:12, color:"var(--stone-600)" }}>
                      <div style={{ width:8, height:8, borderRadius:"50%", background: r.status === 'success' ? 'var(--accent-green)' : r.status === 'partial' ? 'var(--accent-amber)' : 'var(--accent-red)', flexShrink:0 }} />
                      <span style={{ minWidth:140 }}>{new Date(r.ran_at).toLocaleString()}</span>
                      <span style={{ fontWeight:600, color: r.status === 'success' ? 'var(--accent-green)' : r.status === 'partial' ? 'var(--accent-amber)' : 'var(--accent-red)' }}>{r.status}</span>
                      {r.summary?.errors?.length > 0 && <span style={{ color:"var(--accent-red)", fontSize:11 }}>{r.summary.errors.length} errors</span>}
                    </div>
                  ))}
                </div>
              )}

              {/* Test result feedback */}
              {result && (
                <div style={{ padding:"8px 20px", background: result.ok ? "rgba(74,160,74,0.06)" : "rgba(192,97,74,0.06)", borderTop:"1px solid var(--stone-100)", fontSize:12 }}>
                  {result.ok ? (
                    <span style={{ color:"var(--accent-green)", fontWeight:600 }}>
                      Test passed
                      {result.data.postsCreated != null && ` — ${result.data.postsCreated} posts, ${result.data.reviewsSynced || 0} reviews synced`}
                      {result.data.checked != null && ` — ${result.data.checked} jobs checked, ${result.data.thankyou || 0} thank-yous, ${result.data.request || 0} requests sent`}
                      {result.data.sent != null && ` — ${result.data.sent} reminders sent`}
                    </span>
                  ) : (
                    <span style={{ color:"var(--accent-red)", fontWeight:600 }}>
                      Failed: {result.data?.error || "Unknown error"}
                    </span>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Setup instructions for untracked automations */}
      {noDataCt > 0 && (
        <div className="card" style={{ marginTop:20, padding:"16px 20px", background:"rgba(196,149,74,0.05)", border:"1px solid rgba(196,149,74,0.15)" }}>
          <div style={{ fontSize:13, fontWeight:600, color:"var(--stone-700)", marginBottom:6 }}>Setup Note</div>
          <div style={{ fontSize:12, color:"var(--stone-500)", lineHeight:1.7 }}>
            Automations showing "No Data" haven't reported their status yet. Each cron needs a one-line logging call added.
            Once added, the health monitor will automatically track run times, success rates, and error details.
            The "Run Now" button works immediately for all automations regardless of tracking status.
          </div>
        </div>
      )}
    </div>
  );
};

// ── Error Log (Owner only) ────────────────────────────────────────────────────
const ErrorLog = ({ saveErrors, setSaveErrors }) => {
  const sorted = [...saveErrors].sort((a,b) => (b.date||b.id||0) > (a.date||a.id||0) ? 1 : -1);
  return (
    <div className="fade-in" style={{ minHeight:"calc(100vh - 120px)" }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:20, flexWrap:"wrap", gap:12 }}>
        <div>
          <h1 className="section-title">Error Log</h1>
          <p className="section-sub">System errors captured from save operations. Last 50 entries stored.</p>
        </div>
        <button className="btn btn-secondary" style={{ color:"var(--accent-red)", borderColor:"var(--accent-red)" }} onClick={() => { setSaveErrors([]); localStorage.removeItem('ttp_error_log'); }}>
          Clear All Errors
        </button>
      </div>
      {sorted.length === 0 ? (
        <div className="card" style={{ padding:40, textAlign:"center" }}>
          <div style={{ fontSize:48, marginBottom:12 }}>✅</div>
          <div style={{ fontWeight:600, fontSize:16, color:"var(--accent-green)" }}>No errors logged</div>
          <div style={{ fontSize:13, color:"var(--stone-400)", marginTop:4 }}>System is running cleanly.</div>
        </div>
      ) : (
        <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
          {sorted.map(err => (
            <div key={err.id} className="card" style={{ padding:"14px 18px", borderLeft:"4px solid var(--accent-red)" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:10 }}>
                <div style={{ flex:1 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}>
                    <span style={{ fontSize:11, fontWeight:700, background:"rgba(192,97,74,0.12)", color:"var(--accent-red)", padding:"2px 8px", borderRadius:99, textTransform:"uppercase" }}>{err.key}</span>
                    <span style={{ fontSize:11, color:"var(--stone-400)" }}>{err.date ? new Date(err.date).toLocaleString() : new Date(err.id).toLocaleString()}</span>
                  </div>
                  <div style={{ fontSize:13, color:"var(--stone-700)", fontFamily:"monospace", background:"var(--stone-50)", padding:"8px 12px", borderRadius:"var(--radius)", lineHeight:1.6 }}>{err.msg}</div>
                </div>
                <button className="btn-icon" onClick={() => setSaveErrors(p => p.filter(e => e.id !== err.id))}><Icon name="x" size={14} color="var(--stone-400)"/></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// ── Login Screen ──────────────────────────────────────────────────────────────
const LoginScreen = ({ onLogin, users }) => {
  const [step, setStep]       = useState("select"); // "select" | "pin"
  const [selected, setSelected] = useState(null);
  const [pin, setPin]         = useState("");
  const [error, setError]     = useState("");
  const [shake, setShake]     = useState(false);
  const [verifying, setVerifying] = useState(false);

  const handleSelectUser = (user) => { setSelected(user); setPin(""); setError(""); setStep("pin"); };

  const handlePinDigit = async (d) => {
    if (verifying) return;
    const next = pin + d;
    setPin(next);
    if (next.length === 4) {
      setVerifying(true);
      try {
        // Validate PIN server-side — PINs never leave the database
        const { data: valid, error: rpcErr } = await supabase.rpc('validate_pin', {
          user_id: selected.id,
          entered_pin: next
        });
        if (rpcErr) throw rpcErr;
        if (valid) {
          await onLogin(selected);
        } else {
          setShake(true);
          setTimeout(() => { setShake(false); setPin(""); setError("Incorrect PIN — try again"); setVerifying(false); }, 600);
        }
      } catch (err) {
        console.error('[login] PIN validation error:', err);
        setShake(true);
        setTimeout(() => { setShake(false); setPin(""); setError("Login error — please try again"); setVerifying(false); }, 600);
      }
    }
  };

  const handlePinBack = () => { setPin(p => p.slice(0,-1)); setError(""); };

  return (
    <div style={{ minHeight:"100vh", background:"var(--stone-900)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}
      className="tile-pattern">
      <div style={{ width:"100%", maxWidth: step === "select" ? 520 : 380 }}>

        {/* Logo */}
        <div style={{ textAlign:"center", marginBottom:36 }}>
          <div style={{ width:60, height:60, borderRadius:16, background:"var(--warm-gold)", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 14px" }}>
            <Icon name="tile" size={28} color="white"/>
          </div>
          <div style={{ fontFamily:"var(--font-display)", fontSize:"26px", fontWeight:800, color:"white" }}>Timeless Tile Pro</div>
          <div style={{ fontSize:"12px", color:"var(--warm-gold)", letterSpacing:"0.12em", textTransform:"uppercase", marginTop:4 }}>Team Portal</div>
        </div>

        {/* User select */}
        {step === "select" && (
          <div className="fade-in">
            <div style={{ fontSize:"13px", color:"rgba(255,255,255,0.45)", textAlign:"center", marginBottom:18 }}>Select your profile to sign in</div>
            <div style={{ display:"grid", gap:10 }}>
              {users.filter(u => u.active !== false).map(u => {
                const role = ROLES[u.role];
                return (
                  <div key={u.id}
                    onClick={() => handleSelectUser(u)}
                    style={{ background:"rgba(255,255,255,0.06)", border:"1.5px solid rgba(255,255,255,0.08)", borderRadius:"var(--radius-lg)", padding:"14px 18px", cursor:"pointer", display:"flex", alignItems:"center", gap:14, transition:"all 0.18s" }}
                    onMouseEnter={e => { e.currentTarget.style.background="rgba(255,255,255,0.11)"; e.currentTarget.style.borderColor=role.color; }}
                    onMouseLeave={e => { e.currentTarget.style.background="rgba(255,255,255,0.06)"; e.currentTarget.style.borderColor="rgba(255,255,255,0.08)"; }}
                  >
                    <div style={{ width:42, height:42, borderRadius:"50%", background:role.color, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"14px", fontWeight:800, color:"white", flexShrink:0 }}>
                      {u.name.split(" ").map(n=>n[0]).join("")}
                    </div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontWeight:600, color:"white", fontSize:"15px" }}>{u.name}</div>
                      <div style={{ fontSize:"12px", color:"rgba(255,255,255,0.45)", marginTop:1 }}>{u.email}</div>
                    </div>
                    <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                      <span style={{ fontSize:14 }}>{role.badge}</span>
                      <span style={{ fontSize:"11px", fontWeight:700, color:role.color, background:`${role.color}22`, padding:"3px 9px", borderRadius:99 }}>{role.label}</span>
                    </div>
                  </div>
                );
              })}
            </div>
            <div style={{ textAlign:"center", marginTop:22, fontSize:"11px", color:"rgba(255,255,255,0.2)" }}>
              Demo system — select any profile to explore that access level
            </div>
          </div>
        )}

        {/* PIN entry */}
        {step === "pin" && selected && (
          <div className="fade-in">
            <div style={{ textAlign:"center", marginBottom:24 }}>
              <div style={{ width:52, height:52, borderRadius:"50%", background:ROLES[selected.role].color, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"16px", fontWeight:800, color:"white", margin:"0 auto 10px" }}>
                {selected.name.split(" ").map(n=>n[0]).join("")}
              </div>
              <div style={{ fontWeight:700, color:"white", fontSize:"16px" }}>{selected.name}</div>
              <div style={{ fontSize:"12px", color:"rgba(255,255,255,0.4)", marginTop:2 }}>{ROLES[selected.role].label}</div>
            </div>

            {/* PIN dots */}
            <div style={{ display:"flex", justifyContent:"center", gap:14, marginBottom:8 }}>
              {[0,1,2,3].map(i => (
                <div key={i} style={{ width:16, height:16, borderRadius:"50%", background: i < pin.length ? ROLES[selected.role].color : "rgba(255,255,255,0.15)", transition:"background 0.15s", animation: shake && i < pin.length ? "shake 0.4s" : "none" }}/>
              ))}
            </div>
            {error && <div style={{ textAlign:"center", fontSize:"12px", color:"var(--accent-red)", marginBottom:8 }}>{error}</div>}
            <div style={{ textAlign:"center", fontSize:"12px", color:"rgba(255,255,255,0.3)", marginBottom:22 }}>Enter 4-digit PIN</div>

            {/* PIN pad */}
            <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10, maxWidth:260, margin:"0 auto" }}>
              {[1,2,3,4,5,6,7,8,9].map(d => (
                <button key={d} onClick={() => handlePinDigit(String(d))}
                  style={{ height:56, borderRadius:"var(--radius)", background:"rgba(255,255,255,0.08)", border:"1.5px solid rgba(255,255,255,0.1)", color:"white", fontSize:"22px", fontWeight:600, cursor:"pointer", transition:"all 0.12s" }}
                  onMouseEnter={e => { e.currentTarget.style.background=`${ROLES[selected.role].color}33`; e.currentTarget.style.borderColor=ROLES[selected.role].color; }}
                  onMouseLeave={e => { e.currentTarget.style.background="rgba(255,255,255,0.08)"; e.currentTarget.style.borderColor="rgba(255,255,255,0.1)"; }}
                >{d}</button>
              ))}
              <button onClick={handlePinBack}
                style={{ height:56, borderRadius:"var(--radius)", background:"rgba(255,255,255,0.04)", border:"1.5px solid rgba(255,255,255,0.07)", color:"rgba(255,255,255,0.5)", fontSize:"18px", cursor:"pointer" }}
              >⌫</button>
              <button onClick={() => handlePinDigit("0")}
                style={{ height:56, borderRadius:"var(--radius)", background:"rgba(255,255,255,0.08)", border:"1.5px solid rgba(255,255,255,0.1)", color:"white", fontSize:"22px", fontWeight:600, cursor:"pointer", transition:"all 0.12s" }}
                onMouseEnter={e => { e.currentTarget.style.background=`${ROLES[selected.role].color}33`; e.currentTarget.style.borderColor=ROLES[selected.role].color; }}
                onMouseLeave={e => { e.currentTarget.style.background="rgba(255,255,255,0.08)"; e.currentTarget.style.borderColor="rgba(255,255,255,0.1)"; }}
              >0</button>
              <div/>
            </div>

            <button onClick={() => { setStep("select"); setPin(""); setError(""); }}
              style={{ display:"block", margin:"22px auto 0", background:"none", border:"none", color:"rgba(255,255,255,0.35)", fontSize:"12px", cursor:"pointer", textDecoration:"underline" }}>
              ← Switch profile
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

// ── Installer Job Portal (field-focused view for tradesmen) ──────────────────
const InstallerSchedule = ({ jobs, setJobs, estimates, events, currentUser, addNotification }) => {
  const [activeJob, setActiveJob] = useState(null);
  const [noteText, setNoteText] = useState("");
  const [tab, setTab] = useState("active"); // active | upcoming | completed
  const [view, setView] = useState("list"); // list | calendar
  const [calMonth, setCalMonth] = useState(new Date().getMonth());
  const [calYear, setCalYear] = useState(new Date().getFullYear());
  const fileRef = useRef();

  // Filter jobs assigned to this installer
  const myName = currentUser?.name?.toLowerCase() || "";
  const myJobs = jobs.filter(j => {
    const crewStr = (j.crewName || j.crew || "").toLowerCase();
    const crewList = crewStr.split(",").map(s => s.trim()).filter(Boolean);
    return crewList.includes(myName) || crewStr === myName;
  }).sort((a,b) => new Date(a.startDate || "2099") - new Date(b.startDate || "2099"));

  const todayLocal = new Date().toISOString().slice(0, 10);
  const active = myJobs.filter(j => j.status === "In Progress" || (j.status === "Scheduled" && (j.startDate || "9999") <= todayLocal));
  const upcoming = myJobs.filter(j => j.status === "Scheduled" && (j.startDate || "9999") > todayLocal);
  const completed = myJobs.filter(j => j.status === "Completed");
  const weekFromNow = new Date(Date.now() + 7 * 86400000).toISOString().slice(0, 10);
  const thisWeek = myJobs.filter(j => { const d = j.startDate || ""; return d <= weekFromNow && (j.endDate || d) >= todayLocal && j.status !== "Completed"; });

  const getEstimate = (estId) => (estimates || []).find(e => e.id === estId) || null;

  // Add a progress note
  const addNote = (jobId) => {
    if (!noteText.trim()) return;
    const now = new Date();
    const timestamp = `[${now.toLocaleDateString()} ${now.toLocaleTimeString('en-US',{hour:'numeric',minute:'2-digit',hour12:true})} · ${currentUser.name}]`;
    const newNote = `${timestamp} ${noteText.trim()}`;
    setJobs(prev => prev.map(j => j.id === jobId ? { ...j, notes: j.notes ? j.notes + "\n" + newNote : newNote } : j));
    if (addNotification) addNotification("job", `📝 ${currentUser.name} added a note on ${activeJob?.project || "a job"}`, "jobs");
    setNoteText("");
  };

  // Photo upload (with compression)
  const handlePhotoUpload = (e, jobId) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    files.forEach(file => {
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const compressed = await compressImage(ev.target.result);
        const photo = { src: compressed, name: file.name, date: new Date().toLocaleDateString(), tag: `Uploaded by ${currentUser.name}` };
        setJobs(prev => prev.map(j => j.id === jobId ? { ...j, photos: [...(j.photos||[]), photo] } : j));
      };
      reader.readAsDataURL(file);
    });
    if (addNotification) addNotification("job", `📸 ${currentUser.name} uploaded ${files.length} photo(s) for ${activeJob?.project || "a job"}`, "jobs");
    e.target.value = "";
  };

  // Update status
  const updateStatus = (jobId, newStatus) => {
    setJobs(prev => prev.map(j => j.id === jobId ? { ...j, status: newStatus } : j));
    if (addNotification) {
      const emoji = newStatus === "In Progress" ? "🔨" : newStatus === "Completed" ? "✅" : "📅";
      addNotification("job", `${emoji} ${currentUser.name} marked ${activeJob?.project || "job"} as ${newStatus}`, "jobs");
    }
  };

  const StatusBadge = ({ status }) => {
    const styles = { "In Progress":{ bg:"rgba(59,130,246,0.12)", color:"var(--accent-blue)" }, "Scheduled":{ bg:"rgba(122,158,126,0.12)", color:"var(--accent-green)" }, "Completed":{ bg:"var(--stone-200)", color:"var(--stone-500)" } };
    const s = styles[status] || styles.Scheduled;
    return <span style={{ fontSize:"11px", fontWeight:700, background:s.bg, color:s.color, padding:"4px 12px", borderRadius:99, textTransform:"uppercase", letterSpacing:"0.04em" }}>{status}</span>;
  };

  // ── Job Detail View ──
  if (activeJob) {
    const job = jobs.find(j => j.id === activeJob.id) || activeJob;
    const est = getEstimate(job.estimateId || job.estimate_id);

    return (
      <div className="fade-in">
        {/* Back button */}
        <button onClick={() => setActiveJob(null)} style={{ background:"none", border:"none", cursor:"pointer", display:"flex", alignItems:"center", gap:6, color:"var(--stone-500)", fontSize:13, fontWeight:600, marginBottom:16, padding:0 }}>
          ← Back to My Jobs
        </button>

        {/* Job header */}
        <div className="card" style={{ padding:"20px 24px", marginBottom:16, borderLeft:`4px solid ${job.status==="In Progress"?"var(--accent-blue)":job.status==="Completed"?"var(--stone-400)":"var(--accent-green)"}` }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:10, marginBottom:12 }}>
            <div>
              <div style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, marginBottom:4 }}>{job.project}</div>
              <div style={{ fontSize:14, color:"var(--stone-500)" }}>{job.customer}</div>
            </div>
            <StatusBadge status={job.status}/>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))", gap:12, fontSize:13 }}>
            {job.address && <div style={{ display:"flex", alignItems:"center", gap:6 }}><span>📍</span><span style={{ fontWeight:500 }}>{job.address}</span></div>}
            {job.startDate && <div style={{ display:"flex", alignItems:"center", gap:6 }}><span>📅</span><span>{job.startDate}{job.endDate ? ` → ${job.endDate}` : ''}</span></div>}
            {(job.estimatedDays || 0) > 1 && <div style={{ display:"flex", alignItems:"center", gap:6 }}><span>⏱</span><span>{job.estimatedDays} day project</span></div>}
            {(job.crewName || job.crew) && <div style={{ display:"flex", alignItems:"center", gap:6 }}><span>👷</span><span>{job.crewName || job.crew}</span></div>}
          </div>

          {/* Crew Role Notes */}
          {(job.crewNotes || job.crew_notes || []).length > 0 && (
            <div style={{ marginTop:12, padding:"10px 14px", background:"rgba(201,169,110,0.06)", borderRadius:"var(--radius)", border:"1px solid rgba(201,169,110,0.12)" }}>
              <div style={{ fontSize:10, fontWeight:600, color:"var(--warm-gold)", textTransform:"uppercase", letterSpacing:".04em", marginBottom:8 }}>📋 Crew Roles</div>
              <div style={{ display:"flex", flexDirection:"column", gap:4 }}>
                {(job.crewNotes || job.crew_notes || []).map((cn, ci) => (
                  <div key={ci} style={{ fontSize:13, display:"flex", gap:6, alignItems:"center" }}>
                    <span style={{ fontWeight:600, color:"var(--stone-700)", minWidth:80 }}>{cn.name?.split(" ")[0]}</span>
                    <span style={{ color:"var(--stone-300)" }}>—</span>
                    <span style={{ color:"var(--stone-600)" }}>{cn.note}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Status update buttons */}
          {job.status !== "Completed" && (
            <div style={{ display:"flex", gap:8, marginTop:16, paddingTop:14, borderTop:"1px solid var(--stone-200)" }}>
              {job.status === "Scheduled" && <button className="btn btn-primary" style={{ fontSize:13 }} onClick={() => updateStatus(job.id, "In Progress")}>🔨 Start Job</button>}
              {job.status === "In Progress" && <button className="btn btn-primary" style={{ background:"var(--accent-green)", borderColor:"var(--accent-green)", fontSize:13 }} onClick={() => updateStatus(job.id, "Completed")}>✅ Mark Complete</button>}
            </div>
          )}
        </div>

        {/* Scope of Work (no pricing) */}
        {est && est.items && (
          <div className="card" style={{ padding:"18px 22px", marginBottom:16 }}>
            <div style={{ fontFamily:"var(--font-display)", fontSize:16, fontWeight:700, marginBottom:12, display:"flex", alignItems:"center", gap:8 }}>
              <Icon name="estimate" size={16} color="var(--warm-gold)"/>
              Scope of Work
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
              {est.items.map((item, i) => (
                <div key={i} style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 14px", background:"var(--stone-50)", borderRadius:"var(--radius)", borderLeft:"3px solid var(--warm-gold)" }}>
                  <span style={{ fontSize:14, color:"var(--accent-green)" }}>✓</span>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:600, fontSize:14 }}>{item.desc}</div>
                    <div style={{ fontSize:12, color:"var(--stone-400)" }}>{item.qty} {item.unit}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Progress Photos */}
        <div className="card" style={{ padding:"18px 22px", marginBottom:16 }}>
          <div style={{ fontFamily:"var(--font-display)", fontSize:16, fontWeight:700, marginBottom:12, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <span>📸 Progress Photos ({(job.photos||[]).length})</span>
            <button className="btn btn-sm" style={{ background:"var(--warm-gold)", color:"white", border:"none", fontSize:12 }} onClick={() => fileRef.current?.click()}>
              + Upload Photo
            </button>
            <input ref={fileRef} type="file" accept="image/*" multiple hidden onChange={e => handlePhotoUpload(e, job.id)} />
          </div>
          {(job.photos||[]).length === 0 ? (
            <div onClick={() => fileRef.current?.click()} style={{ padding:"28px", textAlign:"center", border:"2px dashed var(--stone-300)", borderRadius:"var(--radius)", cursor:"pointer", color:"var(--stone-400)", fontSize:13 }}>
              <div style={{ fontSize:28, marginBottom:6 }}>📷</div>
              Tap to upload progress photos
            </div>
          ) : (
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(100px,1fr))", gap:8 }}>
              {(job.photos||[]).map((p, i) => (
                <div key={i} style={{ aspectRatio:"1", borderRadius:10, overflow:"hidden", border:"1px solid var(--stone-200)" }}>
                  <img src={p.src || p} alt={p.name || ''} style={{ width:"100%", height:"100%", objectFit:"cover" }}/>
                </div>
              ))}
              <div onClick={() => fileRef.current?.click()} style={{ aspectRatio:"1", borderRadius:10, border:"2px dashed var(--stone-300)", display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer", color:"var(--stone-400)", fontSize:24 }}>+</div>
            </div>
          )}
        </div>

        {/* Notes / Updates */}
        <div className="card" style={{ padding:"18px 22px" }}>
          <div style={{ fontFamily:"var(--font-display)", fontSize:16, fontWeight:700, marginBottom:12 }}>📝 Job Notes & Updates</div>

          {/* Existing notes */}
          {job.notes ? (
            <div style={{ marginBottom:14, maxHeight:300, overflowY:"auto" }}>
              {job.notes.split("\n").filter(Boolean).map((line, i) => {
                const isTimestamped = line.startsWith("[");
                return (
                  <div key={i} style={{ padding:"8px 12px", marginBottom:4, borderRadius:"var(--radius)", background: isTimestamped ? "rgba(201,169,110,0.06)" : "var(--stone-50)", borderLeft: isTimestamped ? "3px solid var(--warm-gold)" : "3px solid var(--stone-200)", fontSize:13, lineHeight:1.6, color:"var(--stone-700)" }}>
                    {line}
                  </div>
                );
              })}
            </div>
          ) : (
            <div style={{ padding:"16px", textAlign:"center", color:"var(--stone-400)", fontSize:13, marginBottom:14 }}>No notes yet — add your first update below.</div>
          )}

          {/* Add note */}
          <div style={{ display:"flex", gap:8 }}>
            <textarea value={noteText} onChange={e => setNoteText(e.target.value)} rows={2}
              placeholder="Add a progress update, issue, or note…"
              style={{ flex:1, padding:"10px 14px", border:"1.5px solid var(--stone-300)", borderRadius:"var(--radius)", fontSize:13, resize:"vertical" }}
              onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); addNote(job.id); } }}
            />
            <button onClick={() => addNote(job.id)} disabled={!noteText.trim()}
              style={{ padding:"10px 16px", background: noteText.trim() ? "var(--warm-gold)" : "var(--stone-200)", color:"white", border:"none", borderRadius:"var(--radius)", cursor: noteText.trim() ? "pointer" : "default", fontWeight:600, fontSize:13, alignSelf:"flex-end" }}>
              Add
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ── Job List View ──
  const jobList = tab === "active" ? active : tab === "upcoming" ? upcoming : completed;

  return (
    <div className="fade-in">
      <div style={{ marginBottom:22 }}>
        <h1 className="section-title">My Jobs</h1>
        <p className="section-sub">Your assigned projects — tap a job to view details, upload photos, or add notes.</p>
      </div>

      {/* Quick stats */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))", gap:12, marginBottom:24 }}>
        {[
          ["Active", active.length, "var(--accent-blue)"],
          ["Upcoming", upcoming.length, "var(--accent-green)"],
          ["This Week", thisWeek.length, "var(--warm-gold)"],
          ["Completed", completed.length, "var(--stone-400)"],
        ].map(([l,v,c]) => (
          <div key={l} className="stat-card">
            <div className="stat-value" style={{ color:c }}>{v}</div>
            <div className="stat-label">{l}</div>
          </div>
        ))}
      </div>

      {/* View Toggle */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20, flexWrap:"wrap", gap:10 }}>
        <div style={{ display:"flex", gap:"4px", background:"var(--stone-200)", borderRadius:"var(--radius)", padding:"3px" }}>
          <button onClick={() => setView("list")} style={{
            padding:"7px 16px", borderRadius:6, border:"none", cursor:"pointer", fontSize:13, fontWeight:600,
            background: view==="list" ? "white" : "transparent", color: view==="list" ? "var(--stone-900)" : "var(--stone-500)",
            boxShadow: view==="list" ? "0 1px 4px rgba(0,0,0,0.1)" : "none"
          }}>📋 List</button>
          <button onClick={() => setView("calendar")} style={{
            padding:"7px 16px", borderRadius:6, border:"none", cursor:"pointer", fontSize:13, fontWeight:600,
            background: view==="calendar" ? "white" : "transparent", color: view==="calendar" ? "var(--stone-900)" : "var(--stone-500)",
            boxShadow: view==="calendar" ? "0 1px 4px rgba(0,0,0,0.1)" : "none"
          }}>📅 Calendar</button>
        </div>
      </div>

      {/* ═══ CALENDAR VIEW ═══ */}
      {view === "calendar" && (() => {
        const monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
        const firstDay = new Date(calYear, calMonth, 1).getDay();
        const daysInMonth = new Date(calYear, calMonth + 1, 0).getDate();
        const cells = [];
        const prevDays = new Date(calYear, calMonth, 0).getDate();
        for (let i = firstDay - 1; i >= 0; i--) cells.push({ day: prevDays - i, thisMonth: false });
        for (let i = 1; i <= daysInMonth; i++) cells.push({ day: i, thisMonth: true });
        while (cells.length % 7 !== 0) cells.push({ day: cells.length - daysInMonth - firstDay + 1, thisMonth: false });
        const getDateStr = (day) => `${calYear}-${String(calMonth+1).padStart(2,"0")}-${String(day).padStart(2,"0")}`;

        // Get events for this installer
        const myEvents = (events || []).filter(e => {
          if (e.type !== "job") return false; // Only show jobs, not quotes/follow-ups
          const crew = (e.crew || "").toLowerCase();
          return crew === myName;
        });

        const today = new Date();
        const todayStr = today.toISOString().slice(0,10);

        return (
          <div>
            <div style={{ display:"flex", alignItems:"center", gap:16, marginBottom:16 }}>
              <button className="btn btn-ghost" onClick={() => { if (calMonth===0) { setCalMonth(11); setCalYear(y=>y-1); } else setCalMonth(m=>m-1); }}>‹</button>
              <h2 style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:600, minWidth:180, textAlign:"center" }}>{monthNames[calMonth]} {calYear}</h2>
              <button className="btn btn-ghost" onClick={() => { if (calMonth===11) { setCalMonth(0); setCalYear(y=>y+1); } else setCalMonth(m=>m+1); }}>›</button>
            </div>
            <div className="card" style={{ padding:0, overflow:"hidden" }}>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", background:"var(--stone-800)" }}>
                {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map(d => (
                  <div key={d} style={{ padding:8, textAlign:"center", fontSize:11, fontWeight:600, color:"var(--stone-300)", letterSpacing:"0.06em", textTransform:"uppercase" }}>{d}</div>
                ))}
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)" }}>
                {cells.map((cell, i) => {
                  const isToday = cell.thisMonth && getDateStr(cell.day) === todayStr;
                  const dayEvents = cell.thisMonth ? myEvents.filter(e => e.date === getDateStr(cell.day)) : [];
                  return (
                    <div key={i} className={`cal-day${isToday?" today":""}${!cell.thisMonth?" other-month":""}`}>
                      <div style={{ fontWeight: isToday?700:400, fontSize:13, color: isToday?"var(--warm-gold)":"inherit" }}>{cell.day}</div>
                      {dayEvents.map(ev => {
                        const isJob = ev.type === "job";
                        return (
                          <div key={ev.id} className={`cal-event${isJob?" job":""}`} style={{ cursor:"pointer", fontSize:10 }}
                            onClick={() => { if (isJob && ev.jobId) { const j = jobs.find(jj => jj.id === ev.jobId); if (j) setActiveJob(j); } }}
                            title={[ev.title, ev.address?`📍 ${ev.address}`:'', ev.crew?`👷 ${ev.crew}`:''].filter(Boolean).join('\n')}
                          >
                            {isJob && ev.multiDay && <span style={{ fontWeight:700, opacity:0.7 }}>D{ev.dayNum}/{ev.totalDays} </span>}
                            {ev.title}
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })()}

      {/* ═══ LIST VIEW ═══ */}
      {view === "list" && (<>
      {/* Tabs */}
      <div style={{ display:"flex", gap:"4px", background:"var(--stone-200)", borderRadius:"var(--radius)", padding:"4px", marginBottom:20, maxWidth:400 }}>
        {[
          { id:"active", label:"Active", count:active.length },
          { id:"upcoming", label:"Upcoming", count:upcoming.length },
          { id:"completed", label:"Completed", count:completed.length },
        ].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            flex:1, padding:"8px 14px", borderRadius:6, border:"none", cursor:"pointer",
            background: tab===t.id ? "white" : "transparent",
            color: tab===t.id ? "var(--stone-900)" : "var(--stone-500)",
            fontWeight: tab===t.id ? 700 : 500, fontSize:13,
            boxShadow: tab===t.id ? "0 1px 4px rgba(0,0,0,0.1)" : "none",
            transition:"all 0.15s"
          }}>
            {t.label}
            {t.count > 0 && <span style={{ marginLeft:6, background: tab===t.id ? "var(--warm-gold)" : "var(--stone-300)", color:"white", fontSize:10, fontWeight:800, padding:"1px 6px", borderRadius:99 }}>{t.count}</span>}
          </button>
        ))}
      </div>

      {/* Job cards */}
      {jobList.length === 0 ? (
        <div className="card" style={{ padding:40, textAlign:"center" }}>
          <div style={{ fontSize:36, marginBottom:10 }}>{tab==="active"?"🔨":tab==="upcoming"?"📅":"✅"}</div>
          <div style={{ fontWeight:600, color:"var(--stone-500)" }}>No {tab} jobs</div>
          <div style={{ fontSize:13, color:"var(--stone-400)", marginTop:4 }}>
            {tab==="active"?"No jobs currently in progress.":tab==="upcoming"?"No upcoming jobs scheduled.":"No completed jobs yet."}
          </div>
        </div>
      ) : (
        <div style={{ display:"grid", gap:10 }}>
          {jobList.map(job => (
            <div key={job.id} onClick={() => setActiveJob(job)} className="card" style={{
              padding:"16px 20px", cursor:"pointer", transition:"all 0.15s",
              borderLeft:`4px solid ${job.status==="In Progress"?"var(--accent-blue)":job.status==="Completed"?"var(--stone-300)":"var(--accent-green)"}`
            }}
              onMouseEnter={e => e.currentTarget.style.transform="translateX(4px)"}
              onMouseLeave={e => e.currentTarget.style.transform="none"}
            >
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:10 }}>
                <div style={{ flex:1 }}>
                  <div style={{ fontWeight:700, fontSize:16, marginBottom:4 }}>{job.project}</div>
                  <div style={{ fontSize:13, color:"var(--stone-500)", marginBottom:6 }}>{job.customer}</div>
                  <div style={{ display:"flex", gap:14, flexWrap:"wrap", fontSize:12, color:"var(--stone-400)" }}>
                    {job.address && <span>📍 {job.address}</span>}
                    {job.startDate && <span>📅 {job.startDate}{job.endDate && job.endDate !== job.startDate ? ` → ${job.endDate}` : ''}</span>}
                    {(job.estimatedDays||0) > 1 && <span>⏱ {job.estimatedDays} days</span>}
                  </div>
                </div>
                <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:6 }}>
                  <StatusBadge status={job.status}/>
                  <div style={{ display:"flex", gap:8, fontSize:11, color:"var(--stone-400)" }}>
                    {(job.photos||[]).length > 0 && <span>📸 {job.photos.length}</span>}
                    {job.notes && <span>📝</span>}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      </>)}
    </div>
  );
};

// ── Reports Placeholder ───────────────────────────────────────────────────────
// ═══════════════════════════════════════════════════════════════════════════════
// ── MARKETING CENTER ─────────────────────────────────────────────────────────
// ═══════════════════════════════════════════════════════════════════════════════

// Simulated campaign data — replaced by live API data when connected
const DEMO_CAMPAIGNS = {
  google: [
    { id:"g1", name:"Tile Installation – VA Beach", status:"Active",   budget:800,  spend:612,  impressions:28400, clicks:834, conversions:14, cpc:0.73, ctr:2.94, roas:6.2, startDate:"2024-03-01", type:"Search" },
    { id:"g2", name:"Bathroom Remodel – Chesapeake", status:"Active",  budget:600,  spend:490,  impressions:19200, clicks:521, conversions:9,  cpc:0.94, ctr:2.71, roas:5.1, startDate:"2024-03-01", type:"Search" },
    { id:"g3", name:"Kitchen Tile – Norfolk",        status:"Paused",  budget:400,  spend:318,  impressions:11800, clicks:290, conversions:4,  cpc:1.10, ctr:2.46, roas:3.8, startDate:"2024-02-15", type:"Search" },
    { id:"g4", name:"Outdoor Tile Remarketing",      status:"Active",  budget:300,  spend:187,  impressions:42100, clicks:213, conversions:6,  cpc:0.88, ctr:0.51, roas:7.4, startDate:"2024-03-10", type:"Display" },
  ],
  meta: [
    { id:"m1", name:"Tile Before/After – Carousel",  status:"Active",  budget:500,  spend:441,  impressions:54200, clicks:712, conversions:11, cpc:0.62, ctr:1.31, roas:5.8, startDate:"2024-03-01", reach:31400, type:"Facebook" },
    { id:"m2", name:"Luxury Bath Remodel – Video",   status:"Active",  budget:600,  spend:573,  impressions:67800, clicks:891, conversions:15, cpc:0.64, ctr:1.31, roas:6.4, startDate:"2024-03-05", reach:44200, type:"Instagram" },
    { id:"m3", name:"VA Beach Homeowners – Lead Gen", status:"Active", budget:400,  spend:356,  impressions:38900, clicks:504, conversions:8,  cpc:0.71, ctr:1.30, roas:5.2, startDate:"2024-03-08", reach:27600, type:"Facebook" },
    { id:"m4", name:"Retargeting – Site Visitors",   status:"Paused",  budget:200,  spend:142,  impressions:15300, clicks:198, conversions:5,  cpc:0.72, ctr:1.29, roas:8.1, startDate:"2024-02-20", reach:9800,  type:"Meta" },
  ],
};

// Weekly spend trend (last 8 weeks, simulated)
const SPEND_TREND = [
  { week:"Jan 29", google:210, meta:180 },
  { week:"Feb 5",  google:245, meta:210 },
  { week:"Feb 12", google:290, meta:255 },
  { week:"Feb 19", google:318, meta:298 },
  { week:"Feb 26", google:376, meta:334 },
  { week:"Mar 4",  google:421, meta:388 },
  { week:"Mar 11", google:448, meta:412 },
  { week:"Mar 18", google:462, meta:441 },
];

// ── Marketing component ───────────────────────────────────────────────────────
const Marketing = ({ leads }) => {
  const [activeTab,    setActiveTab]    = useState("overview");
  const [connections,  setConnections]  = useState({ google: false, meta: false });
  const [connecting,   setConnecting]   = useState(null);   // "google"|"meta"|null
  const [connForm,     setConnForm]     = useState({ customerId:"", accountId:"", developerToken:"", accessToken:"", appId:"", appSecret:"" });
  const [campaigns,    setCampaigns]    = useState(DEMO_CAMPAIGNS);
  const [lastRefresh,  setLastRefresh]  = useState(new Date());
  const [refreshing,   setRefreshing]   = useState(false);
  const [budgetModal,  setBudgetModal]  = useState(null);   // campaign obj
  const [budgetEdit,   setBudgetEdit]   = useState("");
  const [insightIdx,   setInsightIdx]   = useState(0);

  const isDemo = !connections.google && !connections.meta;

  // ── Simulate API refresh ──
  const handleRefresh = () => {
    setRefreshing(true);
    setTimeout(() => { setLastRefresh(new Date()); setRefreshing(false); }, 1400);
  };

  // ── Simulate connect ──
  const handleConnect = (platform) => {
    setRefreshing(true);
    setTimeout(() => {
      setConnections(p => ({ ...p, [platform]: true }));
      setConnecting(null);
      setConnForm({ customerId:"", accountId:"", developerToken:"", accessToken:"", appId:"", appSecret:"" });
      setRefreshing(false);
    }, 1800);
  };

  const handleDisconnect = (platform) => setConnections(p => ({ ...p, [platform]: false }));

  // ── Aggregate all campaigns ──
  const allCampaigns  = [...campaigns.google, ...campaigns.meta];
  const activeCampaigns = allCampaigns.filter(c => c.status === "Active");

  const totalSpend       = allCampaigns.reduce((a,c) => a + c.spend, 0);
  const totalBudget      = allCampaigns.reduce((a,c) => a + c.budget, 0);
  const totalImpressions = allCampaigns.reduce((a,c) => a + c.impressions, 0);
  const totalClicks      = allCampaigns.reduce((a,c) => a + c.clicks, 0);
  const totalConversions = allCampaigns.reduce((a,c) => a + c.conversions, 0);
  const avgCTR           = totalImpressions > 0 ? ((totalClicks / totalImpressions) * 100).toFixed(2) : 0;
  const avgCPC           = totalClicks > 0 ? (totalSpend / totalClicks).toFixed(2) : 0;
  const avgROAS          = allCampaigns.length > 0 ? (allCampaigns.reduce((a,c) => a + c.roas, 0) / allCampaigns.length).toFixed(1) : 0;
  const costPerLead      = totalConversions > 0 ? (totalSpend / totalConversions).toFixed(2) : 0;

  // Cross-reference leads attributed to paid campaigns
  const paidLeads = leads.filter(l => ["Google","Facebook","Instagram"].includes(l.source));
  const paidLeadValue = paidLeads.reduce((a,l) => a + (l.value||0), 0);
  const estimatedRevROAS = totalSpend > 0 ? (paidLeadValue / totalSpend).toFixed(1) : 0;

  // AI-style insights (cycling)
  const INSIGHTS = [
    { icon:"🏆", color:"var(--accent-green)",  title:"Best Performer",     body:`Your Meta "Luxury Bath – Video" campaign is driving the highest ROAS at 6.4x. Consider increasing its budget by 20–30% to scale what's working.` },
    { icon:"⚠️", color:"var(--accent-amber)",  title:"Budget Pacing Alert", body:`Google "Kitchen Tile – Norfolk" is paused but has remaining monthly budget. Resume or reallocate $82 toward your top Search campaigns before month end.` },
    { icon:"🎯", color:"var(--accent-blue)",   title:"Audience Opportunity",body:`Your Google Display remarketing is showing 7.4x ROAS — the highest of all campaigns — with only $300 budget. This audience converts well; increase to $600–800/mo.` },
    { icon:"📍", color:"var(--warm-gold)",     title:"Geographic Insight",  body:`VA Beach and Chesapeake are your top-converting markets. Consider adding a "Norfolk + Portsmouth" Search campaign to capture the underserved southern market.` },
    { icon:"📸", color:"var(--accent-blue)",   title:"Creative Insight",    body:`Before/after photo carousel ads typically outperform static images by 2–3x in home services. Ensure your Meta creatives include project transformation imagery.` },
    { icon:"🔗", color:"var(--accent-green)",  title:"CRM Attribution",     body:`${paidLeads.length} leads in your CRM are attributed to paid channels with a combined value of $${paidLeadValue.toLocaleString()}. Your estimated blended ROAS is ${estimatedRevROAS}x.` },
  ];

  // ── Spend trend mini-chart ──
  const SpendTrendChart = () => {
    const maxVal = Math.max(...SPEND_TREND.flatMap(w => [w.google, w.meta]));
    return (
      <div style={{ display:"flex", alignItems:"flex-end", gap:6, height:80, padding:"0 4px" }}>
        {SPEND_TREND.map((w,i) => (
          <div key={i} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", gap:2, height:"100%", justifyContent:"flex-end" }}>
            <div style={{ width:"100%", display:"flex", flexDirection:"column", gap:1 }}>
              <div style={{ width:"100%", height:`${(w.google/maxVal)*60}px`, background:"#4285f4", borderRadius:"2px 2px 0 0", minHeight:3 }}/>
              <div style={{ width:"100%", height:`${(w.meta/maxVal)*60}px`, background:"#1877f2", borderRadius:"0 0 2px 2px", minHeight:3 }}/>
            </div>
            <div style={{ fontSize:"9px", color:"var(--stone-400)", whiteSpace:"nowrap", transform:"rotate(-35deg)", transformOrigin:"top center", marginTop:4 }}>{w.week.split(" ")[1]}</div>
          </div>
        ))}
      </div>
    );
  };

  // ── Platform badge ──
  const PlatformBadge = ({ platform, size = "sm" }) => {
    const cfg = {
      google: { label:"Google Ads",  bg:"#4285f420", color:"#4285f4", dot:"#4285f4"  },
      meta:   { label:"Meta Ads",    bg:"#1877f220", color:"#1877f2", dot:"#1877f2"  },
      Search:    { label:"Search",     bg:"#4285f420", color:"#4285f4", dot:"#4285f4"  },
      Display:   { label:"Display",    bg:"#34a85320", color:"#34a853", dot:"#34a853"  },
      Facebook:  { label:"Facebook",   bg:"#1877f220", color:"#1877f2", dot:"#1877f2"  },
      Instagram: { label:"Instagram",  bg:"#e1306c20", color:"#e1306c", dot:"#e1306c"  },
      Meta:      { label:"Meta",       bg:"#1877f220", color:"#1877f2", dot:"#1877f2"  },
    };
    const c = cfg[platform] || cfg.google;
    return (
      <span style={{ fontSize: size==="sm" ? "11px" : "12px", fontWeight:700, background:c.bg, color:c.color, padding:"3px 9px", borderRadius:99, display:"inline-flex", alignItems:"center", gap:5 }}>
        <span style={{ width:6, height:6, borderRadius:"50%", background:c.dot, display:"inline-block" }}/>
        {c.label}
      </span>
    );
  };

  // ── Status badge ──
  const StatusBadge = ({ status }) => (
    <span style={{ fontSize:"11px", fontWeight:700,
      background: status==="Active" ? "rgba(40,167,69,0.12)" : "rgba(108,117,125,0.12)",
      color:       status==="Active" ? "var(--accent-green)"  : "var(--stone-400)",
      padding:"3px 9px", borderRadius:99, display:"inline-flex", alignItems:"center", gap:5 }}>
      <span style={{ width:5, height:5, borderRadius:"50%", background: status==="Active" ? "var(--accent-green)" : "var(--stone-400)", display:"inline-block" }}/>
      {status}
    </span>
  );

  // ── ROAS color ──
  const roasColor = (r) => r >= 6 ? "var(--accent-green)" : r >= 4 ? "var(--warm-gold)" : r >= 2 ? "var(--accent-amber)" : "var(--accent-red)";

  const fmt  = (n) => `$${Number(n).toLocaleString()}`;
  const fmtK = (n) => n >= 1000 ? `${(n/1000).toFixed(1)}k` : String(n);

  // ── Platform connection cards ──
  const PlatformConnector = ({ platform, label, color, icon, fields }) => {
    const connected = connections[platform];
    return (
      <div className="card" style={{ padding:"20px", borderTop:`3px solid ${color}` }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14 }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ width:38, height:38, borderRadius:10, background:`${color}18`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:20 }}>{icon}</div>
            <div>
              <div style={{ fontWeight:700, fontSize:"15px" }}>{label}</div>
              <div style={{ fontSize:"11px", color: connected ? "var(--accent-green)" : "var(--stone-400)", marginTop:1, fontWeight:600 }}>
                {connected ? "● Connected" : "○ Not connected"}
              </div>
            </div>
          </div>
          {connected
            ? <button className="btn btn-sm" style={{ background:"rgba(220,53,69,0.08)", color:"var(--accent-red)", border:"none", fontSize:"11px" }} onClick={() => handleDisconnect(platform)}>Disconnect</button>
            : <button className="btn btn-primary btn-sm" style={{ background:color, borderColor:color, fontSize:"12px" }} onClick={() => setConnecting(platform)}>Connect</button>
          }
        </div>
        {connected ? (
          <div style={{ background:"var(--stone-100)", borderRadius:"var(--radius)", padding:"10px 14px" }}>
            <div style={{ fontSize:"12px", color:"var(--stone-600)", display:"flex", justifyContent:"space-between" }}>
              <span>Syncing live campaign data</span>
              <span style={{ color:"var(--accent-green)", fontWeight:600 }}>✓ Active</span>
            </div>
            <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:3 }}>Last refreshed: {lastRefresh.toLocaleTimeString()}</div>
          </div>
        ) : (
          <div style={{ fontSize:"12px", color:"var(--stone-500)", lineHeight:1.6 }}>
            Connect your {label} account to pull live impressions, clicks, spend, conversions, and ROAS directly into this dashboard.
          </div>
        )}
        {!connected && (
          <div style={{ marginTop:12, display:"flex", flexDirection:"column", gap:6 }}>
            {fields.map(f => (
              <div key={f.key} style={{ fontSize:"11px" }}>
                <div style={{ color:"var(--stone-500)", marginBottom:2, fontWeight:600 }}>{f.label}</div>
                <div style={{ fontSize:"11px", color:"var(--stone-400)", fontStyle:"italic", lineHeight:1.5 }}>{f.hint}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const TABS = [
    { id:"overview",   label:"Overview",    icon:"📊" },
    { id:"google",     label:"Google Ads",  icon:"🔍" },
    { id:"meta",       label:"Meta Ads",    icon:"📘" },
    { id:"attribution",label:"Attribution", icon:"🔗" },
    { id:"setup",      label:"API Setup",   icon:"⚙️" },
  ];

  return (
    <div className="fade-in">
      {/* ── Header ── */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:20, flexWrap:"wrap", gap:12 }}>
        <div>
          <h1 className="section-title">Marketing Center</h1>
          <p className="section-sub">Campaign performance, spend tracking, and lead attribution across Google & Meta.</p>
        </div>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          {isDemo && (
            <span style={{ fontSize:"11px", fontWeight:700, background:"rgba(201,169,110,0.15)", color:"var(--warm-gold)", padding:"4px 10px", borderRadius:99, border:"1px solid rgba(201,169,110,0.3)" }}>
              ✦ Demo Data — Connect APIs for live stats
            </span>
          )}
          <button className="btn btn-secondary btn-sm" onClick={handleRefresh} style={{ display:"flex", alignItems:"center", gap:6 }}>
            <Icon name="refresh" size={13} color={refreshing ? "var(--warm-gold)" : "currentColor"}/>
            {refreshing ? "Refreshing…" : "Refresh"}
          </button>
        </div>
      </div>

      {/* ── Tab nav ── */}
      <div style={{ display:"flex", gap:4, marginBottom:26, flexWrap:"wrap", borderBottom:"2px solid var(--stone-200)", paddingBottom:0 }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setActiveTab(t.id)}
            style={{ display:"flex", alignItems:"center", gap:6, padding:"9px 14px", border:"none",
              borderBottom: activeTab===t.id ? "2px solid var(--warm-gold)" : "2px solid transparent",
              marginBottom:"-2px", background:"transparent", fontSize:"13px",
              fontWeight: activeTab===t.id ? 700 : 500,
              color: activeTab===t.id ? "var(--warm-gold)" : "var(--stone-500)",
              cursor:"pointer", transition:"all 0.15s", borderRadius:"4px 4px 0 0" }}>
            <span>{t.icon}</span>{t.label}
            {t.id==="setup" && (connections.google || connections.meta) && (
              <span style={{ width:7, height:7, borderRadius:"50%", background:"var(--accent-green)", display:"inline-block", marginLeft:2 }}/>
            )}
          </button>
        ))}
      </div>

      {/* ════════ OVERVIEW ════════ */}
      {activeTab === "overview" && (
        <div className="fade-in">
          {/* Top KPIs */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(175px,1fr))", gap:12, marginBottom:24 }}>
            {[
              { label:"Total Spend",       value: fmt(totalSpend),          sub:`of ${fmt(totalBudget)} budget`,        color:"var(--accent-red)",   icon:"💸" },
              { label:"Impressions",       value: fmtK(totalImpressions),   sub:`${activeCampaigns.length} active campaigns`, color:"var(--accent-blue)", icon:"👁" },
              { label:"Clicks",            value: fmtK(totalClicks),        sub:`${avgCTR}% avg CTR`,                   color:"var(--warm-gold)",    icon:"👆" },
              { label:"Conversions",       value: totalConversions,         sub:`$${costPerLead} cost per lead`,         color:"var(--accent-green)", icon:"🎯" },
              { label:"Avg CPC",           value:`$${avgCPC}`,              sub:"Cost per click",                       color:"var(--stone-600)",    icon:"💲" },
              { label:"Blended ROAS",      value:`${avgROAS}x`,             sub:"Return on ad spend",                   color: roasColor(Number(avgROAS)), icon:"📈" },
            ].map(k => (
              <div key={k.label} className="card" style={{ padding:"16px 18px" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
                  <div style={{ fontSize:"11px", fontWeight:600, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.07em" }}>{k.label}</div>
                  <span style={{ fontSize:16 }}>{k.icon}</span>
                </div>
                <div style={{ fontFamily:"var(--font-display)", fontSize:"26px", fontWeight:800, color:k.color, lineHeight:1, marginBottom:5 }}>{k.value}</div>
                <div style={{ fontSize:"11px", color:"var(--stone-400)" }}>{k.sub}</div>
              </div>
            ))}
          </div>

          {/* Spend trend + budget utilization */}
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:24 }}>
            <div className="card" style={{ padding:"20px" }}>
              <div style={{ fontWeight:700, fontSize:"14px", marginBottom:2 }}>Weekly Spend Trend</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:16 }}>Google vs. Meta — last 8 weeks</div>
              <SpendTrendChart/>
              <div style={{ display:"flex", gap:16, marginTop:16, fontSize:"12px" }}>
                <div style={{ display:"flex", alignItems:"center", gap:6 }}><div style={{ width:10, height:10, borderRadius:2, background:"#4285f4" }}/> Google Ads</div>
                <div style={{ display:"flex", alignItems:"center", gap:6 }}><div style={{ width:10, height:10, borderRadius:2, background:"#1877f2" }}/> Meta Ads</div>
              </div>
            </div>

            <div className="card" style={{ padding:"20px" }}>
              <div style={{ fontWeight:700, fontSize:"14px", marginBottom:2 }}>Budget Utilization</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:16 }}>Spend vs. monthly budget per campaign</div>
              <div style={{ display:"grid", gap:8 }}>
                {allCampaigns.slice(0,5).map(c => {
                  const pct = Math.min((c.spend / c.budget) * 100, 100);
                  const barColor = pct > 90 ? "var(--accent-red)" : pct > 70 ? "var(--accent-amber)" : "var(--accent-green)";
                  return (
                    <div key={c.id}>
                      <div style={{ display:"flex", justifyContent:"space-between", fontSize:"11px", marginBottom:3 }}>
                        <span style={{ color:"var(--stone-600)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:200 }}>{c.name}</span>
                        <span style={{ fontWeight:700, color:barColor, flexShrink:0, marginLeft:8 }}>{fmt(c.spend)} / {fmt(c.budget)}</span>
                      </div>
                      <div style={{ height:5, background:"var(--stone-200)", borderRadius:3 }}>
                        <div style={{ height:"100%", width:`${pct}%`, background:barColor, borderRadius:3, transition:"width 0.5s" }}/>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* AI Insights carousel */}
          <div style={{ marginBottom:24 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
              <div style={{ fontFamily:"var(--font-display)", fontSize:"16px", fontWeight:700 }}>
                ✦ Campaign Insights
              </div>
              <div style={{ display:"flex", gap:6 }}>
                <button className="btn btn-secondary btn-sm" onClick={() => setInsightIdx(i => (i - 1 + INSIGHTS.length) % INSIGHTS.length)}>‹</button>
                <span style={{ fontSize:"12px", color:"var(--stone-400)", lineHeight:"28px" }}>{insightIdx + 1} / {INSIGHTS.length}</span>
                <button className="btn btn-secondary btn-sm" onClick={() => setInsightIdx(i => (i + 1) % INSIGHTS.length)}>›</button>
              </div>
            </div>
            <div className="card fade-in" key={insightIdx} style={{ padding:"18px 20px", borderLeft:`4px solid ${INSIGHTS[insightIdx].color}`, display:"flex", gap:14, alignItems:"flex-start" }}>
              <span style={{ fontSize:28, flexShrink:0 }}>{INSIGHTS[insightIdx].icon}</span>
              <div>
                <div style={{ fontWeight:700, fontSize:"14px", color:INSIGHTS[insightIdx].color, marginBottom:5 }}>{INSIGHTS[insightIdx].title}</div>
                <div style={{ fontSize:"13px", color:"var(--stone-600)", lineHeight:1.7 }}>{INSIGHTS[insightIdx].body}</div>
              </div>
            </div>
            <div style={{ display:"flex", gap:5, marginTop:10, justifyContent:"center" }}>
              {INSIGHTS.map((_,i) => (
                <div key={i} onClick={() => setInsightIdx(i)} style={{ width: i===insightIdx ? 18 : 6, height:6, borderRadius:3, background: i===insightIdx ? "var(--warm-gold)" : "var(--stone-300)", cursor:"pointer", transition:"all 0.2s" }}/>
              ))}
            </div>
          </div>

          {/* All campaigns summary table */}
          <div>
            <div style={{ fontFamily:"var(--font-display)", fontSize:"16px", fontWeight:700, marginBottom:12 }}>All Campaigns</div>
            <div className="card" style={{ padding:0 }}>
              <div style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse" }}>
                  <thead>
                    <tr style={{ background:"var(--stone-100)", fontSize:"11px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--stone-500)" }}>
                      {["Campaign","Platform","Status","Budget","Spend","Impressions","Clicks","CTR","CPC","Conv.","ROAS"].map(h => (
                        <th key={h} style={{ padding:"10px 12px", textAlign:"left", whiteSpace:"nowrap" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {allCampaigns.map(c => (
                      <tr key={c.id} style={{ borderBottom:"1px solid var(--stone-100)", fontSize:"12px" }}>
                        <td style={{ padding:"10px 12px", fontWeight:600, maxWidth:180, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{c.name}</td>
                        <td style={{ padding:"10px 12px" }}><PlatformBadge platform={c.type}/></td>
                        <td style={{ padding:"10px 12px" }}><StatusBadge status={c.status}/></td>
                        <td style={{ padding:"10px 12px", color:"var(--stone-600)" }}>{fmt(c.budget)}</td>
                        <td style={{ padding:"10px 12px", fontWeight:700 }}>{fmt(c.spend)}</td>
                        <td style={{ padding:"10px 12px", color:"var(--stone-600)" }}>{fmtK(c.impressions)}</td>
                        <td style={{ padding:"10px 12px", color:"var(--stone-600)" }}>{fmtK(c.clicks)}</td>
                        <td style={{ padding:"10px 12px", color:"var(--warm-gold)", fontWeight:600 }}>{c.ctr}%</td>
                        <td style={{ padding:"10px 12px", color:"var(--stone-600)" }}>${c.cpc}</td>
                        <td style={{ padding:"10px 12px", fontWeight:700, color:"var(--accent-green)" }}>{c.conversions}</td>
                        <td style={{ padding:"10px 12px", fontWeight:800, color:roasColor(c.roas) }}>{c.roas}x</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ════════ GOOGLE ADS ════════ */}
      {activeTab === "google" && (
        <div className="fade-in">
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:18, flexWrap:"wrap", gap:10 }}>
            <div>
              <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, display:"flex", alignItems:"center", gap:10 }}>
                🔍 Google Ads Performance
                {connections.google && <span style={{ fontSize:"11px", background:"rgba(40,167,69,0.1)", color:"var(--accent-green)", padding:"2px 8px", borderRadius:99, fontWeight:700 }}>● Live</span>}
              </div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginTop:2 }}>Search, Display & Remarketing campaigns</div>
            </div>
            {!connections.google && (
              <button className="btn btn-primary btn-sm" style={{ background:"#4285f4", borderColor:"#4285f4" }} onClick={() => { setActiveTab("setup"); }}>
                Connect Google Ads →
              </button>
            )}
          </div>

          {/* Google KPIs */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:10, marginBottom:20 }}>
            {[
              ["Spend",       fmt(campaigns.google.reduce((a,c)=>a+c.spend,0)),       "var(--accent-red)"   ],
              ["Impressions", fmtK(campaigns.google.reduce((a,c)=>a+c.impressions,0)),"var(--accent-blue)"  ],
              ["Clicks",      fmtK(campaigns.google.reduce((a,c)=>a+c.clicks,0)),     "var(--warm-gold)"    ],
              ["Conversions", campaigns.google.reduce((a,c)=>a+c.conversions,0),       "var(--accent-green)" ],
              ["Avg CPC",     `$${(campaigns.google.reduce((a,c)=>a+c.spend,0)/campaigns.google.reduce((a,c)=>a+c.clicks,0)).toFixed(2)}`, "var(--stone-600)"],
              ["Avg ROAS",    `${(campaigns.google.reduce((a,c)=>a+c.roas,0)/campaigns.google.length).toFixed(1)}x`, "var(--warm-gold)" ],
            ].map(([l,v,c]) => (
              <div key={l} className="card" style={{ padding:"14px 16px" }}>
                <div style={{ fontSize:"10px", fontWeight:700, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.07em", marginBottom:6 }}>{l}</div>
                <div style={{ fontFamily:"var(--font-display)", fontSize:"22px", fontWeight:800, color:c }}>{v}</div>
              </div>
            ))}
          </div>

          {/* Google campaign cards */}
          <div style={{ display:"grid", gap:14 }}>
            {campaigns.google.map(c => {
              const budgetPct = Math.min((c.spend/c.budget)*100, 100);
              return (
                <div key={c.id} className="card" style={{ padding:"18px 20px", borderLeft:`4px solid ${c.status==="Active" ? "#4285f4" : "var(--stone-300)"}` }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:10, marginBottom:14 }}>
                    <div>
                      <div style={{ fontWeight:700, fontSize:"15px", marginBottom:5, display:"flex", alignItems:"center", gap:8 }}>
                        {c.name}
                      </div>
                      <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                        <PlatformBadge platform={c.type}/>
                        <StatusBadge status={c.status}/>
                      </div>
                    </div>
                    <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                      <button className="btn btn-secondary btn-sm" style={{ fontSize:"11px" }} onClick={() => { setBudgetModal(c); setBudgetEdit(String(c.budget)); }}>Edit Budget</button>
                    </div>
                  </div>

                  {/* Budget bar */}
                  <div style={{ marginBottom:14 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", fontSize:"12px", marginBottom:4 }}>
                      <span style={{ color:"var(--stone-500)" }}>Monthly Budget</span>
                      <span style={{ fontWeight:700, color: budgetPct > 90 ? "var(--accent-red)" : "var(--accent-green)" }}>{fmt(c.spend)} spent of {fmt(c.budget)}</span>
                    </div>
                    <div style={{ height:7, background:"var(--stone-200)", borderRadius:4, overflow:"hidden" }}>
                      <div style={{ height:"100%", width:`${budgetPct}%`, background: budgetPct > 90 ? "var(--accent-red)" : "#4285f4", borderRadius:4, transition:"width 0.5s" }}/>
                    </div>
                  </div>

                  {/* Metrics grid */}
                  <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(110px,1fr))", gap:8 }}>
                    {[
                      ["Impressions", fmtK(c.impressions), "var(--accent-blue)"  ],
                      ["Clicks",      fmtK(c.clicks),      "var(--warm-gold)"    ],
                      ["CTR",         `${c.ctr}%`,         "var(--warm-gold)"    ],
                      ["CPC",         `$${c.cpc}`,         "var(--stone-600)"    ],
                      ["Conversions", c.conversions,        "var(--accent-green)" ],
                      ["ROAS",        `${c.roas}x`,        roasColor(c.roas)     ],
                    ].map(([l,v,col]) => (
                      <div key={l} style={{ background:"var(--stone-100)", borderRadius:6, padding:"8px 10px", textAlign:"center" }}>
                        <div style={{ fontSize:"10px", fontWeight:700, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:3 }}>{l}</div>
                        <div style={{ fontSize:"15px", fontWeight:800, color:col }}>{v}</div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ════════ META ADS ════════ */}
      {activeTab === "meta" && (
        <div className="fade-in">
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:18, flexWrap:"wrap", gap:10 }}>
            <div>
              <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, display:"flex", alignItems:"center", gap:10 }}>
                📘 Meta Ads Performance
                {connections.meta && <span style={{ fontSize:"11px", background:"rgba(40,167,69,0.1)", color:"var(--accent-green)", padding:"2px 8px", borderRadius:99, fontWeight:700 }}>● Live</span>}
              </div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginTop:2 }}>Facebook & Instagram campaigns</div>
            </div>
            {!connections.meta && (
              <button className="btn btn-primary btn-sm" style={{ background:"#1877f2", borderColor:"#1877f2" }} onClick={() => setActiveTab("setup")}>
                Connect Meta Ads →
              </button>
            )}
          </div>

          {/* Meta KPIs */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:10, marginBottom:20 }}>
            {[
              ["Spend",       fmt(campaigns.meta.reduce((a,c)=>a+c.spend,0)),       "var(--accent-red)"   ],
              ["Reach",       fmtK(campaigns.meta.reduce((a,c)=>a+(c.reach||0),0)), "var(--accent-blue)"  ],
              ["Impressions", fmtK(campaigns.meta.reduce((a,c)=>a+c.impressions,0)),"var(--stone-600)"    ],
              ["Clicks",      fmtK(campaigns.meta.reduce((a,c)=>a+c.clicks,0)),     "var(--warm-gold)"    ],
              ["Conversions", campaigns.meta.reduce((a,c)=>a+c.conversions,0),       "var(--accent-green)" ],
              ["Avg ROAS",    `${(campaigns.meta.reduce((a,c)=>a+c.roas,0)/campaigns.meta.length).toFixed(1)}x`, "var(--warm-gold)" ],
            ].map(([l,v,c]) => (
              <div key={l} className="card" style={{ padding:"14px 16px" }}>
                <div style={{ fontSize:"10px", fontWeight:700, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.07em", marginBottom:6 }}>{l}</div>
                <div style={{ fontFamily:"var(--font-display)", fontSize:"22px", fontWeight:800, color:c }}>{v}</div>
              </div>
            ))}
          </div>

          {/* Meta campaign cards */}
          <div style={{ display:"grid", gap:14 }}>
            {campaigns.meta.map(c => {
              const budgetPct = Math.min((c.spend/c.budget)*100, 100);
              return (
                <div key={c.id} className="card" style={{ padding:"18px 20px", borderLeft:`4px solid ${c.status==="Active" ? "#1877f2" : "var(--stone-300)"}` }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:10, marginBottom:14 }}>
                    <div>
                      <div style={{ fontWeight:700, fontSize:"15px", marginBottom:5 }}>{c.name}</div>
                      <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                        <PlatformBadge platform={c.type}/>
                        <StatusBadge status={c.status}/>
                        {c.reach && <span style={{ fontSize:"11px", color:"var(--stone-400)" }}>👥 {fmtK(c.reach)} reach</span>}
                      </div>
                    </div>
                    <button className="btn btn-secondary btn-sm" style={{ fontSize:"11px" }} onClick={() => { setBudgetModal(c); setBudgetEdit(String(c.budget)); }}>Edit Budget</button>
                  </div>

                  <div style={{ marginBottom:14 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", fontSize:"12px", marginBottom:4 }}>
                      <span style={{ color:"var(--stone-500)" }}>Monthly Budget</span>
                      <span style={{ fontWeight:700, color: budgetPct > 90 ? "var(--accent-red)" : "var(--accent-green)" }}>{fmt(c.spend)} spent of {fmt(c.budget)}</span>
                    </div>
                    <div style={{ height:7, background:"var(--stone-200)", borderRadius:4, overflow:"hidden" }}>
                      <div style={{ height:"100%", width:`${budgetPct}%`, background: budgetPct > 90 ? "var(--accent-red)" : "#1877f2", borderRadius:4, transition:"width 0.5s" }}/>
                    </div>
                  </div>

                  <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(110px,1fr))", gap:8 }}>
                    {[
                      ["Impressions", fmtK(c.impressions), "var(--accent-blue)"  ],
                      ["Clicks",      fmtK(c.clicks),      "var(--warm-gold)"    ],
                      ["CTR",         `${c.ctr}%`,         "var(--warm-gold)"    ],
                      ["CPC",         `$${c.cpc}`,         "var(--stone-600)"    ],
                      ["Conversions", c.conversions,        "var(--accent-green)" ],
                      ["ROAS",        `${c.roas}x`,        roasColor(c.roas)     ],
                    ].map(([l,v,col]) => (
                      <div key={l} style={{ background:"var(--stone-100)", borderRadius:6, padding:"8px 10px", textAlign:"center" }}>
                        <div style={{ fontSize:"10px", fontWeight:700, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:3 }}>{l}</div>
                        <div style={{ fontSize:"15px", fontWeight:800, color:col }}>{v}</div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ════════ ATTRIBUTION ════════ */}
      {activeTab === "attribution" && (
        <div className="fade-in">
          <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, marginBottom:4 }}>Lead Attribution</div>
          <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:20 }}>CRM leads cross-referenced with your paid ad channels</div>

          {/* Attribution KPIs */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(185px,1fr))", gap:12, marginBottom:24 }}>
            {[
              { label:"Total CRM Leads",    value: leads.length,                         color:"var(--stone-700)", icon:"👥" },
              { label:"From Paid Channels", value: paidLeads.length,                     color:"var(--accent-blue)", icon:"💰", sub:`${leads.length ? Math.round(paidLeads.length/leads.length*100) : 0}% of all leads` },
              { label:"Paid Lead Value",    value: fmt(paidLeadValue),                   color:"var(--accent-green)", icon:"🎯", sub:"Combined pipeline value" },
              { label:"Revenue ROAS",       value: `${estimatedRevROAS}x`,               color: roasColor(Number(estimatedRevROAS)), icon:"📈", sub:"Pipeline value / ad spend" },
              { label:"Cost Per Lead",      value: `$${costPerLead}`,                    color:"var(--warm-gold)", icon:"💲", sub:"Avg across all conversions" },
              { label:"Won From Paid",      value: paidLeads.filter(l=>l.status==="Won").length, color:"var(--accent-green)", icon:"🏆", sub:`of ${paidLeads.length} paid leads` },
            ].map(k => (
              <div key={k.label} className="card" style={{ padding:"16px 18px" }}>
                <div style={{ display:"flex", justifyContent:"space-between", marginBottom:8 }}>
                  <div style={{ fontSize:"11px", fontWeight:600, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.06em" }}>{k.label}</div>
                  <span style={{ fontSize:16 }}>{k.icon}</span>
                </div>
                <div style={{ fontFamily:"var(--font-display)", fontSize:"26px", fontWeight:800, color:k.color, lineHeight:1, marginBottom:4 }}>{k.value}</div>
                {k.sub && <div style={{ fontSize:"11px", color:"var(--stone-400)" }}>{k.sub}</div>}
              </div>
            ))}
          </div>

          {/* Lead source breakdown */}
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:24 }}>
            <div className="card" style={{ padding:"20px" }}>
              <div style={{ fontWeight:700, fontSize:"14px", marginBottom:4 }}>Leads by Source</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:16 }}>All CRM leads attributed by origin</div>
              <div style={{ display:"grid", gap:10 }}>
                {Object.entries(leads.reduce((acc,l) => { acc[l.source]=(acc[l.source]||0)+1; return acc; }, {}))
                  .sort((a,b) => b[1]-a[1])
                  .map(([src, cnt]) => {
                    const srcColors = { Google:"#4285f4", Facebook:"#1877f2", Instagram:"#e1306c", Referral:"var(--accent-green)", Yelp:"var(--accent-red)" };
                    const c = srcColors[src] || "var(--stone-400)";
                    const maxCnt = Math.max(...Object.values(leads.reduce((acc,l) => { acc[l.source]=(acc[l.source]||0)+1; return acc; }, {})));
                    return (
                      <div key={src}>
                        <div style={{ display:"flex", justifyContent:"space-between", fontSize:"12px", marginBottom:4 }}>
                          <div style={{ display:"flex", alignItems:"center", gap:7 }}>
                            <div style={{ width:9, height:9, borderRadius:"50%", background:c }}/>
                            <span style={{ color:"var(--stone-600)", fontWeight:500 }}>{src}</span>
                          </div>
                          <span style={{ fontWeight:700 }}>{cnt} <span style={{ color:"var(--stone-400)", fontWeight:400 }}>({Math.round(cnt/leads.length*100)}%)</span></span>
                        </div>
                        <div style={{ height:5, background:"var(--stone-200)", borderRadius:3 }}>
                          <div style={{ height:"100%", width:`${(cnt/maxCnt)*100}%`, background:c, borderRadius:3 }}/>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>

            <div className="card" style={{ padding:"20px" }}>
              <div style={{ fontWeight:700, fontSize:"14px", marginBottom:4 }}>Pipeline Value by Source</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:16 }}>Total lead value attributed per channel</div>
              <div style={{ display:"grid", gap:10 }}>
                {Object.entries(leads.reduce((acc,l) => { acc[l.source]=(acc[l.source]||0)+(l.value||0); return acc; }, {}))
                  .sort((a,b) => b[1]-a[1])
                  .map(([src, val]) => {
                    const srcColors = { Google:"#4285f4", Facebook:"#1877f2", Instagram:"#e1306c", Referral:"var(--accent-green)", Yelp:"var(--accent-red)" };
                    const c = srcColors[src] || "var(--stone-400)";
                    const maxVal = Math.max(...Object.values(leads.reduce((acc,l) => { acc[l.source]=(acc[l.source]||0)+(l.value||0); return acc; }, {})));
                    return (
                      <div key={src}>
                        <div style={{ display:"flex", justifyContent:"space-between", fontSize:"12px", marginBottom:4 }}>
                          <div style={{ display:"flex", alignItems:"center", gap:7 }}>
                            <div style={{ width:9, height:9, borderRadius:"50%", background:c }}/>
                            <span style={{ color:"var(--stone-600)", fontWeight:500 }}>{src}</span>
                          </div>
                          <span style={{ fontWeight:700, color:c }}>{fmt(val)}</span>
                        </div>
                        <div style={{ height:5, background:"var(--stone-200)", borderRadius:3 }}>
                          <div style={{ height:"100%", width:`${(val/maxVal)*100}%`, background:c, borderRadius:3 }}/>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

          {/* Paid leads table */}
          <div>
            <div style={{ fontFamily:"var(--font-display)", fontSize:"16px", fontWeight:700, marginBottom:12 }}>Paid Channel Leads</div>
            <div className="card" style={{ padding:0 }}>
              <div style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse" }}>
                  <thead>
                    <tr style={{ background:"var(--stone-100)", fontSize:"11px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--stone-500)" }}>
                      {["Name","Source","Project","Value","Status","Date"].map(h => (
                        <th key={h} style={{ padding:"10px 14px", textAlign:"left" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paidLeads.length === 0
                      ? <tr><td colSpan={6} style={{ padding:"32px", textAlign:"center", color:"var(--stone-400)" }}>No paid channel leads yet.</td></tr>
                      : paidLeads.map(l => {
                          const srcColors = { Google:"#4285f4", Facebook:"#1877f2", Instagram:"#e1306c" };
                          return (
                            <tr key={l.id} style={{ borderBottom:"1px solid var(--stone-100)", fontSize:"13px" }}>
                              <td style={{ padding:"10px 14px", fontWeight:600 }}>{l.name}</td>
                              <td style={{ padding:"10px 14px" }}><PlatformBadge platform={l.source}/></td>
                              <td style={{ padding:"10px 14px", color:"var(--stone-500)" }}>{l.project}</td>
                              <td style={{ padding:"10px 14px", fontWeight:700, color:"var(--warm-gold)" }}>{fmt(l.value||0)}</td>
                              <td style={{ padding:"10px 14px" }}>
                                <span style={{ fontSize:"11px", fontWeight:700, background:`${STAGE_COLORS[l.status]||"var(--stone-400)"}20`, color:STAGE_COLORS[l.status]||"var(--stone-500)", padding:"3px 9px", borderRadius:99 }}>{l.status}</span>
                              </td>
                              <td style={{ padding:"10px 14px", color:"var(--stone-400)", fontSize:"12px" }}>{l.date}</td>
                            </tr>
                          );
                        })
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ════════ API SETUP ════════ */}
      {activeTab === "setup" && (
        <div className="fade-in">
          <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700, marginBottom:4 }}>API Connections</div>
          <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:20 }}>Connect your ad platforms to pull live campaign data into this dashboard.</div>

          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:28 }}>
            <PlatformConnector
              platform="google" label="Google Ads" color="#4285f4" icon="🔍"
              fields={[
                { key:"customerId",      label:"Customer ID",       hint:"Found in Google Ads → Admin → Account settings (format: 123-456-7890)" },
                { key:"developerToken",  label:"Developer Token",   hint:"Google Ads API Center → Your developer token" },
                { key:"accessToken",     label:"OAuth Access Token",hint:"Generated via Google OAuth 2.0 flow with scope: adwords" },
              ]}
            />
            <PlatformConnector
              platform="meta" label="Meta Ads" color="#1877f2" icon="📘"
              fields={[
                { key:"appId",      label:"App ID",          hint:"Meta for Developers → Your App → App ID" },
                { key:"appSecret",  label:"App Secret",      hint:"Meta for Developers → Your App → App Secret" },
                { key:"accessToken",label:"Access Token",    hint:"Long-lived token with ads_read permission via Business Manager" },
                { key:"accountId",  label:"Ad Account ID",   hint:"Business Manager → Ad Accounts → Account ID (format: act_XXXXXX)" },
              ]}
            />
          </div>

          {/* Integration guide */}
          <div className="card" style={{ padding:"22px" }}>
            <div style={{ fontWeight:700, fontSize:"15px", marginBottom:16, display:"flex", alignItems:"center", gap:8 }}>
              📋 Integration Setup Guide
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:24 }}>
              {/* Google steps */}
              <div>
                <div style={{ fontWeight:700, fontSize:"13px", color:"#4285f4", marginBottom:12, display:"flex", alignItems:"center", gap:7 }}>
                  🔍 Google Ads API — Step-by-Step
                </div>
                {[
                  { n:1, title:"Create a Google Ads Manager Account", desc:"Go to ads.google.com, create or use an existing Manager (MCC) account that owns your client accounts." },
                  { n:2, title:"Apply for a Developer Token",         desc:"In your Manager account: Tools → API Center → Apply for access. Basic access is free and sufficient for this dashboard." },
                  { n:3, title:"Set up OAuth 2.0 Credentials",       desc:"Google Cloud Console → Create a project → Enable Google Ads API → Create OAuth 2.0 credentials (Web Application type)." },
                  { n:4, title:"Generate Access & Refresh Tokens",   desc:"Use Google's OAuth Playground (oauth2.googleapis.com/token) with your credentials to generate long-lived refresh tokens." },
                  { n:5, title:"Connect here",                       desc:"Enter your Customer ID (from Account Settings), Developer Token, and OAuth Access Token in the connection card above." },
                ].map(s => (
                  <div key={s.n} style={{ display:"flex", gap:12, marginBottom:12 }}>
                    <div style={{ width:22, height:22, borderRadius:"50%", background:"#4285f418", color:"#4285f4", fontSize:"11px", fontWeight:800, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, marginTop:1 }}>{s.n}</div>
                    <div>
                      <div style={{ fontWeight:600, fontSize:"12px", marginBottom:2 }}>{s.title}</div>
                      <div style={{ fontSize:"11px", color:"var(--stone-500)", lineHeight:1.5 }}>{s.desc}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Meta steps */}
              <div>
                <div style={{ fontWeight:700, fontSize:"13px", color:"#1877f2", marginBottom:12, display:"flex", alignItems:"center", gap:7 }}>
                  📘 Meta Ads API — Step-by-Step
                </div>
                {[
                  { n:1, title:"Create a Meta Business App",         desc:"developers.facebook.com → My Apps → Create App → Business type. This gives you API access to your ad accounts." },
                  { n:2, title:"Add Marketing API Product",          desc:"In your App Dashboard → Add Product → Marketing API. This unlocks the ads_read and ads_management permissions." },
                  { n:3, title:"Get a Long-Lived Access Token",      desc:"Use Graph API Explorer → Generate a User Token with ads_read scope → Exchange for long-lived token (60-day expiry) via Graph API." },
                  { n:4, title:"Find your Ad Account ID",            desc:"Meta Business Manager → Ad Accounts → your account. The ID appears as 'act_XXXXXXXXXX' — copy just the numeric portion." },
                  { n:5, title:"Connect here",                       desc:"Enter your App ID, App Secret, Long-Lived Access Token, and Ad Account ID in the Meta connection card above." },
                ].map(s => (
                  <div key={s.n} style={{ display:"flex", gap:12, marginBottom:12 }}>
                    <div style={{ width:22, height:22, borderRadius:"50%", background:"#1877f218", color:"#1877f2", fontSize:"11px", fontWeight:800, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, marginTop:1 }}>{s.n}</div>
                    <div>
                      <div style={{ fontWeight:600, fontSize:"12px", marginBottom:2 }}>{s.title}</div>
                      <div style={{ fontSize:"11px", color:"var(--stone-500)", lineHeight:1.5 }}>{s.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Security note */}
            <div style={{ marginTop:20, padding:"12px 14px", background:"rgba(201,169,110,0.07)", border:"1px solid rgba(201,169,110,0.25)", borderRadius:"var(--radius)", fontSize:"12px", color:"var(--stone-600)", lineHeight:1.7 }}>
              <strong>🔒 Security note:</strong> In this demo environment, credentials are stored in component state only. For production deployment, API tokens should be stored server-side in environment variables or a secrets manager (AWS Secrets Manager, Vercel env vars, etc.) — never in client-side JavaScript. API calls should route through a backend proxy endpoint so tokens are never exposed to the browser.
            </div>
          </div>

          {/* Recommended backend architecture */}
          <div className="card" style={{ padding:"22px", marginTop:16 }}>
            <div style={{ fontWeight:700, fontSize:"15px", marginBottom:14 }}>🏗 Recommended Backend Architecture</div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))", gap:12 }}>
              {[
                { icon:"🔐", title:"Secrets Management",    desc:"Store API tokens in environment variables via Vercel, Railway, or AWS. Never commit tokens to git." },
                { icon:"🔄", title:"Scheduled Sync",        desc:"Use a cron job (daily or hourly) to pull fresh campaign data and cache it in your database — avoids API rate limits." },
                { icon:"🗃",  title:"Data Caching",         desc:"Store synced campaign metrics in Postgres or Supabase. Serve the dashboard from your DB, not live API calls." },
                { icon:"📊", title:"Webhook Events",        desc:"Google and Meta both support webhooks for budget alerts and status changes — push notifications to this dashboard in real time." },
                { icon:"🔑", title:"OAuth Token Refresh",   desc:"Meta tokens expire every 60 days. Build an auto-refresh flow that renews long-lived tokens before expiry." },
                { icon:"📈", title:"Historical Storage",    desc:"Store daily snapshots of campaign metrics so you can build trend charts going back months — APIs only return recent windows." },
              ].map(item => (
                <div key={item.title} style={{ padding:"12px 14px", background:"var(--stone-100)", borderRadius:"var(--radius)" }}>
                  <div style={{ fontSize:20, marginBottom:7 }}>{item.icon}</div>
                  <div style={{ fontWeight:700, fontSize:"12px", marginBottom:4 }}>{item.title}</div>
                  <div style={{ fontSize:"11px", color:"var(--stone-500)", lineHeight:1.5 }}>{item.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ── Budget edit modal ── */}
      {budgetModal && (
        <Modal title={`Edit Budget — ${budgetModal.name}`} onClose={() => setBudgetModal(null)}>
          <div style={{ marginBottom:16 }}>
            <div className="form-group">
              <label>Monthly Budget ($)</label>
              <input type="number" value={budgetEdit} onChange={e => setBudgetEdit(e.target.value)} autoFocus/>
            </div>
            <div style={{ fontSize:"12px", color:"var(--stone-400)", marginTop:6 }}>
              Current spend: <strong>{fmt(budgetModal.spend)}</strong> · Remaining: <strong>{fmt(Math.max(budgetModal.budget - budgetModal.spend, 0))}</strong>
            </div>
          </div>
          <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
            <button className="btn btn-secondary" onClick={() => setBudgetModal(null)}>Cancel</button>
            <button className="btn btn-primary" onClick={() => {
              const newBudget = Number(budgetEdit);
              if (!newBudget || newBudget < 1) return;
              setCampaigns(p => {
                const key = campaigns.google.find(c=>c.id===budgetModal.id) ? "google" : "meta";
                return { ...p, [key]: p[key].map(c => c.id===budgetModal.id ? {...c, budget:newBudget} : c) };
              });
              setBudgetModal(null);
            }}>Save Budget</button>
          </div>
        </Modal>
      )}

      {/* ── Platform connect modal ── */}
      {connecting && (
        <Modal title={`Connect ${connecting === "google" ? "Google Ads" : "Meta Ads"}`} onClose={() => setConnecting(null)}>
          <div style={{ fontSize:"13px", color:"var(--stone-500)", marginBottom:16, lineHeight:1.6 }}>
            {connecting === "google"
              ? "Enter your Google Ads API credentials. See the API Setup tab for step-by-step instructions on where to find these."
              : "Enter your Meta Business API credentials. See the API Setup tab for step-by-step instructions on where to find these."
            }
          </div>
          <div style={{ display:"grid", gap:12, marginBottom:16 }}>
          {(connecting === "google" ? [
              { fkey:"customerId",    flabel:"Customer ID",        fph:"123-456-7890"    },
              { fkey:"developerToken",flabel:"Developer Token",     fph:"ABcDeFgH..."     },
              { fkey:"accessToken",   flabel:"OAuth Access Token",  fph:"ya29.a0AfH..."   },
            ] : [
              { fkey:"appId",        flabel:"App ID",              fph:"1234567890"       },
              { fkey:"appSecret",    flabel:"App Secret",          fph:"abc123def456..."  },
              { fkey:"accessToken",  flabel:"Long-Lived Token",    fph:"EAABwzLix..."     },
              { fkey:"accountId",    flabel:"Ad Account ID",       fph:"act_1234567890"   },
            ]).map(f => (
              <div key={f.fkey} className="form-group" style={{ marginBottom:0 }}>
                <label>{f.flabel}</label>
                <input type="password" placeholder={f.fph} value={connForm[f.fkey]||""} onChange={e => setConnForm(p => ({...p,[f.fkey]:e.target.value}))}/>
              </div>
            ))}
          </div>
          <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
            <button className="btn btn-secondary" onClick={() => setConnecting(null)}>Cancel</button>
            <button className="btn btn-primary"
              style={{ background: connecting==="google" ? "#4285f4" : "#1877f2", borderColor: connecting==="google" ? "#4285f4" : "#1877f2" }}
              onClick={() => handleConnect(connecting)}>
              {refreshing ? "Connecting…" : `Connect ${connecting === "google" ? "Google Ads" : "Meta Ads"}`}
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
};

// ── Mini bar chart (pure CSS/SVG, no library needed) ─────────────────────────
const MiniBar = ({ data, color = "var(--warm-gold)", height = 60, showLabels = true }) => {
  if (!data || data.length === 0) return null;
  const max = Math.max(...data.map(d => d.value), 1);
  return (
    <div style={{ display:"flex", alignItems:"flex-end", gap:4, height, width:"100%" }}>
      {data.map((d, i) => (
        <div key={i} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", gap:3, height:"100%", justifyContent:"flex-end" }}>
          <div style={{ width:"100%", background:`${color}22`, borderRadius:"3px 3px 0 0", position:"relative", height:`${Math.max((d.value/max)*100,3)}%`, transition:"height 0.4s ease", minHeight:3 }}>
            <div style={{ position:"absolute", bottom:0, left:0, right:0, background:color, borderRadius:"3px 3px 0 0", height:"100%" }}/>
          </div>
          {showLabels && <div style={{ fontSize:"9px", color:"var(--stone-400)", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", maxWidth:"100%", textAlign:"center" }}>{d.label}</div>}
        </div>
      ))}
    </div>
  );
};

// ── Donut chart (SVG) ─────────────────────────────────────────────────────────
const DonutChart = ({ segments, size = 100, thickness = 18 }) => {
  const r = (size / 2) - thickness;
  const circ = 2 * Math.PI * r;
  const total = segments.reduce((a, s) => a + s.value, 0) || 1;
  let offset = 0;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ transform:"rotate(-90deg)" }}>
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="var(--stone-200)" strokeWidth={thickness}/>
      {segments.map((s, i) => {
        const dash = (s.value / total) * circ;
        const gap  = circ - dash;
        const el = (
          <circle key={i} cx={size/2} cy={size/2} r={r} fill="none"
            stroke={s.color} strokeWidth={thickness}
            strokeDasharray={`${dash} ${gap}`}
            strokeDashoffset={-offset}
            strokeLinecap="round"
          />
        );
        offset += dash;
        return el;
      })}
    </svg>
  );
};

// ── KPI card ──────────────────────────────────────────────────────────────────
const KpiCard = ({ label, value, sub, color = "var(--warm-gold)", icon, trend, trendUp }) => (
  <div className="card" style={{ padding:"18px 20px" }}>
    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:10 }}>
      <div style={{ fontSize:"12px", fontWeight:600, color:"var(--stone-500)", textTransform:"uppercase", letterSpacing:"0.07em" }}>{label}</div>
      {icon && <span style={{ fontSize:20 }}>{icon}</span>}
    </div>
    <div style={{ fontFamily:"var(--font-display)", fontSize:"28px", fontWeight:800, color, lineHeight:1, marginBottom:6 }}>{value}</div>
    {sub  && <div style={{ fontSize:"12px", color:"var(--stone-400)", lineHeight:1.4 }}>{sub}</div>}
    {trend !== undefined && (
      <div style={{ display:"flex", alignItems:"center", gap:4, marginTop:8, fontSize:"12px", fontWeight:600, color: trendUp ? "var(--accent-green)" : "var(--accent-red)" }}>
        <span>{trendUp ? "▲" : "▼"}</span> {trend}
      </div>
    )}
  </div>
);

// ── Section header ────────────────────────────────────────────────────────────
const ReportSection = ({ title, sub, children, action }) => (
  <div style={{ marginBottom:32 }}>
    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16, flexWrap:"wrap", gap:8 }}>
      <div>
        <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:700 }}>{title}</div>
        {sub && <div style={{ fontSize:"12px", color:"var(--stone-400)", marginTop:2 }}>{sub}</div>}
      </div>
      {action}
    </div>
    {children}
  </div>
);

// ── REPORTS ───────────────────────────────────────────────────────────────────
const Reports = ({ leads, jobs, invoices, estimates, calls, customers, users }) => {
  const [activeReport, setActiveReport] = useState("overview");
  const [dateRange, setDateRange]       = useState("all");   // "30d" | "90d" | "ytd" | "all"
  const [budgets, setBudgets]           = useState([]);

  // Fetch project budgets for profitability enrichment
  useEffect(() => {
    (async () => {
      const { data } = await supabase.from('project_budgets').select('*').order('created_at');
      if (data) setBudgets(data);
    })();
  }, []);

  // ── CSV Download Utility ──
  const downloadCSV = (filename, headers, rows) => {
    const escape = v => `"${String(v||'').replace(/"/g, '""')}"`;
    const csv = [headers.join(','), ...rows.map(r => r.map(escape).join(','))].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = filename; a.click();
    URL.revokeObjectURL(url);
  };

  const exportLeads = () => downloadCSV(`leads-report-${new Date().toISOString().slice(0,10)}.csv`,
    ['Name','Email','Phone','Source','Status','Project','Value','Date','Address','Notes'],
    leads.map(l => [l.name,l.email,l.phone,l.source,l.status,l.project,l.value,l.date,l.address,l.notes])
  );
  const exportJobs = () => downloadCSV(`jobs-report-${new Date().toISOString().slice(0,10)}.csv`,
    ['Customer','Project','Status','Start Date','End Date','Value','Cost','Crew','Address','Notes'],
    jobs.map(j => [j.customer,j.project,j.status,j.startDate,j.endDate,j.value,j.cost,j.crewName||j.crew,j.address,j.notes])
  );
  const exportInvoices = () => downloadCSV(`invoices-report-${new Date().toISOString().slice(0,10)}.csv`,
    ['Invoice #','Customer','Project','Total','Status','Issued','Paid To Date','Remaining'],
    invoices.map(i => [i.display_id||i.id, i.customer, i.project, invTotal(i), i.status, i.issued, invPaidToDate(i), invTotal(i)-invPaidToDate(i)])
  );
  const exportEstimates = () => downloadCSV(`estimates-report-${new Date().toISOString().slice(0,10)}.csv`,
    ['Estimate #','Customer','Project','Date','Status','Total','Sent Count'],
    estimates.map(e => [e.id, e.customer, e.project, e.date, e.status, e.items?.reduce((s,i)=>s+(Number(i.qty)*Number(i.price)),0)||0, e.sent_count||1])
  );
  const exportCalls = () => downloadCSV(`calls-report-${new Date().toISOString().slice(0,10)}.csv`,
    ['Contact','Phone','Direction','Outcome','Source','Date','Time','Duration','Notes'],
    calls.map(c => [c.contact,c.phone,c.direction,c.outcome,c.source,c.date,c.time,c.duration,c.notes])
  );
  const exportCustomers = () => downloadCSV(`customers-report-${new Date().toISOString().slice(0,10)}.csv`,
    ['Name','Email','Phone','Address','Total Jobs','Total Revenue','Notes'],
    customers.map(c => [c.name,c.email,c.phone,c.address,c.totalJobs||c.total_jobs||0,c.totalRevenue||c.total_revenue||0,c.notes])
  );

  // ── Derived metrics ──────────────────────────────────────────────────────────
  const now = new Date();
  const filterByDate = (items, dateField) => {
    if (dateRange === "all") return items;
    let cutoff;
    if (dateRange === "ytd") {
      cutoff = new Date(now.getFullYear(), 0, 1); // January 1st of current year
    } else {
      const days = dateRange === "30d" ? 30 : 90;
      cutoff = new Date(now);
      cutoff.setDate(cutoff.getDate() - days);
    }
    return items.filter(i => { const d = new Date(i[dateField]); return !isNaN(d) && d >= cutoff; });
  };

  // Apply date filter to all data sets
  const fLeads     = filterByDate(leads, "date");
  const fJobs      = filterByDate(jobs, "startDate");
  const fInvoices  = filterByDate(invoices, "issued");
  const fCalls     = filterByDate(calls, "date");
  const fEstimates = filterByDate(estimates, "date");

  // Revenue — from filtered invoices
  const paidInvoices    = fInvoices.filter(i => i.status === "Paid");
  const totalRevenue    = paidInvoices.reduce((a, i) => a + invTotal(i), 0);
  const outstanding     = fInvoices.filter(i => ["Invoiced","Overdue"].includes(i.status)).reduce((a,i) => a + invTotal(i), 0);
  const overdueAmt      = fInvoices.filter(i => i.status === "Overdue").reduce((a,i) => a + invTotal(i), 0);
  const jobsWithValue   = fJobs.filter(j => (j.value||0) > 0);
  const avgJobValue     = jobsWithValue.length ? Math.round(jobsWithValue.reduce((a,j) => a + j.value, 0) / jobsWithValue.length) : 0;

  // Leads — from filtered leads
  const wonLeads        = fLeads.filter(l => l.status === "Won");
  const lostLeads       = fLeads.filter(l => l.status === "Lost");
  const conversionRate  = fLeads.length ? Math.round((wonLeads.length / fLeads.length) * 100) : 0;
  const pipelineValue   = fLeads.filter(l => !["Won","Lost"].includes(l.status)).reduce((a,l) => a + (l.value||0), 0);

  const sourceBreakdown = fLeads.reduce((acc, l) => {
    acc[l.source] = (acc[l.source] || 0) + 1; return acc;
  }, {});

  const statusBreakdown = fLeads.reduce((acc, l) => {
    acc[l.status] = (acc[l.status] || 0) + 1; return acc;
  }, {});

  // Jobs — from filtered jobs
  const completedJobs   = fJobs.filter(j => j.status === "Completed");
  const inProgressJobs  = fJobs.filter(j => j.status === "In Progress");
  const scheduledJobs   = fJobs.filter(j => j.status === "Scheduled");

  const jobsByCrewRaw   = fJobs.reduce((acc, j) => {
    if (j.crew) acc[j.crew] = (acc[j.crew]||0) + (j.value||0); return acc;
  }, {});

  const jobsByStatus    = [
    { label:"Completed",   value: completedJobs.length,  color:"var(--accent-green)" },
    { label:"In Progress", value: inProgressJobs.length, color:"var(--accent-blue)"  },
    { label:"Scheduled",   value: scheduledJobs.length,  color:"var(--warm-gold)"    },
    { label:"On Hold",     value: fJobs.filter(j=>j.status==="On Hold").length, color:"var(--stone-400)" },
  ].filter(s => s.value > 0);

  // Calls — from filtered calls
  const answeredCalls   = fCalls.filter(c => c.outcome === "Answered");
  const missedCalls     = fCalls.filter(c => c.outcome === "Missed");
  const answerRate      = fCalls.length ? Math.round((answeredCalls.length / fCalls.length) * 100) : 0;
  const inboundCalls    = fCalls.filter(c => c.direction === "inbound");
  const outboundCalls   = fCalls.filter(c => c.direction === "outbound");

  // Customers — always all-time (customer lifetime value doesn't filter by period)
  const topCustomers = [...customers].sort((a,b) => (b.totalRevenue||0) - (a.totalRevenue||0)).slice(0,5);
  const totalCustomerRevenue = customers.reduce((a,c) => a + (c.totalRevenue||0), 0);
  const avgRevenuePerCustomer = customers.length ? Math.round(totalCustomerRevenue / customers.length) : 0;
  const repeatCustomers = customers.filter(c => (c.totalJobs||0) > 1);

  // Estimates — from filtered estimates, exclude Rejected for pipeline value
  const sentEstimates     = fEstimates.filter(e => e.status === "Sent" || e.status === "Approved");
  const estTotalValue     = fEstimates.filter(e => e.status !== "Rejected").reduce((a,e) => a + (e.items||[]).reduce((s,i) => s + ((Number(i.qty)||0)*(Number(i.price)||0)), 0), 0);

  const fmt = (n) => n >= 1000 ? `$${(n/1000).toFixed(1)}k` : `$${n}`;
  const fmtFull = (n) => `$${n.toLocaleString()}`;

  // ── Report nav items ─────────────────────────────────────────────────────────
  const REPORT_TABS = [
    { id:"overview",       label:"Overview",          icon:"📊" },
    { id:"revenue",        label:"Revenue",           icon:"💰" },
    { id:"leads",          label:"Leads & Pipeline",  icon:"🎯" },
    { id:"jobs",           label:"Jobs",              icon:"🔨" },
    { id:"calls",          label:"Call Activity",     icon:"📞" },
    { id:"customers",      label:"Customers",         icon:"👥" },
    { id:"aging",          label:"Invoice Aging",     icon:"⏰" },
    { id:"profitability",  label:"Job Profitability", icon:"📈" },
  ];

  // Date range label
  const DATE_LABELS = { "30d":"Last 30 Days", "90d":"Last 90 Days", "ytd":"Year to Date", "all":"All Time" };

  return (
    <div className="fade-in">
      {/* Page header */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:20, flexWrap:"wrap", gap:12 }}>
        <div>
          <h1 className="section-title">Reports</h1>
          <p className="section-sub">Business performance, revenue analytics, and operational metrics.</p>
        </div>
        {/* Date range filter */}
        <div style={{ display:"flex", gap:6, background:"var(--stone-200)", padding:4, borderRadius:"var(--radius)" }}>
          {Object.entries(DATE_LABELS).map(([k,l]) => (
            <button key={k} onClick={() => setDateRange(k)}
              style={{ padding:"5px 12px", borderRadius:6, border:"none", fontSize:"12px", fontWeight:600, cursor:"pointer",
                background: dateRange===k ? "white" : "transparent",
                color: dateRange===k ? "var(--stone-800)" : "var(--stone-500)",
                boxShadow: dateRange===k ? "0 1px 4px rgba(0,0,0,0.1)" : "none",
                transition:"all 0.15s" }}>
              {l}
            </button>
          ))}
        </div>
      </div>

      {/* Report tab nav */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:26, flexWrap:"wrap", gap:10, borderBottom:"2px solid var(--stone-200)", paddingBottom:0 }}>
        <div style={{ display:"flex", gap:4, flexWrap:"wrap" }}>
          {REPORT_TABS.map(t => (
            <button key={t.id} onClick={() => setActiveReport(t.id)}
              style={{ display:"flex", alignItems:"center", gap:6, padding:"9px 14px", border:"none", borderBottom: activeReport===t.id ? "2px solid var(--warm-gold)" : "2px solid transparent", marginBottom:"-2px", background:"transparent", fontSize:"13px", fontWeight: activeReport===t.id ? 700 : 500, color: activeReport===t.id ? "var(--warm-gold)" : "var(--stone-500)", cursor:"pointer", transition:"all 0.15s", borderRadius:"4px 4px 0 0" }}>
              <span>{t.icon}</span>{t.label}
            </button>
          ))}
        </div>
        <div style={{ position:"relative" }}>
          <button className="btn btn-secondary btn-sm" onClick={() => {
            const exports = { overview: () => { exportLeads(); exportJobs(); exportInvoices(); exportEstimates(); },
              revenue: exportInvoices, leads: exportLeads, jobs: exportJobs, calls: exportCalls, customers: exportCustomers, aging: exportInvoices };
            (exports[activeReport] || exports.overview)();
          }} style={{ display:"flex", alignItems:"center", gap:6, fontSize:12, marginBottom:4 }}>
            📥 Export CSV
          </button>
        </div>
      </div>

      {/* ════════════════════ OVERVIEW ════════════════════ */}
      {activeReport === "overview" && (
        <div className="fade-in">
          {/* Top KPIs */}
          <ReportSection title="Business Snapshot" sub="Key metrics across all modules at a glance">
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))", gap:12, marginBottom:16 }}>
              <KpiCard label="Total Revenue Collected" value={fmtFull(totalRevenue)} icon="💰" color="var(--accent-green)" sub={`${paidInvoices.length} paid invoices`}/>
              <KpiCard label="Outstanding Balance" value={fmtFull(outstanding)} icon="⏳" color="var(--accent-amber)" sub={`${overdueAmt > 0 ? fmtFull(overdueAmt) + " overdue" : "None overdue"}`}/>
              <KpiCard label="Pipeline Value" value={fmtFull(pipelineValue)} icon="🎯" color="var(--accent-blue)" sub={`${fLeads.filter(l=>!["Won","Lost"].includes(l.status)).length} active leads`}/>
              <KpiCard label="Lead Conversion Rate" value={`${conversionRate}%`} icon="📈" color="var(--warm-gold)" sub={`${wonLeads.length} won of ${fLeads.length} leads`}/>
              <KpiCard label="Avg Job Value" value={fmtFull(avgJobValue)} icon="🔨" color="var(--stone-700)" sub={`${jobsWithValue.length} jobs with value`}/>
              <KpiCard label="Call Answer Rate" value={`${answerRate}%`} icon="📞" color="var(--accent-blue)" sub={`${missedCalls.length} missed calls`}/>
            </div>
          </ReportSection>

          {/* Revenue vs Outstanding */}
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:32 }}>
            <div className="card" style={{ padding:"20px" }}>
              <div style={{ fontWeight:700, fontSize:"14px", marginBottom:4 }}>Invoice Status Breakdown</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:16 }}>Current invoice portfolio</div>
              <div style={{ display:"flex", alignItems:"center", gap:20 }}>
                <DonutChart size={110} thickness={16} segments={[
                  { value: paidInvoices.reduce((a,i)=>a+invTotal(i),0), color:"var(--accent-green)" },
                  { value: fInvoices.filter(i=>i.status==="Invoiced").reduce((a,i)=>a+invTotal(i),0), color:"var(--accent-blue)" },
                  { value: overdueAmt, color:"var(--accent-red)" },
                  { value: fInvoices.filter(i=>i.status==="Draft").reduce((a,i)=>a+invTotal(i),0), color:"var(--stone-300)" },
                ]}/>
                <div style={{ flex:1, display:"grid", gap:6 }}>
                  {[
                    ["Paid",     paidInvoices.reduce((a,i)=>a+invTotal(i),0), "var(--accent-green)"],
                    ["Invoiced", fInvoices.filter(i=>i.status==="Invoiced").reduce((a,i)=>a+invTotal(i),0), "var(--accent-blue)"],
                    ["Overdue",  overdueAmt, "var(--accent-red)"],
                    ["Draft",    fInvoices.filter(i=>i.status==="Draft").reduce((a,i)=>a+invTotal(i),0), "var(--stone-400)"],
                  ].map(([l,v,c]) => (
                    <div key={l} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:"12px" }}>
                      <div style={{ display:"flex", alignItems:"center", gap:7 }}>
                        <div style={{ width:9, height:9, borderRadius:"50%", background:c, flexShrink:0 }}/>
                        <span style={{ color:"var(--stone-600)" }}>{l}</span>
                      </div>
                      <span style={{ fontWeight:700, color:c }}>{fmtFull(v)}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="card" style={{ padding:"20px" }}>
              <div style={{ fontWeight:700, fontSize:"14px", marginBottom:4 }}>Lead Pipeline Breakdown</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:16 }}>Leads by current status</div>
              <div style={{ display:"flex", alignItems:"center", gap:20 }}>
                <DonutChart size={110} thickness={16} segments={
                  Object.entries(statusBreakdown).map(([s,v]) => ({
                    value:v, color: STAGE_COLORS[s] || "var(--stone-400)"
                  }))
                }/>
                <div style={{ flex:1, display:"grid", gap:6 }}>
                  {Object.entries(statusBreakdown).map(([s,v]) => (
                    <div key={s} style={{ display:"flex", justifyContent:"space-between", fontSize:"12px" }}>
                      <div style={{ display:"flex", alignItems:"center", gap:7 }}>
                        <div style={{ width:9, height:9, borderRadius:"50%", background:STAGE_COLORS[s]||"var(--stone-400)", flexShrink:0 }}/>
                        <span style={{ color:"var(--stone-600)" }}>{s}</span>
                      </div>
                      <span style={{ fontWeight:700 }}>{v}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Action items */}
          <ReportSection title="Attention Required" sub="Items that need your immediate review">
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))", gap:10 }}>
              {[
                { color:"var(--accent-red)",   icon:"⚠️", label:"Overdue Invoices",   value: fInvoices.filter(i=>i.status==="Overdue").length,  action:"Review in Invoicing" },
                { color:"var(--accent-amber)", icon:"📋", label:"Draft Estimates",     value: fEstimates.filter(e=>e.status==="Draft").length,    action:"Send or finalize" },
                { color:"var(--accent-blue)",  icon:"📞", label:"Missed Calls",        value: missedCalls.length,                               action:"Return calls today" },
                { color:"var(--accent-amber)", icon:"🎯", label:"Leads Not Contacted", value: fLeads.filter(l=>l.status==="New").length,         action:"Follow up now" },
              ].map(item => (
                <div key={item.label} className="card" style={{ padding:"14px 16px", borderLeft:`4px solid ${item.color}`, display:"flex", alignItems:"center", gap:14 }}>
                  <span style={{ fontSize:22, flexShrink:0 }}>{item.icon}</span>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:700, fontSize:"18px", color:item.color, lineHeight:1 }}>{item.value}</div>
                    <div style={{ fontSize:"12px", color:"var(--stone-600)", marginTop:2 }}>{item.label}</div>
                  </div>
                  <div style={{ fontSize:"11px", color:"var(--stone-400)" }}>{item.action}</div>
                </div>
              ))}
            </div>
          </ReportSection>
        </div>
      )}

      {/* ════════════════════ REVENUE ════════════════════ */}
      {activeReport === "revenue" && (
        <div className="fade-in">
          <ReportSection title="Revenue Summary" sub="Collected, outstanding, and projected income">
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(190px,1fr))", gap:12, marginBottom:16 }}>
              <KpiCard label="Total Collected" value={fmtFull(totalRevenue)} color="var(--accent-green)" icon="✅" sub={`${paidInvoices.length} invoices paid`}/>
              <KpiCard label="Outstanding" value={fmtFull(outstanding)} color="var(--accent-amber)" icon="⏳" sub="Awaiting payment"/>
              <KpiCard label="Overdue" value={fmtFull(overdueAmt)} color="var(--accent-red)" icon="🚨" sub={`${invoices.filter(i=>i.status==="Overdue").length} invoices overdue`}/>
              <KpiCard label="Avg Job Value" value={fmtFull(avgJobValue)} color="var(--warm-gold)" icon="📊" sub="Per completed job"/>
              <KpiCard label="Est. Pipeline" value={fmtFull(estTotalValue)} color="var(--accent-blue)" icon="🎯" sub={`${estimates.length} estimates total`}/>
            </div>
          </ReportSection>

          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:28 }}>
            {/* Revenue by job */}
            <div className="card" style={{ padding:"20px" }}>
              <div style={{ fontWeight:700, fontSize:"14px", marginBottom:4 }}>Revenue by Job</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:16 }}>All-time collected per job</div>
              <div style={{ display:"grid", gap:8 }}>
                {[...fJobs].filter(j=>(j.value||0)>0).sort((a,b) => (b.value||0)-(a.value||0)).map(j => {
                  const maxVal = Math.max(...fJobs.filter(x=>(x.value||0)>0).map(x=>x.value||0), 1);
                  const estId = j.estimateId || j.estimate_id;
                  const isPaid = invoices.find(i => (i.jobId === j.id || i.job_id === j.id || (estId && (i.estimate_id === estId || i.estimateId === estId))) && i.status === "Paid");
                  return (
                    <div key={j.id}>
                      <div style={{ display:"flex", justifyContent:"space-between", fontSize:"12px", marginBottom:4 }}>
                        <span style={{ color:"var(--stone-600)", flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:180 }}>{j.project}</span>
                        <span style={{ fontWeight:700, color: isPaid?"var(--accent-green)":"var(--stone-600)", marginLeft:8 }}>{fmtFull(j.value||0)}</span>
                      </div>
                      <div style={{ height:5, background:"var(--stone-200)", borderRadius:3 }}>
                        <div style={{ height:"100%", width:`${((j.value||0)/maxVal)*100}%`, background: isPaid?"var(--accent-green)":"var(--accent-amber)", borderRadius:3, transition:"width 0.5s ease" }}/>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div style={{ display:"flex", gap:12, marginTop:14, fontSize:"11px" }}>
                <div style={{ display:"flex", alignItems:"center", gap:5 }}><div style={{ width:8,height:8,borderRadius:"50%",background:"var(--accent-green)" }}/> Paid</div>
                <div style={{ display:"flex", alignItems:"center", gap:5 }}><div style={{ width:8,height:8,borderRadius:"50%",background:"var(--accent-amber)" }}/> Pending</div>
              </div>
            </div>

            {/* Revenue by customer */}
            <div className="card" style={{ padding:"20px" }}>
              <div style={{ fontWeight:700, fontSize:"14px", marginBottom:4 }}>Revenue by Customer</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:16 }}>Lifetime value per customer</div>
              <div style={{ display:"grid", gap:8 }}>
                {topCustomers.map(c => {
                  const maxVal = Math.max(...topCustomers.map(x=>x.totalRevenue||0), 1);
                  return (
                    <div key={c.id}>
                      <div style={{ display:"flex", justifyContent:"space-between", fontSize:"12px", marginBottom:4 }}>
                        <span style={{ color:"var(--stone-600)" }}>{c.name}</span>
                        <span style={{ fontWeight:700, color:"var(--warm-gold)" }}>{fmtFull(c.totalRevenue||0)}</span>
                      </div>
                      <div style={{ height:5, background:"var(--stone-200)", borderRadius:3 }}>
                        <div style={{ height:"100%", width:`${((c.totalRevenue||0)/maxVal)*100}%`, background:"var(--warm-gold)", borderRadius:3, transition:"width 0.5s ease" }}/>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Invoice table */}
          <ReportSection title="Invoice Register" sub="All invoices and their current status">
            <div className="card" style={{ padding:0 }}>
              <div style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse" }}>
                  <thead>
                    <tr style={{ background:"var(--stone-100)", fontSize:"11px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--stone-500)" }}>
                      {["Invoice","Customer","Project","Amount","Issued","Due","Status"].map(h => (
                        <th key={h} style={{ padding:"10px 14px", textAlign:"left", whiteSpace:"nowrap" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {fInvoices.map(inv => {
                      const sc = { Paid:"var(--accent-green)", Invoiced:"var(--accent-blue)", Overdue:"var(--accent-red)", Draft:"var(--stone-400)" };
                      return (
                        <tr key={inv.id} style={{ borderBottom:"1px solid var(--stone-100)", fontSize:"13px" }}>
                          <td style={{ padding:"11px 14px", fontWeight:600 }}>{inv.id}</td>
                          <td style={{ padding:"11px 14px", color:"var(--stone-600)" }}>{inv.customer}</td>
                          <td style={{ padding:"11px 14px", color:"var(--stone-600)" }}>{inv.project}</td>
                          <td style={{ padding:"11px 14px", fontWeight:700 }}>{fmtFull(invTotal(inv))}</td>
                          <td style={{ padding:"11px 14px", color:"var(--stone-500)", fontSize:"12px" }}>{inv.issued}</td>
                          <td style={{ padding:"11px 14px", color:"var(--stone-500)", fontSize:"12px" }}>{(inv.payments?.find(p=>p.status!=="Paid")?.due || inv.issued)}</td>
                          <td style={{ padding:"11px 14px" }}>
                            <span style={{ fontSize:"11px", fontWeight:700, background:`${sc[inv.status]||"var(--stone-400)"}18`, color:sc[inv.status]||"var(--stone-400)", padding:"3px 9px", borderRadius:99 }}>
                              {inv.status}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </ReportSection>
        </div>
      )}

      {/* ════════════════════ LEADS & PIPELINE ════════════════════ */}
      {activeReport === "leads" && (
        <div className="fade-in">
          <ReportSection title="Pipeline Metrics" sub="Lead volume, conversion, and source performance">
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))", gap:12, marginBottom:16 }}>
              <KpiCard label="Total Leads" value={fLeads.length} icon="📋" color="var(--stone-700)"/>
              <KpiCard label="Won" value={wonLeads.length} icon="✅" color="var(--accent-green)" sub={`${fmtFull(wonLeads.reduce((a,l)=>a+(l.value||0),0))} value`}/>
              <KpiCard label="Lost" value={lostLeads.length} icon="❌" color="var(--accent-red)" sub={`${fmtFull(lostLeads.reduce((a,l)=>a+(l.value||0),0))} lost value`}/>
              <KpiCard label="Conversion Rate" value={`${conversionRate}%`} icon="📈" color="var(--warm-gold)"/>
              <KpiCard label="Active Pipeline" value={fmtFull(pipelineValue)} icon="🎯" color="var(--accent-blue)" sub="Potential revenue"/>
            </div>
          </ReportSection>

          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:28 }}>
            {/* Lead source breakdown */}
            <div className="card" style={{ padding:"20px" }}>
              <div style={{ fontWeight:700, fontSize:"14px", marginBottom:4 }}>Leads by Source</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:16 }}>Where your leads come from</div>
              <MiniBar height={80} color="var(--accent-blue)"
                data={Object.entries(sourceBreakdown).map(([k,v]) => ({ label:k, value:v }))}
              />
              <div style={{ marginTop:14, display:"grid", gap:6 }}>
                {Object.entries(sourceBreakdown).sort((a,b)=>b[1]-a[1]).map(([src, cnt]) => (
                  <div key={src} style={{ display:"flex", justifyContent:"space-between", fontSize:"12px" }}>
                    <span style={{ color:"var(--stone-600)" }}>{src}</span>
                    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                      <span style={{ fontWeight:700 }}>{cnt}</span>
                      <span style={{ fontSize:"11px", color:"var(--stone-400)" }}>({Math.round(cnt/fLeads.length*100)}%)</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Pipeline funnel */}
            <div className="card" style={{ padding:"20px" }}>
              <div style={{ fontWeight:700, fontSize:"14px", marginBottom:4 }}>Pipeline Funnel</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:16 }}>Lead progression through stages</div>
              <div style={{ display:"grid", gap:8 }}>
                {PIPELINE_STAGES.map(stage => {
                  const cnt   = fLeads.filter(l => l.status === stage).length;
                  const value = fLeads.filter(l => l.status === stage).reduce((a,l)=>a+(l.value||0),0);
                  const pct   = fLeads.length ? Math.round(cnt/fLeads.length*100) : 0;
                  return (
                    <div key={stage} style={{ display:"flex", alignItems:"center", gap:10 }}>
                      <div style={{ width:80, fontSize:"12px", color:"var(--stone-600)", flexShrink:0 }}>{stage}</div>
                      <div style={{ flex:1, height:22, background:"var(--stone-100)", borderRadius:4, position:"relative", overflow:"hidden" }}>
                        <div style={{ height:"100%", width:`${Math.max(pct,2)}%`, background:STAGE_COLORS[stage]||"var(--stone-400)", borderRadius:4, transition:"width 0.5s" }}/>
                        <span style={{ position:"absolute", right:8, top:"50%", transform:"translateY(-50%)", fontSize:"11px", fontWeight:700, color:"var(--stone-600)" }}>{cnt} · {fmtFull(value)}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Lead table */}
          <ReportSection title="Lead Register" sub="All leads with status and value">
            <div className="card" style={{ padding:0 }}>
              <div style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse" }}>
                  <thead>
                    <tr style={{ background:"var(--stone-100)", fontSize:"11px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--stone-500)" }}>
                      {["Name","Project","Source","Status","Value","Date"].map(h=>(
                        <th key={h} style={{ padding:"10px 14px", textAlign:"left" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {fLeads.map(l => (
                      <tr key={l.id} style={{ borderBottom:"1px solid var(--stone-100)", fontSize:"13px" }}>
                        <td style={{ padding:"10px 14px", fontWeight:600 }}>{l.name}</td>
                        <td style={{ padding:"10px 14px", color:"var(--stone-600)" }}>{l.project}</td>
                        <td style={{ padding:"10px 14px", color:"var(--stone-500)", fontSize:"12px" }}>{l.source}</td>
                        <td style={{ padding:"10px 14px" }}>
                          <span style={{ fontSize:"11px", fontWeight:700, background:`${STAGE_COLORS[l.status]||"var(--stone-400)"}20`, color:STAGE_COLORS[l.status]||"var(--stone-500)", padding:"3px 9px", borderRadius:99 }}>{l.status}</span>
                        </td>
                        <td style={{ padding:"10px 14px", fontWeight:700 }}>{fmtFull(l.value||0)}</td>
                        <td style={{ padding:"10px 14px", color:"var(--stone-400)", fontSize:"12px" }}>{l.date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </ReportSection>
        </div>
      )}

      {/* ════════════════════ JOBS ════════════════════ */}
      {activeReport === "jobs" && (
        <div className="fade-in">
          <ReportSection title="Job Performance" sub="Completion rates, crew productivity, and job value">
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))", gap:12, marginBottom:16 }}>
              <KpiCard label="Total Jobs" value={fJobs.length} icon="🔨" color="var(--stone-700)"/>
              <KpiCard label="Completed" value={completedJobs.length} icon="✅" color="var(--accent-green)" sub={`${fJobs.length ? Math.round(completedJobs.length/fJobs.length*100) : 0}% completion rate`}/>
              <KpiCard label="In Progress" value={inProgressJobs.length} icon="⚙️" color="var(--accent-blue)"/>
              <KpiCard label="Scheduled" value={scheduledJobs.length} icon="📅" color="var(--warm-gold)"/>
              <KpiCard label="Total Job Value" value={fmtFull(fJobs.reduce((a,j)=>a+(j.value||0),0))} icon="💰" color="var(--accent-green)"/>
            </div>
          </ReportSection>

          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:28 }}>
            {/* Job status donut */}
            <div className="card" style={{ padding:"20px" }}>
              <div style={{ fontWeight:700, fontSize:"14px", marginBottom:4 }}>Jobs by Status</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:16 }}>Current job portfolio breakdown</div>
              <div style={{ display:"flex", alignItems:"center", gap:20 }}>
                <DonutChart size={110} thickness={18} segments={jobsByStatus}/>
                <div style={{ flex:1, display:"grid", gap:7 }}>
                  {jobsByStatus.map(s => (
                    <div key={s.label} style={{ display:"flex", justifyContent:"space-between", fontSize:"12px" }}>
                      <div style={{ display:"flex", alignItems:"center", gap:7 }}>
                        <div style={{ width:9, height:9, borderRadius:"50%", background:s.color, flexShrink:0 }}/>
                        <span style={{ color:"var(--stone-600)" }}>{s.label}</span>
                      </div>
                      <span style={{ fontWeight:700 }}>{s.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Revenue by crew */}
            <div className="card" style={{ padding:"20px" }}>
              <div style={{ fontWeight:700, fontSize:"14px", marginBottom:4 }}>Revenue by Crew</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:16 }}>Job value attributed per team</div>
              {Object.keys(jobsByCrewRaw).length === 0
                ? <div style={{ fontSize:"13px", color:"var(--stone-400)", textAlign:"center", padding:"20px 0" }}>No crew data available</div>
                : <div style={{ display:"grid", gap:10 }}>
                    {Object.entries(jobsByCrewRaw).sort((a,b)=>b[1]-a[1]).map(([crew, val]) => {
                      const maxVal = Math.max(...Object.values(jobsByCrewRaw), 1);
                      return (
                        <div key={crew}>
                          <div style={{ display:"flex", justifyContent:"space-between", fontSize:"12px", marginBottom:4 }}>
                            <span style={{ color:"var(--stone-600)" }}>{crew}</span>
                            <span style={{ fontWeight:700, color:"var(--warm-gold)" }}>{fmtFull(val)}</span>
                          </div>
                          <div style={{ height:6, background:"var(--stone-200)", borderRadius:3 }}>
                            <div style={{ height:"100%", width:`${(val/maxVal)*100}%`, background:"var(--warm-gold)", borderRadius:3 }}/>
                          </div>
                        </div>
                      );
                    })}
                  </div>
              }
            </div>
          </div>

          {/* Jobs table */}
          <ReportSection title="Job Register" sub="All jobs with status, value, and crew assignment">
            <div className="card" style={{ padding:0 }}>
              <div style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse" }}>
                  <thead>
                    <tr style={{ background:"var(--stone-100)", fontSize:"11px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--stone-500)" }}>
                      {["Project","Customer","Status","Crew","Start","End","Value"].map(h=>(
                        <th key={h} style={{ padding:"10px 14px", textAlign:"left", whiteSpace:"nowrap" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {fJobs.map(j => {
                      const sc = { Completed:"var(--accent-green)", "In Progress":"var(--accent-blue)", Scheduled:"var(--warm-gold)", "On Hold":"var(--stone-400)" };
                      return (
                        <tr key={j.id} style={{ borderBottom:"1px solid var(--stone-100)", fontSize:"13px" }}>
                          <td style={{ padding:"10px 14px", fontWeight:600 }}>{j.project}</td>
                          <td style={{ padding:"10px 14px", color:"var(--stone-600)" }}>{j.customer}</td>
                          <td style={{ padding:"10px 14px" }}>
                            <span style={{ fontSize:"11px", fontWeight:700, background:`${sc[j.status]||"var(--stone-400)"}18`, color:sc[j.status]||"var(--stone-500)", padding:"3px 9px", borderRadius:99 }}>{j.status}</span>
                          </td>
                          <td style={{ padding:"10px 14px", fontSize:"12px", color:"var(--stone-500)" }}>{j.crew||"—"}</td>
                          <td style={{ padding:"10px 14px", fontSize:"12px", color:"var(--stone-400)" }}>{j.startDate}</td>
                          <td style={{ padding:"10px 14px", fontSize:"12px", color:"var(--stone-400)" }}>{j.endDate||"TBD"}</td>
                          <td style={{ padding:"10px 14px", fontWeight:700 }}>{fmtFull(j.value||0)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </ReportSection>
        </div>
      )}

      {/* ════════════════════ CALLS ════════════════════ */}
      {activeReport === "calls" && (
        <div className="fade-in">
          <ReportSection title="Call Activity" sub="Volume, outcomes, and responsiveness metrics">
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:12, marginBottom:16 }}>
              <KpiCard label="Total Calls" value={fCalls.length} icon="📞" color="var(--stone-700)"/>
              <KpiCard label="Answered" value={answeredCalls.length} icon="✅" color="var(--accent-green)" sub={`${answerRate}% answer rate`}/>
              <KpiCard label="Missed" value={missedCalls.length} icon="❌" color="var(--accent-red)"/>
              <KpiCard label="Voicemail" value={fCalls.filter(c=>c.outcome==="Voicemail").length} icon="📬" color="var(--accent-amber)"/>
              <KpiCard label="Inbound" value={inboundCalls.length} icon="⬇️" color="var(--accent-blue)" sub={`${fCalls.length ? Math.round(inboundCalls.length/fCalls.length*100) : 0}% of calls`}/>
              <KpiCard label="Outbound" value={outboundCalls.length} icon="⬆️" color="var(--warm-gold)" sub={`${fCalls.length ? Math.round(outboundCalls.length/fCalls.length*100) : 0}% of calls`}/>
            </div>
          </ReportSection>

          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:28 }}>
            <div className="card" style={{ padding:"20px" }}>
              <div style={{ fontWeight:700, fontSize:"14px", marginBottom:4 }}>Outcomes Breakdown</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:16 }}>How calls are resolving</div>
              <div style={{ display:"flex", alignItems:"center", gap:20 }}>
                <DonutChart size={110} thickness={16} segments={[
                  { value:answeredCalls.length, color:"var(--accent-green)" },
                  { value:missedCalls.length,   color:"var(--accent-red)"   },
                  { value:fCalls.filter(c=>c.outcome==="Voicemail").length, color:"var(--accent-amber)" },
                ]}/>
                <div style={{ flex:1, display:"grid", gap:7 }}>
                  {[["Answered",answeredCalls.length,"var(--accent-green)"],["Missed",missedCalls.length,"var(--accent-red)"],["Voicemail",fCalls.filter(c=>c.outcome==="Voicemail").length,"var(--accent-amber)"]].map(([l,v,c])=>(
                    <div key={l} style={{ display:"flex", justifyContent:"space-between", fontSize:"12px" }}>
                      <div style={{ display:"flex", alignItems:"center", gap:7 }}>
                        <div style={{ width:9, height:9, borderRadius:"50%", background:c }}/>
                        <span style={{ color:"var(--stone-600)" }}>{l}</span>
                      </div>
                      <span style={{ fontWeight:700 }}>{v}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="card" style={{ padding:"20px" }}>
              <div style={{ fontWeight:700, fontSize:"14px", marginBottom:4 }}>Inbound vs. Outbound</div>
              <div style={{ fontSize:"12px", color:"var(--stone-400)", marginBottom:16 }}>Call direction split</div>
              <MiniBar height={80} color="var(--accent-blue)"
                data={[{ label:"Inbound", value:inboundCalls.length },{ label:"Outbound", value:outboundCalls.length }]}
              />
              <div style={{ marginTop:14, display:"grid", gap:6 }}>
                {[["Inbound",inboundCalls.length,"var(--accent-blue)"],["Outbound",outboundCalls.length,"var(--warm-gold)"]].map(([l,v,c])=>(
                  <div key={l} style={{ display:"flex", justifyContent:"space-between", fontSize:"12px" }}>
                    <span style={{ color:"var(--stone-600)" }}>{l}</span><span style={{ fontWeight:700,color:c }}>{v}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Call log */}
          <ReportSection title="Call Log" sub="All recorded calls">
            <div className="card" style={{ padding:0 }}>
              <div style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse" }}>
                  <thead>
                    <tr style={{ background:"var(--stone-100)", fontSize:"11px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--stone-500)" }}>
                      {["Date","Time","Contact","Direction","Outcome","Duration","Notes"].map(h=>(
                        <th key={h} style={{ padding:"10px 14px", textAlign:"left" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {[...calls].sort((a,b)=>new Date(b.date)-new Date(a.date)).map(c => {
                      const oc = { Answered:"var(--accent-green)", Missed:"var(--accent-red)", Voicemail:"var(--accent-amber)" };
                      return (
                        <tr key={c.id} style={{ borderBottom:"1px solid var(--stone-100)", fontSize:"13px" }}>
                          <td style={{ padding:"10px 14px", color:"var(--stone-500)", fontSize:"12px", whiteSpace:"nowrap" }}>{c.date}</td>
                          <td style={{ padding:"10px 14px", color:"var(--stone-600)", fontSize:"12px", whiteSpace:"nowrap", fontWeight:500 }}>{c.time||"—"}</td>
                          <td style={{ padding:"10px 14px", fontWeight:600 }}>{c.contact}</td>
                          <td style={{ padding:"10px 14px", fontSize:"12px" }}>
                            <span style={{ color: c.direction==="inbound" ? "var(--accent-blue)" : "var(--warm-gold)", fontWeight:600 }}>{c.direction==="inbound"?"⬇ In":"⬆ Out"}</span>
                          </td>
                          <td style={{ padding:"10px 14px" }}>
                            <span style={{ fontSize:"11px", fontWeight:700, background:`${oc[c.outcome]||"var(--stone-400)"}18`, color:oc[c.outcome]||"var(--stone-400)", padding:"3px 9px", borderRadius:99 }}>{c.outcome}</span>
                          </td>
                          <td style={{ padding:"10px 14px", fontFamily:"monospace", fontSize:"12px" }}>{c.duration}</td>
                          <td style={{ padding:"10px 14px", fontSize:"12px", color:"var(--stone-500)", maxWidth:240, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{c.notes||"—"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </ReportSection>
        </div>
      )}

      {/* ════════════════════ CUSTOMERS ════════════════════ */}
      {activeReport === "customers" && (
        <div className="fade-in">
          <ReportSection title="Customer Metrics" sub="Lifetime value, retention, and top accounts">
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))", gap:12, marginBottom:16 }}>
              <KpiCard label="Total Customers" value={customers.length} icon="👥" color="var(--stone-700)"/>
              <KpiCard label="Repeat Customers" value={repeatCustomers.length} icon="🔁" color="var(--accent-green)" sub={`${customers.length ? Math.round(repeatCustomers.length/customers.length*100) : 0}% retention rate`}/>
              <KpiCard label="Total Lifetime Revenue" value={fmtFull(totalCustomerRevenue)} icon="💰" color="var(--warm-gold)"/>
              <KpiCard label="Avg Revenue / Customer" value={fmtFull(avgRevenuePerCustomer)} icon="📊" color="var(--accent-blue)"/>
              <KpiCard label="Avg Jobs / Customer" value={(customers.reduce((a,c)=>a+(c.totalJobs||0),0)/Math.max(customers.length,1)).toFixed(1)} icon="🔨" color="var(--accent-amber)"/>
            </div>
          </ReportSection>

          {/* Top customers table */}
          <ReportSection title="Customer Leaderboard" sub="Ranked by total lifetime revenue">
            <div className="card" style={{ padding:0 }}>
              {[...customers].sort((a,b)=>(b.totalRevenue||0)-(a.totalRevenue||0)).map((c, idx) => {
                const maxRev = Math.max(...customers.map(x=>x.totalRevenue||0), 1);
                return (
                  <div key={c.id} style={{ display:"flex", alignItems:"center", gap:14, padding:"14px 18px", borderBottom:"1px solid var(--stone-100)" }}>
                    <div style={{ width:28, height:28, borderRadius:"50%", background: idx===0?"var(--warm-gold)":idx===1?"var(--stone-400)":idx===2?"#cd7f32":"var(--stone-200)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"12px", fontWeight:800, color:"white", flexShrink:0 }}>
                      {idx+1}
                    </div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontWeight:600, fontSize:"14px", marginBottom:5 }}>{c.name}</div>
                      <div style={{ height:5, background:"var(--stone-200)", borderRadius:3, maxWidth:300 }}>
                        <div style={{ height:"100%", width:`${((c.totalRevenue||0)/maxRev)*100}%`, background:"var(--warm-gold)", borderRadius:3 }}/>
                      </div>
                    </div>
                    <div style={{ textAlign:"right", flexShrink:0 }}>
                      <div style={{ fontWeight:800, fontSize:"16px", color:"var(--warm-gold)" }}>{fmtFull(c.totalRevenue||0)}</div>
                      <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:2 }}>{c.totalJobs||0} job{(c.totalJobs||0)!==1?"s":""} · since {c.since||"—"}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </ReportSection>
        </div>
      )}

      {/* ════════════════════ INVOICE AGING ════════════════════ */}
      {activeReport === "aging" && (
        <div className="fade-in">
          {(() => {
            const today = new Date();
            const daysDiff = (dateStr) => {
              if (!dateStr) return null;
              const diff = Math.floor((today - new Date(dateStr)) / (1000 * 60 * 60 * 24));
              return diff;
            };

            // Only outstanding invoices (not paid, not draft)
            const outstanding = invoices.filter(i => ["Invoiced","Overdue"].includes(i.status));

            // Aging buckets
            const buckets = [
              { label:"Current",     range:"Not yet due",   days:[null, 0],   color:"var(--accent-green)",  bg:"#e8f5e9" },
              { label:"1–30 Days",   range:"1–30 days past due",  days:[1,30],  color:"var(--accent-amber)",  bg:"#fff8e1" },
              { label:"31–60 Days",  range:"31–60 days past due", days:[31,60], color:"#f57c00",              bg:"#fff3e0" },
              { label:"61–90 Days",  range:"61–90 days past due", days:[61,90], color:"var(--accent-red)",    bg:"#ffebee" },
              { label:"90+ Days",    range:"Over 90 days past due",days:[91,null],color:"#7b0000",            bg:"#fce4ec" },
            ];

            const getBucket = (inv) => {
              const age = daysDiff((inv.payments?.find(p=>p.status!=="Paid")?.due || inv.issued));
              if (age === null) return 0;
              if (age <= 0)  return 0;
              if (age <= 30) return 1;
              if (age <= 60) return 2;
              if (age <= 90) return 3;
              return 4;
            };

            const bucketed = buckets.map((b, i) => ({
              ...b,
              invoices: outstanding.filter(inv => getBucket(inv) === i),
            }));

            const totalOutstanding = outstanding.reduce((a,i) => a + invTotal(i), 0);
            const totalOverdue     = outstanding.filter(i => daysDiff((i.payments?.find(p=>p.status!=="Paid")?.due || i.issued)) > 0).reduce((a,i) => a + invTotal(i), 0);
            const avgAgeDays       = outstanding.length
              ? Math.round(outstanding.reduce((a,i) => a + Math.max(daysDiff((i.payments?.find(p=>p.status!=="Paid")?.due || i.issued))||0, 0), 0) / outstanding.length)
              : 0;
            const oldestInv        = outstanding.reduce((oldest, inv) => {
              const age = daysDiff((inv.payments?.find(p=>p.status!=="Paid")?.due || inv.issued)) || 0;
              return age > (daysDiff(oldest?.due) || 0) ? inv : oldest;
            }, null);

            return (
              <>
                {/* KPIs */}
                <ReportSection title="Invoice Aging Report" sub="Outstanding balances grouped by how long they've been past due">
                  <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(190px,1fr))", gap:12, marginBottom:20 }}>
                    <KpiCard label="Total Outstanding" value={`$${totalOutstanding.toLocaleString()}`} icon="💳" color="var(--accent-amber)" sub={`${outstanding.length} unpaid invoice${outstanding.length!==1?"s":""}`}/>
                    <KpiCard label="Total Overdue" value={`$${totalOverdue.toLocaleString()}`} icon="🚨" color="var(--accent-red)" sub={`${outstanding.filter(i=>daysDiff((i.payments?.find(p=>p.status!=="Paid")?.due || i.issued))>0).length} invoices past due`}/>
                    <KpiCard label="Avg Days Overdue" value={`${avgAgeDays}d`} icon="📅" color={avgAgeDays > 30 ? "var(--accent-red)" : avgAgeDays > 0 ? "var(--accent-amber)" : "var(--accent-green)"} sub="Across all outstanding"/>
                    <KpiCard label="Oldest Invoice" value={oldestInv ? `${Math.max(daysDiff(oldestInv.due)||0,0)}d` : "—"} icon="⏳" color="var(--accent-red)" sub={oldestInv ? oldestInv.customer : "No overdue invoices"}/>
                  </div>
                </ReportSection>

                {/* Aging summary bars */}
                <ReportSection title="Aging Summary" sub="Outstanding balance by age bracket">
                  <div style={{ display:"grid", gap:10, marginBottom:28 }}>
                    {bucketed.map((b) => {
                      const bucketTotal = b.invoices.reduce((a,i) => a + invTotal(i), 0);
                      const pct = totalOutstanding > 0 ? (bucketTotal / totalOutstanding) * 100 : 0;
                      return (
                        <div key={b.label} className="card" style={{ padding:"14px 18px", borderLeft:`4px solid ${b.color}` }}>
                          <div style={{ display:"flex", alignItems:"center", gap:14, flexWrap:"wrap" }}>
                            {/* Bucket label */}
                            <div style={{ width:100, flexShrink:0 }}>
                              <div style={{ fontWeight:700, fontSize:"13px", color:b.color }}>{b.label}</div>
                              <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:1 }}>{b.range}</div>
                            </div>
                            {/* Bar */}
                            <div style={{ flex:1, height:22, background:"var(--stone-100)", borderRadius:4, position:"relative", overflow:"hidden", minWidth:100 }}>
                              <div style={{ height:"100%", width:`${Math.max(pct, pct > 0 ? 2 : 0)}%`, background:b.color, borderRadius:4, transition:"width 0.5s ease", opacity:0.85 }}/>
                              {bucketTotal > 0 && (
                                <span style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)", fontSize:"11px", fontWeight:700, color: pct > 20 ? "white" : b.color }}>
                                  {pct.toFixed(0)}%
                                </span>
                              )}
                            </div>
                            {/* Count & amount */}
                            <div style={{ textAlign:"right", flexShrink:0, minWidth:130 }}>
                              <div style={{ fontWeight:800, fontSize:"16px", color:b.color }}>${bucketTotal.toLocaleString()}</div>
                              <div style={{ fontSize:"11px", color:"var(--stone-400)", marginTop:1 }}>
                                {b.invoices.length} invoice{b.invoices.length!==1?"s":""}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </ReportSection>

                {/* Detailed invoice table per bucket */}
                <ReportSection title="Invoice Detail by Age" sub="Every outstanding invoice with days overdue and recommended action">
                  {bucketed.filter(b => b.invoices.length > 0).map(b => (
                    <div key={b.label} style={{ marginBottom:20 }}>
                      {/* Bucket header */}
                      <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
                        <div style={{ width:10, height:10, borderRadius:"50%", background:b.color, flexShrink:0 }}/>
                        <span style={{ fontWeight:700, fontSize:"13px", color:b.color }}>{b.label}</span>
                        <span style={{ fontSize:"12px", color:"var(--stone-400)" }}>— {b.range}</span>
                        <span style={{ marginLeft:"auto", fontWeight:700, fontSize:"13px", color:b.color }}>
                          ${b.invoices.reduce((a,i)=>a+invTotal(i),0).toLocaleString()}
                        </span>
                      </div>

                      <div className="card" style={{ padding:0 }}>
                        <div style={{ overflowX:"auto" }}>
                          <table style={{ width:"100%", borderCollapse:"collapse" }}>
                            <thead>
                              <tr style={{ background: b.bg, fontSize:"11px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--stone-500)" }}>
                                {["Invoice","Customer","Project","Amount","Due Date","Days Overdue","Action"].map(h => (
                                  <th key={h} style={{ padding:"9px 14px", textAlign:"left", whiteSpace:"nowrap" }}>{h}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {[...b.invoices].sort((a,z) => (daysDiff(z.due)||0) - (daysDiff(a.due)||0)).map(inv => {
                                const age     = Math.max(daysDiff((inv.payments?.find(p=>p.status!=="Paid")?.due || inv.issued)) || 0, 0);
                                const isOverdue = age > 0;

                                // Recommended action based on age
                                const action = age <= 0
                                  ? { label:"Send Reminder",    color:"var(--accent-green)" }
                                  : age <= 30
                                  ? { label:"Call Client",       color:"var(--accent-amber)" }
                                  : age <= 60
                                  ? { label:"Second Notice",     color:"#f57c00"             }
                                  : age <= 90
                                  ? { label:"Final Notice",      color:"var(--accent-red)"   }
                                  : { label:"Collections / Legal",color:"#7b0000"            };

                                return (
                                  <tr key={inv.id} style={{ borderBottom:"1px solid var(--stone-100)", fontSize:"13px" }}>
                                    <td style={{ padding:"10px 14px", fontWeight:700, color:"var(--stone-700)" }}>{inv.id}</td>
                                    <td style={{ padding:"10px 14px", fontWeight:600 }}>{inv.customer}</td>
                                    <td style={{ padding:"10px 14px", color:"var(--stone-500)", fontSize:"12px" }}>{inv.project}</td>
                                    <td style={{ padding:"10px 14px", fontWeight:800, color:b.color }}>${invTotal(inv).toLocaleString()}</td>
                                    <td style={{ padding:"10px 14px", color:"var(--stone-500)", fontSize:"12px", whiteSpace:"nowrap" }}>{(inv.payments?.find(p=>p.status!=="Paid")?.due || inv.issued)}</td>
                                    <td style={{ padding:"10px 14px" }}>
                                      {isOverdue
                                        ? <span style={{ fontWeight:800, color:b.color }}>{age} days</span>
                                        : <span style={{ fontSize:"12px", color:"var(--accent-green)", fontWeight:600 }}>Not yet due</span>
                                      }
                                    </td>
                                    <td style={{ padding:"10px 14px" }}>
                                      <span style={{ fontSize:"11px", fontWeight:700, background:`${action.color}18`, color:action.color, padding:"3px 10px", borderRadius:99, whiteSpace:"nowrap" }}>
                                        {action.label}
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  ))}

                  {outstanding.length === 0 && (
                    <div className="card" style={{ padding:"40px", textAlign:"center" }}>
                      <div style={{ fontSize:40, marginBottom:10 }}>✅</div>
                      <div style={{ fontWeight:600, fontSize:"16px", color:"var(--accent-green)", marginBottom:4 }}>All invoices are paid</div>
                      <div style={{ fontSize:"13px", color:"var(--stone-400)" }}>No outstanding balances at this time.</div>
                    </div>
                  )}
                </ReportSection>

                {/* Collection action guide */}
                <div className="card" style={{ padding:"18px 20px", background:"var(--stone-50)" }}>
                  <div style={{ fontWeight:700, fontSize:"13px", marginBottom:12 }}>📋 Collection Action Guide</div>
                  <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))", gap:8 }}>
                    {[
                      { range:"Not yet due",    action:"Send a friendly payment reminder email",           color:"var(--accent-green)" },
                      { range:"1–30 days",      action:"Phone call to client, confirm invoice was received",color:"var(--accent-amber)" },
                      { range:"31–60 days",     action:"Second written notice, reference contract terms",   color:"#f57c00"             },
                      { range:"61–90 days",     action:"Final written notice with late fee warning",        color:"var(--accent-red)"   },
                      { range:"90+ days",       action:"Consider collections referral or legal action",     color:"#7b0000"             },
                    ].map(g => (
                      <div key={g.range} style={{ padding:"10px 12px", borderRadius:"var(--radius)", borderLeft:`3px solid ${g.color}`, background:`${g.color}0a` }}>
                        <div style={{ fontWeight:700, fontSize:"11px", color:g.color, textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:4 }}>{g.range}</div>
                        <div style={{ fontSize:"12px", color:"var(--stone-600)", lineHeight:1.5 }}>{g.action}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            );
          })()}
        </div>
      )}

      {/* ════════════════════ JOB PROFITABILITY ════════════════════ */}
      {activeReport === "profitability" && (
        <div className="fade-in">
          {(() => {
            // Build a map of job_id → budget cost data (also index by customer + estimate_id)
            const budgetCostByJob = {};
            const budgetCostByCustomer = {};
            const budgetCostByEstimate = {};

            budgets.forEach(b => {
              const phases = b.phases || [];
              let matActual = 0, labor = 0;

              phases.forEach(ph => {
                (ph.items || []).forEach(it => {
                  const actual = (Number(it.actualQty) || 0) * (Number(it.actualPrice) || 0);
                  const budgeted = (Number(it.budgetQty) || 0) * (Number(it.budgetPrice) || 0);
                  matActual += actual > 0 ? actual : budgeted;
                });
                const lActual = Number(ph.laborActual) || 0;
                const lBudget = Number(ph.laborBudget) || 0;
                labor += lActual > 0 ? lActual : lBudget;
              });

              const hasPhaseLabor = phases.some(ph => (Number(ph.laborBudget) || 0) > 0 || (Number(ph.laborActual) || 0) > 0);
              if (!hasPhaseLabor) {
                labor = (b.labor_type || b.laborType) === "flat"
                  ? (Number(b.labor_flat || b.laborFlat) || 0)
                  : (Number(b.labor_rate || b.laborRate) || 0) * (Number(b.labor_hours || b.laborHours) || 0);
              }

              const totalCost = matActual + labor;
              const entry = { matActual, labor, totalCost };
              if (b.job_id) budgetCostByJob[String(b.job_id)] = entry;
              if (b.customer) budgetCostByCustomer[b.customer.toLowerCase().trim()] = entry;
              if (b.estimate_id) budgetCostByEstimate[String(b.estimate_id)] = entry;
            });

            // Enrich each job — match budget by job_id, then estimate_id, then customer name
            const enriched = fJobs.map(j => {
              const revenue = j.value || 0;
              const estId = j.estimateId || j.estimate_id || j.estimateid;
              const budgetData = budgetCostByJob[String(j.id)]
                || (estId ? budgetCostByEstimate[String(estId)] : null)
                || (j.customer ? budgetCostByCustomer[j.customer.toLowerCase().trim()] : null);
              const cost = budgetData ? budgetData.totalCost : (j.cost || 0);
              const costSource = budgetData ? "budget" : (j.cost > 0 ? "job" : "none");
              const profit = revenue - cost;
              const margin = revenue > 0 ? (profit / revenue) * 100 : 0;
              return { ...j, revenue, cost, profit, margin, costSource,
                matActual: budgetData?.matActual || 0, laborCost: budgetData?.labor || 0 };
            });

            const withCost      = enriched.filter(j => j.cost > 0);
            const completed     = enriched.filter(j => j.status === "Completed" && j.cost > 0);
            const totalRevenue  = withCost.reduce((a, j) => a + j.revenue, 0);
            const totalCost     = withCost.reduce((a, j) => a + j.cost, 0);
            const totalProfit   = totalRevenue - totalCost;
            const avgMargin     = withCost.length
              ? withCost.reduce((a, j) => a + j.margin, 0) / withCost.length
              : 0;
            const bestJob       = [...completed].sort((a, b) => b.margin - a.margin)[0];
            const worstJob      = [...completed].sort((a, b) => a.margin - b.margin)[0];

            const marginColor = (m) =>
              m >= 40 ? "var(--accent-green)"
              : m >= 25 ? "var(--warm-gold)"
              : m >= 10 ? "var(--accent-amber)"
              : "var(--accent-red)";

            const marginLabel = (m) =>
              m >= 40 ? "Excellent"
              : m >= 25 ? "Healthy"
              : m >= 10 ? "Tight"
              : "At Risk";

            // Crew-level rollup
            const byCrewMap = {};
            withCost.forEach(j => {
              if (!j.crew) return;
              if (!byCrewMap[j.crew]) byCrewMap[j.crew] = { revenue:0, cost:0, jobs:0 };
              byCrewMap[j.crew].revenue += j.revenue;
              byCrewMap[j.crew].cost    += j.cost;
              byCrewMap[j.crew].jobs    += 1;
            });
            const byCrew = Object.entries(byCrewMap).map(([crew, d]) => ({
              crew, ...d,
              profit: d.revenue - d.cost,
              margin: d.revenue > 0 ? ((d.revenue - d.cost) / d.revenue) * 100 : 0,
            })).sort((a, b) => b.margin - a.margin);

            const fmt = n => `$${n.toLocaleString()}`;
            const pct = n => `${n.toFixed(1)}%`;

            return (
              <>
                {/* KPIs */}
                <ReportSection title="Job Profitability Report" sub="Revenue vs. cost analysis — costs pulled from Project Budgets + Job Tracking">
                  <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(185px,1fr))", gap:12, marginBottom:20 }}>
                    <KpiCard label="Total Revenue" value={fmt(totalRevenue)} icon="💰" color="var(--accent-green)" sub={`${withCost.length} jobs with cost data`}/>
                    <KpiCard label="Total Cost" value={fmt(totalCost)} icon="🧾" color="var(--accent-red)" sub="Materials + labor"/>
                    <KpiCard label="Total Gross Profit" value={fmt(totalProfit)} icon="📈" color={marginColor(avgMargin)} sub={`${pct(avgMargin)} avg margin`}/>
                    <KpiCard label="Avg Margin" value={pct(avgMargin)} icon="🎯" color={marginColor(avgMargin)} sub={marginLabel(avgMargin)}/>
                    <KpiCard label="Best Margin" value={bestJob ? pct(bestJob.margin) : "—"} icon="🏆" color="var(--accent-green)" sub={bestJob?.project || "—"}/>
                    <KpiCard label="Lowest Margin" value={worstJob ? pct(worstJob.margin) : "—"} icon="⚠️" color={worstJob ? marginColor(worstJob.margin) : "var(--stone-400)"} sub={worstJob?.project || "—"}/>
                  </div>
                </ReportSection>

                {/* Margin health guide */}
                <div style={{ display:"flex", gap:8, marginBottom:24, flexWrap:"wrap" }}>
                  {[["40%+","Excellent","var(--accent-green)"],["25–39%","Healthy","var(--warm-gold)"],["10–24%","Tight","var(--accent-amber)"],["<10%","At Risk","var(--accent-red)"]].map(([range, label, color]) => (
                    <div key={label} style={{ display:"flex", alignItems:"center", gap:7, padding:"6px 12px", background:`${color}12`, border:`1px solid ${color}40`, borderRadius:"var(--radius)", fontSize:"12px" }}>
                      <div style={{ width:9, height:9, borderRadius:"50%", background:color, flexShrink:0 }}/>
                      <span style={{ fontWeight:700, color }}>{label}</span>
                      <span style={{ color:"var(--stone-500)" }}>{range} margin</span>
                    </div>
                  ))}
                </div>

                {/* Per-job breakdown */}
                <ReportSection title="Job-by-Job Breakdown" sub="Revenue, cost, profit, and margin per job">
                  <div style={{ display:"grid", gap:12, marginBottom:28 }}>
                    {enriched.map(j => {
                      const hasCost = j.cost > 0;
                      const mc = marginColor(j.margin);
                      const maxRevenue = Math.max(...enriched.map(x => x.revenue), 1);
                      return (
                        <div key={j.id} className="card" style={{ padding:"16px 20px", borderLeft:`4px solid ${hasCost ? mc : "var(--stone-200)"}` }}>
                          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:8, marginBottom:12 }}>
                            <div>
                              <div style={{ fontWeight:700, fontSize:"15px", marginBottom:2 }}>{j.project}</div>
                              <div style={{ fontSize:"12px", color:"var(--stone-400)" }}>
                                {j.customer} · {j.crew || "Unassigned"} · {j.startDate}
                              </div>
                            </div>
                            <div style={{ display:"flex", alignItems:"center", gap:8, flexShrink:0 }}>
                              {/* Status pill */}
                              {(() => {
                                const sc = { Completed:"var(--accent-green)", "In Progress":"var(--accent-blue)", Scheduled:"var(--warm-gold)", "On Hold":"var(--stone-400)" };
                                return <span style={{ fontSize:"11px", fontWeight:700, background:`${sc[j.status]||"var(--stone-400)"}18`, color:sc[j.status]||"var(--stone-500)", padding:"3px 9px", borderRadius:99 }}>{j.status}</span>;
                              })()}
                              {/* Margin badge */}
                              {hasCost && (
                                <span style={{ fontSize:"12px", fontWeight:800, background:`${mc}18`, color:mc, padding:"4px 12px", borderRadius:99 }}>
                                  {pct(j.margin)} · {marginLabel(j.margin)}
                                </span>
                              )}
                            </div>
                          </div>

                          {hasCost ? (
                            <>
                              {/* Revenue vs cost bar */}
                              <div style={{ marginBottom:10 }}>
                                <div style={{ display:"flex", justifyContent:"space-between", fontSize:"12px", marginBottom:4 }}>
                                  <span style={{ color:"var(--stone-500)" }}>Revenue vs. Cost</span>
                                  <span style={{ fontWeight:600, color:"var(--stone-600)" }}>
                                    {fmt(j.revenue)} revenue · {fmt(j.cost)} cost
                                  </span>
                                </div>
                                <div style={{ height:10, background:"var(--stone-200)", borderRadius:5, position:"relative", overflow:"hidden" }}>
                                  {/* Cost bar */}
                                  <div style={{ position:"absolute", left:0, top:0, height:"100%", width:`${(j.cost/j.revenue)*100}%`, background:"var(--accent-red)", opacity:0.7, borderRadius:"5px 0 0 5px" }}/>
                                  {/* Profit bar */}
                                  <div style={{ position:"absolute", left:`${(j.cost/j.revenue)*100}%`, top:0, height:"100%", width:`${(j.profit/j.revenue)*100}%`, background:mc, borderRadius:"0 5px 5px 0" }}/>
                                </div>
                                <div style={{ display:"flex", gap:14, marginTop:5, fontSize:"11px" }}>
                                  <div style={{ display:"flex", alignItems:"center", gap:4 }}>
                                    <div style={{ width:8, height:8, borderRadius:2, background:"var(--accent-red)", opacity:0.7 }}/>
                                    <span style={{ color:"var(--stone-500)" }}>Cost {pct((j.cost/j.revenue)*100)}</span>
                                  </div>
                                  <div style={{ display:"flex", alignItems:"center", gap:4 }}>
                                    <div style={{ width:8, height:8, borderRadius:2, background:mc }}/>
                                    <span style={{ color:"var(--stone-500)" }}>Profit {pct((j.profit/j.revenue)*100)}</span>
                                  </div>
                                </div>
                              </div>

                              {/* Metric row */}
                              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(120px,1fr))", gap:8 }}>
                                {[
                                  ["Revenue",fmt(j.revenue),"var(--accent-green)"],
                                  ...(j.costSource === "budget" ? [
                                    ["Materials",fmt(j.matActual),"var(--accent-red)"],
                                    ["Labor",fmt(j.laborCost),"var(--warm-gold)"],
                                  ] : [
                                    ["Cost",fmt(j.cost),"var(--accent-red)"],
                                  ]),
                                  ["Gross Profit",fmt(j.profit),mc],
                                  ["Margin",pct(j.margin),mc],
                                ].map(([l,v,c]) => (
                                  <div key={l} style={{ background:"var(--stone-100)", borderRadius:6, padding:"8px 10px" }}>
                                    <div style={{ fontSize:"10px", fontWeight:700, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:2 }}>{l}</div>
                                    <div style={{ fontSize:"15px", fontWeight:800, color:c }}>{v}</div>
                                  </div>
                                ))}
                              </div>
                              {j.costSource === "budget" && (
                                <div style={{ marginTop:6, fontSize:"10px", color:"var(--stone-400)" }}>📋 Cost data from Project Budget</div>
                              )}
                            </>
                          ) : (
                            <div style={{ fontSize:"12px", color:"var(--stone-400)", fontStyle:"italic", display:"flex", alignItems:"center", gap:6 }}>
                              <span>📝</span> No cost data recorded — add budget in Project Budgets or set job cost in Job Tracking.
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </ReportSection>

                {/* Crew profitability */}
                {byCrew.length > 0 && (
                  <ReportSection title="Profitability by Crew" sub="Aggregated margin across all jobs per team">
                    <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))", gap:12, marginBottom:28 }}>
                      {byCrew.map(c => {
                        const mc = marginColor(c.margin);
                        return (
                          <div key={c.crew} className="card" style={{ padding:"18px 20px", borderTop:`4px solid ${mc}` }}>
                            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
                              <div style={{ fontFamily:"var(--font-display)", fontSize:"17px", fontWeight:700 }}>{c.crew}</div>
                              <span style={{ fontSize:"13px", fontWeight:800, color:mc }}>{pct(c.margin)}</span>
                            </div>
                            <div style={{ height:7, background:"var(--stone-200)", borderRadius:4, marginBottom:12, overflow:"hidden" }}>
                              <div style={{ height:"100%", width:`${Math.min(c.margin, 100)}%`, background:mc, borderRadius:4, transition:"width 0.5s" }}/>
                            </div>
                            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:6 }}>
                              {[["Revenue",fmt(c.revenue),"var(--stone-700)"],["Cost",fmt(c.cost),"var(--accent-red)"],["Profit",fmt(c.profit),mc]].map(([l,v,color]) => (
                                <div key={l} style={{ textAlign:"center" }}>
                                  <div style={{ fontSize:"13px", fontWeight:800, color }}>{v}</div>
                                  <div style={{ fontSize:"10px", color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em" }}>{l}</div>
                                </div>
                              ))}
                            </div>
                            <div style={{ marginTop:10, fontSize:"12px", color:"var(--stone-400)", textAlign:"center" }}>{c.jobs} job{c.jobs!==1?"s":""}</div>
                          </div>
                        );
                      })}
                    </div>
                  </ReportSection>
                )}

                {/* Summary table */}
                <ReportSection title="Profitability Summary Table" sub="All jobs ranked by gross profit">
                  <div className="card" style={{ padding:0 }}>
                    <div style={{ overflowX:"auto" }}>
                      <table style={{ width:"100%", borderCollapse:"collapse" }}>
                        <thead>
                          <tr style={{ background:"var(--stone-100)", fontSize:"11px", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--stone-500)" }}>
                            {["Project","Customer","Crew","Status","Revenue","Cost","Gross Profit","Margin","Health"].map(h => (
                              <th key={h} style={{ padding:"10px 14px", textAlign:"left", whiteSpace:"nowrap" }}>{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {[...enriched].sort((a,b) => b.profit - a.profit).map(j => {
                            const hasCost = j.cost > 0;
                            const mc = marginColor(j.margin);
                            const sc = { Completed:"var(--accent-green)", "In Progress":"var(--accent-blue)", Scheduled:"var(--warm-gold)", "On Hold":"var(--stone-400)" };
                            return (
                              <tr key={j.id} style={{ borderBottom:"1px solid var(--stone-100)", fontSize:"13px" }}>
                                <td style={{ padding:"10px 14px", fontWeight:600 }}>{j.project}</td>
                                <td style={{ padding:"10px 14px", color:"var(--stone-500)" }}>{j.customer}</td>
                                <td style={{ padding:"10px 14px", color:"var(--stone-500)", fontSize:"12px" }}>{j.crew||"—"}</td>
                                <td style={{ padding:"10px 14px" }}>
                                  <span style={{ fontSize:"11px", fontWeight:700, background:`${sc[j.status]||"var(--stone-400)"}18`, color:sc[j.status]||"var(--stone-500)", padding:"3px 9px", borderRadius:99 }}>{j.status}</span>
                                </td>
                                <td style={{ padding:"10px 14px", fontWeight:700, color:"var(--accent-green)" }}>{fmt(j.revenue)}</td>
                                <td style={{ padding:"10px 14px", fontWeight:600, color: hasCost ? "var(--accent-red)" : "var(--stone-300)" }}>{hasCost ? fmt(j.cost) : "—"}</td>
                                <td style={{ padding:"10px 14px", fontWeight:800, color: hasCost ? mc : "var(--stone-300)" }}>{hasCost ? fmt(j.profit) : "—"}</td>
                                <td style={{ padding:"10px 14px", fontWeight:800, color: hasCost ? mc : "var(--stone-300)" }}>{hasCost ? pct(j.margin) : "—"}</td>
                                <td style={{ padding:"10px 14px" }}>
                                  {hasCost
                                    ? <span style={{ fontSize:"11px", fontWeight:700, background:`${mc}18`, color:mc, padding:"3px 9px", borderRadius:99 }}>{marginLabel(j.margin)}</span>
                                    : <span style={{ fontSize:"11px", color:"var(--stone-300)" }}>No data</span>
                                  }
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        {/* Totals row */}
                        <tfoot>
                          <tr style={{ background:"var(--stone-100)", fontWeight:800, fontSize:"13px", borderTop:"2px solid var(--stone-200)" }}>
                            <td colSpan={4} style={{ padding:"11px 14px", color:"var(--stone-600)" }}>Totals ({withCost.length} jobs with cost data)</td>
                            <td style={{ padding:"11px 14px", color:"var(--accent-green)" }}>{fmt(totalRevenue)}</td>
                            <td style={{ padding:"11px 14px", color:"var(--accent-red)" }}>{fmt(totalCost)}</td>
                            <td style={{ padding:"11px 14px", color:marginColor(avgMargin) }}>{fmt(totalProfit)}</td>
                            <td style={{ padding:"11px 14px", color:marginColor(avgMargin) }}>{pct(avgMargin)} avg</td>
                            <td style={{ padding:"11px 14px", color:marginColor(avgMargin) }}>{marginLabel(avgMargin)}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </ReportSection>

                {/* Note about cost tracking */}
                <div style={{ padding:"13px 16px", background:"rgba(201,169,110,0.07)", border:"1.5px solid var(--sand-300)", borderRadius:"var(--radius)", display:"flex", gap:10, alignItems:"flex-start" }}>
                  <span style={{ fontSize:16, flexShrink:0 }}>💡</span>
                  <div style={{ fontSize:"12px", color:"var(--stone-600)", lineHeight:1.6 }}>
                    <strong>Cost data tip:</strong> This report automatically pulls material and labor costs from <strong>Project Budgets</strong>. Jobs without a budget will fall back to the cost field in Job Tracking. For the most accurate profitability data, use the Budget Builder to track phase-level materials and labor on each project.
                  </div>
                </div>
              </>
            );
          })()}
        </div>
      )}

      {/* ══ Recommendations panel (always visible at bottom) ══ */}
      <div style={{ marginTop:32, padding:"18px 20px", background:"rgba(201,169,110,0.07)", border:"1.5px solid var(--sand-300)", borderRadius:"var(--radius-lg)", display:"flex", gap:12 }}>
        <span style={{ fontSize:20, flexShrink:0 }}>💡</span>
        <div>
          <div style={{ fontWeight:700, fontSize:"13px", color:"var(--warm-gold)", marginBottom:6 }}>Recommended Next Reports to Build</div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))", gap:6 }}>
            {[
              "Monthly revenue trend chart (12-month rolling)",
              "Estimate-to-close ratio by project type",
              "Lead response time tracking",
              "Installer certification completion rates",
              "Seasonal demand analysis by month",
              "Referral source ROI tracking",
            ].map((item, i) => (
              <div key={i} style={{ display:"flex", gap:6, fontSize:"12px", color:"var(--stone-600)" }}>
                <span style={{ color:"var(--warm-gold)", flexShrink:0 }}>→</span>{item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

// ── User Management (Owner only) ─────────────────────────────────────────────
const UserManagement = ({ users, setUsers, currentUser }) => {
  const BLANK = { id: null, name: "", role: "installer", email: "", pin: "", active: true };
  const [modal, setModal]     = useState(null);   // null | "add" | user obj
  const [form, setForm]       = useState(BLANK);
  const [showPins, setShowPins] = useState({});   // id -> bool
  const [confirmDeactivate, setConfirmDeactivate] = useState(null);
  const [pinError, setPinError] = useState("");
  const [saved, setSaved]     = useState(false);

  const openAdd  = () => { setForm({...BLANK, id: `temp_${Date.now()}`, _isNew: true}); setPinError(""); setModal("add"); };
  const openEdit = (u) => { setForm({...u}); setPinError(""); setModal(u); };
  const closeModal = () => { setModal(null); setForm(BLANK); setPinError(""); };

  const validatePin = (pin) => /^\d{4}$/.test(pin);

  const saveUser = () => {
    if (!form.name.trim()) return;
    if (!validatePin(form.pin)) { setPinError("PIN must be exactly 4 digits."); return; }
    // Check PIN uniqueness (excluding self)
    const duplicate = users.find(u => u.pin === form.pin && u.id !== form.id);
    if (duplicate) { setPinError(`PIN already used by ${duplicate.name}. Choose a different PIN.`); return; }

    if (modal === "add") {
      setUsers(p => [...p, form]);
    } else {
      setUsers(p => p.map(u => u.id === form.id ? form : u));
    }
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
    closeModal();
  };

  const toggleActive = (u) => {
    if (u.id === currentUser.id) return; // can't deactivate yourself
    setUsers(p => p.map(x => x.id === u.id ? {...x, active: !x.active} : x));
    setConfirmDeactivate(null);
  };

  const deleteUser = (id) => {
    if (id === currentUser.id) return;
    setUsers(p => p.filter(u => u.id !== id));
    setConfirmDeactivate(null);
  };

  const activeUsers   = users.filter(u => u.active !== false);
  const inactiveUsers = users.filter(u => u.active === false);

  const RoleBadge = ({ role }) => {
    const r = ROLES[role];
    return (
      <span style={{ fontSize:"11px", fontWeight:700, background:`${r.color}18`, color:r.color, padding:"3px 9px", borderRadius:99, display:"inline-flex", alignItems:"center", gap:4 }}>
        {r.badge} {r.label}
      </span>
    );
  };

  const UserRow = ({ u }) => {
    const isSelf = u.id === currentUser.id;
    return (
      <div style={{ display:"flex", alignItems:"center", gap:14, padding:"14px 18px", borderBottom:"1px solid var(--stone-100)", flexWrap:"wrap" }}>
        {/* Avatar */}
        <div style={{ width:40, height:40, borderRadius:"50%", background:ROLES[u.role].color, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"13px", fontWeight:800, color:"white", flexShrink:0, opacity: u.active===false ? 0.45 : 1 }}>
          {u.name.split(" ").map(n=>n[0]).join("").slice(0,2)}
        </div>

        {/* Info */}
        <div style={{ flex:1, minWidth:160, opacity: u.active===false ? 0.5 : 1 }}>
          <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
            <span style={{ fontWeight:600, fontSize:"14px" }}>{u.name}</span>
            {isSelf && <span style={{ fontSize:"10px", background:"var(--warm-gold)", color:"white", padding:"1px 7px", borderRadius:99, fontWeight:700 }}>YOU</span>}
            {u.active === false && <span style={{ fontSize:"10px", background:"var(--stone-200)", color:"var(--stone-500)", padding:"1px 7px", borderRadius:99, fontWeight:700 }}>INACTIVE</span>}
          </div>
          <div style={{ fontSize:"12px", color:"var(--stone-400)", marginTop:2 }}>{u.email||"—"}</div>
        </div>

        {/* Role */}
        <div style={{ flexShrink:0 }}><RoleBadge role={u.role}/></div>

        {/* PIN */}
        <div style={{ flexShrink:0, display:"flex", alignItems:"center", gap:6 }}>
          <div style={{ fontSize:"13px", fontFamily:"monospace", background:"var(--stone-100)", padding:"4px 10px", borderRadius:6, letterSpacing:"0.2em", minWidth:60, textAlign:"center" }}>
            {showPins[u.id] ? u.pin : "••••"}
          </div>
          <button className="btn-icon" title={showPins[u.id]?"Hide PIN":"Show PIN"}
            onClick={() => setShowPins(p => ({...p,[u.id]:!p[u.id]}))}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--stone-400)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {showPins[u.id]
                ? <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></>
                : <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>
              }
            </svg>
          </button>
        </div>

        {/* Actions */}
        <div style={{ display:"flex", gap:6, flexShrink:0 }}>
          <button className="btn btn-secondary btn-sm" onClick={() => openEdit(u)}>
            <Icon name="edit" size={12}/> Edit
          </button>
          {!isSelf && (
            <button className="btn btn-sm"
              style={{ background: u.active===false ? "rgba(40,167,69,0.1)" : "rgba(220,53,69,0.1)", color: u.active===false ? "var(--accent-green)" : "var(--accent-red)", border:"none" }}
              onClick={() => setConfirmDeactivate(u)}>
              {u.active===false ? "Reactivate" : "Deactivate"}
            </button>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="fade-in">
      {/* Header */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:22, flexWrap:"wrap", gap:12 }}>
        <div>
          <h1 className="section-title">User Management</h1>
          <p className="section-sub">Add team members, change roles, reset PINs, and control access levels.</p>
        </div>
        <button className="btn btn-primary" onClick={openAdd}>
          <Icon name="plus" size={14}/> Add Team Member
        </button>
      </div>

      {/* Role legend */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))", gap:10, marginBottom:24 }}>
        {Object.entries(ROLES).map(([key, r]) => (
          <div key={key} style={{ background:"white", border:`1.5px solid ${r.color}30`, borderLeft:`4px solid ${r.color}`, borderRadius:"var(--radius)", padding:"12px 14px" }}>
            <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}>
              <span style={{ fontSize:16 }}>{r.badge}</span>
              <span style={{ fontWeight:700, fontSize:"13px", color:r.color }}>{r.label}</span>
              <span style={{ fontSize:"11px", background:"var(--stone-100)", color:"var(--stone-500)", padding:"1px 7px", borderRadius:99 }}>
                {users.filter(u=>u.role===key && u.active!==false).length} active
              </span>
            </div>
            <div style={{ fontSize:"12px", color:"var(--stone-500)", lineHeight:1.5 }}>{r.desc}</div>
          </div>
        ))}
      </div>

      {/* Stats */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))", gap:10, marginBottom:22 }}>
        {[["Total Users", users.length, "var(--stone-700)"],["Active", activeUsers.length, "var(--accent-green)"],["Inactive", inactiveUsers.length, "var(--stone-400)"],["Owners", users.filter(u=>u.role==="owner").length, "var(--warm-gold)"],["Admins", users.filter(u=>u.role==="admin").length, "var(--accent-blue)"],["Installers", users.filter(u=>u.role==="installer").length, "var(--accent-green)"]].map(([l,v,c])=>(
          <div key={l} className="stat-card">
            <div className="stat-value" style={{ color:c }}>{v}</div>
            <div className="stat-label">{l}</div>
          </div>
        ))}
      </div>

      {/* Active users table */}
      <div className="card" style={{ padding:0, marginBottom:16 }}>
        <div style={{ padding:"13px 18px", borderBottom:"1px solid var(--stone-100)", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <span style={{ fontWeight:700, fontSize:"13px" }}>Active Team Members ({activeUsers.length})</span>
        </div>
        {activeUsers.length === 0
          ? <div style={{ padding:"32px", textAlign:"center", color:"var(--stone-400)" }}>No active users.</div>
          : activeUsers.map(u => <UserRow key={u.id} u={u}/>)
        }
      </div>

      {/* Inactive users */}
      {inactiveUsers.length > 0 && (
        <div className="card" style={{ padding:0 }}>
          <div style={{ padding:"13px 18px", borderBottom:"1px solid var(--stone-100)", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <span style={{ fontWeight:700, fontSize:"13px", color:"var(--stone-400)" }}>Inactive ({inactiveUsers.length})</span>
          </div>
          {inactiveUsers.map(u => <UserRow key={u.id} u={u}/>)}
        </div>
      )}

      {/* ── Add / Edit Modal ── */}
      {modal && (
        <Modal title={modal === "add" ? "Add Team Member" : `Edit — ${form.name}`} onClose={closeModal}>
          <div style={{ display:"grid", gap:14 }}>

            <div className="form-group">
              <label>Full Name <span style={{ color:"var(--accent-red)" }}>*</span></label>
              <input placeholder="e.g. Sam Johnson" value={form.name} onChange={e => setForm(p=>({...p,name:e.target.value}))} />
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input type="email" placeholder="e.g. sam@timelesstile.pro" value={form.email} onChange={e => setForm(p=>({...p,email:e.target.value}))} />
            </div>

            {/* Role selector */}
            <div className="form-group">
              <label>Access Level <span style={{ color:"var(--accent-red)" }}>*</span></label>
              <div style={{ display:"grid", gap:8, marginTop:4 }}>
                {Object.entries(ROLES).map(([key, r]) => (
                  <label key={key} style={{ display:"flex", alignItems:"flex-start", gap:12, padding:"12px 14px", borderRadius:"var(--radius)", border:`1.5px solid ${form.role===key ? r.color : "var(--stone-200)"}`, background: form.role===key ? `${r.color}0d` : "white", cursor:"pointer", transition:"all 0.15s" }}>
                    <input type="radio" name="role" value={key} checked={form.role===key} onChange={() => setForm(p=>({...p,role:key}))} style={{ marginTop:3, accentColor:r.color }}/>
                    <div>
                      <div style={{ display:"flex", alignItems:"center", gap:7, marginBottom:3 }}>
                        <span style={{ fontSize:15 }}>{r.badge}</span>
                        <span style={{ fontWeight:700, fontSize:"13px", color: form.role===key ? r.color : "var(--stone-700)" }}>{r.label}</span>
                      </div>
                      <div style={{ fontSize:"12px", color:"var(--stone-500)", lineHeight:1.5 }}>{r.desc}</div>
                    </div>
                  </label>
                ))}
              </div>
            </div>

            {/* PIN */}
            <div className="form-group">
              <label>4-Digit Login PIN <span style={{ color:"var(--accent-red)" }}>*</span></label>
              <div style={{ position:"relative" }}>
                <input
                  type={showPins["modal"] ? "text" : "password"}
                  placeholder="Enter 4-digit PIN"
                  maxLength={4}
                  value={form.pin}
                  onChange={e => { setForm(p=>({...p,pin:e.target.value.replace(/\D/g,"")})); setPinError(""); }}
                  style={{ paddingRight:40, fontFamily:"monospace", fontSize:"18px", letterSpacing:"0.3em" }}
                />
                <button type="button"
                  onClick={() => setShowPins(p=>({...p,modal:!p["modal"]}))}
                  style={{ position:"absolute", right:10, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", color:"var(--stone-400)" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    {showPins["modal"]
                      ? <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></>
                      : <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>
                    }
                  </svg>
                </button>
              </div>
              {pinError
                ? <div style={{ fontSize:"12px", color:"var(--accent-red)", marginTop:5 }}>{pinError}</div>
                : <div style={{ fontSize:"12px", color:"var(--stone-400)", marginTop:5 }}>Must be exactly 4 digits. Each PIN must be unique across all users.</div>
              }
            </div>

            {/* Active toggle for edit */}
            {modal !== "add" && form.id !== currentUser.id && (
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 14px", background:"var(--stone-100)", borderRadius:"var(--radius)" }}>
                <div>
                  <div style={{ fontWeight:600, fontSize:"13px" }}>Account Status</div>
                  <div style={{ fontSize:"12px", color:"var(--stone-500)", marginTop:2 }}>Inactive users cannot sign in.</div>
                </div>
                <label style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer" }}>
                  <div style={{ position:"relative", width:42, height:24 }}>
                    <input type="checkbox" checked={form.active !== false} onChange={e => setForm(p=>({...p,active:e.target.checked}))} style={{ opacity:0, position:"absolute" }}/>
                    <div style={{ width:42, height:24, borderRadius:12, background: form.active!==false ? "var(--accent-green)" : "var(--stone-300)", transition:"background 0.2s", cursor:"pointer" }}
                      onClick={() => setForm(p=>({...p,active:!p.active}))}/>
                    <div style={{ position:"absolute", top:2, left: form.active!==false ? 20 : 2, width:20, height:20, borderRadius:"50%", background:"white", transition:"left 0.2s", boxShadow:"0 1px 4px rgba(0,0,0,0.2)" }}/>
                  </div>
                  <span style={{ fontSize:"13px", fontWeight:500 }}>{form.active!==false ? "Active" : "Inactive"}</span>
                </label>
              </div>
            )}
          </div>

          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:20, paddingTop:16, borderTop:"1px solid var(--stone-200)", flexWrap:"wrap", gap:8 }}>
            {modal !== "add" && form.id !== currentUser.id ? (
              <button className="btn btn-sm" style={{ background:"rgba(220,53,69,0.08)", color:"var(--accent-red)", border:"none" }}
                onClick={() => { closeModal(); setConfirmDeactivate({...form, _delete:true}); }}>
                🗑 Delete User
              </button>
            ) : <div/>}
            <div style={{ display:"flex", gap:8 }}>
              <button className="btn btn-secondary" onClick={closeModal}>Cancel</button>
              <button className="btn btn-primary" onClick={saveUser} disabled={!form.name.trim() || form.pin.length !== 4}>
                <Icon name="check" size={14}/> {modal === "add" ? "Add Team Member" : "Save Changes"}
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* ── Deactivate / Delete Confirm ── */}
      {confirmDeactivate && (
        <Modal title={confirmDeactivate._delete ? "Delete User" : (confirmDeactivate.active===false ? "Reactivate User" : "Deactivate User")} onClose={() => setConfirmDeactivate(null)}>
          <div style={{ textAlign:"center", padding:"8px 0 16px" }}>
            <div style={{ fontSize:40, marginBottom:12 }}>{confirmDeactivate._delete ? "🗑" : confirmDeactivate.active===false ? "✅" : "⚠️"}</div>
            <div style={{ fontFamily:"var(--font-display)", fontSize:"17px", fontWeight:600, marginBottom:8 }}>
              {confirmDeactivate._delete
                ? `Permanently delete ${confirmDeactivate.name}?`
                : confirmDeactivate.active===false
                  ? `Reactivate ${confirmDeactivate.name}?`
                  : `Deactivate ${confirmDeactivate.name}?`
              }
            </div>
            <div style={{ fontSize:"13px", color:"var(--stone-500)", marginBottom:22, lineHeight:1.6 }}>
              {confirmDeactivate._delete
                ? "This cannot be undone. All of their data will remain, but this user record will be removed."
                : confirmDeactivate.active===false
                  ? "This user will be able to sign in again using their existing PIN."
                  : "This user will no longer be able to sign in. You can reactivate them at any time."
              }
            </div>
            <div style={{ display:"flex", gap:10, justifyContent:"center" }}>
              <button className="btn btn-secondary" onClick={() => setConfirmDeactivate(null)}>Cancel</button>
              <button className="btn btn-primary"
                style={{ background: confirmDeactivate._delete || confirmDeactivate.active!==false ? "var(--accent-red)" : "var(--accent-green)", borderColor: confirmDeactivate._delete || confirmDeactivate.active!==false ? "var(--accent-red)" : "var(--accent-green)" }}
                onClick={() => confirmDeactivate._delete ? deleteUser(confirmDeactivate.id) : toggleActive(confirmDeactivate)}>
                {confirmDeactivate._delete ? "Delete" : confirmDeactivate.active===false ? "Reactivate" : "Deactivate"}
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

// ── Main App ──────────────────────────────────────────────────────────────────
export default function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [page, setPage]               = useState(null);
  const [users, setUsers]             = useState(INIT_USERS);
  const [leads, setLeads]             = useState([]);
  const [customers, setCustomers]     = useState([]);
  const [jobs, setJobs]               = useState([]);
  const [invoices, setInvoices]       = useState([]);
  const [estimates, setEstimates]     = useState([]);
  const [events, setEvents]           = useState([]);
  const [calls, setCalls]             = useState([]);
  const [messages, setMessages]       = useState([]);
  const [materials, setMaterials]     = useState(initMaterials);
  const [reviews, setReviews]         = useState(initReviews);
  const [dbReady, setDbReady]         = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [signOutConfirm, setSignOutConfirm] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(null); // { table, id, label, sublabel }
  const [estimateViews, setEstimateViews] = useState({}); // { estimateId: { viewed_at, view_count, last_viewed_at, accepted_at } }
  const [scopeTemplates, setScopeTemplates] = useState([]); // Reusable estimate line item templates
  const [notifications, setNotifications] = useState([]);
  const [notifOpen, setNotifOpen] = useState(false);

  const addNotification = (type, message, page) => {
    const notif = { id: Date.now(), type, message, page, time: new Date(), read: false };
    setNotifications(p => [notif, ...p].slice(0, 50));
    // Auto-log action to activity tracker
    const actionMap = {
      lead: message.includes('created') ? 'lead_created' : 'lead_updated',
      job: message.includes('created') ? 'job_created' : message.includes('marked') ? 'job_updated' : 'note_added',
      estimate: message.includes('created') ? 'estimate_created' : message.includes('sent') || message.includes('resent') ? 'estimate_sent' : 'estimate_created',
      invoice: 'invoice_created',
      review: 'review_requested',
      sms: 'sms_sent',
      call: 'call_made',
      photo: 'photo_uploaded',
    };
    const actionType = actionMap[type];
    if (actionType && window.ttpLogAction) {
      window.ttpLogAction(actionType, message.slice(0, 200));
    }
  };

  // ── Realtime Notification Toast (separate from bell dropdown) ───────────
  const [realtimeToast, setRealtimeToast] = useState(null);
  const realtimeToastTimer = useRef(null);

  const showRealtimeToast = (emoji, message, targetPage) => {
    if (realtimeToastTimer.current) clearTimeout(realtimeToastTimer.current);
    setRealtimeToast({ emoji, message, targetPage, id: Date.now() });
    realtimeToastTimer.current = setTimeout(() => setRealtimeToast(null), 8000);
    // Play notification chime
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.setValueAtTime(880, ctx.currentTime);
      osc.frequency.setValueAtTime(1100, ctx.currentTime + 0.08);
      gain.gain.setValueAtTime(0.08, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.3);
      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime + 0.3);
    } catch (e) { /* audio not available */ }
  };

  // ── Realtime Notifications (via polling — see poll interval below) ─────
  // Note: Supabase Realtime WebSocket was not connecting on this project.
  // All live notifications (SMS, leads, payments, estimate views) are handled
  // by the 15-second polling interval instead.

  // ── Soft Delete System ────────────────────────────────────────────────────
  const tableSetters = { leads:setLeads, customers:setCustomers, jobs:setJobs, estimates:setEstimates, invoices:setInvoices, events:setEvents, calls:setCalls, reviews:setReviews };

  const requestDelete = (table, record) => {
    const labelMap = {
      leads: r => ({ label: r.name, sublabel: r.project }),
      customers: r => ({ label: r.name, sublabel: r.email }),
      jobs: r => ({ label: r.customer, sublabel: r.project }),
      estimates: r => ({ label: r.id, sublabel: `${r.customer} · ${r.project}` }),
      invoices: r => ({ label: r.id || r.display_id, sublabel: r.customer }),
      events: r => ({ label: r.title, sublabel: r.date }),
      calls: r => ({ label: r.contact, sublabel: r.date }),
      reviews: r => ({ label: r.customer, sublabel: r.project }),
    };
    const info = labelMap[table] ? labelMap[table](record) : { label: String(record.id), sublabel: "" };
    setDeleteConfirm({ table, id: record.id, label: info.label, sublabel: info.sublabel });
  };

  const confirmSoftDelete = () => {
    if (!deleteConfirm) return;
    const { table, id } = deleteConfirm;
    const setter = tableSetters[table];
    if (setter) setter(p => p.map(r => r.id === id ? { ...r, deletedAt: Date.now() } : r));
    // Reviews: update to 'Dismissed' in Supabase so the cron won't recreate them
    // All other tables: delete from Supabase so they don't come back on reload
    if (table === 'reviews') {
      supabase.from('reviews').update({ status: 'Dismissed' }).eq('id', id).then(({ error }) => {
        if (error) console.warn(`[trash] Failed to dismiss review ${id}:`, error.message);
      });
    } else {
      supabase.from(table).delete().eq('id', id).then(({ error }) => {
        if (error) console.warn(`[trash] Failed to delete ${table}:${id} from Supabase:`, error.message);
      });
    }
    // Save trash metadata to localStorage for persistence across reloads
    try {
      const trashStore = JSON.parse(localStorage.getItem('ttp_trash') || '[]');
      setter(p => {
        const rec = p.find(r => r.id === id);
        if (rec) trashStore.push({ ...rec, _table: table, deletedAt: Date.now() });
        localStorage.setItem('ttp_trash', JSON.stringify(trashStore));
        return p;
      });
    } catch (e) { console.warn('[trash] localStorage save failed:', e); }
    addNotification("job", `🗑 ${deleteConfirm.label} moved to Trash`, "trash");
    setDeleteConfirm(null);
  };

  const restoreRecord = (table, id) => {
    const setter = tableSetters[table];
    if (setter) setter(p => p.map(r => r.id === id ? { ...r, deletedAt: undefined, ...(table === 'reviews' ? { status: 'Pending' } : {}) } : r));
    // For reviews: undo the Dismissed status in Supabase
    if (table === 'reviews') {
      supabase.from('reviews').update({ status: 'Pending' }).eq('id', id).then(({ error }) => {
        if (error) console.warn(`[trash] Failed to restore review ${id}:`, error.message);
      });
    }
    // Remove from localStorage trash
    try {
      const trashStore = JSON.parse(localStorage.getItem('ttp_trash') || '[]');
      localStorage.setItem('ttp_trash', JSON.stringify(trashStore.filter(t => !(t._table === table && t.id === id))));
    } catch (e) {}
  };

  const permanentDelete = (table, id) => {
    const setter = tableSetters[table];
    if (setter) setter(p => p.filter(r => r.id !== id));
    // Delete from Supabase (reviews were soft-dismissed, not deleted — now hard-delete)
    supabase.from(table).delete().eq('id', id).catch(() => {});
    // Remove from localStorage trash
    try {
      const trashStore = JSON.parse(localStorage.getItem('ttp_trash') || '[]');
      localStorage.setItem('ttp_trash', JSON.stringify(trashStore.filter(t => !(t._table === table && t.id === id))));
    } catch (e) {}
  };

  // Build trash items list from all tables
  const trashItems = [
    ...leads.filter(r => r.deletedAt).map(r => ({ table:"leads", id:r.id, label:r.name, sublabel:r.project, deletedAt:r.deletedAt })),
    ...customers.filter(r => r.deletedAt).map(r => ({ table:"customers", id:r.id, label:r.name, sublabel:r.email, deletedAt:r.deletedAt })),
    ...jobs.filter(r => r.deletedAt).map(r => ({ table:"jobs", id:r.id, label:r.customer, sublabel:r.project, deletedAt:r.deletedAt })),
    ...estimates.filter(r => r.deletedAt).map(r => ({ table:"estimates", id:r.id, label:r.id, sublabel:`${r.customer} · ${r.project}`, deletedAt:r.deletedAt })),
    ...invoices.filter(r => r.deletedAt).map(r => ({ table:"invoices", id:r.id, label:r.display_id||r.id, sublabel:r.customer, deletedAt:r.deletedAt })),
    ...events.filter(r => r.deletedAt).map(r => ({ table:"events", id:r.id, label:r.title, sublabel:r.date, deletedAt:r.deletedAt })),
    ...calls.filter(r => r.deletedAt).map(r => ({ table:"calls", id:r.id, label:r.contact, sublabel:r.date, deletedAt:r.deletedAt })),
    ...reviews.filter(r => r.deletedAt || r.status === 'Dismissed').map(r => ({ table:"reviews", id:r.id, label:r.customer, sublabel:r.project, deletedAt:r.deletedAt || Date.now() })),
  ];

  // Auto-purge records older than 30 days
  useEffect(() => {
    if (!dbReady) return;
    const thirtyDaysAgo = Date.now() - (30 * 24 * 60 * 60 * 1000);
    Object.entries(tableSetters).forEach(([table, setter]) => {
      setter(p => {
        const toPurge = p.filter(r => r.deletedAt && r.deletedAt < thirtyDaysAgo);
        if (toPurge.length === 0) return p;
        // Delete from Supabase
        toPurge.forEach(r => {
          supabase.from(table).delete().eq('id', r.id).catch(() => {});
        });
        console.log(`[auto-purge] Removed ${toPurge.length} expired records from ${table}`);
        return p.filter(r => !r.deletedAt || r.deletedAt >= thirtyDaysAgo);
      });
    });
  }, [dbReady]); // eslint-disable-line

  // Active (non-deleted) record filters for passing to components
  const activeLeads = leads.filter(r => !r.deletedAt);
  const activeCustomers = customers.filter(r => !r.deletedAt);
  const activeJobs = jobs.filter(r => !r.deletedAt);
  const activeEstimates = (() => { const seen = new Set(); return estimates.filter(r => !r.deletedAt).filter(r => { if (seen.has(r.id)) return false; seen.add(r.id); return true; }); })();
  const activeInvoices = invoices.filter(r => !r.deletedAt);
  const activeEvents = events.filter(r => !r.deletedAt);
  const activeCalls = calls.filter(r => !r.deletedAt);
  const activeReviews = reviews.filter(r => !r.deletedAt && r.status !== 'Dismissed');

  // ── Load login profiles on mount (uses anon-accessible RPC — no PINs exposed) ──
  useEffect(() => {
    const loadLoginProfiles = async () => {
      try {
        const { data: profilesData, error: profilesErr } = await supabase.rpc('get_login_profiles');
        if (profilesErr) throw profilesErr;
        if (profilesData?.length) setUsers(profilesData);
        else                      setUsers(INIT_USERS);
        setDbReady(true);
      } catch (err) {
        console.error('[boot] Login profiles load error:', err);
        setUsers(INIT_USERS);
        setDbReady(true);
      }
    };
    loadLoginProfiles();
  }, []);

  // ── Load all CRM data (called AFTER successful PIN login) ──
  const loadCrmData = useCallback(async () => {
    try {
      const [
        { data: leadsData },
        { data: customersData },
        { data: jobsData, error: jobsErr },
        { data: invoicesData },
        { data: estimatesData },
        { data: eventsData },
        { data: callsData },
        { data: usersData },
      ] = await Promise.all([
        supabase.from('leads').select('*').order('id'),
        supabase.from('customers').select('*').order('id'),
        supabase.from('jobs').select('id,customer,customer_id,project,status,start_date,start_time,end_date,value,cost,address,notes,crew,crew_pay,crew_notes,estimate_id,estimated_days').order('id'),
        supabase.from('invoices').select('*').order('id'),
        supabase.from('estimates').select('*').order('id'),
        supabase.from('events').select('*').order('id'),
        supabase.from('calls').select('*').order('id'),
        supabase.from('users').select('*').order('id'),
      ]);

      // A failed jobs fetch must not look like "no jobs" — bail before anything
      // marks the load as trustworthy, so the cleanup guard stays closed too.
      if (jobsErr) throw new Error(`Jobs failed to load: ${jobsErr.message}`);

      // Map snake_case DB columns back to camelCase for the CRM
      if (leadsData?.length)     setLeads(leadsData);
      if (customersData?.length) setCustomers(customersData.map(c => ({ ...c, totalJobs: c.total_jobs ?? c.totalJobs ?? 0, totalRevenue: c.total_revenue ?? c.totalRevenue ?? 0 })));
      if (jobsData?.length)      setJobs(jobsData.map(j => ({ ...j, photos: [], photosLoaded: false, startDate: j.start_date || j.startDate, startTime: j.start_time || j.startTime || '8:00 AM', endDate: j.end_date || j.endDate, estimateId: j.estimate_id || j.estimateId, customerId: j.customer_id || j.customerId, crewName: j.crew || j.crewName || '', crewPay: j.crew_pay || [], crewNotes: j.crew_notes || [], estimatedDays: j.estimated_days || j.estimatedDays || 1 })));
      if (invoicesData?.length)  setInvoices(invoicesData.map(i => ({ ...i, jobId: i.job_id || i.jobId, contractTotal: i.contract_total ?? i.contractTotal ?? 0, display_id: i.display_id || i.id, estimate_id: i.estimate_id || null })));
      if (estimatesData?.length) setEstimates(estimatesData.map(e => ({ ...e, pricingMode: e.pricing_mode || e.pricingMode || 'bundled', hideMatQty: e.hide_mat_qty || e.hideMatQty || false, change_orders: e.change_orders || null, prior_deposits: e.prior_deposits || null, override_total: e.override_total || null })));
      if (eventsData?.length)    setEvents(eventsData.map(e => ({ ...e, jobTag:e.job_tag||e.jobTag||null, jobId:e.job_id||e.jobId||null, multiDay:e.multi_day||e.multiDay||false, dayNum:e.day_num||e.dayNum||null, totalDays:e.total_days||e.totalDays||null })));
      if (callsData?.length)     setCalls(callsData.map(c => ({ ...c, linkedLead: c.linked_lead || c.linkedLead, linkedCustomer: c.linked_customer || c.linkedCustomer, source: c.source || 'Direct' })));
      if (usersData?.length)     setUsers(usersData);

      // Load messages (separate — table may not exist yet)
      try {
        const { data: messagesData } = await supabase.from('messages').select('*').order('created_at', { ascending: false }).limit(500);
        if (messagesData?.length) {
          setMessages(messagesData);
          lastSeenMsgIds.current = new Set(messagesData.map(m => m.id));
        }
      } catch (e) { console.log('[load] Messages table not found — skipping'); }

      // Load estimate view tracking (separate — table may not exist yet)
      try {
        const { data: viewsData } = await supabase.from('estimate_views').select('*');
        if (viewsData?.length) {
          const viewMap = {};
          viewsData.forEach(v => { viewMap[v.estimate_id] = v; });
          setEstimateViews(viewMap);
        }
      } catch (e) { console.log('[load] estimate_views table not found — skipping'); }

      // Load scope templates (reusable estimate line items)
      try {
        const { data: tplData } = await supabase.from('scope_templates').select('*').order('created_at', { ascending: false });
        if (tplData?.length) setScopeTemplates(tplData);
      } catch (e) { console.log('[load] scope_templates table not found — using localStorage fallback'); 
        try { const local = JSON.parse(localStorage.getItem('ttp_scope_templates') || '[]'); if (local.length) setScopeTemplates(local); } catch(e2) {} 
      }

      // Load reviews from Supabase (replaces hardcoded initReviews)
      try {
        const { data: reviewsData } = await supabase.from('reviews').select('*').order('id');
        if (reviewsData?.length) setReviews(reviewsData.map(r => ({ ...r, jobId: r.job_id || r.jobId || null, googleSent: r.googleSent ?? r.google_sent ?? false })));
      } catch (e) { console.log('[load] Reviews table not found — using defaults'); }

      // Restore trash items from localStorage (soft-deleted but not yet purged)
      try {
        const trashStore = JSON.parse(localStorage.getItem('ttp_trash') || '[]');
        const thirtyDaysAgo = Date.now() - (30 * 24 * 60 * 60 * 1000);
        const validTrash = trashStore.filter(t => t.deletedAt && t.deletedAt >= thirtyDaysAgo);
        localStorage.setItem('ttp_trash', JSON.stringify(validTrash));
        const trashByTable = {};
        validTrash.forEach(t => { if (!trashByTable[t._table]) trashByTable[t._table] = []; trashByTable[t._table].push(t); });
        const setterMap = { leads:setLeads, customers:setCustomers, jobs:setJobs, estimates:setEstimates, invoices:setInvoices, events:setEvents, calls:setCalls, reviews:setReviews };
        Object.entries(trashByTable).forEach(([table, items]) => {
          const setter = setterMap[table];
          if (setter) setter(p => {
            const existingIds = new Set(p.map(r => r.id));
            const newItems = items.filter(t => !existingIds.has(t.id)).map(t => { const { _table, ...rest } = t; return rest; });
            return [...p, ...newItems];
          });
        });
      } catch (e) { console.warn('[trash] localStorage restore failed:', e); }

      // Local state is now trustworthy — cleanup deletes are permitted from here.
      // If this line is never reached (load threw), no table will ever delete rows.
      dataLoaded.current = true;
      setLoadError(null);

    } catch (err) {
      console.error('Supabase CRM data load error:', err);
      // Don't fail silently — an empty jobs list used to look like "no jobs assigned"
      setLoadError(err.message || 'Could not load data from the server.');
    }
  }, []); // eslint-disable-line

  // ── Refs for tracking last-seen IDs (avoids stale closure in poll interval) ──
  const lastSeenCallIds = useRef(new Set());
  const lastSeenLeadIds = useRef(new Set());
  const lastSeenMsgIds = useRef(new Set());
  const lastSeenInvPayments = useRef({}); // { invId: paidCount }
  const lastSeenEstViews = useRef({}); // { estId: { viewed_at, accepted_at } }
  const pollInitialized = useRef(false);

  // ── Poll for new calls, messages, and voicemails every 15 seconds ──
  useEffect(() => {
    if (!dbReady || !currentUser) return;
    const pollInterval = setInterval(async () => {
      try {
        console.log('[poll] Running... initialized:', pollInitialized.current);
        // Refresh calls
        const { data: freshCalls } = await supabase.from('calls').select('*').order('id', { ascending: false }).limit(200);
        if (freshCalls?.length) {
          const newCalls = freshCalls.filter(c => !lastSeenCallIds.current.has(c.id));

          setCalls(prev => {
            const deletedMap = {};
            prev.forEach(c => { if (c.deletedAt) deletedMap[c.id] = c.deletedAt; });
            const merged = freshCalls.map(fc => ({
              ...fc,
              linkedLead: fc.linked_lead || fc.linkedLead,
              linkedCustomer: fc.linked_customer || fc.linkedCustomer,
              source: fc.source || 'Direct',
              ...(deletedMap[fc.id] ? { deletedAt: deletedMap[fc.id] } : {}),
            }));
            const mergedIds = new Set(merged.map(m => m.id));
            const localOnly = prev.filter(p => p.deletedAt && !mergedIds.has(p.id));
            return [...merged, ...localOnly];
          });

          // Only notify after first poll (skip initial load)
          if (pollInitialized.current) {
            newCalls.forEach(c => {
              if (c.outcome === 'Voicemail' || c.recording_url) {
                addNotification('call', `🎙 New voicemail from ${c.contact || c.phone || 'Unknown'}`, 'calls');
                showRealtimeToast('🎙', `New voicemail from ${c.contact || c.phone || 'Unknown'}`, 'calls');
              } else if (c.outcome === 'Missed') {
                addNotification('call', `📞 Missed call from ${c.contact || c.phone || 'Unknown'}`, 'calls');
                showRealtimeToast('📞', `Missed call from ${c.contact || c.phone || 'Unknown'}`, 'calls');
              }
            });
          }
          lastSeenCallIds.current = new Set(freshCalls.map(c => c.id));
        }

        // Refresh leads (catch website form submissions)
        const { data: freshLeads } = await supabase.from('leads').select('*').order('id', { ascending: false }).limit(200);
        if (freshLeads?.length) {
          const newLeads = freshLeads.filter(l => !lastSeenLeadIds.current.has(l.id));

          setLeads(prev => {
            const deletedMap = {};
            prev.forEach(l => { if (l.deletedAt) deletedMap[l.id] = l.deletedAt; });
            const merged = freshLeads.map(fl => ({ ...fl, ...(deletedMap[fl.id] ? { deletedAt: deletedMap[fl.id] } : {}) }));
            const mergedIds = new Set(merged.map(m => m.id));
            const localOnly = prev.filter(p => p.deletedAt && !mergedIds.has(p.id));
            return [...merged, ...localOnly];
          });

          if (pollInitialized.current) {
            newLeads.forEach(l => {
              const name = l.name || 'Unknown';
              const project = l.project || '';
              addNotification('lead', `📋 New lead: ${name} · ${project}`, 'leads');
              showRealtimeToast('📋', `New lead from ${name}${project ? ': ' + project : ''}`, 'leads');
            });
          }
          lastSeenLeadIds.current = new Set(freshLeads.map(l => l.id));
        }

        // Refresh messages
        const { data: freshMsgs } = await supabase.from('messages').select('*').order('created_at', { ascending: false }).limit(200);
        if (freshMsgs?.length) {
          const newInbound = freshMsgs.filter(m => !lastSeenMsgIds.current.has(m.id) && m.direction === 'inbound');
          console.log('[poll] Messages:', freshMsgs.length, 'recent, ', newInbound.length, 'new inbound, initialized:', pollInitialized.current);
          setMessages(p => mergeMessages(p, freshMsgs));

          if (pollInitialized.current) {
            newInbound.forEach(m => {
              console.log('[poll] 🔔 Firing SMS toast for:', m.contact_name || m.phone);
              addNotification('sms', `💬 New text from ${m.contact_name || m.phone || 'Unknown'}`, 'calls');
              showRealtimeToast('💬', `New SMS from ${m.contact_name || m.phone || 'Unknown'}`, 'calls');
            });
          }
          freshMsgs.forEach(m => lastSeenMsgIds.current.add(m.id));
        }

        // Refresh estimate views
        try {
          const { data: viewsData } = await supabase.from('estimate_views').select('*');
          if (viewsData?.length) {
            const viewMap = {};
            viewsData.forEach(v => { viewMap[v.estimate_id] = v; });

            if (pollInitialized.current) {
              Object.entries(viewMap).forEach(([estId, v]) => {
                const old = lastSeenEstViews.current[estId];
                if (v.viewed_at && (!old || !old.viewed_at)) {
                  const est = estimates.find(e => e.id === estId);
                  if (est) {
                    addNotification('estimate', `👁 ${est.customer} viewed ${estId}`, 'estimates');
                    showRealtimeToast('👁', `${est.customer} just viewed their estimate`, 'estimates');
                  }
                }
                if (v.accepted_at && (!old || !old.accepted_at)) {
                  const est = estimates.find(e => e.id === estId);
                  if (est) {
                    addNotification('estimate', `✅ ${est.customer} accepted ${estId}!`, 'estimates');
                    showRealtimeToast('✅', `${est.customer} accepted their estimate!`, 'estimates');
                  }
                }
              });
            }
            lastSeenEstViews.current = viewMap;
            setEstimateViews(viewMap);
          }
        } catch (e) { /* estimate_views table might not exist */ }

        // Refresh invoices (catches client Stripe payments recorded by record-client-payment API)
        try {
          const { data: freshInvoices } = await supabase.from('invoices').select('*').order('id');
          if (freshInvoices?.length) {
            const newlyPaid = freshInvoices.filter(fi => {
              const oldPaidCount = lastSeenInvPayments.current[fi.id] || 0;
              const newPaidCount = (fi.payments || []).filter(p => p.status === 'Paid').length;
              return newPaidCount > oldPaidCount;
            });

            setInvoices(prev => {
              const deletedMap = {};
              prev.forEach(i => { if (i.deletedAt) deletedMap[i.id] = i.deletedAt; });
              const merged = freshInvoices.map(fi => ({
                ...fi, jobId: fi.job_id || fi.jobId, contractTotal: fi.contract_total ?? fi.contractTotal ?? 0,
                display_id: fi.display_id || fi.id, estimate_id: fi.estimate_id || null,
                ...(deletedMap[fi.id] ? { deletedAt: deletedMap[fi.id] } : {}),
              }));
              const mergedIds = new Set(merged.map(m => m.id));
              const localOnly = prev.filter(p => p.deletedAt && !mergedIds.has(p.id));
              return [...merged, ...localOnly];
            });

            if (pollInitialized.current) {
              newlyPaid.forEach(fi => {
                const paidPmt = (fi.payments || []).filter(p => p.status === 'Paid').pop();
                const amt = paidPmt ? paidPmt.amount : '';
                addNotification('invoice', `💰 Payment received · ${fi.customer} · $${Number(amt).toLocaleString()} · ${fi.display_id || fi.id}`, 'invoicing');
                showRealtimeToast('💰', `Payment from ${fi.customer}: $${Number(amt).toLocaleString()}`, 'invoicing');
              });
            }

            // Update ref
            const invPayMap = {};
            freshInvoices.forEach(fi => { invPayMap[fi.id] = (fi.payments || []).filter(p => p.status === 'Paid').length; });
            lastSeenInvPayments.current = invPayMap;
          }
        } catch (e) { /* silent */ }
        // After first poll, enable notifications for subsequent polls
        if (!pollInitialized.current) { pollInitialized.current = true; console.log('[poll] ✅ Initialized — future events will trigger toasts'); }
      } catch (e) { /* silent */ }
    }, 15000);

    // Sync voicemail recordings from Twilio every 60 seconds
    const syncInterval = setInterval(async () => {
      try {
        await fetch('/api/twilio/sync-recordings');
      } catch (e) { /* silent */ }
    }, 60000);

    // Also sync immediately on first load
    fetch('/api/twilio/sync-recordings').catch(() => {});

    return () => { clearInterval(pollInterval); clearInterval(syncInterval); };
  }, [dbReady, currentUser]); // eslint-disable-line

  // ── Check for overdue invoices on load ──
  useEffect(() => {
    if (!dbReady) return;
    const today = new Date().toISOString().slice(0,10);
    const overdue = invoices.filter(i => i.status === "Invoiced" && (i.payments?.find(p=>p.status!=="Paid")?.due || i.issued) && (i.payments?.find(p=>p.status!=="Paid")?.due || i.issued) < today);
    overdue.forEach(inv => {
      addNotification("invoice", `⚠️ Overdue: ${inv.id} · ${inv.customer} · $${invTotal(inv)?.toLocaleString()} (due ${(inv.payments?.find(p=>p.status!=="Paid")?.due || inv.issued)})`, "invoicing");
    });
  }, [dbReady]); // eslint-disable-line

  // ── Check for unseen estimates (3-day follow-up alert) ──
  useEffect(() => {
    if (!dbReady) return;
    const threeDaysAgo = Date.now() - (3 * 24 * 60 * 60 * 1000);
    const sentEstimates = estimates.filter(e => !e.deletedAt && e.status === "Sent");
    sentEstimates.forEach(est => {
      const sentDate = new Date(est.date).getTime();
      if (sentDate > threeDaysAgo) return; // Less than 3 days ago — too early
      const view = estimateViews[est.id];
      if (!view || !view.viewed_at) {
        // Sent 3+ days ago, never viewed
        addNotification("estimate", `👀 ${est.customer} hasn't viewed ${est.id} · Sent ${est.date} — consider following up`, "estimates");
      } else if (!view.accepted_at) {
        // Viewed but not accepted after 3+ days
        const viewedDate = new Date(view.viewed_at).getTime();
        if (viewedDate < threeDaysAgo) {
          addNotification("estimate", `⏳ ${est.customer} viewed ${est.id} but hasn't accepted · Last viewed ${new Date(view.last_viewed_at||view.viewed_at).toLocaleDateString()} — follow up?`, "estimates");
        }
      }
    });
  }, [dbReady, estimateViews]); // eslint-disable-line

  // ── Reconcile invoice contractTotal + job value with linked estimate (catches pre-existing change order mismatches) ──
  const reconciled = useRef(false);
  useEffect(() => {
    if (!dbReady || reconciled.current) return;
    reconciled.current = true;

    const calcTotal = (items) => (items || []).reduce((s, i) => s + (Number(i.qty) * Number(i.price)) + (i.materials || []).reduce((ms, m) => ms + (Number(m.qty) * Number(m.price)), 0), 0);

    let invoiceUpdates = false;
    let jobUpdates = false;

    // Build updated invoices
    const reconciledInvoices = invoices.map(inv => {
      const est = estimates.find(e => e.id === inv.estimate_id);
      if (!est) return inv;
      const estTotal = est.override_total || calcTotal(est.items);
      if (Math.abs((inv.contractTotal || 0) - estTotal) < 1) return inv; // already in sync

      invoiceUpdates = true;
      const paidSoFar = (inv.payments || []).filter(p => p.status === "Paid").reduce((s, p) => s + (p.amount || 0), 0);
      const newHalf = Math.round(estTotal / 2);
      return {
        ...inv,
        contractTotal: estTotal,
        payments: (inv.payments || []).map(pmt => {
          if (pmt.status === "Paid") return pmt;
          if (pmt.label && pmt.label.includes("Deposit")) return { ...pmt, amount: Math.max(0, newHalf - paidSoFar) };
          if (pmt.label && pmt.label.includes("Balance")) return { ...pmt, amount: estTotal - newHalf };
          return pmt;
        })
      };
    });

    // Build updated jobs
    const reconciledJobs = jobs.map(j => {
      const estId = j.estimateId || j.estimate_id;
      if (!estId) return j;
      const est = estimates.find(e => e.id === estId);
      if (!est) return j;
      const estTotal = est.override_total || calcTotal(est.items);
      if (Math.abs((j.value || 0) - estTotal) < 1) return j;
      jobUpdates = true;
      return { ...j, value: estTotal };
    });

    if (invoiceUpdates) setInvoices(reconciledInvoices);
    if (jobUpdates) setJobs(reconciledJobs);
    if (invoiceUpdates || jobUpdates) console.log('[reconcile] Synced invoice/job totals with linked estimates');
  }, [dbReady]); // eslint-disable-line

  // ── Save to Supabase — only after initial load, with debounce ──
  const saveTimer = useRef({});

  // ── Destructive-cleanup guard ───────────────────────────────────────────────
  // Every table's save ends by deleting DB rows that aren't in local state. That
  // is only safe if local state is actually trustworthy. Two ways it isn't:
  //   1. The initial load never completed, so local state is still empty.
  //   2. Local state shrank implausibly (a failed/partial load, a bad setter).
  // In either case we skip the delete and surface it instead of destroying data.
  const dataLoaded = useRef(false);   // flips true only after a full successful load

  const cleanupAllowed = (table, localCount, dbCount, staleCount) => {
    if (!dataLoaded.current) {
      console.warn(`[sync] ${table}: cleanup skipped — initial load not confirmed`);
      return false;
    }
    if (localCount === 0) {
      console.warn(`[sync] ${table}: cleanup skipped — local state is empty`);
      return false;
    }
    // Allow small routine deletes; block anything that looks like a wipe.
    const ceiling = Math.max(3, Math.floor(dbCount * 0.34));
    if (staleCount > ceiling) {
      const msg = `Blocked deleting ${staleCount} of ${dbCount} ${table} rows — local state has only ${localCount}. Nothing was deleted.`;
      console.error(`[sync] ${table}: CLEANUP BLOCKED — ${msg}`);
      setSaveErrors(p => [...p.slice(-49), { id: Date.now(), key: table, msg, date: new Date().toISOString() }]);
      return false;
    }
    return true;
  };
  const [saveErrors, setSaveErrors] = useState(() => {
    try { return JSON.parse(localStorage.getItem('ttp_error_log') || '[]'); } catch(e) { return []; }
  });
  // Persist errors to localStorage
  useEffect(() => {
    try { localStorage.setItem('ttp_error_log', JSON.stringify(saveErrors.slice(-50))); } catch(e) {}
  }, [saveErrors]);
  const scheduleSave = (key, fn, delay = 1500) => {
    if (saveTimer.current[key]) clearTimeout(saveTimer.current[key]);
    saveTimer.current[key] = setTimeout(async () => {
      try {
        const result = await fn();
        if (result?.error) {
          const msg = `⚠️ ${key} save failed: ${result.error.message}`;
          console.error(msg, result.error);
          setSaveErrors(p => [...p.slice(-49), { id:Date.now(), key, msg: result.error.message, date: new Date().toISOString() }]);
        }
      } catch (err) {
        const msg = `⚠️ ${key} save exception: ${err.message}`;
        console.error(msg, err);
        setSaveErrors(p => [...p.slice(-49), { id:Date.now(), key, msg: err.message, date: new Date().toISOString() }]);
      }
    }, 1500);
  };

  // Sync helper: upsert current active records + delete records permanently removed from local state
  const syncTable = async (table, rows, mapFn) => {
    // Only upsert records that are NOT soft-deleted
    const activeRows = rows.filter(r => !r.deletedAt);
    const mapped = mapFn ? activeRows.map(mapFn) : activeRows;
    // Deduplicate by id — keep last occurrence (prevents "ON CONFLICT DO UPDATE cannot affect row a second time")
    const deduped = [...new Map(mapped.map(r => [r.id, r])).values()];
    const localIds = rows.filter(r => !r.deletedAt).map(r => r.id); // Only active IDs — soft-deleted records get cleaned from DB
    if (deduped.length === 0) return { error: null };
    // Upsert active records
    const upsertResult = await supabase.from(table).upsert(deduped, { onConflict: 'id' });
    if (upsertResult.error) return upsertResult;
    // Fetch all IDs in the DB table
    const { data: dbRows, error: fetchErr } = await supabase.from(table).select('id');
    if (fetchErr || !dbRows) return { error: fetchErr };
    // Delete any DB rows not in local state at all (permanently purged)
    const staleIds = dbRows.map(r => r.id).filter(id => !localIds.includes(id));
    if (staleIds.length > 0 && cleanupAllowed(table, localIds.length, dbRows.length, staleIds.length)) {
      const { error: delErr } = await supabase.from(table).delete().in('id', staleIds);
      if (delErr) console.warn(`[sync] Failed to delete stale ${table} rows:`, delErr.message);
    }
    return { error: null };
  };

  useEffect(() => {
    if (!dbReady) return;
    scheduleSave('leads', async () => {
      // Strip base64 photos from upsert to avoid statement timeout
      const activeRows = leads.filter(r => !r.deletedAt);
      const deduped = [...new Map(activeRows.map(r => [r.id, r])).values()];
      const localIds = activeRows.map(r => r.id);
      if (deduped.length === 0) return;

      const stripped = deduped.map(r => {
        if (r.photos && r.photos.length > 0) {
          const { photos, ...rest } = r;
          return rest;
        }
        return r;
      });

      // Batch upsert in chunks of 20 (without photos)
      const BATCH = 20;
      for (let i = 0; i < stripped.length; i += BATCH) {
        const chunk = stripped.slice(i, i + BATCH);
        const { error } = await supabase.from('leads').upsert(chunk, { onConflict: 'id' });
        if (error) {
          console.warn('[sync] leads batch error:', error.message);
          setSaveErrors(p => [...p.filter(e => e.key !== 'leads'), { id: Date.now(), key: 'leads', msg: error.message }]);
          return;
        }
      }

      // Save photos individually for leads that have them
      const withPhotos = deduped.filter(r => r.photos && r.photos.length > 0);
      for (const lead of withPhotos) {
        try {
          await supabase.from('leads').update({ photos: lead.photos }).eq('id', lead.id);
        } catch (e) { console.warn('[sync] lead photo save failed:', lead.id, e.message); }
      }

      // Clean up stale rows
      try {
        const { data: dbRows } = await supabase.from('leads').select('id');
        if (dbRows) {
          const staleIds = dbRows.map(r => r.id).filter(id => !localIds.includes(id));
          if (staleIds.length > 0) {
            await supabase.from('leads').delete().in('id', staleIds);
          }
        }
      } catch (e) { console.warn('[sync] leads cleanup error:', e.message); }
    });
  }, [leads]); // eslint-disable-line

  useEffect(() => {
    if (!dbReady) return;
    scheduleSave('customers', () => syncTable('customers', customers,
      c => ({ id:c.id, name:c.name, email:c.email||'', phone:c.phone||'', address:c.address||'', notes:c.notes||'', cc_email:c.cc_email||'', total_jobs:c.totalJobs||c.total_jobs||0, total_revenue:c.totalRevenue||c.total_revenue||0, since:c.since||null })
    ));
  }, [customers]); // eslint-disable-line

  useEffect(() => {
    if (!dbReady) return;
    scheduleSave('estimates', () => syncTable('estimates', estimates, mapEstimateToRow));
  }, [estimates]); // eslint-disable-line

  useEffect(() => {
    if (!dbReady) return;
    scheduleSave('jobs', async () => {
      // CRITICAL: photos are loaded lazily, so `j.photos` is [] for any job whose
      // photos were never fetched. Writing that would erase the real photos in the
      // DB. Only include the column when photosLoaded === true proves we have them.
      const mapJob = j => {
        const row = { id:j.id, customer:j.customer, customer_id:j.customerId||j.customer_id||null, project:j.project, status:j.status, start_date:j.startDate||j.start_date||null, start_time:j.startTime||null, end_date:j.endDate||j.end_date||null, value:j.value||0, cost:j.cost||0, address:j.address||'', notes:j.notes||'', crew:j.crewName||j.crew||'', crew_pay:j.crewPay||j.crew_pay||[], crew_notes:j.crewNotes||j.crew_notes||[], estimate_id:j.estimateId||j.estimate_id||null, estimated_days:j.estimatedDays||1 };
        if (j.photosLoaded === true && Array.isArray(j.photos)) row.photos = j.photos;
        return row;
      };
      // Save each job individually to prevent large photo payloads from timing out the batch
      const activeJobs = jobs.filter(j => !j.deletedAt);
      if (activeJobs.length === 0) return { error: null };   // never sync an empty jobs list
      for (const j of activeJobs) {
        const { error } = await supabase.from('jobs').upsert(mapJob(j), { onConflict: 'id' });
        if (error) return { error };
      }
      // Cleanup stale rows (includes soft-deleted jobs so they're removed from DB)
      const localIds = activeJobs.map(j => j.id);
      const { data: dbRows } = await supabase.from('jobs').select('id');
      if (dbRows) {
        const staleIds = dbRows.map(r => r.id).filter(id => !localIds.includes(id));
        if (staleIds.length > 0 && cleanupAllowed('jobs', localIds.length, dbRows.length, staleIds.length)) {
          await supabase.from('jobs').delete().in('id', staleIds);
        }
      }
      return { error: null };
    });
  }, [jobs]); // eslint-disable-line

  useEffect(() => {
    if (!dbReady) return;
    scheduleSave('invoices', () => syncTable('invoices', invoices,
      i => ({ id:i.id, display_id:i.display_id||i.id, job_id:i.jobId||i.job_id||null, estimate_id:i.estimate_id||null, customer:i.customer, project:i.project, contract_total:i.contractTotal||0, issued:i.issued||null, status:i.status, payments:i.payments||[] })
    ), 300);
  }, [invoices]); // eslint-disable-line

  useEffect(() => {
    if (!dbReady) return;
    scheduleSave('users', async () => {
      // Separate new users (temp IDs) from existing DB users
      const newUsers = users.filter(u => String(u.id).startsWith('temp_'));
      const existingUsers = users.filter(u => !String(u.id).startsWith('temp_'));

      let error = null;

      // Update existing users (by id, without sending id in payload to avoid GENERATED ALWAYS conflict)
      if (existingUsers.length > 0) {
        for (const u of existingUsers) {
          const { error: upErr } = await supabase.from('users').update({ name:u.name, role:u.role, email:u.email||'', pin:u.pin, active:u.active!==false }).eq('id', u.id);
          if (upErr) { error = upErr; break; }
        }
      }

      // Insert new users without id (let DB auto-generate)
      if (newUsers.length > 0 && !error) {
        const { data: inserted, error: insErr } = await supabase.from('users')
          .insert(newUsers.map(u => ({ name:u.name, role:u.role, email:u.email||'', pin:u.pin, active:u.active!==false })))
          .select();
        if (insErr) { error = insErr; }
        else if (inserted && inserted.length > 0) {
          // Update local state with DB-generated IDs
          setUsers(prev => {
            const updated = [...prev];
            newUsers.forEach((tempUser, i) => {
              if (inserted[i]) {
                const idx = updated.findIndex(u => u.id === tempUser.id);
                if (idx !== -1) updated[idx] = { ...updated[idx], id: inserted[i].id, _isNew: false };
              }
            });
            return updated;
          });
        }
      }

      return { error };
    });
  }, [users]); // eslint-disable-line

  useEffect(() => {
    if (!dbReady) return;
    scheduleSave('events', () => syncTable('events', events,
      e => ({ id:e.id, title:e.title, date:e.date, time:e.time||null, type:e.type||'lead', job_tag:e.jobTag||null, crew:e.crew||null, address:e.address||null, customer:e.customer||null, brief:e.brief||null, job_id:e.jobId||null, multi_day:e.multiDay||false, day_num:e.dayNum||null, total_days:e.totalDays||null })
    ));
  }, [events]); // eslint-disable-line

  useEffect(() => {
    if (!dbReady) return;
    scheduleSave('calls', () => supabase.from('calls').upsert(
      calls.filter(c => !c.deletedAt).map(c => ({ id:c.id, contact:c.contact, phone:c.phone||'', direction:c.direction, outcome:c.outcome, date:c.date, time:c.time||null, duration:c.duration||null, notes:c.notes||'', source:c.source||'Direct', recording_url:c.recording_url||null, transcription:c.transcription||null, linked_lead:c.linkedLead||c.linked_lead||null, linked_customer:c.linkedCustomer||c.linked_customer||null, twilio_sid:c.twilio_sid||null })),
      { onConflict: 'id' }
    ));
  }, [calls]); // eslint-disable-line

  // Messages are written by the Twilio API routes; read status is saved by markThreadRead.
  // (The old bulk upsert re-wrote every message on each change — too heavy with full history.)

  // Reviews save
  useEffect(() => {
    if (!dbReady) return;
    scheduleSave('reviews', () => supabase.from('reviews').upsert(
      reviews.filter(r => !r.deletedAt).map(r => ({ id:r.id, job_id:r.jobId||r.job_id||null, customer:r.customer, project:r.project, crew:r.crew||'', "requestedDate":r.requestedDate||null, "respondedDate":r.respondedDate||null, status:r.status||'Not Sent', rating:r.rating||null, cleanliness:r.cleanliness||null, communication:r.communication||null, comment:r.comment||'', "googleSent":r.googleSent||false, flagged:r.flagged||false, sent_count:r.sent_count||1 })),
      { onConflict: 'id' }
    ));
  }, [reviews]); // eslint-disable-line

  // Scope templates save
  useEffect(() => {
    if (!dbReady || !scopeTemplates.length) return;
    // Always save to localStorage as fallback
    try { localStorage.setItem('ttp_scope_templates', JSON.stringify(scopeTemplates)); } catch(e) {}
    scheduleSave('scope_templates', async () => {
      try {
        const mapped = scopeTemplates.map(t => ({ id: t.id, name: t.name, category: t.category || 'Custom', items: t.items, created_at: t.created_at || new Date().toISOString() }));
        const result = await supabase.from('scope_templates').upsert(mapped, { onConflict: 'id' });
        // Clean up deleted templates
        if (!result.error) {
          const { data: dbRows } = await supabase.from('scope_templates').select('id');
          if (dbRows) {
            const localIds = scopeTemplates.map(t => t.id);
            const staleIds = dbRows.map(r => r.id).filter(id => !localIds.includes(id));
            if (staleIds.length > 0) await supabase.from('scope_templates').delete().in('id', staleIds);
          }
        }
        return result;
      } catch(e) { console.log('[save] scope_templates table not available — saved to localStorage'); return { error: null }; }
    });
  }, [scopeTemplates]); // eslint-disable-line

  // ── Lazy photo loading ──────────────────────────────────────────────────────
  // Job photos are base64 and total ~10 MB, which made `select('*')` time out
  // (intermittent 500s) and left users with an empty jobs list. They're fetched
  // per job on demand instead. Anything that WRITES photos must ensure the job's
  // photos were loaded first, or mapJob will skip the column and the write is lost.
  const [loadError, setLoadError] = useState(null);
  const [photoLoading, setPhotoLoading] = useState({}); // { [jobId]: true }

  const loadJobPhotos = useCallback(async (jobId) => {
    if (jobId == null) return [];
    let already = null;
    setJobs(p => { const j = p.find(x => x.id === jobId); already = j?.photosLoaded ? (j.photos || []) : null; return p; });
    if (already) return already;
    setPhotoLoading(p => ({ ...p, [jobId]: true }));
    try {
      const { data, error } = await supabase.from('jobs').select('photos').eq('id', jobId).single();
      if (error) throw error;
      const photos = data?.photos || [];
      setJobs(p => p.map(j => j.id === jobId ? { ...j, photos, photosLoaded: true } : j));
      return photos;
    } catch (e) {
      console.warn('[photos] load failed for job', jobId, e.message);
      return null;
    } finally {
      setPhotoLoading(p => { const n = { ...p }; delete n[jobId]; return n; });
    }
  }, []);

  // Fetch photos for every job at once — only for the Photo Gallery view.
  const loadAllJobPhotos = useCallback(async () => {
    try {
      const { data, error } = await supabase.from('jobs').select('id,photos');
      if (error) throw error;
      const byId = Object.fromEntries((data || []).map(r => [r.id, r.photos || []]));
      setJobs(p => p.map(j => j.id in byId ? { ...j, photos: byId[j.id], photosLoaded: true } : j));
      return true;
    } catch (e) {
      console.warn('[photos] bulk load failed:', e.message);
      return false;
    }
  }, []);

  const handleLogin = async (user) => {
    setCurrentUser(user);
    // Land each role on their natural home page
    const defaults = { owner:"dashboard", admin:"dashboard", installer:"schedule" };
    setPage(defaults[user.role]);
    // Now load all CRM data (RLS allows access via service_role / authenticated)
    await loadCrmData();
  };

  const handleSignOut = () => { setCurrentUser(null); setPage(null); setSignOutConfirm(false); };

  // ── Show loading screen while Supabase connects ──
  if (!dbReady) return (
    <>
      <GlobalStyles/>
      <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", height:"100vh", background:"var(--stone-950)", gap:16 }}>
        <div style={{ fontSize:40 }}>🏛</div>
        <div style={{ fontFamily:"var(--font-display)", fontSize:"22px", color:"var(--sand-100)", letterSpacing:"0.05em" }}>Timeless Tile Pro</div>
        <div style={{ fontSize:"13px", color:"var(--stone-400)", marginTop:4 }}>Connecting to database…</div>
        <div style={{ width:200, height:3, background:"var(--stone-700)", borderRadius:2, marginTop:8, overflow:"hidden" }}>
          <div style={{ height:"100%", width:"60%", background:"var(--warm-gold)", borderRadius:2, animation:"pulse 1.5s ease-in-out infinite" }}/>
        </div>
      </div>
    </>
  );

  // ── Show login if not authenticated ──
  if (!currentUser) return (
    <>
      <GlobalStyles/>
      <LoginScreen onLogin={handleLogin} users={users}/>
    </>
  );

  const role     = currentUser.role;
  const roleInfo = ROLES[role];
  const nav      = ALL_NAV.filter(n => n.roles.includes(role) && !n.hidden);

  // Guard: if current page is not accessible for role, redirect
  const allowed = PAGE_ACCESS[role];
  const safePage = allowed.includes(page) ? page : allowed[0];

  const renderPage = () => {
    switch(safePage) {
      case "dashboard": return <Dashboard leads={activeLeads} jobs={activeJobs} invoices={activeInvoices} customers={activeCustomers} />;
      case "leads":     return <Leads leads={activeLeads} setLeads={setLeads} jobs={activeJobs} setJobs={setJobs} estimates={activeEstimates} setEstimates={setEstimates} customers={activeCustomers} setCustomers={setCustomers} setPage={setPage} addNotification={addNotification} requestDelete={requestDelete} setEstimateViews={setEstimateViews} />;
      case "calls":     return <CallTracking calls={activeCalls} setCalls={setCalls} messages={messages} setMessages={setMessages} leads={activeLeads} customers={activeCustomers} requestDelete={requestDelete} />;
      case "jobs":      return <Jobs loadJobPhotos={loadJobPhotos} loadAllJobPhotos={loadAllJobPhotos} photoLoading={photoLoading} jobs={activeJobs} setJobs={setJobs} customers={activeCustomers} estimates={activeEstimates} setEstimates={setEstimates} invoices={activeInvoices} setInvoices={setInvoices} events={activeEvents} setEvents={setEvents} users={users} setPage={setPage} addNotification={addNotification} requestDelete={requestDelete} estimateViews={estimateViews} setEstimateViews={setEstimateViews} currentUser={currentUser} reviews={reviews} setReviews={setReviews} />;
      case "customers": return <Customers customers={activeCustomers} setCustomers={setCustomers} requestDelete={requestDelete} />;
      case "calendar":  return <CalendarView events={activeEvents} setEvents={setEvents} jobs={activeJobs} requestDelete={requestDelete} />;
      case "estimates": return <Estimates estimates={activeEstimates} setEstimates={setEstimates} customers={activeCustomers} setCustomers={setCustomers} jobs={activeJobs} setJobs={setJobs} invoices={activeInvoices} setPage={setPage} addNotification={addNotification} requestDelete={requestDelete} estimateViews={estimateViews} setEstimateViews={setEstimateViews} scopeTemplates={scopeTemplates} setScopeTemplates={setScopeTemplates} />;
      case "invoicing": return <Invoicing invoices={activeInvoices} setInvoices={setInvoices} jobs={activeJobs} customers={activeCustomers} estimates={activeEstimates} addNotification={addNotification} requestDelete={requestDelete} />;
      case "reviews":   return <Reviews reviews={activeReviews} setReviews={setReviews} jobs={activeJobs} addNotification={addNotification} requestDelete={requestDelete} />;
      case "materials": return <Materials materials={materials} setMaterials={setMaterials} jobs={activeJobs} invoices={activeInvoices} currentUser={currentUser} />;
      case "catalog":  return <MaterialsCatalog />;
      case "budgets":  return <ProjectBudgetBuilder currentUser={currentUser} />;
      case "pldash":   return <EnhancedPLDashboard />;
      case "gallery":   return <Gallery loadAllJobPhotos={loadAllJobPhotos} jobs={activeJobs} setJobs={setJobs} />;
      case "playbook":  return <Playbook />;
      case "training":  return <Training />;
      case "schedule":  return <CrewApp loadJobPhotos={loadJobPhotos} photoLoading={photoLoading} jobs={activeJobs} setJobs={setJobs} estimates={activeEstimates} events={activeEvents} currentUser={currentUser} addNotification={addNotification} />;
      case "marketing":  return <MarketingDashboard leads={activeLeads} />;
      case "outreach":    return <OutreachDrafts />;
      case "aiassistant": return <AIAssistant currentUser={currentUser} />;
      case "reports":   return <Reports leads={activeLeads} jobs={activeJobs} invoices={activeInvoices} estimates={activeEstimates} calls={activeCalls} customers={activeCustomers} users={users} />;
      case "users":     return <UserManagement users={users} setUsers={setUsers} currentUser={currentUser} />;
      case "teamboard": return <TeamBoard currentUser={currentUser} users={users} />;
      case "activity":  return <ActivityDashboard currentUser={currentUser} />;
      case "automations": return <AutomationHealth />;
      case "errorlog":  return <ErrorLog saveErrors={saveErrors} setSaveErrors={setSaveErrors} />;
      case "trash":     return <TrashPage trashItems={trashItems} onRestore={restoreRecord} onPermanentDelete={permanentDelete} />;
      default: return null;
    }
  };

  return (
    <>
      <GlobalStyles />
      <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>

        {/* ── Sidebar ── */}
        <aside className="tile-pattern" style={{ width: sidebarOpen ? 240 : 64, background: "var(--stone-900)", flexShrink: 0, display: "flex", flexDirection: "column", transition: "width 0.25s ease", overflow: "hidden" }}>

          {/* Logo */}
          <div style={{ padding: "18px 14px 16px", borderBottom: "1px solid rgba(255,255,255,0.07)", flexShrink:0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ width: 34, height: 34, borderRadius: 8, background: "var(--warm-gold)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Icon name="tile" size={18} color="white" />
              </div>
              {sidebarOpen && (
                <div>
                  <div style={{ fontFamily: "var(--font-display)", fontSize: "14px", fontWeight: 700, color: "white", lineHeight: 1.1 }}>Timeless Tile</div>
                  <div style={{ fontSize: "10px", color: "var(--warm-gold)", letterSpacing: "0.1em", textTransform: "uppercase" }}>Pro CRM</div>
                </div>
              )}
            </div>
          </div>

          {/* Role badge */}
          {sidebarOpen && (
            <div style={{ padding:"10px 14px 6px", borderBottom:"1px solid rgba(255,255,255,0.05)" }}>
              <div style={{ display:"flex", alignItems:"center", gap:7, background:"rgba(255,255,255,0.05)", borderRadius:"var(--radius)", padding:"7px 10px" }}>
                <span style={{ fontSize:14 }}>{roleInfo.badge}</span>
                <div>
                  <div style={{ fontSize:"11px", fontWeight:700, color:roleInfo.color, textTransform:"uppercase", letterSpacing:"0.07em" }}>{roleInfo.label}</div>
                  <div style={{ fontSize:"11px", color:"rgba(255,255,255,0.4)", marginTop:1, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", maxWidth:140 }}>{currentUser.name}</div>
                </div>
              </div>
            </div>
          )}

          {/* Nav */}
          <nav style={{ flex: 1, padding: "10px 8px", overflowY: "auto" }}>
            {nav.map(n => (
              <div key={n.id}
                className={`nav-item${safePage === n.id ? " active" : ""}`}
                onClick={() => setPage(n.id)}
                title={!sidebarOpen ? n.label : ""}
                style={{ position:"relative" }}
              >
                <Icon name={n.icon} size={16} />
                {sidebarOpen && <span style={{ flex:1 }}>{n.label}</span>}
                {sidebarOpen && n.badge && (
                  <span style={{ fontSize:"9px", fontWeight:700, background:"var(--warm-gold)", color:"white", padding:"1px 6px", borderRadius:99 }}>{n.badge}</span>
                )}
                {sidebarOpen && n.id === "trash" && trashItems.length > 0 && (
                  <span style={{ fontSize:"9px", fontWeight:700, background:"var(--accent-red)", color:"white", padding:"1px 6px", borderRadius:99, minWidth:18, textAlign:"center" }}>{trashItems.length}</span>
                )}
              </div>
            ))}
          </nav>

          {/* Sidebar footer */}
          <div style={{ padding: "10px 8px", borderTop: "1px solid rgba(255,255,255,0.07)", flexShrink:0 }}>
            {/* Sign out */}
            <div className="nav-item" style={{ color:"rgba(255,100,100,0.7)" }}
              onClick={() => setSignOutConfirm(true)}
              title={!sidebarOpen ? "Sign Out" : ""}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
              </svg>
              {sidebarOpen && <span style={{ fontSize:"12px" }}>Sign Out</span>}
            </div>
            {/* Collapse */}
            <div className="nav-item" onClick={() => setSidebarOpen(p => !p)}>
              <Icon name={sidebarOpen ? "chevron_right" : "chevron_down"} size={16} />
              {sidebarOpen && <span style={{ fontSize: "12px" }}>Collapse</span>}
            </div>
          </div>
        </aside>

        {/* ── Main Content ── */}
        <main style={{ flex: 1, overflow: "auto", background: "var(--stone-100)" }}>

          {/* Top bar */}
          <div style={{ background: "var(--stone-50)", borderBottom: "1px solid var(--stone-200)", padding: "12px 28px", display: "flex", justifyContent: "space-between", alignItems: "center", position: "sticky", top: 0, zIndex: 10 }}>
            <div style={{ fontSize: "13px", color: "var(--stone-500)", fontWeight:500 }}>
              {nav.find(n=>n.id===safePage)?.label}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ fontSize: "12px", color: "var(--stone-500)", background: "var(--stone-100)", padding: "5px 11px", borderRadius: 99 }}>
                {new Date().toLocaleDateString("en-US",{ weekday:"short", month:"short", day:"numeric" })}
              </div>

              {/* Notification Bell */}
              {(role === "owner" || role === "admin") && (
                <div style={{ position:"relative" }}>
                  <button onClick={() => { setNotifOpen(p => !p); setNotifications(p => p.map(n => ({ ...n, read: true }))); }}
                    style={{ width:34, height:34, borderRadius:"50%", background:"var(--stone-100)", border:"1px solid var(--stone-200)", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", position:"relative" }}>
                    <Icon name="bell" size={16} color="var(--stone-600)" />
                    {notifications.filter(n => !n.read).length > 0 && (
                      <span style={{ position:"absolute", top:-2, right:-2, background:"var(--accent-red)", color:"white", fontSize:"9px", fontWeight:800, borderRadius:99, minWidth:16, height:16, display:"flex", alignItems:"center", justifyContent:"center", padding:"0 3px" }}>
                        {notifications.filter(n => !n.read).length}
                      </span>
                    )}
                  </button>

                  {/* Notification Dropdown */}
                  {notifOpen && (
                    <div style={{ position:"absolute", right:0, top:42, width:340, background:"white", borderRadius:"var(--radius-lg)", boxShadow:"0 8px 32px rgba(0,0,0,0.15)", border:"1px solid var(--stone-200)", zIndex:500, overflow:"hidden" }}>
                      <div style={{ padding:"14px 16px", borderBottom:"1px solid var(--stone-100)", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                        <span style={{ fontWeight:700, fontSize:14 }}>Notifications</span>
                        {notifications.length > 0 && <button onClick={() => setNotifications([])} style={{ fontSize:11, color:"var(--stone-500)", background:"none", border:"none", cursor:"pointer" }}>Clear all</button>}
                      </div>
                      <div style={{ maxHeight:360, overflowY:"auto" }}>
                        {notifications.length === 0 ? (
                          <div style={{ padding:"32px 16px", textAlign:"center", color:"var(--stone-400)", fontSize:13 }}>
                            <div style={{ fontSize:24, marginBottom:8 }}>🔔</div>
                            No notifications yet
                          </div>
                        ) : notifications.map(n => (
                          <div key={n.id} onClick={() => { setPage(n.page || safePage); setNotifOpen(false); }}
                            style={{ padding:"12px 16px", borderBottom:"1px solid var(--stone-100)", cursor:"pointer", display:"flex", gap:10, alignItems:"flex-start", background: n.read ? "white" : "rgba(196,149,74,0.04)" }}
                            onMouseEnter={e => e.currentTarget.style.background="var(--stone-50)"}
                            onMouseLeave={e => e.currentTarget.style.background= n.read ? "white" : "rgba(196,149,74,0.04)"}>
                            <div style={{ fontSize:18, flexShrink:0, marginTop:1 }}>
                              {n.type === "job" ? "🔨" : n.type === "lead" ? "📋" : n.type === "invoice" ? "💰" : n.type === "estimate" ? "📝" : "🔔"}
                            </div>
                            <div style={{ flex:1 }}>
                              <div style={{ fontSize:13, fontWeight:500, color:"var(--stone-800)", lineHeight:1.3 }}>{n.message}</div>
                              <div style={{ fontSize:11, color:"var(--stone-400)", marginTop:3 }}>
                                {(() => {
                                  const diff = Math.floor((new Date() - n.time) / 1000);
                                  if (diff < 60) return "Just now";
                                  if (diff < 3600) return `${Math.floor(diff/60)}m ago`;
                                  if (diff < 86400) return `${Math.floor(diff/3600)}h ago`;
                                  return n.time.toLocaleDateString();
                                })()}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Activity tracker + timer */}
              <ActivityTracker currentUser={currentUser} currentPage={page} />

              {/* User chip */}
              <div style={{ display:"flex", alignItems:"center", gap:7, background:"var(--stone-100)", borderRadius:99, padding:"4px 12px 4px 4px", border:"1px solid var(--stone-200)" }}>
                <div style={{ width:26, height:26, borderRadius:"50%", background:roleInfo.color, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"11px", fontWeight:800, color:"white" }}>
                  {currentUser.name.split(" ").map(n=>n[0]).join("")}
                </div>
                <div>
                  <div style={{ fontSize:"12px", fontWeight:600, lineHeight:1.1 }}>{currentUser.name}</div>
                  <div style={{ fontSize:"10px", color:roleInfo.color, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em" }}>{roleInfo.label}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Page content */}
          <div style={{ padding: "28px" }}>
            {loadError && (
              <div style={{ background:"rgba(196,74,74,0.08)", border:"1px solid rgba(196,74,74,0.3)", borderRadius:"var(--radius)", padding:"12px 16px", marginBottom:"16px", display:"flex", alignItems:"center", justifyContent:"space-between", gap:"12px", flexWrap:"wrap" }}>
                <div style={{ fontSize:"13px", color:"var(--accent-red)" }}>
                  <strong>Couldn't load your data.</strong> This screen may look empty even though nothing is missing. {loadError}
                </div>
                <button className="btn btn-secondary btn-sm" onClick={() => loadCrmData()}>Retry</button>
              </div>
            )}
            {renderPage()}
          </div>
        </main>
      </div>

      {/* ── Realtime Notification Toast ── */}
      {realtimeToast && (
        <div
          key={realtimeToast.id}
          onClick={() => { if (realtimeToast.targetPage) setPage(realtimeToast.targetPage); setRealtimeToast(null); }}
          style={{
            position: 'fixed', top: 16, right: 16, zIndex: 3001,
            background: 'white', borderRadius: 'var(--radius-lg, 12px)',
            padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 12,
            boxShadow: '0 8px 32px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.04)',
            cursor: 'pointer', maxWidth: 380,
            animation: 'modalIn 0.3s ease',
            borderLeft: '4px solid var(--warm-gold)',
          }}
        >
          <span style={{ fontSize: 22, flexShrink: 0 }}>{realtimeToast.emoji}</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--stone-800)', lineHeight: 1.3 }}>{realtimeToast.message}</div>
            <div style={{ fontSize: 11, color: 'var(--stone-400)', marginTop: 2 }}>Tap to view</div>
          </div>
          <button onClick={e => { e.stopPropagation(); setRealtimeToast(null); }}
            style={{ background: 'none', border: 'none', color: 'var(--stone-400)', cursor: 'pointer', fontSize: 16, padding: 0, lineHeight: 1 }}>✕</button>
        </div>
      )}

      {/* ── Save Error Toast ── */}
      {saveErrors.length > 0 && (
        <div style={{ position:"fixed", bottom:20, left:"50%", transform:"translateX(-50%)", zIndex:3000, display:"flex", flexDirection:"column", gap:8, maxWidth:420, width:"90%" }}>
          {saveErrors.map(err => (
            <div key={err.id} style={{ background:"var(--accent-red)", color:"white", borderRadius:"var(--radius)", padding:"10px 16px", fontSize:"13px", display:"flex", justifyContent:"space-between", alignItems:"center", gap:10, boxShadow:"0 4px 16px rgba(0,0,0,0.3)", animation:"modalIn 0.3s ease" }}>
              <span>⚠️ <strong>{err.key}</strong> save failed: {err.msg}</span>
              <button onClick={() => setSaveErrors(p => p.filter(e => e.id !== err.id))} style={{ background:"none", border:"none", color:"white", cursor:"pointer", fontSize:16, padding:0, lineHeight:1 }}>✕</button>
            </div>
          ))}
        </div>
      )}

      {/* ── Softphone (owner/admin only) ── */}
      {(role === "owner" || role === "admin") && (
        <Softphone calls={calls} setCalls={setCalls} currentUser={currentUser} />
      )}

      {/* ── Delete Confirmation Modal ── */}
      <ConfirmDeleteModal target={deleteConfirm} onConfirm={confirmSoftDelete} onCancel={() => setDeleteConfirm(null)} />

      {/* ── Sign Out Confirm Modal ── */}
      {signOutConfirm && (
        <Modal title="Sign Out" onClose={() => setSignOutConfirm(false)}>
          <div style={{ textAlign:"center", padding:"10px 0 18px" }}>
            <div style={{ fontSize:40, marginBottom:12 }}>👋</div>
            <div style={{ fontFamily:"var(--font-display)", fontSize:"18px", fontWeight:600, marginBottom:8 }}>Sign out of Timeless Tile Pro?</div>
            <div style={{ fontSize:"13px", color:"var(--stone-500)", marginBottom:22 }}>
              Signed in as <strong>{currentUser.name}</strong> · {roleInfo.label}
            </div>
            <div style={{ display:"flex", gap:10, justifyContent:"center" }}>
              <button className="btn btn-secondary" onClick={() => setSignOutConfirm(false)}>Cancel</button>
              <button className="btn btn-primary" style={{ background:"var(--accent-red)", borderColor:"var(--accent-red)" }} onClick={handleSignOut}>
                Sign Out
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}
